/*
 Highcharts JS v4.0.0 (2014-04-22)

 (c) 2009-2014 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(){function q(a,b){var c;a||(a={});for(c in b)a[c]=b[c];return a}function w(){var a,b=arguments,c,d={},e=function(a,b){var c,d;typeof a!=="object"&&(a={});for(d in b)b.hasOwnProperty(d)&&(c=b[d],a[d]=c&&typeof c==="object"&&Object.prototype.toString.call(c)!=="[object Array]"&&d!=="renderTo"&&typeof c.nodeType!=="number"?e(a[d]||{},c):b[d]);return a};b[0]===!0&&(d=b[1],b=Array.prototype.slice.call(b,2));c=b.length;for(a=0;a<c;a++)d=e(d,b[a]);return d}function A(a,b){return parseInt(a,b||
10)}function Fa(a){return typeof a==="string"}function ca(a){return typeof a==="object"}function La(a){return Object.prototype.toString.call(a)==="[object Array]"}function ha(a){return typeof a==="number"}function za(a){return T.log(a)/T.LN10}function ia(a){return T.pow(10,a)}function ja(a,b){for(var c=a.length;c--;)if(a[c]===b){a.splice(c,1);break}}function r(a){return a!==t&&a!==null}function H(a,b,c){var d,e;if(Fa(b))r(c)?a.setAttribute(b,c):a&&a.getAttribute&&(e=a.getAttribute(b));else if(r(b)&&
ca(b))for(d in b)a.setAttribute(d,b[d]);return e}function qa(a){return La(a)?a:[a]}function m(){var a=arguments,b,c,d=a.length;for(b=0;b<d;b++)if(c=a[b],typeof c!=="undefined"&&c!==null)return c}function D(a,b){if(Aa&&!aa&&b&&b.opacity!==t)b.filter="alpha(opacity="+b.opacity*100+")";q(a.style,b)}function Y(a,b,c,d,e){a=y.createElement(a);b&&q(a,b);e&&D(a,{padding:0,border:N,margin:0});c&&D(a,c);d&&d.appendChild(a);return a}function ka(a,b){var c=function(){};c.prototype=new a;q(c.prototype,b);return c}
function Ga(a,b,c,d){var e=F.lang,a=+a||0,f=b===-1?(a.toString().split(".")[1]||"").length:isNaN(b=O(b))?2:b,b=c===void 0?e.decimalPoint:c,d=d===void 0?e.thousandsSep:d,e=a<0?"-":"",c=String(A(a=O(a).toFixed(f))),g=c.length>3?c.length%3:0;return e+(g?c.substr(0,g)+d:"")+c.substr(g).replace(/(\d{3})(?=\d)/g,"$1"+d)+(f?b+O(a-c).toFixed(f).slice(2):"")}function Ha(a,b){return Array((b||2)+1-String(a).length).join(0)+a}function Ma(a,b,c){var d=a[b];a[b]=function(){var a=Array.prototype.slice.call(arguments);
a.unshift(d);return c.apply(this,a)}}function Ia(a,b){for(var c="{",d=!1,e,f,g,h,i,j=[];(c=a.indexOf(c))!==-1;){e=a.slice(0,c);if(d){f=e.split(":");g=f.shift().split(".");i=g.length;e=b;for(h=0;h<i;h++)e=e[g[h]];if(f.length)f=f.join(":"),g=/\.([0-9])/,h=F.lang,i=void 0,/f$/.test(f)?(i=(i=f.match(g))?i[1]:-1,e!==null&&(e=Ga(e,i,h.decimalPoint,f.indexOf(",")>-1?h.thousandsSep:""))):e=cb(f,e)}j.push(e);a=a.slice(c+1);c=(d=!d)?"}":"{"}j.push(a);return j.join("")}function mb(a){return T.pow(10,S(T.log(a)/
T.LN10))}function nb(a,b,c,d){var e,c=m(c,1);e=a/c;b||(b=[1,2,2.5,5,10],d&&d.allowDecimals===!1&&(c===1?b=[1,2,5,10]:c<=0.1&&(b=[1/c])));for(d=0;d<b.length;d++)if(a=b[d],e<=(b[d]+(b[d+1]||b[d]))/2)break;a*=c;return a}function Bb(){this.symbol=this.color=0}function ob(a,b){var c=a.length,d,e;for(e=0;e<c;e++)a[e].ss_i=e;a.sort(function(a,c){d=b(a,c);return d===0?a.ss_i-c.ss_i:d});for(e=0;e<c;e++)delete a[e].ss_i}function Na(a){for(var b=a.length,c=a[0];b--;)a[b]<c&&(c=a[b]);return c}function Ba(a){for(var b=
a.length,c=a[0];b--;)a[b]>c&&(c=a[b]);return c}function Oa(a,b){for(var c in a)a[c]&&a[c]!==b&&a[c].destroy&&a[c].destroy(),delete a[c]}function Pa(a){db||(db=Y(Ja));a&&db.appendChild(a);db.innerHTML=""}function ra(a,b){var c="Highcharts error #"+a+": www.highcharts.com/errors/"+a;if(b)throw c;else I.console&&console.log(c)}function da(a){return parseFloat(a.toPrecision(14))}function Qa(a,b){va=m(a,b.animation)}function Cb(){var a=F.global.useUTC,b=a?"getUTC":"get",c=a?"setUTC":"set";Ra=(a&&F.global.timezoneOffset||
0)*6E4;eb=a?Date.UTC:function(a,b,c,g,h,i){return(new Date(a,b,m(c,1),m(g,0),m(h,0),m(i,0))).getTime()};pb=b+"Minutes";qb=b+"Hours";rb=b+"Day";Xa=b+"Date";fb=b+"Month";gb=b+"FullYear";Db=c+"Minutes";Eb=c+"Hours";sb=c+"Date";Fb=c+"Month";Gb=c+"FullYear"}function U(){}function Sa(a,b,c,d){this.axis=a;this.pos=b;this.type=c||"";this.isNew=!0;!c&&!d&&this.addLabel()}function la(){this.init.apply(this,arguments)}function Ya(){this.init.apply(this,arguments)}function Hb(a,b,c,d,e){var f=a.chart.inverted;
this.axis=a;this.isNegative=c;this.options=b;this.x=d;this.total=null;this.points={};this.stack=e;this.alignOptions={align:b.align||(f?c?"left":"right":"center"),verticalAlign:b.verticalAlign||(f?"middle":c?"bottom":"top"),y:m(b.y,f?4:c?14:-6),x:m(b.x,f?c?-6:6:0)};this.textAlign=b.textAlign||(f?c?"right":"left":"center")}var t,y=document,I=window,T=Math,u=T.round,S=T.floor,Ka=T.ceil,v=T.max,C=T.min,O=T.abs,Z=T.cos,ea=T.sin,ma=T.PI,Ca=ma*2/360,wa=navigator.userAgent,Ib=I.opera,Aa=/msie/i.test(wa)&&
!Ib,hb=y.documentMode===8,ib=/AppleWebKit/.test(wa),Ta=/Firefox/.test(wa),Jb=/(Mobile|Android|Windows Phone)/.test(wa),xa="http://www.w3.org/2000/svg",aa=!!y.createElementNS&&!!y.createElementNS(xa,"svg").createSVGRect,Nb=Ta&&parseInt(wa.split("Firefox/")[1],10)<4,fa=!aa&&!Aa&&!!y.createElement("canvas").getContext,Za,$a,Kb={},tb=0,db,F,cb,va,ub,z,sa=function(){},V=[],ab=0,Ja="div",N="none",Ob=/^[0-9]+$/,Pb="stroke-width",eb,Ra,pb,qb,rb,Xa,fb,gb,Db,Eb,sb,Fb,Gb,G={},R=I.Highcharts=I.Highcharts?ra(16,
!0):{};cb=function(a,b,c){if(!r(b)||isNaN(b))return"Invalid date";var a=m(a,"%Y-%m-%d %H:%M:%S"),d=new Date(b-Ra),e,f=d[qb](),g=d[rb](),h=d[Xa](),i=d[fb](),j=d[gb](),k=F.lang,l=k.weekdays,d=q({a:l[g].substr(0,3),A:l[g],d:Ha(h),e:h,b:k.shortMonths[i],B:k.months[i],m:Ha(i+1),y:j.toString().substr(2,2),Y:j,H:Ha(f),I:Ha(f%12||12),l:f%12||12,M:Ha(d[pb]()),p:f<12?"AM":"PM",P:f<12?"am":"pm",S:Ha(d.getSeconds()),L:Ha(u(b%1E3),3)},R.dateFormats);for(e in d)for(;a.indexOf("%"+e)!==-1;)a=a.replace("%"+e,typeof d[e]===
"function"?d[e](b):d[e]);return c?a.substr(0,1).toUpperCase()+a.substr(1):a};Bb.prototype={wrapColor:function(a){if(this.color>=a)this.color=0},wrapSymbol:function(a){if(this.symbol>=a)this.symbol=0}};z=function(){for(var a=0,b=arguments,c=b.length,d={};a<c;a++)d[b[a++]]=b[a];return d}("millisecond",1,"second",1E3,"minute",6E4,"hour",36E5,"day",864E5,"week",6048E5,"month",26784E5,"year",31556952E3);ub={init:function(a,b,c){var b=b||"",d=a.shift,e=b.indexOf("C")>-1,f=e?7:3,g,b=b.split(" "),c=[].concat(c),
h,i,j=function(a){for(g=a.length;g--;)a[g]==="M"&&a.splice(g+1,0,a[g+1],a[g+2],a[g+1],a[g+2])};e&&(j(b),j(c));a.isArea&&(h=b.splice(b.length-6,6),i=c.splice(c.length-6,6));if(d<=c.length/f&&b.length===c.length)for(;d--;)c=[].concat(c).splice(0,f).concat(c);a.shift=0;if(b.length)for(a=c.length;b.length<a;)d=[].concat(b).splice(b.length-f,f),e&&(d[f-6]=d[f-2],d[f-5]=d[f-1]),b=b.concat(d);h&&(b=b.concat(h),c=c.concat(i));return[b,c]},step:function(a,b,c,d){var e=[],f=a.length;if(c===1)e=d;else if(f===
b.length&&c<1)for(;f--;)d=parseFloat(a[f]),e[f]=isNaN(d)?a[f]:c*parseFloat(b[f]-d)+d;else e=b;return e}};(function(a){I.HighchartsAdapter=I.HighchartsAdapter||a&&{init:function(b){var c=a.fx,d=c.step,e,f=a.Tween,g=f&&f.propHooks;e=a.cssHooks.opacity;a.extend(a.easing,{easeOutQuad:function(a,b,c,d,e){return-d*(b/=e)*(b-2)+c}});a.each(["cur","_default","width","height","opacity"],function(a,b){var e=d,k;b==="cur"?e=c.prototype:b==="_default"&&f&&(e=g[b],b="set");(k=e[b])&&(e[b]=function(c){var d,c=
a?c:this;if(c.prop!=="align")return d=c.elem,d.attr?d.attr(c.prop,b==="cur"?t:c.now):k.apply(this,arguments)})});Ma(e,"get",function(a,b,c){return b.attr?b.opacity||0:a.call(this,b,c)});e=function(a){var c=a.elem,d;if(!a.started)d=b.init(c,c.d,c.toD),a.start=d[0],a.end=d[1],a.started=!0;c.attr("d",b.step(a.start,a.end,a.pos,c.toD))};f?g.d={set:e}:d.d=e;this.each=Array.prototype.forEach?function(a,b){return Array.prototype.forEach.call(a,b)}:function(a,b){for(var c=0,d=a.length;c<d;c++)if(b.call(a[c],
a[c],c,a)===!1)return c};a.fn.highcharts=function(){var a="Chart",b=arguments,c,d;if(this[0]){Fa(b[0])&&(a=b[0],b=Array.prototype.slice.call(b,1));c=b[0];if(c!==t)c.chart=c.chart||{},c.chart.renderTo=this[0],new R[a](c,b[1]),d=this;c===t&&(d=V[H(this[0],"data-highcharts-chart")])}return d}},getScript:a.getScript,inArray:a.inArray,adapterRun:function(b,c){return a(b)[c]()},grep:a.grep,map:function(a,c){for(var d=[],e=0,f=a.length;e<f;e++)d[e]=c.call(a[e],a[e],e,a);return d},offset:function(b){return a(b).offset()},
addEvent:function(b,c,d){a(b).bind(c,d)},removeEvent:function(b,c,d){var e=y.removeEventListener?"removeEventListener":"detachEvent";y[e]&&b&&!b[e]&&(b[e]=function(){});a(b).unbind(c,d)},fireEvent:function(b,c,d,e){var f=a.Event(c),g="detached"+c,h;!Aa&&d&&(delete d.layerX,delete d.layerY,delete d.returnValue);q(f,d);b[c]&&(b[g]=b[c],b[c]=null);a.each(["preventDefault","stopPropagation"],function(a,b){var c=f[b];f[b]=function(){try{c.call(f)}catch(a){b==="preventDefault"&&(h=!0)}}});a(b).trigger(f);
b[g]&&(b[c]=b[g],b[g]=null);e&&!f.isDefaultPrevented()&&!h&&e(f)},washMouseEvent:function(a){var c=a.originalEvent||a;if(c.pageX===t)c.pageX=a.pageX,c.pageY=a.pageY;return c},animate:function(b,c,d){var e=a(b);if(!b.style)b.style={};if(c.d)b.toD=c.d,c.d=1;e.stop();c.opacity!==t&&b.attr&&(c.opacity+="px");e.animate(c,d)},stop:function(b){a(b).stop()}}})(I.jQuery);var P=I.HighchartsAdapter,L=P||{};P&&P.init.call(P,ub);var jb=L.adapterRun,Qb=L.getScript,Da=L.inArray,p=L.each,vb=L.grep,Rb=L.offset,Ua=
L.map,K=L.addEvent,W=L.removeEvent,E=L.fireEvent,Sb=L.washMouseEvent,kb=L.animate,bb=L.stop,L={enabled:!0,x:0,y:15,style:{color:"#606060",cursor:"default",fontSize:"11px"}};F={colors:"#7cb5ec,#434348,#90ed7d,#f7a35c,#8085e9,#f15c80,#e4d354,#8085e8,#8d4653,#91e8e1".split(","),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January,February,March,April,May,June,July,August,September,October,November,December".split(","),shortMonths:"Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec".split(","),
weekdays:"Sunday,Monday,Tuesday,Wednesday,Thursday,Friday,Saturday".split(","),decimalPoint:".",numericSymbols:"k,M,G,T,P,E".split(","),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:","},global:{useUTC:!0,canvasToolsURL:"http://code.highcharts.com/4.0.0/modules/canvas-tools.js",VMLRadialGradientURL:"http://code.highcharts.com/4.0.0/gfx/vml-radial-gradient.png"},chart:{borderColor:"#4572A7",borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,
10],backgroundColor:"#FFFFFF",plotBorderColor:"#C0C0C0",resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}}},title:{text:"Chart title",align:"center",margin:15,style:{color:"#333333",fontSize:"18px"}},subtitle:{text:"",align:"center",style:{color:"#555555"}},plotOptions:{line:{allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},lineWidth:2,marker:{lineWidth:0,radius:4,lineColor:"#FFFFFF",states:{hover:{enabled:!0},select:{fillColor:"#FFFFFF",lineColor:"#000000",
lineWidth:2}}},point:{events:{}},dataLabels:w(L,{align:"center",enabled:!1,formatter:function(){return this.y===null?"":Ga(this.y,-1)},verticalAlign:"bottom",y:0}),cropThreshold:300,pointRange:0,states:{hover:{marker:{},halo:{size:10,opacity:0.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3}},labels:{style:{position:"absolute",color:"#3E576F"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#909090",borderRadius:0,navigation:{activeColor:"#274b6d",
inactiveColor:"#CCC"},shadow:!1,itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold"},itemHoverStyle:{color:"#000"},itemHiddenStyle:{color:"#CCC"},itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"1em"},style:{position:"absolute",backgroundColor:"white",opacity:0.5,textAlign:"center"}},tooltip:{enabled:!0,animation:aa,backgroundColor:"rgba(249, 249, 249, .85)",
borderWidth:1,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},headerFormat:'<span style="font-size: 10px">{point.key}</span><br/>',pointFormat:'<span style="color:{series.color}">●</span> {series.name}: <b>{point.y}</b><br/>',shadow:!0,snap:Jb?25:10,style:{color:"#333333",cursor:"default",fontSize:"12px",padding:"8px",
whiteSpace:"nowrap"}},credits:{enabled:!0,text:"Highcharts.com",href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#909090",fontSize:"9px"}}};var ba=F.plotOptions,P=ba.line;Cb();var Tb=/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,Ub=/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,Vb=/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,ya=function(a){var b=[],c,
d;(function(a){a&&a.stops?d=Ua(a.stops,function(a){return ya(a[1])}):(c=Tb.exec(a))?b=[A(c[1]),A(c[2]),A(c[3]),parseFloat(c[4],10)]:(c=Ub.exec(a))?b=[A(c[1],16),A(c[2],16),A(c[3],16),1]:(c=Vb.exec(a))&&(b=[A(c[1]),A(c[2]),A(c[3]),1])})(a);return{get:function(c){var f;d?(f=w(a),f.stops=[].concat(f.stops),p(d,function(a,b){f.stops[b]=[f.stops[b][0],a.get(c)]})):f=b&&!isNaN(b[0])?c==="rgb"?"rgb("+b[0]+","+b[1]+","+b[2]+")":c==="a"?b[3]:"rgba("+b.join(",")+")":a;return f},brighten:function(a){if(d)p(d,
function(b){b.brighten(a)});else if(ha(a)&&a!==0){var c;for(c=0;c<3;c++)b[c]+=A(a*255),b[c]<0&&(b[c]=0),b[c]>255&&(b[c]=255)}return this},rgba:b,setOpacity:function(a){b[3]=a;return this}}};U.prototype={init:function(a,b){this.element=b==="span"?Y(b):y.createElementNS(xa,b);this.renderer=a},opacity:1,animate:function(a,b,c){b=m(b,va,!0);bb(this);if(b){b=w(b,{});if(c)b.complete=c;kb(this,a,b)}else this.attr(a),c&&c()},colorGradient:function(a,b,c){var d=this.renderer,e,f,g,h,i,j,k,l,o,n,s=[];a.linearGradient?
f="linearGradient":a.radialGradient&&(f="radialGradient");if(f){g=a[f];h=d.gradients;j=a.stops;o=c.radialReference;La(g)&&(a[f]=g={x1:g[0],y1:g[1],x2:g[2],y2:g[3],gradientUnits:"userSpaceOnUse"});f==="radialGradient"&&o&&!r(g.gradientUnits)&&(g=w(g,{cx:o[0]-o[2]/2+g.cx*o[2],cy:o[1]-o[2]/2+g.cy*o[2],r:g.r*o[2],gradientUnits:"userSpaceOnUse"}));for(n in g)n!=="id"&&s.push(n,g[n]);for(n in j)s.push(j[n]);s=s.join(",");h[s]?a=h[s].attr("id"):(g.id=a="highcharts-"+tb++,h[s]=i=d.createElement(f).attr(g).add(d.defs),
i.stops=[],p(j,function(a){a[1].indexOf("rgba")===0?(e=ya(a[1]),k=e.get("rgb"),l=e.get("a")):(k=a[1],l=1);a=d.createElement("stop").attr({offset:a[0],"stop-color":k,"stop-opacity":l}).add(i);i.stops.push(a)}));c.setAttribute(b,"url("+d.url+"#"+a+")")}},attr:function(a,b){var c,d,e=this.element,f,g=this,h;typeof a==="string"&&b!==t&&(c=a,a={},a[c]=b);if(typeof a==="string")g=(this[a+"Getter"]||this._defaultGetter).call(this,a,e);else{for(c in a){d=a[c];h=!1;this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(c)&&
(f||(this.symbolAttr(a),f=!0),h=!0);if(this.rotation&&(c==="x"||c==="y"))this.doTransform=!0;h||(this[c+"Setter"]||this._defaultSetter).call(this,d,c,e);this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(c)&&this.updateShadows(c,d)}if(this.doTransform)this.updateTransform(),this.doTransform=!1}return g},updateShadows:function(a,b){for(var c=this.shadows,d=c.length;d--;)c[d].setAttribute(a,a==="height"?v(b-(c[d].cutHeight||0),0):a==="d"?this.d:b)},addClass:function(a){var b=this.element,
c=H(b,"class")||"";c.indexOf(a)===-1&&H(b,"class",c+" "+a);return this},symbolAttr:function(a){var b=this;p("x,y,r,start,end,width,height,innerR,anchorX,anchorY".split(","),function(c){b[c]=m(a[c],b[c])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":N)},crisp:function(a){var b,c={},d,e=a.strokeWidth||this.strokeWidth||this.attr&&this.attr("stroke-width")||0;d=u(e)%2/2;a.x=S(a.x||this.x||
0)+d;a.y=S(a.y||this.y||0)+d;a.width=S((a.width||this.width||0)-2*d);a.height=S((a.height||this.height||0)-2*d);a.strokeWidth=e;for(b in a)this[b]!==a[b]&&(this[b]=c[b]=a[b]);return c},css:function(a){var b=this.styles,c={},d=this.element,e,f,g="";e=!b;if(a&&a.color)a.fill=a.color;if(b)for(f in a)a[f]!==b[f]&&(c[f]=a[f],e=!0);if(e){e=this.textWidth=a&&a.width&&d.nodeName.toLowerCase()==="text"&&A(a.width);b&&(a=q(b,c));this.styles=a;e&&(fa||!aa&&this.renderer.forExport)&&delete a.width;if(Aa&&!aa)D(this.element,
a);else{b=function(a,b){return"-"+b.toLowerCase()};for(f in a)g+=f.replace(/([A-Z])/g,b)+":"+a[f]+";";H(d,"style",g)}e&&this.added&&this.renderer.buildText(this)}return this},on:function(a,b){var c=this,d=c.element;$a&&a==="click"?(d.ontouchstart=function(a){c.touchEventFired=Date.now();a.preventDefault();b.call(d,a)},d.onclick=function(a){(wa.indexOf("Android")===-1||Date.now()-(c.touchEventFired||0)>1100)&&b.call(d,a)}):d["on"+a]=b;return this},setRadialReference:function(a){this.element.radialReference=
a;return this},translate:function(a,b){return this.attr({translateX:a,translateY:b})},invert:function(){this.inverted=!0;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,b=this.translateY||0,c=this.scaleX,d=this.scaleY,e=this.inverted,f=this.rotation,g=this.element;e&&(a+=this.attr("width"),b+=this.attr("height"));a=["translate("+a+","+b+")"];e?a.push("rotate(90) scale(-1,1)"):f&&a.push("rotate("+f+" "+(g.getAttribute("x")||0)+" "+(g.getAttribute("y")||0)+")");
(r(c)||r(d))&&a.push("scale("+m(c,1)+" "+m(d,1)+")");a.length&&g.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,b,c){var d,e,f,g,h={};e=this.renderer;f=e.alignedObjects;if(a){if(this.alignOptions=a,this.alignByTranslate=b,!c||Fa(c))this.alignTo=d=c||"renderer",ja(f,this),f.push(this),c=null}else a=this.alignOptions,b=this.alignByTranslate,d=this.alignTo;c=m(c,e[d],e);d=a.align;e=a.verticalAlign;f=(c.x||0)+(a.x||
0);g=(c.y||0)+(a.y||0);if(d==="right"||d==="center")f+=(c.width-(a.width||0))/{right:1,center:2}[d];h[b?"translateX":"x"]=u(f);if(e==="bottom"||e==="middle")g+=(c.height-(a.height||0))/({bottom:1,middle:2}[e]||1);h[b?"translateY":"y"]=u(g);this[this.placed?"animate":"attr"](h);this.placed=!0;this.alignAttr=h;return this},getBBox:function(){var a=this.bBox,b=this.renderer,c,d,e=this.rotation;c=this.element;var f=this.styles,g=e*Ca;d=this.textStr;var h;if(d===""||Ob.test(d))h="num."+d.toString().length+
(f?"|"+f.fontSize+"|"+f.fontFamily:"");h&&(a=b.cache[h]);if(!a){if(c.namespaceURI===xa||b.forExport){try{a=c.getBBox?q({},c.getBBox()):{width:c.offsetWidth,height:c.offsetHeight}}catch(i){}if(!a||a.width<0)a={width:0,height:0}}else a=this.htmlGetBBox();if(b.isSVG){c=a.width;d=a.height;if(Aa&&f&&f.fontSize==="11px"&&d.toPrecision(3)==="16.9")a.height=d=14;if(e)a.width=O(d*ea(g))+O(c*Z(g)),a.height=O(d*Z(g))+O(c*ea(g))}this.bBox=a;h&&(b.cache[h]=a)}return a},show:function(a){return a&&this.element.namespaceURI===
xa?(this.element.removeAttribute("visibility"),this):this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var b=this;b.animate({opacity:0},{duration:a||150,complete:function(){b.hide()}})},add:function(a){var b=this.renderer,c=a||b,d=c.element||b.box,e=this.element,f=this.zIndex,g,h;if(a)this.parentGroup=a;this.parentInverted=a&&a.inverted;this.textStr!==void 0&&b.buildText(this);if(f)c.handleZ=!0,f=A(f);if(c.handleZ){a=d.childNodes;
for(g=0;g<a.length;g++)if(b=a[g],c=H(b,"zIndex"),b!==e&&(A(c)>f||!r(f)&&r(c))){d.insertBefore(e,b);h=!0;break}}h||d.appendChild(e);this.added=!0;if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var b=a.parentNode;b&&b.removeChild(a)},destroy:function(){var a=this,b=a.element||{},c=a.shadows,d=a.renderer.isSVG&&b.nodeName==="SPAN"&&a.parentGroup,e,f;b.onclick=b.onmouseout=b.onmouseover=b.onmousemove=b.point=null;bb(a);if(a.clipPath)a.clipPath=a.clipPath.destroy();if(a.stops){for(f=
0;f<a.stops.length;f++)a.stops[f]=a.stops[f].destroy();a.stops=null}a.safeRemoveChild(b);for(c&&p(c,function(b){a.safeRemoveChild(b)});d&&d.div.childNodes.length===0;)b=d.parentGroup,a.safeRemoveChild(d.div),delete d.div,d=b;a.alignTo&&ja(a.renderer.alignedObjects,a);for(e in a)delete a[e];return null},shadow:function(a,b,c){var d=[],e,f,g=this.element,h,i,j,k;if(a){i=m(a.width,3);j=(a.opacity||0.15)/i;k=this.parentInverted?"(-1,-1)":"("+m(a.offsetX,1)+", "+m(a.offsetY,1)+")";for(e=1;e<=i;e++){f=
g.cloneNode(0);h=i*2+1-2*e;H(f,{isShadow:"true",stroke:a.color||"black","stroke-opacity":j*e,"stroke-width":h,transform:"translate"+k,fill:N});if(c)H(f,"height",v(H(f,"height")-h,0)),f.cutHeight=h;b?b.element.appendChild(f):g.parentNode.insertBefore(f,g);d.push(f)}this.shadows=d}return this},xGetter:function(a){this.element.nodeName==="circle"&&(a={x:"cx",y:"cy"}[a]||a);return this._defaultGetter(a)},_defaultGetter:function(a){a=m(this[a],this.element?this.element.getAttribute(a):null,0);/^[0-9\.]+$/.test(a)&&
(a=parseFloat(a));return a},dSetter:function(a,b,c){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");c.setAttribute(b,a);this[b]=a},dashstyleSetter:function(a){var b;if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=A(a[b])*this.element.getAttribute("stroke-width");
a=a.join(",");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,b,c){this[b]=a;c.setAttribute(b,a)},"stroke-widthSetter":function(a,b,c){a===0&&(a=1.0E-5);this.strokeWidth=a;c.setAttribute(b,a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=y.createElementNS(xa,"title"),this.element.appendChild(b));b.textContent=a},textSetter:function(a){if(a!==
this.textStr)delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this)},fillSetter:function(a,b,c){typeof a==="string"?c.setAttribute(b,a):a&&this.colorGradient(a,b,c)},zIndexSetter:function(a,b,c){c.setAttribute(b,a);this[b]=a},_defaultSetter:function(a,b,c){c.setAttribute(b,a)}};U.prototype.yGetter=U.prototype.xGetter;U.prototype.translateXSetter=U.prototype.translateYSetter=U.prototype.rotationSetter=U.prototype.verticalAlignSetter=U.prototype.scaleXSetter=U.prototype.scaleYSetter=
function(a,b){this[b]=a;this.doTransform=!0};var ta=function(){this.init.apply(this,arguments)};ta.prototype={Element:U,init:function(a,b,c,d,e){var f=location,g,d=this.createElement("svg").attr({version:"1.1"}).css(this.getStyle(d));g=d.element;a.appendChild(g);a.innerHTML.indexOf("xmlns")===-1&&H(g,"xmlns",xa);this.isSVG=!0;this.box=g;this.boxWrapper=d;this.alignedObjects=[];this.url=(Ta||ib)&&y.getElementsByTagName("base").length?f.href.replace(/#.*?$/,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,
"%20"):"";this.createElement("desc").add().element.appendChild(y.createTextNode("Created with Highcharts 4.0.0"));this.defs=this.createElement("defs").add();this.forExport=e;this.gradients={};this.cache={};this.setSize(b,c,!1);var h;if(Ta&&a.getBoundingClientRect)this.subPixelFix=b=function(){D(a,{left:0,top:0});h=a.getBoundingClientRect();D(a,{left:Ka(h.left)-h.left+"px",top:Ka(h.top)-h.top+"px"})},b(),K(I,"resize",b)},getStyle:function(a){return this.style=q({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',
fontSize:"12px"},a)},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();Oa(this.gradients||{});this.gradients=null;if(a)this.defs=a.destroy();this.subPixelFix&&W(I,"resize",this.subPixelFix);return this.alignedObjects=null},createElement:function(a){var b=new this.Element;b.init(this,a);return b},draw:function(){},buildText:function(a){for(var b=a.element,c=this,d=c.forExport,e=m(a.textStr,"").toString(),
f=e.indexOf("<")!==-1,g=b.childNodes,h,i,j=H(b,"x"),k=a.styles,l=a.textWidth,o=k&&k.lineHeight,n=g.length,s=function(a){return o?A(o):c.fontMetrics(/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:k&&k.fontSize||c.style.fontSize||12).h};n--;)b.removeChild(g[n]);!f&&e.indexOf(" ")===-1?b.appendChild(y.createTextNode(e)):(h=/<.*style="([^"]+)".*>/,i=/<.*href="(http[^"]+)".*>/,l&&!a.added&&this.box.appendChild(b),e=f?e.replace(/<(b|strong)>/g,'<span style="font-weight:bold">').replace(/<(i|em)>/g,
'<span style="font-style:italic">').replace(/<a/g,"<span").replace(/<\/(b|strong|i|em|a)>/g,"</span>").split(/<br.*?>/g):[e],e[e.length-1]===""&&e.pop(),p(e,function(e,f){var g,n=0,e=e.replace(/<span/g,"|||<span").replace(/<\/span>/g,"</span>|||");g=e.split("|||");p(g,function(e){if(e!==""||g.length===1){var o={},m=y.createElementNS(xa,"tspan"),p;h.test(e)&&(p=e.match(h)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),H(m,"style",p));i.test(e)&&!d&&(H(m,"onclick",'location.href="'+e.match(i)[1]+'"'),
D(m,{cursor:"pointer"}));e=(e.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"<").replace(/&gt;/g,">");if(e!==" "){m.appendChild(y.createTextNode(e));if(n)o.dx=0;else if(f&&j!==null)o.x=j;H(m,o);!n&&f&&(!aa&&d&&D(m,{display:"block"}),H(m,"dy",s(m),ib&&m.offsetHeight));b.appendChild(m);n++;if(l)for(var e=e.replace(/([^\^])-/g,"$1- ").split(" "),o=e.length>1&&k.whiteSpace!=="nowrap",$,r,B=a._clipHeight,q=[],v=s(),t=1;o&&(e.length||q.length);)delete a.bBox,$=a.getBBox(),r=$.width,!aa&&c.forExport&&
(r=c.measureSpanWidth(m.firstChild.data,a.styles)),$=r>l,!$||e.length===1?(e=q,q=[],e.length&&(t++,B&&t*v>B?(e=["..."],a.attr("title",a.textStr)):(m=y.createElementNS(xa,"tspan"),H(m,{dy:v,x:j}),p&&H(m,"style",p),b.appendChild(m),r>l&&(l=r)))):(m.removeChild(m.firstChild),q.unshift(e.pop())),e.length&&m.appendChild(y.createTextNode(e.join(" ").replace(/- /g,"-")))}}})}))},button:function(a,b,c,d,e,f,g,h,i){var j=this.label(a,b,c,i,null,null,null,null,"button"),k=0,l,o,n,s,m,p,a={x1:0,y1:0,x2:0,y2:1},
e=w({"stroke-width":1,stroke:"#CCCCCC",fill:{linearGradient:a,stops:[[0,"#FEFEFE"],[1,"#F6F6F6"]]},r:2,padding:5,style:{color:"black"}},e);n=e.style;delete e.style;f=w(e,{stroke:"#68A",fill:{linearGradient:a,stops:[[0,"#FFF"],[1,"#ACF"]]}},f);s=f.style;delete f.style;g=w(e,{stroke:"#68A",fill:{linearGradient:a,stops:[[0,"#9BD"],[1,"#CDF"]]}},g);m=g.style;delete g.style;h=w(e,{style:{color:"#CCC"}},h);p=h.style;delete h.style;K(j.element,Aa?"mouseover":"mouseenter",function(){k!==3&&j.attr(f).css(s)});
K(j.element,Aa?"mouseout":"mouseleave",function(){k!==3&&(l=[e,f,g][k],o=[n,s,m][k],j.attr(l).css(o))});j.setState=function(a){(j.state=k=a)?a===2?j.attr(g).css(m):a===3&&j.attr(h).css(p):j.attr(e).css(n)};return j.on("click",function(){k!==3&&d.call(j)}).attr(e).css(q({cursor:"default"},n))},crispLine:function(a,b){a[1]===a[4]&&(a[1]=a[4]=u(a[1])-b%2/2);a[2]===a[5]&&(a[2]=a[5]=u(a[2])+b%2/2);return a},path:function(a){var b={fill:N};La(a)?b.d=a:ca(a)&&q(b,a);return this.createElement("path").attr(b)},
circle:function(a,b,c){a=ca(a)?a:{x:a,y:b,r:c};b=this.createElement("circle");b.xSetter=function(a){this.element.setAttribute("cx",a)};b.ySetter=function(a){this.element.setAttribute("cy",a)};return b.attr(a)},arc:function(a,b,c,d,e,f){if(ca(a))b=a.y,c=a.r,d=a.innerR,e=a.start,f=a.end,a=a.x;a=this.symbol("arc",a||0,b||0,c||0,c||0,{innerR:d||0,start:e||0,end:f||0});a.r=c;return a},rect:function(a,b,c,d,e,f){var e=ca(a)?a.r:e,g=this.createElement("rect"),a=ca(a)?a:a===t?{}:{x:a,y:b,width:v(c,0),height:v(d,
0)};if(f!==t)a.strokeWidth=f,a=g.crisp(a);if(e)a.r=e;g.rSetter=function(a){H(this.element,{rx:a,ry:a})};return g.attr(a)},setSize:function(a,b,c){var d=this.alignedObjects,e=d.length;this.width=a;this.height=b;for(this.boxWrapper[m(c,!0)?"animate":"attr"]({width:a,height:b});e--;)d[e].align()},g:function(a){var b=this.createElement("g");return r(a)?b.attr({"class":"highcharts-"+a}):b},image:function(a,b,c,d,e){var f={preserveAspectRatio:N};arguments.length>1&&q(f,{x:b,y:c,width:d,height:e});f=this.createElement("image").attr(f);
f.element.setAttributeNS?f.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):f.element.setAttribute("hc-svg-href",a);return f},symbol:function(a,b,c,d,e,f){var g,h=this.symbols[a],h=h&&h(u(b),u(c),d,e,f),i=/^url\((.*?)\)$/,j,k;if(h)g=this.path(h),q(g,{symbolName:a,x:b,y:c,width:d,height:e}),f&&q(g,f);else if(i.test(a))k=function(a,b){a.element&&(a.attr({width:b[0],height:b[1]}),a.alignByTranslate||a.translate(u((d-b[0])/2),u((e-b[1])/2)))},j=a.match(i)[1],a=Kb[j],g=this.image(j).attr({x:b,
y:c}),g.isImg=!0,a?k(g,a):(g.attr({width:0,height:0}),Y("img",{onload:function(){k(g,Kb[j]=[this.width,this.height])},src:j}));return g},symbols:{circle:function(a,b,c,d){var e=0.166*c;return["M",a+c/2,b,"C",a+c+e,b,a+c+e,b+d,a+c/2,b+d,"C",a-e,b+d,a-e,b,a+c/2,b,"Z"]},square:function(a,b,c,d){return["M",a,b,"L",a+c,b,a+c,b+d,a,b+d,"Z"]},triangle:function(a,b,c,d){return["M",a+c/2,b,"L",a+c,b+d,a,b+d,"Z"]},"triangle-down":function(a,b,c,d){return["M",a,b,"L",a+c,b,a+c/2,b+d,"Z"]},diamond:function(a,
b,c,d){return["M",a+c/2,b,"L",a+c,b+d/2,a+c/2,b+d,a,b+d/2,"Z"]},arc:function(a,b,c,d,e){var f=e.start,c=e.r||c||d,g=e.end-0.001,d=e.innerR,h=e.open,i=Z(f),j=ea(f),k=Z(g),g=ea(g),e=e.end-f<ma?0:1;return["M",a+c*i,b+c*j,"A",c,c,0,e,1,a+c*k,b+c*g,h?"M":"L",a+d*k,b+d*g,"A",d,d,0,e,0,a+d*i,b+d*j,h?"":"Z"]},callout:function(a,b,c,d,e){var f=C(e&&e.r||0,c,d),g=f+6,h=e&&e.anchorX,i=e&&e.anchorY,e=u(e.strokeWidth||0)%2/2;a+=e;b+=e;e=["M",a+f,b,"L",a+c-f,b,"C",a+c,b,a+c,b,a+c,b+f,"L",a+c,b+d-f,"C",a+c,b+d,
a+c,b+d,a+c-f,b+d,"L",a+f,b+d,"C",a,b+d,a,b+d,a,b+d-f,"L",a,b+f,"C",a,b,a,b,a+f,b];h&&h>c&&i>b+g&&i<b+d-g?e.splice(13,3,"L",a+c,i-6,a+c+6,i,a+c,i+6,a+c,b+d-f):h&&h<0&&i>b+g&&i<b+d-g?e.splice(33,3,"L",a,i+6,a-6,i,a,i-6,a,b+f):i&&i>d&&h>a+g&&h<a+c-g?e.splice(23,3,"L",h+6,b+d,h,b+d+6,h-6,b+d,a+f,b+d):i&&i<0&&h>a+g&&h<a+c-g&&e.splice(3,3,"L",h-6,b,h,b-6,h+6,b,c-f,b);return e}},clipRect:function(a,b,c,d){var e="highcharts-"+tb++,f=this.createElement("clipPath").attr({id:e}).add(this.defs),a=this.rect(a,
b,c,d,0).add(f);a.id=e;a.clipPath=f;return a},text:function(a,b,c,d){var e=fa||!aa&&this.forExport,f={};if(d&&!this.forExport)return this.html(a,b,c);f.x=Math.round(b||0);if(c)f.y=Math.round(c);if(a||a===0)f.text=a;a=this.createElement("text").attr(f);e&&a.css({position:"absolute"});if(!d)a.xSetter=function(a,b,c){var d=c.childNodes,e,f;for(f=1;f<d.length;f++)e=d[f],e.getAttribute("x")===c.getAttribute("x")&&e.setAttribute("x",a);c.setAttribute(b,a)};return a},fontMetrics:function(a){var a=a||this.style.fontSize,
a=/px/.test(a)?A(a):/em/.test(a)?parseFloat(a)*12:12,a=a<24?a+4:u(a*1.2),b=u(a*0.8);return{h:a,b:b}},label:function(a,b,c,d,e,f,g,h,i){function j(){var a,b;a=s.element.style;J=(Va===void 0||wb===void 0||n.styles.textAlign)&&s.textStr&&s.getBBox();n.width=(Va||J.width||0)+2*x+v;n.height=(wb||J.height||0)+2*x;na=x+o.fontMetrics(a&&a.fontSize).b;if(A){if(!m)a=u(-Q*x),b=h?-na:0,n.box=m=d?o.symbol(d,a,b,n.width,n.height,B):o.rect(a,b,n.width,n.height,0,B[Pb]),m.attr("fill",N).add(n);m.isImg||m.attr(q({width:u(n.width),
height:u(n.height)},B));B=null}}function k(){var a=n.styles,a=a&&a.textAlign,b=v+x*(1-Q),c;c=h?0:na;if(r(Va)&&J&&(a==="center"||a==="right"))b+={center:0.5,right:1}[a]*(Va-J.width);if(b!==s.x||c!==s.y)s.attr("x",b),c!==t&&s.attr("y",c);s.x=b;s.y=c}function l(a,b){m?m.attr(a,b):B[a]=b}var o=this,n=o.g(i),s=o.text("",0,0,g).attr({zIndex:1}),m,J,Q=0,x=3,v=0,Va,wb,xb,yb,y=0,B={},na,A;n.onAdd=function(){s.add(n);n.attr({text:a||"",x:b,y:c});m&&r(e)&&n.attr({anchorX:e,anchorY:f})};n.widthSetter=function(a){Va=
a};n.heightSetter=function(a){wb=a};n.paddingSetter=function(a){r(a)&&a!==x&&(x=a,k())};n.paddingLeftSetter=function(a){r(a)&&a!==v&&(v=a,k())};n.alignSetter=function(a){Q={left:0,center:0.5,right:1}[a]};n.textSetter=function(a){a!==t&&s.textSetter(a);j();k()};n["stroke-widthSetter"]=function(a,b){a&&(A=!0);y=a%2/2;l(b,a)};n.strokeSetter=n.fillSetter=n.rSetter=function(a,b){b==="fill"&&a&&(A=!0);l(b,a)};n.anchorXSetter=function(a,b){e=a;l(b,a+y-xb)};n.anchorYSetter=function(a,b){f=a;l(b,a-yb)};n.xSetter=
function(a){n.x=a;Q&&(a-=Q*((Va||J.width)+x));xb=u(a);n.attr("translateX",xb)};n.ySetter=function(a){yb=n.y=u(a);n.attr("translateY",yb)};var z=n.css;return q(n,{css:function(a){if(a){var b={},a=w(a);p("fontSize,fontWeight,fontFamily,color,lineHeight,width,textDecoration,textShadow".split(","),function(c){a[c]!==t&&(b[c]=a[c],delete a[c])});s.css(b)}return z.call(n,a)},getBBox:function(){return{width:J.width+2*x,height:J.height+2*x,x:J.x-x,y:J.y-x}},shadow:function(a){m&&m.shadow(a);return n},destroy:function(){W(n.element,
"mouseenter");W(n.element,"mouseleave");s&&(s=s.destroy());m&&(m=m.destroy());U.prototype.destroy.call(n);n=o=j=k=l=null}})}};Za=ta;q(U.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&b.tagName==="SPAN"&&a.width)delete a.width,this.textWidth=b,this.updateTransform();this.styles=q(this.styles,a);D(this.element,a);return this},htmlGetBBox:function(){var a=this.element,b=this.bBox;if(!b){if(a.nodeName==="text")a.style.position="absolute";b=this.bBox={x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,
height:a.offsetHeight}}return b},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,c=this.translateX||0,d=this.translateY||0,e=this.x||0,f=this.y||0,g=this.textAlign||"left",h={left:0,center:0.5,right:1}[g],i=this.shadows;D(b,{marginLeft:c,marginTop:d});i&&p(i,function(a){D(a,{marginLeft:c+1,marginTop:d+1})});this.inverted&&p(b.childNodes,function(c){a.invertChild(c,b)});if(b.tagName==="SPAN"){var j=this.rotation,k,l=A(this.textWidth),o=[j,g,b.innerHTML,this.textWidth].join(",");
if(o!==this.cTT){k=a.fontMetrics(b.style.fontSize).b;r(j)&&this.setSpanRotation(j,h,k);i=m(this.elemWidth,b.offsetWidth);if(i>l&&/[ \-]/.test(b.textContent||b.innerText))D(b,{width:l+"px",display:"block",whiteSpace:"normal"}),i=l;this.getSpanCorrection(i,k,h,j,g)}D(b,{left:e+(this.xCorr||0)+"px",top:f+(this.yCorr||0)+"px"});if(ib)k=b.offsetHeight;this.cTT=o}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,c){var d={},e=Aa?"-ms-transform":ib?"-webkit-transform":Ta?"MozTransform":Ib?"-o-transform":
"";d[e]=d.transform="rotate("+a+"deg)";d[e+(Ta?"Origin":"-origin")]=d.transformOrigin=b*100+"% "+c+"px";D(this.element,d)},getSpanCorrection:function(a,b,c){this.xCorr=-a*c;this.yCorr=-b}});q(ta.prototype,{html:function(a,b,c){var d=this.createElement("span"),e=d.element,f=d.renderer;d.textSetter=function(a){a!==e.innerHTML&&delete this.bBox;e.innerHTML=this.textStr=a};d.xSetter=d.ySetter=d.alignSetter=d.rotationSetter=function(a,b){b==="align"&&(b="textAlign");d[b]=a;d.htmlUpdateTransform()};d.attr({text:a,
x:u(b),y:u(c)}).css({position:"absolute",whiteSpace:"nowrap",fontFamily:this.style.fontFamily,fontSize:this.style.fontSize});d.css=d.htmlCss;if(f.isSVG)d.add=function(a){var b,c=f.box.parentNode,j=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)j.push(a),a=a.parentGroup;p(j.reverse(),function(a){var d;b=a.div=a.div||Y(Ja,{className:H(a.element,"class")},{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px"},b||c);d=b.style;q(a,{translateXSetter:function(b,c){d.left=b+"px";a[c]=
b;a.doTransform=!0},translateYSetter:function(b,c){d.top=b+"px";a[c]=b;a.doTransform=!0},visibilitySetter:function(a,b){d[b]=a}})})}}else b=c;b.appendChild(e);d.added=!0;d.alignOnAdd&&d.htmlUpdateTransform();return d};return d}});var X;if(!aa&&!fa){R.VMLElement=X={init:function(a,b){var c=["<",b,' filled="f" stroked="f"'],d=["position: ","absolute",";"],e=b===Ja;(b==="shape"||e)&&d.push("left:0;top:0;width:1px;height:1px;");d.push("visibility: ",e?"hidden":"visible");c.push(' style="',d.join(""),
'"/>');if(b)c=e||b==="span"||b==="img"?c.join(""):a.prepVML(c),this.element=Y(c);this.renderer=a},add:function(a){var b=this.renderer,c=this.element,d=b.box,d=a?a.element||a:d;a&&a.inverted&&b.invertChild(c,d);d.appendChild(c);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();return this},updateTransform:U.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Z(a*Ca),c=ea(a*Ca);D(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11=",
b,", M12=",-c,", M21=",c,", M22=",b,", sizingMethod='auto expand')"].join(""):N})},getSpanCorrection:function(a,b,c,d,e){var f=d?Z(d*Ca):1,g=d?ea(d*Ca):0,h=m(this.elemHeight,this.element.offsetHeight),i;this.xCorr=f<0&&-a;this.yCorr=g<0&&-h;i=f*g<0;this.xCorr+=g*b*(i?1-c:c);this.yCorr-=f*b*(d?i?c:1-c:1);e&&e!=="left"&&(this.xCorr-=a*c*(f<0?-1:1),d&&(this.yCorr-=h*c*(g<0?-1:1)),D(this.element,{textAlign:e}))},pathToVML:function(a){for(var b=a.length,c=[];b--;)if(ha(a[b]))c[b]=u(a[b]*10)-5;else if(a[b]===
"Z")c[b]="x";else if(c[b]=a[b],a.isArc&&(a[b]==="wa"||a[b]==="at"))c[b+5]===c[b+7]&&(c[b+7]+=a[b+7]>a[b+5]?1:-1),c[b+6]===c[b+8]&&(c[b+8]+=a[b+8]>a[b+6]?1:-1);return c.join(" ")||"x"},clip:function(a){var b=this,c;a?(c=a.members,ja(c,b),c.push(b),b.destroyClip=function(){ja(c,b)},a=a.getCSS(b)):(b.destroyClip&&b.destroyClip(),a={clip:hb?"inherit":"rect(auto)"});return b.css(a)},css:U.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&Pa(a)},destroy:function(){this.destroyClip&&this.destroyClip();
return U.prototype.destroy.apply(this)},on:function(a,b){this.element["on"+a]=function(){var a=I.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var c,a=a.split(/[ ,]/);c=a.length;if(c===9||c===11)a[c-4]=a[c-2]=A(a[c-2])-10*b;return a.join(" ")},shadow:function(a,b,c){var d=[],e,f=this.element,g=this.renderer,h,i=f.style,j,k=f.path,l,o,n,s;k&&typeof k.value!=="string"&&(k="x");o=k;if(a){n=m(a.width,3);s=(a.opacity||0.15)/n;for(e=1;e<=3;e++){l=n*2+1-2*e;c&&(o=this.cutOffPath(k.value,
l+0.5));j=['<shape isShadow="true" strokeweight="',l,'" filled="false" path="',o,'" coordsize="10 10" style="',f.style.cssText,'" />'];h=Y(g.prepVML(j),null,{left:A(i.left)+m(a.offsetX,1),top:A(i.top)+m(a.offsetY,1)});if(c)h.cutOff=l+1;j=['<stroke color="',a.color||"black",'" opacity="',s*e,'"/>'];Y(g.prepVML(j),null,null,h);b?b.element.appendChild(h):f.parentNode.insertBefore(h,f);d.push(h)}this.shadows=d}return this},updateShadows:sa,setAttr:function(a,b){hb?this.element[a]=b:this.element.setAttribute(a,
b)},classSetter:function(a){this.element.className=a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName("stroke")[0]||Y(this.renderer.prepVML(["<stroke/>"]),null,null,c))[b]=a||"solid";this[b]=a},dSetter:function(a,b,c){var d=this.shadows,a=a||[];this.d=a.join(" ");c.path=a=this.pathToVML(a);if(d)for(c=d.length;c--;)d[c].path=d[c].cutOff?this.cutOffPath(a,d[c].cutOff):a;this.setAttr(b,a)},fillSetter:function(a,b,c){var d=c.nodeName;if(d==="SPAN")c.style.color=a;else if(d!=="IMG")c.filled=a!==
N,this.setAttr("fillcolor",this.renderer.color(a,c,b,this))},opacitySetter:sa,rotationSetter:function(a,b,c){c=c.style;this[b]=c[b]=a;c.left=-u(ea(a*Ca)+1)+"px";c.top=u(Z(a*Ca))+"px"},strokeSetter:function(a,b,c){this.setAttr("strokecolor",this.renderer.color(a,c,b))},"stroke-widthSetter":function(a,b,c){c.stroked=!!a;this[b]=a;ha(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,c){a==="inherit"&&(a="visible");this.shadows&&p(this.shadows,
function(c){c.style[b]=a});c.nodeName==="DIV"&&(a=a==="hidden"?"-999em":0,hb||(c.style[b]=a?"visible":"hidden"),b="top");c.style[b]=a},xSetter:function(a,b,c){this[b]=a;b==="x"?b="left":b==="y"&&(b="top");this.updateClipping?(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}};X=ka(U,X);X.prototype.ySetter=X.prototype.widthSetter=X.prototype.heightSetter=X.prototype.xSetter;var ga={Element:X,isIE8:wa.indexOf("MSIE 8.0")>-1,init:function(a,b,c,d){var e;this.alignedObjects=
[];d=this.createElement(Ja).css(q(this.getStyle(d),{position:"relative"}));e=d.element;a.appendChild(d.element);this.isVML=!0;this.box=e;this.boxWrapper=d;this.cache={};this.setSize(b,c,!1);if(!y.namespaces.hcv){y.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{y.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(f){y.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},
isHidden:function(){return!this.box.offsetWidth},clipRect:function(a,b,c,d){var e=this.createElement(),f=ca(a);return q(e,{members:[],left:(f?a.x:a)+1,top:(f?a.y:b)+1,width:(f?a.width:c)-1,height:(f?a.height:d)-1,getCSS:function(a){var b=a.element,c=b.nodeName,a=a.inverted,d=this.top-(c==="shape"?b.offsetTop:0),e=this.left,b=e+this.width,f=d+this.height,d={clip:"rect("+u(a?e:d)+"px,"+u(a?f:b)+"px,"+u(a?b:f)+"px,"+u(a?d:e)+"px)"};!a&&hb&&c==="DIV"&&q(d,{width:b+"px",height:f+"px"});return d},updateClipping:function(){p(e.members,
function(a){a.element&&a.css(e.getCSS(a))})}})},color:function(a,b,c,d){var e=this,f,g=/^rgba/,h,i,j=N;a&&a.linearGradient?i="gradient":a&&a.radialGradient&&(i="pattern");if(i){var k,l,o=a.linearGradient||a.radialGradient,n,s,m,J,Q,x="",a=a.stops,r,v=[],q=function(){h=['<fill colors="'+v.join(",")+'" opacity="',m,'" o:opacity2="',s,'" type="',i,'" ',x,'focus="100%" method="any" />'];Y(e.prepVML(h),null,null,b)};n=a[0];r=a[a.length-1];n[0]>0&&a.unshift([0,n[1]]);r[0]<1&&a.push([1,r[1]]);p(a,function(a,
b){g.test(a[1])?(f=ya(a[1]),k=f.get("rgb"),l=f.get("a")):(k=a[1],l=1);v.push(a[0]*100+"% "+k);b?(m=l,J=k):(s=l,Q=k)});if(c==="fill")if(i==="gradient")c=o.x1||o[0]||0,a=o.y1||o[1]||0,n=o.x2||o[2]||0,o=o.y2||o[3]||0,x='angle="'+(90-T.atan((o-a)/(n-c))*180/ma)+'"',q();else{var j=o.r,t=j*2,u=j*2,y=o.cx,B=o.cy,na=b.radialReference,w,j=function(){na&&(w=d.getBBox(),y+=(na[0]-w.x)/w.width-0.5,B+=(na[1]-w.y)/w.height-0.5,t*=na[2]/w.width,u*=na[2]/w.height);x='src="'+F.global.VMLRadialGradientURL+'" size="'+
t+","+u+'" origin="0.5,0.5" position="'+y+","+B+'" color2="'+Q+'" ';q()};d.added?j():d.onAdd=j;j=J}else j=k}else if(g.test(a)&&b.tagName!=="IMG")f=ya(a),h=["<",c,' opacity="',f.get("a"),'"/>'],Y(this.prepVML(h),null,null,b),j=f.get("rgb");else{j=b.getElementsByTagName(c);if(j.length)j[0].opacity=1,j[0].type="solid";j=a}return j},prepVML:function(a){var b=this.isIE8,a=a.join("");b?(a=a.replace("/>",' xmlns="urn:schemas-microsoft-com:vml" />'),a=a.indexOf('style="')===-1?a.replace("/>",' style="display:inline-block;behavior:url(#default#VML);" />'):
a.replace('style="','style="display:inline-block;behavior:url(#default#VML);')):a=a.replace("<","<hcv:");return a},text:ta.prototype.html,path:function(a){var b={coordsize:"10 10"};La(a)?b.d=a:ca(a)&&q(b,a);return this.createElement("shape").attr(b)},circle:function(a,b,c){var d=this.symbol("circle");if(ca(a))c=a.r,b=a.y,a=a.x;d.isCircle=!0;d.r=c;return d.attr({x:a,y:b})},g:function(a){var b;a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement(Ja).attr(b)},image:function(a,
b,c,d,e){var f=this.createElement("img").attr({src:a});arguments.length>1&&f.attr({x:b,y:c,width:d,height:e});return f},createElement:function(a){return a==="rect"?this.symbol(a):ta.prototype.createElement.call(this,a)},invertChild:function(a,b){var c=this,d=b.style,e=a.tagName==="IMG"&&a.style;D(a,{flip:"x",left:A(d.width)-(e?A(e.top):1),top:A(d.height)-(e?A(e.left):1),rotation:-90});p(a.childNodes,function(b){c.invertChild(b,a)})},symbols:{arc:function(a,b,c,d,e){var f=e.start,g=e.end,h=e.r||c||
d,c=e.innerR,d=Z(f),i=ea(f),j=Z(g),k=ea(g);if(g-f===0)return["x"];f=["wa",a-h,b-h,a+h,b+h,a+h*d,b+h*i,a+h*j,b+h*k];e.open&&!c&&f.push("e","M",a,b);f.push("at",a-c,b-c,a+c,b+c,a+c*j,b+c*k,a+c*d,b+c*i,"x","e");f.isArc=!0;return f},circle:function(a,b,c,d,e){e&&(c=d=2*e.r);e&&e.isCircle&&(a-=c/2,b-=d/2);return["wa",a,b,a+c,b+d,a+c,b+d/2,a+c,b+d/2,"e"]},rect:function(a,b,c,d,e){return ta.prototype.symbols[!r(e)||!e.r?"square":"callout"].call(0,a,b,c,d,e)}}};R.VMLRenderer=X=function(){this.init.apply(this,
arguments)};X.prototype=w(ta.prototype,ga);Za=X}ta.prototype.measureSpanWidth=function(a,b){var c=y.createElement("span"),d;d=y.createTextNode(a);c.appendChild(d);D(c,b);this.box.appendChild(c);d=c.offsetWidth;Pa(c);return d};var Lb;if(fa)R.CanVGRenderer=X=function(){xa="http://www.w3.org/1999/xhtml"},X.prototype.symbols={},Lb=function(){function a(){var a=b.length,d;for(d=0;d<a;d++)b[d]();b=[]}var b=[];return{push:function(c,d){b.length===0&&Qb(d,a);b.push(c)}}}(),Za=X;Sa.prototype={addLabel:function(){var a=
this.axis,b=a.options,c=a.chart,d=a.horiz,e=a.categories,f=a.names,g=this.pos,h=b.labels,i=a.tickPositions,d=d&&e&&!h.step&&!h.staggerLines&&!h.rotation&&c.plotWidth/i.length||!d&&(c.margin[3]||c.chartWidth*0.33),j=g===i[0],k=g===i[i.length-1],l,f=e?m(e[g],f[g],g):g,e=this.label,o=i.info;a.isDatetimeAxis&&o&&(l=b.dateTimeLabelFormats[o.higherRanks[g]||o.unitName]);this.isFirst=j;this.isLast=k;b=a.labelFormatter.call({axis:a,chart:c,isFirst:j,isLast:k,dateTimeLabelFormat:l,value:a.isLog?da(ia(f)):
f});g=d&&{width:v(1,u(d-2*(h.padding||10)))+"px"};g=q(g,h.style);if(r(e))e&&e.attr({text:b}).css(g);else{l={align:a.labelAlign};if(ha(h.rotation))l.rotation=h.rotation;if(d&&h.ellipsis)l._clipHeight=a.len/i.length;this.label=r(b)&&h.enabled?c.renderer.text(b,0,0,h.useHTML).attr(l).css(g).add(a.labelGroup):null}},getLabelSize:function(){var a=this.label,b=this.axis;return a?a.getBBox()[b.horiz?"height":"width"]:0},getLabelSides:function(){var a=this.label.getBBox(),b=this.axis,c=b.horiz,d=b.options.labels,
a=c?a.width:a.height,b=c?d.x-a*{left:0,center:0.5,right:1}[b.labelAlign]:0;return[b,c?a+b:a]},handleOverflow:function(a,b){var c=!0,d=this.axis,e=this.isFirst,f=this.isLast,g=d.horiz?b.x:b.y,h=d.reversed,i=d.tickPositions,j=this.getLabelSides(),k=j[0],j=j[1],l,o,n,s=this.label.line||0;l=d.labelEdge;o=d.justifyLabels&&(e||f);l[s]===t||g+k>l[s]?l[s]=g+j:o||(c=!1);if(o){l=(o=d.justifyToPlot)?d.pos:0;o=o?l+d.len:d.chart.chartWidth;do a+=e?1:-1,n=d.ticks[i[a]];while(i[a]&&(!n||n.label.line!==s));d=n&&
n.label.xy&&n.label.xy.x+n.getLabelSides()[e?0:1];e&&!h||f&&h?g+k<l&&(g=l-k,n&&g+j>d&&(c=!1)):g+j>o&&(g=o-j,n&&g+k<d&&(c=!1));b.x=g}return c},getPosition:function(a,b,c,d){var e=this.axis,f=e.chart,g=d&&f.oldChartHeight||f.chartHeight;return{x:a?e.translate(b+c,null,null,d)+e.transB:e.left+e.offset+(e.opposite?(d&&f.oldChartWidth||f.chartWidth)-e.right-e.left:0),y:a?g-e.bottom+e.offset-(e.opposite?e.height:0):g-e.translate(b+c,null,null,d)-e.transB}},getLabelPosition:function(a,b,c,d,e,f,g,h){var i=
this.axis,j=i.transA,k=i.reversed,l=i.staggerLines,o=i.chart.renderer.fontMetrics(e.style.fontSize).b,n=e.rotation,a=a+e.x-(f&&d?f*j*(k?-1:1):0),b=b+e.y-(f&&!d?f*j*(k?1:-1):0);n&&i.side===2&&(b-=o-o*Z(n*Ca));!r(e.y)&&!n&&(b+=o-c.getBBox().height/2);if(l)c.line=g/(h||1)%l,b+=c.line*(i.labelOffset/l);return{x:a,y:b}},getMarkPath:function(a,b,c,d,e,f){return f.crispLine(["M",a,b,"L",a+(e?0:-c),b+(e?c:0)],d)},render:function(a,b,c){var d=this.axis,e=d.options,f=d.chart.renderer,g=d.horiz,h=this.type,
i=this.label,j=this.pos,k=e.labels,l=this.gridLine,o=h?h+"Grid":"grid",n=h?h+"Tick":"tick",s=e[o+"LineWidth"],p=e[o+"LineColor"],J=e[o+"LineDashStyle"],Q=e[n+"Length"],o=e[n+"Width"]||0,x=e[n+"Color"],r=e[n+"Position"],n=this.mark,v=k.step,q=!0,u=d.tickmarkOffset,w=this.getPosition(g,j,u,b),y=w.x,w=w.y,B=g&&y===d.pos+d.len||!g&&w===d.pos?-1:1;this.isActive=!0;if(s){j=d.getPlotLinePath(j+u,s*B,b,!0);if(l===t){l={stroke:p,"stroke-width":s};if(J)l.dashstyle=J;if(!h)l.zIndex=1;if(b)l.opacity=0;this.gridLine=
l=s?f.path(j).attr(l).add(d.gridGroup):null}if(!b&&l&&j)l[this.isNew?"attr":"animate"]({d:j,opacity:c})}if(o&&Q)r==="inside"&&(Q=-Q),d.opposite&&(Q=-Q),h=this.getMarkPath(y,w,Q,o*B,g,f),n?n.animate({d:h,opacity:c}):this.mark=f.path(h).attr({stroke:x,"stroke-width":o,opacity:c}).add(d.axisGroup);if(i&&!isNaN(y))i.xy=w=this.getLabelPosition(y,w,i,g,k,u,a,v),this.isFirst&&!this.isLast&&!m(e.showFirstLabel,1)||this.isLast&&!this.isFirst&&!m(e.showLastLabel,1)?q=!1:!d.isRadial&&!k.step&&!k.rotation&&!b&&
c!==0&&(q=this.handleOverflow(a,w)),v&&a%v&&(q=!1),q&&!isNaN(w.y)?(w.opacity=c,i[this.isNew?"attr":"animate"](w),this.isNew=!1):i.attr("y",-9999)},destroy:function(){Oa(this,this.axis)}};R.PlotLineOrBand=function(a,b){this.axis=a;if(b)this.options=b,this.id=b.id};R.PlotLineOrBand.prototype={render:function(){var a=this,b=a.axis,c=b.horiz,d=(b.pointRange||0)/2,e=a.options,f=e.label,g=a.label,h=e.width,i=e.to,j=e.from,k=r(j)&&r(i),l=e.value,o=e.dashStyle,n=a.svgElem,s=[],p,J=e.color,Q=e.zIndex,x=e.events,
q={},t=b.chart.renderer;b.isLog&&(j=za(j),i=za(i),l=za(l));if(h){if(s=b.getPlotLinePath(l,h),q={stroke:J,"stroke-width":h},o)q.dashstyle=o}else if(k){j=v(j,b.min-d);i=C(i,b.max+d);s=b.getPlotBandPath(j,i,e);if(J)q.fill=J;if(e.borderWidth)q.stroke=e.borderColor,q["stroke-width"]=e.borderWidth}else return;if(r(Q))q.zIndex=Q;if(n)if(s)n.animate({d:s},null,n.onGetPath);else{if(n.hide(),n.onGetPath=function(){n.show()},g)a.label=g=g.destroy()}else if(s&&s.length&&(a.svgElem=n=t.path(s).attr(q).add(),x))for(p in d=
function(b){n.on(b,function(c){x[b].apply(a,[c])})},x)d(p);if(f&&r(f.text)&&s&&s.length&&b.width>0&&b.height>0){f=w({align:c&&k&&"center",x:c?!k&&4:10,verticalAlign:!c&&k&&"middle",y:c?k?16:10:k?6:-4,rotation:c&&!k&&90},f);if(!g){q={align:f.textAlign||f.align,rotation:f.rotation};if(r(Q))q.zIndex=Q;a.label=g=t.text(f.text,0,0,f.useHTML).attr(q).css(f.style).add()}b=[s[1],s[4],m(s[6],s[1])];s=[s[2],s[5],m(s[7],s[2])];c=Na(b);k=Na(s);g.align(f,!1,{x:c,y:k,width:Ba(b)-c,height:Ba(s)-k});g.show()}else g&&
g.hide();return a},destroy:function(){ja(this.axis.plotLinesAndBands,this);delete this.axis;Oa(this)}};la.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,gridLineColor:"#C0C0C0",labels:L,lineColor:"#C0D0E0",lineWidth:1,minPadding:0.01,maxPadding:0.01,minorGridLineColor:"#E0E0E0",minorGridLineWidth:1,minorTickColor:"#A0A0A0",minorTickLength:2,minorTickPosition:"outside",
startOfWeek:1,startOnTick:!1,tickColor:"#C0D0E0",tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",tickWidth:1,title:{align:"middle",style:{color:"#707070"}},type:"linear"},defaultYAxisOptions:{endOnTick:!0,gridLineWidth:1,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8,y:3},lineWidth:0,maxPadding:0.05,minPadding:0.05,startOnTick:!0,tickWidth:0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,formatter:function(){return Ga(this.total,-1)},style:L.style}},
defaultLeftAxisOptions:{labels:{x:-15,y:null},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15,y:null},title:{rotation:90}},defaultBottomAxisOptions:{labels:{x:0,y:20},title:{rotation:0}},defaultTopAxisOptions:{labels:{x:0,y:-15},title:{rotation:0}},init:function(a,b){var c=b.isX;this.horiz=a.inverted?!c:c;this.coll=(this.isXAxis=c)?"xAxis":"yAxis";this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(b);var d=this.options,e=d.type;
this.labelFormatter=d.labels.formatter||this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.chart=a;this.reversed=d.reversed;this.zoomEnabled=d.zoomEnabled!==!1;this.categories=d.categories||e==="category";this.names=[];this.isLog=e==="logarithmic";this.isDatetimeAxis=e==="datetime";this.isLinked=r(d.linkedTo);this.tickmarkOffset=this.categories&&d.tickmarkPlacement==="between"?0.5:0;this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=[];this.alternateBands=
{};this.len=0;this.minRange=this.userMinRange=d.minRange||d.maxZoom;this.range=d.range;this.offset=d.offset||0;this.stacks={};this.oldStacks={};this.min=this.max=null;this.crosshair=m(d.crosshair,qa(a.options.tooltip.crosshairs)[c?0:1],!1);var f,d=this.options.events;Da(this,a.axes)===-1&&(c&&!this.isColorAxis?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];if(a.inverted&&c&&this.reversed===t)this.reversed=!0;this.removePlotLine=this.removePlotBand=
this.removePlotBandOrLine;for(f in d)K(this,f,d[f]);if(this.isLog)this.val2lin=za,this.lin2val=ia},setOptions:function(a){this.options=w(this.defaultOptions,this.isXAxis?{}:this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],w(F[this.coll],a))},defaultLabelFormatter:function(){var a=this.axis,b=this.value,c=a.categories,d=this.dateTimeLabelFormat,e=F.lang.numericSymbols,f=e&&e.length,g,h=a.options.labels.format,
a=a.isLog?b:a.tickInterval;if(h)g=Ia(h,this);else if(c)g=b;else if(d)g=cb(d,b);else if(f&&a>=1E3)for(;f--&&g===t;)c=Math.pow(1E3,f+1),a>=c&&e[f]!==null&&(g=Ga(b/c,-1)+e[f]);g===t&&(g=b>=1E4?Ga(b,0):Ga(b,-1,t,""));return g},getSeriesExtremes:function(){var a=this,b=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=null;a.buildStacks&&a.buildStacks();p(a.series,function(c){if(c.visible||!b.options.chart.ignoreHiddenSeries){var d;d=c.options.threshold;var e;a.hasVisibleSeries=!0;a.isLog&&d<=0&&(d=null);
if(a.isXAxis){if(d=c.xData,d.length)a.dataMin=C(m(a.dataMin,d[0]),Na(d)),a.dataMax=v(m(a.dataMax,d[0]),Ba(d))}else{c.getExtremes();e=c.dataMax;c=c.dataMin;if(r(c)&&r(e))a.dataMin=C(m(a.dataMin,c),c),a.dataMax=v(m(a.dataMax,e),e);if(r(d))if(a.dataMin>=d)a.dataMin=d,a.ignoreMinPadding=!0;else if(a.dataMax<d)a.dataMax=d,a.ignoreMaxPadding=!0}}})},translate:function(a,b,c,d,e,f){var g=1,h=0,i=d?this.oldTransA:this.transA,d=d?this.oldMin:this.min,j=this.minPixelPadding,e=(this.options.ordinal||this.isLog&&
e)&&this.lin2val;if(!i)i=this.transA;if(c)g*=-1,h=this.len;this.reversed&&(g*=-1,h-=g*(this.sector||this.len));b?(a=a*g+h,a-=j,a=a/i+d,e&&(a=this.lin2val(a))):(e&&(a=this.val2lin(a)),f==="between"&&(f=0.5),a=g*(a-d)*i+h+g*j+(ha(f)?i*f*this.pointRange:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,d,e){var f=this.chart,g=this.left,
h=this.top,i,j,k=c&&f.oldChartHeight||f.chartHeight,l=c&&f.oldChartWidth||f.chartWidth,o;i=this.transB;e=m(e,this.translate(a,null,null,c));a=c=u(e+i);i=j=u(k-e-i);if(isNaN(e))o=!0;else if(this.horiz){if(i=h,j=k-this.bottom,a<g||a>g+this.width)o=!0}else if(a=g,c=l-this.right,i<h||i>h+this.height)o=!0;return o&&!d?null:f.renderer.crispLine(["M",a,i,"L",c,j],b||1)},getLinearTickPositions:function(a,b,c){var d,e=da(S(b/a)*a),f=da(Ka(c/a)*a),g=[];if(b===c&&ha(b))return[b];for(b=e;b<=f;){g.push(b);b=da(b+
a);if(b===d)break;d=b}return g},getMinorTickPositions:function(){var a=this.options,b=this.tickPositions,c=this.minorTickInterval,d=[],e;if(this.isLog){e=b.length;for(a=1;a<e;a++)d=d.concat(this.getLogTickPositions(c,b[a-1],b[a],!0))}else if(this.isDatetimeAxis&&a.minorTickInterval==="auto")d=d.concat(this.getTimeTicks(this.normalizeTimeTickInterval(c),this.min,this.max,a.startOfWeek)),d[0]<this.min&&d.shift();else for(b=this.min+(b[0]-this.min)%c;b<=this.max;b+=c)d.push(b);return d},adjustForMinRange:function(){var a=
this.options,b=this.min,c=this.max,d,e=this.dataMax-this.dataMin>=this.minRange,f,g,h,i,j;if(this.isXAxis&&this.minRange===t&&!this.isLog)r(a.min)||r(a.max)?this.minRange=null:(p(this.series,function(a){i=a.xData;for(g=j=a.xIncrement?1:i.length-1;g>0;g--)if(h=i[g]-i[g-1],f===t||h<f)f=h}),this.minRange=C(f*5,this.dataMax-this.dataMin));if(c-b<this.minRange){var k=this.minRange;d=(k-c+b)/2;d=[b-d,m(a.min,b-d)];if(e)d[2]=this.dataMin;b=Ba(d);c=[b+k,m(a.max,b+k)];if(e)c[2]=this.dataMax;c=Na(c);c-b<k&&
(d[0]=c-k,d[1]=m(a.min,c-k),b=Ba(d))}this.min=b;this.max=c},setAxisTranslation:function(a){var b=this,c=b.max-b.min,d=b.axisPointRange||0,e,f=0,g=0,h=b.linkedParent,i=!!b.categories,j=b.transA;if(b.isXAxis||i||d)h?(f=h.minPointOffset,g=h.pointRangePadding):p(b.series,function(a){var h=i?1:b.isXAxis?a.pointRange:b.axisPointRange||0,j=a.options.pointPlacement,n=a.closestPointRange;h>c&&(h=0);d=v(d,h);f=v(f,Fa(j)?0:h/2);g=v(g,j==="on"?0:h);!a.noSharedTooltip&&r(n)&&(e=r(e)?C(e,n):n)}),h=b.ordinalSlope&&
e?b.ordinalSlope/e:1,b.minPointOffset=f*=h,b.pointRangePadding=g*=h,b.pointRange=C(d,c),b.closestPointRange=e;if(a)b.oldTransA=j;b.translationSlope=b.transA=j=b.len/(c+g||1);b.transB=b.horiz?b.left:b.bottom;b.minPixelPadding=j*f},setTickPositions:function(a){var b=this,c=b.chart,d=b.options,e=b.isLog,f=b.isDatetimeAxis,g=b.isXAxis,h=b.isLinked,i=b.options.tickPositioner,j=d.maxPadding,k=d.minPadding,l=d.tickInterval,o=d.minTickInterval,n=d.tickPixelInterval,s,$=b.categories;h?(b.linkedParent=c[b.coll][d.linkedTo],
c=b.linkedParent.getExtremes(),b.min=m(c.min,c.dataMin),b.max=m(c.max,c.dataMax),d.type!==b.linkedParent.options.type&&ra(11,1)):(b.min=m(b.userMin,d.min,b.dataMin),b.max=m(b.userMax,d.max,b.dataMax));if(e)!a&&C(b.min,m(b.dataMin,b.min))<=0&&ra(10,1),b.min=da(za(b.min)),b.max=da(za(b.max));if(b.range&&r(b.max))b.userMin=b.min=v(b.min,b.max-b.range),b.userMax=b.max,b.range=null;b.beforePadding&&b.beforePadding();b.adjustForMinRange();if(!$&&!b.axisPointRange&&!b.usePercentage&&!h&&r(b.min)&&r(b.max)&&
(c=b.max-b.min)){if(!r(d.min)&&!r(b.userMin)&&k&&(b.dataMin<0||!b.ignoreMinPadding))b.min-=c*k;if(!r(d.max)&&!r(b.userMax)&&j&&(b.dataMax>0||!b.ignoreMaxPadding))b.max+=c*j}if(ha(d.floor))b.min=v(b.min,d.floor);if(ha(d.ceiling))b.max=C(b.max,d.ceiling);b.min===b.max||b.min===void 0||b.max===void 0?b.tickInterval=1:h&&!l&&n===b.linkedParent.options.tickPixelInterval?b.tickInterval=b.linkedParent.tickInterval:(b.tickInterval=m(l,$?1:(b.max-b.min)*n/v(b.len,n)),!r(l)&&b.len<n&&!this.isRadial&&!this.isLog&&
!$&&d.startOnTick&&d.endOnTick&&(s=!0,b.tickInterval/=4));g&&!a&&p(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();if(b.postProcessTickInterval)b.tickInterval=b.postProcessTickInterval(b.tickInterval);if(b.pointRange)b.tickInterval=v(b.pointRange,b.tickInterval);if(!l&&b.tickInterval<o)b.tickInterval=o;if(!f&&!e&&!l)b.tickInterval=nb(b.tickInterval,null,mb(b.tickInterval),d);b.minorTickInterval=
d.minorTickInterval==="auto"&&b.tickInterval?b.tickInterval/5:d.minorTickInterval;b.tickPositions=a=d.tickPositions?[].concat(d.tickPositions):i&&i.apply(b,[b.min,b.max]);if(!a)!b.ordinalPositions&&(b.max-b.min)/b.tickInterval>v(2*b.len,200)&&ra(19,!0),a=f?b.getTimeTicks(b.normalizeTimeTickInterval(b.tickInterval,d.units),b.min,b.max,d.startOfWeek,b.ordinalPositions,b.closestPointRange,!0):e?b.getLogTickPositions(b.tickInterval,b.min,b.max):b.getLinearTickPositions(b.tickInterval,b.min,b.max),s&&
a.splice(1,a.length-2),b.tickPositions=a;if(!h)e=a[0],f=a[a.length-1],h=b.minPointOffset||0,d.startOnTick?b.min=e:b.min-h>e&&a.shift(),d.endOnTick?b.max=f:b.max+h<f&&a.pop(),a.length===1&&(d=O(b.max)>1E13?1:0.001,b.min-=d,b.max+=d)},setMaxTicks:function(){var a=this.chart,b=a.maxTicks||{},c=this.tickPositions,d=this._maxTicksKey=[this.coll,this.pos,this.len].join("-");if(!this.isLinked&&!this.isDatetimeAxis&&c&&c.length>(b[d]||0)&&this.options.alignTicks!==!1)b[d]=c.length;a.maxTicks=b},adjustTickAmount:function(){var a=
this._maxTicksKey,b=this.tickPositions,c=this.chart.maxTicks;if(c&&c[a]&&!this.isDatetimeAxis&&!this.categories&&!this.isLinked&&this.options.alignTicks!==!1&&this.min!==t){var d=this.tickAmount,e=b.length;this.tickAmount=a=c[a];if(e<a){for(;b.length<a;)b.push(da(b[b.length-1]+this.tickInterval));this.transA*=(e-1)/(a-1);this.max=b[b.length-1]}if(r(d)&&a!==d)this.isDirty=!0}},setScale:function(){var a=this.stacks,b,c,d,e;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();
e=this.len!==this.oldAxisLength;p(this.series,function(a){if(a.isDirtyData||a.isDirty||a.xAxis.isDirty)d=!0});if(e||d||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax){if(!this.isXAxis)for(b in a)for(c in a[b])a[b][c].total=null,a[b][c].cum=0;this.forceRedraw=!1;this.getSeriesExtremes();this.setTickPositions();this.oldUserMin=this.userMin;this.oldUserMax=this.userMax;if(!this.isDirty)this.isDirty=e||this.min!==this.oldMin||this.max!==this.oldMax}else if(!this.isXAxis){if(this.oldStacks)a=
this.stacks=this.oldStacks;for(b in a)for(c in a[b])a[b][c].cum=a[b][c].total}this.setMaxTicks()},setExtremes:function(a,b,c,d,e){var f=this,g=f.chart,c=m(c,!0),e=q(e,{min:a,max:b});E(f,"setExtremes",e,function(){f.userMin=a;f.userMax=b;f.eventArgs=e;f.isDirtyExtremes=!0;c&&g.redraw(d)})},zoom:function(a,b){var c=this.dataMin,d=this.dataMax,e=this.options;this.allowZoomOutside||(r(c)&&a<=C(c,m(e.min,c))&&(a=t),r(d)&&b>=v(d,m(e.max,d))&&(b=t));this.displayBtn=a!==t||b!==t;this.setExtremes(a,b,!1,t,
{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsetLeft||0,d=this.horiz,e=m(b.width,a.plotWidth-c+(b.offsetRight||0)),f=m(b.height,a.plotHeight),g=m(b.top,a.plotTop),b=m(b.left,a.plotLeft+c),c=/%$/;c.test(f)&&(f=parseInt(f,10)/100*a.plotHeight);c.test(g)&&(g=parseInt(g,10)/100*a.plotHeight+a.plotTop);this.left=b;this.top=g;this.width=e;this.height=f;this.bottom=a.chartHeight-f-g;this.right=a.chartWidth-e-b;this.len=v(d?e:f,0);this.pos=d?b:g},getExtremes:function(){var a=
this.isLog;return{min:a?da(ia(this.min)):this.min,max:a?da(ia(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,c=b?ia(this.min):this.min,b=b?ia(this.max):this.max;c>a||a===null?a=c:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(m(a,0)-this.side*90+720)%360;return a>15&&a<165?"right":a>195&&a<345?"left":"center"},getOffset:function(){var a=this,b=a.chart,c=b.renderer,d=a.options,
e=a.tickPositions,f=a.ticks,g=a.horiz,h=a.side,i=b.inverted?[1,0,3,2][h]:h,j,k=0,l,o=0,n=d.title,s=d.labels,$=0,J=b.axisOffset,Q=b.clipOffset,x=[-1,1,1,-1][h],q,u=1,w=m(s.maxStaggerLines,5),y,A,z,B,na=h===2?c.fontMetrics(s.style.fontSize).b:0;a.hasData=j=a.hasVisibleSeries||r(a.min)&&r(a.max)&&!!e;a.showAxis=b=j||m(d.showEmpty,!0);a.staggerLines=a.horiz&&s.staggerLines;if(!a.axisGroup)a.gridGroup=c.g("grid").attr({zIndex:d.gridZIndex||1}).add(),a.axisGroup=c.g("axis").attr({zIndex:d.zIndex||2}).add(),
a.labelGroup=c.g("axis-labels").attr({zIndex:s.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels").add();if(j||a.isLinked){a.labelAlign=m(s.align||a.autoLabelAlign(s.rotation));p(e,function(b){f[b]?f[b].addLabel():f[b]=new Sa(a,b)});if(a.horiz&&!a.staggerLines&&w&&!s.rotation){for(q=a.reversed?[].concat(e).reverse():e;u<w;){j=[];y=!1;for(s=0;s<q.length;s++)A=q[s],z=(z=f[A].label&&f[A].label.getBBox())?z.width:0,B=s%u,z&&(A=a.translate(A),j[B]!==t&&A<j[B]&&(y=!0),j[B]=A+z);if(y)u++;
else break}if(u>1)a.staggerLines=u}p(e,function(b){if(h===0||h===2||{1:"left",3:"right"}[h]===a.labelAlign)$=v(f[b].getLabelSize(),$)});if(a.staggerLines)$*=a.staggerLines,a.labelOffset=$}else for(q in f)f[q].destroy(),delete f[q];if(n&&n.text&&n.enabled!==!1){if(!a.axisTitle)a.axisTitle=c.text(n.text,0,0,n.useHTML).attr({zIndex:7,rotation:n.rotation||0,align:n.textAlign||{low:"left",middle:"center",high:"right"}[n.align]}).addClass("highcharts-"+this.coll.toLowerCase()+"-title").css(n.style).add(a.axisGroup),
a.axisTitle.isNew=!0;if(b)k=a.axisTitle.getBBox()[g?"height":"width"],o=m(n.margin,g?5:10),l=n.offset;a.axisTitle[b?"show":"hide"]()}a.offset=x*m(d.offset,J[h]);a.axisTitleMargin=m(l,$+o+($&&x*d.labels[g?"y":"x"]-na));J[h]=v(J[h],a.axisTitleMargin+k+x*a.offset);Q[i]=v(Q[i],S(d.lineWidth/2)*2)},getLinePath:function(a){var b=this.chart,c=this.opposite,d=this.offset,e=this.horiz,f=this.left+(c?this.width:0)+d,d=b.chartHeight-this.bottom-(c?this.height:0)+d;c&&(a*=-1);return b.renderer.crispLine(["M",
e?this.left:f,e?d:this.top,"L",e?b.chartWidth-this.right:f,e?d:b.chartHeight-this.bottom],a)},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,d=this.len,e=this.options.title,f=a?b:c,g=this.opposite,h=this.offset,i=A(e.style.fontSize||12),d={low:f+(a?0:d),middle:f+d/2,high:f+(a?d:0)}[e.align],b=(a?c+this.height:b)+(a?1:-1)*(g?-1:1)*this.axisTitleMargin+(this.side===2?i:0);return{x:a?d:b+(g?this.width:0)+h+(e.x||0),y:a?b-(g?this.height:0)+h:d+(e.y||0)}},render:function(){var a=this,
b=a.horiz,c=a.reversed,d=a.chart,e=d.renderer,f=a.options,g=a.isLog,h=a.isLinked,i=a.tickPositions,j,k=a.axisTitle,l=a.ticks,o=a.minorTicks,n=a.alternateBands,s=f.stackLabels,m=f.alternateGridColor,J=a.tickmarkOffset,q=f.lineWidth,x=d.hasRendered&&r(a.oldMin)&&!isNaN(a.oldMin),v=a.hasData,u=a.showAxis,w,y=f.labels.overflow,A=a.justifyLabels=b&&y!==!1,z;a.labelEdge.length=0;a.justifyToPlot=y==="justify";p([l,o,n],function(a){for(var b in a)a[b].isActive=!1});if(v||h)if(a.minorTickInterval&&!a.categories&&
p(a.getMinorTickPositions(),function(b){o[b]||(o[b]=new Sa(a,b,"minor"));x&&o[b].isNew&&o[b].render(null,!0);o[b].render(null,!1,1)}),i.length&&(j=i.slice(),(b&&c||!b&&!c)&&j.reverse(),A&&(j=j.slice(1).concat([j[0]])),p(j,function(b,c){A&&(c=c===j.length-1?0:c+1);if(!h||b>=a.min&&b<=a.max)l[b]||(l[b]=new Sa(a,b)),x&&l[b].isNew&&l[b].render(c,!0,0.1),l[b].render(c,!1,1)}),J&&a.min===0&&(l[-1]||(l[-1]=new Sa(a,-1,null,!0)),l[-1].render(-1))),m&&p(i,function(b,c){if(c%2===0&&b<a.max)n[b]||(n[b]=new R.PlotLineOrBand(a)),
w=b+J,z=i[c+1]!==t?i[c+1]+J:a.max,n[b].options={from:g?ia(w):w,to:g?ia(z):z,color:m},n[b].render(),n[b].isActive=!0}),!a._addedPlotLB)p((f.plotLines||[]).concat(f.plotBands||[]),function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=!0;p([l,o,n],function(a){var b,c,e=[],f=va?va.duration||500:0,g=function(){for(c=e.length;c--;)a[e[c]]&&!a[e[c]].isActive&&(a[e[c]].destroy(),delete a[e[c]])};for(b in a)if(!a[b].isActive)a[b].render(b,!1,0),a[b].isActive=!1,e.push(b);a===n||!d.hasRendered||!f?g():f&&setTimeout(g,
f)});if(q)b=a.getLinePath(q),a.axisLine?a.axisLine.animate({d:b}):a.axisLine=e.path(b).attr({stroke:f.lineColor,"stroke-width":q,zIndex:7}).add(a.axisGroup),a.axisLine[u?"show":"hide"]();if(k&&u)k[k.isNew?"attr":"animate"](a.getTitlePosition()),k.isNew=!1;s&&s.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){var a=this.chart.pointer;a&&a.reset(!0);this.render();p(this.plotLinesAndBands,function(a){a.render()});p(this.series,function(a){a.isDirty=!0})},destroy:function(a){var b=this,
c=b.stacks,d,e=b.plotLinesAndBands;a||W(b);for(d in c)Oa(c[d]),c[d]=null;p([b.ticks,b.minorTicks,b.alternateBands],function(a){Oa(a)});for(a=e.length;a--;)e[a].destroy();p("stackTotalGroup,axisLine,axisTitle,axisGroup,cross,gridGroup,labelGroup".split(","),function(a){b[a]&&(b[a]=b[a].destroy())});this.cross&&this.cross.destroy()},drawCrosshair:function(a,b){if(this.crosshair)if((r(b)||!m(this.crosshair.snap,!0))===!1)this.hideCrosshair();else{var c,d=this.crosshair,e=d.animation;m(d.snap,!0)?r(b)&&
(c=this.chart.inverted!=this.horiz?b.plotX:this.len-b.plotY):c=this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos;c=this.isRadial?this.getPlotLinePath(this.isXAxis?b.x:m(b.stackY,b.y)):this.getPlotLinePath(null,null,null,null,c);if(c===null)this.hideCrosshair();else if(this.cross)this.cross.attr({visibility:"visible"})[e?"animate":"attr"]({d:c},e);else{e={"stroke-width":d.width||1,stroke:d.color||"#C0C0C0",zIndex:d.zIndex||2};if(d.dashStyle)e.dashstyle=d.dashStyle;this.cross=this.chart.renderer.path(c).attr(e).add()}}},
hideCrosshair:function(){this.cross&&this.cross.hide()}};q(la.prototype,{getPlotBandPath:function(a,b){var c=this.getPlotLinePath(b),d=this.getPlotLinePath(a);d&&c?d.push(c[4],c[5],c[1],c[2]):d=null;return d},addPlotBand:function(a){this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(a,b){var c=(new R.PlotLineOrBand(this,a)).render(),d=this.userOptions;c&&(b&&(d[b]=d[b]||[],d[b].push(a)),this.plotLinesAndBands.push(c));return c},
removePlotBandOrLine:function(a){for(var b=this.plotLinesAndBands,c=this.options,d=this.userOptions,e=b.length;e--;)b[e].id===a&&b[e].destroy();p([c.plotLines||[],d.plotLines||[],c.plotBands||[],d.plotBands||[]],function(b){for(e=b.length;e--;)b[e].id===a&&ja(b,b[e])})}});la.prototype.getTimeTicks=function(a,b,c,d){var e=[],f={},g=F.global.useUTC,h,i=new Date(b-Ra),j=a.unitRange,k=a.count;if(r(b)){j>=z.second&&(i.setMilliseconds(0),i.setSeconds(j>=z.minute?0:k*S(i.getSeconds()/k)));if(j>=z.minute)i[Db](j>=
z.hour?0:k*S(i[pb]()/k));if(j>=z.hour)i[Eb](j>=z.day?0:k*S(i[qb]()/k));if(j>=z.day)i[sb](j>=z.month?1:k*S(i[Xa]()/k));j>=z.month&&(i[Fb](j>=z.year?0:k*S(i[fb]()/k)),h=i[gb]());j>=z.year&&(h-=h%k,i[Gb](h));if(j===z.week)i[sb](i[Xa]()-i[rb]()+m(d,1));b=1;Ra&&(i=new Date(i.getTime()+Ra));h=i[gb]();for(var d=i.getTime(),l=i[fb](),o=i[Xa](),n=g?Ra:(864E5+i.getTimezoneOffset()*6E4)%864E5;d<c;)e.push(d),j===z.year?d=eb(h+b*k,0):j===z.month?d=eb(h,l+b*k):!g&&(j===z.day||j===z.week)?d=eb(h,l,o+b*k*(j===z.day?
1:7)):d+=j*k,b++;e.push(d);p(vb(e,function(a){return j<=z.hour&&a%z.day===n}),function(a){f[a]="day"})}e.info=q(a,{higherRanks:f,totalRange:j*k});return e};la.prototype.normalizeTimeTickInterval=function(a,b){var c=b||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]],d=c[c.length-1],e=z[d[0]],f=d[1],g;for(g=0;g<c.length;g++)if(d=c[g],e=z[d[0]],f=d[1],c[g+
1]&&a<=(e*f[f.length-1]+z[c[g+1][0]])/2)break;e===z.year&&a<5*e&&(f=[1,2,5]);c=nb(a/e,f,d[0]==="year"?v(mb(a/e),1):1);return{unitRange:e,count:c,unitName:d[0]}};la.prototype.getLogTickPositions=function(a,b,c,d){var e=this.options,f=this.len,g=[];if(!d)this._minorAutoInterval=null;if(a>=0.5)a=u(a),g=this.getLinearTickPositions(a,b,c);else if(a>=0.08)for(var f=S(b),h,i,j,k,l,e=a>0.3?[1,2,4]:a>0.15?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];f<c+1&&!l;f++){i=e.length;for(h=0;h<i&&!l;h++)j=za(ia(f)*e[h]),j>b&&(!d||
k<=c)&&g.push(k),k>c&&(l=!0),k=j}else if(b=ia(b),c=ia(c),a=e[d?"minorTickInterval":"tickInterval"],a=m(a==="auto"?null:a,this._minorAutoInterval,(c-b)*(e.tickPixelInterval/(d?5:1))/((d?f/this.tickPositions.length:f)||1)),a=nb(a,null,mb(a)),g=Ua(this.getLinearTickPositions(a,b,c),za),!d)this._minorAutoInterval=a/5;if(!d)this.tickInterval=a;return g};var Mb=R.Tooltip=function(){this.init.apply(this,arguments)};Mb.prototype={init:function(a,b){var c=b.borderWidth,d=b.style,e=A(d.padding);this.chart=
a;this.options=b;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.label=a.renderer.label("",0,0,b.shape||"callout",null,null,b.useHTML,null,"tooltip").attr({padding:e,fill:b.backgroundColor,"stroke-width":c,r:b.borderRadius,zIndex:8}).css(d).css({padding:0}).add().attr({y:-9999});fa||this.label.shadow(b.shadow);this.shared=b.shared},destroy:function(){if(this.label)this.label=this.label.destroy();clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,b,c,d){var e=
this,f=e.now,g=e.options.animation!==!1&&!e.isHidden,h=e.followPointer||e.len>1;q(f,{x:g?(2*f.x+a)/3:a,y:g?(f.y+b)/2:b,anchorX:h?t:g?(2*f.anchorX+c)/3:c,anchorY:h?t:g?(f.anchorY+d)/2:d});e.label.attr(f);if(g&&(O(a-f.x)>1||O(b-f.y)>1))clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){e&&e.move(a,b,c,d)},32)},hide:function(){var a=this,b;clearTimeout(this.hideTimer);if(!this.isHidden)b=this.chart.hoverPoints,this.hideTimer=setTimeout(function(){a.label.fadeOut();a.isHidden=
!0},m(this.options.hideDelay,500)),b&&p(b,function(a){a.setState()}),this.chart.hoverPoints=null},getAnchor:function(a,b){var c,d=this.chart,e=d.inverted,f=d.plotTop,g=0,h=0,i,a=qa(a);c=a[0].tooltipPos;this.followPointer&&b&&(b.chartX===t&&(b=d.pointer.normalize(b)),c=[b.chartX-d.plotLeft,b.chartY-f]);c||(p(a,function(a){i=a.series.yAxis;g+=a.plotX;h+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!e&&i?i.top-f:0)}),g/=a.length,h/=a.length,c=[e?d.plotWidth-h:g,this.shared&&!e&&a.length>1&&b?b.chartY-
f:e?d.plotHeight-g:h]);return Ua(c,u)},getPosition:function(a,b,c){var d=this.chart,e=this.distance,f={},g,h=["y",d.chartHeight,b,c.plotY+d.plotTop],i=["x",d.chartWidth,a,c.plotX+d.plotLeft],j=c.ttBelow||d.inverted&&!c.negative||!d.inverted&&c.negative,k=function(a,b,c,d){var g=c<d-e,b=d+e+c<b,c=d-e-c;d+=e;if(j&&b)f[a]=d;else if(!j&&g)f[a]=c;else if(g)f[a]=c;else if(b)f[a]=d;else return!1},l=function(a,b,c,d){if(d<e||d>b-e)return!1;else f[a]=d<c/2?1:d>b-c/2?b-c-2:d-c/2},o=function(a){var b=h;h=i;
i=b;g=a},n=function(){k.apply(0,h)!==!1?l.apply(0,i)===!1&&!g&&(o(!0),n()):g?f.x=f.y=0:(o(!0),n())};(d.inverted||this.len>1)&&o();n();return f},defaultFormatter:function(a){var b=this.points||qa(this),c=b[0].series,d;d=[a.tooltipHeaderFormatter(b[0])];p(b,function(a){c=a.series;d.push(c.tooltipFormatter&&c.tooltipFormatter(a)||a.point.tooltipFormatter(c.tooltipOptions.pointFormat))});d.push(a.options.footerFormat||"");return d.join("")},refresh:function(a,b){var c=this.chart,d=this.label,e=this.options,
f,g,h={},i,j=[];i=e.formatter||this.defaultFormatter;var h=c.hoverPoints,k,l=this.shared;clearTimeout(this.hideTimer);this.followPointer=qa(a)[0].series.tooltipOptions.followPointer;g=this.getAnchor(a,b);f=g[0];g=g[1];l&&(!a.series||!a.series.noSharedTooltip)?(c.hoverPoints=a,h&&p(h,function(a){a.setState()}),p(a,function(a){a.setState("hover");j.push(a.getLabelConfig())}),h={x:a[0].category,y:a[0].y},h.points=j,this.len=j.length,a=a[0]):h=a.getLabelConfig();i=i.call(h,this);h=a.series;this.distance=
m(h.tooltipOptions.distance,16);i===!1?this.hide():(this.isHidden&&(bb(d),d.attr("opacity",1).show()),d.attr({text:i}),k=e.borderColor||a.color||h.color||"#606060",d.attr({stroke:k}),this.updatePosition({plotX:f,plotY:g,negative:a.negative,ttBelow:a.ttBelow}),this.isHidden=!1);E(c,"tooltipRefresh",{text:i,x:f+c.plotLeft,y:g+c.plotTop,borderColor:k})},updatePosition:function(a){var b=this.chart,c=this.label,c=(this.options.positioner||this.getPosition).call(this,c.width,c.height,a);this.move(u(c.x),
u(c.y),a.plotX+b.plotLeft,a.plotY+b.plotTop)},tooltipHeaderFormatter:function(a){var b=a.series,c=b.tooltipOptions,d=c.dateTimeLabelFormats,e=c.xDateFormat,f=b.xAxis,g=f&&f.options.type==="datetime"&&ha(a.key),c=c.headerFormat,f=f&&f.closestPointRange,h;if(g&&!e){if(f)for(h in z){if(z[h]>=f||z[h]<=z.day&&a.key%z[h]>0){e=d[h];break}}else e=d.day;e=e||d.year}g&&e&&(c=c.replace("{point.key}","{point.key:"+e+"}"));return Ia(c,{point:a,series:b})}};var oa;$a=y.documentElement.ontouchstart!==t;var Wa=R.Pointer=
function(a,b){this.init(a,b)};Wa.prototype={init:function(a,b){var c=b.chart,d=c.events,e=fa?"":c.zoomType,c=a.inverted,f;this.options=b;this.chart=a;this.zoomX=f=/x/.test(e);this.zoomY=e=/y/.test(e);this.zoomHor=f&&!c||e&&c;this.zoomVert=e&&!c||f&&c;this.hasZoom=f||e;this.runChartClick=d&&!!d.click;this.pinchDown=[];this.lastValidTouch={};if(R.Tooltip&&b.tooltip.enabled)a.tooltip=new Mb(a,b.tooltip),this.followTouchMove=b.tooltip.followTouchMove;this.setDOMEvents()},normalize:function(a,b){var c,
d,a=a||window.event,a=Sb(a);if(!a.target)a.target=a.srcElement;d=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;if(!b)this.chartPosition=b=Rb(this.chart.container);d.pageX===t?(c=v(a.x,a.clientX-b.left),d=a.y):(c=d.pageX-b.left,d=d.pageY-b.top);return q(a,{chartX:u(c),chartY:u(d)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};p(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},getIndex:function(a){var b=
this.chart;return b.inverted?b.plotHeight+b.plotTop-a.chartY:a.chartX-b.plotLeft},runPointActions:function(a){var b=this.chart,c=b.series,d=b.tooltip,e,f,g=b.hoverPoint,h=b.hoverSeries,i,j,k=b.chartWidth,l=this.getIndex(a);if(d&&this.options.tooltip.shared&&(!h||!h.noSharedTooltip)){f=[];i=c.length;for(j=0;j<i;j++)if(c[j].visible&&c[j].options.enableMouseTracking!==!1&&!c[j].noSharedTooltip&&c[j].singularTooltips!==!0&&c[j].tooltipPoints.length&&(e=c[j].tooltipPoints[l])&&e.series)e._dist=O(l-e.clientX),
k=C(k,e._dist),f.push(e);for(i=f.length;i--;)f[i]._dist>k&&f.splice(i,1);if(f.length&&f[0].clientX!==this.hoverX)d.refresh(f,a),this.hoverX=f[0].clientX}c=h&&h.tooltipOptions.followPointer;if(h&&h.tracker&&!c){if((e=h.tooltipPoints[l])&&e!==g)e.onMouseOver(a)}else d&&c&&!d.isHidden&&(h=d.getAnchor([{}],a),d.updatePosition({plotX:h[0],plotY:h[1]}));if(d&&!this._onDocumentMouseMove)this._onDocumentMouseMove=function(a){if(V[oa])V[oa].pointer.onDocumentMouseMove(a)},K(y,"mousemove",this._onDocumentMouseMove);
p(b.axes,function(b){b.drawCrosshair(a,m(e,g))})},reset:function(a){var b=this.chart,c=b.hoverSeries,d=b.hoverPoint,e=b.tooltip,f=e&&e.shared?b.hoverPoints:d;(a=a&&e&&f)&&qa(f)[0].plotX===t&&(a=!1);if(a)e.refresh(f),d&&d.setState(d.state,!0);else{if(d)d.onMouseOut();if(c)c.onMouseOut();e&&e.hide();if(this._onDocumentMouseMove)W(y,"mousemove",this._onDocumentMouseMove),this._onDocumentMouseMove=null;p(b.axes,function(a){a.hideCrosshair()});this.hoverX=null}},scaleGroups:function(a,b){var c=this.chart,
d;p(c.series,function(e){d=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&(e.group.attr(d),e.markerGroup&&(e.markerGroup.attr(d),e.markerGroup.clip(b?c.clipRect:null)),e.dataLabelsGroup&&e.dataLabelsGroup.attr(d))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,d=a.chartX,e=a.chartY,f=this.zoomHor,g=this.zoomVert,
h=b.plotLeft,i=b.plotTop,j=b.plotWidth,k=b.plotHeight,l,o=this.mouseDownX,n=this.mouseDownY;d<h?d=h:d>h+j&&(d=h+j);e<i?e=i:e>i+k&&(e=i+k);this.hasDragged=Math.sqrt(Math.pow(o-d,2)+Math.pow(n-e,2));if(this.hasDragged>10){l=b.isInsidePlot(o-h,n-i);if(b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&l&&!this.selectionMarker)this.selectionMarker=b.renderer.rect(h,i,f?1:j,g?1:k,0).attr({fill:c.selectionMarkerFill||"rgba(69,114,167,0.25)",zIndex:7}).add();this.selectionMarker&&f&&(d-=o,this.selectionMarker.attr({width:O(d),
x:(d>0?0:d)+o}));this.selectionMarker&&g&&(d=e-n,this.selectionMarker.attr({height:O(d),y:(d>0?0:d)+n}));l&&!this.selectionMarker&&c.panning&&b.pan(a,c.panning)}},drop:function(a){var b=this.chart,c=this.hasPinched;if(this.selectionMarker){var d={xAxis:[],yAxis:[],originalEvent:a.originalEvent||a},a=this.selectionMarker,e=a.attr?a.attr("x"):a.x,f=a.attr?a.attr("y"):a.y,g=a.attr?a.attr("width"):a.width,h=a.attr?a.attr("height"):a.height,i;if(this.hasDragged||c)p(b.axes,function(a){if(a.zoomEnabled){var b=
a.horiz,c=a.toValue(b?e:f),b=a.toValue(b?e+g:f+h);!isNaN(c)&&!isNaN(b)&&(d[a.coll].push({axis:a,min:C(c,b),max:v(c,b)}),i=!0)}}),i&&E(b,"selection",d,function(a){b.zoom(q(a,c?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();c&&this.scaleGroups()}if(b)D(b.container,{cursor:b._cursor}),b.cancelClick=this.hasDragged>10,b.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[]},onContainerMouseDown:function(a){a=this.normalize(a);a.preventDefault&&a.preventDefault();
this.dragStart(a)},onDocumentMouseUp:function(a){V[oa]&&V[oa].pointer.drop(a)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition,d=b.hoverSeries,a=this.normalize(a,c);c&&d&&!this.inClass(a.target,"highcharts-tracker")&&!b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)&&this.reset()},onContainerMouseLeave:function(){var a=V[oa];if(a)a.pointer.reset(),a.pointer.chartPosition=null},onContainerMouseMove:function(a){var b=this.chart;oa=b.index;a=this.normalize(a);b.mouseIsDown===
"mousedown"&&this.drag(a);(this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop))&&!b.openMenu&&this.runPointActions(a)},inClass:function(a,b){for(var c;a;){if(c=H(a,"class"))if(c.indexOf(b)!==-1)return!0;else if(c.indexOf("highcharts-container")!==-1)return!1;a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries,c=(a=a.relatedTarget||a.toElement)&&a.point&&a.point.series;if(b&&!b.options.stickyTracking&&!this.inClass(a,"highcharts-tooltip")&&
c!==b)b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop,f=b.inverted,g,h,i,a=this.normalize(a);a.cancelBubble=!0;if(!b.cancelClick)c&&this.inClass(a.target,"highcharts-tracker")?(g=this.chartPosition,h=c.plotX,i=c.plotY,q(c,{pageX:g.left+d+(f?b.plotWidth-i:h),pageY:g.top+e+(f?b.plotHeight-h:i)}),E(c.series,"click",q(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(q(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-e)&&E(b,"click",
a))},setDOMEvents:function(){var a=this,b=a.chart.container;b.onmousedown=function(b){a.onContainerMouseDown(b)};b.onmousemove=function(b){a.onContainerMouseMove(b)};b.onclick=function(b){a.onContainerClick(b)};K(b,"mouseleave",a.onContainerMouseLeave);ab===1&&K(y,"mouseup",a.onDocumentMouseUp);if($a)b.ontouchstart=function(b){a.onContainerTouchStart(b)},b.ontouchmove=function(b){a.onContainerTouchMove(b)},ab===1&&K(y,"touchend",a.onDocumentTouchEnd)},destroy:function(){var a;W(this.chart.container,
"mouseleave",this.onContainerMouseLeave);ab||(W(y,"mouseup",this.onDocumentMouseUp),W(y,"touchend",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(a in this)this[a]=null}};q(R.Pointer.prototype,{pinchTranslate:function(a,b,c,d,e,f){(this.zoomHor||this.pinchHor)&&this.pinchTranslateDirection(!0,a,b,c,d,e,f);(this.zoomVert||this.pinchVert)&&this.pinchTranslateDirection(!1,a,b,c,d,e,f)},pinchTranslateDirection:function(a,b,c,d,e,f,g,h){var i=this.chart,j=a?"x":"y",k=a?"X":"Y",l="chart"+
k,o=a?"width":"height",n=i["plot"+(a?"Left":"Top")],s,m,p=h||1,q=i.inverted,x=i.bounds[a?"h":"v"],r=b.length===1,v=b[0][l],u=c[0][l],t=!r&&b[1][l],w=!r&&c[1][l],y,c=function(){!r&&O(v-t)>20&&(p=h||O(u-w)/O(v-t));m=(n-u)/p+v;s=i["plot"+(a?"Width":"Height")]/p};c();b=m;b<x.min?(b=x.min,y=!0):b+s>x.max&&(b=x.max-s,y=!0);y?(u-=0.8*(u-g[j][0]),r||(w-=0.8*(w-g[j][1])),c()):g[j]=[u,w];q||(f[j]=m-n,f[o]=s);f=q?1/p:p;e[o]=s;e[j]=b;d[q?a?"scaleY":"scaleX":"scale"+k]=p;d["translate"+k]=f*n+(u-f*v)},pinch:function(a){var b=
this,c=b.chart,d=b.pinchDown,e=b.followTouchMove,f=a.touches,g=f.length,h=b.lastValidTouch,i=b.hasZoom,j=b.selectionMarker,k={},l=g===1&&(b.inClass(a.target,"highcharts-tracker")&&c.runTrackerClick||c.runChartClick),o={};(i||e)&&!l&&a.preventDefault();Ua(f,function(a){return b.normalize(a)});if(a.type==="touchstart")p(f,function(a,b){d[b]={chartX:a.chartX,chartY:a.chartY}}),h.x=[d[0].chartX,d[1]&&d[1].chartX],h.y=[d[0].chartY,d[1]&&d[1].chartY],p(c.axes,function(a){if(a.zoomEnabled){var b=c.bounds[a.horiz?
"h":"v"],d=a.minPixelPadding,e=a.toPixels(a.dataMin),f=a.toPixels(a.dataMax),g=C(e,f),e=v(e,f);b.min=C(a.pos,g-d);b.max=v(a.pos+a.len,e+d)}});else if(d.length){if(!j)b.selectionMarker=j=q({destroy:sa},c.plotBox);b.pinchTranslate(d,f,k,j,o,h);b.hasPinched=i;b.scaleGroups(k,o);!i&&e&&g===1&&this.runPointActions(b.normalize(a))}},onContainerTouchStart:function(a){var b=this.chart;oa=b.index;a.touches.length===1?(a=this.normalize(a),b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)?(this.runPointActions(a),
this.pinch(a)):this.reset()):a.touches.length===2&&this.pinch(a)},onContainerTouchMove:function(a){(a.touches.length===1||a.touches.length===2)&&this.pinch(a)},onDocumentTouchEnd:function(a){V[oa]&&V[oa].pointer.drop(a)}});if(I.PointerEvent||I.MSPointerEvent){var ua={},zb=!!I.PointerEvent,Wb=function(){var a,b=[];b.item=function(a){return this[a]};for(a in ua)ua.hasOwnProperty(a)&&b.push({pageX:ua[a].pageX,pageY:ua[a].pageY,target:ua[a].target});return b},Ab=function(a,b,c,d){a=a.originalEvent||a;
if((a.pointerType==="touch"||a.pointerType===a.MSPOINTER_TYPE_TOUCH)&&V[oa])d(a),d=V[oa].pointer,d[b]({type:c,target:a.currentTarget,preventDefault:sa,touches:Wb()})};q(Wa.prototype,{onContainerPointerDown:function(a){Ab(a,"onContainerTouchStart","touchstart",function(a){ua[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){Ab(a,"onContainerTouchMove","touchmove",function(a){ua[a.pointerId]={pageX:a.pageX,pageY:a.pageY};if(!ua[a.pointerId].target)ua[a.pointerId].target=
a.currentTarget})},onDocumentPointerUp:function(a){Ab(a,"onContainerTouchEnd","touchend",function(a){delete ua[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,zb?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,zb?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(y,zb?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});Ma(Wa.prototype,"init",function(a,b,c){a.call(this,b,c);(this.hasZoom||this.followTouchMove)&&D(b.container,{"-ms-touch-action":N,
"touch-action":N})});Ma(Wa.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(K)});Ma(Wa.prototype,"destroy",function(a){this.batchMSEvents(W);a.call(this)})}var lb=R.Legend=function(a,b){this.init(a,b)};lb.prototype={init:function(a,b){var c=this,d=b.itemStyle,e=m(b.padding,8),f=b.itemMarginTop||0;this.options=b;if(b.enabled)c.baseline=A(d.fontSize)+3+f,c.itemStyle=d,c.itemHiddenStyle=w(d,b.itemHiddenStyle),c.itemMarginTop=f,c.padding=e,c.initialItemX=
e,c.initialItemY=e-5,c.maxItemWidth=0,c.chart=a,c.itemHeight=0,c.lastLineHeight=0,c.symbolWidth=m(b.symbolWidth,16),c.pages=[],c.render(),K(c.chart,"endResize",function(){c.positionCheckboxes()})},colorizeItem:function(a,b){var c=this.options,d=a.legendItem,e=a.legendLine,f=a.legendSymbol,g=this.itemHiddenStyle.color,c=b?c.itemStyle.color:g,h=b?a.legendColor||a.color||"#CCC":g,g=a.options&&a.options.marker,i={fill:h},j;d&&d.css({fill:c,color:c});e&&e.attr({stroke:h});if(f){if(g&&f.isMarker)for(j in i.stroke=
h,g=a.convertAttribs(g),g)d=g[j],d!==t&&(i[j]=d);f.attr(i)}},positionItem:function(a){var b=this.options,c=b.symbolPadding,b=!b.rtl,d=a._legendItemPos,e=d[0],d=d[1],f=a.checkbox;a.legendGroup&&a.legendGroup.translate(b?e:this.legendWidth-e-2*c-4,d);if(f)f.x=e,f.y=d},destroyItem:function(a){var b=a.checkbox;p(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&Pa(a.checkbox)},destroy:function(){var a=this.group,b=this.box;if(b)this.box=b.destroy();
if(a)this.group=a.destroy()},positionCheckboxes:function(a){var b=this.group.alignAttr,c,d=this.clipHeight||this.legendHeight;if(b)c=b.translateY,p(this.allItems,function(e){var f=e.checkbox,g;f&&(g=c+f.y+(a||0)+3,D(f,{left:b.translateX+e.legendItemWidth+f.x-20+"px",top:g+"px",display:g>c-6&&g<c+d-6?"":N}))})},renderTitle:function(){var a=this.padding,b=this.options.title,c=0;if(b.text){if(!this.title)this.title=this.chart.renderer.label(b.text,a-3,a-4,null,null,null,null,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group);
a=this.title.getBBox();c=a.height;this.offsetWidth=a.width;this.contentGroup.attr({translateY:c})}this.titleHeight=c},renderItem:function(a){var b=this.chart,c=b.renderer,d=this.options,e=d.layout==="horizontal",f=this.symbolWidth,g=d.symbolPadding,h=this.itemStyle,i=this.itemHiddenStyle,j=this.padding,k=e?m(d.itemDistance,20):0,l=!d.rtl,o=d.width,n=d.itemMarginBottom||0,s=this.itemMarginTop,p=this.initialItemX,q=a.legendItem,r=a.series&&a.series.drawLegendSymbol?a.series:a,x=r.options,x=this.createCheckboxForItem&&
x&&x.showCheckbox,t=d.useHTML;if(!q)a.legendGroup=c.g("legend-item").attr({zIndex:1}).add(this.scrollGroup),r.drawLegendSymbol(this,a),a.legendItem=q=c.text(d.labelFormat?Ia(d.labelFormat,a):d.labelFormatter.call(a),l?f+g:-g,this.baseline,t).css(w(a.visible?h:i)).attr({align:l?"left":"right",zIndex:2}).add(a.legendGroup),this.setItemEvents&&this.setItemEvents(a,q,t,h,i),this.colorizeItem(a,a.visible),x&&this.createCheckboxForItem(a);c=q.getBBox();f=a.legendItemWidth=d.itemWidth||a.legendItemWidth||
f+g+c.width+k+(x?20:0);this.itemHeight=g=u(a.legendItemHeight||c.height);if(e&&this.itemX-p+f>(o||b.chartWidth-2*j-p-d.x))this.itemX=p,this.itemY+=s+this.lastLineHeight+n,this.lastLineHeight=0;this.maxItemWidth=v(this.maxItemWidth,f);this.lastItemY=s+this.itemY+n;this.lastLineHeight=v(g,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=f:(this.itemY+=s+g+n,this.lastLineHeight=g);this.offsetWidth=o||v((e?this.itemX-p-k:f)+j,this.offsetWidth)},getAllItems:function(){var a=
[];p(this.chart.series,function(b){var c=b.options;if(m(c.showInLegend,!r(c.linkedTo)?t:!1,!0))a=a.concat(b.legendItems||(c.legendType==="point"?b.data:b))});return a},render:function(){var a=this,b=a.chart,c=b.renderer,d=a.group,e,f,g,h,i=a.box,j=a.options,k=a.padding,l=j.borderWidth,o=j.backgroundColor;a.itemX=a.initialItemX;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;if(!d)a.group=d=c.g("legend").attr({zIndex:7}).add(),a.contentGroup=c.g().attr({zIndex:1}).add(d),a.scrollGroup=c.g().add(a.contentGroup);
a.renderTitle();e=a.getAllItems();ob(e,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});j.reversed&&e.reverse();a.allItems=e;a.display=f=!!e.length;p(e,function(b){a.renderItem(b)});g=j.width||a.offsetWidth;h=a.lastItemY+a.lastLineHeight+a.titleHeight;h=a.handleOverflow(h);if(l||o){g+=k;h+=k;if(i){if(g>0&&h>0)i[i.isNew?"attr":"animate"](i.crisp({width:g,height:h})),i.isNew=!1}else a.box=i=c.rect(0,0,g,h,j.borderRadius,l||0).attr({stroke:j.borderColor,
"stroke-width":l||0,fill:o||N}).add(d).shadow(j.shadow),i.isNew=!0;i[f?"show":"hide"]()}a.legendWidth=g;a.legendHeight=h;p(e,function(b){a.positionItem(b)});f&&d.align(q({width:g,height:h},j),!0,"spacingBox");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,c=this.chart,d=c.renderer,e=this.options,f=e.y,f=c.spacingBox.height+(e.verticalAlign==="top"?-f:f)-this.padding,g=e.maxHeight,h,i=this.clipRect,j=e.navigation,k=m(j.animation,!0),l=j.arrowSize||12,o=this.nav,n=this.pages,
s,q=this.allItems;e.layout==="horizontal"&&(f/=2);g&&(f=C(f,g));n.length=0;if(a>f&&!e.useHTML){this.clipHeight=h=f-20-this.titleHeight-this.padding;this.currentPage=m(this.currentPage,1);this.fullHeight=a;p(q,function(a,b){var c=a._legendItemPos[1],d=u(a.legendItem.getBBox().height),e=n.length;if(!e||c-n[e-1]>h&&(s||c)!==n[e-1])n.push(s||c),e++;b===q.length-1&&c+d-n[e-1]>h&&n.push(c);c!==s&&(s=c)});if(!i)i=b.clipRect=d.clipRect(0,this.padding,9999,0),b.contentGroup.clip(i);i.attr({height:h});if(!o)this.nav=
o=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol("triangle",0,0,l,l).on("click",function(){b.scroll(-1,k)}).add(o),this.pager=d.text("",15,10).css(j.style).add(o),this.down=d.symbol("triangle-down",0,0,l,l).on("click",function(){b.scroll(1,k)}).add(o);b.scroll(0);a=f}else if(o)i.attr({height:c.chartHeight}),o.hide(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0;return a},scroll:function(a,b){var c=this.pages,d=c.length,e=this.currentPage+a,f=this.clipHeight,g=this.options.navigation,
h=g.activeColor,g=g.inactiveColor,i=this.pager,j=this.padding;e>d&&(e=d);if(e>0)b!==t&&Qa(b,this.chart),this.nav.attr({translateX:j,translateY:f+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({fill:e===1?g:h}).css({cursor:e===1?"default":"pointer"}),i.attr({text:e+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,fill:e===d?g:h}).css({cursor:e===d?"default":"pointer"}),c=-c[e-1]+this.initialItemY,this.scrollGroup.animate({translateY:c}),this.currentPage=e,this.positionCheckboxes(c)}};
L=R.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.options.symbolHeight||12;b.legendSymbol=this.chart.renderer.rect(0,a.baseline-5-c/2,a.symbolWidth,c,a.options.symbolRadius||0).attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,c=b.marker,d;d=a.symbolWidth;var e=this.chart.renderer,f=this.legendGroup,a=a.baseline-u(e.fontMetrics(a.options.itemStyle.fontSize).b*0.3),g;if(b.lineWidth){g={"stroke-width":b.lineWidth};if(b.dashStyle)g.dashstyle=b.dashStyle;this.legendLine=
e.path(["M",0,a,"L",d,a]).attr(g).add(f)}if(c&&c.enabled!==!1)b=c.radius,this.legendSymbol=d=e.symbol(this.symbol,d/2-b,a-b,2*b,2*b).add(f),d.isMarker=!0}};(/Trident\/7\.0/.test(wa)||Ta)&&Ma(lb.prototype,"positionItem",function(a,b){var c=this,d=function(){b._legendItemPos&&a.call(c,b)};d();setTimeout(d)});Ya.prototype={init:function(a,b){var c,d=a.series;a.series=null;c=w(F,a);c.series=a.series=d;this.userOptions=a;d=c.chart;this.margin=this.splashArray("margin",d);this.spacing=this.splashArray("spacing",
d);var e=d.events;this.bounds={h:{},v:{}};this.callback=b;this.isResizing=0;this.options=c;this.axes=[];this.series=[];this.hasCartesianSeries=d.showAxes;var f=this,g;f.index=V.length;V.push(f);ab++;d.reflow!==!1&&K(f,"load",function(){f.initReflow()});if(e)for(g in e)K(f,g,e[g]);f.xAxis=[];f.yAxis=[];f.animation=fa?!1:m(d.animation,!0);f.pointCount=0;f.counters=new Bb;f.firstRender()},initSeries:function(a){var b=this.options.chart;(b=G[a.type||b.type||b.defaultSeriesType])||ra(17,!0);b=new b;b.init(this,
a);return b},isInsidePlot:function(a,b,c){var d=c?b:a,a=c?a:b;return d>=0&&d<=this.plotWidth&&a>=0&&a<=this.plotHeight},adjustTickAmounts:function(){this.options.chart.alignTicks!==!1&&p(this.axes,function(a){a.adjustTickAmount()});this.maxTicks=null},redraw:function(a){var b=this.axes,c=this.series,d=this.pointer,e=this.legend,f=this.isDirtyLegend,g,h,i=this.isDirtyBox,j=c.length,k=j,l=this.renderer,o=l.isHidden(),n=[];Qa(a,this);o&&this.cloneRenderTo();for(this.layOutTitles();k--;)if(a=c[k],a.options.stacking&&
(g=!0,a.isDirty)){h=!0;break}if(h)for(k=j;k--;)if(a=c[k],a.options.stacking)a.isDirty=!0;p(c,function(a){a.isDirty&&a.options.legendType==="point"&&(f=!0)});if(f&&e.options.enabled)e.render(),this.isDirtyLegend=!1;g&&this.getStacks();if(this.hasCartesianSeries){if(!this.isResizing)this.maxTicks=null,p(b,function(a){a.setScale()});this.adjustTickAmounts();this.getMargins();p(b,function(a){a.isDirty&&(i=!0)});p(b,function(a){if(a.isDirtyExtremes)a.isDirtyExtremes=!1,n.push(function(){E(a,"afterSetExtremes",
q(a.eventArgs,a.getExtremes()));delete a.eventArgs});(i||g)&&a.redraw()})}i&&this.drawChartBox();p(c,function(a){a.isDirty&&a.visible&&(!a.isCartesian||a.xAxis)&&a.redraw()});d&&d.reset(!0);l.draw();E(this,"redraw");o&&this.cloneRenderTo(!0);p(n,function(a){a.call()})},get:function(a){var b=this.axes,c=this.series,d,e;for(d=0;d<b.length;d++)if(b[d].options.id===a)return b[d];for(d=0;d<c.length;d++)if(c[d].options.id===a)return c[d];for(d=0;d<c.length;d++){e=c[d].points||[];for(b=0;b<e.length;b++)if(e[b].id===
a)return e[b]}return null},getAxes:function(){var a=this,b=this.options,c=b.xAxis=qa(b.xAxis||{}),b=b.yAxis=qa(b.yAxis||{});p(c,function(a,b){a.index=b;a.isX=!0});p(b,function(a,b){a.index=b});c=c.concat(b);p(c,function(b){new la(a,b)});a.adjustTickAmounts()},getSelectedPoints:function(){var a=[];p(this.series,function(b){a=a.concat(vb(b.points||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return vb(this.series,function(a){return a.selected})},getStacks:function(){var a=
this;p(a.yAxis,function(a){if(a.stacks&&a.hasVisibleSeries)a.oldStacks=a.stacks});p(a.series,function(b){if(b.options.stacking&&(b.visible===!0||a.options.chart.ignoreHiddenSeries===!1))b.stackKey=b.type+m(b.options.stack,"")})},setTitle:function(a,b,c){var g;var d=this,e=d.options,f;f=e.title=w(e.title,a);g=e.subtitle=w(e.subtitle,b),e=g;p([["title",a,f],["subtitle",b,e]],function(a){var b=a[0],c=d[b],e=a[1],a=a[2];c&&e&&(d[b]=c=c.destroy());a&&a.text&&!c&&(d[b]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,
"class":"highcharts-"+b,zIndex:a.zIndex||4}).css(a.style).add())});d.layOutTitles(c)},layOutTitles:function(a){var b=0,c=this.title,d=this.subtitle,e=this.options,f=e.title,e=e.subtitle,g=this.spacingBox.width-44;if(c&&(c.css({width:(f.width||g)+"px"}).align(q({y:15},f),!1,"spacingBox"),!f.floating&&!f.verticalAlign))b=c.getBBox().height;d&&(d.css({width:(e.width||g)+"px"}).align(q({y:b+f.margin},e),!1,"spacingBox"),!e.floating&&!e.verticalAlign&&(b=Ka(b+d.getBBox().height)));c=this.titleOffset!==
b;this.titleOffset=b;if(!this.isDirtyBox&&c)this.isDirtyBox=c,this.hasRendered&&m(a,!0)&&this.isDirtyBox&&this.redraw()},getChartSize:function(){var a=this.options.chart,b=a.width,a=a.height,c=this.renderToClone||this.renderTo;if(!r(b))this.containerWidth=jb(c,"width");if(!r(a))this.containerHeight=jb(c,"height");this.chartWidth=v(0,b||this.containerWidth||600);this.chartHeight=v(0,m(a,this.containerHeight>19?this.containerHeight:400))},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;
a?b&&(this.renderTo.appendChild(c),Pa(b),delete this.renderToClone):(c&&c.parentNode===this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),D(b,{position:"absolute",top:"-9999px",display:"block"}),b.style.setProperty&&b.style.setProperty("display","block","important"),y.body.appendChild(b),c&&b.appendChild(c))},getContainer:function(){var a,b=this.options.chart,c,d,e;this.renderTo=a=b.renderTo;e="highcharts-"+tb++;if(Fa(a))this.renderTo=a=y.getElementById(a);
a||ra(13,!0);c=A(H(a,"data-highcharts-chart"));!isNaN(c)&&V[c]&&V[c].hasRendered&&V[c].destroy();H(a,"data-highcharts-chart",this.index);a.innerHTML="";!b.skipClone&&!a.offsetWidth&&this.cloneRenderTo();this.getChartSize();c=this.chartWidth;d=this.chartHeight;this.container=a=Y(Ja,{className:"highcharts-container"+(b.className?" "+b.className:""),id:e},q({position:"relative",overflow:"hidden",width:c+"px",height:d+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},
b.style),this.renderToClone||a);this._cursor=a.style.cursor;this.renderer=b.forExport?new ta(a,c,d,b.style,!0):new Za(a,c,d,b.style);fa&&this.renderer.create(this,a,c,d)},getMargins:function(){var a=this.spacing,b,c=this.legend,d=this.margin,e=this.options.legend,f=m(e.margin,20),g=e.x,h=e.y,i=e.align,j=e.verticalAlign,k=this.titleOffset;this.resetMargins();b=this.axisOffset;if(k&&!r(d[0]))this.plotTop=v(this.plotTop,k+this.options.title.margin+a[0]);if(c.display&&!e.floating)if(i==="right"){if(!r(d[1]))this.marginRight=
v(this.marginRight,c.legendWidth-g+f+a[1])}else if(i==="left"){if(!r(d[3]))this.plotLeft=v(this.plotLeft,c.legendWidth+g+f+a[3])}else if(j==="top"){if(!r(d[0]))this.plotTop=v(this.plotTop,c.legendHeight+h+f+a[0])}else if(j==="bottom"&&!r(d[2]))this.marginBottom=v(this.marginBottom,c.legendHeight-h+f+a[2]);this.extraBottomMargin&&(this.marginBottom+=this.extraBottomMargin);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);this.hasCartesianSeries&&p(this.axes,function(a){a.getOffset()});r(d[3])||
(this.plotLeft+=b[3]);r(d[0])||(this.plotTop+=b[0]);r(d[2])||(this.marginBottom+=b[2]);r(d[1])||(this.marginRight+=b[1]);this.setChartSize()},reflow:function(a){var b=this,c=b.options.chart,d=b.renderTo,e=c.width||jb(d,"width"),f=c.height||jb(d,"height"),c=a?a.target:I,d=function(){if(b.container)b.setSize(e,f,!1),b.hasUserSize=null};if(!b.hasUserSize&&e&&f&&(c===I||c===y)){if(e!==b.containerWidth||f!==b.containerHeight)clearTimeout(b.reflowTimeout),a?b.reflowTimeout=setTimeout(d,100):d();b.containerWidth=
e;b.containerHeight=f}},initReflow:function(){var a=this,b=function(b){a.reflow(b)};K(I,"resize",b);K(a,"destroy",function(){W(I,"resize",b)})},setSize:function(a,b,c){var d=this,e,f,g;d.isResizing+=1;g=function(){d&&E(d,"endResize",null,function(){d.isResizing-=1})};Qa(c,d);d.oldChartHeight=d.chartHeight;d.oldChartWidth=d.chartWidth;if(r(a))d.chartWidth=e=v(0,u(a)),d.hasUserSize=!!e;if(r(b))d.chartHeight=f=v(0,u(b));(va?kb:D)(d.container,{width:e+"px",height:f+"px"},va);d.setChartSize(!0);d.renderer.setSize(e,
f,c);d.maxTicks=null;p(d.axes,function(a){a.isDirty=!0;a.setScale()});p(d.series,function(a){a.isDirty=!0});d.isDirtyLegend=!0;d.isDirtyBox=!0;d.layOutTitles();d.getMargins();d.redraw(c);d.oldChartHeight=null;E(d,"resize");va===!1?g():setTimeout(g,va&&va.duration||500)},setChartSize:function(a){var b=this.inverted,c=this.renderer,d=this.chartWidth,e=this.chartHeight,f=this.options.chart,g=this.spacing,h=this.clipOffset,i,j,k,l;this.plotLeft=i=u(this.plotLeft);this.plotTop=j=u(this.plotTop);this.plotWidth=
k=v(0,u(d-i-this.marginRight));this.plotHeight=l=v(0,u(e-j-this.marginBottom));this.plotSizeX=b?l:k;this.plotSizeY=b?k:l;this.plotBorderWidth=f.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:g[3],y:g[0],width:d-g[3]-g[1],height:e-g[0]-g[2]};this.plotBox=c.plotBox={x:i,y:j,width:k,height:l};d=2*S(this.plotBorderWidth/2);b=Ka(v(d,h[3])/2);c=Ka(v(d,h[0])/2);this.clipBox={x:b,y:c,width:S(this.plotSizeX-v(d,h[1])/2-b),height:S(this.plotSizeY-v(d,h[2])/2-c)};a||p(this.axes,function(a){a.setAxisSize();
a.setAxisTranslation()})},resetMargins:function(){var a=this.spacing,b=this.margin;this.plotTop=m(b[0],a[0]);this.marginRight=m(b[1],a[1]);this.marginBottom=m(b[2],a[2]);this.plotLeft=m(b[3],a[3]);this.axisOffset=[0,0,0,0];this.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,d=this.chartHeight,e=this.chartBackground,f=this.plotBackground,g=this.plotBorder,h=this.plotBGImage,i=a.borderWidth||0,j=a.backgroundColor,k=a.plotBackgroundColor,l=a.plotBackgroundImage,
o=a.plotBorderWidth||0,n,s=this.plotLeft,m=this.plotTop,p=this.plotWidth,q=this.plotHeight,r=this.plotBox,v=this.clipRect,u=this.clipBox;n=i+(a.shadow?8:0);if(i||j)if(e)e.animate(e.crisp({width:c-n,height:d-n}));else{e={fill:j||N};if(i)e.stroke=a.borderColor,e["stroke-width"]=i;this.chartBackground=b.rect(n/2,n/2,c-n,d-n,a.borderRadius,i).attr(e).addClass("highcharts-background").add().shadow(a.shadow)}if(k)f?f.animate(r):this.plotBackground=b.rect(s,m,p,q,0).attr({fill:k}).add().shadow(a.plotShadow);
if(l)h?h.animate(r):this.plotBGImage=b.image(l,s,m,p,q).add();v?v.animate({width:u.width,height:u.height}):this.clipRect=b.clipRect(u);if(o)g?g.animate(g.crisp({x:s,y:m,width:p,height:q})):this.plotBorder=b.rect(s,m,p,q,0,-o).attr({stroke:a.plotBorderColor,"stroke-width":o,fill:N,zIndex:1}).add();this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,e,f;p(["inverted","angular","polar"],function(g){c=G[b.type||b.defaultSeriesType];f=a[g]||b[g]||c&&c.prototype[g];
for(e=d&&d.length;!f&&e--;)(c=G[d[e].type])&&c.prototype[g]&&(f=!0);a[g]=f})},linkSeries:function(){var a=this,b=a.series;p(b,function(a){a.linkedSeries.length=0});p(b,function(b){var d=b.options.linkedTo;if(Fa(d)&&(d=d===":previous"?a.series[b.index-1]:a.get(d)))d.linkedSeries.push(b),b.linkedParent=d})},renderSeries:function(){p(this.series,function(a){a.translate();a.setTooltipPoints&&a.setTooltipPoints();a.render()})},render:function(){var a=this,b=a.axes,c=a.renderer,d=a.options,e=d.labels,f=
d.credits,g;a.setTitle();a.legend=new lb(a,d.legend);a.getStacks();p(b,function(a){a.setScale()});a.getMargins();a.maxTicks=null;p(b,function(a){a.setTickPositions(!0);a.setMaxTicks()});a.adjustTickAmounts();a.getMargins();a.drawChartBox();a.hasCartesianSeries&&p(b,function(a){a.render()});if(!a.seriesGroup)a.seriesGroup=c.g("series-group").attr({zIndex:3}).add();a.renderSeries();e.items&&p(e.items,function(b){var d=q(e.style,b.style),f=A(d.left)+a.plotLeft,g=A(d.top)+a.plotTop+12;delete d.left;delete d.top;
c.text(b.html,f,g).attr({zIndex:2}).css(d).add()});if(f.enabled&&!a.credits)g=f.href,a.credits=c.text(f.text,0,0).on("click",function(){if(g)location.href=g}).attr({align:f.position.align,zIndex:8}).css(f.style).add().align(f.position);a.hasRendered=!0},destroy:function(){var a=this,b=a.axes,c=a.series,d=a.container,e,f=d&&d.parentNode;E(a,"destroy");V[a.index]=t;ab--;a.renderTo.removeAttribute("data-highcharts-chart");W(a);for(e=b.length;e--;)b[e]=b[e].destroy();for(e=c.length;e--;)c[e]=c[e].destroy();
p("title,subtitle,chartBackground,plotBackground,plotBGImage,plotBorder,seriesGroup,clipRect,credits,pointer,scroller,rangeSelector,legend,resetZoomButton,tooltip,renderer".split(","),function(b){var c=a[b];c&&c.destroy&&(a[b]=c.destroy())});if(d)d.innerHTML="",W(d),f&&Pa(d);for(e in a)delete a[e]},isReadyToRender:function(){var a=this;return!aa&&I==I.top&&y.readyState!=="complete"||fa&&!I.canvg?(fa?Lb.push(function(){a.firstRender()},a.options.global.canvasToolsURL):y.attachEvent("onreadystatechange",
function(){y.detachEvent("onreadystatechange",a.firstRender);y.readyState==="complete"&&a.firstRender()}),!1):!0},firstRender:function(){var a=this,b=a.options,c=a.callback;if(a.isReadyToRender()){a.getContainer();E(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();p(b.series||[],function(b){a.initSeries(b)});a.linkSeries();E(a,"beforeRender");if(R.Pointer)a.pointer=new Wa(a,b);a.render();a.renderer.draw();c&&c.apply(a,[a]);p(a.callbacks,function(b){b.apply(a,[a])});a.cloneRenderTo(!0);
E(a,"load")}},splashArray:function(a,b){var c=b[a],c=ca(c)?c:[c,c,c,c];return[m(b[a+"Top"],c[0]),m(b[a+"Right"],c[1]),m(b[a+"Bottom"],c[2]),m(b[a+"Left"],c[3])]}};Ya.prototype.callbacks=[];X=R.CenteredSeriesMixin={getCenter:function(){var a=this.options,b=this.chart,c=2*(a.slicedOffset||0),d,e=b.plotWidth-2*c,f=b.plotHeight-2*c,b=a.center,a=[m(b[0],"50%"),m(b[1],"50%"),a.size||"100%",a.innerSize||0],g=C(e,f),h;return Ua(a,function(a,b){h=/%$/.test(a);d=b<2||b===2&&h;return(h?[e,f,g,g][b]*A(a)/100:
a)+(d?c:0)})}};var Ea=function(){};Ea.prototype={init:function(a,b,c){this.series=a;this.applyOptions(b,c);this.pointAttr={};if(a.options.colorByPoint&&(b=a.options.colors||a.chart.options.colors,this.color=this.color||b[a.colorCounter++],a.colorCounter===b.length))a.colorCounter=0;a.chart.pointCount++;return this},applyOptions:function(a,b){var c=this.series,d=c.pointValKey,a=Ea.prototype.optionsToObject.call(this,a);q(this,a);this.options=this.options?q(this.options,a):a;if(d)this.y=this[d];if(this.x===
t&&c)this.x=b===t?c.autoIncrement():b;return this},optionsToObject:function(a){var b={},c=this.series,d=c.pointArrayMap||["y"],e=d.length,f=0,g=0;if(typeof a==="number"||a===null)b[d[0]]=a;else if(La(a)){if(a.length>e){c=typeof a[0];if(c==="string")b.name=a[0];else if(c==="number")b.x=a[0];f++}for(;g<e;)b[d[g++]]=a[f++]}else if(typeof a==="object"){b=a;if(a.dataLabels)c._hasPointLabels=!0;if(a.marker)c._hasPointMarkers=!0}return b},destroy:function(){var a=this.series.chart,b=a.hoverPoints,c;a.pointCount--;
if(b&&(this.setState(),ja(b,this),!b.length))a.hoverPoints=null;if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)W(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(c in this)this[c]=null},destroyElements:function(){for(var a="graphic,dataLabel,dataLabelUpper,group,connector,shadowGroup".split(","),b,c=6;c--;)b=a[c],this[b]&&(this[b]=this[b].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,key:this.name||this.category,series:this.series,
point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var b=this.series,c=b.tooltipOptions,d=m(c.valueDecimals,""),e=c.valuePrefix||"",f=c.valueSuffix||"";p(b.pointArrayMap||["y"],function(b){b="{point."+b;if(e||f)a=a.replace(b+"}",e+b+"}"+f);a=a.replace(b+"}",b+":,."+d+"f}")});return Ia(a,{point:this,series:this.series})},firePointEvent:function(a,b,c){var d=this,e=this.series.options;(e.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&
this.importEvents();a==="click"&&e.allowPointSelect&&(c=function(a){d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});E(this,a,b,c)}};var M=function(){};M.prototype={isCartesian:!0,type:"line",pointClass:Ea,sorted:!0,requireSorting:!0,pointAttrToOptions:{stroke:"lineColor","stroke-width":"lineWidth",fill:"fillColor",r:"radius"},axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],init:function(a,b){var c=this,d,e,f=a.series,g=function(a,b){return m(a.options.index,a._i)-m(b.options.index,
b._i)};c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();q(c,{name:b.name,state:"",pointAttr:{},visible:b.visible!==!1,selected:b.selected===!0});if(fa)b.animation=!1;e=b.events;for(d in e)K(c,d,e[d]);if(e&&e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();c.getSymbol();p(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);if(c.isCartesian)a.hasCartesianSeries=!0;f.push(c);c._i=f.length-1;ob(f,g);this.yAxis&&
ob(this.yAxis.series,g);p(f,function(a,b){a.index=b;a.name=a.name||"Series "+(b+1)})},bindAxes:function(){var a=this,b=a.options,c=a.chart,d;p(a.axisTypes||[],function(e){p(c[e],function(c){d=c.options;if(b[e]===d.index||b[e]!==t&&b[e]===d.id||b[e]===t&&d.index===0)c.series.push(a),a[e]=c,c.isDirty=!0});!a[e]&&a.optionalAxis!==e&&ra(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,d=arguments;p(c.parallelArrays,typeof b==="number"?function(d){var f=d==="y"&&c.toYData?c.toYData(a):a[d];
c[d+"Data"][b]=f}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(d,2))})},autoIncrement:function(){var a=this.options,b=this.xIncrement,b=m(b,a.pointStart,0);this.pointInterval=m(this.pointInterval,a.pointInterval,1);this.xIncrement=b+this.pointInterval;return b},getSegments:function(){var a=-1,b=[],c,d=this.points,e=d.length;if(e)if(this.options.connectNulls){for(c=e;c--;)d[c].y===null&&d.splice(c,1);d.length&&(b=[d])}else p(d,function(c,g){c.y===null?(g>a+1&&b.push(d.slice(a+
1,g)),a=g):g===e-1&&b.push(d.slice(a+1,g+1))});this.segments=b},setOptions:function(a){var b=this.chart,c=b.options.plotOptions,b=b.userOptions||{},d=b.plotOptions||{},e=c[this.type];this.userOptions=a;c=w(e,c.series,a);this.tooltipOptions=w(F.tooltip,F.plotOptions[this.type].tooltip,b.tooltip,d.series&&d.series.tooltip,d[this.type]&&d[this.type].tooltip,a.tooltip);e.marker===null&&delete c.marker;return c},getColor:function(){var a=this.options,b=this.userOptions,c=this.chart.options.colors,d=this.chart.counters,
e;e=a.color||ba[this.type].color;if(!e&&!a.colorByPoint)r(b._colorIndex)?a=b._colorIndex:(b._colorIndex=d.color,a=d.color++),e=c[a];this.color=e;d.wrapColor(c.length)},getSymbol:function(){var a=this.userOptions,b=this.options.marker,c=this.chart,d=c.options.symbols,c=c.counters;this.symbol=b.symbol;if(!this.symbol)r(a._symbolIndex)?a=a._symbolIndex:(a._symbolIndex=c.symbol,a=c.symbol++),this.symbol=d[a];if(/^url/.test(this.symbol))b.radius=0;c.wrapSymbol(d.length)},drawLegendSymbol:L.drawLineMarker,
setData:function(a,b,c,d){var e=this,f=e.points,g=f&&f.length||0,h,i=e.options,j=e.chart,k=null,l=e.xAxis,o=l&&!!l.categories,n=e.tooltipPoints,s=i.turboThreshold,q=this.xData,r=this.yData,v=(h=e.pointArrayMap)&&h.length,a=a||[];h=a.length;b=m(b,!0);if(d!==!1&&h&&g===h&&!e.cropped&&!e.hasGroupedData)p(a,function(a,b){f[b].update(a,!1)});else{e.xIncrement=null;e.pointRange=o?1:i.pointRange;e.colorCounter=0;p(this.parallelArrays,function(a){e[a+"Data"].length=0});if(s&&h>s){for(c=0;k===null&&c<h;)k=
a[c],c++;if(ha(k)){o=m(i.pointStart,0);i=m(i.pointInterval,1);for(c=0;c<h;c++)q[c]=o,r[c]=a[c],o+=i;e.xIncrement=o}else if(La(k))if(v)for(c=0;c<h;c++)i=a[c],q[c]=i[0],r[c]=i.slice(1,v+1);else for(c=0;c<h;c++)i=a[c],q[c]=i[0],r[c]=i[1];else ra(12)}else for(c=0;c<h;c++)if(a[c]!==t&&(i={series:e},e.pointClass.prototype.applyOptions.apply(i,[a[c]]),e.updateParallelArrays(i,c),o&&i.name))l.names[i.x]=i.name;Fa(r[0])&&ra(14,!0);e.data=[];e.options.data=a;for(c=g;c--;)f[c]&&f[c].destroy&&f[c].destroy();
if(n)n.length=0;if(l)l.minRange=l.userMinRange;e.isDirty=e.isDirtyData=j.isDirtyBox=!0;c=!1}b&&j.redraw(c)},processData:function(a){var b=this.xData,c=this.yData,d=b.length,e;e=0;var f,g,h=this.xAxis,i=this.options,j=i.cropThreshold,k=0,l=this.isCartesian,o,n;if(l&&!this.isDirty&&!h.isDirty&&!this.yAxis.isDirty&&!a)return!1;if(l&&this.sorted&&(!j||d>j||this.forceCrop))if(o=h.min,n=h.max,b[d-1]<o||b[0]>n)b=[],c=[];else if(b[0]<o||b[d-1]>n)e=this.cropData(this.xData,this.yData,o,n),b=e.xData,c=e.yData,
e=e.start,f=!0,k=b.length;for(d=b.length-1;d>=0;d--)a=b[d]-b[d-1],!f&&b[d]>o&&b[d]<n&&k++,a>0&&(g===t||a<g)?g=a:a<0&&this.requireSorting&&ra(15);this.cropped=f;this.cropStart=e;this.processedXData=b;this.processedYData=c;this.activePointCount=k;if(i.pointRange===null)this.pointRange=g||1;this.closestPointRange=g},cropData:function(a,b,c,d){var e=a.length,f=0,g=e,h=m(this.cropShoulder,1),i;for(i=0;i<e;i++)if(a[i]>=c){f=v(0,i-h);break}for(;i<e;i++)if(a[i]>d){g=i+h;break}return{xData:a.slice(f,g),yData:b.slice(f,
g),start:f,end:g}},generatePoints:function(){var a=this.options.data,b=this.data,c,d=this.processedXData,e=this.processedYData,f=this.pointClass,g=d.length,h=this.cropStart||0,i,j=this.hasGroupedData,k,l=[],o;if(!b&&!j)b=[],b.length=a.length,b=this.data=b;for(o=0;o<g;o++)i=h+o,j?l[o]=(new f).init(this,[d[o]].concat(qa(e[o]))):(b[i]?k=b[i]:a[i]!==t&&(b[i]=k=(new f).init(this,a[i],d[o])),l[o]=k);if(b&&(g!==(c=b.length)||j))for(o=0;o<c;o++)if(o===h&&!j&&(o+=g),b[o])b[o].destroyElements(),b[o].plotX=
t;this.data=b;this.points=l},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,d,e=[],f=0;d=this.xAxis.getExtremes();var g=d.min,h=d.max,i,j,k,l,a=a||this.stackedYData||this.processedYData;d=a.length;for(l=0;l<d;l++)if(j=c[l],k=a[l],i=k!==null&&k!==t&&(!b.isLog||k.length||k>0),j=this.getExtremesFromAll||this.cropped||(c[l+1]||j)>=g&&(c[l-1]||j)<=h,i&&j)if(i=k.length)for(;i--;)k[i]!==null&&(e[f++]=k[i]);else e[f++]=k;this.dataMin=m(void 0,Na(e));this.dataMax=m(void 0,Ba(e))},translate:function(){this.processedXData||
this.processData();this.generatePoints();for(var a=this.options,b=a.stacking,c=this.xAxis,d=c.categories,e=this.yAxis,f=this.points,g=f.length,h=!!this.modifyValue,i=a.pointPlacement,j=i==="between"||ha(i),k=a.threshold,a=0;a<g;a++){var l=f[a],o=l.x,n=l.y,s=l.low,p=b&&e.stacks[(this.negStacks&&n<k?"-":"")+this.stackKey];if(e.isLog&&n<=0)l.y=n=null;l.plotX=c.translate(o,0,0,0,1,i,this.type==="flags");if(b&&this.visible&&p&&p[o])p=p[o],n=p.points[this.index+","+a],s=n[0],n=n[1],s===0&&(s=m(k,e.min)),
e.isLog&&s<=0&&(s=null),l.total=l.stackTotal=p.total,l.percentage=p.total&&l.y/p.total*100,l.stackY=n,p.setOffset(this.pointXOffset||0,this.barW||0);l.yBottom=r(s)?e.translate(s,0,1,0,1):null;h&&(n=this.modifyValue(n,l));l.plotY=typeof n==="number"&&n!==Infinity?e.translate(n,0,1,0,1):t;l.clientX=j?c.translate(o,0,0,0,1):l.plotX;l.negative=l.y<(k||0);l.category=d&&d[l.x]!==t?d[l.x]:l.x}this.getSegments()},animate:function(a){var b=this.chart,c=b.renderer,d;d=this.options.animation;var e=this.clipBox||
b.clipBox,f=b.inverted,g;if(d&&!ca(d))d=ba[this.type].animation;g=["_sharedClip",d.duration,d.easing,e.height].join(",");a?(a=b[g],d=b[g+"m"],a||(b[g]=a=c.clipRect(q(e,{width:0})),b[g+"m"]=d=c.clipRect(-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),this.group.clip(a),this.markerGroup.clip(d),this.sharedClipKey=g):((a=b[g])&&a.animate({width:b.plotSizeX},d),b[g+"m"]&&b[g+"m"].animate({width:b.plotSizeX+99},d),this.animate=null)},afterAnimate:function(){var a=this.chart,b=this.sharedClipKey,
c=this.group,d=this.clipBox;if(c&&this.options.clip!==!1){if(!b||!d)c.clip(d?a.renderer.clipRect(d):a.clipRect);this.markerGroup.clip()}E(this,"afterAnimate");setTimeout(function(){b&&a[b]&&(d||(a[b]=a[b].destroy()),a[b+"m"]&&(a[b+"m"]=a[b+"m"].destroy()))},100)},drawPoints:function(){var a,b=this.points,c=this.chart,d,e,f,g,h,i,j,k;d=this.options.marker;var l=this.pointAttr[""],o,n=this.markerGroup,s=m(d.enabled,this.activePointCount<0.5*this.xAxis.len/d.radius);if(d.enabled!==!1||this._hasPointMarkers)for(f=
b.length;f--;)if(g=b[f],d=S(g.plotX),e=g.plotY,k=g.graphic,i=g.marker||{},a=s&&i.enabled===t||i.enabled,o=c.isInsidePlot(u(d),e,c.inverted),a&&e!==t&&!isNaN(e)&&g.y!==null)if(a=g.pointAttr[g.selected?"select":""]||l,h=a.r,i=m(i.symbol,this.symbol),j=i.indexOf("url")===0,k)k[o?"show":"hide"](!0).animate(q({x:d-h,y:e-h},k.symbolName?{width:2*h,height:2*h}:{}));else{if(o&&(h>0||j))g.graphic=c.renderer.symbol(i,d-h,e-h,2*h,2*h).attr(a).add(n)}else if(k)g.graphic=k.destroy()},convertAttribs:function(a,
b,c,d){var e=this.pointAttrToOptions,f,g,h={},a=a||{},b=b||{},c=c||{},d=d||{};for(f in e)g=e[f],h[f]=m(a[g],b[f],c[f],d[f]);return h},getAttribs:function(){var a=this,b=a.options,c=ba[a.type].marker?b.marker:b,d=c.states,e=d.hover,f,g=a.color;f={stroke:g,fill:g};var h=a.points||[],i,j=[],k,l=a.pointAttrToOptions;k=a.hasPointSpecificOptions;var o=b.negativeColor,n=c.lineColor,s=c.fillColor;i=b.turboThreshold;var m;b.marker?(e.radius=e.radius||c.radius+2,e.lineWidth=e.lineWidth||c.lineWidth+1):e.color=
e.color||ya(e.color||g).brighten(e.brightness).get();j[""]=a.convertAttribs(c,f);p(["hover","select"],function(b){j[b]=a.convertAttribs(d[b],j[""])});a.pointAttr=j;g=h.length;if(!i||g<i||k)for(;g--;){i=h[g];if((c=i.options&&i.options.marker||i.options)&&c.enabled===!1)c.radius=0;if(i.negative&&o)i.color=i.fillColor=o;k=b.colorByPoint||i.color;if(i.options)for(m in l)r(c[l[m]])&&(k=!0);if(k){c=c||{};k=[];d=c.states||{};f=d.hover=d.hover||{};if(!b.marker)f.color=f.color||!i.options.color&&e.color||
ya(i.color).brighten(f.brightness||e.brightness).get();f={color:i.color};if(!s)f.fillColor=i.color;if(!n)f.lineColor=i.color;k[""]=a.convertAttribs(q(f,c),j[""]);k.hover=a.convertAttribs(d.hover,j.hover,k[""]);k.select=a.convertAttribs(d.select,j.select,k[""])}else k=j;i.pointAttr=k}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(wa),d,e,f=a.data||[],g,h,i;E(a,"destroy");W(a);p(a.axisTypes||[],function(b){if(i=a[b])ja(i.series,a),i.isDirty=i.forceRedraw=!0});a.legendItem&&a.chart.legend.destroyItem(a);
for(e=f.length;e--;)(g=f[e])&&g.destroy&&g.destroy();a.points=null;clearTimeout(a.animationTimeout);p("area,graph,dataLabelsGroup,group,markerGroup,tracker,graphNeg,areaNeg,posClip,negClip".split(","),function(b){a[b]&&(d=c&&b==="group"?"hide":"destroy",a[b][d]())});if(b.hoverSeries===a)b.hoverSeries=null;ja(b.series,a);for(h in a)delete a[h]},getSegmentPath:function(a){var b=this,c=[],d=b.options.step;p(a,function(e,f){var g=e.plotX,h=e.plotY,i;b.getPointSpline?c.push.apply(c,b.getPointSpline(a,
e,f)):(c.push(f?"L":"M"),d&&f&&(i=a[f-1],d==="right"?c.push(i.plotX,h):d==="center"?c.push((i.plotX+g)/2,i.plotY,(i.plotX+g)/2,h):c.push(g,i.plotY)),c.push(e.plotX,e.plotY))});return c},getGraphPath:function(){var a=this,b=[],c,d=[];p(a.segments,function(e){c=a.getSegmentPath(e);e.length>1?b=b.concat(c):d.push(e[0])});a.singlePoints=d;return a.graphPath=b},drawGraph:function(){var a=this,b=this.options,c=[["graph",b.lineColor||this.color]],d=b.lineWidth,e=b.dashStyle,f=b.linecap!=="square",g=this.getGraphPath(),
h=b.negativeColor;h&&c.push(["graphNeg",h]);p(c,function(c,h){var k=c[0],l=a[k];if(l)bb(l),l.animate({d:g});else if(d&&g.length)l={stroke:c[1],"stroke-width":d,fill:N,zIndex:1},e?l.dashstyle=e:f&&(l["stroke-linecap"]=l["stroke-linejoin"]="round"),a[k]=a.chart.renderer.path(g).attr(l).add(a.group).shadow(!h&&b.shadow)})},clipNeg:function(){var a=this.options,b=this.chart,c=b.renderer,d=a.negativeColor||a.negativeFillColor,e,f=this.graph,g=this.area,h=this.posClip,i=this.negClip;e=b.chartWidth;var j=
b.chartHeight,k=v(e,j),l=this.yAxis;if(d&&(f||g)){d=u(l.toPixels(a.threshold||0,!0));d<0&&(k-=d);a={x:0,y:0,width:k,height:d};k={x:0,y:d,width:k,height:k};if(b.inverted)a.height=k.y=b.plotWidth-d,c.isVML&&(a={x:b.plotWidth-d-b.plotLeft,y:0,width:e,height:j},k={x:d+b.plotLeft-e,y:0,width:b.plotLeft+d,height:e});l.reversed?(b=k,e=a):(b=a,e=k);h?(h.animate(b),i.animate(e)):(this.posClip=h=c.clipRect(b),this.negClip=i=c.clipRect(e),f&&this.graphNeg&&(f.clip(h),this.graphNeg.clip(i)),g&&(g.clip(h),this.areaNeg.clip(i)))}},
invertGroups:function(){function a(){var a={width:b.yAxis.len,height:b.xAxis.len};p(["group","markerGroup"],function(c){b[c]&&b[c].attr(a).invert()})}var b=this,c=b.chart;if(b.xAxis)K(c,"resize",a),K(b,"destroy",function(){W(c,"resize",a)}),a(),b.invertGroups=a},plotGroup:function(a,b,c,d,e){var f=this[a],g=!f;g&&(this[a]=f=this.chart.renderer.g(b).attr({visibility:c,zIndex:d||0.1}).add(e));f[g?"attr":"animate"](this.getPlotBox());return f},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;
if(a.inverted)b=c,c=this.xAxis;return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,e=(c=d.animation)&&!!a.animate&&b.renderer.isSVG&&m(c.duration,500)||0,f=a.visible?"visible":"hidden",g=d.zIndex,h=a.hasRendered,i=b.seriesGroup;c=a.plotGroup("group","series",f,g,i);a.markerGroup=a.plotGroup("markerGroup","markers",f,g,i);e&&a.animate(!0);a.getAttribs();c.inverted=a.isCartesian?b.inverted:!1;a.drawGraph&&(a.drawGraph(),
a.clipNeg());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&a.options.enableMouseTracking!==!1&&a.drawTracker();b.inverted&&a.invertGroups();d.clip!==!1&&!a.sharedClipKey&&!h&&c.clip(b.clipRect);e&&a.animate();if(!h)e?a.animationTimeout=setTimeout(function(){a.afterAnimate()},e):a.afterAnimate();a.isDirty=a.isDirtyData=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirtyData,c=this.group,d=this.xAxis,e=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,
height:a.plotHeight}),c.animate({translateX:m(d&&d.left,a.plotLeft),translateY:m(e&&e.top,a.plotTop)}));this.translate();this.setTooltipPoints&&this.setTooltipPoints(!0);this.render();b&&E(this,"updatedData")}};Hb.prototype={destroy:function(){Oa(this,this.axis)},render:function(a){var b=this.options,c=b.format,c=c?Ia(c,this):b.formatter.call(this);this.label?this.label.attr({text:c,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(c,null,null,b.useHTML).css(b.style).attr({align:this.textAlign,
rotation:b.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,b){var c=this.axis,d=c.chart,e=d.inverted,f=this.isNegative,g=c.translate(c.usePercentage?100:this.total,0,0,0,1),c=c.translate(0),c=O(g-c),h=d.xAxis[0].translate(this.x)+a,i=d.plotHeight,f={x:e?f?g:g-c:h,y:e?i-h-b:f?i-g-c:i-g,width:e?c:b,height:e?b:c};if(e=this.label)e.align(this.alignOptions,null,f),f=e.alignAttr,e[this.options.crop===!1||d.isInsidePlot(f.x,f.y)?"show":"hide"](!0)}};la.prototype.buildStacks=function(){var a=
this.series,b=m(this.options.reversedStacks,!0),c=a.length;if(!this.isXAxis){for(this.usePercentage=!1;c--;)a[b?c:a.length-c-1].setStackedPoints();if(this.usePercentage)for(c=0;c<a.length;c++)a[c].setPercentStacks()}};la.prototype.renderStackTotals=function(){var a=this.chart,b=a.renderer,c=this.stacks,d,e,f=this.stackTotalGroup;if(!f)this.stackTotalGroup=f=b.g("stack-labels").attr({visibility:"visible",zIndex:6}).add();f.translate(a.plotLeft,a.plotTop);for(d in c)for(e in a=c[d],a)a[e].render(f)};
M.prototype.setStackedPoints=function(){if(this.options.stacking&&!(this.visible!==!0&&this.chart.options.chart.ignoreHiddenSeries!==!1)){var a=this.processedXData,b=this.processedYData,c=[],d=b.length,e=this.options,f=e.threshold,g=e.stack,e=e.stacking,h=this.stackKey,i="-"+h,j=this.negStacks,k=this.yAxis,l=k.stacks,o=k.oldStacks,n,m,p,q,r,u;for(q=0;q<d;q++){r=a[q];u=b[q];p=this.index+","+q;m=(n=j&&u<f)?i:h;l[m]||(l[m]={});if(!l[m][r])o[m]&&o[m][r]?(l[m][r]=o[m][r],l[m][r].total=null):l[m][r]=new Hb(k,
k.options.stackLabels,n,r,g);m=l[m][r];m.points[p]=[m.cum||0];e==="percent"?(n=n?h:i,j&&l[n]&&l[n][r]?(n=l[n][r],m.total=n.total=v(n.total,m.total)+O(u)||0):m.total=da(m.total+(O(u)||0))):m.total=da(m.total+(u||0));m.cum=(m.cum||0)+(u||0);m.points[p].push(m.cum);c[q]=m.cum}if(e==="percent")k.usePercentage=!0;this.stackedYData=c;k.oldStacks={}}};M.prototype.setPercentStacks=function(){var a=this,b=a.stackKey,c=a.yAxis.stacks,d=a.processedXData;p([b,"-"+b],function(b){var e;for(var f=d.length,g,h;f--;)if(g=
d[f],e=(h=c[b]&&c[b][g])&&h.points[a.index+","+f],g=e)h=h.total?100/h.total:0,g[0]=da(g[0]*h),g[1]=da(g[1]*h),a.stackedYData[f]=g[1]})};q(Ya.prototype,{addSeries:function(a,b,c){var d,e=this;a&&(b=m(b,!0),E(e,"addSeries",{options:a},function(){d=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();b&&e.redraw(c)}));return d},addAxis:function(a,b,c,d){var e=b?"xAxis":"yAxis",f=this.options;new la(this,w(a,{index:this[e].length,isX:b}));f[e]=qa(f[e]||{});f[e].push(a);m(c,!0)&&this.redraw(d)},showLoading:function(a){var b=
this.options,c=this.loadingDiv,d=b.loading;if(!c)this.loadingDiv=c=Y(Ja,{className:"highcharts-loading"},q(d.style,{zIndex:10,display:N}),this.container),this.loadingSpan=Y("span",null,d.labelStyle,c);this.loadingSpan.innerHTML=a||b.lang.loading;if(!this.loadingShown)D(c,{opacity:0,display:"",left:this.plotLeft+"px",top:this.plotTop+"px",width:this.plotWidth+"px",height:this.plotHeight+"px"}),kb(c,{opacity:d.style.opacity},{duration:d.showDuration||0}),this.loadingShown=!0},hideLoading:function(){var a=
this.options,b=this.loadingDiv;b&&kb(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){D(b,{display:N})}});this.loadingShown=!1}});q(Ea.prototype,{update:function(a,b,c){var d=this,e=d.series,f=d.graphic,g,h=e.data,i=e.chart,j=e.options,b=m(b,!0);d.firePointEvent("update",{options:a},function(){d.applyOptions(a);if(ca(a)){e.getAttribs();if(f)a&&a.marker&&a.marker.symbol?d.graphic=f.destroy():f.attr(d.pointAttr[d.state||""]);if(a&&a.dataLabels&&d.dataLabel)d.dataLabel=d.dataLabel.destroy()}g=
Da(d,h);e.updateParallelArrays(d,g);j.data[g]=d.options;e.isDirty=e.isDirtyData=!0;if(!e.fixedBox&&e.hasCartesianSeries)i.isDirtyBox=!0;j.legendType==="point"&&i.legend.destroyItem(d);b&&i.redraw(c)})},remove:function(a,b){var c=this,d=c.series,e=d.points,f=d.chart,g,h=d.data;Qa(b,f);a=m(a,!0);c.firePointEvent("remove",null,function(){g=Da(c,h);h.length===e.length&&e.splice(g,1);h.splice(g,1);d.options.data.splice(g,1);d.updateParallelArrays(c,"splice",g,1);c.destroy();d.isDirty=!0;d.isDirtyData=
!0;a&&f.redraw()})}});q(M.prototype,{addPoint:function(a,b,c,d){var e=this.options,f=this.data,g=this.graph,h=this.area,i=this.chart,j=this.xAxis&&this.xAxis.names,k=g&&g.shift||0,l=e.data,o,n=this.xData;Qa(d,i);c&&p([g,h,this.graphNeg,this.areaNeg],function(a){if(a)a.shift=k+1});if(h)h.isArea=!0;b=m(b,!0);d={series:this};this.pointClass.prototype.applyOptions.apply(d,[a]);g=d.x;h=n.length;if(this.requireSorting&&g<n[h-1])for(o=!0;h&&n[h-1]>g;)h--;this.updateParallelArrays(d,"splice",h,0,0);this.updateParallelArrays(d,
h);if(j)j[g]=d.name;l.splice(h,0,a);o&&(this.data.splice(h,0,null),this.processData());e.legendType==="point"&&this.generatePoints();c&&(f[0]&&f[0].remove?f[0].remove(!1):(f.shift(),this.updateParallelArrays(d,"shift"),l.shift()));this.isDirtyData=this.isDirty=!0;b&&(this.getAttribs(),i.redraw())},remove:function(a,b){var c=this,d=c.chart,a=m(a,!0);if(!c.isRemoving)c.isRemoving=!0,E(c,"remove",null,function(){c.destroy();d.isDirtyLegend=d.isDirtyBox=!0;d.linkSeries();a&&d.redraw(b)});c.isRemoving=
!1},update:function(a,b){var c=this.chart,d=this.type,e=G[d].prototype,f,a=w(this.userOptions,{animation:!1,index:this.index,pointStart:this.xData[0]},{data:this.options.data},a);this.remove(!1);for(f in e)e.hasOwnProperty(f)&&(this[f]=t);q(this,G[a.type||d].prototype);this.init(c,a);m(b,!0)&&c.redraw(!1)}});q(la.prototype,{update:function(a,b){var c=this.chart,a=c.options[this.coll][this.options.index]=w(this.userOptions,a);this.destroy(!0);this._addedPlotLB=t;this.init(c,q(a,{events:t}));c.isDirtyBox=
!0;m(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,d=this.series,e=d.length;e--;)d[e]&&d[e].remove(!1);ja(b.axes,this);ja(b[c],this);b.options[c].splice(this.options.index,1);p(b[c],function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;m(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}});ga=ka(M);G.line=ga;ba.area=w(P,{threshold:0});var pa=ka(M,{type:"area",getSegments:function(){var a=
[],b=[],c=[],d=this.xAxis,e=this.yAxis,f=e.stacks[this.stackKey],g={},h,i,j=this.points,k=this.options.connectNulls,l,o,n;if(this.options.stacking&&!this.cropped){for(o=0;o<j.length;o++)g[j[o].x]=j[o];for(n in f)f[n].total!==null&&c.push(+n);c.sort(function(a,b){return a-b});p(c,function(a){if(!k||g[a]&&g[a].y!==null)g[a]?b.push(g[a]):(h=d.translate(a),l=f[a].percent?f[a].total?f[a].cum*100/f[a].total:0:f[a].cum,i=e.toPixels(l,!0),b.push({y:null,plotX:h,clientX:h,plotY:i,yBottom:i,onMouseOver:sa}))});
b.length&&a.push(b)}else M.prototype.getSegments.call(this),a=this.segments;this.segments=a},getSegmentPath:function(a){var b=M.prototype.getSegmentPath.call(this,a),c=[].concat(b),d,e=this.options;d=b.length;var f=this.yAxis.getThreshold(e.threshold),g;d===3&&c.push("L",b[1],b[2]);if(e.stacking&&!this.closedStacks)for(d=a.length-1;d>=0;d--)g=m(a[d].yBottom,f),d<a.length-1&&e.step&&c.push(a[d+1].plotX,g),c.push(a[d].plotX,g);else this.closeSegment(c,a,f);this.areaPath=this.areaPath.concat(c);return b},
closeSegment:function(a,b,c){a.push("L",b[b.length-1].plotX,c,"L",b[0].plotX,c)},drawGraph:function(){this.areaPath=[];M.prototype.drawGraph.apply(this);var a=this,b=this.areaPath,c=this.options,d=c.negativeColor,e=c.negativeFillColor,f=[["area",this.color,c.fillColor]];(d||e)&&f.push(["areaNeg",d,e]);p(f,function(d){var e=d[0],f=a[e];f?f.animate({d:b}):a[e]=a.chart.renderer.path(b).attr({fill:m(d[2],ya(d[1]).setOpacity(m(c.fillOpacity,0.75)).get()),zIndex:0}).add(a.group)})},drawLegendSymbol:L.drawRectangle});
G.area=pa;ba.spline=w(P);ga=ka(M,{type:"spline",getPointSpline:function(a,b,c){var d=b.plotX,e=b.plotY,f=a[c-1],g=a[c+1],h,i,j,k;if(f&&g){a=f.plotY;j=g.plotX;var g=g.plotY,l;h=(1.5*d+f.plotX)/2.5;i=(1.5*e+a)/2.5;j=(1.5*d+j)/2.5;k=(1.5*e+g)/2.5;l=(k-i)*(j-d)/(j-h)+e-k;i+=l;k+=l;i>a&&i>e?(i=v(a,e),k=2*e-i):i<a&&i<e&&(i=C(a,e),k=2*e-i);k>g&&k>e?(k=v(g,e),i=2*e-k):k<g&&k<e&&(k=C(g,e),i=2*e-k);b.rightContX=j;b.rightContY=k}c?(b=["C",f.rightContX||f.plotX,f.rightContY||f.plotY,h||d,i||e,d,e],f.rightContX=
f.rightContY=null):b=["M",d,e];return b}});G.spline=ga;ba.areaspline=w(ba.area);pa=pa.prototype;ga=ka(ga,{type:"areaspline",closedStacks:!0,getSegmentPath:pa.getSegmentPath,closeSegment:pa.closeSegment,drawGraph:pa.drawGraph,drawLegendSymbol:L.drawRectangle});G.areaspline=ga;ba.column=w(P,{borderColor:"#FFFFFF",borderRadius:0,groupPadding:0.2,marker:null,pointPadding:0.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{brightness:0.1,shadow:!1,halo:!1},select:{color:"#C0C0C0",borderColor:"#000000",
shadow:!1}},dataLabels:{align:null,verticalAlign:null,y:null},stickyTracking:!1,tooltip:{distance:6},threshold:0});ga=ka(M,{type:"column",pointAttrToOptions:{stroke:"borderColor",fill:"color",r:"borderRadius"},cropShoulder:0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){M.prototype.init.apply(this,arguments);var a=this,b=a.chart;b.hasRendered&&p(b.series,function(b){if(b.type===a.type)b.isDirty=!0})},getColumnMetrics:function(){var a=this,b=a.options,c=a.xAxis,d=a.yAxis,e=
c.reversed,f,g={},h,i=0;b.grouping===!1?i=1:p(a.chart.series,function(b){var c=b.options,e=b.yAxis;if(b.type===a.type&&b.visible&&d.len===e.len&&d.pos===e.pos)c.stacking?(f=b.stackKey,g[f]===t&&(g[f]=i++),h=g[f]):c.grouping!==!1&&(h=i++),b.columnIndex=h});var c=C(O(c.transA)*(c.ordinalSlope||b.pointRange||c.closestPointRange||c.tickInterval||1),c.len),j=c*b.groupPadding,k=(c-2*j)/i,l=b.pointWidth,b=r(l)?(k-l)/2:k*b.pointPadding,l=m(l,k-2*b);return a.columnMetrics={width:l,offset:b+(j+((e?i-(a.columnIndex||
0):a.columnIndex)||0)*k-c/2)*(e?-1:1)}},translate:function(){var a=this,b=a.chart,c=a.options,d=a.borderWidth=m(c.borderWidth,a.activePointCount>0.5*a.xAxis.len?0:1),e=a.yAxis,f=a.translatedThreshold=e.getThreshold(c.threshold),g=m(c.minPointLength,5),c=a.getColumnMetrics(),h=c.width,i=a.barW=Ka(v(h,1+2*d)),j=a.pointXOffset=c.offset,k=-(d%2?0.5:0),l=d%2?0.5:1;b.renderer.isVML&&b.inverted&&(l+=1);M.prototype.translate.apply(a);p(a.points,function(c){var d=m(c.yBottom,f),p=C(v(-999-d,c.plotY),e.len+
999+d),q=c.plotX+j,r=i,t=C(p,d),x;x=v(p,d)-t;O(x)<g&&g&&(x=g,t=u(O(t-f)>g?d-g:f-(e.translate(c.y,0,1,0,1)<=f?g:0)));c.barX=q;c.pointWidth=h;c.tooltipPos=b.inverted?[e.len-p,a.xAxis.len-q-r/2]:[q+r/2,p];d=O(q)<0.5;r=u(q+r)+k;q=u(q)+k;r-=q;p=O(t)<0.5;x=u(t+x)+l;t=u(t)+l;x-=t;d&&(q+=1,r-=1);p&&(t-=1,x+=1);c.shapeType="rect";c.shapeArgs={x:q,y:t,width:r,height:x}})},getSymbol:sa,drawLegendSymbol:L.drawRectangle,drawGraph:sa,drawPoints:function(){var a=this,b=this.chart,c=a.options,d=b.renderer,e=c.animationLimit||
250,f,g,h;p(a.points,function(i){var j=i.plotY,k=i.graphic;if(j!==t&&!isNaN(j)&&i.y!==null)f=i.shapeArgs,h=r(a.borderWidth)?{"stroke-width":a.borderWidth}:{},g=i.pointAttr[i.selected?"select":""]||a.pointAttr[""],k?(bb(k),k.attr(h)[b.pointCount<e?"animate":"attr"](w(f))):i.graphic=d[i.shapeType](f).attr(g).attr(h).add(a.group).shadow(c.shadow,null,c.stacking&&!c.borderRadius);else if(k)i.graphic=k.destroy()})},animate:function(a){var b=this.yAxis,c=this.options,d=this.chart.inverted,e={};if(aa)a?
(e.scaleY=0.001,a=C(b.pos+b.len,v(b.pos,b.toPixels(c.threshold))),d?e.translateX=a-b.len:e.translateY=a,this.group.attr(e)):(e.scaleY=1,e[d?"translateX":"translateY"]=b.pos,this.group.animate(e,this.options.animation),this.animate=null)},remove:function(){var a=this,b=a.chart;b.hasRendered&&p(b.series,function(b){if(b.type===a.type)b.isDirty=!0});M.prototype.remove.apply(a,arguments)}});G.column=ga;ba.bar=w(ba.column);pa=ka(ga,{type:"bar",inverted:!0});G.bar=pa;ba.scatter=w(P,{lineWidth:0,tooltip:{headerFormat:'<span style="color:{series.color}">●</span> <span style="font-size: 10px;"> {series.name}</span><br/>',
pointFormat:"x: <b>{point.x}</b><br/>y: <b>{point.y}</b><br/>"},stickyTracking:!1});pa=ka(M,{type:"scatter",sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["markerGroup"],takeOrdinalPosition:!1,singularTooltips:!0,drawGraph:function(){this.options.lineWidth&&M.prototype.drawGraph.call(this)}});G.scatter=pa;ba.pie=w(P,{borderColor:"#FFFFFF",borderWidth:1,center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,format:"{point.name}"},ignoreHiddenPoint:!0,legendType:"point",
marker:null,size:null,showInLegend:!1,slicedOffset:10,states:{hover:{brightness:0.1,shadow:!1}},stickyTracking:!1,tooltip:{followPointer:!0}});P={type:"pie",isCartesian:!1,pointClass:ka(Ea,{init:function(){Ea.prototype.init.apply(this,arguments);var a=this,b;if(a.y<0)a.y=null;q(a,{visible:a.visible!==!1,name:m(a.name,"Slice")});b=function(b){a.slice(b.type==="select")};K(a,"select",b);K(a,"unselect",b);return a},setVisible:function(a){var b=this,c=b.series,d=c.chart;b.visible=b.options.visible=a=
a===t?!b.visible:a;c.options.data[Da(b,c.data)]=b.options;p(["graphic","dataLabel","connector","shadowGroup"],function(c){if(b[c])b[c][a?"show":"hide"](!0)});b.legendItem&&d.legend.colorizeItem(b,a);if(!c.isDirty&&c.options.ignoreHiddenPoint)c.isDirty=!0,d.redraw()},slice:function(a,b,c){var d=this.series;Qa(c,d.chart);m(b,!0);this.sliced=this.options.sliced=a=r(a)?a:!this.sliced;d.options.data[Da(this,d.data)]=this.options;a=a?this.slicedTranslation:{translateX:0,translateY:0};this.graphic.animate(a);
this.shadowGroup&&this.shadowGroup.animate(a)},haloPath:function(a){var b=this.shapeArgs,c=this.series.chart;return this.series.chart.renderer.symbols.arc(c.plotLeft+b.x,c.plotTop+b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,start:b.start,end:b.end})}}),requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttrToOptions:{stroke:"borderColor","stroke-width":"borderWidth",fill:"color"},singularTooltips:!0,getColor:sa,animate:function(a){var b=this,c=b.points,d=
b.startAngleRad;if(!a)p(c,function(a){var c=a.graphic,a=a.shapeArgs;c&&(c.attr({r:b.center[3]/2,start:d,end:d}),c.animate({r:a.r,start:a.start,end:a.end},b.options.animation))}),b.animate=null},setData:function(a,b,c,d){M.prototype.setData.call(this,a,!1,c,d);this.processData();this.generatePoints();m(b,!0)&&this.chart.redraw(c)},generatePoints:function(){var a,b=0,c,d,e,f=this.options.ignoreHiddenPoint;M.prototype.generatePoints.call(this);c=this.points;d=c.length;for(a=0;a<d;a++)e=c[a],b+=f&&!e.visible?
0:e.y;this.total=b;for(a=0;a<d;a++)e=c[a],e.percentage=b>0?e.y/b*100:0,e.total=b},translate:function(a){this.generatePoints();var b=0,c=this.options,d=c.slicedOffset,e=d+c.borderWidth,f,g,h,i=c.startAngle||0,j=this.startAngleRad=ma/180*(i-90),i=(this.endAngleRad=ma/180*(m(c.endAngle,i+360)-90))-j,k=this.points,l=c.dataLabels.distance,c=c.ignoreHiddenPoint,o,n=k.length,p;if(!a)this.center=a=this.getCenter();this.getX=function(b,c){h=T.asin(C((b-a[1])/(a[2]/2+l),1));return a[0]+(c?-1:1)*Z(h)*(a[2]/
2+l)};for(o=0;o<n;o++){p=k[o];f=j+b*i;if(!c||p.visible)b+=p.percentage/100;g=j+b*i;p.shapeType="arc";p.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:u(f*1E3)/1E3,end:u(g*1E3)/1E3};h=(g+f)/2;h>1.5*ma?h-=2*ma:h<-ma/2&&(h+=2*ma);p.slicedTranslation={translateX:u(Z(h)*d),translateY:u(ea(h)*d)};f=Z(h)*a[2]/2;g=ea(h)*a[2]/2;p.tooltipPos=[a[0]+f*0.7,a[1]+g*0.7];p.half=h<-ma/2||h>ma/2?1:0;p.angle=h;e=C(e,l/2);p.labelPos=[a[0]+f+Z(h)*l,a[1]+g+ea(h)*l,a[0]+f+Z(h)*e,a[1]+g+ea(h)*e,a[0]+f,a[1]+g,l<0?
"center":p.half?"right":"left",h]}},drawGraph:null,drawPoints:function(){var a=this,b=a.chart.renderer,c,d,e=a.options.shadow,f,g;if(e&&!a.shadowGroup)a.shadowGroup=b.g("shadow").add(a.group);p(a.points,function(h){d=h.graphic;g=h.shapeArgs;f=h.shadowGroup;if(e&&!f)f=h.shadowGroup=b.g("shadow").add(a.shadowGroup);c=h.sliced?h.slicedTranslation:{translateX:0,translateY:0};f&&f.attr(c);d?d.animate(q(g,c)):h.graphic=d=b[h.shapeType](g).setRadialReference(a.center).attr(h.pointAttr[h.selected?"select":
""]).attr({"stroke-linejoin":"round"}).attr(c).add(a.group).shadow(e,f);h.visible!==void 0&&h.setVisible(h.visible)})},sortByAngle:function(a,b){a.sort(function(a,d){return a.angle!==void 0&&(d.angle-a.angle)*b})},drawLegendSymbol:L.drawRectangle,getCenter:X.getCenter,getSymbol:sa};P=ka(M,P);G.pie=P;M.prototype.drawDataLabels=function(){var a=this,b=a.options,c=b.cursor,d=b.dataLabels,e=a.points,f,g,h,i;if(d.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(d),i=a.plotGroup("dataLabelsGroup",
"data-labels","hidden",d.zIndex||6),!a.hasRendered&&m(d.defer,!0)&&(i.attr({opacity:0}),K(a,"afterAnimate",function(){a.dataLabelsGroup.show()[b.animation?"animate":"attr"]({opacity:1},{duration:200})})),g=d,p(e,function(b){var e,l=b.dataLabel,o,n,p=b.connector,u=!0;f=b.options&&b.options.dataLabels;e=m(f&&f.enabled,g.enabled);if(l&&!e)b.dataLabel=l.destroy();else if(e){d=w(g,f);e=d.rotation;o=b.getLabelConfig();h=d.format?Ia(d.format,o):d.formatter.call(o,d);d.style.color=m(d.color,d.style.color,
a.color,"black");if(l)if(r(h))l.attr({text:h}),u=!1;else{if(b.dataLabel=l=l.destroy(),p)b.connector=p.destroy()}else if(r(h)){l={fill:d.backgroundColor,stroke:d.borderColor,"stroke-width":d.borderWidth,r:d.borderRadius||0,rotation:e,padding:d.padding,zIndex:1};for(n in l)l[n]===t&&delete l[n];l=b.dataLabel=a.chart.renderer[e?"text":"label"](h,0,-999,null,null,null,d.useHTML).attr(l).css(q(d.style,c&&{cursor:c})).add(i).shadow(d.shadow)}l&&a.alignDataLabel(b,l,d,null,u)}})};M.prototype.alignDataLabel=
function(a,b,c,d,e){var f=this.chart,g=f.inverted,h=m(a.plotX,-999),i=m(a.plotY,-999),j=b.getBBox();if(a=this.visible&&(a.series.forceDL||f.isInsidePlot(h,u(i),g)||d&&f.isInsidePlot(h,g?d.x+1:d.y+d.height-1,g)))d=q({x:g?f.plotWidth-i:h,y:u(g?f.plotHeight-h:i),width:0,height:0},d),q(c,{width:j.width,height:j.height}),c.rotation?(g={align:c.align,x:d.x+c.x+d.width/2,y:d.y+c.y+d.height/2},b[e?"attr":"animate"](g)):(b.align(c,null,d),g=b.alignAttr,m(c.overflow,"justify")==="justify"?this.justifyDataLabel(b,
c,g,j,d,e):m(c.crop,!0)&&(a=f.isInsidePlot(g.x,g.y)&&f.isInsidePlot(g.x+j.width,g.y+j.height)));if(!a)b.attr({y:-999}),b.placed=!1};M.prototype.justifyDataLabel=function(a,b,c,d,e,f){var g=this.chart,h=b.align,i=b.verticalAlign,j,k;j=c.x;if(j<0)h==="right"?b.align="left":b.x=-j,k=!0;j=c.x+d.width;if(j>g.plotWidth)h==="left"?b.align="right":b.x=g.plotWidth-j,k=!0;j=c.y;if(j<0)i==="bottom"?b.verticalAlign="top":b.y=-j,k=!0;j=c.y+d.height;if(j>g.plotHeight)i==="top"?b.verticalAlign="bottom":b.y=g.plotHeight-
j,k=!0;if(k)a.placed=!f,a.align(b,null,e)};if(G.pie)G.pie.prototype.drawDataLabels=function(){var a=this,b=a.data,c,d=a.chart,e=a.options.dataLabels,f=m(e.connectorPadding,10),g=m(e.connectorWidth,1),h=d.plotWidth,d=d.plotHeight,i,j,k=m(e.softConnector,!0),l=e.distance,o=a.center,n=o[2]/2,q=o[1],r=l>0,t,w,x,y,A=[[],[]],z,C,G,D,B,E=[0,0,0,0],L=function(a,b){return b.y-a.y};if(a.visible&&(e.enabled||a._hasPointLabels)){M.prototype.drawDataLabels.apply(a);p(b,function(a){a.dataLabel&&a.visible&&A[a.half].push(a)});
for(D=0;!y&&b[D];)y=b[D]&&b[D].dataLabel&&(b[D].dataLabel.getBBox().height||21),D++;for(D=2;D--;){var b=[],K=[],H=A[D],I=H.length,F;a.sortByAngle(H,D-0.5);if(l>0){for(B=q-n-l;B<=q+n+l;B+=y)b.push(B);w=b.length;if(I>w){c=[].concat(H);c.sort(L);for(B=I;B--;)c[B].rank=B;for(B=I;B--;)H[B].rank>=w&&H.splice(B,1);I=H.length}for(B=0;B<I;B++){c=H[B];x=c.labelPos;c=9999;var P,N;for(N=0;N<w;N++)P=O(b[N]-x[1]),P<c&&(c=P,F=N);if(F<B&&b[B]!==null)F=B;else for(w<I-B+F&&b[B]!==null&&(F=w-I+B);b[F]===null;)F++;K.push({i:F,
y:b[F]});b[F]=null}K.sort(L)}for(B=0;B<I;B++){c=H[B];x=c.labelPos;t=c.dataLabel;G=c.visible===!1?"hidden":"visible";c=x[1];if(l>0){if(w=K.pop(),F=w.i,C=w.y,c>C&&b[F+1]!==null||c<C&&b[F-1]!==null)C=c}else C=c;z=e.justify?o[0]+(D?-1:1)*(n+l):a.getX(F===0||F===b.length-1?c:C,D);t._attr={visibility:G,align:x[6]};t._pos={x:z+e.x+({left:f,right:-f}[x[6]]||0),y:C+e.y-10};t.connX=z;t.connY=C;if(this.options.size===null)w=t.width,z-w<f?E[3]=v(u(w-z+f),E[3]):z+w>h-f&&(E[1]=v(u(z+w-h+f),E[1])),C-y/2<0?E[0]=
v(u(-C+y/2),E[0]):C+y/2>d&&(E[2]=v(u(C+y/2-d),E[2]))}}if(Ba(E)===0||this.verifyDataLabelOverflow(E))this.placeDataLabels(),r&&g&&p(this.points,function(b){i=b.connector;x=b.labelPos;if((t=b.dataLabel)&&t._pos)G=t._attr.visibility,z=t.connX,C=t.connY,j=k?["M",z+(x[6]==="left"?5:-5),C,"C",z,C,2*x[2]-x[4],2*x[3]-x[5],x[2],x[3],"L",x[4],x[5]]:["M",z+(x[6]==="left"?5:-5),C,"L",x[2],x[3],"L",x[4],x[5]],i?(i.animate({d:j}),i.attr("visibility",G)):b.connector=i=a.chart.renderer.path(j).attr({"stroke-width":g,
stroke:e.connectorColor||b.color||"#606060",visibility:G}).add(a.dataLabelsGroup);else if(i)b.connector=i.destroy()})}},G.pie.prototype.placeDataLabels=function(){p(this.points,function(a){var a=a.dataLabel,b;if(a)(b=a._pos)?(a.attr(a._attr),a[a.moved?"animate":"attr"](b),a.moved=!0):a&&a.attr({y:-999})})},G.pie.prototype.alignDataLabel=sa,G.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,d=c.center,e=c=c.minSize||80,f;d[0]!==null?e=v(b[2]-v(a[1],a[3]),c):(e=v(b[2]-
a[1]-a[3],c),b[0]+=(a[3]-a[1])/2);d[1]!==null?e=v(C(e,b[2]-v(a[0],a[2])),c):(e=v(C(e,b[2]-a[0]-a[2]),c),b[1]+=(a[0]-a[2])/2);e<b[2]?(b[2]=e,this.translate(b),p(this.points,function(a){if(a.dataLabel)a.dataLabel._pos=null}),this.drawDataLabels&&this.drawDataLabels()):f=!0;return f};if(G.column)G.column.prototype.alignDataLabel=function(a,b,c,d,e){var f=this.chart,g=f.inverted,h=a.dlBox||a.shapeArgs,i=a.below||a.plotY>m(this.translatedThreshold,f.plotSizeY),j=m(c.inside,!!this.options.stacking);if(h&&
(d=w(h),g&&(d={x:f.plotWidth-d.y-d.height,y:f.plotHeight-d.x-d.width,width:d.height,height:d.width}),!j))g?(d.x+=i?0:d.width,d.width=0):(d.y+=i?d.height:0,d.height=0);c.align=m(c.align,!g||j?"center":i?"right":"left");c.verticalAlign=m(c.verticalAlign,g||j?"middle":i?"top":"bottom");M.prototype.alignDataLabel.call(this,a,b,c,d,e)};P=R.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,c=b.pointer,d=a.options.cursor,e=d&&{cursor:d},f=function(c){var d=c.target,e;if(b.hoverSeries!==a)a.onMouseOver();
for(;d&&!e;)e=d.point,d=d.parentNode;if(e!==t&&e!==b.hoverPoint)e.onMouseOver(c)};p(a.points,function(a){if(a.graphic)a.graphic.element.point=a;if(a.dataLabel)a.dataLabel.element.point=a});if(!a._hasTracking)p(a.trackerGroups,function(b){if(a[b]&&(a[b].addClass("highcharts-tracker").on("mouseover",f).on("mouseout",function(a){c.onTrackerMouseOut(a)}).css(e),$a))a[b].on("touchstart",f)}),a._hasTracking=!0},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:
a.graphPath),e=d.length,f=a.chart,g=f.pointer,h=f.renderer,i=f.options.tooltip.snap,j=a.tracker,k=b.cursor,l=k&&{cursor:k},k=a.singlePoints,m,n=function(){if(f.hoverSeries!==a)a.onMouseOver()},q="rgba(192,192,192,"+(aa?1.0E-4:0.002)+")";if(e&&!c)for(m=e+1;m--;)d[m]==="M"&&d.splice(m+1,0,d[m+1]-i,d[m+2],"L"),(m&&d[m]==="M"||m===e)&&d.splice(m,0,"L",d[m-2]+i,d[m-1]);for(m=0;m<k.length;m++)e=k[m],d.push("M",e.plotX-i,e.plotY,"L",e.plotX+i,e.plotY);j?j.attr({d:d}):(a.tracker=h.path(d).attr({"stroke-linejoin":"round",
visibility:a.visible?"visible":"hidden",stroke:q,fill:c?q:N,"stroke-width":b.lineWidth+(c?0:2*i),zIndex:2}).add(a.group),p([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",n).on("mouseout",function(a){g.onTrackerMouseOut(a)}).css(l);if($a)a.on("touchstart",n)}))}};if(G.column)ga.prototype.drawTracker=P.drawTrackerPoint;if(G.pie)G.pie.prototype.drawTracker=P.drawTrackerPoint;if(G.scatter)pa.prototype.drawTracker=P.drawTrackerPoint;if(G.gauge)G.gauge.prototype.drawTracker=
P.drawTrackerPoint;q(lb.prototype,{setItemEvents:function(a,b,c,d,e){var f=this;(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");b.css(f.options.itemHoverStyle)}).on("mouseout",function(){b.css(a.visible?d:e);a.setState()}).on("click",function(b){var c=function(){a.setVisible()},b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):E(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=Y("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},
this.options.itemCheckboxStyle,this.chart.container);K(a.checkbox,"click",function(b){E(a,"checkboxClick",{checked:b.target.checked},function(){a.select()})})}});F.legend.itemStyle.cursor="pointer";q(Ya.prototype,{showResetZoom:function(){var a=this,b=F.lang,c=a.options.chart.resetZoomButton,d=c.theme,e=d.states,f=c.relativeTo==="chart"?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,e&&e.hover).attr({align:c.position.align,title:b.resetZoomTitle}).add().align(c.position,
!1,f)},zoomOut:function(){var a=this;E(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,c=this.pointer,d=!1,e;!a||a.resetSelection?p(this.axes,function(a){b=a.zoom()}):p(a.xAxis.concat(a.yAxis),function(a){var e=a.axis,h=e.isXAxis;if(c[h?"zoomX":"zoomY"]||c[h?"pinchX":"pinchY"])b=e.zoom(a.min,a.max),e.displayBtn&&(d=!0)});e=this.resetZoomButton;if(d&&!e)this.showResetZoom();else if(!d&&ca(e))this.resetZoomButton=e.destroy();b&&this.redraw(m(this.options.chart.animation,
a&&a.animation,this.pointCount<100))},pan:function(a,b){var c=this,d=c.hoverPoints,e;d&&p(d,function(a){a.setState()});p(b==="xy"?[1,0]:[1],function(b){var d=a[b?"chartX":"chartY"],h=c[b?"xAxis":"yAxis"][0],i=c[b?"mouseDownX":"mouseDownY"],j=(h.pointRange||0)/2,k=h.getExtremes(),l=h.toValue(i-d,!0)+j,i=h.toValue(i+c[b?"plotWidth":"plotHeight"]-d,!0)-j;h.series.length&&l>C(k.dataMin,k.min)&&i<v(k.dataMax,k.max)&&(h.setExtremes(l,i,!1,!1,{trigger:"pan"}),e=!0);c[b?"mouseDownX":"mouseDownY"]=d});e&&
c.redraw(!1);D(c.container,{cursor:"move"})}});q(Ea.prototype,{select:function(a,b){var c=this,d=c.series,e=d.chart,a=m(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[Da(c,d.data)]=c.options;c.setState(a&&"select");b||p(e.getSelectedPoints(),function(a){if(a.selected&&a!==c)a.selected=a.options.selected=!1,d.options.data[Da(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect")})})},onMouseOver:function(a){var b=
this.series,c=b.chart,d=c.tooltip,e=c.hoverPoint;if(e&&e!==this)e.onMouseOut();this.firePointEvent("mouseOver");d&&(!d.shared||b.noSharedTooltip)&&d.refresh(this,a);this.setState("hover");c.hoverPoint=this},onMouseOut:function(){var a=this.series.chart,b=a.hoverPoints;if(!b||Da(this,b)===-1)this.firePointEvent("mouseOut"),this.setState(),a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var a=w(this.series.options.point,this.options).events,b;this.events=a;for(b in a)K(this,b,
a[b]);this.hasImportedEvents=!0}},setState:function(a,b){var c=this.plotX,d=this.plotY,e=this.series,f=e.options.states,g=ba[e.type].marker&&e.options.marker,h=g&&!g.enabled,i=g&&g.states[a],j=i&&i.enabled===!1,k=e.stateMarkerGraphic,l=this.marker||{},m=e.chart,n=e.halo,p,a=a||"";p=this.pointAttr[a]||e.pointAttr[a];if(!(a===this.state&&!b||this.selected&&a!=="select"||f[a]&&f[a].enabled===!1||a&&(j||h&&i.enabled===!1)||a&&l.states&&l.states[a]&&l.states[a].enabled===!1)){if(this.graphic)g=g&&this.graphic.symbolName&&
p.r,this.graphic.attr(w(p,g?{x:c-g,y:d-g,width:2*g,height:2*g}:{})),k&&k.hide();else{if(a&&i)if(g=i.radius,l=l.symbol||e.symbol,k&&k.currentSymbol!==l&&(k=k.destroy()),k)k[b?"animate":"attr"]({x:c-g,y:d-g});else if(l)e.stateMarkerGraphic=k=m.renderer.symbol(l,c-g,d-g,2*g,2*g).attr(p).add(e.markerGroup),k.currentSymbol=l;if(k)k[a&&m.isInsidePlot(c,d,m.inverted)?"show":"hide"]()}if((c=f[a]&&f[a].halo)&&c.size){if(!n)e.halo=n=m.renderer.path().add(e.seriesGroup);n.attr(q({fill:ya(this.color||e.color).setOpacity(c.opacity).get()},
c.attributes))[b?"animate":"attr"]({d:this.haloPath(c.size)})}else n&&n.attr({d:[]});this.state=a}},haloPath:function(a){var b=this.series.chart;return b.renderer.symbols.circle(b.plotLeft+this.plotX-a,b.plotTop+this.plotY-a,a*2,a*2)}});q(M.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&E(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;
if(d)d.onMouseOut();this&&a.events.mouseOut&&E(this,"mouseOut");c&&!a.stickyTracking&&(!c.shared||this.noSharedTooltip)&&c.hide();this.setState();b.hoverSeries=null},setState:function(a){var b=this.options,c=this.graph,d=this.graphNeg,e=b.states,b=b.lineWidth,a=a||"";if(this.state!==a)this.state=a,e[a]&&e[a].enabled===!1||(a&&(b=e[a].lineWidth||b+1),c&&!c.dashstyle&&(a={"stroke-width":b},c.attr(a),d&&d.attr(a)))},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,f,g=d.options.chart.ignoreHiddenSeries,
h=c.visible;f=(c.visible=a=c.userOptions.visible=a===t?!h:a)?"show":"hide";p(["group","dataLabelsGroup","markerGroup","tracker"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&p(d.series,function(a){if(a.options.stacking&&a.visible)a.isDirty=!0});p(c.linkedSeries,function(b){b.setVisible(a,!1)});if(g)d.isDirtyBox=!0;b!==!1&&d.redraw();E(c,f)},setTooltipPoints:function(a){var b=[],c,d,e=this.xAxis,f=e&&e.getExtremes(),
g=e?e.tooltipLen||e.len:this.chart.plotSizeX,h,i,j=[];if(!(this.options.enableMouseTracking===!1||this.singularTooltips)){if(a)this.tooltipPoints=null;p(this.segments||this.points,function(a){b=b.concat(a)});e&&e.reversed&&(b=b.reverse());this.orderTooltipPoints&&this.orderTooltipPoints(b);a=b.length;for(i=0;i<a;i++)if(e=b[i],c=e.x,c>=f.min&&c<=f.max){h=b[i+1];c=d===t?0:d+1;for(d=b[i+1]?C(v(0,S((e.clientX+(h?h.wrappedClientX||h.clientX:g))/2)),g):g;c>=0&&c<=d;)j[c++]=e}this.tooltipPoints=j}},show:function(){this.setVisible(!0)},
hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=a===t?!this.selected:a;if(this.checkbox)this.checkbox.checked=a;E(this,a?"select":"unselect")},drawTracker:P.drawTrackerGraph});q(R,{Axis:la,Chart:Ya,Color:ya,Point:Ea,Tick:Sa,Renderer:Za,Series:M,SVGElement:U,SVGRenderer:ta,arrayMin:Na,arrayMax:Ba,charts:V,dateFormat:cb,format:Ia,pathAnim:ub,getOptions:function(){return F},hasBidiBug:Nb,isTouchDevice:Jb,numberFormat:Ga,seriesTypes:G,setOptions:function(a){F=w(!0,F,a);Cb();return F},
addEvent:K,removeEvent:W,createElement:Y,discardElement:Pa,css:D,each:p,extend:q,map:Ua,merge:w,pick:m,splat:qa,extendClass:ka,pInt:A,wrap:Ma,svg:aa,canvas:fa,vml:!aa&&!fa,product:"Highcharts",version:"4.0.0"})})();

/*!
 * jCarousel - Riding carousels with jQuery
 *   http://sorgalla.com/jcarousel/
 *
 * Copyright (c) 2006 Jan Sorgalla (http://sorgalla.com)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Built on top of the jQuery library
 *   http://jquery.com
 *
 * Inspired by the "Carousel Component" by Bill Scott
 *   http://billwscott.com/carousel/
 */

/*global window, jQuery */
(function($) {
    // Default configuration properties.
    var defaults = {
        vertical: false,
        rtl: false,
        start: 1,
        offset: 1,
        size: null,
        scroll: 3,
        visible: null,
        animation: 'normal',
        easing: 'swing',
        auto: 0,
        wrap: null,
        initCallback: null,
        setupCallback: null,
        reloadCallback: null,
        itemLoadCallback: null,
        itemFirstInCallback: null,
        itemFirstOutCallback: null,
        itemLastInCallback: null,
        itemLastOutCallback: null,
        itemVisibleInCallback: null,
        itemVisibleOutCallback: null,
        animationStepCallback: null,
        buttonNextHTML: '<div class="icon icon-right-open icon-muted"></div>',
        buttonPrevHTML: '<div class="icon icon-left-open icon-muted"></div>',
        buttonNextEvent: 'click',
        buttonPrevEvent: 'click',
        buttonNextCallback: null,
        buttonPrevCallback: null,
        itemFallbackDimension: null
    }, windowLoaded = false;

    $(window).bind('load.jcarousel', function() { windowLoaded = true; });

    /**
     * The jCarousel object.
     *
     * @constructor
     * @class jcarousel
     * @param e {HTMLElement} The element to create the carousel for.
     * @param o {Object} A set of key/value pairs to set as configuration properties.
     * @cat Plugins/jCarousel
     */
    $.jcarousel = function(e, o) {
        this.options    = $.extend({}, defaults, o || {});

        this.locked          = false;
        this.autoStopped     = false;

        this.container       = null;
        this.clip            = null;
        this.list            = null;
        this.buttonNext      = null;
        this.buttonPrev      = null;
        this.buttonNextState = null;
        this.buttonPrevState = null;

        // Only set if not explicitly passed as option
        if (!o || o.rtl === undefined) {
            this.options.rtl = ($(e).attr('dir') || $('html').attr('dir') || '').toLowerCase() == 'rtl';
        }

        this.wh = !this.options.vertical ? 'width' : 'height';
        this.lt = !this.options.vertical ? (this.options.rtl ? 'right' : 'left') : 'top';

        // Extract skin class
        var skin = '', split = e.className.split(' ');

        for (var i = 0; i < split.length; i++) {
            if (split[i].indexOf('jcarousel-skin') != -1) {
                $(e).removeClass(split[i]);
                skin = split[i];
                break;
            }
        }

        if (e.nodeName.toUpperCase() == 'UL' || e.nodeName.toUpperCase() == 'OL') {
            this.list      = $(e);
            this.clip      = this.list.parents('.jcarousel-clip');
            this.container = this.list.parents('.jcarousel-container');
        } else {
            this.container = $(e);
            this.list      = this.container.find('ul,ol').eq(0);
            this.clip      = this.container.find('.jcarousel-clip');
        }

        if (this.clip.size() === 0) {
            this.clip = this.list.wrap('<div></div>').parent();
        }

        if (this.container.size() === 0) {
            this.container = this.clip.wrap('<div></div>').parent();
        }

        if (skin !== '' && this.container.parent()[0].className.indexOf('jcarousel-skin') == -1) {
            this.container.wrap('<div class=" '+ skin + '"></div>');
        }

        this.buttonPrev = $('.jcarousel-prev', this.container);

        if (this.buttonPrev.size() === 0 && this.options.buttonPrevHTML !== null) {
            this.buttonPrev = $(this.options.buttonPrevHTML).appendTo(this.container);
        }

        this.buttonPrev.addClass(this.className('jcarousel-prev'));

        this.buttonNext = $('.jcarousel-next', this.container);

        if (this.buttonNext.size() === 0 && this.options.buttonNextHTML !== null) {
            this.buttonNext = $(this.options.buttonNextHTML).appendTo(this.container);
        }

        this.buttonNext.addClass(this.className('jcarousel-next'));

        this.clip.addClass(this.className('jcarousel-clip')).css({
            position: 'relative'
        });

        this.list.addClass(this.className('jcarousel-list')).css({
            overflow: 'hidden',
            position: 'relative',
            top: 0,
            margin: 0,
            padding: 0
        }).css((this.options.rtl ? 'right' : 'left'), 0);

        this.container.addClass(this.className('jcarousel-container')).css({
            position: 'relative'
        });

        if (!this.options.vertical && this.options.rtl) {
            this.container.addClass('jcarousel-direction-rtl').attr('dir', 'rtl');
        }

        var di = this.options.visible !== null ? Math.ceil(this.clipping() / this.options.visible) : null;
        var li = this.list.children('li');

        var self = this;

        if (li.size() > 0) {
            var wh = 0, j = this.options.offset;
            li.each(function() {
                self.format(this, j++);
                wh += self.dimension(this, di);
            });

            this.list.css(this.wh, (wh + 100) + 'px');

            // Only set if not explicitly passed as option
            if (!o || o.size === undefined) {
                this.options.size = li.size();
            }
        }

        // For whatever reason, .show() does not work in Safari...
        this.container.css('display', 'block');
        this.buttonNext.css('display', 'block');
        this.buttonPrev.css('display', 'block');

        this.funcNext   = function() { self.next(); return false; };
        this.funcPrev   = function() { self.prev(); return false; };
        this.funcResize = function() {
            if (self.resizeTimer) {
                clearTimeout(self.resizeTimer);
            }

            self.resizeTimer = setTimeout(function() {
                self.reload();
            }, 100);
        };

        if (this.options.initCallback !== null) {
            this.options.initCallback(this, 'init');
        }

        if (!windowLoaded && $jc.isSafari()) {
            this.buttons(false, false);
            $(window).bind('load.jcarousel', function() { self.setup(); });
        } else {
            this.setup();
        }
    };

    // Create shortcut for internal use
    var $jc = $.jcarousel;

    $jc.fn = $jc.prototype = {
        jcarousel: '0.2.9'
    };

    $jc.fn.extend = $jc.extend = $.extend;

    $jc.fn.extend({
        /**
         * Setups the carousel.
         *
         * @method setup
         * @return undefined
         */
        setup: function() {
            this.first       = null;
            this.last        = null;
            this.prevFirst   = null;
            this.prevLast    = null;
            this.animating   = false;
            this.timer       = null;
            this.resizeTimer = null;
            this.tail        = null;
            this.inTail      = false;

            if (this.locked) {
                return;
            }

            this.list.css(this.lt, this.pos(this.options.offset) + 'px');
            var p = this.pos(this.options.start, true);
            this.prevFirst = this.prevLast = null;
            this.animate(p, false);

            $(window).unbind('resize.jcarousel', this.funcResize).bind('resize.jcarousel', this.funcResize);

            if (this.options.setupCallback !== null) {
                this.options.setupCallback(this);
            }
        },

        /**
         * Clears the list and resets the carousel.
         *
         * @method reset
         * @return undefined
         */
        reset: function() {
            this.list.empty();

            this.list.css(this.lt, '0px');
            this.list.css(this.wh, '10px');

            if (this.options.initCallback !== null) {
                this.options.initCallback(this, 'reset');
            }

            this.setup();
        },

        /**
         * Reloads the carousel and adjusts positions.
         *
         * @method reload
         * @return undefined
         */
        reload: function() {
            if (this.tail !== null && this.inTail) {
                this.list.css(this.lt, $jc.intval(this.list.css(this.lt)) + this.tail);
            }

            this.tail   = null;
            this.inTail = false;

            if (this.options.reloadCallback !== null) {
                this.options.reloadCallback(this);
            }

            if (this.options.visible !== null) {
                var self = this;
                var di = Math.ceil(this.clipping() / this.options.visible), wh = 0, lt = 0;
                this.list.children('li').each(function(i) {
                    wh += self.dimension(this, di);
                    if (i + 1 < self.first) {
                        lt = wh;
                    }
                });

                this.list.css(this.wh, wh + 'px');
                this.list.css(this.lt, -lt + 'px');
            }

            this.scroll(this.first, false);
        },

        /**
         * Locks the carousel.
         *
         * @method lock
         * @return undefined
         */
        lock: function() {
            this.locked = true;
            this.buttons();
        },

        /**
         * Unlocks the carousel.
         *
         * @method unlock
         * @return undefined
         */
        unlock: function() {
            this.locked = false;
            this.buttons();
        },

        /**
         * Sets the size of the carousel.
         *
         * @method size
         * @return undefined
         * @param s {Number} The size of the carousel.
         */
        size: function(s) {
            if (s !== undefined) {
                this.options.size = s;
                if (!this.locked) {
                    this.buttons();
                }
            }

            return this.options.size;
        },

        /**
         * Checks whether a list element exists for the given index (or index range).
         *
         * @method get
         * @return bool
         * @param i {Number} The index of the (first) element.
         * @param i2 {Number} The index of the last element.
         */
        has: function(i, i2) {
            if (i2 === undefined || !i2) {
                i2 = i;
            }

            if (this.options.size !== null && i2 > this.options.size) {
                i2 = this.options.size;
            }

            for (var j = i; j <= i2; j++) {
                var e = this.get(j);
                if (!e.length || e.hasClass('jcarousel-item-placeholder')) {
                    return false;
                }
            }

            return true;
        },

        /**
         * Returns a jQuery object with list element for the given index.
         *
         * @method get
         * @return jQuery
         * @param i {Number} The index of the element.
         */
        get: function(i) {
            return $('>.jcarousel-item-' + i, this.list);
        },

        /**
         * Adds an element for the given index to the list.
         * If the element already exists, it updates the inner html.
         * Returns the created element as jQuery object.
         *
         * @method add
         * @return jQuery
         * @param i {Number} The index of the element.
         * @param s {String} The innerHTML of the element.
         */
        add: function(i, s) {
            var e = this.get(i), old = 0, n = $(s);

            if (e.length === 0) {
                var c, j = $jc.intval(i);
                e = this.create(i);
                while (true) {
                    c = this.get(--j);
                    if (j <= 0 || c.length) {
                        if (j <= 0) {
                            this.list.prepend(e);
                        } else {
                            c.after(e);
                        }
                        break;
                    }
                }
            } else {
                old = this.dimension(e);
            }

            if (n.get(0).nodeName.toUpperCase() == 'LI') {
                e.replaceWith(n);
                e = n;
            } else {
                e.empty().append(s);
            }

            this.format(e.removeClass(this.className('jcarousel-item-placeholder')), i);

            var di = this.options.visible !== null ? Math.ceil(this.clipping() / this.options.visible) : null;
            var wh = this.dimension(e, di) - old;

            if (i > 0 && i < this.first) {
                this.list.css(this.lt, $jc.intval(this.list.css(this.lt)) - wh + 'px');
            }

            this.list.css(this.wh, $jc.intval(this.list.css(this.wh)) + wh + 'px');

            return e;
        },

        /**
         * Removes an element for the given index from the list.
         *
         * @method remove
         * @return undefined
         * @param i {Number} The index of the element.
         */
        remove: function(i) {
            var e = this.get(i);

            // Check if item exists and is not currently visible
            if (!e.length || (i >= this.first && i <= this.last)) {
                return;
            }

            var d = this.dimension(e);

            if (i < this.first) {
                this.list.css(this.lt, $jc.intval(this.list.css(this.lt)) + d + 'px');
            }

            e.remove();

            this.list.css(this.wh, $jc.intval(this.list.css(this.wh)) - d + 'px');
        },

        /**
         * Moves the carousel forwards.
         *
         * @method next
         * @return undefined
         */
        next: function() {
            if (this.tail !== null && !this.inTail) {
                this.scrollTail(false);
            } else {
                this.scroll(((this.options.wrap == 'both' || this.options.wrap == 'last') && this.options.size !== null && this.last == this.options.size) ? 1 : this.first + this.options.scroll);
            }
        },

        /**
         * Moves the carousel backwards.
         *
         * @method prev
         * @return undefined
         */
        prev: function() {
            if (this.tail !== null && this.inTail) {
                this.scrollTail(true);
            } else {
                this.scroll(((this.options.wrap == 'both' || this.options.wrap == 'first') && this.options.size !== null && this.first == 1) ? this.options.size : this.first - this.options.scroll);
            }
        },

        /**
         * Scrolls the tail of the carousel.
         *
         * @method scrollTail
         * @return undefined
         * @param b {Boolean} Whether scroll the tail back or forward.
         */
        scrollTail: function(b) {
            if (this.locked || this.animating || !this.tail) {
                return;
            }

            this.pauseAuto();

            var pos  = $jc.intval(this.list.css(this.lt));

            pos = !b ? pos - this.tail : pos + this.tail;
            this.inTail = !b;

            // Save for callbacks
            this.prevFirst = this.first;
            this.prevLast  = this.last;

            this.animate(pos);
        },

        /**
         * Scrolls the carousel to a certain position.
         *
         * @method scroll
         * @return undefined
         * @param i {Number} The index of the element to scoll to.
         * @param a {Boolean} Flag indicating whether to perform animation.
         */
        scroll: function(i, a) {
            if (this.locked || this.animating) {
                return;
            }

            this.pauseAuto();
            this.animate(this.pos(i), a);
        },

        /**
         * Prepares the carousel and return the position for a certian index.
         *
         * @method pos
         * @return {Number}
         * @param i {Number} The index of the element to scoll to.
         * @param fv {Boolean} Whether to force last item to be visible.
         */
        pos: function(i, fv) {
            var pos  = $jc.intval(this.list.css(this.lt));

            if (this.locked || this.animating) {
                return pos;
            }

            if (this.options.wrap != 'circular') {
                i = i < 1 ? 1 : (this.options.size && i > this.options.size ? this.options.size : i);
            }

            var back = this.first > i;

            // Create placeholders, new list width/height
            // and new list position
            var f = this.options.wrap != 'circular' && this.first <= 1 ? 1 : this.first;
            var c = back ? this.get(f) : this.get(this.last);
            var j = back ? f : f - 1;
            var e = null, l = 0, p = false, d = 0, g;

            while (back ? --j >= i : ++j < i) {
                e = this.get(j);
                p = !e.length;
                if (e.length === 0) {
                    e = this.create(j).addClass(this.className('jcarousel-item-placeholder'));
                    c[back ? 'before' : 'after' ](e);

                    if (this.first !== null && this.options.wrap == 'circular' && this.options.size !== null && (j <= 0 || j > this.options.size)) {
                        g = this.get(this.index(j));
                        if (g.length) {
                            e = this.add(j, g.clone(true));
                        }
                    }
                }

                c = e;
                d = this.dimension(e);

                if (p) {
                    l += d;
                }

                if (this.first !== null && (this.options.wrap == 'circular' || (j >= 1 && (this.options.size === null || j <= this.options.size)))) {
                    pos = back ? pos + d : pos - d;
                }
            }

            // Calculate visible items
            var clipping = this.clipping(), cache = [], visible = 0, v = 0;
            c = this.get(i - 1);
            j = i;

            while (++visible) {
                e = this.get(j);
                p = !e.length;
                if (e.length === 0) {
                    e = this.create(j).addClass(this.className('jcarousel-item-placeholder'));
                    // This should only happen on a next scroll
                    if (c.length === 0) {
                        this.list.prepend(e);
                    } else {
                        c[back ? 'before' : 'after' ](e);
                    }

                    if (this.first !== null && this.options.wrap == 'circular' && this.options.size !== null && (j <= 0 || j > this.options.size)) {
                        g = this.get(this.index(j));
                        if (g.length) {
                            e = this.add(j, g.clone(true));
                        }
                    }
                }

                c = e;
                d = this.dimension(e);
                if (d === 0) {
                    throw new Error('jCarousel: No width/height set for items. This will cause an infinite loop. Aborting...');
                }

                if (this.options.wrap != 'circular' && this.options.size !== null && j > this.options.size) {
                    cache.push(e);
                } else if (p) {
                    l += d;
                }

                v += d;

                if (v >= clipping) {
                    break;
                }

                j++;
            }

             // Remove out-of-range placeholders
            for (var x = 0; x < cache.length; x++) {
                cache[x].remove();
            }

            // Resize list
            if (l > 0) {
                this.list.css(this.wh, this.dimension(this.list) + l + 'px');

                if (back) {
                    pos -= l;
                    this.list.css(this.lt, $jc.intval(this.list.css(this.lt)) - l + 'px');
                }
            }

            // Calculate first and last item
            var last = i + visible - 1;
            if (this.options.wrap != 'circular' && this.options.size && last > this.options.size) {
                last = this.options.size;
            }

            if (j > last) {
                visible = 0;
                j = last;
                v = 0;
                while (++visible) {
                    e = this.get(j--);
                    if (!e.length) {
                        break;
                    }
                    v += this.dimension(e);
                    if (v >= clipping) {
                        break;
                    }
                }
            }

            var first = last - visible + 1;
            if (this.options.wrap != 'circular' && first < 1) {
                first = 1;
            }

            if (this.inTail && back) {
                pos += this.tail;
                this.inTail = false;
            }

            this.tail = null;
            if (this.options.wrap != 'circular' && last == this.options.size && (last - visible + 1) >= 1) {
                var m = $jc.intval(this.get(last).css(!this.options.vertical ? 'marginRight' : 'marginBottom'));
                if ((v - m) > clipping) {
                    this.tail = v - clipping - m;
                }
            }

            if (fv && i === this.options.size && this.tail) {
                pos -= this.tail;
                this.inTail = true;
            }

            // Adjust position
            while (i-- > first) {
                pos += this.dimension(this.get(i));
            }

            // Save visible item range
            this.prevFirst = this.first;
            this.prevLast  = this.last;
            this.first     = first;
            this.last      = last;

            return pos;
        },

        /**
         * Animates the carousel to a certain position.
         *
         * @method animate
         * @return undefined
         * @param p {Number} Position to scroll to.
         * @param a {Boolean} Flag indicating whether to perform animation.
         */
        animate: function(p, a) {
            if (this.locked || this.animating) {
                return;
            }

            this.animating = true;

            var self = this;
            var scrolled = function() {
                self.animating = false;

                if (p === 0) {
                    self.list.css(self.lt,  0);
                }

                if (!self.autoStopped && (self.options.wrap == 'circular' || self.options.wrap == 'both' || self.options.wrap == 'last' || self.options.size === null || self.last < self.options.size || (self.last == self.options.size && self.tail !== null && !self.inTail))) {
                    self.startAuto();
                }

                self.buttons();
                self.notify('onAfterAnimation');

                // This function removes items which are appended automatically for circulation.
                // This prevents the list from growing infinitely.
                if (self.options.wrap == 'circular' && self.options.size !== null) {
                    for (var i = self.prevFirst; i <= self.prevLast; i++) {
                        if (i !== null && !(i >= self.first && i <= self.last) && (i < 1 || i > self.options.size)) {
                            self.remove(i);
                        }
                    }
                }
            };

            this.notify('onBeforeAnimation');

            // Animate
            if (!this.options.animation || a === false) {
                this.list.css(this.lt, p + 'px');
                scrolled();
            } else {
                var o = !this.options.vertical ? (this.options.rtl ? {'right': p} : {'left': p}) : {'top': p};
                // Define animation settings.
                var settings = {
                    duration: this.options.animation,
                    easing:   this.options.easing,
                    complete: scrolled
                };
                // If we have a step callback, specify it as well.
                if ($.isFunction(this.options.animationStepCallback)) {
                    settings.step = this.options.animationStepCallback;
                }
                // Start the animation.
                this.list.animate(o, settings);
            }
        },

        /**
         * Starts autoscrolling.
         *
         * @method auto
         * @return undefined
         * @param s {Number} Seconds to periodically autoscroll the content.
         */
        startAuto: function(s) {
            if (s !== undefined) {
                this.options.auto = s;
            }

            if (this.options.auto === 0) {
                return this.stopAuto();
            }

            if (this.timer !== null) {
                return;
            }

            this.autoStopped = false;

            var self = this;
            this.timer = window.setTimeout(function() { self.next(); }, this.options.auto * 1000);
        },

        /**
         * Stops autoscrolling.
         *
         * @method stopAuto
         * @return undefined
         */
        stopAuto: function() {
            this.pauseAuto();
            this.autoStopped = true;
        },

        /**
         * Pauses autoscrolling.
         *
         * @method pauseAuto
         * @return undefined
         */
        pauseAuto: function() {
            if (this.timer === null) {
                return;
            }

            window.clearTimeout(this.timer);
            this.timer = null;
        },

        /**
         * Sets the states of the prev/next buttons.
         *
         * @method buttons
         * @return undefined
         */
        buttons: function(n, p) {
            if (n == null) {
                n = !this.locked && this.options.size !== 0 && ((this.options.wrap && this.options.wrap != 'first') || this.options.size === null || this.last < this.options.size);
                if (!this.locked && (!this.options.wrap || this.options.wrap == 'first') && this.options.size !== null && this.last >= this.options.size) {
                    n = this.tail !== null && !this.inTail;
                }
            }

            if (p == null) {
                p = !this.locked && this.options.size !== 0 && ((this.options.wrap && this.options.wrap != 'last') || this.first > 1);
                if (!this.locked && (!this.options.wrap || this.options.wrap == 'last') && this.options.size !== null && this.first == 1) {
                    p = this.tail !== null && this.inTail;
                }
            }

            var self = this;

            if (this.buttonNext.size() > 0) {
                this.buttonNext.unbind(this.options.buttonNextEvent + '.jcarousel', this.funcNext);

                if (n) {
                    this.buttonNext.bind(this.options.buttonNextEvent + '.jcarousel', this.funcNext);
                }

                this.buttonNext[n ? 'removeClass' : 'addClass'](this.className('jcarousel-next-disabled')).attr('disabled', n ? false : true);

                if (this.options.buttonNextCallback !== null && this.buttonNext.data('jcarouselstate') != n) {
                    this.buttonNext.each(function() { self.options.buttonNextCallback(self, this, n); }).data('jcarouselstate', n);
                }
            } else {
                if (this.options.buttonNextCallback !== null && this.buttonNextState != n) {
                    this.options.buttonNextCallback(self, null, n);
                }
            }

            if (this.buttonPrev.size() > 0) {
                this.buttonPrev.unbind(this.options.buttonPrevEvent + '.jcarousel', this.funcPrev);

                if (p) {
                    this.buttonPrev.bind(this.options.buttonPrevEvent + '.jcarousel', this.funcPrev);
                }

                this.buttonPrev[p ? 'removeClass' : 'addClass'](this.className('jcarousel-prev-disabled')).attr('disabled', p ? false : true);

                if (this.options.buttonPrevCallback !== null && this.buttonPrev.data('jcarouselstate') != p) {
                    this.buttonPrev.each(function() { self.options.buttonPrevCallback(self, this, p); }).data('jcarouselstate', p);
                }
            } else {
                if (this.options.buttonPrevCallback !== null && this.buttonPrevState != p) {
                    this.options.buttonPrevCallback(self, null, p);
                }
            }

            this.buttonNextState = n;
            this.buttonPrevState = p;
        },

        /**
         * Notify callback of a specified event.
         *
         * @method notify
         * @return undefined
         * @param evt {String} The event name
         */
        notify: function(evt) {
            var state = this.prevFirst === null ? 'init' : (this.prevFirst < this.first ? 'next' : 'prev');

            // Load items
            this.callback('itemLoadCallback', evt, state);

            if (this.prevFirst !== this.first) {
                this.callback('itemFirstInCallback', evt, state, this.first);
                this.callback('itemFirstOutCallback', evt, state, this.prevFirst);
            }

            if (this.prevLast !== this.last) {
                this.callback('itemLastInCallback', evt, state, this.last);
                this.callback('itemLastOutCallback', evt, state, this.prevLast);
            }

            this.callback('itemVisibleInCallback', evt, state, this.first, this.last, this.prevFirst, this.prevLast);
            this.callback('itemVisibleOutCallback', evt, state, this.prevFirst, this.prevLast, this.first, this.last);
        },

        callback: function(cb, evt, state, i1, i2, i3, i4) {
            if (this.options[cb] == null || (typeof this.options[cb] != 'object' && evt != 'onAfterAnimation')) {
                return;
            }

            var callback = typeof this.options[cb] == 'object' ? this.options[cb][evt] : this.options[cb];

            if (!$.isFunction(callback)) {
                return;
            }

            var self = this;

            if (i1 === undefined) {
                callback(self, state, evt);
            } else if (i2 === undefined) {
                this.get(i1).each(function() { callback(self, this, i1, state, evt); });
            } else {
                var call = function(i) {
                    self.get(i).each(function() { callback(self, this, i, state, evt); });
                };
                for (var i = i1; i <= i2; i++) {
                    if (i !== null && !(i >= i3 && i <= i4)) {
                        call(i);
                    }
                }
            }
        },

        create: function(i) {
            return this.format('<li></li>', i);
        },

        format: function(e, i) {
            e = $(e);
            var split = e.get(0).className.split(' ');
            for (var j = 0; j < split.length; j++) {
                if (split[j].indexOf('jcarousel-') != -1) {
                    e.removeClass(split[j]);
                }
            }
            e.addClass(this.className('jcarousel-item')).addClass(this.className('jcarousel-item-' + i)).css({
                'float': (this.options.rtl ? 'right' : 'left'),
                'list-style': 'none'
            }).attr('jcarouselindex', i);
            return e;
        },

        className: function(c) {
            return c + ' ' + c + (!this.options.vertical ? '-horizontal' : '-vertical');
        },

        dimension: function(e, d) {
            var el = $(e);

            if (d == null) {
                return !this.options.vertical ?
                    ((el.innerWidth() +
                        $jc.intval(el.css('margin-left')) +
                        $jc.intval(el.css('margin-right')) +
                        $jc.intval(el.css('border-left-width')) +
                        $jc.intval(el.css('border-right-width'))) || $jc.intval(this.options.itemFallbackDimension)) :
                    ((el.innerHeight() +
                        $jc.intval(el.css('margin-top')) +
                        $jc.intval(el.css('margin-bottom')) +
                        $jc.intval(el.css('border-top-width')) +
                        $jc.intval(el.css('border-bottom-width'))) || $jc.intval(this.options.itemFallbackDimension));
            } else {
                var w = !this.options.vertical ?
                    d - $jc.intval(el.css('marginLeft')) - $jc.intval(el.css('marginRight')) :
                    d - $jc.intval(el.css('marginTop')) - $jc.intval(el.css('marginBottom'));

                $(el).css(this.wh, w + 'px');

                return this.dimension(el);
            }
        },

        clipping: function() {
            return !this.options.vertical ?
                this.clip[0].offsetWidth - $jc.intval(this.clip.css('borderLeftWidth')) - $jc.intval(this.clip.css('borderRightWidth')) :
                this.clip[0].offsetHeight - $jc.intval(this.clip.css('borderTopWidth')) - $jc.intval(this.clip.css('borderBottomWidth'));
        },

        index: function(i, s) {
            if (s == null) {
                s = this.options.size;
            }

            return Math.round((((i-1) / s) - Math.floor((i-1) / s)) * s) + 1;
        }
    });

    $jc.extend({
        /**
         * Gets/Sets the global default configuration properties.
         *
         * @method defaults
         * @return {Object}
         * @param d {Object} A set of key/value pairs to set as configuration properties.
         */
        defaults: function(d) {
            return $.extend(defaults, d || {});
        },

        intval: function(v) {
            v = parseInt(v, 10);
            return isNaN(v) ? 0 : v;
        },

        windowLoaded: function() {
            windowLoaded = true;
        },

        isSafari: function() {
            var ua = navigator.userAgent.toLowerCase(),
                match = /(chrome)[ \/]([\w.]+)/.exec(ua) || /(webkit)[ \/]([\w.]+)/.exec(ua) || [],
                browser = match[1] || "";

            return browser === 'webkit';
        }
    });

    /**
     * Creates a carousel for all matched elements.
     *
     * @example $("#mycarousel").jcarousel();
     * @before <ul id="mycarousel" class="jcarousel-skin-name"><li>First item</li><li>Second item</li></ul>
     * @result
     *
     * <div class="jcarousel-skin-name">
     *   <div class="jcarousel-container">
     *     <div class="jcarousel-clip">
     *       <ul class="jcarousel-list">
     *         <li class="jcarousel-item-1">First item</li>
     *         <li class="jcarousel-item-2">Second item</li>
     *       </ul>
     *     </div>
     *     <div disabled="disabled" class="jcarousel-prev jcarousel-prev-disabled"></div>
     *     <div class="jcarousel-next"></div>
     *   </div>
     * </div>
     *
     * @method jcarousel
     * @return jQuery
     * @param o {Hash|String} A set of key/value pairs to set as configuration properties or a method name to call on a formerly created instance.
     */
    $.fn.jcarousel = function(o) {
        if (typeof o == 'string') {
            var instance = $(this).data('jcarousel'), args = Array.prototype.slice.call(arguments, 1);
            return instance[o].apply(instance, args);
        } else {
            return this.each(function() {
                var instance = $(this).data('jcarousel');
                if (instance) {
                    if (o) {
                        $.extend(instance.options, o);
                    }
                    instance.reload();
                } else {
                    $(this).data('jcarousel', new $jc(this, o));
                }
            });
        }
    };

})(jQuery);

/*!
 * jQuery Validation Plugin v1.13.0
 *
 * http://jqueryvalidation.org/
 *
 * Copyright (c) 2014 Jörn Zaefferer
 * Released under the MIT license
 */
(function( factory ) {
    if ( typeof define === "function" && define.amd ) {
        define( ["jquery"], factory );
    } else {
        factory( jQuery );
    }
}(function( $ ) {

$.extend($.fn, {
    // http://jqueryvalidation.org/validate/
    validate: function( options ) {

        // if nothing is selected, return nothing; can't chain anyway
        if ( !this.length ) {
            if ( options && options.debug && window.console ) {
                console.warn( "Nothing selected, can't validate, returning nothing." );
            }
            return;
        }

        // check if a validator for this form was already created
        var validator = $.data( this[ 0 ], "validator" );
        if ( validator ) {
            return validator;
        }

        // Add novalidate tag if HTML5.
        this.attr( "novalidate", "novalidate" );

        validator = new $.validator( options, this[ 0 ] );
        $.data( this[ 0 ], "validator", validator );

        if ( validator.settings.onsubmit ) {

            this.validateDelegate( ":submit", "click", function( event ) {
                if ( validator.settings.submitHandler ) {
                    validator.submitButton = event.target;
                }
                // allow suppressing validation by adding a cancel class to the submit button
                if ( $( event.target ).hasClass( "cancel" ) ) {
                    validator.cancelSubmit = true;
                }

                // allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
                if ( $( event.target ).attr( "formnovalidate" ) !== undefined ) {
                    validator.cancelSubmit = true;
                }
            });

            // validate the form on submit
            this.submit( function( event ) {
                if ( validator.settings.debug ) {
                    // prevent form submit to be able to see console output
                    event.preventDefault();
                }
                function handle() {
                    var hidden;
                    if ( validator.settings.submitHandler ) {
                        if ( validator.submitButton ) {
                            // insert a hidden input as a replacement for the missing submit button
                            hidden = $( "<input type='hidden'/>" )
                                .attr( "name", validator.submitButton.name )
                                .val( $( validator.submitButton ).val() )
                                .appendTo( validator.currentForm );
                        }
                        validator.settings.submitHandler.call( validator, validator.currentForm, event );
                        if ( validator.submitButton ) {
                            // and clean up afterwards; thanks to no-block-scope, hidden can be referenced
                            hidden.remove();
                        }
                        return false;
                    }
                    return true;
                }

                // prevent submit for invalid forms or custom submit handlers
                if ( validator.cancelSubmit ) {
                    validator.cancelSubmit = false;
                    return handle();
                }
                if ( validator.form() ) {
                    if ( validator.pendingRequest ) {
                        validator.formSubmitted = true;
                        return false;
                    }
                    return handle();
                } else {
                    validator.focusInvalid();
                    return false;
                }
            });
        }

        return validator;
    },
    // http://jqueryvalidation.org/valid/
    valid: function() {
        var valid, validator;

        if ( $( this[ 0 ] ).is( "form" ) ) {
            valid = this.validate().form();
        } else {
            valid = true;
            validator = $( this[ 0 ].form ).validate();
            this.each( function() {
                valid = validator.element( this ) && valid;
            });
        }
        return valid;
    },
    // attributes: space separated list of attributes to retrieve and remove
    removeAttrs: function( attributes ) {
        var result = {},
            $element = this;
        $.each( attributes.split( /\s/ ), function( index, value ) {
            result[ value ] = $element.attr( value );
            $element.removeAttr( value );
        });
        return result;
    },
    // http://jqueryvalidation.org/rules/
    rules: function( command, argument ) {
        var element = this[ 0 ],
            settings, staticRules, existingRules, data, param, filtered;

        if ( command ) {
            settings = $.data( element.form, "validator" ).settings;
            staticRules = settings.rules;
            existingRules = $.validator.staticRules( element );
            switch ( command ) {
            case "add":
                $.extend( existingRules, $.validator.normalizeRule( argument ) );
                // remove messages from rules, but allow them to be set separately
                delete existingRules.messages;
                staticRules[ element.name ] = existingRules;
                if ( argument.messages ) {
                    settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
                }
                break;
            case "remove":
                if ( !argument ) {
                    delete staticRules[ element.name ];
                    return existingRules;
                }
                filtered = {};
                $.each( argument.split( /\s/ ), function( index, method ) {
                    filtered[ method ] = existingRules[ method ];
                    delete existingRules[ method ];
                    if ( method === "required" ) {
                        $( element ).removeAttr( "aria-required" );
                    }
                });
                return filtered;
            }
        }

        data = $.validator.normalizeRules(
        $.extend(
            {},
            $.validator.classRules( element ),
            $.validator.attributeRules( element ),
            $.validator.dataRules( element ),
            $.validator.staticRules( element )
        ), element );

        // make sure required is at front
        if ( data.required ) {
            param = data.required;
            delete data.required;
            data = $.extend( { required: param }, data );
            $( element ).attr( "aria-required", "true" );
        }

        // make sure remote is at back
        if ( data.remote ) {
            param = data.remote;
            delete data.remote;
            data = $.extend( data, { remote: param });
        }

        return data;
    }
});

// Custom selectors
$.extend( $.expr[ ":" ], {
    // http://jqueryvalidation.org/blank-selector/
    blank: function( a ) {
        return !$.trim( "" + $( a ).val() );
    },
    // http://jqueryvalidation.org/filled-selector/
    filled: function( a ) {
        return !!$.trim( "" + $( a ).val() );
    },
    // http://jqueryvalidation.org/unchecked-selector/
    unchecked: function( a ) {
        return !$( a ).prop( "checked" );
    }
});

// constructor for validator
$.validator = function( options, form ) {
    this.settings = $.extend( true, {}, $.validator.defaults, options );
    this.currentForm = form;
    this.init();
};

// http://jqueryvalidation.org/jQuery.validator.format/
$.validator.format = function( source, params ) {
    if ( arguments.length === 1 ) {
        return function() {
            var args = $.makeArray( arguments );
            args.unshift( source );
            return $.validator.format.apply( this, args );
        };
    }
    if ( arguments.length > 2 && params.constructor !== Array  ) {
        params = $.makeArray( arguments ).slice( 1 );
    }
    if ( params.constructor !== Array ) {
        params = [ params ];
    }
    $.each( params, function( i, n ) {
        source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
            return n;
        });
    });
    return source;
};

$.extend( $.validator, {

    defaults: {
        messages: {},
        groups: {},
        rules: {},
        errorClass: "error",
        validClass: "valid",
        errorElement: "label",
        focusInvalid: true,
        errorContainer: $( [] ),
        errorLabelContainer: $( [] ),
        onsubmit: true,
        ignore: ":hidden",
        ignoreTitle: false,
        onfocusin: function( element ) {
            this.lastActive = element;

            // hide error label and remove error class on focus if enabled
            if ( this.settings.focusCleanup && !this.blockFocusCleanup ) {
                if ( this.settings.unhighlight ) {
                    this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
                }
                this.hideThese( this.errorsFor( element ) );
            }
        },
        onfocusout: function( element ) {
            if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
                this.element( element );
            }
        },
        onkeyup: function( element, event ) {
            if ( event.which === 9 && this.elementValue( element ) === "" ) {
                return;
            } else if ( element.name in this.submitted || element === this.lastElement ) {
                this.element( element );
            }
        },
        onclick: function( element ) {
            // click on selects, radiobuttons and checkboxes
            if ( element.name in this.submitted ) {
                this.element( element );

            // or option elements, check parent select in that case
            } else if ( element.parentNode.name in this.submitted ) {
                this.element( element.parentNode );
            }
        },
        highlight: function( element, errorClass, validClass ) {
            if ( element.type === "radio" ) {
                this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
            } else {
                $( element ).addClass( errorClass ).removeClass( validClass );
            }
        },
        unhighlight: function( element, errorClass, validClass ) {
            if ( element.type === "radio" ) {
                this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
            } else {
                $( element ).removeClass( errorClass ).addClass( validClass );
            }
        }
    },

    // http://jqueryvalidation.org/jQuery.validator.setDefaults/
    setDefaults: function( settings ) {
        $.extend( $.validator.defaults, settings );
    },

    messages: {
        required: "This field is required.",
        remote: "Please fix this field.",
        email: "Please provide a full, valid email address e.g. johnsmith@gmail.com",
        url: "Please enter a valid URL.",
        date: "Please enter a valid date.",
        dateISO: "Please enter a valid date ( ISO ).",
        number: "Please enter a valid number.",
        digits: "Please enter only digits.",
        creditcard: "Please enter a valid credit card number.",
        equalTo: "Please enter the same value again.",
        maxlength: $.validator.format( "Please enter no more than {0} characters." ),
        minlength: $.validator.format( "Please enter at least {0} characters." ),
        rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
        range: $.validator.format( "Please enter a value between {0} and {1}." ),
        max: $.validator.format( "Please enter a value less than or equal to {0}." ),
        min: $.validator.format( "Please enter a value greater than or equal to {0}." )
    },

    autoCreateRanges: false,

    prototype: {

        init: function() {
            this.labelContainer = $( this.settings.errorLabelContainer );
            this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
            this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
            this.submitted = {};
            this.valueCache = {};
            this.pendingRequest = 0;
            this.pending = {};
            this.invalid = {};
            this.reset();

            var groups = ( this.groups = {} ),
                rules;
            $.each( this.settings.groups, function( key, value ) {
                if ( typeof value === "string" ) {
                    value = value.split( /\s/ );
                }
                $.each( value, function( index, name ) {
                    groups[ name ] = key;
                });
            });
            rules = this.settings.rules;
            $.each( rules, function( key, value ) {
                rules[ key ] = $.validator.normalizeRule( value );
            });

            function delegate( event ) {
                var validator = $.data( this[ 0 ].form, "validator" ),
                    eventType = "on" + event.type.replace( /^validate/, "" ),
                    settings = validator.settings;
                if ( settings[ eventType ] && !this.is( settings.ignore ) ) {
                    settings[ eventType ].call( validator, this[ 0 ], event );
                }
            }
            $( this.currentForm )
                .validateDelegate( ":text, [type='password'], [type='file'], select, textarea, " +
                    "[type='number'], [type='search'] ,[type='tel'], [type='url'], " +
                    "[type='email'], [type='datetime'], [type='date'], [type='month'], " +
                    "[type='week'], [type='time'], [type='datetime-local'], " +
                    "[type='range'], [type='color'], [type='radio'], [type='checkbox']",
                    "focusin focusout keyup", delegate)
                // Support: Chrome, oldIE
                // "select" is provided as event.target when clicking a option
                .validateDelegate("select, option, [type='radio'], [type='checkbox']", "click", delegate);

            if ( this.settings.invalidHandler ) {
                $( this.currentForm ).bind( "invalid-form.validate", this.settings.invalidHandler );
            }

            // Add aria-required to any Static/Data/Class required fields before first validation
            // Screen readers require this attribute to be present before the initial submission http://www.w3.org/TR/WCAG-TECHS/ARIA2.html
            $( this.currentForm ).find( "[required], [data-rule-required], .required" ).attr( "aria-required", "true" );
        },

        // http://jqueryvalidation.org/Validator.form/
        form: function() {
            this.checkForm();
            $.extend( this.submitted, this.errorMap );
            this.invalid = $.extend({}, this.errorMap );
            if ( !this.valid() ) {
                $( this.currentForm ).triggerHandler( "invalid-form", [ this ]);
            }
            this.showErrors();
            return this.valid();
        },

        checkForm: function() {
            this.prepareForm();
            for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
                this.check( elements[ i ] );
            }
            return this.valid();
        },

        // http://jqueryvalidation.org/Validator.element/
        element: function( element ) {
            var cleanElement = this.clean( element ),
                checkElement = this.validationTargetFor( cleanElement ),
                result = true;

            this.lastElement = checkElement;

            if ( checkElement === undefined ) {
                delete this.invalid[ cleanElement.name ];
            } else {
                this.prepareElement( checkElement );
                this.currentElements = $( checkElement );

                result = this.check( checkElement ) !== false;
                if ( result ) {
                    delete this.invalid[ checkElement.name ];
                } else {
                    this.invalid[ checkElement.name ] = true;
                }
            }
            // Add aria-invalid status for screen readers
            $( element ).attr( "aria-invalid", !result );

            if ( !this.numberOfInvalids() ) {
                // Hide error containers on last error
                this.toHide = this.toHide.add( this.containers );
            }
            this.showErrors();
            return result;
        },

        // http://jqueryvalidation.org/Validator.showErrors/
        showErrors: function( errors ) {
            if ( errors ) {
                // add items to error list and map
                $.extend( this.errorMap, errors );
                this.errorList = [];
                for ( var name in errors ) {
                    this.errorList.push({
                        message: errors[ name ],
                        element: this.findByName( name )[ 0 ]
                    });
                }
                // remove items from success list
                this.successList = $.grep( this.successList, function( element ) {
                    return !( element.name in errors );
                });
            }
            if ( this.settings.showErrors ) {
                this.settings.showErrors.call( this, this.errorMap, this.errorList );
            } else {
                this.defaultShowErrors();
            }
        },

        // http://jqueryvalidation.org/Validator.resetForm/
        resetForm: function() {
            if ( $.fn.resetForm ) {
                $( this.currentForm ).resetForm();
            }
            this.submitted = {};
            this.lastElement = null;
            this.prepareForm();
            this.hideErrors();
            this.elements()
                    .removeClass( this.settings.errorClass )
                    .removeData( "previousValue" )
                    .removeAttr( "aria-invalid" );
        },

        numberOfInvalids: function() {
            return this.objectLength( this.invalid );
        },

        objectLength: function( obj ) {
            /* jshint unused: false */
            var count = 0,
                i;
            for ( i in obj ) {
                count++;
            }
            return count;
        },

        hideErrors: function() {
            this.hideThese( this.toHide );
        },

        hideThese: function( errors ) {
            errors.not( this.containers ).text( "" );
            this.addWrapper( errors ).hide();
        },

        valid: function() {
            return this.size() === 0;
        },

        size: function() {
            return this.errorList.length;
        },

        focusInvalid: function() {
            if ( this.settings.focusInvalid ) {
                try {
                    $( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [])
                    .filter( ":visible" )
                    .focus()
                    // manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
                    .trigger( "focusin" );
                } catch ( e ) {
                    // ignore IE throwing errors when focusing hidden elements
                }
            }
        },

        findLastActive: function() {
            var lastActive = this.lastActive;
            return lastActive && $.grep( this.errorList, function( n ) {
                return n.element.name === lastActive.name;
            }).length === 1 && lastActive;
        },

        elements: function() {
            var validator = this,
                rulesCache = {};

            // select all valid inputs inside the form (no submit or reset buttons)
            return $( this.currentForm )
            .find( "input, select, textarea" )
            .not( ":submit, :reset, :image, [disabled]" )
            .not( this.settings.ignore )
            .filter( function() {
                if ( !this.name && validator.settings.debug && window.console ) {
                    console.error( "%o has no name assigned", this );
                }

                // select only the first element for each name, and only those with rules specified
                if ( this.name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
                    return false;
                }

                rulesCache[ this.name ] = true;
                return true;
            });
        },

        clean: function( selector ) {
            return $( selector )[ 0 ];
        },

        errors: function() {
            var errorClass = this.settings.errorClass.split( " " ).join( "." );
            return $( this.settings.errorElement + "." + errorClass, this.errorContext );
        },

        reset: function() {
            this.successList = [];
            this.errorList = [];
            this.errorMap = {};
            this.toShow = $( [] );
            this.toHide = $( [] );
            this.currentElements = $( [] );
        },

        prepareForm: function() {
            this.reset();
            this.toHide = this.errors().add( this.containers );
        },

        prepareElement: function( element ) {
            this.reset();
            this.toHide = this.errorsFor( element );
        },

        elementValue: function( element ) {
            var val,
                $element = $( element ),
                type = element.type;

            if ( type === "radio" || type === "checkbox" ) {
                return $( "input[name='" + element.name + "']:checked" ).val();
            } else if ( type === "number" && typeof element.validity !== "undefined" ) {
                return element.validity.badInput ? false : $element.val();
            }

            val = $element.val();
            if ( typeof val === "string" ) {
                return val.replace(/\r/g, "" );
            }
            return val;
        },

        check: function( element ) {
            element = this.validationTargetFor( this.clean( element ) );

            var rules = $( element ).rules(),
                rulesCount = $.map( rules, function( n, i ) {
                    return i;
                }).length,
                dependencyMismatch = false,
                val = this.elementValue( element ),
                result, method, rule;

            for ( method in rules ) {
                rule = { method: method, parameters: rules[ method ] };
                try {

                    result = $.validator.methods[ method ].call( this, val, element, rule.parameters );

                    // if a method indicates that the field is optional and therefore valid,
                    // don't mark it as valid when there are no other rules
                    if ( result === "dependency-mismatch" && rulesCount === 1 ) {
                        dependencyMismatch = true;
                        continue;
                    }
                    dependencyMismatch = false;

                    if ( result === "pending" ) {
                        this.toHide = this.toHide.not( this.errorsFor( element ) );
                        return;
                    }

                    if ( !result ) {
                        this.formatAndAdd( element, rule );
                        return false;
                    }
                } catch ( e ) {
                    if ( this.settings.debug && window.console ) {
                        console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
                    }
                    throw e;
                }
            }
            if ( dependencyMismatch ) {
                return;
            }
            if ( this.objectLength( rules ) ) {
                this.successList.push( element );
            }
            return true;
        },

        // return the custom message for the given element and validation method
        // specified in the element's HTML5 data attribute
        // return the generic message if present and no method specific message is present
        customDataMessage: function( element, method ) {
            return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
                method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
        },

        // return the custom message for the given element name and validation method
        customMessage: function( name, method ) {
            var m = this.settings.messages[ name ];
            return m && ( m.constructor === String ? m : m[ method ]);
        },

        // return the first defined argument, allowing empty strings
        findDefined: function() {
            for ( var i = 0; i < arguments.length; i++) {
                if ( arguments[ i ] !== undefined ) {
                    return arguments[ i ];
                }
            }
            return undefined;
        },

        defaultMessage: function( element, method ) {
            return this.findDefined(
                this.customMessage( element.name, method ),
                this.customDataMessage( element, method ),
                // title is never undefined, so handle empty string as undefined
                !this.settings.ignoreTitle && element.title || undefined,
                $.validator.messages[ method ],
                "<strong>Warning: No message defined for " + element.name + "</strong>"
            );
        },

        formatAndAdd: function( element, rule ) {
            var message = this.defaultMessage( element, rule.method ),
                theregex = /\$?\{(\d+)\}/g;
            if ( typeof message === "function" ) {
                message = message.call( this, rule.parameters, element );
            } else if ( theregex.test( message ) ) {
                message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
            }
            this.errorList.push({
                message: message,
                element: element,
                method: rule.method
            });

            this.errorMap[ element.name ] = message;
            this.submitted[ element.name ] = message;
        },

        addWrapper: function( toToggle ) {
            if ( this.settings.wrapper ) {
                toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
            }
            return toToggle;
        },

        defaultShowErrors: function() {
            var i, elements, error;
            for ( i = 0; this.errorList[ i ]; i++ ) {
                error = this.errorList[ i ];
                if ( this.settings.highlight ) {
                    this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
                }
                this.showLabel( error.element, error.message );
            }
            if ( this.errorList.length ) {
                this.toShow = this.toShow.add( this.containers );
            }
            if ( this.settings.success ) {
                for ( i = 0; this.successList[ i ]; i++ ) {
                    this.showLabel( this.successList[ i ] );
                }
            }
            if ( this.settings.unhighlight ) {
                for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
                    this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
                }
            }
            this.toHide = this.toHide.not( this.toShow );
            this.hideErrors();
            this.addWrapper( this.toShow ).show();
        },

        validElements: function() {
            return this.currentElements.not( this.invalidElements() );
        },

        invalidElements: function() {
            return $( this.errorList ).map(function() {
                return this.element;
            });
        },

        showLabel: function( element, message ) {
            var place, group, errorID,
                error = this.errorsFor( element ),
                elementID = this.idOrName( element ),
                describedBy = $( element ).attr( "aria-describedby" );
            if ( error.length ) {
                // refresh error/success class
                error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );
                // replace message on existing label
                error.html( message );
            } else {
                // create error element
                error = $( "<" + this.settings.errorElement + ">" )
                    .attr( "id", elementID + "-error" )
                    .addClass( this.settings.errorClass )
                    .html( message || "" );

                // Maintain reference to the element to be placed into the DOM
                place = error;
                if ( this.settings.wrapper ) {
                    // make sure the element is visible, even in IE
                    // actually showing the wrapped element is handled elsewhere
                    place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
                }
                if ( this.labelContainer.length ) {
                    this.labelContainer.append( place );
                } else if ( this.settings.errorPlacement ) {
                    this.settings.errorPlacement( place, $( element ) );
                } else {
                    place.insertAfter( element );
                }

                // Link error back to the element
                if ( error.is( "label" ) ) {
                    // If the error is a label, then associate using 'for'
                    error.attr( "for", elementID );
                } else if ( error.parents( "label[for='" + elementID + "']" ).length === 0 ) {
                    // If the element is not a child of an associated label, then it's necessary
                    // to explicitly apply aria-describedby

                    errorID = error.attr( "id" );
                    // Respect existing non-error aria-describedby
                    if ( !describedBy ) {
                        describedBy = errorID;
                    } else if ( !describedBy.match( new RegExp( "\b" + errorID + "\b" ) ) ) {
                        // Add to end of list if not already present
                        describedBy += " " + errorID;
                    }
                    $( element ).attr( "aria-describedby", describedBy );

                    // If this element is grouped, then assign to all elements in the same group
                    group = this.groups[ element.name ];
                    if ( group ) {
                        $.each( this.groups, function( name, testgroup ) {
                            if ( testgroup === group ) {
                                $( "[name='" + name + "']", this.currentForm )
                                    .attr( "aria-describedby", error.attr( "id" ) );
                            }
                        });
                    }
                }
            }
            if ( !message && this.settings.success ) {
                error.text( "" );
                if ( typeof this.settings.success === "string" ) {
                    error.addClass( this.settings.success );
                } else {
                    this.settings.success( error, element );
                }
            }
            this.toShow = this.toShow.add( error );
        },

        errorsFor: function( element ) {
            var name = this.idOrName( element ),
                describer = $( element ).attr( "aria-describedby" ),
                selector = "label[for='" + name + "'], label[for='" + name + "'] *";
            // aria-describedby should directly reference the error element
            if ( describer ) {
                selector = selector + ", #" + describer.replace( /\s+/g, ", #" );
            }
            return this
                .errors()
                .filter( selector );
        },

        idOrName: function( element ) {
            return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
        },

        validationTargetFor: function( element ) {
            // if radio/checkbox, validate first element in group instead
            if ( this.checkable( element ) ) {
                element = this.findByName( element.name ).not( this.settings.ignore )[ 0 ];
            }
            return element;
        },

        checkable: function( element ) {
            return ( /radio|checkbox/i ).test( element.type );
        },

        findByName: function( name ) {
            return $( this.currentForm ).find( "[name='" + name + "']" );
        },

        getLength: function( value, element ) {
            switch ( element.nodeName.toLowerCase() ) {
            case "select":
                return $( "option:selected", element ).length;
            case "input":
                if ( this.checkable( element ) ) {
                    return this.findByName( element.name ).filter( ":checked" ).length;
                }
            }
            return value.length;
        },

        depend: function( param, element ) {
            return this.dependTypes[typeof param] ? this.dependTypes[typeof param]( param, element ) : true;
        },

        dependTypes: {
            "boolean": function( param ) {
                return param;
            },
            "string": function( param, element ) {
                return !!$( param, element.form ).length;
            },
            "function": function( param, element ) {
                return param( element );
            }
        },

        optional: function( element ) {
            var val = this.elementValue( element );
            return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
        },

        startRequest: function( element ) {
            if ( !this.pending[ element.name ] ) {
                this.pendingRequest++;
                this.pending[ element.name ] = true;
            }
        },

        stopRequest: function( element, valid ) {
            this.pendingRequest--;
            // sometimes synchronization fails, make sure pendingRequest is never < 0
            if ( this.pendingRequest < 0 ) {
                this.pendingRequest = 0;
            }
            delete this.pending[ element.name ];
            if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
                $( this.currentForm ).submit();
                this.formSubmitted = false;
            } else if (!valid && this.pendingRequest === 0 && this.formSubmitted ) {
                $( this.currentForm ).triggerHandler( "invalid-form", [ this ]);
                this.formSubmitted = false;
            }
        },

        previousValue: function( element ) {
            return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
                old: null,
                valid: true,
                message: this.defaultMessage( element, "remote" )
            });
        }

    },

    classRuleSettings: {
        required: { required: true },
        email: { email: true },
        url: { url: true },
        date: { date: true },
        dateISO: { dateISO: true },
        number: { number: true },
        digits: { digits: true },
        creditcard: { creditcard: true }
    },

    addClassRules: function( className, rules ) {
        if ( className.constructor === String ) {
            this.classRuleSettings[ className ] = rules;
        } else {
            $.extend( this.classRuleSettings, className );
        }
    },

    classRules: function( element ) {
        var rules = {},
            classes = $( element ).attr( "class" );

        if ( classes ) {
            $.each( classes.split( " " ), function() {
                if ( this in $.validator.classRuleSettings ) {
                    $.extend( rules, $.validator.classRuleSettings[ this ]);
                }
            });
        }
        return rules;
    },

    attributeRules: function( element ) {
        var rules = {},
            $element = $( element ),
            type = element.getAttribute( "type" ),
            method, value;

        for ( method in $.validator.methods ) {

            // support for <input required> in both html5 and older browsers
            if ( method === "required" ) {
                value = element.getAttribute( method );
                // Some browsers return an empty string for the required attribute
                // and non-HTML5 browsers might have required="" markup
                if ( value === "" ) {
                    value = true;
                }
                // force non-HTML5 browsers to return bool
                value = !!value;
            } else {
                value = $element.attr( method );
            }

            // convert the value to a number for number inputs, and for text for backwards compability
            // allows type="date" and others to be compared as strings
            if ( /min|max/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
                value = Number( value );
            }

            if ( value || value === 0 ) {
                rules[ method ] = value;
            } else if ( type === method && type !== "range" ) {
                // exception: the jquery validate 'range' method
                // does not test for the html5 'range' type
                rules[ method ] = true;
            }
        }

        // maxlength may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
        if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
            delete rules.maxlength;
        }

        return rules;
    },

    dataRules: function( element ) {
        var method, value,
            rules = {}, $element = $( element );
        for ( method in $.validator.methods ) {
            value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );
            if ( value !== undefined ) {
                rules[ method ] = value;
            }
        }
        return rules;
    },

    staticRules: function( element ) {
        var rules = {},
            validator = $.data( element.form, "validator" );

        if ( validator.settings.rules ) {
            rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
        }
        return rules;
    },

    normalizeRules: function( rules, element ) {
        // handle dependency check
        $.each( rules, function( prop, val ) {
            // ignore rule when param is explicitly false, eg. required:false
            if ( val === false ) {
                delete rules[ prop ];
                return;
            }
            if ( val.param || val.depends ) {
                var keepRule = true;
                switch ( typeof val.depends ) {
                case "string":
                    keepRule = !!$( val.depends, element.form ).length;
                    break;
                case "function":
                    keepRule = val.depends.call( element, element );
                    break;
                }
                if ( keepRule ) {
                    rules[ prop ] = val.param !== undefined ? val.param : true;
                } else {
                    delete rules[ prop ];
                }
            }
        });

        // evaluate parameters
        $.each( rules, function( rule, parameter ) {
            rules[ rule ] = $.isFunction( parameter ) ? parameter( element ) : parameter;
        });

        // clean number parameters
        $.each([ "minlength", "maxlength" ], function() {
            if ( rules[ this ] ) {
                rules[ this ] = Number( rules[ this ] );
            }
        });
        $.each([ "rangelength", "range" ], function() {
            var parts;
            if ( rules[ this ] ) {
                if ( $.isArray( rules[ this ] ) ) {
                    rules[ this ] = [ Number( rules[ this ][ 0 ]), Number( rules[ this ][ 1 ] ) ];
                } else if ( typeof rules[ this ] === "string" ) {
                    parts = rules[ this ].replace(/[\[\]]/g, "" ).split( /[\s,]+/ );
                    rules[ this ] = [ Number( parts[ 0 ]), Number( parts[ 1 ] ) ];
                }
            }
        });

        if ( $.validator.autoCreateRanges ) {
            // auto-create ranges
            if ( rules.min && rules.max ) {
                rules.range = [ rules.min, rules.max ];
                delete rules.min;
                delete rules.max;
            }
            if ( rules.minlength && rules.maxlength ) {
                rules.rangelength = [ rules.minlength, rules.maxlength ];
                delete rules.minlength;
                delete rules.maxlength;
            }
        }

        return rules;
    },

    // Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
    normalizeRule: function( data ) {
        if ( typeof data === "string" ) {
            var transformed = {};
            $.each( data.split( /\s/ ), function() {
                transformed[ this ] = true;
            });
            data = transformed;
        }
        return data;
    },

    // http://jqueryvalidation.org/jQuery.validator.addMethod/
    addMethod: function( name, method, message ) {
        $.validator.methods[ name ] = method;
        $.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
        if ( method.length < 3 ) {
            $.validator.addClassRules( name, $.validator.normalizeRule( name ) );
        }
    },

    methods: {

        // http://jqueryvalidation.org/required-method/
        required: function( value, element, param ) {
            // check if dependency is met
            if ( !this.depend( param, element ) ) {
                return "dependency-mismatch";
            }
            if ( element.nodeName.toLowerCase() === "select" ) {
                // could be an array for select-multiple or a string, both are fine this way
                var val = $( element ).val();
                return val && val.length > 0;
            }
            if ( this.checkable( element ) ) {
                return this.getLength( value, element ) > 0;
            }
            return $.trim( value ).length > 0;
        },

        // http://jqueryvalidation.org/email-method/
        email: function( value, element ) {
            // Derived from http://www.whatwg.org/specs/web-apps/current-work/multipage/states-of-the-type-attribute.html#e-mail-state-%28type=email%29
            // and https://www.regular-expressions.info/email.html
            // Retrieved 2018-06-19
            // If you have a problem with this implementation, report a bug against the above spec
            // Or use custom methods to implement your own email validation
            return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])*$/.test( value );
        },

        // http://jqueryvalidation.org/url-method/
        url: function( value, element ) {
            // contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
            return this.optional( element ) || /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test( value );
        },

        // http://jqueryvalidation.org/date-method/
        date: function( value, element ) {
            return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
        },

        // http://jqueryvalidation.org/dateISO-method/
        dateISO: function( value, element ) {
            return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
        },

        // http://jqueryvalidation.org/number-method/
        number: function( value, element ) {
            return this.optional( element ) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
        },

        // http://jqueryvalidation.org/digits-method/
        digits: function( value, element ) {
            return this.optional( element ) || /^\d+$/.test( value );
        },

        // http://jqueryvalidation.org/creditcard-method/
        // based on http://en.wikipedia.org/wiki/Luhn/
        creditcard: function( value, element ) {
            if ( this.optional( element ) ) {
                return "dependency-mismatch";
            }
            // accept only spaces, digits and dashes
            if ( /[^0-9 \-]+/.test( value ) ) {
                return false;
            }
            var nCheck = 0,
                nDigit = 0,
                bEven = false,
                n, cDigit;

            value = value.replace( /\D/g, "" );

            // Basing min and max length on
            // http://developer.ean.com/general_info/Valid_Credit_Card_Types
            if ( value.length < 13 || value.length > 19 ) {
                return false;
            }

            for ( n = value.length - 1; n >= 0; n--) {
                cDigit = value.charAt( n );
                nDigit = parseInt( cDigit, 10 );
                if ( bEven ) {
                    if ( ( nDigit *= 2 ) > 9 ) {
                        nDigit -= 9;
                    }
                }
                nCheck += nDigit;
                bEven = !bEven;
            }

            return ( nCheck % 10 ) === 0;
        },

        // http://jqueryvalidation.org/minlength-method/
        minlength: function( value, element, param ) {
            var length = $.isArray( value ) ? value.length : this.getLength( $.trim( value ), element );
            return this.optional( element ) || length >= param;
        },

        // http://jqueryvalidation.org/maxlength-method/
        maxlength: function( value, element, param ) {
            var length = $.isArray( value ) ? value.length : this.getLength( $.trim( value ), element );
            return this.optional( element ) || length <= param;
        },

        // http://jqueryvalidation.org/rangelength-method/
        rangelength: function( value, element, param ) {
            var length = $.isArray( value ) ? value.length : this.getLength( $.trim( value ), element );
            return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
        },

        // http://jqueryvalidation.org/min-method/
        min: function( value, element, param ) {
            return this.optional( element ) || value >= param;
        },

        // http://jqueryvalidation.org/max-method/
        max: function( value, element, param ) {
            return this.optional( element ) || value <= param;
        },

        // http://jqueryvalidation.org/range-method/
        range: function( value, element, param ) {
            return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
        },

        // http://jqueryvalidation.org/equalTo-method/
        equalTo: function( value, element, param ) {
            // bind to the blur event of the target in order to revalidate whenever the target field is updated
            // TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
            var target = $( param );
            if ( this.settings.onfocusout ) {
                target.unbind( ".validate-equalTo" ).bind( "blur.validate-equalTo", function() {
                    $( element ).valid();
                });
            }
            return value === target.val();
        },

        // http://jqueryvalidation.org/remote-method/
        remote: function( value, element, param ) {
            if ( this.optional( element ) ) {
                return "dependency-mismatch";
            }

            var previous = this.previousValue( element ),
                validator, data;

            if (!this.settings.messages[ element.name ] ) {
                this.settings.messages[ element.name ] = {};
            }
            previous.originalMessage = this.settings.messages[ element.name ].remote;
            this.settings.messages[ element.name ].remote = previous.message;

            param = typeof param === "string" && { url: param } || param;

            if ( previous.old === value ) {
                return previous.valid;
            }

            previous.old = value;
            validator = this;
            this.startRequest( element );
            data = {};
            data[ element.name ] = value;
            $.ajax( $.extend( true, {
                url: param,
                mode: "abort",
                port: "validate" + element.name,
                dataType: "json",
                data: data,
                context: validator.currentForm,
                success: function( response ) {
                    var valid = response === true || response === "true",
                        errors, message, submitted;

                    validator.settings.messages[ element.name ].remote = previous.originalMessage;
                    if ( valid ) {
                        submitted = validator.formSubmitted;
                        validator.prepareElement( element );
                        validator.formSubmitted = submitted;
                        validator.successList.push( element );
                        delete validator.invalid[ element.name ];
                        validator.showErrors();
                    } else {
                        errors = {};
                        message = response || validator.defaultMessage( element, "remote" );
                        errors[ element.name ] = previous.message = $.isFunction( message ) ? message( value ) : message;
                        validator.invalid[ element.name ] = true;
                        validator.showErrors( errors );
                    }
                    previous.valid = valid;
                    validator.stopRequest( element, valid );
                }
            }, param ) );
            return "pending";
        }

    }

});

$.format = function deprecated() {
    throw "$.format has been deprecated. Please use $.validator.format instead.";
};

// ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

var pendingRequests = {},
    ajax;
// Use a prefilter if available (1.5+)
if ( $.ajaxPrefilter ) {
    $.ajaxPrefilter(function( settings, _, xhr ) {
        var port = settings.port;
        if ( settings.mode === "abort" ) {
            if ( pendingRequests[port] ) {
                pendingRequests[port].abort();
            }
            pendingRequests[port] = xhr;
        }
    });
} else {
    // Proxy ajax
    ajax = $.ajax;
    $.ajax = function( settings ) {
        var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
            port = ( "port" in settings ? settings : $.ajaxSettings ).port;
        if ( mode === "abort" ) {
            if ( pendingRequests[port] ) {
                pendingRequests[port].abort();
            }
            pendingRequests[port] = ajax.apply(this, arguments);
            return pendingRequests[port];
        }
        return ajax.apply(this, arguments);
    };
}

// provides delegate(type: String, delegate: Selector, handler: Callback) plugin for easier event delegation
// handler is only called when $(event.target).is(delegate), in the scope of the jquery-object for event.target

$.extend($.fn, {
    validateDelegate: function( delegate, type, handler ) {
        return this.bind(type, function( event ) {
            var target = $(event.target);
            if ( target.is(delegate) ) {
                return handler.apply(target, arguments);
            }
        });
    }
});

}));

$( ".validate" ).each(function( key, form ) {

    $( form ).validate({

        errorPlacement: function( error, element ){
            error.appendTo( element.parent() );
        },

        invalidHandler: function( event, validator ) {

            // Validation event tracking
            var formName = $( validator.currentForm ).attr( "name" ) || "Fixme" + " (" + window.location.pathname + ")";

            $.each( validator.invalid, function( i, val ) {

                dataLayer.push({ 
                    "event": "GAEvent",
                    "eventCategory": "Form validate: " + formName, 
                    "eventAction": i, 
                    "eventLabel": val
                });

            });

        },

        submitHandler: function( form ) {

            if ( !this.beenSubmitted ) {

                this.beenSubmitted = true;

                /* Comment this out to save if we decide to use at some poin
                
                var $form = $( form ),
                    $formName = $form.attr( "name" ),
                    data = $form.serializeArray(),
                    formData = JSON.stringify( data );

                // Submit event tracking
                $.each( JSON.parse( formData ), function( i, val ) {

                    var $field = $( "[name=" + val.name + "]" );

                    // Don't track personally identifiable information
                    if ( $field.attr( "type" ) === "email" || $field.attr( "type" ) === "phone" || $field.attr( "type" ) === "password" ) {
                        return true;
                    }

                    dataLayer.push({ 
                        "event": "GAEvent",
                        "eventCategory": "Form submit: " + $formName, 
                        "eventAction": val.name, 
                        "eventLabel": val.value
                    });

                });

                */

                form.submit();

            }

        }

    });

});

$('.validate-relevant-agents').validate({

     errorPlacement: function(error, element){
          if(element.attr("name") == "branch_id"){

              error.appendTo($('.relevant-select'));

          }else{

              error.appendTo(element.parent());

         }
     },

    submitHandler: function(form) {

        if (!this.beenSubmitted) {

            this.beenSubmitted = true;
            form.submit();

        }

    }

});

(function($) {

    //Helper Function for Caret positioning
    $.fn.caret=function(begin,end){ 
        if(this.length==0) return;
        if (typeof begin == 'number') {
            end = (typeof end == 'number')?end:begin;  
            return this.each(function(){
                if(this.setSelectionRange){
                    this.focus();
                    this.setSelectionRange(begin,end);
                }else if (this.createTextRange){
                    var range = this.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', end);
                    range.moveStart('character', begin);
                    range.select();
                }
            });
        } else {
            if (this[0].setSelectionRange){
                begin = this[0].selectionStart;
                end = this[0].selectionEnd;
            }else if (document.selection && document.selection.createRange){
                var range = document.selection.createRange();           
                begin = 0 - range.duplicate().moveStart('character', -100000);
                end = begin + range.text.length;
            }
            return {begin:begin,end:end};
        }       
    };
})(jQuery);

jQuery.validator.addMethod('zdigits', function(value, element, param) {
    return this.optional(element) || /^\d+$/.test(value);
}, 'Please enter only digits.'); 

jQuery.validator.addMethod('zfloat', function(value, element, param) {
    return this.optional(element) || /^(?:\d+|\d{1,3}(?:\d{3})+)(?:\.\d+)?$/.test(value);
}, 'Please enter only digits.'); 

jQuery.validator.addMethod('maxprice', function(value, element, param) {
    return this.optional(element) || value.replace(/,/g, '') <= param;
}, jQuery.validator.format('Please enter a valid number.')); 

jQuery.validator.addMethod('minprice', function(value, element, param) {
return this.optional(element) || value.replace(/,/g, '') >= param;
}, function (value, element) {
    if ( !element.value) return;
    if ( element.value == 0 ) {
        return 'Please enter a valid number.'; 
    }
    var append = '';
    var stripped = element.value.replace(/\D+/g, '');
    switch (stripped.length) {
        case 1:
            append = '00000';
            break;
        case 2:
            append = '0000';
            break;
        case 3:
            append = '000';
            break;
        case 4:
            append = '00';
            break;
        default:
    }
    return 'Please enter a valid number, i.e. ' + formatThousands(stripped + append) + '.';
});

jQuery.validator.addMethod('zarea', function(value, element, param) {
    var acresRadio = $('#external_size_measure_acres');
    if ( acresRadio.attr('checked') != null ) {
        return this.optional(element) || /^(?:\d+|\d{1,3}(?:\d{3})+)(?:\.\d+)?$/.test(value);
    } else {
        return this.optional(element) || /^\d+$/.test(value);
    }
}, function (value, element) {
    var acresRadio = $('#external_size_measure_acres');
    if ( acresRadio.attr('checked') != null ) {
        return 'Please enter as decimals, e.g. 0.25 or 1.5.';
    } else {
        return 'Please enter only digits.';
    }
});

jQuery.validator.addMethod('postcode', function(value, element, param) {
    return this.optional(element) || /^[A-Z]{1,2}[0-9][0-9A-Z]? *[0-9][A-Z]{2}$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid postcode, e.g. "G46 7LA".')); 

jQuery.validator.addMethod('partialpostcode', function(value, element, param) {
    return this.optional(element) || /^[A-Z]{1,2}[0-9][0-9A-Z]? *([0-9][A-Z]{2})?$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid postcode, e.g. "G46" or "G46 7LA".')); 

jQuery.validator.addMethod('outcode', function(value, element, param) {
    return this.optional(element) || /^[A-Z]{1,2}[0-9][0-9A-Z]?$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid outcode, e.g. "G46".')); 

jQuery.validator.addMethod('incode', function(value, element, param) {
    return this.optional(element) || /^[0-9][A-Z]{2}$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid incode, e.g. "7LA".')); 

jQuery.validator.addMethod('generalpostcode', function(value, element, param) {
    return this.optional(element) || /^[\s\S]{2,12}$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid postcode.'));

// The regexes for telephone and fullname are constructed from the equivalent
// bits of perl code (see Internal::Website::Constraints) but they will be
// somewhat prone to going out of date. Quite possibly we should just replace
// these with some ajax checks.

jQuery.validator.addMethod('telephone', function(value, element, param) {
    return this.optional(element) || /^\+?(\d|\s|[-().,\/\\])*\d(\d|\s|[-().,\/\\])*\s*([-().,\/\\]*(EXTENSION|EXT|X)*\s*[0-9]+[-().,\/\\]*)?$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid telephone number.')); 

jQuery.validator.addMethod('telephonesimple', function(value, element, param) {
    return this.optional(element) || /^(\d|\s|[-+()])*(\d(\d|\s|[-+()])*){7,}$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a valid telephone number.')); 

jQuery.validator.addMethod('fullname', function(value, element, param) {
    return this.optional(element) || /^([-\.'[a-zA-Z\u0081-\uFFFF]*\s+)*(([a-zA-Z\u0081-\uFFFF]*[-'])*[a-zA-Z\u0081-\uFFFF]{2,}([-'][a-zA-Z\u0081-\uFFFF]*)*\s+)+([-\.'a-zA-Z\u0081-\uFFFF]*\s+)*([a-zA-Z\u0081-\uFFFF]*[-'])*[a-zA-Z\u0081-\uFFFF]{2,}([-'][a-zA-Z\u0081-\uFFFF]*)*(,?\s+[-\.'a-zA-Z\u0081-\uFFFF]*)*$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter a full name.')); 

jQuery.validator.addMethod("alphaonly", function(value, element, param) {
    return this.optional(element) || /.[a-zA-Z]+$/.test(jQuery.trim(value).toUpperCase());
}, jQuery.validator.format('Please enter only letters or spaces.'));

jQuery.validator.addMethod('photo', function(value, element, param) {
    return this.optional(element) || value.match(/\.(jpe?g|png|gif|bmp|tiff?)$/i);
}, jQuery.validator.format('Please upload a photo in JPEG, PNG, GIF, BMP or TIFF format.')); 

jQuery.validator.addMethod('ddmmyyyy', function(value, element, param) {
    var valid = false;
    if (value) {
        var dmy = value.split('/');
        valid = (dmy.length == 3) && (!isNaN(Date.parse(dmy[2]+'/'+dmy[1]+'/'+dmy[0])));
    } else if (this.optional(element)) {
        valid = true;
    }
    return valid;
}, jQuery.validator.format('Date must of the format DD/MM/YYYY')); 

function formatThousands(value) {
    return value.replace(/\D+/g, '').split("").reverse().join("").replace(/(\d{3,3})(?=\d+)/gi, '$1,').split("").reverse().join("");
}

String.prototype.reverse = function() {

    var s = "";
    var i = this.length;

    while (i>0) {
        s += this.substring(i-1,i);
        i--;
    }

    return s;

}

/*
 * FancyBox - jQuery Plugin
 * Simple and fancy lightbox alternative
 *
 * Examples and documentation at: http://fancybox.net
 *
 * Copyright (c) 2008 - 2010 Janis Skarnelis
 * That said, it is hardly a one-person project. Many people have submitted bugs, code, and offered their advice freely. Their support is greatly appreciated.
 *
 * Version: 1.3.4 (11/11/2010)
 * Requires: jQuery v1.3+
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 */

;(function($) {
	var tmp, loading, overlay, wrap, outer, content, close, title, nav_left, nav_right,

		selectedIndex = 0, selectedOpts = {}, selectedArray = [], currentIndex = 0, currentOpts = {}, currentArray = [],

		ajaxLoader = null, imgPreloader = new Image(), imgRegExp = /\.(jpg|gif|png|bmp|jpeg)(.*)?$/i, swfRegExp = /[^\.]\.(swf)\s*$/i,

		loadingTimer, loadingFrame = 1,

		titleHeight = 0, titleStr = '', start_pos, final_pos, busy = false, fx = $.extend($('<div/>')[0], { prop: 0 }),

		//isIE6 = $.browser.msie && $.browser.version < 7 && !window.XMLHttpRequest,
        isIE = !+"\v1",
        isIE6 = isIE && window.XMLHttpRequest === undefined,

		/*
		 * Private methods 
		 */

		_abort = function() {
			loading.hide();

			imgPreloader.onerror = imgPreloader.onload = null;

			if (ajaxLoader) {
				ajaxLoader.abort();
			}

			tmp.empty();
		},

		_error = function() {
			if (false === selectedOpts.onError(selectedArray, selectedIndex, selectedOpts)) {
				loading.hide();
				busy = false;
				return;
			}

			selectedOpts.titleShow = false;

			selectedOpts.width = 'auto';
			selectedOpts.height = 'auto';

			tmp.html( '<p id="fancybox-error">The requested content cannot be loaded.<br />Please try again later.</p>' );

			_process_inline();
		},

		_start = function() {
			var obj = selectedArray[ selectedIndex ],
				href, 
				type, 
				title,
				str,
				emb,
				ret;

			_abort();

			selectedOpts = $.extend({}, $.fn.fancybox.defaults, (typeof $(obj).data('fancybox') == 'undefined' ? selectedOpts : $(obj).data('fancybox')));

			ret = selectedOpts.onStart(selectedArray, selectedIndex, selectedOpts);

			if (ret === false) {
				busy = false;
				return;
			} else if (typeof ret == 'object') {
				selectedOpts = $.extend(selectedOpts, ret);
			}

			title = selectedOpts.title || (obj.nodeName ? $(obj).attr('title') : obj.title) || '';

			if (obj.nodeName && !selectedOpts.orig) {
				selectedOpts.orig = $(obj).children("img:first").length ? $(obj).children("img:first") : $(obj);
			}

			if (title === '' && selectedOpts.orig && selectedOpts.titleFromAlt) {
				title = selectedOpts.orig.attr('alt');
			}

			href = selectedOpts.href || (obj.nodeName ? $(obj).attr('href') : obj.href) || null;

			if ((/^(?:javascript)/i).test(href) || href == '#') {
				href = null;
			}

			if (selectedOpts.type) {
				type = selectedOpts.type;

				if (!href) {
					href = selectedOpts.content;
				}

			} else if (selectedOpts.content) {
				type = 'html';

			} else if (href) {
				if (href.match(imgRegExp)) {
					type = 'image';

				} else if (href.match(swfRegExp)) {
					type = 'swf';

				} else if ($(obj).hasClass("iframe")) {
					type = 'iframe';

				} else if (href.indexOf("#") === 0) {
					type = 'inline';

				} else {
					type = 'ajax';
				}
			}

			if (!type) {
				_error();
				return;
			}

			if (type == 'inline') {
				obj	= href.substr(href.indexOf("#"));
				type = $(obj).length > 0 ? 'inline' : 'ajax';
			}

			selectedOpts.type = type;
			selectedOpts.href = href;
			selectedOpts.title = title;

			if (selectedOpts.autoDimensions) {
				if (selectedOpts.type == 'html' || selectedOpts.type == 'inline' || selectedOpts.type == 'ajax') {
					selectedOpts.width = 'auto';
					selectedOpts.height = 'auto';
				} else {
					selectedOpts.autoDimensions = false;	
				}
			}

			if (selectedOpts.modal) {
				selectedOpts.overlayShow = true;
				selectedOpts.hideOnOverlayClick = false;
				selectedOpts.hideOnContentClick = false;
				selectedOpts.enableEscapeButton = false;
				selectedOpts.showCloseButton = false;
			}

			selectedOpts.padding = parseInt(selectedOpts.padding, 10);
			selectedOpts.margin = parseInt(selectedOpts.margin, 10);

			tmp.css('padding', (selectedOpts.padding + selectedOpts.margin));

			$('.fancybox-inline-tmp').unbind('fancybox-cancel').bind('fancybox-change', function() {
				$(this).replaceWith(content.children());				
			});

			switch (type) {
				case 'html' :
					tmp.html( selectedOpts.content );
					_process_inline();
				break;

				case 'inline' :
					if ( $(obj).parent().is('#fancybox-content') === true) {
						busy = false;
						return;
					}

					$('<div class="fancybox-inline-tmp" />')
						.hide()
						.insertBefore( $(obj) )
						.bind('fancybox-cleanup', function() {
							$(this).replaceWith(content.children());
						}).bind('fancybox-cancel', function() {
							$(this).replaceWith(tmp.children());
						});

					$(obj).appendTo(tmp);

					_process_inline();
				break;

				case 'image':
					busy = false;

					$.fancybox.showActivity();

					imgPreloader = new Image();

					imgPreloader.onerror = function() {
						_error();
					};

					imgPreloader.onload = function() {
						busy = true;

						imgPreloader.onerror = imgPreloader.onload = null;

						_process_image();
					};

					imgPreloader.src = href;
				break;

				case 'swf':
					selectedOpts.scrolling = 'no';

					str = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="' + selectedOpts.width + '" height="' + selectedOpts.height + '"><param name="movie" value="' + href + '"></param>';
					emb = '';

					$.each(selectedOpts.swf, function(name, val) {
						str += '<param name="' + name + '" value="' + val + '"></param>';
						emb += ' ' + name + '="' + val + '"';
					});

					str += '<embed src="' + href + '" type="application/x-shockwave-flash" width="' + selectedOpts.width + '" height="' + selectedOpts.height + '"' + emb + '></embed></object>';

					tmp.html(str);

					_process_inline();
				break;

				case 'ajax':
					busy = false;

					$.fancybox.showActivity();

					selectedOpts.ajax.win = selectedOpts.ajax.success;

					ajaxLoader = $.ajax($.extend({}, selectedOpts.ajax, {
						url	: href,
						data : selectedOpts.ajax.data || {},
						error : function(XMLHttpRequest, textStatus, errorThrown) {
							if ( XMLHttpRequest.status > 0 ) {
								_error();
							}
						},
						success : function(data, textStatus, XMLHttpRequest) {
							var o = typeof XMLHttpRequest == 'object' ? XMLHttpRequest : ajaxLoader;
							if (o.status == 200) {
								if ( typeof selectedOpts.ajax.win == 'function' ) {
									ret = selectedOpts.ajax.win(href, data, textStatus, XMLHttpRequest);

									if (ret === false) {
										loading.hide();
										return;
									} else if (typeof ret == 'string' || typeof ret == 'object') {
										data = ret;
									}
								}

								tmp.html( data );
								_process_inline();
							}
						}
					}));

				break;

				case 'iframe':
					_show();
				break;
			}
		},

		_process_inline = function() {
			var
				w = selectedOpts.width,
				h = selectedOpts.height;

			if (w.toString().indexOf('%') > -1) {
				w = parseInt( ($(window).width() - (selectedOpts.margin * 2)) * parseFloat(w) / 100, 10) + 'px';

			} else {
				w = w == 'auto' ? 'auto' : w + 'px';	
			}

			if (h.toString().indexOf('%') > -1) {
				h = parseInt( ($(window).height() - (selectedOpts.margin * 2)) * parseFloat(h) / 100, 10) + 'px';

			} else {
				h = h == 'auto' ? 'auto' : h + 'px';	
			}

			tmp.wrapInner('<div style="width:' + w + ';height:' + h + ';overflow: ' + (selectedOpts.scrolling == 'auto' ? 'auto' : (selectedOpts.scrolling == 'yes' ? 'scroll' : 'hidden')) + ';position:relative;"></div>');

			selectedOpts.width = tmp.width();
			selectedOpts.height = tmp.height();

			_show();
		},

		_process_image = function() {
			selectedOpts.width = imgPreloader.width;
			selectedOpts.height = imgPreloader.height;

			$("<img />").attr({
				'id' : 'fancybox-img',
				'src' : imgPreloader.src,
				'alt' : selectedOpts.title
			}).appendTo( tmp );

			_show();
		},

		_show = function() {
			var pos, equal;

			loading.hide();

			if (wrap.is(":visible") && false === currentOpts.onCleanup(currentArray, currentIndex, currentOpts)) {
				$.event.trigger('fancybox-cancel');

				busy = false;
				return;
			}

			busy = true;

			$(content.add( overlay )).unbind();

			$(window).unbind("resize.fb scroll.fb");
			$(document).unbind('keydown.fb');

			if (wrap.is(":visible") && currentOpts.titlePosition !== 'outside') {
				wrap.css('height', wrap.height());
			}

			currentArray = selectedArray;
			currentIndex = selectedIndex;
			currentOpts = selectedOpts;

			if (currentOpts.overlayShow) {
				overlay.css({
					'background-color' : currentOpts.overlayColor,
					'opacity' : currentOpts.overlayOpacity,
					'cursor' : currentOpts.hideOnOverlayClick ? 'pointer' : 'auto',
					'height' : $(document).height()
				});

				if (!overlay.is(':visible')) {
					if (isIE6) {
						$('select:not(#fancybox-tmp select)').filter(function() {
							return this.style.visibility !== 'hidden';
						}).css({'visibility' : 'hidden'}).one('fancybox-cleanup', function() {
							this.style.visibility = 'inherit';
						});
					}

					overlay.show();
				}
			} else {
				overlay.hide();
			}

			final_pos = _get_zoom_to();

			_process_title();

			if (wrap.is(":visible")) {
				$( close.add( nav_left ).add( nav_right ) ).hide();

				pos = wrap.position(),

				start_pos = {
					top	 : pos.top,
					left : pos.left,
					width : wrap.width(),
					height : wrap.height()
				};

				equal = (start_pos.width == final_pos.width && start_pos.height == final_pos.height);

				content.fadeTo(currentOpts.changeFade, 0.3, function() {
					var finish_resizing = function() {
						content.html( tmp.contents() ).fadeTo(currentOpts.changeFade, 1, _finish);
					};

					$.event.trigger('fancybox-change');

					content
						.empty()
						.removeAttr('filter')
						.css({
							'border-width' : currentOpts.padding,
							'width'	: final_pos.width - currentOpts.padding * 2,
							'height' : selectedOpts.autoDimensions ? 'auto' : final_pos.height - titleHeight - currentOpts.padding * 2
						});

					if (equal) {
						finish_resizing();

					} else {
						fx.prop = 0;

						$(fx).animate({prop: 1}, {
							 duration : currentOpts.changeSpeed,
							 easing : currentOpts.easingChange,
							 step : _draw,
							 complete : finish_resizing
						});
					}
				});

				return;
			}

			wrap.removeAttr("style");

			content.css('border-width', currentOpts.padding);

			if (currentOpts.transitionIn == 'elastic') {
				start_pos = _get_zoom_from();

				content.html( tmp.contents() );

				wrap.show();

				if (currentOpts.opacity) {
					final_pos.opacity = 0;
				}

				fx.prop = 0;

				$(fx).animate({prop: 1}, {
					 duration : currentOpts.speedIn,
					 easing : currentOpts.easingIn,
					 step : _draw,
					 complete : _finish
				});

				return;
			}

			if (currentOpts.titlePosition == 'inside' && titleHeight > 0) {	
				title.show();	
			}

			content
				.css({
					'width' : final_pos.width - currentOpts.padding * 2,
					'height' : selectedOpts.autoDimensions ? 'auto' : final_pos.height - titleHeight - currentOpts.padding * 2
				})
				.html( tmp.contents() );

			wrap
				.css(final_pos)
				.fadeIn( currentOpts.transitionIn == 'none' ? 0 : currentOpts.speedIn, _finish );
		},

		_format_title = function(title) {
			if (title && title.length) {
				if (currentOpts.titlePosition == 'float') {
					return '<table id="fancybox-title-float-wrap" cellpadding="0" cellspacing="0"><tr><td id="fancybox-title-float-left"></td><td id="fancybox-title-float-main">' + title + '</td><td id="fancybox-title-float-right"></td></tr></table>';
				}

				return '<div id="fancybox-title-' + currentOpts.titlePosition + '">' + title + '</div>';
			}

			return false;
		},

		_process_title = function() {
			titleStr = currentOpts.title || '';
			titleHeight = 0;

			title
				.empty()
				.removeAttr('style')
				.removeClass();

			if (currentOpts.titleShow === false) {
				title.hide();
				return;
			}

			titleStr = $.isFunction(currentOpts.titleFormat) ? currentOpts.titleFormat(titleStr, currentArray, currentIndex, currentOpts) : _format_title(titleStr);

			if (!titleStr || titleStr === '') {
				title.hide();
				return;
			}

			title
				.addClass('fancybox-title-' + currentOpts.titlePosition)
				.html( titleStr )
				.appendTo( 'body' )
				.show();

			switch (currentOpts.titlePosition) {
				case 'inside':
					title
						.css({
							'width' : final_pos.width - (currentOpts.padding * 2),
							'marginLeft' : currentOpts.padding,
							'marginRight' : currentOpts.padding
						});

					titleHeight = title.outerHeight(true);

					title.appendTo( outer );

					final_pos.height += titleHeight;
				break;

				case 'over':
					title
						.css({
							'marginLeft' : currentOpts.padding,
							'width'	: final_pos.width - (currentOpts.padding * 2),
							'bottom' : currentOpts.padding
						})
						.appendTo( outer );
				break;

				case 'float':
					title
						.css('left', parseInt((title.width() - final_pos.width - 40)/ 2, 10) * -1)
						.appendTo( wrap );
				break;

				default:
					title
						.css({
							'width' : final_pos.width - (currentOpts.padding * 2),
							'paddingLeft' : currentOpts.padding,
							'paddingRight' : currentOpts.padding
						})
						.appendTo( wrap );
				break;
			}

			title.hide();
		},

		_set_navigation = function() {
			if (currentOpts.enableEscapeButton || currentOpts.enableKeyboardNav) {
				$(document).bind('keydown.fb', function(e) {
					if (e.keyCode == 27 && currentOpts.enableEscapeButton) {
						e.preventDefault();
						$.fancybox.close();

					} else if ((e.keyCode == 37 || e.keyCode == 39) && currentOpts.enableKeyboardNav && e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'SELECT') {
						e.preventDefault();
						$.fancybox[ e.keyCode == 37 ? 'prev' : 'next']();
					}
				});
			}

			if (!currentOpts.showNavArrows) { 
				nav_left.hide();
				nav_right.hide();
				return;
			}

			if ((currentOpts.cyclic && currentArray.length > 1) || currentIndex !== 0) {
				nav_left.show();
			}

			if ((currentOpts.cyclic && currentArray.length > 1) || currentIndex != (currentArray.length -1)) {
				nav_right.show();
			}
		},

		_finish = function () {
			if (!$.support.opacity) {
				content.css('filter', 0);
				wrap.css('filter', 0);
			}

			if (selectedOpts.autoDimensions) {
				content.css('height', 'auto');
			}

			wrap.css('height', 'auto');

			if (titleStr && titleStr.length) {
				title.show();
			}

			if (currentOpts.showCloseButton) {
				close.show();
			}

			_set_navigation();
	
			if (currentOpts.hideOnContentClick)	{
				content.bind('click', $.fancybox.close);
			}

			if (currentOpts.hideOnOverlayClick)	{
				overlay.bind('click', $.fancybox.close);
			}

			$(window).bind("resize.fb", $.fancybox.resize);

			if (currentOpts.centerOnScroll) {
				$(window).bind("scroll.fb", $.fancybox.center);
			}

			if (currentOpts.type == 'iframe') {
				$('<iframe id="fancybox-frame" name="fancybox-frame' + new Date().getTime() + '" frameborder="0" hspace="0" ' + (navigator.userAgent.match(/msie [6]/i) ? 'allowtransparency="true""' : '') + ' scrolling="' + selectedOpts.scrolling + '" src="' + currentOpts.href + '"></iframe>').appendTo(content);
			}

			wrap.show();

			busy = false;

			$.fancybox.center();

			currentOpts.onComplete(currentArray, currentIndex, currentOpts);

			_preload_images();
		},

		_preload_images = function() {
			var href, 
				objNext;

			if ((currentArray.length -1) > currentIndex) {
				href = currentArray[ currentIndex + 1 ].href;

				if (typeof href !== 'undefined' && href.match(imgRegExp)) {
					objNext = new Image();
					objNext.src = href;
				}
			}

			if (currentIndex > 0) {
				href = currentArray[ currentIndex - 1 ].href;

				if (typeof href !== 'undefined' && href.match(imgRegExp)) {
					objNext = new Image();
					objNext.src = href;
				}
			}
		},

		_draw = function(pos) {
			var dim = {
				width : parseInt(start_pos.width + (final_pos.width - start_pos.width) * pos, 10),
				height : parseInt(start_pos.height + (final_pos.height - start_pos.height) * pos, 10),

				top : parseInt(start_pos.top + (final_pos.top - start_pos.top) * pos, 10),
				left : parseInt(start_pos.left + (final_pos.left - start_pos.left) * pos, 10)
			};

			if (typeof final_pos.opacity !== 'undefined') {
				dim.opacity = pos < 0.5 ? 0.5 : pos;
			}

			wrap.css(dim);

			content.css({
				'width' : dim.width - currentOpts.padding * 2,
				'height' : dim.height - (titleHeight * pos) - currentOpts.padding * 2
			});
		},

		_get_viewport = function() {
			return [
				$(window).width() - (currentOpts.margin * 2),
				$(window).height() - (currentOpts.margin * 2),
				$(document).scrollLeft() + currentOpts.margin,
				$(document).scrollTop() + currentOpts.margin
			];
		},

		_get_zoom_to = function () {
			var view = _get_viewport(),
				to = {},
				resize = currentOpts.autoScale,
				double_padding = currentOpts.padding * 2,
				ratio;

			if (currentOpts.width.toString().indexOf('%') > -1) {
				to.width = parseInt((view[0] * parseFloat(currentOpts.width)) / 100, 10);
			} else {
				to.width = currentOpts.width + double_padding;
			}

			if (currentOpts.height.toString().indexOf('%') > -1) {
				to.height = parseInt((view[1] * parseFloat(currentOpts.height)) / 100, 10);
			} else {
				to.height = currentOpts.height + double_padding;
			}

			if (resize && (to.width > view[0] || to.height > view[1])) {
				if (selectedOpts.type == 'image' || selectedOpts.type == 'swf') {
					ratio = (currentOpts.width ) / (currentOpts.height );

					if ((to.width ) > view[0]) {
						to.width = view[0];
						to.height = parseInt(((to.width - double_padding) / ratio) + double_padding, 10);
					}

					if ((to.height) > view[1]) {
						to.height = view[1];
						to.width = parseInt(((to.height - double_padding) * ratio) + double_padding, 10);
					}

				} else {
					to.width = Math.min(to.width, view[0]);
					to.height = Math.min(to.height, view[1]);
				}
			}

			to.top = parseInt(Math.max(view[3] - 20, view[3] + ((view[1] - to.height - 40) * 0.5)), 10);
			to.left = parseInt(Math.max(view[2] - 20, view[2] + ((view[0] - to.width - 40) * 0.5)), 10);

			return to;
		},

		_get_obj_pos = function(obj) {
			var pos = obj.offset();

			pos.top += parseInt( obj.css('paddingTop'), 10 ) || 0;
			pos.left += parseInt( obj.css('paddingLeft'), 10 ) || 0;

			pos.top += parseInt( obj.css('border-top-width'), 10 ) || 0;
			pos.left += parseInt( obj.css('border-left-width'), 10 ) || 0;

			pos.width = obj.width();
			pos.height = obj.height();

			return pos;
		},

		_get_zoom_from = function() {
			var orig = selectedOpts.orig ? $(selectedOpts.orig) : false,
				from = {},
				pos,
				view;

			if (orig && orig.length) {
				pos = _get_obj_pos(orig);

				from = {
					width : pos.width + (currentOpts.padding * 2),
					height : pos.height + (currentOpts.padding * 2),
					top	: pos.top - currentOpts.padding - 20,
					left : pos.left - currentOpts.padding - 20
				};

			} else {
				view = _get_viewport();

				from = {
					width : currentOpts.padding * 2,
					height : currentOpts.padding * 2,
					top	: parseInt(view[3] + view[1] * 0.5, 10),
					left : parseInt(view[2] + view[0] * 0.5, 10)
				};
			}

			return from;
		},

		_animate_loading = function() {
			if (!loading.is(':visible')){
				clearInterval(loadingTimer);
				return;
			}

			$('div', loading).css('top', (loadingFrame * -40) + 'px');

			loadingFrame = (loadingFrame + 1) % 12;
		};

	/*
	 * Public methods 
	 */

	$.fn.fancybox = function(options) {
		if (!$(this).length) {
			return this;
		}

		$(this)
            .data('fancybox', $.extend({}, options, {})) 
			.unbind('click.fb')
			.bind('click.fb', function(e) {
				e.preventDefault();

				if (busy) {
					return;
				}

				busy = true;

				$(this).blur();

				selectedArray = [];
				selectedIndex = 0;

				var rel = $(this).attr('rel') || '';

				if (!rel || rel == '' || rel.match( /(nofollow|noopener|noreferrer)/ )) {
					selectedArray.push(this);

				} else {
					selectedArray = $("a[rel=" + rel + "], area[rel=" + rel + "]");
					selectedIndex = selectedArray.index( this );
				}

				_start();

				return;
			});

		return this;
	};

	$.fancybox = function(obj) {
		var opts;

		if (busy) {
			return;
		}

		busy = true;
		opts = typeof arguments[1] !== 'undefined' ? arguments[1] : {};

		selectedArray = [];
		selectedIndex = parseInt(opts.index, 10) || 0;

		if ($.isArray(obj)) {
			for (var i = 0, j = obj.length; i < j; i++) {
				if (typeof obj[i] == 'object') {
					$(obj[i]).data('fancybox', $.extend({}, opts, obj[i]));
				} else {
					obj[i] = $({}).data('fancybox', $.extend({content : obj[i]}, opts));
				}
			}

			selectedArray = jQuery.merge(selectedArray, obj);

		} else {
			if (typeof obj == 'object') {
				$(obj).data('fancybox', $.extend({}, opts, obj));
			} else {
				obj = $({}).data('fancybox', $.extend({content : obj}, opts));
			}

			selectedArray.push(obj);
		}

		if (selectedIndex > selectedArray.length || selectedIndex < 0) {
			selectedIndex = 0;
		}

		_start();
	};

	$.fancybox.showActivity = function() {
		clearInterval(loadingTimer);

		loading.show();
		loadingTimer = setInterval(_animate_loading, 66);
	};

	$.fancybox.hideActivity = function() {
		loading.hide();
	};

	$.fancybox.next = function() {
		return $.fancybox.pos( currentIndex + 1);
	};

	$.fancybox.prev = function() {
		return $.fancybox.pos( currentIndex - 1);
	};

	$.fancybox.pos = function(pos) {
		if (busy) {
			return;
		}

		pos = parseInt(pos);

		selectedArray = currentArray;

		if (pos > -1 && pos < currentArray.length) {
			selectedIndex = pos;
			_start();

		} else if (currentOpts.cyclic && currentArray.length > 1) {
			selectedIndex = pos >= currentArray.length ? 0 : currentArray.length - 1;
			_start();
		}

		return;
	};

	$.fancybox.cancel = function() {
		if (busy) {
			return;
		}

		busy = true;

		$.event.trigger('fancybox-cancel');

		_abort();

		selectedOpts.onCancel(selectedArray, selectedIndex, selectedOpts);

		busy = false;
	};

	// Note: within an iframe use - parent.$.fancybox.close();
	$.fancybox.close = function() {
		if (busy || wrap.is(':hidden')) {
			return;
		}

		busy = true;

		if (currentOpts && false === currentOpts.onCleanup(currentArray, currentIndex, currentOpts)) {
			busy = false;
			return;
		}

		_abort();

		$(close.add( nav_left ).add( nav_right )).hide();

		$(content.add( overlay )).unbind();

		$(window).unbind("resize.fb scroll.fb");
		$(document).unbind('keydown.fb');

		content.find('iframe').attr('src', isIE6 && /^https/i.test(window.location.href || '') ? 'javascript:void(false)' : 'about:blank');

		if (currentOpts.titlePosition !== 'inside') {
			title.empty();
		}

		wrap.stop();

		function _cleanup() {
			overlay.fadeOut('fast');

			title.empty().hide();
			wrap.hide();

			$.event.trigger('fancybox-cleanup');

			content.empty();

			currentOpts.onClosed(currentArray, currentIndex, currentOpts);

			currentArray = selectedOpts	= [];
			currentIndex = selectedIndex = 0;
			currentOpts = selectedOpts	= {};

			busy = false;
		}

		if (currentOpts.transitionOut == 'elastic') {
			start_pos = _get_zoom_from();

			var pos = wrap.position();

			final_pos = {
				top	 : pos.top ,
				left : pos.left,
				width :	wrap.width(),
				height : wrap.height()
			};

			if (currentOpts.opacity) {
				final_pos.opacity = 1;
			}

			title.empty().hide();

			fx.prop = 1;

			$(fx).animate({ prop: 0 }, {
				 duration : currentOpts.speedOut,
				 easing : currentOpts.easingOut,
				 step : _draw,
				 complete : _cleanup
			});

		} else {
			wrap.fadeOut( currentOpts.transitionOut == 'none' ? 0 : currentOpts.speedOut, _cleanup);
		}
	};

	$.fancybox.resize = function() {
		if (overlay.is(':visible')) {
			overlay.css('height', $(document).height());
		}

		$.fancybox.center(true);
	};

	$.fancybox.center = function() {
		var view, align;

		if (busy) {
			return;	
		}

		align = arguments[0] === true ? 1 : 0;
		view = _get_viewport();

		if (!align && (wrap.width() > view[0] || wrap.height() > view[1])) {
			return;	
		}

		wrap
			.stop()
			.animate({
				'top' : parseInt(Math.max(view[3] - 20, view[3] + ((view[1] - content.height() - 40) * 0.5) - currentOpts.padding)),
				'left' : parseInt(Math.max(view[2] - 20, view[2] + ((view[0] - content.width() - 40) * 0.5) - currentOpts.padding))
			}, typeof arguments[0] == 'number' ? arguments[0] : 200);
	};

	$.fancybox.init = function() {
		if ($("#fancybox-wrap").length) {
			return;
		}

		$('body').append(
			tmp	= $('<div id="fancybox-tmp"></div>'),
			loading	= $('<div id="fancybox-loading"><div></div></div>'),
			overlay	= $('<div id="fancybox-overlay"></div>'),
			wrap = $('<div id="fancybox-wrap"></div>')
		);

		outer = $('<div id="fancybox-outer"></div>')
			.append('<div class="fancybox-bg" id="fancybox-bg-n"></div><div class="fancybox-bg" id="fancybox-bg-ne"></div><div class="fancybox-bg" id="fancybox-bg-e"></div><div class="fancybox-bg" id="fancybox-bg-se"></div><div class="fancybox-bg" id="fancybox-bg-s"></div><div class="fancybox-bg" id="fancybox-bg-sw"></div><div class="fancybox-bg" id="fancybox-bg-w"></div><div class="fancybox-bg" id="fancybox-bg-nw"></div>')
			.appendTo( wrap );

		outer.append(
			content = $('<div id="fancybox-content"></div>'),
			close = $('<a id="fancybox-close"></a>'),
			title = $('<div id="fancybox-title"></div>'),

			nav_left = $('<a href="javascript:;" id="fancybox-left"><span class="fancy-ico" id="fancybox-left-ico"></span></a>'),
			nav_right = $('<a href="javascript:;" id="fancybox-right"><span class="fancy-ico" id="fancybox-right-ico"></span></a>')
		);

		close.click($.fancybox.close);
		loading.click($.fancybox.cancel);

		nav_left.click(function(e) {
			e.preventDefault();
			$.fancybox.prev();
		});

		nav_right.click(function(e) {
			e.preventDefault();
			$.fancybox.next();
		});

		if ($.fn.mousewheel) {
			wrap.bind('mousewheel.fb', function(e, delta) {
				if (busy) {
					e.preventDefault();

				} else if ($(e.target).get(0).clientHeight == 0 || $(e.target).get(0).scrollHeight === $(e.target).get(0).clientHeight) {
					e.preventDefault();
					$.fancybox[ delta > 0 ? 'prev' : 'next']();
				}
			});
		}

		if (!$.support.opacity) {
			wrap.addClass('fancybox-ie');
		}

		if (isIE6) {
			loading.addClass('fancybox-ie6');
			wrap.addClass('fancybox-ie6');

			$('<iframe id="fancybox-hide-sel-frame" src="' + (/^https/i.test(window.location.href || '') ? 'javascript:void(false)' : 'about:blank' ) + '" scrolling="no" border="0" frameborder="0" tabindex="-1"></iframe>').prependTo(outer);
		}
	};

	$.fn.fancybox.defaults = {
		padding : 10,
		margin : 40,
		opacity : false,
		modal : false,
		cyclic : false,
		scrolling : 'auto',	// 'auto', 'yes' or 'no'

		width : 560,
		height : 340,

		autoScale : true,
		autoDimensions : true,
		centerOnScroll : false,

		ajax : {},
		swf : { wmode: 'transparent' },

		hideOnOverlayClick : true,
		hideOnContentClick : false,

		overlayShow : true,
		overlayOpacity : 0.5,
		overlayColor : '#000',

		titleShow : true,
		titlePosition : 'float', // 'float', 'outside', 'inside' or 'over'
		titleFormat : null,
		titleFromAlt : false,

		transitionIn : 'fade', // 'elastic', 'fade' or 'none'
		transitionOut : 'fade', // 'elastic', 'fade' or 'none'

		speedIn : 300,
		speedOut : 300,

		changeSpeed : 300,
		changeFade : 'fast',

		easingIn : 'swing',
		easingOut : 'swing',

		showCloseButton	 : true,
		showNavArrows : true,
		enableEscapeButton : true,
		enableKeyboardNav : true,

		onStart : function(){},
		onCancel : function(){},
		onComplete : function(){},
		onCleanup : function(){},
		onClosed : function(){},
		onError : function(){}
	};

	$(document).ready(function() {
		$.fancybox.init();
	});

})(jQuery);

/*! jQuery UI - v1.11.4 - 2016-01-07
* http://jqueryui.com
* Includes: core.js, widget.js, mouse.js, position.js, accordion.js, autocomplete.js, menu.js, slider.js, tabs.js, tooltip.js
* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function( factory ) {
    if ( typeof define === "function" && define.amd ) {

        // AMD. Register as an anonymous module.
        define([ "jquery" ], factory );
    } else {

        // Browser globals
        factory( jQuery );
    }
}(function( $ ) {
/*!
 * jQuery UI Core 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */


// $.ui might exist from components with no dependencies, e.g., $.ui.position
$.ui = $.ui || {};

$.extend( $.ui, {
    version: "1.11.4",

    keyCode: {
        BACKSPACE: 8,
        COMMA: 188,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        LEFT: 37,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SPACE: 32,
        TAB: 9,
        UP: 38
    }
});

// plugins
$.fn.extend({
    scrollParent: function( includeHidden ) {
        var position = this.css( "position" ),
            excludeStaticParent = position === "absolute",
            overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
            scrollParent = this.parents().filter( function() {
                var parent = $( this );
                if ( excludeStaticParent && parent.css( "position" ) === "static" ) {
                    return false;
                }
                return overflowRegex.test( parent.css( "overflow" ) + parent.css( "overflow-y" ) + parent.css( "overflow-x" ) );
            }).eq( 0 );

        return position === "fixed" || !scrollParent.length ? $( this[ 0 ].ownerDocument || document ) : scrollParent;
    },

    uniqueId: (function() {
        var uuid = 0;

        return function() {
            return this.each(function() {
                if ( !this.id ) {
                    this.id = "ui-id-" + ( ++uuid );
                }
            });
        };
    })(),

    removeUniqueId: function() {
        return this.each(function() {
            if ( /^ui-id-\d+$/.test( this.id ) ) {
                $( this ).removeAttr( "id" );
            }
        });
    }
});

// selectors
function focusable( element, isTabIndexNotNaN ) {
    var map, mapName, img,
        nodeName = element.nodeName.toLowerCase();
    if ( "area" === nodeName ) {
        map = element.parentNode;
        mapName = map.name;
        if ( !element.href || !mapName || map.nodeName.toLowerCase() !== "map" ) {
            return false;
        }
        img = $( "img[usemap='#" + mapName + "']" )[ 0 ];
        return !!img && visible( img );
    }
    return ( /^(input|select|textarea|button|object)$/.test( nodeName ) ?
        !element.disabled :
        "a" === nodeName ?
            element.href || isTabIndexNotNaN :
            isTabIndexNotNaN) &&
        // the element and all of its ancestors must be visible
        visible( element );
}

function visible( element ) {
    return $.expr.filters.visible( element ) &&
        !$( element ).parents().addBack().filter(function() {
            return $.css( this, "visibility" ) === "hidden";
        }).length;
}

$.extend( $.expr[ ":" ], {
    data: $.expr.createPseudo ?
        $.expr.createPseudo(function( dataName ) {
            return function( elem ) {
                return !!$.data( elem, dataName );
            };
        }) :
        // support: jQuery <1.8
        function( elem, i, match ) {
            return !!$.data( elem, match[ 3 ] );
        },

    focusable: function( element ) {
        return focusable( element, !isNaN( $.attr( element, "tabindex" ) ) );
    },

    tabbable: function( element ) {
        var tabIndex = $.attr( element, "tabindex" ),
            isTabIndexNaN = isNaN( tabIndex );
        return ( isTabIndexNaN || tabIndex >= 0 ) && focusable( element, !isTabIndexNaN );
    }
});

// support: jQuery <1.8
if ( !$( "<a>" ).outerWidth( 1 ).jquery ) {
    $.each( [ "Width", "Height" ], function( i, name ) {
        var side = name === "Width" ? [ "Left", "Right" ] : [ "Top", "Bottom" ],
            type = name.toLowerCase(),
            orig = {
                innerWidth: $.fn.innerWidth,
                innerHeight: $.fn.innerHeight,
                outerWidth: $.fn.outerWidth,
                outerHeight: $.fn.outerHeight
            };

        function reduce( elem, size, border, margin ) {
            $.each( side, function() {
                size -= parseFloat( $.css( elem, "padding" + this ) ) || 0;
                if ( border ) {
                    size -= parseFloat( $.css( elem, "border" + this + "Width" ) ) || 0;
                }
                if ( margin ) {
                    size -= parseFloat( $.css( elem, "margin" + this ) ) || 0;
                }
            });
            return size;
        }

        $.fn[ "inner" + name ] = function( size ) {
            if ( size === undefined ) {
                return orig[ "inner" + name ].call( this );
            }

            return this.each(function() {
                $( this ).css( type, reduce( this, size ) + "px" );
            });
        };

        $.fn[ "outer" + name] = function( size, margin ) {
            if ( typeof size !== "number" ) {
                return orig[ "outer" + name ].call( this, size );
            }

            return this.each(function() {
                $( this).css( type, reduce( this, size, true, margin ) + "px" );
            });
        };
    });
}

// support: jQuery <1.8
if ( !$.fn.addBack ) {
    $.fn.addBack = function( selector ) {
        return this.add( selector == null ?
            this.prevObject : this.prevObject.filter( selector )
        );
    };
}

// support: jQuery 1.6.1, 1.6.2 (http://bugs.jquery.com/ticket/9413)
if ( $( "<a>" ).data( "a-b", "a" ).removeData( "a-b" ).data( "a-b" ) ) {
    $.fn.removeData = (function( removeData ) {
        return function( key ) {
            if ( arguments.length ) {
                return removeData.call( this, $.camelCase( key ) );
            } else {
                return removeData.call( this );
            }
        };
    })( $.fn.removeData );
}

// deprecated
$.ui.ie = !!/msie [\w.]+/.exec( navigator.userAgent.toLowerCase() );

$.fn.extend({
    focus: (function( orig ) {
        return function( delay, fn ) {
            return typeof delay === "number" ?
                this.each(function() {
                    var elem = this;
                    setTimeout(function() {
                        $( elem ).focus();
                        if ( fn ) {
                            fn.call( elem );
                        }
                    }, delay );
                }) :
                orig.apply( this, arguments );
        };
    })( $.fn.focus ),

    disableSelection: (function() {
        var eventType = "onselectstart" in document.createElement( "div" ) ?
            "selectstart" :
            "mousedown";

        return function() {
            return this.bind( eventType + ".ui-disableSelection", function( event ) {
                event.preventDefault();
            });
        };
    })(),

    enableSelection: function() {
        return this.unbind( ".ui-disableSelection" );
    },

    zIndex: function( zIndex ) {
        if ( zIndex !== undefined ) {
            return this.css( "zIndex", zIndex );
        }

        if ( this.length ) {
            var elem = $( this[ 0 ] ), position, value;
            while ( elem.length && elem[ 0 ] !== document ) {
                // Ignore z-index if position is set to a value where z-index is ignored by the browser
                // This makes behavior of this function consistent across browsers
                // WebKit always returns auto if the element is positioned
                position = elem.css( "position" );
                if ( position === "absolute" || position === "relative" || position === "fixed" ) {
                    // IE returns 0 when zIndex is not specified
                    // other browsers return a string
                    // we ignore the case of nested elements with an explicit value of 0
                    // <div style="z-index: -10;"><div style="z-index: 0;"></div></div>
                    value = parseInt( elem.css( "zIndex" ), 10 );
                    if ( !isNaN( value ) && value !== 0 ) {
                        return value;
                    }
                }
                elem = elem.parent();
            }
        }

        return 0;
    }
});

// $.ui.plugin is deprecated. Use $.widget() extensions instead.
$.ui.plugin = {
    add: function( module, option, set ) {
        var i,
            proto = $.ui[ module ].prototype;
        for ( i in set ) {
            proto.plugins[ i ] = proto.plugins[ i ] || [];
            proto.plugins[ i ].push( [ option, set[ i ] ] );
        }
    },
    call: function( instance, name, args, allowDisconnected ) {
        var i,
            set = instance.plugins[ name ];

        if ( !set ) {
            return;
        }

        if ( !allowDisconnected && ( !instance.element[ 0 ].parentNode || instance.element[ 0 ].parentNode.nodeType === 11 ) ) {
            return;
        }

        for ( i = 0; i < set.length; i++ ) {
            if ( instance.options[ set[ i ][ 0 ] ] ) {
                set[ i ][ 1 ].apply( instance.element, args );
            }
        }
    }
};


/*!
 * jQuery UI Widget 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/jQuery.widget/
 */


var widget_uuid = 0,
    widget_slice = Array.prototype.slice;

$.cleanData = (function( orig ) {
    return function( elems ) {
        var events, elem, i;
        for ( i = 0; (elem = elems[i]) != null; i++ ) {
            try {

                // Only trigger remove when necessary to save time
                events = $._data( elem, "events" );
                if ( events && events.remove ) {
                    $( elem ).triggerHandler( "remove" );
                }

            // http://bugs.jquery.com/ticket/8235
            } catch ( e ) {}
        }
        orig( elems );
    };
})( $.cleanData );

$.widget = function( name, base, prototype ) {
    var fullName, existingConstructor, constructor, basePrototype,
        // proxiedPrototype allows the provided prototype to remain unmodified
        // so that it can be used as a mixin for multiple widgets (#8876)
        proxiedPrototype = {},
        namespace = name.split( "." )[ 0 ];

    name = name.split( "." )[ 1 ];
    fullName = namespace + "-" + name;

    if ( !prototype ) {
        prototype = base;
        base = $.Widget;
    }

    // create selector for plugin
    $.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
        return !!$.data( elem, fullName );
    };

    $[ namespace ] = $[ namespace ] || {};
    existingConstructor = $[ namespace ][ name ];
    constructor = $[ namespace ][ name ] = function( options, element ) {
        // allow instantiation without "new" keyword
        if ( !this._createWidget ) {
            return new constructor( options, element );
        }

        // allow instantiation without initializing for simple inheritance
        // must use "new" keyword (the code above always passes args)
        if ( arguments.length ) {
            this._createWidget( options, element );
        }
    };
    // extend with the existing constructor to carry over any static properties
    $.extend( constructor, existingConstructor, {
        version: prototype.version,
        // copy the object used to create the prototype in case we need to
        // redefine the widget later
        _proto: $.extend( {}, prototype ),
        // track widgets that inherit from this widget in case this widget is
        // redefined after a widget inherits from it
        _childConstructors: []
    });

    basePrototype = new base();
    // we need to make the options hash a property directly on the new instance
    // otherwise we'll modify the options hash on the prototype that we're
    // inheriting from
    basePrototype.options = $.widget.extend( {}, basePrototype.options );
    $.each( prototype, function( prop, value ) {
        if ( !$.isFunction( value ) ) {
            proxiedPrototype[ prop ] = value;
            return;
        }
        proxiedPrototype[ prop ] = (function() {
            var _super = function() {
                    return base.prototype[ prop ].apply( this, arguments );
                },
                _superApply = function( args ) {
                    return base.prototype[ prop ].apply( this, args );
                };
            return function() {
                var __super = this._super,
                    __superApply = this._superApply,
                    returnValue;

                this._super = _super;
                this._superApply = _superApply;

                returnValue = value.apply( this, arguments );

                this._super = __super;
                this._superApply = __superApply;

                return returnValue;
            };
        })();
    });
    constructor.prototype = $.widget.extend( basePrototype, {
        // TODO: remove support for widgetEventPrefix
        // always use the name + a colon as the prefix, e.g., draggable:start
        // don't prefix for widgets that aren't DOM-based
        widgetEventPrefix: existingConstructor ? (basePrototype.widgetEventPrefix || name) : name
    }, proxiedPrototype, {
        constructor: constructor,
        namespace: namespace,
        widgetName: name,
        widgetFullName: fullName
    });

    // If this widget is being redefined then we need to find all widgets that
    // are inheriting from it and redefine all of them so that they inherit from
    // the new version of this widget. We're essentially trying to replace one
    // level in the prototype chain.
    if ( existingConstructor ) {
        $.each( existingConstructor._childConstructors, function( i, child ) {
            var childPrototype = child.prototype;

            // redefine the child widget using the same prototype that was
            // originally used, but inherit from the new version of the base
            $.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor, child._proto );
        });
        // remove the list of existing child constructors from the old constructor
        // so the old child constructors can be garbage collected
        delete existingConstructor._childConstructors;
    } else {
        base._childConstructors.push( constructor );
    }

    $.widget.bridge( name, constructor );

    return constructor;
};

$.widget.extend = function( target ) {
    var input = widget_slice.call( arguments, 1 ),
        inputIndex = 0,
        inputLength = input.length,
        key,
        value;
    for ( ; inputIndex < inputLength; inputIndex++ ) {
        for ( key in input[ inputIndex ] ) {
            value = input[ inputIndex ][ key ];
            if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
                // Clone objects
                if ( $.isPlainObject( value ) ) {
                    target[ key ] = $.isPlainObject( target[ key ] ) ?
                        $.widget.extend( {}, target[ key ], value ) :
                        // Don't extend strings, arrays, etc. with objects
                        $.widget.extend( {}, value );
                // Copy everything else by reference
                } else {
                    target[ key ] = value;
                }
            }
        }
    }
    return target;
};

$.widget.bridge = function( name, object ) {
    var fullName = object.prototype.widgetFullName || name;
    $.fn[ name ] = function( options ) {
        var isMethodCall = typeof options === "string",
            args = widget_slice.call( arguments, 1 ),
            returnValue = this;

        if ( isMethodCall ) {
            this.each(function() {
                var methodValue,
                    instance = $.data( this, fullName );
                if ( options === "instance" ) {
                    returnValue = instance;
                    return false;
                }
                if ( !instance ) {
                    return $.error( "cannot call methods on " + name + " prior to initialization; " +
                        "attempted to call method '" + options + "'" );
                }
                if ( !$.isFunction( instance[options] ) || options.charAt( 0 ) === "_" ) {
                    return $.error( "no such method '" + options + "' for " + name + " widget instance" );
                }
                methodValue = instance[ options ].apply( instance, args );
                if ( methodValue !== instance && methodValue !== undefined ) {
                    returnValue = methodValue && methodValue.jquery ?
                        returnValue.pushStack( methodValue.get() ) :
                        methodValue;
                    return false;
                }
            });
        } else {

            // Allow multiple hashes to be passed on init
            if ( args.length ) {
                options = $.widget.extend.apply( null, [ options ].concat(args) );
            }

            this.each(function() {
                var instance = $.data( this, fullName );
                if ( instance ) {
                    instance.option( options || {} );
                    if ( instance._init ) {
                        instance._init();
                    }
                } else {
                    $.data( this, fullName, new object( options, this ) );
                }
            });
        }

        return returnValue;
    };
};

$.Widget = function( /* options, element */ ) {};
$.Widget._childConstructors = [];

$.Widget.prototype = {
    widgetName: "widget",
    widgetEventPrefix: "",
    defaultElement: "<div>",
    options: {
        disabled: false,

        // callbacks
        create: null
    },
    _createWidget: function( options, element ) {
        element = $( element || this.defaultElement || this )[ 0 ];
        this.element = $( element );
        this.uuid = widget_uuid++;
        this.eventNamespace = "." + this.widgetName + this.uuid;

        this.bindings = $();
        this.hoverable = $();
        this.focusable = $();

        if ( element !== this ) {
            $.data( element, this.widgetFullName, this );
            this._on( true, this.element, {
                remove: function( event ) {
                    if ( event.target === element ) {
                        this.destroy();
                    }
                }
            });
            this.document = $( element.style ?
                // element within the document
                element.ownerDocument :
                // element is window or document
                element.document || element );
            this.window = $( this.document[0].defaultView || this.document[0].parentWindow );
        }

        this.options = $.widget.extend( {},
            this.options,
            this._getCreateOptions(),
            options );

        this._create();
        this._trigger( "create", null, this._getCreateEventData() );
        this._init();
    },
    _getCreateOptions: $.noop,
    _getCreateEventData: $.noop,
    _create: $.noop,
    _init: $.noop,

    destroy: function() {
        this._destroy();
        // we can probably remove the unbind calls in 2.0
        // all event bindings should go through this._on()
        this.element
            .unbind( this.eventNamespace )
            .removeData( this.widgetFullName )
            // support: jquery <1.6.3
            // http://bugs.jquery.com/ticket/9413
            .removeData( $.camelCase( this.widgetFullName ) );
        this.widget()
            .unbind( this.eventNamespace )
            .removeAttr( "aria-disabled" )
            .removeClass(
                this.widgetFullName + "-disabled " +
                "ui-state-disabled" );

        // clean up events and states
        this.bindings.unbind( this.eventNamespace );
        this.hoverable.removeClass( "ui-state-hover" );
        this.focusable.removeClass( "ui-state-focus" );
    },
    _destroy: $.noop,

    widget: function() {
        return this.element;
    },

    option: function( key, value ) {
        var options = key,
            parts,
            curOption,
            i;

        if ( arguments.length === 0 ) {
            // don't return a reference to the internal hash
            return $.widget.extend( {}, this.options );
        }

        if ( typeof key === "string" ) {
            // handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
            options = {};
            parts = key.split( "." );
            key = parts.shift();
            if ( parts.length ) {
                curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
                for ( i = 0; i < parts.length - 1; i++ ) {
                    curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
                    curOption = curOption[ parts[ i ] ];
                }
                key = parts.pop();
                if ( arguments.length === 1 ) {
                    return curOption[ key ] === undefined ? null : curOption[ key ];
                }
                curOption[ key ] = value;
            } else {
                if ( arguments.length === 1 ) {
                    return this.options[ key ] === undefined ? null : this.options[ key ];
                }
                options[ key ] = value;
            }
        }

        this._setOptions( options );

        return this;
    },
    _setOptions: function( options ) {
        var key;

        for ( key in options ) {
            this._setOption( key, options[ key ] );
        }

        return this;
    },
    _setOption: function( key, value ) {
        this.options[ key ] = value;

        if ( key === "disabled" ) {
            this.widget()
                .toggleClass( this.widgetFullName + "-disabled", !!value );

            // If the widget is becoming disabled, then nothing is interactive
            if ( value ) {
                this.hoverable.removeClass( "ui-state-hover" );
                this.focusable.removeClass( "ui-state-focus" );
            }
        }

        return this;
    },

    enable: function() {
        return this._setOptions({ disabled: false });
    },
    disable: function() {
        return this._setOptions({ disabled: true });
    },

    _on: function( suppressDisabledCheck, element, handlers ) {
        var delegateElement,
            instance = this;

        // no suppressDisabledCheck flag, shuffle arguments
        if ( typeof suppressDisabledCheck !== "boolean" ) {
            handlers = element;
            element = suppressDisabledCheck;
            suppressDisabledCheck = false;
        }

        // no element argument, shuffle and use this.element
        if ( !handlers ) {
            handlers = element;
            element = this.element;
            delegateElement = this.widget();
        } else {
            element = delegateElement = $( element );
            this.bindings = this.bindings.add( element );
        }

        $.each( handlers, function( event, handler ) {
            function handlerProxy() {
                // allow widgets to customize the disabled handling
                // - disabled as an array instead of boolean
                // - disabled class as method for disabling individual parts
                if ( !suppressDisabledCheck &&
                        ( instance.options.disabled === true ||
                            $( this ).hasClass( "ui-state-disabled" ) ) ) {
                    return;
                }
                return ( typeof handler === "string" ? instance[ handler ] : handler )
                    .apply( instance, arguments );
            }

            // copy the guid so direct unbinding works
            if ( typeof handler !== "string" ) {
                handlerProxy.guid = handler.guid =
                    handler.guid || handlerProxy.guid || $.guid++;
            }

            var match = event.match( /^([\w:-]*)\s*(.*)$/ ),
                eventName = match[1] + instance.eventNamespace,
                selector = match[2];
            if ( selector ) {
                delegateElement.delegate( selector, eventName, handlerProxy );
            } else {
                element.bind( eventName, handlerProxy );
            }
        });
    },

    _off: function( element, eventName ) {
        eventName = (eventName || "").split( " " ).join( this.eventNamespace + " " ) +
            this.eventNamespace;
        element.unbind( eventName ).undelegate( eventName );

        // Clear the stack to avoid memory leaks (#10056)
        this.bindings = $( this.bindings.not( element ).get() );
        this.focusable = $( this.focusable.not( element ).get() );
        this.hoverable = $( this.hoverable.not( element ).get() );
    },

    _delay: function( handler, delay ) {
        function handlerProxy() {
            return ( typeof handler === "string" ? instance[ handler ] : handler )
                .apply( instance, arguments );
        }
        var instance = this;
        return setTimeout( handlerProxy, delay || 0 );
    },

    _hoverable: function( element ) {
        this.hoverable = this.hoverable.add( element );
        this._on( element, {
            mouseenter: function( event ) {
                $( event.currentTarget ).addClass( "ui-state-hover" );
            },
            mouseleave: function( event ) {
                $( event.currentTarget ).removeClass( "ui-state-hover" );
            }
        });
    },

    _focusable: function( element ) {
        this.focusable = this.focusable.add( element );
        this._on( element, {
            focusin: function( event ) {
                $( event.currentTarget ).addClass( "ui-state-focus" );
            },
            focusout: function( event ) {
                $( event.currentTarget ).removeClass( "ui-state-focus" );
            }
        });
    },

    _trigger: function( type, event, data ) {
        var prop, orig,
            callback = this.options[ type ];

        data = data || {};
        event = $.Event( event );
        event.type = ( type === this.widgetEventPrefix ?
            type :
            this.widgetEventPrefix + type ).toLowerCase();
        // the original event may come from any element
        // so we need to reset the target on the new event
        event.target = this.element[ 0 ];

        // copy original event properties over to the new event
        orig = event.originalEvent;
        if ( orig ) {
            for ( prop in orig ) {
                if ( !( prop in event ) ) {
                    event[ prop ] = orig[ prop ];
                }
            }
        }

        this.element.trigger( event, data );
        return !( $.isFunction( callback ) &&
            callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
            event.isDefaultPrevented() );
    }
};

$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
    $.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
        if ( typeof options === "string" ) {
            options = { effect: options };
        }
        var hasOptions,
            effectName = !options ?
                method :
                options === true || typeof options === "number" ?
                    defaultEffect :
                    options.effect || defaultEffect;
        options = options || {};
        if ( typeof options === "number" ) {
            options = { duration: options };
        }
        hasOptions = !$.isEmptyObject( options );
        options.complete = callback;
        if ( options.delay ) {
            element.delay( options.delay );
        }
        if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
            element[ method ]( options );
        } else if ( effectName !== method && element[ effectName ] ) {
            element[ effectName ]( options.duration, options.easing, callback );
        } else {
            element.queue(function( next ) {
                $( this )[ method ]();
                if ( callback ) {
                    callback.call( element[ 0 ] );
                }
                next();
            });
        }
    };
});

var widget = $.widget;


/*!
 * jQuery UI Mouse 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/mouse/
 */


var mouseHandled = false;
$( document ).mouseup( function() {
    mouseHandled = false;
});

var mouse = $.widget("ui.mouse", {
    version: "1.11.4",
    options: {
        cancel: "input,textarea,button,select,option",
        distance: 1,
        delay: 0
    },
    _mouseInit: function() {
        var that = this;

        this.element
            .bind("mousedown." + this.widgetName, function(event) {
                return that._mouseDown(event);
            })
            .bind("click." + this.widgetName, function(event) {
                if (true === $.data(event.target, that.widgetName + ".preventClickEvent")) {
                    $.removeData(event.target, that.widgetName + ".preventClickEvent");
                    event.stopImmediatePropagation();
                    return false;
                }
            });

        this.started = false;
    },

    // TODO: make sure destroying one instance of mouse doesn't mess with
    // other instances of mouse
    _mouseDestroy: function() {
        this.element.unbind("." + this.widgetName);
        if ( this._mouseMoveDelegate ) {
            this.document
                .unbind("mousemove." + this.widgetName, this._mouseMoveDelegate)
                .unbind("mouseup." + this.widgetName, this._mouseUpDelegate);
        }
    },

    _mouseDown: function(event) {
        // don't let more than one widget handle mouseStart
        if ( mouseHandled ) {
            return;
        }

        this._mouseMoved = false;

        // we may have missed mouseup (out of window)
        (this._mouseStarted && this._mouseUp(event));

        this._mouseDownEvent = event;

        var that = this,
            btnIsLeft = (event.which === 1),
            // event.target.nodeName works around a bug in IE 8 with
            // disabled inputs (#7620)
            elIsCancel = (typeof this.options.cancel === "string" && event.target.nodeName ? $(event.target).closest(this.options.cancel).length : false);
        if (!btnIsLeft || elIsCancel || !this._mouseCapture(event)) {
            return true;
        }

        this.mouseDelayMet = !this.options.delay;
        if (!this.mouseDelayMet) {
            this._mouseDelayTimer = setTimeout(function() {
                that.mouseDelayMet = true;
            }, this.options.delay);
        }

        if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
            this._mouseStarted = (this._mouseStart(event) !== false);
            if (!this._mouseStarted) {
                event.preventDefault();
                return true;
            }
        }

        // Click event may never have fired (Gecko & Opera)
        if (true === $.data(event.target, this.widgetName + ".preventClickEvent")) {
            $.removeData(event.target, this.widgetName + ".preventClickEvent");
        }

        // these delegates are required to keep context
        this._mouseMoveDelegate = function(event) {
            return that._mouseMove(event);
        };
        this._mouseUpDelegate = function(event) {
            return that._mouseUp(event);
        };

        this.document
            .bind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
            .bind( "mouseup." + this.widgetName, this._mouseUpDelegate );

        event.preventDefault();

        mouseHandled = true;
        return true;
    },

    _mouseMove: function(event) {
        // Only check for mouseups outside the document if you've moved inside the document
        // at least once. This prevents the firing of mouseup in the case of IE<9, which will
        // fire a mousemove event if content is placed under the cursor. See #7778
        // Support: IE <9
        if ( this._mouseMoved ) {
            // IE mouseup check - mouseup happened when mouse was out of window
            if ($.ui.ie && ( !document.documentMode || document.documentMode < 9 ) && !event.button) {
                return this._mouseUp(event);

            // Iframe mouseup check - mouseup occurred in another document
            } else if ( !event.which ) {
                return this._mouseUp( event );
            }
        }

        if ( event.which || event.button ) {
            this._mouseMoved = true;
        }

        if (this._mouseStarted) {
            this._mouseDrag(event);
            return event.preventDefault();
        }

        if (this._mouseDistanceMet(event) && this._mouseDelayMet(event)) {
            this._mouseStarted =
                (this._mouseStart(this._mouseDownEvent, event) !== false);
            (this._mouseStarted ? this._mouseDrag(event) : this._mouseUp(event));
        }

        return !this._mouseStarted;
    },

    _mouseUp: function(event) {
        this.document
            .unbind( "mousemove." + this.widgetName, this._mouseMoveDelegate )
            .unbind( "mouseup." + this.widgetName, this._mouseUpDelegate );

        if (this._mouseStarted) {
            this._mouseStarted = false;

            if (event.target === this._mouseDownEvent.target) {
                $.data(event.target, this.widgetName + ".preventClickEvent", true);
            }

            this._mouseStop(event);
        }

        mouseHandled = false;
        return false;
    },

    _mouseDistanceMet: function(event) {
        return (Math.max(
                Math.abs(this._mouseDownEvent.pageX - event.pageX),
                Math.abs(this._mouseDownEvent.pageY - event.pageY)
            ) >= this.options.distance
        );
    },

    _mouseDelayMet: function(/* event */) {
        return this.mouseDelayMet;
    },

    // These are placeholder methods, to be overriden by extending plugin
    _mouseStart: function(/* event */) {},
    _mouseDrag: function(/* event */) {},
    _mouseStop: function(/* event */) {},
    _mouseCapture: function(/* event */) { return true; }
});


/*!
 * jQuery UI Position 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/position/
 */

(function() {

$.ui = $.ui || {};

var cachedScrollbarWidth, supportsOffsetFractions,
    max = Math.max,
    abs = Math.abs,
    round = Math.round,
    rhorizontal = /left|center|right/,
    rvertical = /top|center|bottom/,
    roffset = /[\+\-]\d+(\.[\d]+)?%?/,
    rposition = /^\w+/,
    rpercent = /%$/,
    _position = $.fn.position;

function getOffsets( offsets, width, height ) {
    return [
        parseFloat( offsets[ 0 ] ) * ( rpercent.test( offsets[ 0 ] ) ? width / 100 : 1 ),
        parseFloat( offsets[ 1 ] ) * ( rpercent.test( offsets[ 1 ] ) ? height / 100 : 1 )
    ];
}

function parseCss( element, property ) {
    return parseInt( $.css( element, property ), 10 ) || 0;
}

function getDimensions( elem ) {
    var raw = elem[0];
    if ( raw.nodeType === 9 ) {
        return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: 0, left: 0 }
        };
    }
    if ( $.isWindow( raw ) ) {
        return {
            width: elem.width(),
            height: elem.height(),
            offset: { top: elem.scrollTop(), left: elem.scrollLeft() }
        };
    }
    if ( raw.preventDefault ) {
        return {
            width: 0,
            height: 0,
            offset: { top: raw.pageY, left: raw.pageX }
        };
    }
    return {
        width: elem.outerWidth(),
        height: elem.outerHeight(),
        offset: elem.offset()
    };
}

$.position = {
    scrollbarWidth: function() {
        if ( cachedScrollbarWidth !== undefined ) {
            return cachedScrollbarWidth;
        }
        var w1, w2,
            div = $( "<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>" ),
            innerDiv = div.children()[0];

        $( "body" ).append( div );
        w1 = innerDiv.offsetWidth;
        div.css( "overflow", "scroll" );

        w2 = innerDiv.offsetWidth;

        if ( w1 === w2 ) {
            w2 = div[0].clientWidth;
        }

        div.remove();

        return (cachedScrollbarWidth = w1 - w2);
    },
    getScrollInfo: function( within ) {
        var overflowX = within.isWindow || within.isDocument ? "" :
                within.element.css( "overflow-x" ),
            overflowY = within.isWindow || within.isDocument ? "" :
                within.element.css( "overflow-y" ),
            hasOverflowX = overflowX === "scroll" ||
                ( overflowX === "auto" && within.width < within.element[0].scrollWidth ),
            hasOverflowY = overflowY === "scroll" ||
                ( overflowY === "auto" && within.height < within.element[0].scrollHeight );
        return {
            width: hasOverflowY ? $.position.scrollbarWidth() : 0,
            height: hasOverflowX ? $.position.scrollbarWidth() : 0
        };
    },
    getWithinInfo: function( element ) {
        var withinElement = $( element || window ),
            isWindow = $.isWindow( withinElement[0] ),
            isDocument = !!withinElement[ 0 ] && withinElement[ 0 ].nodeType === 9;
        return {
            element: withinElement,
            isWindow: isWindow,
            isDocument: isDocument,
            offset: withinElement.offset() || { left: 0, top: 0 },
            scrollLeft: withinElement.scrollLeft(),
            scrollTop: withinElement.scrollTop(),

            // support: jQuery 1.6.x
            // jQuery 1.6 doesn't support .outerWidth/Height() on documents or windows
            width: isWindow || isDocument ? withinElement.width() : withinElement.outerWidth(),
            height: isWindow || isDocument ? withinElement.height() : withinElement.outerHeight()
        };
    }
};

$.fn.position = function( options ) {
    if ( !options || !options.of ) {
        return _position.apply( this, arguments );
    }

    // make a copy, we don't want to modify arguments
    options = $.extend( {}, options );

    var atOffset, targetWidth, targetHeight, targetOffset, basePosition, dimensions,
        target = $( options.of ),
        within = $.position.getWithinInfo( options.within ),
        scrollInfo = $.position.getScrollInfo( within ),
        collision = ( options.collision || "flip" ).split( " " ),
        offsets = {};

    dimensions = getDimensions( target );
    if ( target[0].preventDefault ) {
        // force left top to allow flipping
        options.at = "left top";
    }
    targetWidth = dimensions.width;
    targetHeight = dimensions.height;
    targetOffset = dimensions.offset;
    // clone to reuse original targetOffset later
    basePosition = $.extend( {}, targetOffset );

    // force my and at to have valid horizontal and vertical positions
    // if a value is missing or invalid, it will be converted to center
    $.each( [ "my", "at" ], function() {
        var pos = ( options[ this ] || "" ).split( " " ),
            horizontalOffset,
            verticalOffset;

        if ( pos.length === 1) {
            pos = rhorizontal.test( pos[ 0 ] ) ?
                pos.concat( [ "center" ] ) :
                rvertical.test( pos[ 0 ] ) ?
                    [ "center" ].concat( pos ) :
                    [ "center", "center" ];
        }
        pos[ 0 ] = rhorizontal.test( pos[ 0 ] ) ? pos[ 0 ] : "center";
        pos[ 1 ] = rvertical.test( pos[ 1 ] ) ? pos[ 1 ] : "center";

        // calculate offsets
        horizontalOffset = roffset.exec( pos[ 0 ] );
        verticalOffset = roffset.exec( pos[ 1 ] );
        offsets[ this ] = [
            horizontalOffset ? horizontalOffset[ 0 ] : 0,
            verticalOffset ? verticalOffset[ 0 ] : 0
        ];

        // reduce to just the positions without the offsets
        options[ this ] = [
            rposition.exec( pos[ 0 ] )[ 0 ],
            rposition.exec( pos[ 1 ] )[ 0 ]
        ];
    });

    // normalize collision option
    if ( collision.length === 1 ) {
        collision[ 1 ] = collision[ 0 ];
    }

    if ( options.at[ 0 ] === "right" ) {
        basePosition.left += targetWidth;
    } else if ( options.at[ 0 ] === "center" ) {
        basePosition.left += targetWidth / 2;
    }

    if ( options.at[ 1 ] === "bottom" ) {
        basePosition.top += targetHeight;
    } else if ( options.at[ 1 ] === "center" ) {
        basePosition.top += targetHeight / 2;
    }

    atOffset = getOffsets( offsets.at, targetWidth, targetHeight );
    basePosition.left += atOffset[ 0 ];
    basePosition.top += atOffset[ 1 ];

    return this.each(function() {
        var collisionPosition, using,
            elem = $( this ),
            elemWidth = elem.outerWidth(),
            elemHeight = elem.outerHeight(),
            marginLeft = parseCss( this, "marginLeft" ),
            marginTop = parseCss( this, "marginTop" ),
            collisionWidth = elemWidth + marginLeft + parseCss( this, "marginRight" ) + scrollInfo.width,
            collisionHeight = elemHeight + marginTop + parseCss( this, "marginBottom" ) + scrollInfo.height,
            position = $.extend( {}, basePosition ),
            myOffset = getOffsets( offsets.my, elem.outerWidth(), elem.outerHeight() );

        if ( options.my[ 0 ] === "right" ) {
            position.left -= elemWidth;
        } else if ( options.my[ 0 ] === "center" ) {
            position.left -= elemWidth / 2;
        }

        if ( options.my[ 1 ] === "bottom" ) {
            position.top -= elemHeight;
        } else if ( options.my[ 1 ] === "center" ) {
            position.top -= elemHeight / 2;
        }

        position.left += myOffset[ 0 ];
        position.top += myOffset[ 1 ];

        // if the browser doesn't support fractions, then round for consistent results
        if ( !supportsOffsetFractions ) {
            position.left = round( position.left );
            position.top = round( position.top );
        }

        collisionPosition = {
            marginLeft: marginLeft,
            marginTop: marginTop
        };

        $.each( [ "left", "top" ], function( i, dir ) {
            if ( $.ui.position[ collision[ i ] ] ) {
                $.ui.position[ collision[ i ] ][ dir ]( position, {
                    targetWidth: targetWidth,
                    targetHeight: targetHeight,
                    elemWidth: elemWidth,
                    elemHeight: elemHeight,
                    collisionPosition: collisionPosition,
                    collisionWidth: collisionWidth,
                    collisionHeight: collisionHeight,
                    offset: [ atOffset[ 0 ] + myOffset[ 0 ], atOffset [ 1 ] + myOffset[ 1 ] ],
                    my: options.my,
                    at: options.at,
                    within: within,
                    elem: elem
                });
            }
        });

        if ( options.using ) {
            // adds feedback as second argument to using callback, if present
            using = function( props ) {
                var left = targetOffset.left - position.left,
                    right = left + targetWidth - elemWidth,
                    top = targetOffset.top - position.top,
                    bottom = top + targetHeight - elemHeight,
                    feedback = {
                        target: {
                            element: target,
                            left: targetOffset.left,
                            top: targetOffset.top,
                            width: targetWidth,
                            height: targetHeight
                        },
                        element: {
                            element: elem,
                            left: position.left,
                            top: position.top,
                            width: elemWidth,
                            height: elemHeight
                        },
                        horizontal: right < 0 ? "left" : left > 0 ? "right" : "center",
                        vertical: bottom < 0 ? "top" : top > 0 ? "bottom" : "middle"
                    };
                if ( targetWidth < elemWidth && abs( left + right ) < targetWidth ) {
                    feedback.horizontal = "center";
                }
                if ( targetHeight < elemHeight && abs( top + bottom ) < targetHeight ) {
                    feedback.vertical = "middle";
                }
                if ( max( abs( left ), abs( right ) ) > max( abs( top ), abs( bottom ) ) ) {
                    feedback.important = "horizontal";
                } else {
                    feedback.important = "vertical";
                }
                options.using.call( this, props, feedback );
            };
        }

        elem.offset( $.extend( position, { using: using } ) );
    });
};

$.ui.position = {
    fit: {
        left: function( position, data ) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollLeft : within.offset.left,
                outerWidth = within.width,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = withinOffset - collisionPosLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - withinOffset,
                newOverRight;

            // element is wider than within
            if ( data.collisionWidth > outerWidth ) {
                // element is initially over the left side of within
                if ( overLeft > 0 && overRight <= 0 ) {
                    newOverRight = position.left + overLeft + data.collisionWidth - outerWidth - withinOffset;
                    position.left += overLeft - newOverRight;
                // element is initially over right side of within
                } else if ( overRight > 0 && overLeft <= 0 ) {
                    position.left = withinOffset;
                // element is initially over both left and right sides of within
                } else {
                    if ( overLeft > overRight ) {
                        position.left = withinOffset + outerWidth - data.collisionWidth;
                    } else {
                        position.left = withinOffset;
                    }
                }
            // too far left -> align with left edge
            } else if ( overLeft > 0 ) {
                position.left += overLeft;
            // too far right -> align with right edge
            } else if ( overRight > 0 ) {
                position.left -= overRight;
            // adjust based on position and margin
            } else {
                position.left = max( position.left - collisionPosLeft, position.left );
            }
        },
        top: function( position, data ) {
            var within = data.within,
                withinOffset = within.isWindow ? within.scrollTop : within.offset.top,
                outerHeight = data.within.height,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = withinOffset - collisionPosTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - withinOffset,
                newOverBottom;

            // element is taller than within
            if ( data.collisionHeight > outerHeight ) {
                // element is initially over the top of within
                if ( overTop > 0 && overBottom <= 0 ) {
                    newOverBottom = position.top + overTop + data.collisionHeight - outerHeight - withinOffset;
                    position.top += overTop - newOverBottom;
                // element is initially over bottom of within
                } else if ( overBottom > 0 && overTop <= 0 ) {
                    position.top = withinOffset;
                // element is initially over both top and bottom of within
                } else {
                    if ( overTop > overBottom ) {
                        position.top = withinOffset + outerHeight - data.collisionHeight;
                    } else {
                        position.top = withinOffset;
                    }
                }
            // too far up -> align with top
            } else if ( overTop > 0 ) {
                position.top += overTop;
            // too far down -> align with bottom edge
            } else if ( overBottom > 0 ) {
                position.top -= overBottom;
            // adjust based on position and margin
            } else {
                position.top = max( position.top - collisionPosTop, position.top );
            }
        }
    },
    flip: {
        left: function( position, data ) {
            var within = data.within,
                withinOffset = within.offset.left + within.scrollLeft,
                outerWidth = within.width,
                offsetLeft = within.isWindow ? within.scrollLeft : within.offset.left,
                collisionPosLeft = position.left - data.collisionPosition.marginLeft,
                overLeft = collisionPosLeft - offsetLeft,
                overRight = collisionPosLeft + data.collisionWidth - outerWidth - offsetLeft,
                myOffset = data.my[ 0 ] === "left" ?
                    -data.elemWidth :
                    data.my[ 0 ] === "right" ?
                        data.elemWidth :
                        0,
                atOffset = data.at[ 0 ] === "left" ?
                    data.targetWidth :
                    data.at[ 0 ] === "right" ?
                        -data.targetWidth :
                        0,
                offset = -2 * data.offset[ 0 ],
                newOverRight,
                newOverLeft;

            if ( overLeft < 0 ) {
                newOverRight = position.left + myOffset + atOffset + offset + data.collisionWidth - outerWidth - withinOffset;
                if ( newOverRight < 0 || newOverRight < abs( overLeft ) ) {
                    position.left += myOffset + atOffset + offset;
                }
            } else if ( overRight > 0 ) {
                newOverLeft = position.left - data.collisionPosition.marginLeft + myOffset + atOffset + offset - offsetLeft;
                if ( newOverLeft > 0 || abs( newOverLeft ) < overRight ) {
                    position.left += myOffset + atOffset + offset;
                }
            }
        },
        top: function( position, data ) {
            var within = data.within,
                withinOffset = within.offset.top + within.scrollTop,
                outerHeight = within.height,
                offsetTop = within.isWindow ? within.scrollTop : within.offset.top,
                collisionPosTop = position.top - data.collisionPosition.marginTop,
                overTop = collisionPosTop - offsetTop,
                overBottom = collisionPosTop + data.collisionHeight - outerHeight - offsetTop,
                top = data.my[ 1 ] === "top",
                myOffset = top ?
                    -data.elemHeight :
                    data.my[ 1 ] === "bottom" ?
                        data.elemHeight :
                        0,
                atOffset = data.at[ 1 ] === "top" ?
                    data.targetHeight :
                    data.at[ 1 ] === "bottom" ?
                        -data.targetHeight :
                        0,
                offset = -2 * data.offset[ 1 ],
                newOverTop,
                newOverBottom;
            if ( overTop < 0 ) {
                newOverBottom = position.top + myOffset + atOffset + offset + data.collisionHeight - outerHeight - withinOffset;
                if ( newOverBottom < 0 || newOverBottom < abs( overTop ) ) {
                    position.top += myOffset + atOffset + offset;
                }
            } else if ( overBottom > 0 ) {
                newOverTop = position.top - data.collisionPosition.marginTop + myOffset + atOffset + offset - offsetTop;
                if ( newOverTop > 0 || abs( newOverTop ) < overBottom ) {
                    position.top += myOffset + atOffset + offset;
                }
            }
        }
    },
    flipfit: {
        left: function() {
            $.ui.position.flip.left.apply( this, arguments );
            $.ui.position.fit.left.apply( this, arguments );
        },
        top: function() {
            $.ui.position.flip.top.apply( this, arguments );
            $.ui.position.fit.top.apply( this, arguments );
        }
    }
};

// fraction support test
(function() {
    var testElement, testElementParent, testElementStyle, offsetLeft, i,
        body = document.getElementsByTagName( "body" )[ 0 ],
        div = document.createElement( "div" );

    //Create a "fake body" for testing based on method used in jQuery.support
    testElement = document.createElement( body ? "div" : "body" );
    testElementStyle = {
        visibility: "hidden",
        width: 0,
        height: 0,
        border: 0,
        margin: 0,
        background: "none"
    };
    if ( body ) {
        $.extend( testElementStyle, {
            position: "absolute",
            left: "-1000px",
            top: "-1000px"
        });
    }
    for ( i in testElementStyle ) {
        testElement.style[ i ] = testElementStyle[ i ];
    }
    testElement.appendChild( div );
    testElementParent = body || document.documentElement;
    testElementParent.insertBefore( testElement, testElementParent.firstChild );

    div.style.cssText = "position: absolute; left: 10.7432222px;";

    offsetLeft = $( div ).offset().left;
    supportsOffsetFractions = offsetLeft > 10 && offsetLeft < 11;

    testElement.innerHTML = "";
    testElementParent.removeChild( testElement );
})();

})();

var position = $.ui.position;


/*!
 * jQuery UI Accordion 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/accordion/
 */


var accordion = $.widget( "ui.accordion", {
    version: "1.11.4",
    options: {
        active: 0,
        animate: {},
        collapsible: false,
        event: "click",
        header: "> li > :first-child,> :not(li):even",
        heightStyle: "auto",
        icons: {
            activeHeader: "ui-icon-triangle-1-s",
            header: "ui-icon-triangle-1-e"
        },

        // callbacks
        activate: null,
        beforeActivate: null
    },

    hideProps: {
        borderTopWidth: "hide",
        borderBottomWidth: "hide",
        paddingTop: "hide",
        paddingBottom: "hide",
        height: "hide"
    },

    showProps: {
        borderTopWidth: "show",
        borderBottomWidth: "show",
        paddingTop: "show",
        paddingBottom: "show",
        height: "show"
    },

    _create: function() {
        var options = this.options;
        this.prevShow = this.prevHide = $();
        this.element.addClass( "ui-accordion ui-widget ui-helper-reset" )
            // ARIA
            .attr( "role", "tablist" );

        // don't allow collapsible: false and active: false / null
        if ( !options.collapsible && (options.active === false || options.active == null) ) {
            options.active = 0;
        }

        this._processPanels();
        // handle negative values
        if ( options.active < 0 ) {
            options.active += this.headers.length;
        }
        this._refresh();
    },

    _getCreateEventData: function() {
        return {
            header: this.active,
            panel: !this.active.length ? $() : this.active.next()
        };
    },

    _createIcons: function() {
        var icons = this.options.icons;
        if ( icons ) {
            $( "<span>" )
                .addClass( "ui-accordion-header-icon ui-icon " + icons.header )
                .prependTo( this.headers );
            this.active.children( ".ui-accordion-header-icon" )
                .removeClass( icons.header )
                .addClass( icons.activeHeader );
            this.headers.addClass( "ui-accordion-icons" );
        }
    },

    _destroyIcons: function() {
        this.headers
            .removeClass( "ui-accordion-icons" )
            .children( ".ui-accordion-header-icon" )
                .remove();
    },

    _destroy: function() {
        var contents;

        // clean up main element
        this.element
            .removeClass( "ui-accordion ui-widget ui-helper-reset" )
            .removeAttr( "role" );

        // clean up headers
        this.headers
            .removeClass( "ui-accordion-header ui-accordion-header-active ui-state-default " +
                "ui-corner-all ui-state-active ui-state-disabled ui-corner-top" )
            .removeAttr( "role" )
            .removeAttr( "aria-expanded" )
            .removeAttr( "aria-selected" )
            .removeAttr( "aria-controls" )
            .removeAttr( "tabIndex" )
            .removeUniqueId();

        this._destroyIcons();

        // clean up content panels
        contents = this.headers.next()
            .removeClass( "ui-helper-reset ui-widget-content ui-corner-bottom " +
                "ui-accordion-content ui-accordion-content-active ui-state-disabled" )
            .css( "display", "" )
            .removeAttr( "role" )
            .removeAttr( "aria-hidden" )
            .removeAttr( "aria-labelledby" )
            .removeUniqueId();

        if ( this.options.heightStyle !== "content" ) {
            contents.css( "height", "" );
        }
    },

    _setOption: function( key, value ) {
        if ( key === "active" ) {
            // _activate() will handle invalid values and update this.options
            this._activate( value );
            return;
        }

        if ( key === "event" ) {
            if ( this.options.event ) {
                this._off( this.headers, this.options.event );
            }
            this._setupEvents( value );
        }

        this._super( key, value );

        // setting collapsible: false while collapsed; open first panel
        if ( key === "collapsible" && !value && this.options.active === false ) {
            this._activate( 0 );
        }

        if ( key === "icons" ) {
            this._destroyIcons();
            if ( value ) {
                this._createIcons();
            }
        }

        // #5332 - opacity doesn't cascade to positioned elements in IE
        // so we need to add the disabled class to the headers and panels
        if ( key === "disabled" ) {
            this.element
                .toggleClass( "ui-state-disabled", !!value )
                .attr( "aria-disabled", value );
            this.headers.add( this.headers.next() )
                .toggleClass( "ui-state-disabled", !!value );
        }
    },

    _keydown: function( event ) {
        if ( event.altKey || event.ctrlKey ) {
            return;
        }

        var keyCode = $.ui.keyCode,
            length = this.headers.length,
            currentIndex = this.headers.index( event.target ),
            toFocus = false;

        switch ( event.keyCode ) {
            case keyCode.RIGHT:
            case keyCode.DOWN:
                toFocus = this.headers[ ( currentIndex + 1 ) % length ];
                break;
            case keyCode.LEFT:
            case keyCode.UP:
                toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
                break;
            case keyCode.SPACE:
            case keyCode.ENTER:
                this._eventHandler( event );
                break;
            case keyCode.HOME:
                toFocus = this.headers[ 0 ];
                break;
            case keyCode.END:
                toFocus = this.headers[ length - 1 ];
                break;
        }

        if ( toFocus ) {
            $( event.target ).attr( "tabIndex", -1 );
            $( toFocus ).attr( "tabIndex", 0 );
            toFocus.focus();
            event.preventDefault();
        }
    },

    _panelKeyDown: function( event ) {
        if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
            $( event.currentTarget ).prev().focus();
        }
    },

    refresh: function() {
        var options = this.options;
        this._processPanels();

        // was collapsed or no panel
        if ( ( options.active === false && options.collapsible === true ) || !this.headers.length ) {
            options.active = false;
            this.active = $();
        // active false only when collapsible is true
        } else if ( options.active === false ) {
            this._activate( 0 );
        // was active, but active panel is gone
        } else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
            // all remaining panel are disabled
            if ( this.headers.length === this.headers.find(".ui-state-disabled").length ) {
                options.active = false;
                this.active = $();
            // activate previous panel
            } else {
                this._activate( Math.max( 0, options.active - 1 ) );
            }
        // was active, active panel still exists
        } else {
            // make sure active index is correct
            options.active = this.headers.index( this.active );
        }

        this._destroyIcons();

        this._refresh();
    },

    _processPanels: function() {
        var prevHeaders = this.headers,
            prevPanels = this.panels;

        this.headers = this.element.find( this.options.header )
            .addClass( "ui-accordion-header ui-state-default ui-corner-all" );

        this.panels = this.headers.next()
            .addClass( "ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom" )
            .filter( ":not(.ui-accordion-content-active)" )
            .hide();

        // Avoid memory leaks (#10056)
        if ( prevPanels ) {
            this._off( prevHeaders.not( this.headers ) );
            this._off( prevPanels.not( this.panels ) );
        }
    },

    _refresh: function() {
        var maxHeight,
            options = this.options,
            heightStyle = options.heightStyle,
            parent = this.element.parent();

        this.active = this._findActive( options.active )
            .addClass( "ui-accordion-header-active ui-state-active ui-corner-top" )
            .removeClass( "ui-corner-all" );
        this.active.next()
            .addClass( "ui-accordion-content-active" )
            .show();

        this.headers
            .attr( "role", "tab" )
            .each(function() {
                var header = $( this ),
                    headerId = header.uniqueId().attr( "id" ),
                    panel = header.next(),
                    panelId = panel.uniqueId().attr( "id" );
                header.attr( "aria-controls", panelId );
                panel.attr( "aria-labelledby", headerId );
            })
            .next()
                .attr( "role", "tabpanel" );

        this.headers
            .not( this.active )
            .attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            })
            .next()
                .attr({
                    "aria-hidden": "true"
                })
                .hide();

        // make sure at least one header is in the tab order
        if ( !this.active.length ) {
            this.headers.eq( 0 ).attr( "tabIndex", 0 );
        } else {
            this.active.attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            })
            .next()
                .attr({
                    "aria-hidden": "false"
                });
        }

        this._createIcons();

        this._setupEvents( options.event );

        if ( heightStyle === "fill" ) {
            maxHeight = parent.height();
            this.element.siblings( ":visible" ).each(function() {
                var elem = $( this ),
                    position = elem.css( "position" );

                if ( position === "absolute" || position === "fixed" ) {
                    return;
                }
                maxHeight -= elem.outerHeight( true );
            });

            this.headers.each(function() {
                maxHeight -= $( this ).outerHeight( true );
            });

            this.headers.next()
                .each(function() {
                    $( this ).height( Math.max( 0, maxHeight -
                        $( this ).innerHeight() + $( this ).height() ) );
                })
                .css( "overflow", "auto" );
        } else if ( heightStyle === "auto" ) {
            maxHeight = 0;
            this.headers.next()
                .each(function() {
                    maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
                })
                .height( maxHeight );
        }
    },

    _activate: function( index ) {
        var active = this._findActive( index )[ 0 ];

        // trying to activate the already active panel
        if ( active === this.active[ 0 ] ) {
            return;
        }

        // trying to collapse, simulate a click on the currently active header
        active = active || this.active[ 0 ];

        this._eventHandler({
            target: active,
            currentTarget: active,
            preventDefault: $.noop
        });
    },

    _findActive: function( selector ) {
        return typeof selector === "number" ? this.headers.eq( selector ) : $();
    },

    _setupEvents: function( event ) {
        var events = {
            keydown: "_keydown"
        };
        if ( event ) {
            $.each( event.split( " " ), function( index, eventName ) {
                events[ eventName ] = "_eventHandler";
            });
        }

        this._off( this.headers.add( this.headers.next() ) );
        this._on( this.headers, events );
        this._on( this.headers.next(), { keydown: "_panelKeyDown" });
        this._hoverable( this.headers );
        this._focusable( this.headers );
    },

    _eventHandler: function( event ) {
        var options = this.options,
            active = this.active,
            clicked = $( event.currentTarget ),
            clickedIsActive = clicked[ 0 ] === active[ 0 ],
            collapsing = clickedIsActive && options.collapsible,
            toShow = collapsing ? $() : clicked.next(),
            toHide = active.next(),
            eventData = {
                oldHeader: active,
                oldPanel: toHide,
                newHeader: collapsing ? $() : clicked,
                newPanel: toShow
            };

        event.preventDefault();

        if (
                // click on active header, but not collapsible
                ( clickedIsActive && !options.collapsible ) ||
                // allow canceling activation
                ( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
            return;
        }

        options.active = collapsing ? false : this.headers.index( clicked );

        // when the call to ._toggle() comes after the class changes
        // it causes a very odd bug in IE 8 (see #6720)
        this.active = clickedIsActive ? $() : clicked;
        this._toggle( eventData );

        // switch classes
        // corner classes on the previously active header stay after the animation
        active.removeClass( "ui-accordion-header-active ui-state-active" );
        if ( options.icons ) {
            active.children( ".ui-accordion-header-icon" )
                .removeClass( options.icons.activeHeader )
                .addClass( options.icons.header );
        }

        if ( !clickedIsActive ) {
            clicked
                .removeClass( "ui-corner-all" )
                .addClass( "ui-accordion-header-active ui-state-active ui-corner-top" );
            if ( options.icons ) {
                clicked.children( ".ui-accordion-header-icon" )
                    .removeClass( options.icons.header )
                    .addClass( options.icons.activeHeader );
            }

            clicked
                .next()
                .addClass( "ui-accordion-content-active" );
        }
    },

    _toggle: function( data ) {
        var toShow = data.newPanel,
            toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

        // handle activating a panel during the animation for another activation
        this.prevShow.add( this.prevHide ).stop( true, true );
        this.prevShow = toShow;
        this.prevHide = toHide;

        if ( this.options.animate ) {
            this._animate( toShow, toHide, data );
        } else {
            toHide.hide();
            toShow.show();
            this._toggleComplete( data );
        }

        toHide.attr({
            "aria-hidden": "true"
        });
        toHide.prev().attr({
            "aria-selected": "false",
            "aria-expanded": "false"
        });
        // if we're switching panels, remove the old header from the tab order
        // if we're opening from collapsed state, remove the previous header from the tab order
        // if we're collapsing, then keep the collapsing header in the tab order
        if ( toShow.length && toHide.length ) {
            toHide.prev().attr({
                "tabIndex": -1,
                "aria-expanded": "false"
            });
        } else if ( toShow.length ) {
            this.headers.filter(function() {
                return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
            })
            .attr( "tabIndex", -1 );
        }

        toShow
            .attr( "aria-hidden", "false" )
            .prev()
                .attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                });
    },

    _animate: function( toShow, toHide, data ) {
        var total, easing, duration,
            that = this,
            adjust = 0,
            boxSizing = toShow.css( "box-sizing" ),
            down = toShow.length &&
                ( !toHide.length || ( toShow.index() < toHide.index() ) ),
            animate = this.options.animate || {},
            options = down && animate.down || animate,
            complete = function() {
                that._toggleComplete( data );
            };

        if ( typeof options === "number" ) {
            duration = options;
        }
        if ( typeof options === "string" ) {
            easing = options;
        }
        // fall back from options to animation in case of partial down settings
        easing = easing || options.easing || animate.easing;
        duration = duration || options.duration || animate.duration;

        if ( !toHide.length ) {
            return toShow.animate( this.showProps, duration, easing, complete );
        }
        if ( !toShow.length ) {
            return toHide.animate( this.hideProps, duration, easing, complete );
        }

        total = toShow.show().outerHeight();
        toHide.animate( this.hideProps, {
            duration: duration,
            easing: easing,
            step: function( now, fx ) {
                fx.now = Math.round( now );
            }
        });
        toShow
            .hide()
            .animate( this.showProps, {
                duration: duration,
                easing: easing,
                complete: complete,
                step: function( now, fx ) {
                    fx.now = Math.round( now );
                    if ( fx.prop !== "height" ) {
                        if ( boxSizing === "content-box" ) {
                            adjust += fx.now;
                        }
                    } else if ( that.options.heightStyle !== "content" ) {
                        fx.now = Math.round( total - toHide.outerHeight() - adjust );
                        adjust = 0;
                    }
                }
            });
    },

    _toggleComplete: function( data ) {
        var toHide = data.oldPanel;

        toHide
            .removeClass( "ui-accordion-content-active" )
            .prev()
                .removeClass( "ui-corner-top" )
                .addClass( "ui-corner-all" );

        // Work around for rendering bug in IE (#5421)
        if ( toHide.length ) {
            toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
        }
        this._trigger( "activate", null, data );
    }
});


/*!
 * jQuery UI Menu 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/menu/
 */


var menu = $.widget( "ui.menu", {
    version: "1.11.4",
    defaultElement: "<ul>",
    delay: 300,
    options: {
        icons: {
            submenu: "ui-icon-carat-1-e"
        },
        items: "> *",
        menus: "ul",
        position: {
            my: "left-1 top",
            at: "right top"
        },
        role: "menu",

        // callbacks
        blur: null,
        focus: null,
        select: null
    },

    _create: function() {
        this.activeMenu = this.element;

        // Flag used to prevent firing of the click handler
        // as the event bubbles up through nested menus
        this.mouseHandled = false;
        this.element
            .uniqueId()
            .addClass( "ui-menu ui-widget ui-widget-content" )
            .toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length )
            .attr({
                role: this.options.role,
                tabIndex: 0
            });

        if ( this.options.disabled ) {
            this.element
                .addClass( "ui-state-disabled" )
                .attr( "aria-disabled", "true" );
        }

        this._on({
            // Prevent focus from sticking to links inside menu after clicking
            // them (focus should always stay on UL during navigation).
            "mousedown .ui-menu-item": function( event ) {
                event.preventDefault();
            },
            "click .ui-menu-item": function( event ) {
                var target = $( event.target );
                if ( !this.mouseHandled && target.not( ".ui-state-disabled" ).length ) {
                    this.select( event );

                    // Only set the mouseHandled flag if the event will bubble, see #9469.
                    if ( !event.isPropagationStopped() ) {
                        this.mouseHandled = true;
                    }

                    // Open submenu on click
                    if ( target.has( ".ui-menu" ).length ) {
                        this.expand( event );
                    } else if ( !this.element.is( ":focus" ) && $( this.document[ 0 ].activeElement ).closest( ".ui-menu" ).length ) {

                        // Redirect focus to the menu
                        this.element.trigger( "focus", [ true ] );

                        // If the active item is on the top level, let it stay active.
                        // Otherwise, blur the active item since it is no longer visible.
                        if ( this.active && this.active.parents( ".ui-menu" ).length === 1 ) {
                            clearTimeout( this.timer );
                        }
                    }
                }
            },
            "mouseenter .ui-menu-item": function( event ) {
                // Ignore mouse events while typeahead is active, see #10458.
                // Prevents focusing the wrong item when typeahead causes a scroll while the mouse
                // is over an item in the menu
                if ( this.previousFilter ) {
                    return;
                }
                var target = $( event.currentTarget );
                // Remove ui-state-active class from siblings of the newly focused menu item
                // to avoid a jump caused by adjacent elements both having a class with a border
                target.siblings( ".ui-state-active" ).removeClass( "ui-state-active" );
                this.focus( event, target );
            },
            mouseleave: "collapseAll",
            "mouseleave .ui-menu": "collapseAll",
            focus: function( event, keepActiveItem ) {
                // If there's already an active item, keep it active
                // If not, activate the first item
                var item = this.active || this.element.find( this.options.items ).eq( 0 );

                if ( !keepActiveItem ) {
                    this.focus( event, item );
                }
            },
            blur: function( event ) {
                this._delay(function() {
                    if ( !$.contains( this.element[0], this.document[0].activeElement ) ) {
                        this.collapseAll( event );
                    }
                });
            },
            keydown: "_keydown"
        });

        this.refresh();

        // Clicks outside of a menu collapse any open menus
        this._on( this.document, {
            click: function( event ) {
                if ( this._closeOnDocumentClick( event ) ) {
                    this.collapseAll( event );
                }

                // Reset the mouseHandled flag
                this.mouseHandled = false;
            }
        });
    },

    _destroy: function() {
        // Destroy (sub)menus
        this.element
            .removeAttr( "aria-activedescendant" )
            .find( ".ui-menu" ).addBack()
                .removeClass( "ui-menu ui-widget ui-widget-content ui-menu-icons ui-front" )
                .removeAttr( "role" )
                .removeAttr( "tabIndex" )
                .removeAttr( "aria-labelledby" )
                .removeAttr( "aria-expanded" )
                .removeAttr( "aria-hidden" )
                .removeAttr( "aria-disabled" )
                .removeUniqueId()
                .show();

        // Destroy menu items
        this.element.find( ".ui-menu-item" )
            .removeClass( "ui-menu-item" )
            .removeAttr( "role" )
            .removeAttr( "aria-disabled" )
            .removeUniqueId()
            .removeClass( "ui-state-hover" )
            .removeAttr( "tabIndex" )
            .removeAttr( "role" )
            .removeAttr( "aria-haspopup" )
            .children().each( function() {
                var elem = $( this );
                if ( elem.data( "ui-menu-submenu-carat" ) ) {
                    elem.remove();
                }
            });

        // Destroy menu dividers
        this.element.find( ".ui-menu-divider" ).removeClass( "ui-menu-divider ui-widget-content" );
    },

    _keydown: function( event ) {
        var match, prev, character, skip,
            preventDefault = true;

        switch ( event.keyCode ) {
        case $.ui.keyCode.PAGE_UP:
            this.previousPage( event );
            break;
        case $.ui.keyCode.PAGE_DOWN:
            this.nextPage( event );
            break;
        case $.ui.keyCode.HOME:
            this._move( "first", "first", event );
            break;
        case $.ui.keyCode.END:
            this._move( "last", "last", event );
            break;
        case $.ui.keyCode.UP:
            this.previous( event );
            break;
        case $.ui.keyCode.DOWN:
            this.next( event );
            break;
        case $.ui.keyCode.LEFT:
            this.collapse( event );
            break;
        case $.ui.keyCode.RIGHT:
            if ( this.active && !this.active.is( ".ui-state-disabled" ) ) {
                this.expand( event );
            }
            break;
        case $.ui.keyCode.ENTER:
        case $.ui.keyCode.SPACE:
            this._activate( event );
            break;
        case $.ui.keyCode.ESCAPE:
            this.collapse( event );
            break;
        default:
            preventDefault = false;
            prev = this.previousFilter || "";
            character = String.fromCharCode( event.keyCode );
            skip = false;

            clearTimeout( this.filterTimer );

            if ( character === prev ) {
                skip = true;
            } else {
                character = prev + character;
            }

            match = this._filterMenuItems( character );
            match = skip && match.index( this.active.next() ) !== -1 ?
                this.active.nextAll( ".ui-menu-item" ) :
                match;

            // If no matches on the current filter, reset to the last character pressed
            // to move down the menu to the first item that starts with that character
            if ( !match.length ) {
                character = String.fromCharCode( event.keyCode );
                match = this._filterMenuItems( character );
            }

            if ( match.length ) {
                this.focus( event, match );
                this.previousFilter = character;
                this.filterTimer = this._delay(function() {
                    delete this.previousFilter;
                }, 1000 );
            } else {
                delete this.previousFilter;
            }
        }

        if ( preventDefault ) {
            event.preventDefault();
        }
    },

    _activate: function( event ) {
        if ( !this.active.is( ".ui-state-disabled" ) ) {
            if ( this.active.is( "[aria-haspopup='true']" ) ) {
                this.expand( event );
            } else {
                this.select( event );
            }
        }
    },

    refresh: function() {
        var menus, items,
            that = this,
            icon = this.options.icons.submenu,
            submenus = this.element.find( this.options.menus );

        this.element.toggleClass( "ui-menu-icons", !!this.element.find( ".ui-icon" ).length );

        // Initialize nested menus
        submenus.filter( ":not(.ui-menu)" )
            .addClass( "ui-menu ui-widget ui-widget-content ui-front" )
            .hide()
            .attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            })
            .each(function() {
                var menu = $( this ),
                    item = menu.parent(),
                    submenuCarat = $( "<span>" )
                        .addClass( "ui-menu-icon ui-icon " + icon )
                        .data( "ui-menu-submenu-carat", true );

                item
                    .attr( "aria-haspopup", "true" )
                    .prepend( submenuCarat );
                menu.attr( "aria-labelledby", item.attr( "id" ) );
            });

        menus = submenus.add( this.element );
        items = menus.find( this.options.items );

        // Initialize menu-items containing spaces and/or dashes only as dividers
        items.not( ".ui-menu-item" ).each(function() {
            var item = $( this );
            if ( that._isDivider( item ) ) {
                item.addClass( "ui-widget-content ui-menu-divider" );
            }
        });

        // Don't refresh list items that are already adapted
        items.not( ".ui-menu-item, .ui-menu-divider" )
            .addClass( "ui-menu-item" )
            .uniqueId()
            .attr({
                tabIndex: -1,
                role: this._itemRole()
            });

        // Add aria-disabled attribute to any disabled menu item
        items.filter( ".ui-state-disabled" ).attr( "aria-disabled", "true" );

        // If the active item has been removed, blur the menu
        if ( this.active && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {
            this.blur();
        }
    },

    _itemRole: function() {
        return {
            menu: "menuitem",
            listbox: "option"
        }[ this.options.role ];
    },

    _setOption: function( key, value ) {
        if ( key === "icons" ) {
            this.element.find( ".ui-menu-icon" )
                .removeClass( this.options.icons.submenu )
                .addClass( value.submenu );
        }
        if ( key === "disabled" ) {
            this.element
                .toggleClass( "ui-state-disabled", !!value )
                .attr( "aria-disabled", value );
        }
        this._super( key, value );
    },

    focus: function( event, item ) {
        var nested, focused;
        this.blur( event, event && event.type === "focus" );

        this._scrollIntoView( item );

        this.active = item.first();
        focused = this.active.addClass( "ui-state-focus" ).removeClass( "ui-state-active" );
        // Only update aria-activedescendant if there's a role
        // otherwise we assume focus is managed elsewhere
        if ( this.options.role ) {
            this.element.attr( "aria-activedescendant", focused.attr( "id" ) );
        }

        // Highlight active parent menu item, if any
        this.active
            .parent()
            .closest( ".ui-menu-item" )
            .addClass( "ui-state-active" );

        if ( event && event.type === "keydown" ) {
            this._close();
        } else {
            this.timer = this._delay(function() {
                this._close();
            }, this.delay );
        }

        nested = item.children( ".ui-menu" );
        if ( nested.length && event && ( /^mouse/.test( event.type ) ) ) {
            this._startOpening(nested);
        }
        this.activeMenu = item.parent();

        this._trigger( "focus", event, { item: item } );
    },

    _scrollIntoView: function( item ) {
        var borderTop, paddingTop, offset, scroll, elementHeight, itemHeight;
        if ( this._hasScroll() ) {
            borderTop = parseFloat( $.css( this.activeMenu[0], "borderTopWidth" ) ) || 0;
            paddingTop = parseFloat( $.css( this.activeMenu[0], "paddingTop" ) ) || 0;
            offset = item.offset().top - this.activeMenu.offset().top - borderTop - paddingTop;
            scroll = this.activeMenu.scrollTop();
            elementHeight = this.activeMenu.height();
            itemHeight = item.outerHeight();

            if ( offset < 0 ) {
                this.activeMenu.scrollTop( scroll + offset );
            } else if ( offset + itemHeight > elementHeight ) {
                this.activeMenu.scrollTop( scroll + offset - elementHeight + itemHeight );
            }
        }
    },

    blur: function( event, fromFocus ) {
        if ( !fromFocus ) {
            clearTimeout( this.timer );
        }

        if ( !this.active ) {
            return;
        }

        this.active.removeClass( "ui-state-focus" );
        this.active = null;

        this._trigger( "blur", event, { item: this.active } );
    },

    _startOpening: function( submenu ) {
        clearTimeout( this.timer );

        // Don't open if already open fixes a Firefox bug that caused a .5 pixel
        // shift in the submenu position when mousing over the carat icon
        if ( submenu.attr( "aria-hidden" ) !== "true" ) {
            return;
        }

        this.timer = this._delay(function() {
            this._close();
            this._open( submenu );
        }, this.delay );
    },

    _open: function( submenu ) {
        var position = $.extend({
            of: this.active
        }, this.options.position );

        clearTimeout( this.timer );
        this.element.find( ".ui-menu" ).not( submenu.parents( ".ui-menu" ) )
            .hide()
            .attr( "aria-hidden", "true" );

        submenu
            .show()
            .removeAttr( "aria-hidden" )
            .attr( "aria-expanded", "true" )
            .position( position );
    },

    collapseAll: function( event, all ) {
        clearTimeout( this.timer );
        this.timer = this._delay(function() {
            // If we were passed an event, look for the submenu that contains the event
            var currentMenu = all ? this.element :
                $( event && event.target ).closest( this.element.find( ".ui-menu" ) );

            // If we found no valid submenu ancestor, use the main menu to close all sub menus anyway
            if ( !currentMenu.length ) {
                currentMenu = this.element;
            }

            this._close( currentMenu );

            this.blur( event );
            this.activeMenu = currentMenu;
        }, this.delay );
    },

    // With no arguments, closes the currently active menu - if nothing is active
    // it closes all menus.  If passed an argument, it will search for menus BELOW
    _close: function( startMenu ) {
        if ( !startMenu ) {
            startMenu = this.active ? this.active.parent() : this.element;
        }

        startMenu
            .find( ".ui-menu" )
                .hide()
                .attr( "aria-hidden", "true" )
                .attr( "aria-expanded", "false" )
            .end()
            .find( ".ui-state-active" ).not( ".ui-state-focus" )
                .removeClass( "ui-state-active" );
    },

    _closeOnDocumentClick: function( event ) {
        return !$( event.target ).closest( ".ui-menu" ).length;
    },

    _isDivider: function( item ) {

        // Match hyphen, em dash, en dash
        return !/[^\-\u2014\u2013\s]/.test( item.text() );
    },

    collapse: function( event ) {
        var newItem = this.active &&
            this.active.parent().closest( ".ui-menu-item", this.element );
        if ( newItem && newItem.length ) {
            this._close();
            this.focus( event, newItem );
        }
    },

    expand: function( event ) {
        var newItem = this.active &&
            this.active
                .children( ".ui-menu " )
                .find( this.options.items )
                .first();

        if ( newItem && newItem.length ) {
            this._open( newItem.parent() );

            // Delay so Firefox will not hide activedescendant change in expanding submenu from AT
            this._delay(function() {
                this.focus( event, newItem );
            });
        }
    },

    next: function( event ) {
        this._move( "next", "first", event );
    },

    previous: function( event ) {
        this._move( "prev", "last", event );
    },

    isFirstItem: function() {
        return this.active && !this.active.prevAll( ".ui-menu-item" ).length;
    },

    isLastItem: function() {
        return this.active && !this.active.nextAll( ".ui-menu-item" ).length;
    },

    _move: function( direction, filter, event ) {
        var next;
        if ( this.active ) {
            if ( direction === "first" || direction === "last" ) {
                next = this.active
                    [ direction === "first" ? "prevAll" : "nextAll" ]( ".ui-menu-item" )
                    .eq( -1 );
            } else {
                next = this.active
                    [ direction + "All" ]( ".ui-menu-item" )
                    .eq( 0 );
            }
        }
        if ( !next || !next.length || !this.active ) {
            next = this.activeMenu.find( this.options.items )[ filter ]();
        }

        this.focus( event, next );
    },

    nextPage: function( event ) {
        var item, base, height;

        if ( !this.active ) {
            this.next( event );
            return;
        }
        if ( this.isLastItem() ) {
            return;
        }
        if ( this._hasScroll() ) {
            base = this.active.offset().top;
            height = this.element.height();
            this.active.nextAll( ".ui-menu-item" ).each(function() {
                item = $( this );
                return item.offset().top - base - height < 0;
            });

            this.focus( event, item );
        } else {
            this.focus( event, this.activeMenu.find( this.options.items )
                [ !this.active ? "first" : "last" ]() );
        }
    },

    previousPage: function( event ) {
        var item, base, height;
        if ( !this.active ) {
            this.next( event );
            return;
        }
        if ( this.isFirstItem() ) {
            return;
        }
        if ( this._hasScroll() ) {
            base = this.active.offset().top;
            height = this.element.height();
            this.active.prevAll( ".ui-menu-item" ).each(function() {
                item = $( this );
                return item.offset().top - base + height > 0;
            });

            this.focus( event, item );
        } else {
            this.focus( event, this.activeMenu.find( this.options.items ).first() );
        }
    },

    _hasScroll: function() {
        return this.element.outerHeight() < this.element.prop( "scrollHeight" );
    },

    select: function( event ) {
        // TODO: It should never be possible to not have an active item at this
        // point, but the tests don't trigger mouseenter before click.
        this.active = this.active || $( event.target ).closest( ".ui-menu-item" );
        var ui = { item: this.active };
        if ( !this.active.has( ".ui-menu" ).length ) {
            this.collapseAll( event, true );
        }
        this._trigger( "select", event, ui );
    },

    _filterMenuItems: function(character) {
        var escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" ),
            regex = new RegExp( "^" + escapedCharacter, "i" );

        return this.activeMenu
            .find( this.options.items )

            // Only match on items, not dividers or other content (#10571)
            .filter( ".ui-menu-item" )
            .filter(function() {
                return regex.test( $.trim( $( this ).text() ) );
            });
    }
});


/*!
 * jQuery UI Autocomplete 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/autocomplete/
 */


$.widget( "ui.autocomplete", {
    version: "1.11.4",
    defaultElement: "<input>",
    options: {
        appendTo: null,
        autoFocus: false,
        delay: 300,
        minLength: 1,
        position: {
            my: "left top",
            at: "left bottom",
            collision: "none"
        },
        source: null,

        // callbacks
        change: null,
        close: null,
        focus: null,
        open: null,
        response: null,
        search: null,
        select: null
    },

    requestIndex: 0,
    pending: 0,

    _create: function() {
        // Some browsers only repeat keydown events, not keypress events,
        // so we use the suppressKeyPress flag to determine if we've already
        // handled the keydown event. #7269
        // Unfortunately the code for & in keypress is the same as the up arrow,
        // so we use the suppressKeyPressRepeat flag to avoid handling keypress
        // events when we know the keydown event was used to modify the
        // search term. #7799
        var suppressKeyPress, suppressKeyPressRepeat, suppressInput,
            nodeName = this.element[ 0 ].nodeName.toLowerCase(),
            isTextarea = nodeName === "textarea",
            isInput = nodeName === "input";

        this.isMultiLine =
            // Textareas are always multi-line
            isTextarea ? true :
            // Inputs are always single-line, even if inside a contentEditable element
            // IE also treats inputs as contentEditable
            isInput ? false :
            // All other element types are determined by whether or not they're contentEditable
            this.element.prop( "isContentEditable" );

        this.valueMethod = this.element[ isTextarea || isInput ? "val" : "text" ];
        this.isNewMenu = true;

        this.element
            .addClass( "ui-autocomplete-input" )
            .attr( "autocomplete", "off" );

        this._on( this.element, {
            keydown: function( event ) {
                if ( this.element.prop( "readOnly" ) ) {
                    suppressKeyPress = true;
                    suppressInput = true;
                    suppressKeyPressRepeat = true;
                    return;
                }

                suppressKeyPress = false;
                suppressInput = false;
                suppressKeyPressRepeat = false;
                var keyCode = $.ui.keyCode;
                switch ( event.keyCode ) {
                case keyCode.PAGE_UP:
                    suppressKeyPress = true;
                    this._move( "previousPage", event );
                    break;
                case keyCode.PAGE_DOWN:
                    suppressKeyPress = true;
                    this._move( "nextPage", event );
                    break;
                case keyCode.UP:
                    suppressKeyPress = true;
                    this._keyEvent( "previous", event );
                    break;
                case keyCode.DOWN:
                    suppressKeyPress = true;
                    this._keyEvent( "next", event );
                    break;
                case keyCode.ENTER:
                    // when menu is open and has focus
                    if ( this.menu.active ) {
                        // #6055 - Opera still allows the keypress to occur
                        // which causes forms to submit
                        suppressKeyPress = true;
                        event.preventDefault();
                        this.menu.select( event );
                    }
                    break;
                case keyCode.TAB:
                    if ( this.menu.active ) {
                        this.menu.select( event );
                    }
                    break;
                case keyCode.ESCAPE:
                    if ( this.menu.element.is( ":visible" ) ) {
                        if ( !this.isMultiLine ) {
                            this._value( this.term );
                        }
                        this.close( event );
                        // Different browsers have different default behavior for escape
                        // Single press can mean undo or clear
                        // Double press in IE means clear the whole form
                        event.preventDefault();
                    }
                    break;
                default:
                    suppressKeyPressRepeat = true;
                    // search timeout should be triggered before the input value is changed
                    this._searchTimeout( event );
                    break;
                }
            },
            keypress: function( event ) {
                if ( suppressKeyPress ) {
                    suppressKeyPress = false;
                    if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
                        event.preventDefault();
                    }
                    return;
                }
                if ( suppressKeyPressRepeat ) {
                    return;
                }

                // replicate some key handlers to allow them to repeat in Firefox and Opera
                var keyCode = $.ui.keyCode;
                switch ( event.keyCode ) {
                case keyCode.PAGE_UP:
                    this._move( "previousPage", event );
                    break;
                case keyCode.PAGE_DOWN:
                    this._move( "nextPage", event );
                    break;
                case keyCode.UP:
                    this._keyEvent( "previous", event );
                    break;
                case keyCode.DOWN:
                    this._keyEvent( "next", event );
                    break;
                }
            },
            input: function( event ) {
                if ( suppressInput ) {
                    suppressInput = false;
                    event.preventDefault();
                    return;
                }
                this._searchTimeout( event );
            },
            focus: function() {
                this.selectedItem = null;
                this.previous = this._value();
            },
            blur: function( event ) {
                if ( this.cancelBlur ) {
                    delete this.cancelBlur;
                    return;
                }

                clearTimeout( this.searching );
                this.close( event );
                this._change( event );
            }
        });

        this._initSource();
        this.menu = $( "<ul>" )
            .addClass( "ui-autocomplete ui-front" )
            .appendTo( this._appendTo() )
            .menu({
                // disable ARIA support, the live region takes care of that
                role: null
            })
            .hide()
            .menu( "instance" );

        this._on( this.menu.element, {
            mousedown: function( event ) {
                // prevent moving focus out of the text field
                event.preventDefault();

                // IE doesn't prevent moving focus even with event.preventDefault()
                // so we set a flag to know when we should ignore the blur event
                this.cancelBlur = true;
                this._delay(function() {
                    delete this.cancelBlur;
                });

                // clicking on the scrollbar causes focus to shift to the body
                // but we can't detect a mouseup or a click immediately afterward
                // so we have to track the next mousedown and close the menu if
                // the user clicks somewhere outside of the autocomplete
                var menuElement = this.menu.element[ 0 ];
                if ( !$( event.target ).closest( ".ui-menu-item" ).length ) {
                    this._delay(function() {
                        var that = this;
                        this.document.one( "mousedown", function( event ) {
                            if ( event.target !== that.element[ 0 ] &&
                                    event.target !== menuElement &&
                                    !$.contains( menuElement, event.target ) ) {
                                that.close();
                            }
                        });
                    });
                }
            },
            menufocus: function( event, ui ) {
                var label, item;
                // support: Firefox
                // Prevent accidental activation of menu items in Firefox (#7024 #9118)
                if ( this.isNewMenu ) {
                    this.isNewMenu = false;
                    if ( event.originalEvent && /^mouse/.test( event.originalEvent.type ) ) {
                        this.menu.blur();

                        this.document.one( "mousemove", function() {
                            $( event.target ).trigger( event.originalEvent );
                        });

                        return;
                    }
                }

                item = ui.item.data( "ui-autocomplete-item" );
                if ( false !== this._trigger( "focus", event, { item: item } ) ) {
                    // use value to match what will end up in the input, if it was a key event
                    if ( event.originalEvent && /^key/.test( event.originalEvent.type ) ) {
                        this._value( item.value );
                    }
                }

                // Announce the value in the liveRegion
                label = ui.item.attr( "aria-label" ) || item.value;
                if ( label && $.trim( label ).length ) {
                    this.liveRegion.children().hide();
                    $( "<div>" ).text( label ).appendTo( this.liveRegion );
                }
            },
            menuselect: function( event, ui ) {
                var item = ui.item.data( "ui-autocomplete-item" ),
                    previous = this.previous;

                // only trigger when focus was lost (click on menu)
                if ( this.element[ 0 ] !== this.document[ 0 ].activeElement ) {
                    this.element.focus();
                    this.previous = previous;
                    // #6109 - IE triggers two focus events and the second
                    // is asynchronous, so we need to reset the previous
                    // term synchronously and asynchronously :-(
                    this._delay(function() {
                        this.previous = previous;
                        this.selectedItem = item;
                    });
                }

                if ( false !== this._trigger( "select", event, { item: item } ) ) {
                    this._value( item.value );
                }
                // reset the term after the select event
                // this allows custom select handling to work properly
                this.term = this._value();

                this.close( event );
                this.selectedItem = item;
            }
        });

        this.liveRegion = $( "<span>", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            })
            .addClass( "ui-helper-hidden-accessible" )
            .appendTo( this.document[ 0 ].body );

        // turning off autocomplete prevents the browser from remembering the
        // value when navigating through history, so we re-enable autocomplete
        // if the page is unloaded before the widget is destroyed. #7790
        this._on( this.window, {
            beforeunload: function() {
                this.element.removeAttr( "autocomplete" );
            }
        });
    },

    _destroy: function() {
        clearTimeout( this.searching );
        this.element
            .removeClass( "ui-autocomplete-input" )
            .removeAttr( "autocomplete" );
        this.menu.element.remove();
        this.liveRegion.remove();
    },

    _setOption: function( key, value ) {
        this._super( key, value );
        if ( key === "source" ) {
            this._initSource();
        }
        if ( key === "appendTo" ) {
            this.menu.element.appendTo( this._appendTo() );
        }
        if ( key === "disabled" && value && this.xhr ) {
            this.xhr.abort();
        }
    },

    _appendTo: function() {
        var element = this.options.appendTo;

        if ( element ) {
            element = element.jquery || element.nodeType ?
                $( element ) :
                this.document.find( element ).eq( 0 );
        }

        if ( !element || !element[ 0 ] ) {
            element = this.element.closest( ".ui-front" );
        }

        if ( !element.length ) {
            element = this.document[ 0 ].body;
        }

        return element;
    },

    _initSource: function() {
        var array, url,
            that = this;
        if ( $.isArray( this.options.source ) ) {
            array = this.options.source;
            this.source = function( request, response ) {
                response( $.ui.autocomplete.filter( array, request.term ) );
            };
        } else if ( typeof this.options.source === "string" ) {
            url = this.options.source;
            this.source = function( request, response ) {
                if ( that.xhr ) {
                    that.xhr.abort();
                }
                that.xhr = $.ajax({
                    url: url,
                    data: request,
                    dataType: "json",
                    success: function( data ) {
                        response( data );
                    },
                    error: function() {
                        response([]);
                    }
                });
            };
        } else {
            this.source = this.options.source;
        }
    },

    _searchTimeout: function( event ) {
        clearTimeout( this.searching );
        this.searching = this._delay(function() {

            // Search if the value has changed, or if the user retypes the same value (see #7434)
            var equalValues = this.term === this._value(),
                menuVisible = this.menu.element.is( ":visible" ),
                modifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;

            if ( !equalValues || ( equalValues && !menuVisible && !modifierKey ) ) {
                this.selectedItem = null;
                this.search( null, event );
            }
        }, this.options.delay );
    },

    search: function( value, event ) {
        value = value != null ? value : this._value();

        // always save the actual value, not the one passed as an argument
        this.term = this._value();

        if ( value.length < this.options.minLength ) {
            return this.close( event );
        }

        if ( this._trigger( "search", event ) === false ) {
            return;
        }

        return this._search( value );
    },

    _search: function( value ) {
        this.pending++;
        this.element.addClass( "ui-autocomplete-loading" );
        this.cancelSearch = false;

        this.source( { term: value }, this._response() );
    },

    _response: function() {
        var index = ++this.requestIndex;

        return $.proxy(function( content ) {
            if ( index === this.requestIndex ) {
                this.__response( content );
            }

            this.pending--;
            if ( !this.pending ) {
                this.element.removeClass( "ui-autocomplete-loading" );
            }
        }, this );
    },

    __response: function( content ) {
        if ( content ) {
            content = this._normalize( content );
        }
        this._trigger( "response", null, { content: content } );
        if ( !this.options.disabled && content && content.length && !this.cancelSearch ) {
            this._suggest( content );
            this._trigger( "open" );
        } else {
            // use ._close() instead of .close() so we don't cancel future searches
            this._close();
        }
    },

    close: function( event ) {
        this.cancelSearch = true;
        this._close( event );
    },

    _close: function( event ) {
        if ( this.menu.element.is( ":visible" ) ) {
            this.menu.element.hide();
            this.menu.blur();
            this.isNewMenu = true;
            this._trigger( "close", event );
        }
    },

    _change: function( event ) {
        if ( this.previous !== this._value() ) {
            this._trigger( "change", event, { item: this.selectedItem } );
        }
    },

    _normalize: function( items ) {
        // assume all items have the right format when the first item is complete
        if ( items.length && items[ 0 ].label && items[ 0 ].value ) {
            return items;
        }
        return $.map( items, function( item ) {
            if ( typeof item === "string" ) {
                return {
                    label: item,
                    value: item
                };
            }
            return $.extend( {}, item, {
                label: item.label || item.value,
                value: item.value || item.label
            });
        });
    },

    _suggest: function( items ) {
        var ul = this.menu.element.empty();
        this._renderMenu( ul, items );
        this.isNewMenu = true;
        this.menu.refresh();

        // size and position menu
        ul.show();
        this._resizeMenu();
        ul.position( $.extend({
            of: this.element
        }, this.options.position ) );

        if ( this.options.autoFocus ) {
            this.menu.next();
        }
    },

    _resizeMenu: function() {
        var ul = this.menu.element;
        ul.outerWidth( Math.max(
            // Firefox wraps long text (possibly a rounding bug)
            // so we add 1px to avoid the wrapping (#7513)
            ul.width( "" ).outerWidth() + 1,
            this.element.outerWidth()
        ) );
    },

    _renderMenu: function( ul, items ) {
        var that = this;
        $.each( items, function( index, item ) {
            that._renderItemData( ul, item );
        });
    },

    _renderItemData: function( ul, item ) {
        return this._renderItem( ul, item ).data( "ui-autocomplete-item", item );
    },

    _renderItem: function( ul, item ) {
        return $( "<li>" ).text( item.label ).appendTo( ul );
    },

    _move: function( direction, event ) {
        if ( !this.menu.element.is( ":visible" ) ) {
            this.search( null, event );
            return;
        }
        if ( this.menu.isFirstItem() && /^previous/.test( direction ) ||
                this.menu.isLastItem() && /^next/.test( direction ) ) {

            if ( !this.isMultiLine ) {
                this._value( this.term );
            }

            this.menu.blur();
            return;
        }
        this.menu[ direction ]( event );
    },

    widget: function() {
        return this.menu.element;
    },

    _value: function() {
        return this.valueMethod.apply( this.element, arguments );
    },

    _keyEvent: function( keyEvent, event ) {
        if ( !this.isMultiLine || this.menu.element.is( ":visible" ) ) {
            this._move( keyEvent, event );

            // prevents moving cursor to beginning/end of the text field in some browsers
            event.preventDefault();
        }
    }
});

$.extend( $.ui.autocomplete, {
    escapeRegex: function( value ) {
        return value.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&" );
    },
    filter: function( array, term ) {
        var matcher = new RegExp( $.ui.autocomplete.escapeRegex( term ), "i" );
        return $.grep( array, function( value ) {
            return matcher.test( value.label || value.value || value );
        });
    }
});

// live region extension, adding a `messages` option
// NOTE: This is an experimental API. We are still investigating
// a full solution for string manipulation and internationalization.
$.widget( "ui.autocomplete", $.ui.autocomplete, {
    options: {
        messages: {
            noResults: "No search results.",
            results: function( amount ) {
                return amount + ( amount > 1 ? " results are" : " result is" ) +
                    " available, use up and down arrow keys to navigate.";
            }
        }
    },

    __response: function( content ) {
        var message;
        this._superApply( arguments );
        if ( this.options.disabled || this.cancelSearch ) {
            return;
        }
        if ( content && content.length ) {
            message = this.options.messages.results( content.length );
        } else {
            message = this.options.messages.noResults;
        }
        this.liveRegion.children().hide();
        $( "<div>" ).text( message ).appendTo( this.liveRegion );
    }
});

var autocomplete = $.ui.autocomplete;


/*!
 * jQuery UI Slider 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/
 */


var slider = $.widget( "ui.slider", $.ui.mouse, {
    version: "1.11.4",
    widgetEventPrefix: "slide",

    options: {
        animate: false,
        distance: 0,
        max: 100,
        min: 0,
        orientation: "horizontal",
        range: false,
        step: 1,
        value: 0,
        values: null,

        // callbacks
        change: null,
        slide: null,
        start: null,
        stop: null
    },

    // number of pages in a slider
    // (how many times can you page up/down to go through the whole range)
    numPages: 5,

    _create: function() {
        this._keySliding = false;
        this._mouseSliding = false;
        this._animateOff = true;
        this._handleIndex = null;
        this._detectOrientation();
        this._mouseInit();
        this._calculateNewMax();

        this.element
            .addClass( "ui-slider" +
                " ui-slider-" + this.orientation +
                " ui-widget" +
                " ui-widget-content" +
                " ui-corner-all");

        this._refresh();
        this._setOption( "disabled", this.options.disabled );

        this._animateOff = false;
    },

    _refresh: function() {
        this._createRange();
        this._createHandles();
        this._setupEvents();
        this._refreshValue();
    },

    _createHandles: function() {
        var i, handleCount,
            options = this.options,
            existingHandles = this.element.find( ".ui-slider-handle" ).addClass( "ui-state-default ui-corner-all" ),
            handle = "<span class='ui-slider-handle ui-state-default ui-corner-all' tabindex='0'></span>",
            handles = [];

        handleCount = ( options.values && options.values.length ) || 1;

        if ( existingHandles.length > handleCount ) {
            existingHandles.slice( handleCount ).remove();
            existingHandles = existingHandles.slice( 0, handleCount );
        }

        for ( i = existingHandles.length; i < handleCount; i++ ) {
            handles.push( handle );
        }

        this.handles = existingHandles.add( $( handles.join( "" ) ).appendTo( this.element ) );

        this.handle = this.handles.eq( 0 );

        this.handles.each(function( i ) {
            $( this ).data( "ui-slider-handle-index", i );
        });
    },

    _createRange: function() {
        var options = this.options,
            classes = "";

        if ( options.range ) {
            if ( options.range === true ) {
                if ( !options.values ) {
                    options.values = [ this._valueMin(), this._valueMin() ];
                } else if ( options.values.length && options.values.length !== 2 ) {
                    options.values = [ options.values[0], options.values[0] ];
                } else if ( $.isArray( options.values ) ) {
                    options.values = options.values.slice(0);
                }
            }

            if ( !this.range || !this.range.length ) {
                this.range = $( "<div></div>" )
                    .appendTo( this.element );

                classes = "ui-slider-range" +
                // note: this isn't the most fittingly semantic framework class for this element,
                // but worked best visually with a variety of themes
                " ui-widget-header ui-corner-all";
            } else {
                this.range.removeClass( "ui-slider-range-min ui-slider-range-max" )
                    // Handle range switching from true to min/max
                    .css({
                        "left": "",
                        "bottom": ""
                    });
            }

            this.range.addClass( classes +
                ( ( options.range === "min" || options.range === "max" ) ? " ui-slider-range-" + options.range : "" ) );
        } else {
            if ( this.range ) {
                this.range.remove();
            }
            this.range = null;
        }
    },

    _setupEvents: function() {
        this._off( this.handles );
        this._on( this.handles, this._handleEvents );
        this._hoverable( this.handles );
        this._focusable( this.handles );
    },

    _destroy: function() {
        this.handles.remove();
        if ( this.range ) {
            this.range.remove();
        }

        this.element
            .removeClass( "ui-slider" +
                " ui-slider-horizontal" +
                " ui-slider-vertical" +
                " ui-widget" +
                " ui-widget-content" +
                " ui-corner-all" );

        this._mouseDestroy();
    },

    _mouseCapture: function( event ) {
        var position, normValue, distance, closestHandle, index, allowed, offset, mouseOverHandle,
            that = this,
            o = this.options;

        if ( o.disabled ) {
            return false;
        }

        this.elementSize = {
            width: this.element.outerWidth(),
            height: this.element.outerHeight()
        };
        this.elementOffset = this.element.offset();

        position = { x: event.pageX, y: event.pageY };
        normValue = this._normValueFromMouse( position );
        distance = this._valueMax() - this._valueMin() + 1;
        this.handles.each(function( i ) {
            var thisDistance = Math.abs( normValue - that.values(i) );
            if (( distance > thisDistance ) ||
                ( distance === thisDistance &&
                    (i === that._lastChangedValue || that.values(i) === o.min ))) {
                distance = thisDistance;
                closestHandle = $( this );
                index = i;
            }
        });

        allowed = this._start( event, index );
        if ( allowed === false ) {
            return false;
        }
        this._mouseSliding = true;

        this._handleIndex = index;

        closestHandle
            .addClass( "ui-state-active" )
            .focus();

        offset = closestHandle.offset();
        mouseOverHandle = !$( event.target ).parents().addBack().is( ".ui-slider-handle" );
        this._clickOffset = mouseOverHandle ? { left: 0, top: 0 } : {
            left: event.pageX - offset.left - ( closestHandle.width() / 2 ),
            top: event.pageY - offset.top -
                ( closestHandle.height() / 2 ) -
                ( parseInt( closestHandle.css("borderTopWidth"), 10 ) || 0 ) -
                ( parseInt( closestHandle.css("borderBottomWidth"), 10 ) || 0) +
                ( parseInt( closestHandle.css("marginTop"), 10 ) || 0)
        };

        if ( !this.handles.hasClass( "ui-state-hover" ) ) {
            this._slide( event, index, normValue );
        }
        this._animateOff = true;
        return true;
    },

    _mouseStart: function() {
        return true;
    },

    _mouseDrag: function( event ) {
        var position = { x: event.pageX, y: event.pageY },
            normValue = this._normValueFromMouse( position );

        this._slide( event, this._handleIndex, normValue );

        return false;
    },

    _mouseStop: function( event ) {
        this.handles.removeClass( "ui-state-active" );
        this._mouseSliding = false;

        this._stop( event, this._handleIndex );
        this._change( event, this._handleIndex );

        this._handleIndex = null;
        this._clickOffset = null;
        this._animateOff = false;

        return false;
    },

    _detectOrientation: function() {
        this.orientation = ( this.options.orientation === "vertical" ) ? "vertical" : "horizontal";
    },

    _normValueFromMouse: function( position ) {
        var pixelTotal,
            pixelMouse,
            percentMouse,
            valueTotal,
            valueMouse;

        if ( this.orientation === "horizontal" ) {
            pixelTotal = this.elementSize.width;
            pixelMouse = position.x - this.elementOffset.left - ( this._clickOffset ? this._clickOffset.left : 0 );
        } else {
            pixelTotal = this.elementSize.height;
            pixelMouse = position.y - this.elementOffset.top - ( this._clickOffset ? this._clickOffset.top : 0 );
        }

        percentMouse = ( pixelMouse / pixelTotal );
        if ( percentMouse > 1 ) {
            percentMouse = 1;
        }
        if ( percentMouse < 0 ) {
            percentMouse = 0;
        }
        if ( this.orientation === "vertical" ) {
            percentMouse = 1 - percentMouse;
        }

        valueTotal = this._valueMax() - this._valueMin();
        valueMouse = this._valueMin() + percentMouse * valueTotal;

        return this._trimAlignValue( valueMouse );
    },

    _start: function( event, index ) {
        var uiHash = {
            handle: this.handles[ index ],
            value: this.value()
        };
        if ( this.options.values && this.options.values.length ) {
            uiHash.value = this.values( index );
            uiHash.values = this.values();
        }
        return this._trigger( "start", event, uiHash );
    },

    _slide: function( event, index, newVal ) {
        var otherVal,
            newValues,
            allowed;

        if ( this.options.values && this.options.values.length ) {
            otherVal = this.values( index ? 0 : 1 );

            if ( ( this.options.values.length === 2 && this.options.range === true ) &&
                    ( ( index === 0 && newVal > otherVal) || ( index === 1 && newVal < otherVal ) )
                ) {
                newVal = otherVal;
            }

            if ( newVal !== this.values( index ) ) {
                newValues = this.values();
                newValues[ index ] = newVal;
                // A slide can be canceled by returning false from the slide callback
                allowed = this._trigger( "slide", event, {
                    handle: this.handles[ index ],
                    value: newVal,
                    values: newValues
                } );
                otherVal = this.values( index ? 0 : 1 );
                if ( allowed !== false ) {
                    this.values( index, newVal );
                }
            }
        } else {
            if ( newVal !== this.value() ) {
                // A slide can be canceled by returning false from the slide callback
                allowed = this._trigger( "slide", event, {
                    handle: this.handles[ index ],
                    value: newVal
                } );
                if ( allowed !== false ) {
                    this.value( newVal );
                }
            }
        }
    },

    _stop: function( event, index ) {
        var uiHash = {
            handle: this.handles[ index ],
            value: this.value()
        };
        if ( this.options.values && this.options.values.length ) {
            uiHash.value = this.values( index );
            uiHash.values = this.values();
        }

        this._trigger( "stop", event, uiHash );
    },

    _change: function( event, index ) {
        if ( !this._keySliding && !this._mouseSliding ) {
            var uiHash = {
                handle: this.handles[ index ],
                value: this.value()
            };
            if ( this.options.values && this.options.values.length ) {
                uiHash.value = this.values( index );
                uiHash.values = this.values();
            }

            //store the last changed value index for reference when handles overlap
            this._lastChangedValue = index;

            this._trigger( "change", event, uiHash );
        }
    },

    value: function( newValue ) {
        if ( arguments.length ) {
            this.options.value = this._trimAlignValue( newValue );
            this._refreshValue();
            this._change( null, 0 );
            return;
        }

        return this._value();
    },

    values: function( index, newValue ) {
        var vals,
            newValues,
            i;

        if ( arguments.length > 1 ) {
            this.options.values[ index ] = this._trimAlignValue( newValue );
            this._refreshValue();
            this._change( null, index );
            return;
        }

        if ( arguments.length ) {
            if ( $.isArray( arguments[ 0 ] ) ) {
                vals = this.options.values;
                newValues = arguments[ 0 ];
                for ( i = 0; i < vals.length; i += 1 ) {
                    vals[ i ] = this._trimAlignValue( newValues[ i ] );
                    this._change( null, i );
                }
                this._refreshValue();
            } else {
                if ( this.options.values && this.options.values.length ) {
                    return this._values( index );
                } else {
                    return this.value();
                }
            }
        } else {
            return this._values();
        }
    },

    _setOption: function( key, value ) {
        var i,
            valsLength = 0;

        if ( key === "range" && this.options.range === true ) {
            if ( value === "min" ) {
                this.options.value = this._values( 0 );
                this.options.values = null;
            } else if ( value === "max" ) {
                this.options.value = this._values( this.options.values.length - 1 );
                this.options.values = null;
            }
        }

        if ( $.isArray( this.options.values ) ) {
            valsLength = this.options.values.length;
        }

        if ( key === "disabled" ) {
            this.element.toggleClass( "ui-state-disabled", !!value );
        }

        this._super( key, value );

        switch ( key ) {
            case "orientation":
                this._detectOrientation();
                this.element
                    .removeClass( "ui-slider-horizontal ui-slider-vertical" )
                    .addClass( "ui-slider-" + this.orientation );
                this._refreshValue();

                // Reset positioning from previous orientation
                this.handles.css( value === "horizontal" ? "bottom" : "left", "" );
                break;
            case "value":
                this._animateOff = true;
                this._refreshValue();
                this._change( null, 0 );
                this._animateOff = false;
                break;
            case "values":
                this._animateOff = true;
                this._refreshValue();
                for ( i = 0; i < valsLength; i += 1 ) {
                    this._change( null, i );
                }
                this._animateOff = false;
                break;
            case "step":
            case "min":
            case "max":
                this._animateOff = true;
                this._calculateNewMax();
                this._refreshValue();
                this._animateOff = false;
                break;
            case "range":
                this._animateOff = true;
                this._refresh();
                this._animateOff = false;
                break;
        }
    },

    //internal value getter
    // _value() returns value trimmed by min and max, aligned by step
    _value: function() {
        var val = this.options.value;
        val = this._trimAlignValue( val );

        return val;
    },

    //internal values getter
    // _values() returns array of values trimmed by min and max, aligned by step
    // _values( index ) returns single value trimmed by min and max, aligned by step
    _values: function( index ) {
        var val,
            vals,
            i;

        if ( arguments.length ) {
            val = this.options.values[ index ];
            val = this._trimAlignValue( val );

            return val;
        } else if ( this.options.values && this.options.values.length ) {
            // .slice() creates a copy of the array
            // this copy gets trimmed by min and max and then returned
            vals = this.options.values.slice();
            for ( i = 0; i < vals.length; i += 1) {
                vals[ i ] = this._trimAlignValue( vals[ i ] );
            }

            return vals;
        } else {
            return [];
        }
    },

    // returns the step-aligned value that val is closest to, between (inclusive) min and max
    _trimAlignValue: function( val ) {
        if ( val <= this._valueMin() ) {
            return this._valueMin();
        }
        if ( val >= this._valueMax() ) {
            return this._valueMax();
        }
        var step = ( this.options.step > 0 ) ? this.options.step : 1,
            valModStep = (val - this._valueMin()) % step,
            alignValue = val - valModStep;

        if ( Math.abs(valModStep) * 2 >= step ) {
            alignValue += ( valModStep > 0 ) ? step : ( -step );
        }

        // Since JavaScript has problems with large floats, round
        // the final value to 5 digits after the decimal point (see #4124)
        return parseFloat( alignValue.toFixed(5) );
    },

    _calculateNewMax: function() {
        var max = this.options.max,
            min = this._valueMin(),
            step = this.options.step,
            aboveMin = Math.floor( ( +( max - min ).toFixed( this._precision() ) ) / step ) * step;
        max = aboveMin + min;
        this.max = parseFloat( max.toFixed( this._precision() ) );
    },

    _precision: function() {
        var precision = this._precisionOf( this.options.step );
        if ( this.options.min !== null ) {
            precision = Math.max( precision, this._precisionOf( this.options.min ) );
        }
        return precision;
    },

    _precisionOf: function( num ) {
        var str = num.toString(),
            decimal = str.indexOf( "." );
        return decimal === -1 ? 0 : str.length - decimal - 1;
    },

    _valueMin: function() {
        return this.options.min;
    },

    _valueMax: function() {
        return this.max;
    },

    _refreshValue: function() {
        var lastValPercent, valPercent, value, valueMin, valueMax,
            oRange = this.options.range,
            o = this.options,
            that = this,
            animate = ( !this._animateOff ) ? o.animate : false,
            _set = {};

        if ( this.options.values && this.options.values.length ) {
            this.handles.each(function( i ) {
                valPercent = ( that.values(i) - that._valueMin() ) / ( that._valueMax() - that._valueMin() ) * 100;
                _set[ that.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
                $( this ).stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );
                if ( that.options.range === true ) {
                    if ( that.orientation === "horizontal" ) {
                        if ( i === 0 ) {
                            that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { left: valPercent + "%" }, o.animate );
                        }
                        if ( i === 1 ) {
                            that.range[ animate ? "animate" : "css" ]( { width: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
                        }
                    } else {
                        if ( i === 0 ) {
                            that.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { bottom: ( valPercent ) + "%" }, o.animate );
                        }
                        if ( i === 1 ) {
                            that.range[ animate ? "animate" : "css" ]( { height: ( valPercent - lastValPercent ) + "%" }, { queue: false, duration: o.animate } );
                        }
                    }
                }
                lastValPercent = valPercent;
            });
        } else {
            value = this.value();
            valueMin = this._valueMin();
            valueMax = this._valueMax();
            valPercent = ( valueMax !== valueMin ) ?
                    ( value - valueMin ) / ( valueMax - valueMin ) * 100 :
                    0;
            _set[ this.orientation === "horizontal" ? "left" : "bottom" ] = valPercent + "%";
            this.handle.stop( 1, 1 )[ animate ? "animate" : "css" ]( _set, o.animate );

            if ( oRange === "min" && this.orientation === "horizontal" ) {
                this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { width: valPercent + "%" }, o.animate );
            }
            if ( oRange === "max" && this.orientation === "horizontal" ) {
                this.range[ animate ? "animate" : "css" ]( { width: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
            }
            if ( oRange === "min" && this.orientation === "vertical" ) {
                this.range.stop( 1, 1 )[ animate ? "animate" : "css" ]( { height: valPercent + "%" }, o.animate );
            }
            if ( oRange === "max" && this.orientation === "vertical" ) {
                this.range[ animate ? "animate" : "css" ]( { height: ( 100 - valPercent ) + "%" }, { queue: false, duration: o.animate } );
            }
        }
    },

    _handleEvents: {
        keydown: function( event ) {
            var allowed, curVal, newVal, step,
                index = $( event.target ).data( "ui-slider-handle-index" );

            switch ( event.keyCode ) {
                case $.ui.keyCode.HOME:
                case $.ui.keyCode.END:
                case $.ui.keyCode.PAGE_UP:
                case $.ui.keyCode.PAGE_DOWN:
                case $.ui.keyCode.UP:
                case $.ui.keyCode.RIGHT:
                case $.ui.keyCode.DOWN:
                case $.ui.keyCode.LEFT:
                    event.preventDefault();
                    if ( !this._keySliding ) {
                        this._keySliding = true;
                        $( event.target ).addClass( "ui-state-active" );
                        allowed = this._start( event, index );
                        if ( allowed === false ) {
                            return;
                        }
                    }
                    break;
            }

            step = this.options.step;
            if ( this.options.values && this.options.values.length ) {
                curVal = newVal = this.values( index );
            } else {
                curVal = newVal = this.value();
            }

            switch ( event.keyCode ) {
                case $.ui.keyCode.HOME:
                    newVal = this._valueMin();
                    break;
                case $.ui.keyCode.END:
                    newVal = this._valueMax();
                    break;
                case $.ui.keyCode.PAGE_UP:
                    newVal = this._trimAlignValue(
                        curVal + ( ( this._valueMax() - this._valueMin() ) / this.numPages )
                    );
                    break;
                case $.ui.keyCode.PAGE_DOWN:
                    newVal = this._trimAlignValue(
                        curVal - ( (this._valueMax() - this._valueMin()) / this.numPages ) );
                    break;
                case $.ui.keyCode.UP:
                case $.ui.keyCode.RIGHT:
                    if ( curVal === this._valueMax() ) {
                        return;
                    }
                    newVal = this._trimAlignValue( curVal + step );
                    break;
                case $.ui.keyCode.DOWN:
                case $.ui.keyCode.LEFT:
                    if ( curVal === this._valueMin() ) {
                        return;
                    }
                    newVal = this._trimAlignValue( curVal - step );
                    break;
            }

            this._slide( event, index, newVal );
        },
        keyup: function( event ) {
            var index = $( event.target ).data( "ui-slider-handle-index" );

            if ( this._keySliding ) {
                this._keySliding = false;
                this._stop( event, index );
                this._change( event, index );
                $( event.target ).removeClass( "ui-state-active" );
            }
        }
    }
});


/*!
 * jQuery UI Tabs 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tabs/
 */


var tabs = $.widget( "ui.tabs", {
    version: "1.11.4",
    delay: 300,
    options: {
        active: null,
        collapsible: false,
        event: "click",
        heightStyle: "content",
        hide: null,
        show: null,

        // callbacks
        activate: null,
        beforeActivate: null,
        beforeLoad: null,
        load: null
    },

    _isLocal: (function() {
        var rhash = /#.*$/;

        return function( anchor ) {
            var anchorUrl, locationUrl;

            // support: IE7
            // IE7 doesn't normalize the href property when set via script (#9317)
            anchor = anchor.cloneNode( false );

            anchorUrl = anchor.href.replace( rhash, "" );
            locationUrl = location.href.replace( rhash, "" );

            // decoding may throw an error if the URL isn't UTF-8 (#9518)
            try {
                anchorUrl = decodeURIComponent( anchorUrl );
            } catch ( error ) {}
            try {
                locationUrl = decodeURIComponent( locationUrl );
            } catch ( error ) {}

            return anchor.hash.length > 1 && anchorUrl === locationUrl;
        };
    })(),

    _create: function() {
        var that = this,
            options = this.options;

        this.running = false;

        this.element
            .addClass( "ui-tabs ui-widget ui-widget-content ui-corner-all" )
            .toggleClass( "ui-tabs-collapsible", options.collapsible );

        this._processTabs();
        options.active = this._initialActive();

        // Take disabling tabs via class attribute from HTML
        // into account and update option properly.
        if ( $.isArray( options.disabled ) ) {
            options.disabled = $.unique( options.disabled.concat(
                $.map( this.tabs.filter( ".ui-state-disabled" ), function( li ) {
                    return that.tabs.index( li );
                })
            ) ).sort();
        }

        // check for length avoids error when initializing empty list
        if ( this.options.active !== false && this.anchors.length ) {
            this.active = this._findActive( options.active );
        } else {
            this.active = $();
        }

        this._refresh();

        if ( this.active.length ) {
            this.load( options.active );
        }
    },

    _initialActive: function() {
        var active = this.options.active,
            collapsible = this.options.collapsible,
            locationHash = location.hash.substring( 1 );

        if ( active === null ) {
            // check the fragment identifier in the URL
            if ( locationHash ) {
                this.tabs.each(function( i, tab ) {
                    if ( $( tab ).attr( "aria-controls" ) === locationHash ) {
                        active = i;
                        return false;
                    }
                });
            }

            // check for a tab marked active via a class
            if ( active === null ) {
                active = this.tabs.index( this.tabs.filter( ".ui-tabs-active" ) );
            }

            // no active tab, set to false
            if ( active === null || active === -1 ) {
                active = this.tabs.length ? 0 : false;
            }
        }

        // handle numbers: negative, out of range
        if ( active !== false ) {
            active = this.tabs.index( this.tabs.eq( active ) );
            if ( active === -1 ) {
                active = collapsible ? false : 0;
            }
        }

        // don't allow collapsible: false and active: false
        if ( !collapsible && active === false && this.anchors.length ) {
            active = 0;
        }

        return active;
    },

    _getCreateEventData: function() {
        return {
            tab: this.active,
            panel: !this.active.length ? $() : this._getPanelForTab( this.active )
        };
    },

    _tabKeydown: function( event ) {
        var focusedTab = $( this.document[0].activeElement ).closest( "li" ),
            selectedIndex = this.tabs.index( focusedTab ),
            goingForward = true;

        if ( this._handlePageNav( event ) ) {
            return;
        }

        switch ( event.keyCode ) {
            case $.ui.keyCode.RIGHT:
            case $.ui.keyCode.DOWN:
                selectedIndex++;
                break;
            case $.ui.keyCode.UP:
            case $.ui.keyCode.LEFT:
                goingForward = false;
                selectedIndex--;
                break;
            case $.ui.keyCode.END:
                selectedIndex = this.anchors.length - 1;
                break;
            case $.ui.keyCode.HOME:
                selectedIndex = 0;
                break;
            case $.ui.keyCode.SPACE:
                // Activate only, no collapsing
                event.preventDefault();
                clearTimeout( this.activating );
                this._activate( selectedIndex );
                return;
            case $.ui.keyCode.ENTER:
                // Toggle (cancel delayed activation, allow collapsing)
                event.preventDefault();
                clearTimeout( this.activating );
                // Determine if we should collapse or activate
                this._activate( selectedIndex === this.options.active ? false : selectedIndex );
                return;
            default:
                return;
        }

        // Focus the appropriate tab, based on which key was pressed
        event.preventDefault();
        clearTimeout( this.activating );
        selectedIndex = this._focusNextTab( selectedIndex, goingForward );

        // Navigating with control/command key will prevent automatic activation
        if ( !event.ctrlKey && !event.metaKey ) {

            // Update aria-selected immediately so that AT think the tab is already selected.
            // Otherwise AT may confuse the user by stating that they need to activate the tab,
            // but the tab will already be activated by the time the announcement finishes.
            focusedTab.attr( "aria-selected", "false" );
            this.tabs.eq( selectedIndex ).attr( "aria-selected", "true" );

            this.activating = this._delay(function() {
                this.option( "active", selectedIndex );
            }, this.delay );
        }
    },

    _panelKeydown: function( event ) {
        if ( this._handlePageNav( event ) ) {
            return;
        }

        // Ctrl+up moves focus to the current tab
        if ( event.ctrlKey && event.keyCode === $.ui.keyCode.UP ) {
            event.preventDefault();
            this.active.focus();
        }
    },

    // Alt+page up/down moves focus to the previous/next tab (and activates)
    _handlePageNav: function( event ) {
        if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_UP ) {
            this._activate( this._focusNextTab( this.options.active - 1, false ) );
            return true;
        }
        if ( event.altKey && event.keyCode === $.ui.keyCode.PAGE_DOWN ) {
            this._activate( this._focusNextTab( this.options.active + 1, true ) );
            return true;
        }
    },

    _findNextTab: function( index, goingForward ) {
        var lastTabIndex = this.tabs.length - 1;

        function constrain() {
            if ( index > lastTabIndex ) {
                index = 0;
            }
            if ( index < 0 ) {
                index = lastTabIndex;
            }
            return index;
        }

        while ( $.inArray( constrain(), this.options.disabled ) !== -1 ) {
            index = goingForward ? index + 1 : index - 1;
        }

        return index;
    },

    _focusNextTab: function( index, goingForward ) {
        index = this._findNextTab( index, goingForward );
        this.tabs.eq( index ).focus();
        return index;
    },

    _setOption: function( key, value ) {
        if ( key === "active" ) {
            // _activate() will handle invalid values and update this.options
            this._activate( value );
            return;
        }

        if ( key === "disabled" ) {
            // don't use the widget factory's disabled handling
            this._setupDisabled( value );
            return;
        }

        this._super( key, value);

        if ( key === "collapsible" ) {
            this.element.toggleClass( "ui-tabs-collapsible", value );
            // Setting collapsible: false while collapsed; open first panel
            if ( !value && this.options.active === false ) {
                this._activate( 0 );
            }
        }

        if ( key === "event" ) {
            this._setupEvents( value );
        }

        if ( key === "heightStyle" ) {
            this._setupHeightStyle( value );
        }
    },

    _sanitizeSelector: function( hash ) {
        return hash ? hash.replace( /[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&" ) : "";
    },

    refresh: function() {
        var options = this.options,
            lis = this.tablist.children( ":has(a[href])" );

        // get disabled tabs from class attribute from HTML
        // this will get converted to a boolean if needed in _refresh()
        options.disabled = $.map( lis.filter( ".ui-state-disabled" ), function( tab ) {
            return lis.index( tab );
        });

        this._processTabs();

        // was collapsed or no tabs
        if ( options.active === false || !this.anchors.length ) {
            options.active = false;
            this.active = $();
        // was active, but active tab is gone
        } else if ( this.active.length && !$.contains( this.tablist[ 0 ], this.active[ 0 ] ) ) {
            // all remaining tabs are disabled
            if ( this.tabs.length === options.disabled.length ) {
                options.active = false;
                this.active = $();
            // activate previous tab
            } else {
                this._activate( this._findNextTab( Math.max( 0, options.active - 1 ), false ) );
            }
        // was active, active tab still exists
        } else {
            // make sure active index is correct
            options.active = this.tabs.index( this.active );
        }

        this._refresh();
    },

    _refresh: function() {
        this._setupDisabled( this.options.disabled );
        this._setupEvents( this.options.event );
        this._setupHeightStyle( this.options.heightStyle );

        this.tabs.not( this.active ).attr({
            "aria-selected": "false",
            "aria-expanded": "false",
            tabIndex: -1
        });
        this.panels.not( this._getPanelForTab( this.active ) )
            .hide()
            .attr({
                "aria-hidden": "true"
            });

        // Make sure one tab is in the tab order
        if ( !this.active.length ) {
            this.tabs.eq( 0 ).attr( "tabIndex", 0 );
        } else {
            this.active
                .addClass( "ui-tabs-active ui-state-active" )
                .attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                });
            this._getPanelForTab( this.active )
                .show()
                .attr({
                    "aria-hidden": "false"
                });
        }
    },

    _processTabs: function() {
        var that = this,
            prevTabs = this.tabs,
            prevAnchors = this.anchors,
            prevPanels = this.panels;

        this.tablist = this._getList()
            .addClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
            .attr( "role", "tablist" )

            // Prevent users from focusing disabled tabs via click
            .delegate( "> li", "mousedown" + this.eventNamespace, function( event ) {
                if ( $( this ).is( ".ui-state-disabled" ) ) {
                    event.preventDefault();
                }
            })

            // support: IE <9
            // Preventing the default action in mousedown doesn't prevent IE
            // from focusing the element, so if the anchor gets focused, blur.
            // We don't have to worry about focusing the previously focused
            // element since clicking on a non-focusable element should focus
            // the body anyway.
            .delegate( ".ui-tabs-anchor", "focus" + this.eventNamespace, function() {
                if ( $( this ).closest( "li" ).is( ".ui-state-disabled" ) ) {
                    this.blur();
                }
            });

        this.tabs = this.tablist.find( "> li:has(a[href])" )
            .addClass( "ui-state-default ui-corner-top" )
            .attr({
                role: "tab",
                tabIndex: -1
            });

        this.anchors = this.tabs.map(function() {
                return $( "a", this )[ 0 ];
            })
            .addClass( "ui-tabs-anchor" )
            .attr({
                role: "presentation",
                tabIndex: -1
            });

        this.panels = $();

        this.anchors.each(function( i, anchor ) {
            var selector, panel, panelId,
                anchorId = $( anchor ).uniqueId().attr( "id" ),
                tab = $( anchor ).closest( "li" ),
                originalAriaControls = tab.attr( "aria-controls" );

            // inline tab
            if ( that._isLocal( anchor ) ) {
                selector = anchor.hash;
                panelId = selector.substring( 1 );
                panel = that.element.find( that._sanitizeSelector( selector ) );
            // remote tab
            } else {
                // If the tab doesn't already have aria-controls,
                // generate an id by using a throw-away element
                panelId = tab.attr( "aria-controls" ) || $( {} ).uniqueId()[ 0 ].id;
                selector = "#" + panelId;
                panel = that.element.find( selector );
                if ( !panel.length ) {
                    panel = that._createPanel( panelId );
                    panel.insertAfter( that.panels[ i - 1 ] || that.tablist );
                }
                panel.attr( "aria-live", "polite" );
            }

            if ( panel.length) {
                that.panels = that.panels.add( panel );
            }
            if ( originalAriaControls ) {
                tab.data( "ui-tabs-aria-controls", originalAriaControls );
            }
            tab.attr({
                "aria-controls": panelId,
                "aria-labelledby": anchorId
            });
            panel.attr( "aria-labelledby", anchorId );
        });

        this.panels
            .addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
            .attr( "role", "tabpanel" );

        // Avoid memory leaks (#10056)
        if ( prevTabs ) {
            this._off( prevTabs.not( this.tabs ) );
            this._off( prevAnchors.not( this.anchors ) );
            this._off( prevPanels.not( this.panels ) );
        }
    },

    // allow overriding how to find the list for rare usage scenarios (#7715)
    _getList: function() {
        return this.tablist || this.element.find( "ol,ul" ).eq( 0 );
    },

    _createPanel: function( id ) {
        return $( "<div>" )
            .attr( "id", id )
            .addClass( "ui-tabs-panel ui-widget-content ui-corner-bottom" )
            .data( "ui-tabs-destroy", true );
    },

    _setupDisabled: function( disabled ) {
        if ( $.isArray( disabled ) ) {
            if ( !disabled.length ) {
                disabled = false;
            } else if ( disabled.length === this.anchors.length ) {
                disabled = true;
            }
        }

        // disable tabs
        for ( var i = 0, li; ( li = this.tabs[ i ] ); i++ ) {
            if ( disabled === true || $.inArray( i, disabled ) !== -1 ) {
                $( li )
                    .addClass( "ui-state-disabled" )
                    .attr( "aria-disabled", "true" );
            } else {
                $( li )
                    .removeClass( "ui-state-disabled" )
                    .removeAttr( "aria-disabled" );
            }
        }

        this.options.disabled = disabled;
    },

    _setupEvents: function( event ) {
        var events = {};
        if ( event ) {
            $.each( event.split(" "), function( index, eventName ) {
                events[ eventName ] = "_eventHandler";
            });
        }

        this._off( this.anchors.add( this.tabs ).add( this.panels ) );
        // Always prevent the default action, even when disabled
        this._on( true, this.anchors, {
            click: function( event ) {
                event.preventDefault();
            }
        });
        this._on( this.anchors, events );
        this._on( this.tabs, { keydown: "_tabKeydown" } );
        this._on( this.panels, { keydown: "_panelKeydown" } );

        this._focusable( this.tabs );
        this._hoverable( this.tabs );
    },

    _setupHeightStyle: function( heightStyle ) {
        var maxHeight,
            parent = this.element.parent();

        if ( heightStyle === "fill" ) {
            maxHeight = parent.height();
            maxHeight -= this.element.outerHeight() - this.element.height();

            this.element.siblings( ":visible" ).each(function() {
                var elem = $( this ),
                    position = elem.css( "position" );

                if ( position === "absolute" || position === "fixed" ) {
                    return;
                }
                maxHeight -= elem.outerHeight( true );
            });

            this.element.children().not( this.panels ).each(function() {
                maxHeight -= $( this ).outerHeight( true );
            });

            this.panels.each(function() {
                $( this ).height( Math.max( 0, maxHeight -
                    $( this ).innerHeight() + $( this ).height() ) );
            })
            .css( "overflow", "auto" );
        } else if ( heightStyle === "auto" ) {
            maxHeight = 0;
            this.panels.each(function() {
                maxHeight = Math.max( maxHeight, $( this ).height( "" ).height() );
            }).height( maxHeight );
        }
    },

    _eventHandler: function( event ) {
        var options = this.options,
            active = this.active,
            anchor = $( event.currentTarget ),
            tab = anchor.closest( "li" ),
            clickedIsActive = tab[ 0 ] === active[ 0 ],
            collapsing = clickedIsActive && options.collapsible,
            toShow = collapsing ? $() : this._getPanelForTab( tab ),
            toHide = !active.length ? $() : this._getPanelForTab( active ),
            eventData = {
                oldTab: active,
                oldPanel: toHide,
                newTab: collapsing ? $() : tab,
                newPanel: toShow
            };

        event.preventDefault();

        if ( tab.hasClass( "ui-state-disabled" ) ||
                // tab is already loading
                tab.hasClass( "ui-tabs-loading" ) ||
                // can't switch durning an animation
                this.running ||
                // click on active header, but not collapsible
                ( clickedIsActive && !options.collapsible ) ||
                // allow canceling activation
                ( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
            return;
        }

        options.active = collapsing ? false : this.tabs.index( tab );

        this.active = clickedIsActive ? $() : tab;
        if ( this.xhr ) {
            this.xhr.abort();
        }

        if ( !toHide.length && !toShow.length ) {
            $.error( "jQuery UI Tabs: Mismatching fragment identifier." );
        }

        if ( toShow.length ) {
            this.load( this.tabs.index( tab ), event );
        }
        this._toggle( event, eventData );
    },

    // handles show/hide for selecting tabs
    _toggle: function( event, eventData ) {
        var that = this,
            toShow = eventData.newPanel,
            toHide = eventData.oldPanel;

        this.running = true;

        function complete() {
            that.running = false;
            that._trigger( "activate", event, eventData );
        }

        function show() {
            eventData.newTab.closest( "li" ).addClass( "ui-tabs-active ui-state-active" );

            if ( toShow.length && that.options.show ) {
                that._show( toShow, that.options.show, complete );
            } else {
                toShow.show();
                complete();
            }
        }

        // start out by hiding, then showing, then completing
        if ( toHide.length && this.options.hide ) {
            this._hide( toHide, this.options.hide, function() {
                eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
                show();
            });
        } else {
            eventData.oldTab.closest( "li" ).removeClass( "ui-tabs-active ui-state-active" );
            toHide.hide();
            show();
        }

        toHide.attr( "aria-hidden", "true" );
        eventData.oldTab.attr({
            "aria-selected": "false",
            "aria-expanded": "false"
        });
        // If we're switching tabs, remove the old tab from the tab order.
        // If we're opening from collapsed state, remove the previous tab from the tab order.
        // If we're collapsing, then keep the collapsing tab in the tab order.
        if ( toShow.length && toHide.length ) {
            eventData.oldTab.attr( "tabIndex", -1 );
        } else if ( toShow.length ) {
            this.tabs.filter(function() {
                return $( this ).attr( "tabIndex" ) === 0;
            })
            .attr( "tabIndex", -1 );
        }

        toShow.attr( "aria-hidden", "false" );
        eventData.newTab.attr({
            "aria-selected": "true",
            "aria-expanded": "true",
            tabIndex: 0
        });
    },

    _activate: function( index ) {
        var anchor,
            active = this._findActive( index );

        // trying to activate the already active panel
        if ( active[ 0 ] === this.active[ 0 ] ) {
            return;
        }

        // trying to collapse, simulate a click on the current active header
        if ( !active.length ) {
            active = this.active;
        }

        anchor = active.find( ".ui-tabs-anchor" )[ 0 ];
        this._eventHandler({
            target: anchor,
            currentTarget: anchor,
            preventDefault: $.noop
        });
    },

    _findActive: function( index ) {
        return index === false ? $() : this.tabs.eq( index );
    },

    _getIndex: function( index ) {
        // meta-function to give users option to provide a href string instead of a numerical index.
        if ( typeof index === "string" ) {
            index = this.anchors.index( this.anchors.filter( "[href$='" + index + "']" ) );
        }

        return index;
    },

    _destroy: function() {
        if ( this.xhr ) {
            this.xhr.abort();
        }

        this.element.removeClass( "ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible" );

        this.tablist
            .removeClass( "ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" )
            .removeAttr( "role" );

        this.anchors
            .removeClass( "ui-tabs-anchor" )
            .removeAttr( "role" )
            .removeAttr( "tabIndex" )
            .removeUniqueId();

        this.tablist.unbind( this.eventNamespace );

        this.tabs.add( this.panels ).each(function() {
            if ( $.data( this, "ui-tabs-destroy" ) ) {
                $( this ).remove();
            } else {
                $( this )
                    .removeClass( "ui-state-default ui-state-active ui-state-disabled " +
                        "ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel" )
                    .removeAttr( "tabIndex" )
                    .removeAttr( "aria-live" )
                    .removeAttr( "aria-busy" )
                    .removeAttr( "aria-selected" )
                    .removeAttr( "aria-labelledby" )
                    .removeAttr( "aria-hidden" )
                    .removeAttr( "aria-expanded" )
                    .removeAttr( "role" );
            }
        });

        this.tabs.each(function() {
            var li = $( this ),
                prev = li.data( "ui-tabs-aria-controls" );
            if ( prev ) {
                li
                    .attr( "aria-controls", prev )
                    .removeData( "ui-tabs-aria-controls" );
            } else {
                li.removeAttr( "aria-controls" );
            }
        });

        this.panels.show();

        if ( this.options.heightStyle !== "content" ) {
            this.panels.css( "height", "" );
        }
    },

    enable: function( index ) {
        var disabled = this.options.disabled;
        if ( disabled === false ) {
            return;
        }

        if ( index === undefined ) {
            disabled = false;
        } else {
            index = this._getIndex( index );
            if ( $.isArray( disabled ) ) {
                disabled = $.map( disabled, function( num ) {
                    return num !== index ? num : null;
                });
            } else {
                disabled = $.map( this.tabs, function( li, num ) {
                    return num !== index ? num : null;
                });
            }
        }
        this._setupDisabled( disabled );
    },

    disable: function( index ) {
        var disabled = this.options.disabled;
        if ( disabled === true ) {
            return;
        }

        if ( index === undefined ) {
            disabled = true;
        } else {
            index = this._getIndex( index );
            if ( $.inArray( index, disabled ) !== -1 ) {
                return;
            }
            if ( $.isArray( disabled ) ) {
                disabled = $.merge( [ index ], disabled ).sort();
            } else {
                disabled = [ index ];
            }
        }
        this._setupDisabled( disabled );
    },

    load: function( index, event ) {
        index = this._getIndex( index );
        var that = this,
            tab = this.tabs.eq( index ),
            anchor = tab.find( ".ui-tabs-anchor" ),
            panel = this._getPanelForTab( tab ),
            eventData = {
                tab: tab,
                panel: panel
            },
            complete = function( jqXHR, status ) {
                if ( status === "abort" ) {
                    that.panels.stop( false, true );
                }

                tab.removeClass( "ui-tabs-loading" );
                panel.removeAttr( "aria-busy" );

                if ( jqXHR === that.xhr ) {
                    delete that.xhr;
                }
            };

        // not remote
        if ( this._isLocal( anchor[ 0 ] ) ) {
            return;
        }

        this.xhr = $.ajax( this._ajaxSettings( anchor, event, eventData ) );

        // support: jQuery <1.8
        // jQuery <1.8 returns false if the request is canceled in beforeSend,
        // but as of 1.8, $.ajax() always returns a jqXHR object.
        if ( this.xhr && this.xhr.statusText !== "canceled" ) {
            tab.addClass( "ui-tabs-loading" );
            panel.attr( "aria-busy", "true" );

            this.xhr
                .done(function( response, status, jqXHR ) {
                    // support: jQuery <1.8
                    // http://bugs.jquery.com/ticket/11778
                    setTimeout(function() {
                        panel.html( response );
                        that._trigger( "load", event, eventData );

                        complete( jqXHR, status );
                    }, 1 );
                })
                .fail(function( jqXHR, status ) {
                    // support: jQuery <1.8
                    // http://bugs.jquery.com/ticket/11778
                    setTimeout(function() {
                        complete( jqXHR, status );
                    }, 1 );
                });
        }
    },

    _ajaxSettings: function( anchor, event, eventData ) {
        var that = this;
        return {
            url: anchor.attr( "href" ),
            beforeSend: function( jqXHR, settings ) {
                return that._trigger( "beforeLoad", event,
                    $.extend( { jqXHR: jqXHR, ajaxSettings: settings }, eventData ) );
            }
        };
    },

    _getPanelForTab: function( tab ) {
        var id = $( tab ).attr( "aria-controls" );
        return this.element.find( this._sanitizeSelector( "#" + id ) );
    }
});


/*!
 * jQuery UI Tooltip 1.11.4
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/tooltip/
 */


var tooltip = $.widget( "ui.tooltip", {
    version: "1.11.4",
    options: {
        content: function() {
            // support: IE<9, Opera in jQuery <1.7
            // .text() can't accept undefined, so coerce to a string
            var title = $( this ).attr( "title" ) || "";
            // Escape title, since we're going from an attribute to raw HTML
            return $( "<a>" ).text( title ).html();
        },
        hide: true,
        // Disabled elements have inconsistent behavior across browsers (#8661)
        items: "[title]:not([disabled])",
        position: {
            my: "left top+15",
            at: "left bottom",
            collision: "flipfit flip"
        },
        show: true,
        tooltipClass: null,
        track: false,

        // callbacks
        close: null,
        open: null
    },

    _addDescribedBy: function( elem, id ) {
        var describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ );
        describedby.push( id );
        elem
            .data( "ui-tooltip-id", id )
            .attr( "aria-describedby", $.trim( describedby.join( " " ) ) );
    },

    _removeDescribedBy: function( elem ) {
        var id = elem.data( "ui-tooltip-id" ),
            describedby = (elem.attr( "aria-describedby" ) || "").split( /\s+/ ),
            index = $.inArray( id, describedby );

        if ( index !== -1 ) {
            describedby.splice( index, 1 );
        }

        elem.removeData( "ui-tooltip-id" );
        describedby = $.trim( describedby.join( " " ) );
        if ( describedby ) {
            elem.attr( "aria-describedby", describedby );
        } else {
            elem.removeAttr( "aria-describedby" );
        }
    },

    _create: function() {
        this._on({
            mouseover: "open",
            focusin: "open"
        });

        // IDs of generated tooltips, needed for destroy
        this.tooltips = {};

        // IDs of parent tooltips where we removed the title attribute
        this.parents = {};

        if ( this.options.disabled ) {
            this._disable();
        }

        // Append the aria-live region so tooltips announce correctly
        this.liveRegion = $( "<div>" )
            .attr({
                role: "log",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            })
            .addClass( "ui-helper-hidden-accessible" )
            .appendTo( this.document[ 0 ].body );
    },

    _setOption: function( key, value ) {
        var that = this;

        if ( key === "disabled" ) {
            this[ value ? "_disable" : "_enable" ]();
            this.options[ key ] = value;
            // disable element style changes
            return;
        }

        this._super( key, value );

        if ( key === "content" ) {
            $.each( this.tooltips, function( id, tooltipData ) {
                that._updateContent( tooltipData.element );
            });
        }
    },

    _disable: function() {
        var that = this;

        // close open tooltips
        $.each( this.tooltips, function( id, tooltipData ) {
            var event = $.Event( "blur" );
            event.target = event.currentTarget = tooltipData.element[ 0 ];
            that.close( event, true );
        });

        // remove title attributes to prevent native tooltips
        this.element.find( this.options.items ).addBack().each(function() {
            var element = $( this );
            if ( element.is( "[title]" ) ) {
                element
                    .data( "ui-tooltip-title", element.attr( "title" ) )
                    .removeAttr( "title" );
            }
        });
    },

    _enable: function() {
        // restore title attributes
        this.element.find( this.options.items ).addBack().each(function() {
            var element = $( this );
            if ( element.data( "ui-tooltip-title" ) ) {
                element.attr( "title", element.data( "ui-tooltip-title" ) );
            }
        });
    },

    open: function( event ) {
        var that = this,
            target = $( event ? event.target : this.element )
                // we need closest here due to mouseover bubbling,
                // but always pointing at the same event target
                .closest( this.options.items );

        // No element to show a tooltip for or the tooltip is already open
        if ( !target.length || target.data( "ui-tooltip-id" ) ) {
            return;
        }

        if ( target.attr( "title" ) ) {
            target.data( "ui-tooltip-title", target.attr( "title" ) );
        }

        target.data( "ui-tooltip-open", true );

        // kill parent tooltips, custom or native, for hover
        if ( event && event.type === "mouseover" ) {
            target.parents().each(function() {
                var parent = $( this ),
                    blurEvent;
                if ( parent.data( "ui-tooltip-open" ) ) {
                    blurEvent = $.Event( "blur" );
                    blurEvent.target = blurEvent.currentTarget = this;
                    that.close( blurEvent, true );
                }
                if ( parent.attr( "title" ) ) {
                    parent.uniqueId();
                    that.parents[ this.id ] = {
                        element: this,
                        title: parent.attr( "title" )
                    };
                    parent.attr( "title", "" );
                }
            });
        }

        this._registerCloseHandlers( event, target );
        this._updateContent( target, event );
    },

    _updateContent: function( target, event ) {
        var content,
            contentOption = this.options.content,
            that = this,
            eventType = event ? event.type : null;

        if ( typeof contentOption === "string" ) {
            return this._open( event, target, contentOption );
        }

        content = contentOption.call( target[0], function( response ) {

            // IE may instantly serve a cached response for ajax requests
            // delay this call to _open so the other call to _open runs first
            that._delay(function() {

                // Ignore async response if tooltip was closed already
                if ( !target.data( "ui-tooltip-open" ) ) {
                    return;
                }

                // jQuery creates a special event for focusin when it doesn't
                // exist natively. To improve performance, the native event
                // object is reused and the type is changed. Therefore, we can't
                // rely on the type being correct after the event finished
                // bubbling, so we set it back to the previous value. (#8740)
                if ( event ) {
                    event.type = eventType;
                }
                this._open( event, target, response );
            });
        });
        if ( content ) {
            this._open( event, target, content );
        }
    },

    _open: function( event, target, content ) {
        var tooltipData, tooltip, delayedShow, a11yContent,
            positionOption = $.extend( {}, this.options.position );

        if ( !content ) {
            return;
        }

        // Content can be updated multiple times. If the tooltip already
        // exists, then just update the content and bail.
        tooltipData = this._find( target );
        if ( tooltipData ) {
            tooltipData.tooltip.find( ".ui-tooltip-content" ).html( content );
            return;
        }

        // if we have a title, clear it to prevent the native tooltip
        // we have to check first to avoid defining a title if none exists
        // (we don't want to cause an element to start matching [title])
        //
        // We use removeAttr only for key events, to allow IE to export the correct
        // accessible attributes. For mouse events, set to empty string to avoid
        // native tooltip showing up (happens only when removing inside mouseover).
        if ( target.is( "[title]" ) ) {
            if ( event && event.type === "mouseover" ) {
                target.attr( "title", "" );
            } else {
                target.removeAttr( "title" );
            }
        }

        tooltipData = this._tooltip( target );
        tooltip = tooltipData.tooltip;
        this._addDescribedBy( target, tooltip.attr( "id" ) );
        tooltip.find( ".ui-tooltip-content" ).html( content );

        // Support: Voiceover on OS X, JAWS on IE <= 9
        // JAWS announces deletions even when aria-relevant="additions"
        // Voiceover will sometimes re-read the entire log region's contents from the beginning
        this.liveRegion.children().hide();
        if ( content.clone ) {
            a11yContent = content.clone();
            a11yContent.removeAttr( "id" ).find( "[id]" ).removeAttr( "id" );
        } else {
            a11yContent = content;
        }
        $( "<div>" ).html( a11yContent ).appendTo( this.liveRegion );

        function position( event ) {
            positionOption.of = event;
            if ( tooltip.is( ":hidden" ) ) {
                return;
            }
            tooltip.position( positionOption );
        }
        if ( this.options.track && event && /^mouse/.test( event.type ) ) {
            this._on( this.document, {
                mousemove: position
            });
            // trigger once to override element-relative positioning
            position( event );
        } else {
            tooltip.position( $.extend({
                of: target
            }, this.options.position ) );
        }

        tooltip.hide();

        this._show( tooltip, this.options.show );
        // Handle tracking tooltips that are shown with a delay (#8644). As soon
        // as the tooltip is visible, position the tooltip using the most recent
        // event.
        if ( this.options.show && this.options.show.delay ) {
            delayedShow = this.delayedShow = setInterval(function() {
                if ( tooltip.is( ":visible" ) ) {
                    position( positionOption.of );
                    clearInterval( delayedShow );
                }
            }, $.fx.interval );
        }

        this._trigger( "open", event, { tooltip: tooltip } );
    },

    _registerCloseHandlers: function( event, target ) {
        var events = {
            keyup: function( event ) {
                if ( event.keyCode === $.ui.keyCode.ESCAPE ) {
                    var fakeEvent = $.Event(event);
                    fakeEvent.currentTarget = target[0];
                    this.close( fakeEvent, true );
                }
            }
        };

        // Only bind remove handler for delegated targets. Non-delegated
        // tooltips will handle this in destroy.
        if ( target[ 0 ] !== this.element[ 0 ] ) {
            events.remove = function() {
                this._removeTooltip( this._find( target ).tooltip );
            };
        }

        if ( !event || event.type === "mouseover" ) {
            events.mouseleave = "close";
        }
        if ( !event || event.type === "focusin" ) {
            events.focusout = "close";
        }
        this._on( true, target, events );
    },

    close: function( event ) {
        var tooltip,
            that = this,
            target = $( event ? event.currentTarget : this.element ),
            tooltipData = this._find( target );

        // The tooltip may already be closed
        if ( !tooltipData ) {

            // We set ui-tooltip-open immediately upon open (in open()), but only set the
            // additional data once there's actually content to show (in _open()). So even if the
            // tooltip doesn't have full data, we always remove ui-tooltip-open in case we're in
            // the period between open() and _open().
            target.removeData( "ui-tooltip-open" );
            return;
        }

        tooltip = tooltipData.tooltip;

        // disabling closes the tooltip, so we need to track when we're closing
        // to avoid an infinite loop in case the tooltip becomes disabled on close
        if ( tooltipData.closing ) {
            return;
        }

        // Clear the interval for delayed tracking tooltips
        clearInterval( this.delayedShow );

        // only set title if we had one before (see comment in _open())
        // If the title attribute has changed since open(), don't restore
        if ( target.data( "ui-tooltip-title" ) && !target.attr( "title" ) ) {
            target.attr( "title", target.data( "ui-tooltip-title" ) );
        }

        this._removeDescribedBy( target );

        tooltipData.hiding = true;
        tooltip.stop( true );
        this._hide( tooltip, this.options.hide, function() {
            that._removeTooltip( $( this ) );
        });

        target.removeData( "ui-tooltip-open" );
        this._off( target, "mouseleave focusout keyup" );

        // Remove 'remove' binding only on delegated targets
        if ( target[ 0 ] !== this.element[ 0 ] ) {
            this._off( target, "remove" );
        }
        this._off( this.document, "mousemove" );

        if ( event && event.type === "mouseleave" ) {
            $.each( this.parents, function( id, parent ) {
                $( parent.element ).attr( "title", parent.title );
                delete that.parents[ id ];
            });
        }

        tooltipData.closing = true;
        this._trigger( "close", event, { tooltip: tooltip } );
        if ( !tooltipData.hiding ) {
            tooltipData.closing = false;
        }
    },

    _tooltip: function( element ) {
        var tooltip = $( "<div>" )
                .attr( "role", "tooltip" )
                .addClass( "ui-tooltip ui-widget ui-corner-all ui-widget-content " +
                    ( this.options.tooltipClass || "" ) ),
            id = tooltip.uniqueId().attr( "id" );

        $( "<div>" )
            .addClass( "ui-tooltip-content" )
            .appendTo( tooltip );

        tooltip.appendTo( this.document[0].body );

        return this.tooltips[ id ] = {
            element: element,
            tooltip: tooltip
        };
    },

    _find: function( target ) {
        var id = target.data( "ui-tooltip-id" );
        return id ? this.tooltips[ id ] : null;
    },

    _removeTooltip: function( tooltip ) {
        tooltip.remove();
        delete this.tooltips[ tooltip.attr( "id" ) ];
    },

    _destroy: function() {
        var that = this;

        // close open tooltips
        $.each( this.tooltips, function( id, tooltipData ) {
            // Delegate to close method to handle common cleanup
            var event = $.Event( "blur" ),
                element = tooltipData.element;
            event.target = event.currentTarget = element[ 0 ];
            that.close( event, true );

            // Remove immediately; destroying an open tooltip doesn't use the
            // hide animation
            $( "#" + id ).remove();

            // Restore the title
            if ( element.data( "ui-tooltip-title" ) ) {
                // If the title attribute has changed since open(), don't restore
                if ( !element.attr( "title" ) ) {
                    element.attr( "title", element.data( "ui-tooltip-title" ) );
                }
                element.removeData( "ui-tooltip-title" );
            }
        });
        this.liveRegion.remove();
    }
});



}));

/*!
 * jQuery UI Touch Punch 0.2.3
 *
 * Copyright 2011–2014, Dave Furfero
 * Dual licensed under the MIT or GPL Version 2 licenses.
 *
 * Depends:
 *  jquery.ui.widget.js
 *  jquery.ui.mouse.js
 */
(function ($) {

  // Detect touch support
  $.support.touch = 'ontouchend' in document;

  // Ignore browsers without touch support
  if (!$.support.touch) {
    return;
  }

  var mouseProto = $.ui.mouse.prototype,
      _mouseInit = mouseProto._mouseInit,
      _mouseDestroy = mouseProto._mouseDestroy,
      touchHandled;

  /**
   * Simulate a mouse event based on a corresponding touch event
   * @param {Object} event A touch event
   * @param {String} simulatedType The corresponding mouse event
   */
  function simulateMouseEvent (event, simulatedType) {

    // Ignore multi-touch events
    if (event.originalEvent.touches.length > 1) {
      return;
    }

    event.preventDefault();

    var touch = event.originalEvent.changedTouches[0],
        simulatedEvent = document.createEvent('MouseEvents');
    
    // Initialize the simulated mouse event using the touch event's coordinates
    simulatedEvent.initMouseEvent(
      simulatedType,    // type
      true,             // bubbles                    
      true,             // cancelable                 
      window,           // view                       
      1,                // detail                     
      touch.screenX,    // screenX                    
      touch.screenY,    // screenY                    
      touch.clientX,    // clientX                    
      touch.clientY,    // clientY                    
      false,            // ctrlKey                    
      false,            // altKey                     
      false,            // shiftKey                   
      false,            // metaKey                    
      0,                // button                     
      null              // relatedTarget              
    );

    // Dispatch the simulated event to the target element
    event.target.dispatchEvent(simulatedEvent);
  }

  /**
   * Handle the jQuery UI widget's touchstart events
   * @param {Object} event The widget element's touchstart event
   */
  mouseProto._touchStart = function (event) {

    var self = this;

    // Ignore the event if another widget is already being handled
    if (touchHandled || !self._mouseCapture(event.originalEvent.changedTouches[0])) {
      return;
    }

    // Set the flag to prevent other widgets from inheriting the touch event
    touchHandled = true;

    // Track movement to determine if interaction was a click
    self._touchMoved = false;

    // Simulate the mouseover event
    simulateMouseEvent(event, 'mouseover');

    // Simulate the mousemove event
    simulateMouseEvent(event, 'mousemove');

    // Simulate the mousedown event
    simulateMouseEvent(event, 'mousedown');
  };

  /**
   * Handle the jQuery UI widget's touchmove events
   * @param {Object} event The document's touchmove event
   */
  mouseProto._touchMove = function (event) {

    // Ignore event if not handled
    if (!touchHandled) {
      return;
    }

    // Interaction was not a click
    this._touchMoved = true;

    // Simulate the mousemove event
    simulateMouseEvent(event, 'mousemove');
  };

  /**
   * Handle the jQuery UI widget's touchend events
   * @param {Object} event The document's touchend event
   */
  mouseProto._touchEnd = function (event) {

    // Ignore event if not handled
    if (!touchHandled) {
      return;
    }

    // Simulate the mouseup event
    simulateMouseEvent(event, 'mouseup');

    // Simulate the mouseout event
    simulateMouseEvent(event, 'mouseout');

    // If the touch interaction did not move, it should trigger a click
    if (!this._touchMoved) {

      // Simulate the click event
      simulateMouseEvent(event, 'click');
    }

    // Unset the flag to allow other widgets to inherit the touch event
    touchHandled = false;
  };

  /**
   * A duck punch of the $.ui.mouse _mouseInit method to support touch events.
   * This method extends the widget with bound touch event handlers that
   * translate touch events to mouse events and pass them to the widget's
   * original mouse event handling methods.
   */
  mouseProto._mouseInit = function () {
    
    var self = this;

    // Delegate the touch handlers to the widget's element
    self.element.bind({
      touchstart: $.proxy(self, '_touchStart'),
      touchmove: $.proxy(self, '_touchMove'),
      touchend: $.proxy(self, '_touchEnd')
    });

    // Call the original $.ui.mouse init method
    _mouseInit.call(self);
  };

  /**
   * Remove the touch event handlers
   */
  mouseProto._mouseDestroy = function () {
    
    var self = this;

    // Delegate the touch handlers to the widget's element
    self.element.unbind({
      touchstart: $.proxy(self, '_touchStart'),
      touchmove: $.proxy(self, '_touchMove'),
      touchend: $.proxy(self, '_touchEnd')
    });

    // Call the original $.ui.mouse destroy method
    _mouseDestroy.call(self);
  };

})(jQuery);

/*
* jQuery UI Tag-it!
*
* @version v2.0 (06/2011)
*
* Copyright 2011, Levy Carneiro Jr.
* Released under the MIT license.
* http://aehlke.github.com/tag-it/LICENSE
*
* Homepage:
*   http://aehlke.github.com/tag-it/
*
* Authors:
*   Levy Carneiro Jr.
*   Martin Rehfeld
*   Tobias Schmidt
*   Skylar Challand
*   Alex Ehlke
*
* Maintainer:
*   Alex Ehlke - Twitter: @aehlke
*
* Dependencies:
*   jQuery v1.4+
*   jQuery UI v1.8+
*/
(function($) {

    $.widget('ui.tagit', {
        options: {
            allowDuplicates   : false,
            caseSensitive     : true,
            fieldName         : 'tags',
            placeholderText   : null,   // Sets `placeholder` attr on input field.
            readOnly          : false,  // Disables editing.
            removeConfirmation: false,  // Require confirmation to remove tags.
            tagLimit          : null,   // Max number of tags allowed (null for unlimited).

            // Used for autocomplete, unless you override `autocomplete.source`.
            availableTags     : [],

            // Use to override or add any options to the autocomplete widget.
            //
            // By default, autocomplete.source will map to availableTags,
            // unless overridden.
            autocomplete: {},

            // Shows autocomplete before the user even types anything.
            showAutocompleteOnFocus: false,

            // When enabled, quotes are unneccesary for inputting multi-word tags.
            allowSpaces: false,

            // The below options are for using a single field instead of several
            // for our form values.
            //
            // When enabled, will use a single hidden field for the form,
            // rather than one per tag. It will delimit tags in the field
            // with singleFieldDelimiter.
            //
            // The easiest way to use singleField is to just instantiate tag-it
            // on an INPUT element, in which case singleField is automatically
            // set to true, and singleFieldNode is set to that element. This
            // way, you don't need to fiddle with these options.
            singleField: false,

            // This is just used when preloading data from the field, and for
            // populating the field with delimited tags as the user adds them.
            singleFieldDelimiter: ',',

            // Set this to an input DOM node to use an existing form field.
            // Any text in it will be erased on init. But it will be
            // populated with the text of tags as they are created,
            // delimited by singleFieldDelimiter.
            //
            // If this is not set, we create an input node for it,
            // with the name given in settings.fieldName.
            singleFieldNode: null,

            // Whether to animate tag removals or not.
            animate: true,

            // Optionally set a tabindex attribute on the input that gets
            // created for tag-it.
            tabIndex: null,

            // Event callbacks.
            beforeTagAdded      : null,
            afterTagAdded       : null,

            beforeTagRemoved    : null,
            afterTagRemoved     : null,

            onTagClicked        : null,
            onTagLimitExceeded  : null,


            // DEPRECATED:
            //
            // /!\ These event callbacks are deprecated and WILL BE REMOVED at some
            // point in the future. They're here for backwards-compatibility.
            // Use the above before/after event callbacks instead.
            onTagAdded  : null,
            onTagRemoved: null,
            // `autocomplete.source` is the replacement for tagSource.
            tagSource: null
            // Do not use the above deprecated options.
        },

        _create: function() {
            // for handling static scoping inside callbacks
            var that = this;

            // There are 2 kinds of DOM nodes this widget can be instantiated on:
            //     1. UL, OL, or some element containing either of these.
            //     2. INPUT, in which case 'singleField' is overridden to true,
            //        a UL is created and the INPUT is hidden.
            if (this.element.is('input')) {
                this.tagList = $('<ul></ul>').insertAfter(this.element);
                this.options.singleField = true;
                this.options.singleFieldNode = this.element;
                this.element.addClass('tagit-hidden-field');
            } else {
                this.tagList = this.element.find('ul, ol').andSelf().last();
            }

            this.tagInput = $('<input type="text" />').addClass('ui-widget-content');

            if (this.options.readOnly) this.tagInput.attr('disabled', 'disabled');

            if (this.options.tabIndex) {
                this.tagInput.attr('tabindex', this.options.tabIndex);
            }

            if (this.options.placeholderText) {
                this.tagInput.attr('placeholder', this.options.placeholderText);
            }

            if (!this.options.autocomplete.source) {
                this.options.autocomplete.source = function(search, showChoices) {
                    var filter = search.term.toLowerCase();
                    var choices = $.grep(this.options.availableTags, function(element) {
                        // Only match autocomplete options that begin with the search term.
                        // (Case insensitive.)
                        return (element.toLowerCase().indexOf(filter) === 0);
                    });
                    if (!this.options.allowDuplicates) {
                        choices = this._subtractArray(choices, this.assignedTags());
                    }
                    showChoices(choices);
                };
            }

            if (this.options.showAutocompleteOnFocus) {
                this.tagInput.focus(function(event, ui) {
                    that._showAutocomplete();
                });

                if (typeof this.options.autocomplete.minLength === 'undefined') {
                    this.options.autocomplete.minLength = 0;
                }
            }

            // Bind autocomplete.source callback functions to this context.
            if ($.isFunction(this.options.autocomplete.source)) {
                this.options.autocomplete.source = $.proxy(this.options.autocomplete.source, this);
            }

            // DEPRECATED.
            if ($.isFunction(this.options.tagSource)) {
                this.options.tagSource = $.proxy(this.options.tagSource, this);
            }

            this.tagList
                .addClass('tagit')
                .addClass('ui-widget ui-widget-content ui-corner-all')
                // Create the input field.
                .append($('<li class="tagit-new"></li>').append(this.tagInput))
                .click(function(e) {
                    var target = $(e.target);
                    if (target.hasClass('tagit-label')) {
                        var tag = target.closest('.tagit-choice');
                        if (!tag.hasClass('removed')) {
                            that._trigger('onTagClicked', e, {tag: tag, tagLabel: that.tagLabel(tag)});
                        }
                    } else {
                        // Sets the focus() to the input field, if the user
                        // clicks anywhere inside the UL. This is needed
                        // because the input field needs to be of a small size.
                        that.tagInput.focus();
                    }
                });

            // Single field support.
            var addedExistingFromSingleFieldNode = false;
            if (this.options.singleField) {
                if (this.options.singleFieldNode) {
                    // Add existing tags from the input field.
                    var node = $(this.options.singleFieldNode);
                    var tags = node.val().split(this.options.singleFieldDelimiter);
                    node.val('');
                    $.each(tags, function(index, tag) {
                        that.createTag(tag, null, true);
                        addedExistingFromSingleFieldNode = true;
                    });
                } else {
                    // Create our single field input after our list.
                    this.options.singleFieldNode = $('<input type="hidden" style="display:none;" value="" name="' + this.options.fieldName + '" />');
                    this.tagList.after(this.options.singleFieldNode);
                }
            }

            // Add existing tags from the list, if any.
            if (!addedExistingFromSingleFieldNode) {
                this.tagList.children('li').each(function() {
                    if (!$(this).hasClass('tagit-new')) {
                        that.createTag($(this).text(), $(this).attr('class'), true);
                        $(this).remove();
                    }
                });
            }

            // Events.
            this.tagInput
                .keydown(function(event) {
                    // Backspace is not detected within a keypress, so it must use keydown.
                    if (event.which == $.ui.keyCode.BACKSPACE && that.tagInput.val() === '') {
                        var tag = that._lastTag();
                        if (!that.options.removeConfirmation || tag.hasClass('remove')) {
                            // When backspace is pressed, the last tag is deleted.
                            that.removeTag(tag);
                        } else if (that.options.removeConfirmation) {
                            tag.addClass('remove ui-state-highlight');
                        }
                    } else if (that.options.removeConfirmation) {
                        that._lastTag().removeClass('remove ui-state-highlight');
                    }

                    // Comma/Space/Enter are all valid delimiters for new tags,
                    // except when there is an open quote or if setting allowSpaces = true.
                    // Tab will also create a tag, unless the tag input is empty,
                    // in which case it isn't caught.
                    if (
                        (event.which === $.ui.keyCode.COMMA && event.shiftKey === false) ||
                        event.which === $.ui.keyCode.ENTER ||
                        (
                            event.which == $.ui.keyCode.TAB &&
                            that.tagInput.val() !== ''
                        ) ||
                        (
                            event.which == $.ui.keyCode.SPACE &&
                            that.options.allowSpaces !== true &&
                            (
                                $.trim(that.tagInput.val()).replace( /^s*/, '' ).charAt(0) != '"' ||
                                (
                                    $.trim(that.tagInput.val()).charAt(0) == '"' &&
                                    $.trim(that.tagInput.val()).charAt($.trim(that.tagInput.val()).length - 1) == '"' &&
                                    $.trim(that.tagInput.val()).length - 1 !== 0
                                )
                            )
                        )
                    ) {
                        // Enter submits the form if there's no text in the input.
                        if (!(event.which === $.ui.keyCode.ENTER && that.tagInput.val() === '')) {
                            event.preventDefault();
                        }

                        // Autocomplete will create its own tag from a selection and close automatically.
                        if (!(that.options.autocomplete.autoFocus && that.tagInput.data('autocomplete-open'))) {
                            that.tagInput.autocomplete('close');
                            that.createTag(that._cleanedInput());
                        }
                    }
                }).blur(function(e){
                    // Create a tag when the element loses focus.
                    // If autocomplete is enabled and suggestion was clicked, don't add it.
                    if (!that.tagInput.data('autocomplete-open')) {
                        that.createTag(that._cleanedInput());
                    }
                });

            // Autocomplete.
            if (this.options.availableTags || this.options.tagSource || this.options.autocomplete.source) {
                var autocompleteOptions = {
                    select: function(event, ui) {
                        that.createTag(ui.item.value);
                        // Preventing the tag input to be updated with the chosen value.
                        return false;
                    }
                };
                $.extend(autocompleteOptions, this.options.autocomplete);

                // tagSource is deprecated, but takes precedence here since autocomplete.source is set by default,
                // while tagSource is left null by default.
                autocompleteOptions.source = this.options.tagSource || autocompleteOptions.source;

                this.tagInput.autocomplete(autocompleteOptions).bind('autocompleteopen.tagit', function(event, ui) {
                    that.tagInput.data('autocomplete-open', true);
                }).bind('autocompleteclose.tagit', function(event, ui) {
                    that.tagInput.data('autocomplete-open', false);
                });

                this.tagInput.autocomplete('widget').addClass('tagit-autocomplete');
            }
        },

        destroy: function() {
            $.Widget.prototype.destroy.call(this);

            this.element.unbind('.tagit');
            this.tagList.unbind('.tagit');

            this.tagInput.removeData('autocomplete-open');

            this.tagList.removeClass([
                'tagit',
                'ui-widget',
                'ui-widget-content',
                'ui-corner-all',
                'tagit-hidden-field'
            ].join(' '));

            if (this.element.is('input')) {
                this.element.removeClass('tagit-hidden-field');
                this.tagList.remove();
            } else {
                this.element.children('li').each(function() {
                    if ($(this).hasClass('tagit-new')) {
                        $(this).remove();
                    } else {
                        $(this).removeClass([
                            'tagit-choice',
                            'ui-widget-content',
                            'ui-state-default',
                            'ui-state-highlight',
                            'ui-corner-all',
                            'remove',
                            'tagit-choice-editable',
                            'tagit-choice-read-only'
                        ].join(' '));

                        $(this).text($(this).children('.tagit-label').text());
                    }
                });

                if (this.singleFieldNode) {
                    this.singleFieldNode.remove();
                }
            }

            return this;
        },

        _cleanedInput: function() {
            // Returns the contents of the tag input, cleaned and ready to be passed to createTag
            return $.trim(this.tagInput.val().replace(/^"(.*)"$/, '$1'));
        },

        _lastTag: function() {
            return this.tagList.find('.tagit-choice:last:not(.removed)');
        },

        _tags: function() {
            return this.tagList.find('.tagit-choice:not(.removed)');
        },

        assignedTags: function() {
            // Returns an array of tag string values
            var that = this;
            var tags = [];
            if (this.options.singleField) {
                tags = $(this.options.singleFieldNode).val().split(this.options.singleFieldDelimiter);
                if (tags[0] === '') {
                    tags = [];
                }
            } else {
                this._tags().each(function() {
                    tags.push(that.tagLabel(this));
                });
            }
            return tags;
        },

        _updateSingleTagsField: function(tags) {
            // Takes a list of tag string values, updates this.options.singleFieldNode.val to the tags delimited by this.options.singleFieldDelimiter
            $(this.options.singleFieldNode).val(tags.join(this.options.singleFieldDelimiter)).trigger('change');
        },

        _subtractArray: function(a1, a2) {
            var result = [];
            for (var i = 0; i < a1.length; i++) {
                if ($.inArray(a1[i], a2) == -1) {
                    result.push(a1[i]);
                }
            }
            return result;
        },

        tagLabel: function(tag) {
            // Returns the tag's string label.
            if (this.options.singleField) {
                return $(tag).find('.tagit-label:first').text();
            } else {
                return $(tag).find('input:first').val();
            }
        },

        _showAutocomplete: function() {
            this.tagInput.autocomplete('search', '');
        },

        _findTagByLabel: function(name) {
            var that = this;
            var tag = null;
            this._tags().each(function(i) {
                if (that._formatStr(name) == that._formatStr(that.tagLabel(this))) {
                    tag = $(this);
                    return false;
                }
            });
            return tag;
        },

        _isNew: function(name) {
            return !this._findTagByLabel(name);
        },

        _formatStr: function(str) {
            if (this.options.caseSensitive) {
                return str;
            }
            return $.trim(str.toLowerCase());
        },

        _effectExists: function(name) {
            return Boolean($.effects && ($.effects[name] || ($.effects.effect && $.effects.effect[name])));
        },

        createTag: function(value, additionalClass, duringInitialization) {
            var that = this;

            value = $.trim(value);

            if(this.options.preprocessTag) {
                value = this.options.preprocessTag(value);
            }

            if (value === '') {
                return false;
            }

            if (!this.options.allowDuplicates && !this._isNew(value)) {
                var existingTag = this._findTagByLabel(value);
                if (this._trigger('onTagExists', null, {
                    existingTag: existingTag,
                    duringInitialization: duringInitialization
                }) !== false) {
                    if (this._effectExists('highlight')) {
                        existingTag.effect('highlight');
                    }
                }
                return false;
            }

            if (this.options.tagLimit && this._tags().length >= this.options.tagLimit) {
                this._trigger('onTagLimitExceeded', null, {duringInitialization: duringInitialization});
                return false;
            }

            var label = $(this.options.onTagClicked ? '<a class="tagit-label"></a>' : '<span class="tagit-label"></span>').text(value);

            // Create tag.
            var tag = $('<li></li>')
                .addClass('tagit-choice ui-widget-content ui-state-default ui-corner-all')
                .addClass(additionalClass)
                .append(label);

            if (this.options.readOnly){
                tag.addClass('tagit-choice-read-only');
            } else {
                tag.addClass('tagit-choice-editable');
                // Button for removing the tag.
                var removeTagIcon = $('<span></span>')
                    .addClass('ui-icon ui-icon-close');
                var removeTag = $('<a><span class="text-icon">\xd7</span></a>') // \xd7 is an X
                    .addClass('tagit-close')
                    .append(removeTagIcon)
                    .click(function(e) {
                        // Removes a tag when the little 'x' is clicked.
                        that.removeTag(tag);
                    });
                tag.append(removeTag);
            }

            // Unless options.singleField is set, each tag has a hidden input field inline.
            if (!this.options.singleField) {
                var escapedValue = label.html();
                tag.append('<input type="hidden" value="' + escapedValue + '" name="' + this.options.fieldName + '" class="tagit-hidden-field" />');
            }

            if (this._trigger('beforeTagAdded', null, {
                tag: tag,
                tagLabel: this.tagLabel(tag),
                duringInitialization: duringInitialization
            }) === false) {
                return;
            }

            if (this.options.singleField) {
                var tags = this.assignedTags();
                tags.push(value);
                this._updateSingleTagsField(tags);
            }

            // DEPRECATED.
            this._trigger('onTagAdded', null, tag);

            this.tagInput.val('');

            // Insert tag.
            this.tagInput.parent().before(tag);

            this._trigger('afterTagAdded', null, {
                tag: tag,
                tagLabel: this.tagLabel(tag),
                duringInitialization: duringInitialization
            });

            if (this.options.showAutocompleteOnFocus && !duringInitialization) {
                setTimeout(function () { that._showAutocomplete(); }, 0);
            }
        },

        removeTag: function(tag, animate) {
            animate = typeof animate === 'undefined' ? this.options.animate : animate;

            tag = $(tag);

            // DEPRECATED.
            this._trigger('onTagRemoved', null, tag);

            if (this._trigger('beforeTagRemoved', null, {tag: tag, tagLabel: this.tagLabel(tag)}) === false) {
                return;
            }

            if (this.options.singleField) {
                var tags = this.assignedTags();
                var removedTagLabel = this.tagLabel(tag);
                tags = $.grep(tags, function(el){
                    return el != removedTagLabel;
                });
                this._updateSingleTagsField(tags);
            }

            if (animate) {
                tag.addClass('removed'); // Excludes this tag from _tags.
                var hide_args = this._effectExists('blind') ? ['blind', {direction: 'horizontal'}, 'fast'] : ['fast'];

                var thisTag = this;
                hide_args.push(function() {
                    tag.remove();
                    thisTag._trigger('afterTagRemoved', null, {tag: tag, tagLabel: thisTag.tagLabel(tag)});
                });

                tag.fadeOut('fast').hide.apply(tag, hide_args).dequeue();
            } else {
                tag.remove();
                this._trigger('afterTagRemoved', null, {tag: tag, tagLabel: this.tagLabel(tag)});
            }

        },

        removeTagByLabel: function(tagLabel, animate) {
            var toRemove = this._findTagByLabel(tagLabel);
            if (!toRemove) {
                throw "No such tag exists with the name '" + tagLabel + "'";
            }
            this.removeTag(toRemove, animate);
        },

        removeAll: function() {
            // Removes all tags.
            var that = this;
            this._tags().each(function(index, tag) {
                that.removeTag(tag, false);
            });
        }

    });
})(jQuery);


/*!
 * jQuery Cookie Plugin v1.3.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as anonymous module.
        define(['jquery'], factory);
    } else {
        // Browser globals.
        factory(jQuery);
    }
}(function ($) {

    var pluses = /\+/g;

    function raw(s) {
        return s;
    }

    function decoded(s) {
        return decodeURIComponent(s.replace(pluses, ' '));
    }

    function converted(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }
        try {
            return config.json ? JSON.parse(s) : s;
        } catch(er) {}
    }

    var config = $.cookie = function (key, value, options) {

        // write
        if (value !== undefined) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setDate(t.getDate() + days);
            }

            value = config.json ? JSON.stringify(value) : String(value);

            return (document.cookie = [
                config.raw ? key : encodeURIComponent(key),
                '=',
                config.raw ? value : encodeURIComponent(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path    ? '; path=' + options.path : '',
                options.domain  ? '; domain=' + options.domain : '',
                options.secure  ? '; secure' : ''
            ].join(''));
        }

        // read
        var decode = config.raw ? raw : decoded;
        var cookies = document.cookie.split('; ');
        var result = key ? undefined : {};
        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split('=');
            var name = decode(parts.shift());
            var cookie = decode(parts.join('='));

            if (key && key === name) {
                result = converted(cookie);
                break;
            }

            if (!key) {
                result[name] = converted(cookie);
            }
        }

        return result;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        if ($.cookie(key) !== undefined) {
            // Must not alter options, thus extending a fresh object...
            $.cookie(key, '', $.extend({}, options, { expires: -1 }));
            return true;
        }
        return false;
    };

}));
/*! jquery.selectBoxIt - v3.8.1 - 2013-10-17
* http://www.selectboxit.com
* Copyright (c) 2013 Greg Franko; Licensed MIT*/

// Immediately-Invoked Function Expression (IIFE) [Ben Alman Blog Post](http://benalman.com/news/2010/11/immediately-invoked-function-expression/) that calls another IIFE that contains all of the plugin logic.  I used this pattern so that anyone viewing this code would not have to scroll to the bottom of the page to view the local parameters that were passed to the main IIFE.

;(function (selectBoxIt) {

    //ECMAScript 5 Strict Mode: [John Resig Blog Post](http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/)
    "use strict";

    // Calls the second IIFE and locally passes in the global jQuery, window, and document objects
    selectBoxIt(window.jQuery, window, document);

}

// Locally passes in `jQuery`, the `window` object, the `document` object, and an `undefined` variable.  The `jQuery`, `window` and `document` objects are passed in locally, to improve performance, since javascript first searches for a variable match within the local variables set before searching the global variables set.  All of the global variables are also passed in locally to be minifier friendly. `undefined` can be passed in locally, because it is not a reserved word in JavaScript.

(function ($, window, document, undefined) {

    // ECMAScript 5 Strict Mode: [John Resig Blog Post](http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/)
    "use strict";

    // Calling the jQueryUI Widget Factory Method
    $.widget("selectBox.selectBoxIt", {

        // Plugin version
        VERSION: "3.8.2",

        // These options will be used as defaults
        options: {

            // **showEffect**: Accepts String: "none", "fadeIn", "show", "slideDown", or any of the jQueryUI show effects (i.e. "bounce")
            "showEffect": "none",

            // **showEffectOptions**: Accepts an object literal.  All of the available properties are based on the jqueryUI effect options
            "showEffectOptions": {},

            // **showEffectSpeed**: Accepts Number (milliseconds) or String: "slow", "medium", or "fast"
            "showEffectSpeed": "medium",

            // **hideEffect**: Accepts String: "none", "fadeOut", "hide", "slideUp", or any of the jQueryUI hide effects (i.e. "explode")
            "hideEffect": "none",

            // **hideEffectOptions**: Accepts an object literal.  All of the available properties are based on the jqueryUI effect options
            "hideEffectOptions": {},

            // **hideEffectSpeed**: Accepts Number (milliseconds) or String: "slow", "medium", or "fast"
            "hideEffectSpeed": "medium",

            // **showFirstOption**: Shows the first dropdown list option within the dropdown list options list
            "showFirstOption": true,

            // **defaultText**: Overrides the text used by the dropdown list selected option to allow a user to specify custom text.  Accepts a String.
            "defaultText": "",

            // **defaultIcon**: Overrides the icon used by the dropdown list selected option to allow a user to specify a custom icon.  Accepts a String (CSS class name(s)).
            "defaultIcon": "",

            // **downArrowIcon**: Overrides the default down arrow used by the dropdown list to allow a user to specify a custom image.  Accepts a String (CSS class name(s)).
            "downArrowIcon": "",

            // **theme**: Provides theming support for Twitter Bootstrap and jQueryUI
            "theme": "default",

            // **keydownOpen**: Opens the dropdown if the up or down key is pressed when the dropdown is focused
            "keydownOpen": true,

            // **isMobile**: Function to determine if a user's browser is a mobile browser
            "isMobile": function() {

                // Adapted from http://www.detectmobilebrowsers.com
                var ua = navigator.userAgent || navigator.vendor || window.opera;

                // Checks for iOs, Android, Blackberry, Opera Mini, and Windows mobile devices
                return (/iPhone|iPod|iPad|Silk|Android|BlackBerry|Opera Mini|IEMobile/).test(ua);

            },

            // **native**: Triggers the native select box when a user interacts with the drop down
            "native": false,

            // **aggressiveChange**: Will select a drop down item (and trigger a change event) when a user navigates to the item via the keyboard (up and down arrow or search), before a user selects an option with a click or the enter key
            "aggressiveChange": false,

            // **selectWhenHidden: Will allow a user to select an option using the keyboard when the drop down list is hidden and focused
            "selectWhenHidden": true,

            // **viewport**: Allows for a custom domnode used for the viewport. Accepts a selector.  Default is $(window).
            "viewport": $(window),

            // **similarSearch**: Optimizes the search for lists with many similar values (i.e. State lists) by making it easier to navigate through
            "similarSearch": false,

            // **copyAttributes**: HTML attributes that will be copied over to the new drop down
            "copyAttributes": [

                "title",

                "rel"

            ],

            // **dontCopyAttributes: HTML attributes to explicitly blacklist from being copied to the new dropdown
            "dontCopyAttributes": [

                "data-reactid"

            ],

            // **copyClasses**: HTML classes that will be copied over to the new drop down.  The value indicates where the classes should be copied.  The default value is 'button', but you can also use 'container' (recommended) or 'none'.
            "copyClasses": "button",

            // **nativeMousedown**: Mimics native firefox drop down behavior by opening the drop down on mousedown and selecting the currently hovered drop down option on mouseup
            "nativeMousedown": false,

            // **customShowHideEvent**: Prevents the drop down from opening on click or mousedown, which allows a user to open/close the drop down with a custom event handler.
            "customShowHideEvent": false,

            // **autoWidth**: Makes sure the width of the drop down is wide enough to fit all of the drop down options
            "autoWidth": true,

            // **html**: Determines whether or not option text is rendered as html or as text
            "html": true,

            // **populate**: Convenience option that accepts JSON data, an array, a single object, or valid HTML string to add options to the drop down list
            "populate": "",

            // **dynamicPositioning**: Determines whether or not the drop down list should fit inside it's viewport
            "dynamicPositioning": true,

            // **hideCurrent**: Determines whether or not the currently selected drop down option is hidden in the list
            "hideCurrent": false,

            // **numSearchCharacters**: Option for how many characters a user must search to be treated as a full string search
            "numSearchCharacters": "auto"

        },

        // Get Themes
        // ----------
        //      Retrieves the active drop down theme and returns the theme object
        "getThemes": function() {

            var self = this,
                theme = $(self.element).attr("data-theme") || "c";

            return {

                // Twitter Bootstrap Theme
                "bootstrap": {

                    "focus": "active",

                    "hover": "",

                    "enabled": "enabled",

                    "disabled": "disabled",

                    "arrow": "caret",

                    "button": "btn",

                    "list": "dropdown-menu",

                    "container": "bootstrap",

                    "open": "open"

                },

                // jQueryUI Theme
                "jqueryui": {

                    "focus": "ui-state-focus",

                    "hover": "ui-state-hover",

                    "enabled": "ui-state-enabled",

                    "disabled": "ui-state-disabled",

                    "arrow": "ui-icon ui-icon-triangle-1-s",

                    "button": "ui-widget ui-state-default",

                    "list": "ui-widget ui-widget-content",

                    "container": "jqueryui",

                    "open": "selectboxit-open"

                },

                // jQuery Mobile Theme
                "jquerymobile": {

                    "focus": "ui-btn-down-" + theme,

                    "hover": "ui-btn-hover-" + theme,

                    "enabled": "ui-enabled",

                    "disabled": "ui-disabled",

                    "arrow": "ui-icon ui-icon-arrow-d ui-icon-shadow",

                    "button": "ui-btn ui-btn-icon-right ui-btn-corner-all ui-shadow ui-btn-up-" + theme,

                    "list": "ui-btn ui-btn-icon-right ui-btn-corner-all ui-shadow ui-btn-up-" + theme,

                    "container": "jquerymobile",

                    "open": "selectboxit-open"

                },

                "default": {

                    "focus": "selectboxit-focus",

                    "hover": "selectboxit-hover",

                    "enabled": "selectboxit-enabled",

                    "disabled": "selectboxit-disabled",

                    "arrow": "selectboxit-default-arrow",

                    "button": "selectboxit-btn",

                    "list": "selectboxit-list",

                    "container": "selectboxit-container",

                    "open": "selectboxit-open"

                }

            };

        },

        // isDeferred
        // ----------
        //      Checks if parameter is a defered object
        isDeferred: function(def) {
            return $.isPlainObject(def) && def.promise && def.done;
        },

        // _Create
        // -------
        //      Sets the Plugin Instance variables and
        //      constructs the plugin.  Only called once.
        _create: function(internal) {

            var self = this,
                populateOption = self.options["populate"],
                userTheme = self.options["theme"];

            // If the element calling SelectBoxIt is not a select box or is not visible
            if(!self.element.is("select")) {

                // Exits the plugin
                return;

            }

            // Stores a reference to the parent Widget class
            self.widgetProto = $.Widget.prototype;

            // The original select box DOM element
            self.originalElem = self.element[0];

            // The original select box DOM element wrapped in a jQuery object
            self.selectBox = self.element;

            if(self.options["populate"] && self.add && !internal) {

                self.add(populateOption);

            }

            // All of the original select box options
            self.selectItems = self.element.find("option");

            // The first option in the original select box
            self.firstSelectItem = self.selectItems.slice(0, 1);

            // The html document height
            self.documentHeight = $(document).height();

            self.theme = $.isPlainObject(userTheme) ? $.extend({}, self.getThemes()["default"], userTheme) : self.getThemes()[userTheme] ? self.getThemes()[userTheme] : self.getThemes()["default"];

            // The index of the currently selected dropdown list option
            self.currentFocus = 0;

            // Keeps track of which blur events will hide the dropdown list options
            self.blur = true;

             // Array holding all of the original select box options text
            self.textArray = [];

            // Maintains search order in the `search` method
            self.currentIndex = 0;

            // Maintains the current search text in the `search` method
            self.currentText = "";

            // Whether or not the dropdown list opens up or down (depending on how much room is on the page)
            self.flipped = false;

            // If the create method is not called internally by the plugin
            if(!internal) {

                // Saves the original select box `style` attribute within the `selectBoxStyles` plugin instance property
                self.selectBoxStyles = self.selectBox.attr("style");

            }

            // Creates the dropdown elements that will become the dropdown
            // Creates the ul element that will become the dropdown options list
            // Add's all attributes (excluding id, class names, and unselectable properties) to the drop down and drop down items list
            // Hides the original select box and adds the new plugin DOM elements to the page
            // Adds event handlers to the new dropdown list
            self._createDropdownButton()._createUnorderedList()._copyAttributes()._replaceSelectBox()._addClasses(self.theme)._eventHandlers();

            if(self.originalElem.disabled && self.disable) {

                // Disables the dropdown list if the original dropdown list had the `disabled` attribute
                self.disable();

            }

            // If the Aria Accessibility Module has been included
            if(self._ariaAccessibility) {

                // Adds ARIA accessibillity tags to the dropdown list
                self._ariaAccessibility();

            }

            self.isMobile = self.options["isMobile"]();

            if(self._mobile) {

                // Adds mobile support
                self._mobile();

            }

            // If the native option is set to true
            if(self.options["native"]) {

                // Triggers the native select box when a user is interacting with the drop down
                this._applyNativeSelect();

            }

            // Triggers a custom `create` event on the original dropdown list
            self.triggerEvent("create");

            // Maintains chainability
            return self;

        },

        // _Create dropdown button
        // -----------------------
        //      Creates new dropdown and dropdown elements to replace
        //      the original select box with a dropdown list
        _createDropdownButton: function() {

            var self = this,
                originalElemId = self.originalElemId = self.originalElem.id || "",
                originalElemValue = self.originalElemValue = self.originalElem.value || "",
                originalElemName = self.originalElemName = self.originalElem.name || "",
                copyClasses = self.options["copyClasses"],
                selectboxClasses = self.selectBox.attr("class") || "";

            // Creates a dropdown element that contains the dropdown list text value
            self.dropdownText = $("<span/>", {

                // Dynamically sets the dropdown `id` attribute
                "id": originalElemId && originalElemId + "SelectBoxItText",

                "class": "selectboxit-text",

                // IE specific attribute to not allow the element to be selected
                "unselectable": "on",

                // Sets the dropdown `text` to equal the original select box default value
                "text": self.firstSelectItem.text()

            }).

            // Sets the HTML5 data attribute on the dropdownText `dropdown` element
            attr("data-val", originalElemValue);

            self.dropdownImageContainer = $("<span/>", {

                "class": "selectboxit-option-icon-container"

            });

            // Creates a dropdown element that contains the dropdown list text value
            self.dropdownImage = $("<i/>", {

                // Dynamically sets the dropdown `id` attribute
                "id": originalElemId && originalElemId + "SelectBoxItDefaultIcon",

                "class": "selectboxit-default-icon",

                // IE specific attribute to not allow the element to be selected
                "unselectable": "on"

            });

            // Creates a dropdown to act as the new dropdown list
            self.dropdown = $("<span/>", {

                // Dynamically sets the dropdown `id` attribute
                "id": originalElemId && originalElemId + "SelectBoxIt",

                "class": "selectboxit " + (copyClasses === "button" ? selectboxClasses: "") + " " + (self.selectBox.prop("disabled") ? self.theme["disabled"]: self.theme["enabled"]),

                // Sets the dropdown `name` attribute to be the same name as the original select box
                "name": originalElemName,

                // Sets the dropdown `tabindex` attribute to 0 to allow the dropdown to be focusable
                "tabindex": self.selectBox.attr("tabindex") || "0",

                // IE specific attribute to not allow the element to be selected
                "unselectable": "on"

            }).

            // Appends the default text to the inner dropdown list dropdown element
            append(self.dropdownImageContainer.append(self.dropdownImage)).append(self.dropdownText);

            // Create the dropdown container that will hold all of the dropdown list dom elements
            self.dropdownContainer = $("<span/>", {

                "id": originalElemId && originalElemId + "SelectBoxItContainer",

                "class": 'selectboxit-container ' + self.theme.container + ' ' + (copyClasses === "container" ? selectboxClasses: "")

            }).

            // Appends the inner dropdown list dropdown element to the dropdown list container dropdown element
            append(self.dropdown);

            // Maintains chainability
            return self;

        },

        // _Create Unordered List
        // ----------------------
        //      Creates an unordered list element to hold the
        //        new dropdown list options that directly match
        //        the values of the original select box options
        _createUnorderedList: function() {

            // Storing the context of the widget
            var self = this,

                dataDisabled,

                optgroupClass,

                optgroupElement,

                iconClass,

                iconUrl,

                iconUrlClass,

                iconUrlStyle,

                // Declaring the variable that will hold all of the dropdown list option elements
                currentItem = "",

                originalElemId = self.originalElemId || "",

                // Creates an unordered list element
                createdList = $("<ul/>", {

                    // Sets the unordered list `id` attribute
                    "id": originalElemId && originalElemId + "SelectBoxItOptions",

                    "class": "selectboxit-options",

                    //Sets the unordered list `tabindex` attribute to -1 to prevent the unordered list from being focusable
                    "tabindex": -1

                }),

                currentDataSelectedText,

                currentDataText,

                currentDataSearch,

                currentText,

                currentOption,

                parent;

            // Checks the `showFirstOption` plugin option to determine if the first dropdown list option should be shown in the options list.
            if (!self.options["showFirstOption"]) {

                // Disables the first select box option
                self.selectItems.first().attr("disabled", "disabled");

                // Excludes the first dropdown list option from the options list
                self.selectItems = self.selectBox.find("option").slice(1);

            }

            // Loops through the original select box options list and copies the text of each
            // into new list item elements of the new dropdown list
            self.selectItems.each(function(index) {

                currentOption = $(this);

                optgroupClass = "";

                optgroupElement = "";

                dataDisabled = currentOption.prop("disabled");

                iconClass = currentOption.attr("data-icon") || "";

                iconUrl = currentOption.attr("data-iconurl") || "";

                iconUrlClass = iconUrl ? "selectboxit-option-icon-url": "";

                iconUrlStyle = iconUrl ? 'style="background-image:url(\'' + iconUrl + '\');"': "";

                currentDataSelectedText = currentOption.attr("data-selectedtext");

                currentDataText = currentOption.attr("data-text");

                currentText = currentDataText ? currentDataText: currentOption.text();

                parent = currentOption.parent();

                // If the current option being traversed is within an optgroup

                if(parent.is("optgroup")) {

                    optgroupClass = "selectboxit-optgroup-option";

                    if(currentOption.index() === 0) {

                         optgroupElement = '<span class="selectboxit-optgroup-header ' + parent.first().attr("class") + '"data-disabled="true">' + parent.first().attr("label") + '</span>';

                    }

                }

                currentOption.attr("value", this.value);

                // Uses string concatenation for speed (applies HTML attribute encoding)
                currentItem += optgroupElement + '<li data-id="' + index + '" data-val="' + self.htmlEscape(this.value) + '" data-disabled="' + dataDisabled + '" class="' + optgroupClass + " selectboxit-option " + ($(this).attr("class") || "") + '"><a class="selectboxit-option-anchor"><span class="selectboxit-option-icon-container"><i class="selectboxit-option-icon ' + iconClass + ' ' + (iconUrlClass || self.theme["container"]) + '"' + iconUrlStyle + '></i></span>' + (self.options["html"] ? currentText: self.htmlEscape(currentText)) + '</a></li>';

                currentDataSearch = currentOption.attr("data-search");

                // Stores all of the original select box options text inside of an array
                // (Used later in the `searchAlgorithm` method)
                self.textArray[index] = dataDisabled ? "": currentDataSearch ? currentDataSearch: currentText;

                // Checks the original select box option for the `selected` attribute
                if (this.selected) {

                    // Replaces the default text with the selected option text
                    self._setText(self.dropdownText, currentDataSelectedText || currentText);

                    //Set the currently selected option
                    self.currentFocus = index;

                }

            });

            // If the `defaultText` option is being used
            if ((self.options["defaultText"] || self.selectBox.attr("data-text"))) {

                var defaultedText = self.options["defaultText"] || self.selectBox.attr("data-text");

                // Overrides the current dropdown default text with the value the user specifies in the `defaultText` option
                self._setText(self.dropdownText, defaultedText);

                self.options["defaultText"] = defaultedText;

            }

            // Append the list item to the unordered list
            createdList.append(currentItem);

            // Stores the dropdown list options list inside of the `list` instance variable
            self.list = createdList;

            // Append the dropdown list options list to the dropdown container element
            self.dropdownContainer.append(self.list);

            // Stores the individual dropdown list options inside of the `listItems` instance variable
            self.listItems = self.list.children("li");

            self.listAnchors = self.list.find("a");

            // Sets the 'selectboxit-option-first' class name on the first drop down option
            self.listItems.first().addClass("selectboxit-option-first");

            // Sets the 'selectboxit-option-last' class name on the last drop down option
            self.listItems.last().addClass("selectboxit-option-last");

            // Set the disabled CSS class for select box options
            self.list.find("li[data-disabled='true']").not(".optgroupHeader").addClass(self.theme["disabled"]);

            self.dropdownImage.addClass(self.selectBox.attr("data-icon") || self.options["defaultIcon"] || self.listItems.eq(self.currentFocus).find("i").attr("class"));

            self.dropdownImage.attr("style", self.listItems.eq(self.currentFocus).find("i").attr("style"));

            //Maintains chainability
            return self;

        },

        // _Replace Select Box
        // -------------------
        //      Hides the original dropdown list and inserts
        //        the new DOM elements
        _replaceSelectBox: function() {

            var self = this,
                height,
                originalElemId = self.originalElem.id || "",
                size = self.selectBox.attr("data-size"),
                listSize = self.listSize = size === undefined ? "auto" : size === "0" || "size" === "auto" ? "auto" : +size,
                downArrowContainerWidth,
                dropdownImageWidth;

            // Hides the original select box
            self.selectBox.css("display", "none").

            // Adds the new dropdown list to the page directly after the hidden original select box element
            after(self.dropdownContainer);

            self.dropdownContainer.appendTo('body').

            addClass('selectboxit-rendering');

            // The height of the dropdown list
            height = self.dropdown.height();

            // The down arrow element of the dropdown list
            self.downArrow = $("<i/>", {

                // Dynamically sets the dropdown `id` attribute of the dropdown list down arrow
                "id": originalElemId && originalElemId + "SelectBoxItArrow",

                "class": "selectboxit-arrow",

                // IE specific attribute to not allow the dropdown list text to be selected
                "unselectable": "on"

            });

            // The down arrow container element of the dropdown list
            self.downArrowContainer = $("<span/>", {

                // Dynamically sets the dropdown `id` attribute for the down arrow container element
                "id": originalElemId && originalElemId + "SelectBoxItArrowContainer",

                "class": "selectboxit-arrow-container",

                // IE specific attribute to not allow the dropdown list text to be selected
                "unselectable": "on"

            }).

            // Inserts the down arrow element inside of the down arrow container element
            append(self.downArrow);

            // Appends the down arrow element to the dropdown list
            self.dropdown.append(self.downArrowContainer);

            // Adds the `selectboxit-selected` class name to the currently selected drop down option
            self.listItems.removeClass("selectboxit-selected").eq(self.currentFocus).addClass("selectboxit-selected");

            // The full outer width of the down arrow container
            downArrowContainerWidth = self.downArrowContainer.outerWidth(true);

            // The full outer width of the dropdown image
            dropdownImageWidth = self.dropdownImage.outerWidth(true);

            // If the `autoWidth` option is true
            if(self.options["autoWidth"]) {

                // Sets the auto width of the drop down
                self.dropdown.css({ "width": "auto" }).css({

                    "width": self.list.outerWidth(true) + downArrowContainerWidth + dropdownImageWidth

                });

                self.list.css({

                    "min-width": self.dropdown.width()

                });

            }

            // Adds the new dropdown list to the page directly after the hidden original select box element
            self.selectBox.after(self.dropdownContainer);

            self.dropdownContainer.removeClass('selectboxit-rendering');

            // Fixes #255
			// Dynamically adds the `max-width` and `line-height` CSS styles of the dropdown list text element
            self.dropdownText.css({

                "max-width": self.dropdownContainer.outerWidth(true) - (downArrowContainerWidth + dropdownImageWidth)

            });

            if($.type(listSize) === "number") {

                // Stores the new `max-height` for later
                self.maxHeight = self.listAnchors.outerHeight(true) * listSize;

            }

            // Maintains chainability
            return self;

        },

        // _Scroll-To-View
        // ---------------
        //      Updates the dropdown list scrollTop value
        _scrollToView: function(type) {

            var self = this,

                currentOption = self.listItems.eq(self.currentFocus),

                // The current scroll positioning of the dropdown list options list
                listScrollTop = self.list.scrollTop(),

                // The height of the currently selected dropdown list option
                currentItemHeight = currentOption.height(),

                // The relative distance from the currently selected dropdown list option to the the top of the dropdown list options list
                currentTopPosition = currentOption.position().top,

                absCurrentTopPosition = Math.abs(currentTopPosition),

                // The height of the dropdown list option list
                listHeight = self.list.height(),

                currentText;

            // Scrolling logic for a text search
            if (type === "search") {

                // Increases the dropdown list options `scrollTop` if a user is searching for an option
                // below the currently selected option that is not visible
                if (listHeight - currentTopPosition < currentItemHeight) {

                    // The selected option will be shown at the very bottom of the visible options list
                    self.list.scrollTop(listScrollTop + (currentTopPosition - (listHeight - currentItemHeight)));

                }

                // Decreases the dropdown list options `scrollTop` if a user is searching for an option above the currently selected option that is not visible
                else if (currentTopPosition < -1) {

                    self.list.scrollTop(currentTopPosition - currentItemHeight);

                }
            }

            // Scrolling logic for the `up` keyboard navigation
            else if (type === "up") {

                // Decreases the dropdown list option list `scrollTop` if a user is navigating to an element that is not visible
                if (currentTopPosition < -1) {

                    self.list.scrollTop(listScrollTop - absCurrentTopPosition);

                }
            }

            // Scrolling logic for the `down` keyboard navigation
            else if (type === "down") {

                // Increases the dropdown list options `scrollTop` if a user is navigating to an element that is not fully visible
                if (listHeight - currentTopPosition < currentItemHeight) {

                    // Increases the dropdown list options `scrollTop` by the height of the current option item.
                    self.list.scrollTop((listScrollTop + (absCurrentTopPosition - listHeight + currentItemHeight)));

                }
            }

            // Maintains chainability
            return self;

        },

        // _Callback
        // ---------
        //      Call the function passed into the method
        _callbackSupport: function(callback) {

            var self = this;

            // Checks to make sure the parameter passed in is a function
            if ($.isFunction(callback)) {

                // Calls the method passed in as a parameter and sets the current `SelectBoxIt` object that is stored in the jQuery data method as the context(allows for `this` to reference the SelectBoxIt API Methods in the callback function. The `dropdown` DOM element that acts as the new dropdown list is also passed as the only parameter to the callback
                callback.call(self, self.dropdown);

            }

            // Maintains chainability
            return self;

        },

        // _setText
        // --------
        //      Set's the text or html for the drop down
        _setText: function(elem, currentText) {

            var self = this;

            if(self.options["html"]) {

                elem.html(currentText);

            }

            else {

                elem.text(currentText);

            }

            return self;

        },

        // Open
        // ----
        //      Opens the dropdown list options list
        open: function(callback) {

            var self = this,
                showEffect = self.options["showEffect"],
                showEffectSpeed = self.options["showEffectSpeed"],
                showEffectOptions = self.options["showEffectOptions"],
                isNative = self.options["native"],
                isMobile = self.isMobile;

            // If there are no select box options, do not try to open the select box
            if(!self.listItems.length || self.dropdown.hasClass(self.theme["disabled"])) {

                return self;

            }

            // If the new drop down is being used and is not visible
            if((!isNative && !isMobile) && !this.list.is(":visible")) {

                // Triggers a custom "open" event on the original select box
                self.triggerEvent("open");

                if (self._dynamicPositioning && self.options["dynamicPositioning"]) {

                    // Dynamically positions the dropdown list options list
                    self._dynamicPositioning();

                }

                // Uses `no effect`
                if(showEffect === "none") {

                    // Does not require a callback function because this animation will complete before the call to `scrollToView`
                    self.list.show();

                }

                // Uses the jQuery `show` special effect
                else if(showEffect === "show" || showEffect === "slideDown" || showEffect === "fadeIn") {

                    // Requires a callback function to determine when the `show` animation is complete
                    self.list[showEffect](showEffectSpeed);

                }

                // If none of the above options were passed, then a `jqueryUI show effect` is expected
                else {

                    // Allows for custom show effects via the [jQueryUI core effects](http://http://jqueryui.com/demos/show/)
                    self.list.show(showEffect, showEffectOptions, showEffectSpeed);

                }

                self.list.promise().done(function() {

                    // Updates the list `scrollTop` attribute
                    self._scrollToView("search");

                    // Triggers a custom "opened" event when the drop down list is done animating
                    self.triggerEvent("opened");

                });

            }

            // Provide callback function support
            self._callbackSupport(callback);

            // Maintains chainability
            return self;

        },

        // Close
        // -----
        //      Closes the dropdown list options list
        close: function(callback) {

            var self = this,
                hideEffect = self.options["hideEffect"],
                hideEffectSpeed = self.options["hideEffectSpeed"],
                hideEffectOptions = self.options["hideEffectOptions"],
                isNative = self.options["native"],
                isMobile = self.isMobile;

            // If the drop down is being used and is visible
            if((!isNative && !isMobile) && self.list.is(":visible")) {

                // Triggers a custom "close" event on the original select box
                self.triggerEvent("close");

                // Uses `no effect`
                if(hideEffect === "none") {

                    // Does not require a callback function because this animation will complete before the call to `scrollToView`
                    self.list.hide();

                }

                // Uses the jQuery `hide` special effect
                else if(hideEffect === "hide" || hideEffect === "slideUp" || hideEffect === "fadeOut") {

                    self.list[hideEffect](hideEffectSpeed);

                }

                // If none of the above options were passed, then a `jqueryUI hide effect` is expected
                else {

                    // Allows for custom hide effects via the [jQueryUI core effects](http://http://jqueryui.com/demos/hide/)
                    self.list.hide(hideEffect, hideEffectOptions, hideEffectSpeed);

                }

                // After the drop down list is done animating
                self.list.promise().done(function() {

                    // Triggers a custom "closed" event when the drop down list is done animating
                    self.triggerEvent("closed");

                });

            }

            // Provide callback function support
            self._callbackSupport(callback);

            // Maintains chainability
            return self;

        },

        toggle: function() {

            var self = this,
                listIsVisible = self.list.is(":visible");

            if(listIsVisible) {

                self.close();

            }

            else if(!listIsVisible) {

                self.open();

            }

        },

        // _Key Mappings
        // -------------
        //      Object literal holding the string representation of each key code
        _keyMappings: {

            "38": "up",

            "40": "down",

            "13": "enter",

            "8": "backspace",

            "9": "tab",

            "32": "space",

            "27": "esc"

        },

        // _Key Down Methods
        // -----------------
        //      Methods to use when the keydown event is triggered
        _keydownMethods: function() {

            var self = this,
                moveToOption = self.list.is(":visible") || !self.options["keydownOpen"];

            return {

                "down": function() {

                    // If the plugin options allow keyboard navigation
                    if (self.moveDown && moveToOption) {

                        self.moveDown();

                    }

                },

                "up": function() {

                     // If the plugin options allow keyboard navigation
                    if (self.moveUp && moveToOption) {

                        self.moveUp();

                    }

                },

                "enter": function() {

                    var activeElem = self.listItems.eq(self.currentFocus);

                    // Updates the dropdown list value
                    self._update(activeElem);

                    if (activeElem.attr("data-preventclose") !== "true") {

                        // Closes the drop down list options list
                        self.close();

                    }

                    // Triggers the `enter` events on the original select box
                    self.triggerEvent("enter");

                },

                "tab": function() {

                    // Triggers the custom `tab-blur` event on the original select box
                    self.triggerEvent("tab-blur");

                    // Closes the drop down list
                    self.close();

                },

                "backspace": function() {

                    // Triggers the custom `backspace` event on the original select box
                    self.triggerEvent("backspace");

                },

                "esc": function() {

                    // Closes the dropdown options list
                    self.close();

                }

            };

        },


        // _Event Handlers
        // ---------------
        //      Adds event handlers to the new dropdown and the original select box
        _eventHandlers: function() {

            // LOCAL VARIABLES
            var self = this,
                nativeMousedown = self.options["nativeMousedown"],
                customShowHideEvent = self.options["customShowHideEvent"],
                currentDataText,
                currentText,
                focusClass = self.focusClass,
                hoverClass = self.hoverClass,
                openClass = self.openClass;

            // Select Box events
            this.dropdown.on({

                // `click` event with the `selectBoxIt` namespace
                "click.selectBoxIt": function() {

                    // Used to make sure the dropdown becomes focused (fixes IE issue)
                    self.dropdown.trigger("focus", true);

                    // The `click` handler logic will only be applied if the dropdown list is enabled
                    if (!self.originalElem.disabled) {

                        // Triggers the `click` event on the original select box
                        self.triggerEvent("click");

                        if(!nativeMousedown && !customShowHideEvent) {

                            self.toggle();

                        }

                    }

                },

                // `mousedown` event with the `selectBoxIt` namespace
                "mousedown.selectBoxIt": function() {

                    // Stores data in the jQuery `data` method to help determine if the dropdown list gains focus from a click or tabstop.  The mousedown event fires before the focus event.
                    $(this).data("mdown", true);

                    self.triggerEvent("mousedown");

                    if(nativeMousedown && !customShowHideEvent) {

                        self.toggle();

                    }

                },

                // `mouseup` event with the `selectBoxIt` namespace
                "mouseup.selectBoxIt": function() {

                    self.triggerEvent("mouseup");

                },

                // `blur` event with the `selectBoxIt` namespace.  Uses special blur logic to make sure the dropdown list closes correctly
                "blur.selectBoxIt": function() {

                    // If `self.blur` property is true
                    if (self.blur) {

                        // Triggers both the `blur` and `focusout` events on the original select box.
                        // The `focusout` event is also triggered because the event bubbles
                        // This event has to be used when using event delegation (such as the jQuery `delegate` or `on` methods)
                        // Popular open source projects such as Backbone.js utilize event delegation to bind events, so if you are using Backbone.js, use the `focusout` event instead of the `blur` event
                        self.triggerEvent("blur");

                        // Closes the dropdown list options list
                        self.close();

                        $(this).removeClass(focusClass);

                    }

                },

                "focus.selectBoxIt": function(event, internal) {

                    // Stores the data associated with the mousedown event inside of a local variable
                    var mdown = $(this).data("mdown");

                    // Removes the jQuery data associated with the mousedown event
                    $(this).removeData("mdown");

                    // If a mousedown event did not occur and no data was passed to the focus event (this correctly triggers the focus event), then the dropdown list gained focus from a tabstop
                    if (!mdown && !internal) {

                        setTimeout(function() {

                            // Triggers the `tabFocus` custom event on the original select box
                            self.triggerEvent("tab-focus");

                        }, 0);

                    }

                    // Only trigger the `focus` event on the original select box if the dropdown list is hidden (this verifies that only the correct `focus` events are used to trigger the event on the original select box
                    if(!internal) {

                        if(!$(this).hasClass(self.theme["disabled"])) {

                            $(this).addClass(focusClass);

                        }

                        //Triggers the `focus` default event on the original select box
                        self.triggerEvent("focus");

                    }

                },

                // `keydown` event with the `selectBoxIt` namespace.  Catches all user keyboard navigations
                "keydown.selectBoxIt": function(e) {

                    // Stores the `keycode` value in a local variable
                    var currentKey = self._keyMappings[e.keyCode],

                        keydownMethod = self._keydownMethods()[currentKey];

                    if(keydownMethod) {

                        keydownMethod();

                        if(self.options["keydownOpen"] && (currentKey === "up" || currentKey === "down")) {

                            self.open();

                        }

                    }

                    if(keydownMethod && currentKey !== "tab") {

                        e.preventDefault();

                    }

                },

                // `keypress` event with the `selectBoxIt` namespace.  Catches all user keyboard text searches since you can only reliably get character codes using the `keypress` event
                "keypress.selectBoxIt": function(e) {

                    if (!self.originalElem.disabled) {
                        // Sets the current key to the `keyCode` value if `charCode` does not exist.  Used for cross
                        // browser support since IE uses `keyCode` instead of `charCode`.
                        var currentKey = e.charCode || e.keyCode,

                            key = self._keyMappings[e.charCode || e.keyCode],

                            // Converts unicode values to characters
                            alphaNumericKey = String.fromCharCode(currentKey);

                        // If the plugin options allow text searches
                        if (self.search && (!key || (key && key === "space"))) {

                            // Calls `search` and passes the character value of the user's text search
                            self.search(alphaNumericKey, true, true);

                        }

                        if(key === "space") {

                            e.preventDefault();

                        }
                    }
                },

                // `mousenter` event with the `selectBoxIt` namespace .The mouseenter JavaScript event is proprietary to Internet Explorer. Because of the event's general utility, jQuery simulates this event so that it can be used regardless of browser.
                "mouseenter.selectBoxIt": function() {

                    // Trigger the `mouseenter` event on the original select box
                    self.triggerEvent("mouseenter");

                },

                // `mouseleave` event with the `selectBoxIt` namespace. The mouseleave JavaScript event is proprietary to Internet Explorer. Because of the event's general utility, jQuery simulates this event so that it can be used regardless of browser.
                "mouseleave.selectBoxIt": function() {

                    // Trigger the `mouseleave` event on the original select box
                    self.triggerEvent("mouseleave");

                }

            });

            // Select box options events that set the dropdown list blur logic (decides when the dropdown list gets
            // closed)
            self.list.on({

                // `mouseover` event with the `selectBoxIt` namespace
                "mouseover.selectBoxIt": function() {

                    // Prevents the dropdown list options list from closing
                    self.blur = false;

                },

                // `mouseout` event with the `selectBoxIt` namespace
                "mouseout.selectBoxIt": function() {

                    // Allows the dropdown list options list to close
                    self.blur = true;

                },

                // `focusin` event with the `selectBoxIt` namespace
                "focusin.selectBoxIt": function() {

                    // Prevents the default browser outline border to flicker, which results because of the `blur` event
                    self.dropdown.trigger("focus", true);

                }

            });

            // Select box individual options events bound with the jQuery `delegate` method.  `Delegate` was used because binding indropdownidual events to each list item (since we don't know how many there will be) would decrease performance.  Instead, we bind each event to the unordered list, provide the list item context, and allow the list item events to bubble up (`event bubbling`). This greatly increases page performance because we only have to bind an event to one element instead of x number of elements. Delegates the `click` event with the `selectBoxIt` namespace to the list items
            self.list.on({

                "mousedown.selectBoxIt": function() {

                    self._update($(this));

                    self.triggerEvent("option-click");

                    // If the current drop down option is not disabled
                    if ($(this).attr("data-disabled") === "false" && $(this).attr("data-preventclose") !== "true") {

                        // Closes the drop down list
                        self.close();

                    }

                    setTimeout(function() {

                        self.dropdown.trigger('focus', true);

                    }, 0);

                },

               // Delegates the `focusin` event with the `selectBoxIt` namespace to the list items
               "focusin.selectBoxIt": function() {

                    // Removes the hover class from the previous drop down option
                    self.listItems.not($(this)).removeAttr("data-active");

                    $(this).attr("data-active", "");

                    var listIsHidden = self.list.is(":hidden");

                    if((self.options["searchWhenHidden"] && listIsHidden) || self.options["aggressiveChange"] || (listIsHidden && self.options["selectWhenHidden"])) {

                        self._update($(this));

                    }

                    // Adds the focus CSS class to the currently focused dropdown list option
                   $(this).addClass(focusClass);

                },

                // Delegates the `focus` event with the `selectBoxIt` namespace to the list items
                "mouseup.selectBoxIt": function() {

                    if(nativeMousedown && !customShowHideEvent) {

                        self._update($(this));

                        self.triggerEvent("option-mouseup");

                        // If the current drop down option is not disabled
                        if ($(this).attr("data-disabled") === "false" && $(this).attr("data-preventclose") !== "true") {

                            // Closes the drop down list
                            self.close();

                        }

                    }

                },

                // Delegates the `mouseenter` event with the `selectBoxIt` namespace to the list items
                "mouseenter.selectBoxIt": function() {

                    // If the currently moused over drop down option is not disabled
                    if($(this).attr("data-disabled") === "false") {

                        self.listItems.removeAttr("data-active");

                        $(this).addClass(focusClass).attr("data-active", "");

                        // Sets the dropdown list indropdownidual options back to the default state and sets the focus CSS class on the currently hovered option
                        self.listItems.not($(this)).removeClass(focusClass);

                        $(this).addClass(focusClass);

                        self.currentFocus = +$(this).attr("data-id");

                    }

                },

                // Delegates the `mouseleave` event with the `selectBoxIt` namespace to the list items
                "mouseleave.selectBoxIt": function() {

                    // If the currently moused over drop down option is not disabled
                    if($(this).attr("data-disabled") === "false") {

                        // Removes the focus class from the previous drop down option
                        self.listItems.not($(this)).removeClass(focusClass).removeAttr("data-active");

                        $(this).addClass(focusClass);

                        self.currentFocus = +$(this).attr("data-id");

                    }

                },

                // Delegates the `blur` event with the `selectBoxIt` namespace to the list items
                "blur.selectBoxIt": function() {

                    // Removes the focus CSS class from the previously focused dropdown list option
                    $(this).removeClass(focusClass);

                }

            }, ".selectboxit-option");

            // Select box individual option anchor events bound with the jQuery `delegate` method.  `Delegate` was used because binding indropdownidual events to each list item (since we don't know how many there will be) would decrease performance.  Instead, we bind each event to the unordered list, provide the list item context, and allow the list item events to bubble up (`event bubbling`). This greatly increases page performance because we only have to bind an event to one element instead of x number of elements. Delegates the `click` event with the `selectBoxIt` namespace to the list items
            self.list.on({

                "click.selectBoxIt": function(ev) {

                    // Prevents the internal anchor tag from doing anything funny
                    ev.preventDefault();

                }

            }, "a");

            // Original dropdown list events
            self.selectBox.on({

                // `change` event handler with the `selectBoxIt` namespace
                "change.selectBoxIt, internal-change.selectBoxIt": function(event, internal) {

                    var currentOption,
                        currentDataSelectedText;

                    // If the user called the change method
                    if(!internal) {

                        currentOption = self.list.find('li[data-val="' + self.originalElem.value + '"]');

                        // If there is a dropdown option with the same value as the original select box element
                        if(currentOption.length) {

                            self.listItems.eq(self.currentFocus).removeClass(self.focusClass);

                            self.currentFocus = +currentOption.attr("data-id");

                        }

                    }

                    currentOption = self.listItems.eq(self.currentFocus);

                    currentDataSelectedText = currentOption.attr("data-selectedtext");

                    currentDataText = currentOption.attr("data-text");

                    currentText = currentDataText ?  currentDataText: currentOption.find("a").text();

                    // Sets the new dropdown list text to the value of the current option
                    self._setText(self.dropdownText, currentDataSelectedText || currentText);

                    self.dropdownText.attr("data-val", self.originalElem.value);

                    if(currentOption.find("i").attr("class")) {

                        self.dropdownImage.attr("class", currentOption.find("i").attr("class")).addClass("selectboxit-default-icon");

                        self.dropdownImage.attr("style", currentOption.find("i").attr("style"));
                    }

                    // Triggers a custom changed event on the original select box
                    self.triggerEvent("changed");

                },

                // `disable` event with the `selectBoxIt` namespace
                "disable.selectBoxIt": function() {

                    // Adds the `disabled` CSS class to the new dropdown list to visually show that it is disabled
                    self.dropdown.addClass(self.theme["disabled"]);

                },

                // `enable` event with the `selectBoxIt` namespace
                "enable.selectBoxIt": function() {

                    // Removes the `disabled` CSS class from the new dropdown list to visually show that it is enabled
                    self.dropdown.removeClass(self.theme["disabled"]);

                },

                // `open` event with the `selectBoxIt` namespace
                "open.selectBoxIt": function() {

                    var currentElem = self.list.find("li[data-val='" + self.dropdownText.attr("data-val") + "']"),
                        activeElem;

                    // If no current element can be found, then select the first drop down option
                    if(!currentElem.length) {

                        // Sets the default value of the dropdown list to the first option that is not disabled
                        currentElem = self.listItems.not("[data-disabled=true]").first();

                    }

                    self.currentFocus = +currentElem.attr("data-id");

                    activeElem = self.listItems.eq(self.currentFocus);

                    self.dropdown.addClass(openClass).

                    // Removes the focus class from the dropdown list and adds the library focus class for both the dropdown list and the currently selected dropdown list option
                    removeClass(hoverClass).addClass(focusClass);

                    self.listItems.removeClass(self.selectedClass).

                    removeAttr("data-active").not(activeElem).removeClass(focusClass);

                    activeElem.addClass(self.selectedClass).addClass(focusClass);

                    if(self.options.hideCurrent) {
                        activeElem.hide().promise().done(function () {
                            self.listItems.show();
                        });
                    }

                },

                "close.selectBoxIt": function() {

                    // Removes the open class from the dropdown container
                    self.dropdown.removeClass(openClass);

                },

                "blur.selectBoxIt": function() {

                    self.dropdown.removeClass(focusClass);

                },

                // `mousenter` event with the `selectBoxIt` namespace
                "mouseenter.selectBoxIt": function() {

                    if(!$(this).hasClass(self.theme["disabled"])) {
                        self.dropdown.addClass(hoverClass);
                    }

                },

                // `mouseleave` event with the `selectBoxIt` namespace
                "mouseleave.selectBoxIt": function() {

                    // Removes the hover CSS class on the previously hovered dropdown list option
                    self.dropdown.removeClass(hoverClass);

                },

                // `destroy` event
                "destroy": function(ev) {

                    // Prevents the default action from happening
                    ev.preventDefault();

                    // Prevents the destroy event from propagating
                    ev.stopPropagation();

                }

            });

            // Maintains chainability
            return self;

        },

        // _update
        // -------
        //      Updates the drop down and select box with the current value
        _update: function(elem) {

            var self = this,
                currentDataSelectedText,
                currentDataText,
                currentText,
                defaultText = self.options["defaultText"] || self.selectBox.attr("data-text"),
                currentElem = self.listItems.eq(self.currentFocus);

            if (elem.attr("data-disabled") === "false") {

                currentDataSelectedText = self.listItems.eq(self.currentFocus).attr("data-selectedtext");

                currentDataText = currentElem.attr("data-text");

                currentText = currentDataText ? currentDataText: currentElem.text();

                // If the default text option is set and the current drop down option is not disabled
                if ((defaultText && self.options["html"] ? self.dropdownText.html() === defaultText: self.dropdownText.text() === defaultText) && self.selectBox.val() === elem.attr("data-val")) {

                    self.triggerEvent("change");

                }

                else {

                    // Sets the original dropdown list value and triggers the `change` event on the original select box
                    self.selectBox.val(elem.attr("data-val"));

                    // Sets `currentFocus` to the currently focused dropdown list option.
                    // The unary `+` operator casts the string to a number
                    // [James Padolsey Blog Post](http://james.padolsey.com/javascript/terse-javascript-101-part-2/)
                    self.currentFocus = +elem.attr("data-id");

                    // Triggers the dropdown list `change` event if a value change occurs
                    if (self.originalElem.value !== self.dropdownText.attr("data-val")) {

                        self.triggerEvent("change");

                    }

                }

            }

        },

        // _addClasses
        // -----------
        //      Adds SelectBoxIt CSS classes
        _addClasses: function(obj) {

            var self = this,

                focusClass = self.focusClass = obj.focus,

                hoverClass = self.hoverClass = obj.hover,

                buttonClass = obj.button,

                listClass = obj.list,

                arrowClass = obj.arrow,

                containerClass = obj.container,

                openClass = self.openClass = obj.open;

            self.selectedClass = "selectboxit-selected";

            self.downArrow.addClass(self.selectBox.attr("data-downarrow") || self.options["downArrowIcon"] || arrowClass);

            // Adds the correct container class to the dropdown list
            self.dropdownContainer.addClass(containerClass);

            // Adds the correct class to the dropdown list
            self.dropdown.addClass(buttonClass);

            // Adds the default class to the dropdown list options
            self.list.addClass(listClass);

            // Maintains chainability
            return self;

        },

        // Refresh
        // -------
        //    The dropdown will rebuild itself.  Useful for dynamic content.
        refresh: function(callback, internal) {

            var self = this;

            // Destroys the plugin and then recreates the plugin
            self._destroySelectBoxIt()._create(true);

            if(!internal) {
                self.triggerEvent("refresh");
            }

            self._callbackSupport(callback);

            //Maintains chainability
            return self;

        },

        // HTML Escape
        // -----------
        //      HTML encodes a string
        htmlEscape: function(str) {

            return String(str)
                .replace(/&/g, "&amp;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");

        },

        // triggerEvent
        // ------------
        //      Trigger's an external event on the original select box element
        triggerEvent: function(eventName) {

            var self = this,
                // Finds the currently option index
                currentIndex = self.options["showFirstOption"] ? self.currentFocus : ((self.currentFocus - 1) >= 0 ? self.currentFocus: 0);

            // Triggers the custom option-click event on the original select box and passes the select box option
            self.selectBox.trigger(eventName, { "selectbox": self.selectBox, "selectboxOption": self.selectItems.eq(currentIndex), "dropdown": self.dropdown, "dropdownOption": self.listItems.eq(self.currentFocus) });

            // Maintains chainability
            return self;

        },

        // _copyAttributes
        // ---------------
        //      Copies HTML attributes from the original select box to the new drop down
        _copyAttributes: function() {

            var self = this;

            if(self._addSelectBoxAttributes) {

                self._addSelectBoxAttributes();

            }

            return self;

        },

        // _realOuterWidth
        // ---------------
        //      Retrieves the true outerWidth dimensions of a hidden DOM element
        _realOuterWidth: function(elem) {

            if(elem.is(":visible")) {

                return elem.outerWidth(true);

            }

            var self = this,
                clonedElem = elem.clone(),
                outerWidth;

            clonedElem.css({

                "visibility": "hidden",

                "display": "block",

                "position": "absolute"

            }).appendTo("body");

            outerWidth = clonedElem.outerWidth(true);

            clonedElem.remove();

            return outerWidth;
        }

    });

    // Stores the plugin prototype object in a local variable
    var selectBoxIt = $.selectBox.selectBoxIt.prototype;

    // Accessibility Module
    // ====================

    // _ARIA Accessibility
    // ------------------
    //      Adds ARIA (Accessible Rich Internet Applications)
    //      Accessibility Tags to the Select Box

    selectBoxIt._ariaAccessibility = function() {

        var self = this,
            dropdownLabel = $("label[for='" + self.originalElem.id + "']");

        // Adds `ARIA attributes` to the dropdown list
        self.dropdownContainer.attr({

            // W3C `combobox` description: A presentation of a select; usually similar to a textbox where users can type ahead to select an option.
            "role": "combobox",

            "aria-haspopup": "true",

            // W3C `aria-expanded` description: Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.
            "aria-expanded": "false",

            // W3C `aria-owns` description: The value of the aria-owns attribute is a space-separated list of IDREFS that reference one or more elements in the document by ID. The reason for adding aria-owns is to expose a parent/child contextual relationship to assistive technologies that is otherwise impossible to infer from the DOM.
            "aria-owns": self.list[0].id

        });

        self.dropdownText.attr({

            "aria-live": "polite"

        });

        // Dynamically adds `ARIA attributes` if the new dropdown list is enabled or disabled
        self.dropdown.on({

            //Select box custom `disable` event with the `selectBoxIt` namespace
            "disable.selectBoxIt" : function() {

                // W3C `aria-disabled` description: Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.
                self.dropdownContainer.attr("aria-disabled", "true");

            },

            // Select box custom `enable` event with the `selectBoxIt` namespace
            "enable.selectBoxIt" : function() {

                // W3C `aria-disabled` description: Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.
                self.dropdownContainer.attr("aria-disabled", "false");

            }

        });

        if(dropdownLabel.length) {

            // MDN `aria-labelledby` description:  Indicates the IDs of the elements that are the labels for the object.
            self.dropdownContainer.attr("aria-labelledby", dropdownLabel[0].id);

        }

        // Adds ARIA attributes to the dropdown list options list
        self.list.attr({

            // W3C `listbox` description: A widget that allows the user to select one or more items from a list of choices.
            "role": "listbox",

            // Indicates that the dropdown list options list is currently hidden
            "aria-hidden": "true"

        });

        // Adds `ARIA attributes` to the dropdown list options
        self.listItems.attr({

            // This must be set for each element when the container element role is set to `listbox`
            "role": "option"

        });

        // Dynamically updates the new dropdown list `aria-label` attribute after the original dropdown list value changes
        self.selectBox.on({

            // Custom `open` event with the `selectBoxIt` namespace
            "open.selectBoxIt": function() {

                // Indicates that the dropdown list options list is currently visible
                self.list.attr("aria-hidden", "false");

                // Indicates that the dropdown list is currently expanded
                self.dropdownContainer.attr("aria-expanded", "true");

            },

            // Custom `close` event with the `selectBoxIt` namespace
            "close.selectBoxIt": function() {

                // Indicates that the dropdown list options list is currently hidden
                self.list.attr("aria-hidden", "true");

                // Indicates that the dropdown list is currently collapsed
                self.dropdownContainer.attr("aria-expanded", "false");

            }

        });

        // Maintains chainability
        return self;

    };
    // Copy Attributes Module
    // ======================

    // addSelectBoxAttributes
    // ----------------------
    //      Add's all attributes (excluding id, class names, and the style attribute) from the default select box to the new drop down

    selectBoxIt._addSelectBoxAttributes = function() {

        // Stores the plugin context inside of the self variable
        var self = this;

        // Add's all attributes to the currently traversed drop down option
        self._addAttributes(self.selectBox.prop("attributes"), self.dropdown);

        // Add's all attributes to the drop down items list
        self.selectItems.each(function(iterator) {

            // Add's all attributes to the currently traversed drop down option
            self._addAttributes($(this).prop("attributes"), self.listItems.eq(iterator));

        });

        // Maintains chainability
        return self;

    };

    // addAttributes
    // -------------
    //  Add's attributes to a DOM element
    selectBoxIt._addAttributes = function(arr, elem) {

        // Stores the plugin context inside of the self variable
        var self = this,
            whitelist = self.options["copyAttributes"],
            blacklist = self.options["dontCopyAttributes"];


        // If there are array properties
        if(arr.length) {

            // Iterates over all of array properties
            $.each(arr, function(iterator, property) {

                // Get's the property name and property value of each property
                var propName = (property.name).toLowerCase(), propValue = property.value;

                // If the currently traversed property is in the blacklist
                if($.inArray(propName, blacklist) !== -1) {

                    return;

                }

                // If the currently traversed property value is not "null", is on the whitelist, or is an HTML 5 data attribute
                if(propValue !== "null" && ($.inArray(propName, whitelist) !== -1 || propName.indexOf("data") !== -1)) {

                    // Set's the currently traversed property on element
                    elem.attr(propName, propValue);

                }

            });

        }

        // Maintains chainability
        return self;

    };
// Destroy Module
// ==============

// Destroy
// -------
//    Removes the plugin from the page

selectBoxIt.destroy = function(callback) {

    // Stores the plugin context inside of the self variable
    var self = this;

    self._destroySelectBoxIt();

    // Calls the jQueryUI Widget Factory destroy method
    self.widgetProto.destroy.call(self);

    // Provides callback function support
    self._callbackSupport(callback);

    // Maintains chainability
    return self;

};

// Internal Destroy Method
// -----------------------
//    Removes the plugin from the page

selectBoxIt._destroySelectBoxIt = function() {

    // Stores the plugin context inside of the self variable
    var self = this;

    // Unbinds all of the dropdown list event handlers with the `selectBoxIt` namespace
    self.dropdown.off(".selectBoxIt");

    // If the original select box has been placed inside of the new drop down container
    if ($.contains(self.dropdownContainer[0], self.originalElem)) {

        // Moves the original select box before the drop down container
        self.dropdownContainer.before(self.selectBox);

    }

    // Remove all of the `selectBoxIt` DOM elements from the page
    self.dropdownContainer.remove();

    // Resets the style attributes for the original select box
    self.selectBox.removeAttr("style").attr("style", self.selectBoxStyles);

    // Triggers the custom `destroy` event on the original select box
    self.triggerEvent("destroy");

    // Maintains chainability
    return self;

};
    // Disable Module
    // ==============

    // Disable
    // -------
    //      Disables the new dropdown list

    selectBoxIt.disable = function(callback) {

        var self = this;

        if(!self.options["disabled"]) {

            // Makes sure the dropdown list is closed
            self.close();

            // Sets the `disabled` attribute on the original select box
            self.selectBox.attr("disabled", "disabled");

            // Makes the dropdown list not focusable by removing the `tabindex` attribute
            self.dropdown.removeAttr("tabindex").

            // Disables styling for enabled state
            removeClass(self.theme["enabled"]).

            // Enabled styling for disabled state
            addClass(self.theme["disabled"]);

            self._setOption("disabled", true);

            // Triggers a `disable` custom event on the original select box
            self.triggerEvent("disable");

        }

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Disable Option
    // --------------
    //      Disables a single drop down option

    selectBoxIt.disableOption = function(index, callback) {

        var self = this, currentSelectBoxOption, hasNextEnabled, hasPreviousEnabled, type = $.type(index);

        // If an index is passed to target an indropdownidual drop down option
        if(type === "number") {

            // Makes sure the dropdown list is closed
            self.close();

            // The select box option being targeted
            currentSelectBoxOption = self.selectBox.find("option").eq(index);

            // Triggers a `disable-option` custom event on the original select box and passes the disabled option
            self.triggerEvent("disable-option");

            // Disables the targeted select box option
            currentSelectBoxOption.attr("disabled", "disabled");

            // Disables the drop down option
            self.listItems.eq(index).attr("data-disabled", "true").

            // Applies disabled styling for the drop down option
            addClass(self.theme["disabled"]);

            // If the currently selected drop down option is the item being disabled
            if(self.currentFocus === index) {

                hasNextEnabled = self.listItems.eq(self.currentFocus).nextAll("li").not("[data-disabled='true']").first().length;

                hasPreviousEnabled = self.listItems.eq(self.currentFocus).prevAll("li").not("[data-disabled='true']").first().length;

                // If there is a currently enabled option beneath the currently selected option
                if(hasNextEnabled) {

                    // Selects the option beneath the currently selected option
                    self.moveDown();

                }

                // If there is a currently enabled option above the currently selected option
                else if(hasPreviousEnabled) {

                    // Selects the option above the currently selected option
                    self.moveUp();

                }

                // If there is not a currently enabled option
                else {

                    // Disables the entire drop down list
                    self.disable();

                }

            }

        }

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // _Is Disabled
    // -----------
    //      Checks the original select box for the
    //    disabled attribute

    selectBoxIt._isDisabled = function(callback) {

        var self = this;

        // If the original select box is disabled
        if (self.originalElem.disabled) {

            // Disables the dropdown list
            self.disable();

        }

        // Maintains chainability
        return self;

    };
    // Dynamic Positioning Module
    // ==========================

    // _Dynamic positioning
    // --------------------
    //      Dynamically positions the dropdown list options list

    selectBoxIt._dynamicPositioning = function() {

        var self = this;
        var openUpClassName = 'selectboxit-open-up';
        var openDownClassName = 'selectboxit-open-down';

        // If the `size` option is a number
        if($.type(self.listSize) === "number") {

            // Set's the max-height of the drop down list
            self.list.css("max-height", self.maxHeight || "none");

        }

        // If the `size` option is not a number
        else {

            // Returns the x and y coordinates of the dropdown list options list relative to the document
            var listOffsetTop = self.dropdown.offset().top,

                // The height of the dropdown list options list
                listHeight = self.list.data("max-height") || self.list.outerHeight(),

                // The height of the dropdown list DOM element
                selectBoxHeight = self.dropdown.outerHeight(),

                viewport = self.options["viewport"],

                viewportHeight = viewport.height(),

                viewportScrollTop = $.isWindow(viewport.get(0)) ? viewport.scrollTop() : viewport.offset().top,

                topToBottom = (listOffsetTop + selectBoxHeight + listHeight <= viewportHeight + viewportScrollTop),

                bottomReached = !topToBottom;

            if(!self.list.data("max-height")) {

              self.list.data("max-height", self.list.outerHeight());

            }

            // If there is room on the bottom of the viewport to display the drop down options
            if (!bottomReached) {

                self.list.css("max-height", listHeight);

                // Sets custom CSS properties to place the dropdown list options directly below the dropdown list
                self.list.css("top", "auto");

                self.dropdown.addClass(openDownClassName);

            }

            // If there is room on the top of the viewport
            else if((self.dropdown.offset().top - viewportScrollTop) >= listHeight) {

                self.list.css("max-height", listHeight);

                // Sets custom CSS properties to place the dropdown list options directly above the dropdown list
                self.list.css("top", (self.dropdown.position().top - self.list.outerHeight()));

                self.dropdown.addClass(openUpClassName);

            }

            // If there is not enough room on the top or the bottom
            else {

                var outsideBottomViewport = Math.abs((listOffsetTop + selectBoxHeight + listHeight) - (viewportHeight + viewportScrollTop)),

                    outsideTopViewport = Math.abs((self.dropdown.offset().top - viewportScrollTop) - listHeight);

                // If there is more room on the bottom
                if(outsideBottomViewport < outsideTopViewport) {

                    self.list.css("max-height", listHeight - outsideBottomViewport - (selectBoxHeight/2));

                    self.list.css("top", "auto");

                    self.dropdown.addClass(openDownClassName);
                }

                // If there is more room on the top
                else {

                    self.list.css("max-height", listHeight - outsideTopViewport - (selectBoxHeight/2));

                    // Sets custom CSS properties to place the dropdown list options directly above the dropdown list
                    self.list.css("top", (self.dropdown.position().top - self.list.outerHeight()));

                    self.dropdown.addClass(openUpClassName);
                }

            }

        }

        // Maintains chainability
        return self;

    };
    // Enable Module
    // =============

    // Enable
    // ------
    //      Enables the new dropdown list

    selectBoxIt.enable = function(callback) {

        var self = this;

        if(self.options["disabled"]) {

            // Triggers a `enable` custom event on the original select box
            self.triggerEvent("enable");

            // Removes the `disabled` attribute from the original dropdown list
            self.selectBox.removeAttr("disabled");

            // Make the dropdown list focusable
            self.dropdown.attr("tabindex", 0).

            // Disable styling for disabled state
            removeClass(self.theme["disabled"]).

            // Enables styling for enabled state
            addClass(self.theme["enabled"]);

            self._setOption("disabled", false);

            // Provide callback function support
            self._callbackSupport(callback);

        }

        // Maintains chainability
        return self;

    };

    // Enable Option
    // -------------
    //      Disables a single drop down option

    selectBoxIt.enableOption = function(index, callback) {

        var self = this, currentSelectBoxOption, currentIndex = 0, hasNextEnabled, hasPreviousEnabled, type = $.type(index);

        // If an index is passed to target an indropdownidual drop down option
        if(type === "number") {

            // The select box option being targeted
            currentSelectBoxOption = self.selectBox.find("option").eq(index);

            // Triggers a `enable-option` custom event on the original select box and passes the enabled option
            self.triggerEvent("enable-option");

            // Disables the targeted select box option
            currentSelectBoxOption.removeAttr("disabled");

            // Disables the drop down option
            self.listItems.eq(index).attr("data-disabled", "false").

            // Applies disabled styling for the drop down option
            removeClass(self.theme["disabled"]);

        }

        // Provides callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };
    // Keyboard Navigation Module
    // ==========================

    // Move Down
    // ---------
    //      Handles the down keyboard navigation logic

    selectBoxIt.moveDown = function(callback) {

        var self = this;

        // Increments `currentFocus`, which represents the currently focused list item `id` attribute.
        self.currentFocus += 1;

        // Determines whether the dropdown option the user is trying to go to is currently disabled
        var disabled = self.listItems.eq(self.currentFocus).attr("data-disabled") === "true" ? true: false,

            hasNextEnabled = self.listItems.eq(self.currentFocus).nextAll("li").not("[data-disabled='true']").first().length;

        // If the user has reached the top of the list
        if (self.currentFocus === self.listItems.length) {

            // Does not allow the user to continue to go up the list
            self.currentFocus -= 1;

        }

        // If the option the user is trying to go to is disabled, but there is another enabled option
        else if (disabled && hasNextEnabled) {

            // Blur the previously selected option
            self.listItems.eq(self.currentFocus - 1).blur();

           // Call the `moveDown` method again
            self.moveDown();

            // Exit the method
            return;

        }

        // If the option the user is trying to go to is disabled, but there is not another enabled option
        else if (disabled && !hasNextEnabled) {

            self.currentFocus -= 1;

        }

        // If the user has not reached the bottom of the unordered list
        else {

            // Blurs the previously focused list item
            // The jQuery `end()` method allows you to continue chaining while also using a different selector
            self.listItems.eq(self.currentFocus - 1).blur().end().

            // Focuses the currently focused list item
            eq(self.currentFocus).focusin();

            // Calls `scrollToView` to make sure the `scrollTop` is correctly updated. The `down` user action
            self._scrollToView("down");

            // Triggers the custom `moveDown` event on the original select box
            self.triggerEvent("moveDown");

        }

        // Provide callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };

    // Move Up
    // ------
    //      Handles the up keyboard navigation logic
    selectBoxIt.moveUp = function(callback) {

        var self = this;

        // Increments `currentFocus`, which represents the currently focused list item `id` attribute.
        self.currentFocus -= 1;

        // Determines whether the dropdown option the user is trying to go to is currently disabled
        var disabled = self.listItems.eq(self.currentFocus).attr("data-disabled") === "true" ? true: false,

            hasPreviousEnabled = self.listItems.eq(self.currentFocus).prevAll("li").not("[data-disabled='true']").first().length;

        // If the user has reached the top of the list
        if (self.currentFocus === -1) {

            // Does not allow the user to continue to go up the list
            self.currentFocus += 1;

        }

        // If the option the user is trying to go to is disabled and the user is not trying to go up after the user has reached the top of the list
        else if (disabled && hasPreviousEnabled) {

            // Blur the previously selected option
            self.listItems.eq(self.currentFocus + 1).blur();

            // Call the `moveUp` method again
            self.moveUp();

            // Exits the method
            return;

        }

        else if (disabled && !hasPreviousEnabled) {

            self.currentFocus += 1;

        }

        // If the user has not reached the top of the unordered list
        else {

            // Blurs the previously focused list item
            // The jQuery `end()` method allows you to continue chaining while also using a different selector
            self.listItems.eq(this.currentFocus + 1).blur().end().

            // Focuses the currently focused list item
            eq(self.currentFocus).focusin();

            // Calls `scrollToView` to make sure the `scrollTop` is correctly updated. The `down` user action
            self._scrollToView("up");

            // Triggers the custom `moveDown` event on the original select box
            self.triggerEvent("moveUp");

        }

        // Provide callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };
    // Keyboard Search Module
    // ======================

    // _Set Current Search Option
    // -------------------------
    //      Sets the currently selected dropdown list search option

    selectBoxIt._setCurrentSearchOption = function(currentOption) {

        var self = this;

        // Does not change the current option if `showFirstOption` is false and the matched search item is the hidden first option.
        // Otherwise, the current option value is updated
        if ((self.options["aggressiveChange"] || self.options["selectWhenHidden"] || self.listItems.eq(currentOption).is(":visible")) && self.listItems.eq(currentOption).data("disabled") !== true) {

            // Calls the `blur` event of the currently selected dropdown list option
            self.listItems.eq(self.currentFocus).blur();

            // Sets `currentIndex` to the currently selected dropdown list option
            self.currentIndex = currentOption;

            // Sets `currentFocus` to the currently selected dropdown list option
            self.currentFocus = currentOption;

            // Focuses the currently selected dropdown list option
            self.listItems.eq(self.currentFocus).focusin();

            // Updates the scrollTop so that the currently selected dropdown list option is visible to the user
            self._scrollToView("search");

            // Triggers the custom `search` event on the original select box
            self.triggerEvent("search");

        }

        // Maintains chainability
        return self;

    };

    // _Search Algorithm
    // -----------------
    //      Uses regular expressions to find text matches
    selectBoxIt._searchAlgorithm = function(currentIndex, alphaNumeric) {

        var self = this,

            options = self.options,

            // Boolean to determine if a pattern match exists
            matchExists = false,

            // Iteration variable used in the outermost for loop
            x,

            // Iteration variable used in the nested for loop
            y,

            // Variable used to cache the length of the text array (Small enhancement to speed up traversing)
            arrayLength,

            // Variable storing the current search
            currentSearch,

            // Variable storing the textArray property
            textArray = self.textArray,

            // Variable storing the current text property
            currentText = self.currentText,

            // Option for how many characters a user must search to be treated as a full string search
            numSearchCharacters = $.type(options.numSearchCharacters) === 'number' ? options.numSearchCharacters : 3;

        // Loops through the text array to find a pattern match
        for (x = currentIndex, arrayLength = textArray.length; x < arrayLength; x += 1) {

            currentSearch = textArray[x];

            // Nested for loop to help search for a pattern match with the currently traversed array item
            for (y = 0; y < arrayLength; y += 1) {

                // Searches for a match
                if (textArray[y].search(alphaNumeric) !== -1) {

                    // `matchExists` is set to true if there is a match
                    matchExists = true;

                    // Exits the nested for loop
                    y = arrayLength;

                }

            } // End nested for loop

            // If a match does not exist
            if (!matchExists) {

                // Sets the current text to the last entered character
                self.currentText = self.currentText.charAt(self.currentText.length - 1).

                // Escapes the regular expression to make sure special characters are seen as literal characters instead of special commands
                replace(/[|()\[{.+*?$\\]/g, "\\$0");

                currentText = self.currentText;

            }

            // Resets the regular expression with the new value of `self.currentText`
            alphaNumeric = new RegExp(currentText, "gi");

            // Searches based on the first letter of the dropdown list options text if the currentText < 3 characters
            if (currentText.length < numSearchCharacters) {

                alphaNumeric = new RegExp(currentText.charAt(0), "gi");

                // If there is a match based on the first character
                if ((currentSearch.charAt(0).search(alphaNumeric) !== -1)) {

                    // Sets properties of that dropdown list option to make it the currently selected option
                    self._setCurrentSearchOption(x);

                    if((currentSearch.substring(0, currentText.length).toLowerCase() !== currentText.toLowerCase()) || self.options["similarSearch"]) {

                        // Increments the current index by one
                        self.currentIndex += 1;

                    }

                    // Exits the search
                    return false;

                }

            }

            // If `self.currentText` > 1 character
            else {

                // If there is a match based on the entire string
                if ((currentSearch.search(alphaNumeric) !== -1)) {

                    // Sets properties of that dropdown list option to make it the currently selected option
                    self._setCurrentSearchOption(x);

                    // Exits the search
                    return false;

                }

            }

            // If the current text search is an exact match
            if (currentSearch.toLowerCase() === self.currentText.toLowerCase()) {

                // Sets properties of that dropdown list option to make it the currently selected option
                self._setCurrentSearchOption(x);

                // Resets the current text search to a blank string to start fresh again
                self.currentText = "";

                // Exits the search
                return false;

            }

        }

       // Returns true if there is not a match at all
        return true;

    };

    // Search
    // ------
    //      Calls searchAlgorithm()
    selectBoxIt.search = function(alphaNumericKey, callback, rememberPreviousSearch) {

        var self = this;

        // If the search method is being called internally by the plugin, and not externally as a method by a user
        if (rememberPreviousSearch) {

            // Continued search with history from past searches.  Properly escapes the regular expression
            self.currentText += alphaNumericKey.replace(/[|()\[{.+*?$\\]/g, "\\$0");

        }

        else {

            // Brand new search.  Properly escapes the regular expression
            self.currentText = alphaNumericKey.replace(/[|()\[{.+*?$\\]/g, "\\$0");

        }

        // Searches globally
        var searchResults = self._searchAlgorithm(self.currentIndex, new RegExp(self.currentText, "gi"));

        // Searches the list again if a match is not found.  This is needed, because the first search started at the array indece of the currently selected dropdown list option, and does not search the options before the current array indece.
        // If there are many similar dropdown list options, starting the search at the indece of the currently selected dropdown list option is needed to properly traverse the text array.
        if (searchResults) {

            // Searches the dropdown list values starting from the beginning of the text array
            self._searchAlgorithm(0, self.currentText);

        }

        // Provide callback function support
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };
    // Mobile Module
    // =============

    // Set Mobile Text
    // ---------------
    //      Updates the text of the drop down
    selectBoxIt._updateMobileText = function() {

        var self = this,
            currentOption,
            currentDataText,
            currentText;

        currentOption = self.selectBox.find("option").filter(":selected");

        currentDataText = currentOption.attr("data-text");

        currentText = currentDataText ? currentDataText: currentOption.text();

        // Sets the new dropdown list text to the value of the original dropdown list
        self._setText(self.dropdownText, currentText);

        if(self.list.find('li[data-val="' + currentOption.val() + '"]').find("i").attr("class")) {

           self.dropdownImage.attr("class", self.list.find('li[data-val="' + currentOption.val() + '"]').find("i").attr("class")).addClass("selectboxit-default-icon");

        }

    };

    // Apply Native Select
    // -------------------
    //      Applies the original select box directly over the new drop down

    selectBoxIt._applyNativeSelect = function() {

        // Stores the plugin context inside of the self variable
        var self = this;

        // Appends the native select box to the drop down (allows for relative positioning using the position() method)
        self.dropdownContainer.append(self.selectBox);

        self.dropdown.attr("tabindex", "-1");

        // Positions the original select box directly over top the new dropdown list using position absolute and "hides" the original select box using an opacity of 0.  This allows the mobile browser "wheel" interface for better usability.
        self.selectBox.css({

            "display": "block",

            "visibility": "visible",

            "width": self._realOuterWidth(self.dropdown),

            "height": self.dropdown.outerHeight(),

            "opacity": "0",

            "position": "absolute",

            "top": "0",

            "left": "0",

            "cursor": "pointer",

            "z-index": "1",

            "margin": self.dropdown.css("margin"),

            "padding": "0",

            "-webkit-appearance": "menulist-button"

        });

        if(self.originalElem.disabled) {

            self.triggerEvent("disable");

        }

        return this;

    };

    // Mobile Events
    // -------------
    //      Listens to mobile-specific events
    selectBoxIt._mobileEvents = function() {

        var self = this;

        self.selectBox.on({

            "changed.selectBoxIt": function() {

                self.hasChanged = true;

                self._updateMobileText();

                // Triggers the `option-click` event on mobile
                self.triggerEvent("option-click");

            },

            "mousedown.selectBoxIt": function() {

                // If the select box has not been changed, the defaultText option is being used
                if(!self.hasChanged && self.options.defaultText && !self.originalElem.disabled) {

                    self._updateMobileText();

                    self.triggerEvent("option-click");

                }

            },

            "enable.selectBoxIt": function() {

                // Moves SelectBoxIt onto the page
                self.selectBox.removeClass('selectboxit-rendering');

            },

            "disable.selectBoxIt": function() {

                // Moves SelectBoxIt off the page
                self.selectBox.addClass('selectboxit-rendering');

            },

            "destroy.selectBoxIt": function() {

                // Reset SelectBoxIt class
                self.selectBox.removeClass('selectboxit-rendering');

            }
        });

    };

    // Mobile
    // ------
    //      Applies the native "wheel" interface when a mobile user is interacting with the dropdown

    selectBoxIt._mobile = function(callback) {

        // Stores the plugin context inside of the self variable
        var self = this;

            if(self.isMobile) {

                self._applyNativeSelect();

                self._mobileEvents();

            }

            // Maintains chainability
            return this;

    };
    // Select Option Module
    // ====================

    // Select Option
    // -------------
    //      Programatically selects a drop down option by either index or value

    selectBoxIt.selectOption = function(val, callback) {

        // Stores the plugin context inside of the self variable
        var self = this,
            type = $.type(val);

        // Makes sure the passed in position is a number
        if(type === "number") {

            // Set's the original select box value and triggers the change event (which SelectBoxIt listens for)
            self.selectBox.val(self.selectItems.eq(val).val()).change();

        }

        else if(type === "string") {

            // Set's the original select box value and triggers the change event (which SelectBoxIt listens for)
            self.selectBox.val(val).change();

        }

        // Calls the callback function
        self._callbackSupport(callback);

        // Maintains chainability
        return self;

    };
    // Set Option Module
    // =================

    // Set Option
    // ----------
    //      Accepts an string key, a value, and a callback function to replace a single
    //      property of the plugin options object

    selectBoxIt.setOption = function(key, value, callback) {

        var self = this;

        //Makes sure a string is passed in
        if($.type(key) === "string") {

            // Sets the plugin option to the new value provided by the user
            self.options[key] = value;

        }

        // Rebuilds the dropdown
        self.refresh(function() {

            // Provide callback function support
            self._callbackSupport(callback);

        }, true);

        // Maintains chainability
        return self;

    };
    // Set Options Module
    // ==================

    // Set Options
    // ----------
    //      Accepts an object to replace plugin options
    //      properties of the plugin options object

    selectBoxIt.setOptions = function(newOptions, callback) {

        var self = this;

        // If the passed in parameter is an object literal
        if($.isPlainObject(newOptions)) {

            self.options = $.extend({}, self.options, newOptions);

        }

        // Rebuilds the dropdown
        self.refresh(function() {

            // Provide callback function support
            self._callbackSupport(callback);

        }, true);

        // Maintains chainability
        return self;

    };
    // Wait Module
    // ===========

    // Wait
    // ----
    //    Delays execution by the amount of time
    //    specified by the parameter

    selectBoxIt.wait = function(time, callback) {

        var self = this;

        self.widgetProto._delay.call(self, callback, time);

        // Maintains chainability
        return self;

    };
    // Add Options Module
    // ==================

    // add
    // ---
    //    Adds drop down options
    //    using JSON data, an array,
    //    a single object, or valid HTML string

    selectBoxIt.add = function(data, callback) {

        this._populate(data, function(data) {

            var self = this,
                dataType = $.type(data),
                value,
                x = 0,
                dataLength,
                elems = [],
                isJSON = self._isJSON(data),
                parsedJSON = isJSON && self._parseJSON(data);

            // If the passed data is a local or JSON array
            if(data && (dataType === "array" || (isJSON && parsedJSON.data && $.type(parsedJSON.data) === "array")) || (dataType === "object" && data.data && $.type(data.data) === "array")) {

                // If the data is JSON
                if(self._isJSON(data)) {

                    // Parses the JSON and stores it in the data local variable
                    data = parsedJSON;

                }

                // If there is an inner `data` property stored in the first level of the JSON array
                if(data.data) {

                    // Set's the data to the inner `data` property
                    data = data.data;

                }

                // Loops through the array
                for(dataLength = data.length; x <= dataLength - 1; x += 1) {

                    // Stores the currently traversed array item in the local `value` variable
                    value = data[x];

                    // If the currently traversed array item is an object literal
                    if($.isPlainObject(value)) {

                        // Adds an option to the elems array
                        elems.push($("<option/>", value));

                    }

                    // If the currently traversed array item is a string
                    else if($.type(value) === "string") {

                        // Adds an option to the elems array
                        elems.push($("<option/>", { text: value, value: value }));

                    }

                }

                // Appends all options to the drop down (with the correct object configurations)
                self.selectBox.append(elems);

            }

            // if the passed data is an html string and not a JSON string
            else if(data && dataType === "string" && !self._isJSON(data)) {

                // Appends the html string options to the original select box
                self.selectBox.append(data);

            }

            else if(data && dataType === "object") {

                // Appends an option to the original select box (with the object configurations)
                self.selectBox.append($("<option/>", data));

            }

            else if(data && self._isJSON(data) && $.isPlainObject(self._parseJSON(data))) {

                // Appends an option to the original select box (with the object configurations)
                self.selectBox.append($("<option/>", self._parseJSON(data)));

            }

            // If the dropdown property exists
            if(self.dropdown) {

                // Rebuilds the dropdown
                self.refresh(function() {

                    // Provide callback function support
                    self._callbackSupport(callback);

                }, true);

            } else {

                // Provide callback function support
                self._callbackSupport(callback);

            }

            // Maintains chainability
            return self;

        });

    };

    // parseJSON
    // ---------
    //      Detects JSON support and parses JSON data
    selectBoxIt._parseJSON = function(data) {

        return (JSON && JSON.parse && JSON.parse(data)) || $.parseJSON(data);

    };

    // isjSON
    // ------
    //    Determines if a string is valid JSON

    selectBoxIt._isJSON = function(data) {

        var self = this,
            json;

        try {

            json = self._parseJSON(data);

            // Valid JSON
            return true;

        } catch (e) {

            // Invalid JSON
            return false;

        }

    };

    // _populate
    // --------
    //    Handles asynchronous and synchronous data
    //    to populate the select box

    selectBoxIt._populate = function(data, callback) {

        var self = this;

        data = $.isFunction(data) ? data.call() : data;

        if(self.isDeferred(data)) {

            data.done(function(returnedData) {

                callback.call(self, returnedData);

            });

        }

        else {

            callback.call(self, data);

        }

        // Maintains chainability
        return self;

    };
    // Remove Options Module
    // =====================

    // remove
    // ------
    //    Removes drop down list options
    //    using an index

    selectBoxIt.remove = function(indexes, callback) {

        var self = this,
            dataType = $.type(indexes),
            value,
            x = 0,
            dataLength,
            elems = "";

        // If an array is passed in
        if(dataType === "array") {

            // Loops through the array
            for(dataLength = indexes.length; x <= dataLength - 1; x += 1) {

                // Stores the currently traversed array item in the local `value` variable
                value = indexes[x];

                // If the currently traversed array item is an object literal
                if($.type(value) === "number") {

                    if(elems.length) {

                        // Adds an element to the removal string
                        elems += ", option:eq(" + value + ")";

                    }

                    else {

                        // Adds an element to the removal string
                        elems += "option:eq(" + value + ")";

                    }

                }

            }

            // Removes all of the appropriate options from the select box
            self.selectBox.find(elems).remove();

        }

        // If a number is passed in
        else if(dataType === "number") {

            self.selectBox.find("option").eq(indexes).remove();

        }

        // If anything besides a number or array is passed in
        else {

            // Removes all of the options from the original select box
            self.selectBox.find("option").remove();

        }

        // If the dropdown property exists
        if(self.dropdown) {

            // Rebuilds the dropdown
            self.refresh(function() {

                // Provide callback function support
                self._callbackSupport(callback);

            }, true);

        } else {

            // Provide callback function support
            self._callbackSupport(callback);

        }

        // Maintains chainability
        return self;

    };})); // End of all modules

/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://cherne.net/brian/resources/jquery.hoverIntent.html
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007, 2014 Brian Cherne
 */
 
/* hoverIntent is similar to jQuery's built-in "hover" method except that
 * instead of firing the handlerIn function immediately, hoverIntent checks
 * to see if the user's mouse has slowed down (beneath the sensitivity
 * threshold) before firing the event. The handlerOut function is only
 * called after a matching handlerIn.
 *
 * // basic usage ... just like .hover()
 * .hoverIntent( handlerIn, handlerOut )
 * .hoverIntent( handlerInOut )
 *
 * // basic usage ... with event delegation!
 * .hoverIntent( handlerIn, handlerOut, selector )
 * .hoverIntent( handlerInOut, selector )
 *
 * // using a basic configuration object
 * .hoverIntent( config )
 *
 * @param  handlerIn   function OR configuration object
 * @param  handlerOut  function OR selector for delegation OR undefined
 * @param  selector    selector OR undefined
 * @author Brian Cherne <brian(at)cherne(dot)net>
 */
(function($) {
    $.fn.hoverIntent = function(handlerIn,handlerOut,selector) {

        // default configuration values
        var cfg = {
            interval: 100,
            sensitivity: 6,
            timeout: 0
        };

        if ( typeof handlerIn === "object" ) {
            cfg = $.extend(cfg, handlerIn );
        } else if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector } );
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut } );
        }

        // instantiate variables
        // cX, cY = current X and Y position of mouse, updated by mousemove event
        // pX, pY = previous X and Y position of mouse, set by mouseover and polling interval
        var cX, cY, pX, pY;

        // A private function for getting mouse position
        var track = function(ev) {
            cX = ev.pageX;
            cY = ev.pageY;
        };

        // A private function for comparing current and previous mouse position
        var compare = function(ev,ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            // compare mouse positions to see if they've crossed the threshold
            if ( Math.sqrt( (pX-cX)*(pX-cX) + (pY-cY)*(pY-cY) ) < cfg.sensitivity ) {
                $(ob).off("mousemove.hoverIntent",track);
                // set hoverIntent state to true (so mouseOut can be called)
                ob.hoverIntent_s = true;
                return cfg.over.apply(ob,[ev]);
            } else {
                // set previous coordinates for next time
                pX = cX; pY = cY;
                // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
                ob.hoverIntent_t = setTimeout( function(){compare(ev, ob);} , cfg.interval );
            }
        };

        // A private function for delaying the mouseOut function
        var delay = function(ev,ob) {
            ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t);
            ob.hoverIntent_s = false;
            return cfg.out.apply(ob,[ev]);
        };

        // A private function for handling mouse 'hovering'
        var handleHover = function(e) {
            // copy objects to be passed into t (required for event object to be passed in IE)
            var ev = $.extend({},e);
            var ob = this;

            // cancel hoverIntent timer if it exists
            if (ob.hoverIntent_t) { ob.hoverIntent_t = clearTimeout(ob.hoverIntent_t); }

            // if e.type === "mouseenter"
            if (e.type === "mouseenter") {
                // set "previous" X and Y position based on initial entry point
                pX = ev.pageX; pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $(ob).on("mousemove.hoverIntent",track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                if (!ob.hoverIntent_s) { ob.hoverIntent_t = setTimeout( function(){compare(ev,ob);} , cfg.interval );}

                // else e.type == "mouseleave"
            } else {
                // unbind expensive mousemove event
                $(ob).off("mousemove.hoverIntent",track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                if (ob.hoverIntent_s) { ob.hoverIntent_t = setTimeout( function(){delay(ev,ob);} , cfg.timeout );}
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({'mouseenter.hoverIntent':handleHover,'mouseleave.hoverIntent':handleHover}, cfg.selector);
    };
})(jQuery);

/*  
 *  jQuery zoom plugin
 *  Demo and documentation:
 *  http://e-smartdev.com/#!jsPluginList/panAndZoomJQuery
 *  
 *  Copyright (c) 2012 Damien Corzani
 *  http://e-smartdev.com/
 *
 *  Dual licensed under the MIT and GPL licenses.
 *  http://en.wikipedia.org/wiki/MIT_License
 *  http://en.wikipedia.org/wiki/GNU_General_Public_License
 */
(function( $ ){

  $.fn.smartZoom = function(method) {
    // define global vars
    var targetElement = this; // the element target of the plugin
    
    /**
     * ESmartZoomEvent Class 
     * define const use to dispatch zoom events
     */
    function ESmartZoomEvent(type){}
    ESmartZoomEvent.ZOOM = "SmartZoom_ZOOM";
    ESmartZoomEvent.PAN = "SmartZoom_PAN";
    ESmartZoomEvent.START = "START";
    ESmartZoomEvent.END = "END";
    ESmartZoomEvent.DESTROYED = "SmartZoom_DESTROYED";      

    /**
     * define public methods that user user could call 
     */
    var publicMethods = {
        /**
          * initialize zoom component
          * @param {Object} options = {'top': '0' zoom target container top position in pixel
          *                            'left': '0' zoom target container left position in pixel
          *                            'width' : '100%' zoom target container width in pixel or in percent
          *                            'height' : '100%' zoom target container height in pixel or in percent 
          *                            'easing' : 'smartZoomEasing' jquery easing function used when the browser doesn't support css transitions
          *                            'initCallback' : null a callback function to call after plugin initilization
          *                            'maxScale' : 3 the max scale that will be applied on the zoom target
          *                            'dblClickMaxScale' : 1.8 the max scale that will be applied on the zoom target on double click
          *                            'mouseEnabled' : true enable plugin mouse interaction 
          *                            'scrollEnabled' : true enable plugin mouse wheel behviour
          *                            'dblClickEnabled' : true enable plugin mouse doubleClick behviour
          *                            'mouseMoveEnabled' : true enable plugin target drag behviour
          *                            'moveCursorEnabled' : true show moveCursor for drag
          *                            'touchEnabled' : true enable plugin touch interaction 
          *                            'dblTapEnabled' : true enable plugin double tap behaviour
          *                            'zoomOnSimpleClick': false enable zoom on simple click (if set to true dbl lick is disabled)
          *                            'pinchEnabled' : true enable zoom when user pinch on target
          *                            'touchMoveEnabled' : true enable target move via touch
          *                            'containerBackground' : '#FFFFFF' zoom target container background color (if containerClass is not set)
          *                            'containerClass' : '' class to apply to zoom target container if you whant to change background or borders (don't change size or position via the class)
          *                           } 
          */
        init : function(options) {
            // is smartZoomData exists on the targetElement, we have already initialize it
            if(targetElement.data('smartZoomData'))
                return; 
                
            // Create some defaults, extending them with any options that were provided
            var settings = $.extend( {
              'top' : "0",
              'left' : "0",
              'width' : "100%",
              'height' : "100%",
              'easing' : "smartZoomEasing",
              'initCallback' : null,
              'maxScale' : 3,
              'dblClickMaxScale' : 1.8,
              'mouseEnabled' : true,
              'scrollEnabled' : true,
              'dblClickEnabled' : true,
              'mouseMoveEnabled' : true,
              'moveCursorEnabled' : true,
              'adjustOnResize' : true, 
              'touchEnabled' : true,
              'dblTapEnabled' : true,
              'zoomOnSimpleClick': false,
              'pinchEnabled' : true,
              'touchMoveEnabled' : true,
              'containerBackground' : "#FFFFFF",
              'containerClass' : ""
            }, options);
            
            var targetElementInitialStyles = targetElement.attr('style'); // save target element initial styles

            // create the container that will contain the zoom target
            var zoomContainerId = "smartZoomContainer"+new Date().getTime();
            var containerDiv = $('<div id="'+zoomContainerId+'" class="'+settings.containerClass+'"></div>');
            targetElement.before(containerDiv);
            targetElement.remove();
            containerDiv = $('#'+zoomContainerId);
            containerDiv.css({'overflow':'hidden'});
            if(settings.containerClass == "")
                containerDiv.css({'background-color':settings.containerBackground});
            containerDiv.append(targetElement);
            
            // create touchInfos object that will be use to manage zoom with touch events
            var touchInfos = new Object();
            touchInfos.lastTouchEndTime = 0; // this var is use to know if user had doubleTap or not 
            touchInfos.lastTouchPositionArr = null; // list of touch point used for pinch
            touchInfos.touchMove = false; // is the user is in move mode?
            touchInfos.touchPinch = false; // or is the user is in pinch mode?
            
            // smartZoomData is used to saved every plugin vars
            targetElement.data('smartZoomData', {
               settings : settings, // given settings
               containerDiv : containerDiv, // target container
               originalSize: {width:targetElement.width(), height:targetElement.height()}, // plugin target size at the beginning
               originalPosition: targetElement.offset(), // plugin target position at the beginning 
               transitionObject:getBrowserTransitionObject(), // use to know if the browser is compatible with css transition
               touch:touchInfos, // save touchInfos
               mouseWheelDeltaFactor:0.15, // enable to slow down the zoom via mouse wheel
               currentWheelDelta:0, // the current mouse wheel delta used to calculate scale to apply
               adjustedPosInfos:null, // use to save the adjust information in "adjustToContainer" method (so we can access the normal target size in plugin when we whant)
               moveCurrentPosition:null, // save the current mouse/touch position use in "moveOnMotion" method   
               moveLastPosition:null, // save the last mouse/touch position use in "moveOnMotion" method  
               mouseMoveForPan:false, // use to know if the user pan or not
               currentActionType:'', // use to save the current user action type (equal to 'ZOOM' or 'PAN')
               initialStyles:targetElementInitialStyles, // use in destroy method to reset initial styles
               currentActionStep:'' // equal to 'START' or 'END'
            });
            
            // adjust the contain and target size into the page            
            adjustToContainer();

            // listening mouse and touch events
            if(settings.touchEnabled == true)
                targetElement.bind('touchstart.smartZoom', touchStartHandler);
            if(settings.mouseEnabled == true){
                if(settings.mouseMoveEnabled == true)
                    targetElement.bind('mousedown.smartZoom', mouseDownHandler);
                if(settings.scrollEnabled == true){
                    containerDiv.bind('mousewheel.smartZoom', mouseWheelHandler);
                    containerDiv.bind( 'mousewheel.smartZoom DOMMouseScroll.smartZoom', containerMouseWheelHander);
                }
                if(settings.dblClickEnabled == true && settings.zoomOnSimpleClick == false)
                    containerDiv.bind('dblclick.smartZoom', mouseDblClickHandler);
            }
            document.ondragstart = function () { return false; }; // allow to remove browser default drag behaviour
            if(settings.adjustOnResize == true)
                $(window).bind('resize.smartZoom', windowResizeEventHandler); // call "adjustToContainer" on resize

            if(settings.initCallback != null) // call callback function after plugin initialization
                settings.initCallback.apply(this, targetElement);
        },
       /**
          * zoom function used into the plugin and accessible via direct call (ex : $('#zoomImage').smartZoom('zoom', 0.2);)
          * @param {Number} scaleToAdd : the scale to add to the plugin target current scale (often < 1) 
          * @param {Point} globalRequestedPosition {'x': global requested position in x
          *                                         'y': global requested position in y
          *                                        }  if this parameter is missing the zoom will target the object center
          * @param {Number} duration : zoom effect duration 700ms by default
          */
        zoom : function(scaleToAdd, globalRequestedPosition, duration){
            
            var smartData = targetElement.data('smartZoomData');
            var globaRequestedX;
            var globaRequestedY;
            if(!globalRequestedPosition){ // use target center if globalRequestedPosition is not set
                var containerRect = getRect(smartData.containerDiv);
                globaRequestedX = containerRect.x + containerRect.width/2;
                globaRequestedY = containerRect.y + containerRect.height/2;
            }else{
                globaRequestedX = globalRequestedPosition.x;
                globaRequestedY = globalRequestedPosition.y;
            }
            
            // stop previous effect before make calculation
            stopAnim(ESmartZoomEvent.ZOOM); 
            
            var targetRect = getTargetRect(true); // the target rectangle in global position
            var originalSize = smartData.originalSize;
            var newScale = (targetRect.width / originalSize.width) + scaleToAdd; // calculate new scale to apply

            // manage scale min, max
            newScale = Math.max(smartData.adjustedPosInfos.scale, newScale); // the scale couldn't be lowest than the initial scale
            newScale = Math.min(smartData.settings.maxScale, newScale); // the scale couldn't be highest than the max setted by user
            
            var newWidth = originalSize.width * newScale; // new size to apply according to new scale
            var newHeight = originalSize.height * newScale;
          
            var positionGlobalXDiff = globaRequestedX - targetRect.x; // the position difference between with the target position
            var positionGlobalYDiff = globaRequestedY - targetRect.y;
            var sizeRatio =  newWidth / targetRect.width;
        
            var newGlobalX = targetRect.x - ((positionGlobalXDiff * sizeRatio) - positionGlobalXDiff); // apply the ratio to positionGlobalDiff and then find the final target point
            var newGlobalY = targetRect.y - ((positionGlobalYDiff * sizeRatio) - positionGlobalYDiff);
            var validPosition = getValidTargetElementPosition(newGlobalX, newGlobalY, newWidth, newHeight); // return a valid position from the calculated position 
        
            if(duration == null) // default effect duration is 700ms
                duration = 700;

            dispatchSmartZoomEvent(ESmartZoomEvent.ZOOM, ESmartZoomEvent.START, false); 
            
            animate(targetElement, validPosition.x, validPosition.y, newWidth, newHeight, duration, function(){ // set the new position and size via the animation function
                smartData.currentWheelDelta = 0; // reset the weelDelta when zoom end
                updateMouseMoveCursor(); // remove "move" cursor when zoom end
                dispatchSmartZoomEvent(ESmartZoomEvent.ZOOM, ESmartZoomEvent.END, false); 
            });
            
        },
         /**
          * pan function accessible via direct call (ex : $('#zoomImage').smartZoom('pan', 5, 0);)
          * @param {Number} xToAdd : a number to add to the object current position in X
          * @param {Point} yToAdd : a number to add to the object current position in Y
          * @param {Number} duration : move effect duration 700ms by default
          */
        pan : function(xToAdd, yToAdd, duration){
            if(xToAdd == null || yToAdd == null) // check params
                return;
                
            if(duration == null) // default pan duration is 700ms
                duration = 700;
            var currentPosition = targetElement.offset();
            
            var targetRect = getTargetRect();
            var validPosition = getValidTargetElementPosition(currentPosition.left+xToAdd, currentPosition.top+yToAdd, targetRect.width, targetRect.height); // add the given numbers to the current coordinates and valid the result
            
            if(validPosition.x != currentPosition.left || validPosition.y != currentPosition.top){
                // stop previous effect before make calculation
                stopAnim(ESmartZoomEvent.PAN);
                dispatchSmartZoomEvent(ESmartZoomEvent.PAN, ESmartZoomEvent.START, false); 
                animate(targetElement, validPosition.x, validPosition.y, targetRect.width, targetRect.height, duration, function(){ // set the new position and size via the animation function
                    dispatchSmartZoomEvent(ESmartZoomEvent.PAN, ESmartZoomEvent.END, false); 
                });
            }
        },
         /**
          * destroy function accessible via direct call (ex : $('#zoomImage').smartZoom('destroy');)
          * use this function to clean and remove smartZoom plugin 
          */
        destroy : function() {
            var smartData = targetElement.data('smartZoomData');
            if(!smartData)
                return;
            stopAnim(); // stop current animation
            var containerDiv = smartData.containerDiv;
            // remove all listenerns 
            targetElement.unbind('mousedown.smartZoom');
            targetElement.unbind('touchstart.smartZoom');
            containerDiv.unbind('mousewheel.smartZoom');
            containerDiv.unbind('dblclick.smartZoom');
            containerDiv.unbind( 'mousewheel.smartZoom DOMMouseScroll.smartZoom');
            $(window).unbind('resize.smartZoom');
            $(document).unbind('mousemove.smartZoom');
            $(document).unbind('mouseup.smartZoom');
            $(document).unbind('touchmove.smartZoom');
            $(document).unbind('touchend.smartZoom');
        
            targetElement.css({"cursor":"default"}); // reset default cursor
            containerDiv.before(targetElement); // move target element to original container 
            animate(targetElement, smartData.originalPosition.left, smartData.originalPosition.top,  smartData.originalSize.width, smartData.originalSize.height, 5); // reset initial position
            targetElement.removeData('smartZoomData');// clean saved data
            containerDiv.remove(); // remove zoom container
            targetElement.attr('style', smartData.initialStyles); // reset initial styles
            targetElement.trigger(ESmartZoomEvent.DESTROYED); // dispatch event after plugin destruction
        },
        /**
         * call this funcion to know if the plugin is used 
         */
        isPluginActive : function(){
            return targetElement.data('smartZoomData') != undefined;
        }
    };

    if (publicMethods[method] ) { // if the parameter is an existing method, then we call this method
        return publicMethods[method].apply( this, Array.prototype.slice.call( arguments, 1 ));
    } else if (typeof method === 'object' || ! method ) { // else if it's an object we initilize the plugin
        if(targetElement[0].tagName.toLowerCase() == "img" && !targetElement[0].complete){ // if the target is an image when wait for image loading before initialization
            targetElement.bind('load.smartZoom',{arguments:arguments[0]},  imgLoadedHandler);
        }else{
            publicMethods.init.apply( targetElement, [arguments[0]]);
        } 
    } else {
        $.error( 'Method ' +  method + ' does not exist on e-smartzoom jquery plugin' );
    }    
    
    /**
     * call zoom function on mouse wheel event
     * @param {Object} e : mouse event
     * @param {Object} delta : wheel direction 1 or -1
     */
    function mouseWheelHandler(e, delta){
        var smartData = targetElement.data('smartZoomData');
        if(smartData.currentWheelDelta*delta < 0) // if current and delta have != sign we set 0 to go to other direction
            smartData.currentWheelDelta = 0;
        smartData.currentWheelDelta += delta; // increment delta zoom faster when the user use wheel again
        publicMethods.zoom(smartData.mouseWheelDeltaFactor*smartData.currentWheelDelta, {"x":e.pageX, "y":e.pageY}); // 0.15
    }
      
    /**
     * prevent page scroll when scrolling on zoomableContainer
     * @param {Object} e : mouse event
     */  
    function containerMouseWheelHander(e){
        e.preventDefault();
    }
    
    /**
     * update mouse cursor (move or default) if the zoom target is draggable 
     */
    function updateMouseMoveCursor(){
        var smartData = targetElement.data('smartZoomData');
        if(smartData.settings.mouseMoveEnabled != true || smartData.settings.moveCursorEnabled != true)
            return;
        var targetRect = getTargetRect();
        var currentScale = (targetRect.width / smartData.originalSize.width);
        if(parseInt(currentScale*100)>parseInt(smartData.adjustedPosInfos.scale*100)) // multiply by 100 to resolve precision problem
            targetElement.css({"cursor":"move"});     
        else    
            targetElement.css({"cursor":"default"});
    }
    
    /**
     * call "zoomOnDblClick" when user double click
     * @param {Object} e : mouse event
     */
    function mouseDblClickHandler(e){
         zoomOnDblClick(e.pageX, e.pageY);
    }
    
    /**
     * save mouse position on mouse down (positions will be used in moveOnMotion function)
     * @param {Object} e : mouse event 
     */
    function mouseDownHandler(e){
        e.preventDefault(); // prevent default browser drag
        $(document).on('mousemove.smartZoom', mouseMoveHandler); // add mouse move and mouseup listeners to enable drag
        $(document).bind('mouseup.smartZoom', mouseUpHandler);
        var smartData = targetElement.data('smartZoomData'); // save mouse position on mouse down
        smartData.moveCurrentPosition = new Point(e.pageX, e.pageY);
        smartData.moveLastPosition =  new Point(e.pageX, e.pageY);
    }
    
    /**
     * call "moveOnMotion" when the mouse move after mouseDown
     * @param {Object} e : mouse event
     */
    function mouseMoveHandler(e){

        var smartData = targetElement.data('smartZoomData');
        if(smartData.mouseMoveForPan || (!smartData.mouseMoveForPan && smartData.moveCurrentPosition.x != e.pageX && smartData.moveCurrentPosition.y != e.pageY)){
            smartData.mouseMoveForPan = true;
            moveOnMotion(e.pageX, e.pageY, 0, false);
        }
    }
    
    /**
     *  stop the drag on mouseup
     * @param {Object} e : mouse event
     */
    function mouseUpHandler(e){
        
        var smartData = targetElement.data('smartZoomData');
        if(smartData.mouseMoveForPan){
            smartData.mouseMoveForPan = false;
            if(smartData.moveLastPosition.distance(smartData.moveCurrentPosition) > 4){ // smooth the drag end when user move the mouse fast
                var interpolateP = smartData.moveLastPosition.interpolate(smartData.moveCurrentPosition, -4);
                moveOnMotion(interpolateP.x, interpolateP.y, 500, true);
            }else{
                moveOnMotion(smartData.moveLastPosition.x, smartData.moveLastPosition.y, 0, true);
            }
        }else if(smartData.settings.zoomOnSimpleClick){
            zoomOnDblClick(e.pageX, e.pageY);
        }
        
        $(document).unbind('mousemove.smartZoom'); // remove listeners when drag is done
        $(document).unbind('mouseup.smartZoom');        
    }
    
    /**
     * save touch position and init vars on touch start (information will be use in touchMoveHandler function and touch end)
     * @param {Object} e : touch event  
     */
    function touchStartHandler(e){
        e.preventDefault(); // prevent default browser drag
        
        $(document).unbind('touchmove.smartZoom'); // unbind if we already listen touch events
        $(document).unbind('touchend.smartZoom');
        
        $(document).bind('touchmove.smartZoom', touchMoveHandler); // listen move and touch end events to manage drag on touch
        $(document).bind('touchend.smartZoom', touchEndHandler);
        
        var touchList = e.originalEvent.touches; // get touch infos from event 
        var firstTouch = touchList[0];
             
        var smartData = targetElement.data('smartZoomData'); 
        smartData.touch.touchMove = false; // will be set to true if the user start drag
        smartData.touch.touchPinch = false; // will be set to true if the user whant to pinch (zoom)
        smartData.moveCurrentPosition = new Point(firstTouch.pageX, firstTouch.pageY); // save the finger position on screen on touch start
        smartData.moveLastPosition = new Point(firstTouch.pageX, firstTouch.pageY);
        smartData.touch.lastTouchPositionArr = new Array(); // save touch position off all fingers to manage pinch
        var currentTouch;
        var nbTouch = touchList.length;
        for(var i = 0;i<nbTouch;++i){
            currentTouch = touchList[i];
            smartData.touch.lastTouchPositionArr.push(new Point(currentTouch.pageX, currentTouch.pageY));
        }
    }
    
    /**
     *  manage pinch or drag when touch move
     * @param {Object} e : touch event
     */
    function touchMoveHandler(e){ 

        e.preventDefault(); // prevent default browser behaviour

        var smartData = targetElement.data('smartZoomData');
        
        var touchListEv = e.originalEvent.touches; // get touch information on event
        var nbTouch = touchListEv.length;
        var currentFirstTouchEv = touchListEv[0];
        
        if(nbTouch == 1 && !smartData.touch.touchPinch && smartData.settings.touchMoveEnabled == true){ // if the user use only one finger and touchPinch==false => we manage drag
            if(!smartData.touch.touchMove){ 
                var downLastPoint = smartData.touch.lastTouchPositionArr[0];
                if(downLastPoint.distance(new Point(currentFirstTouchEv.pageX, currentFirstTouchEv.pageY))<3){ // check if user really had moved
                    return;
                }
                else
                    smartData.touch.touchMove = true;
            }
            moveOnMotion(currentFirstTouchEv.pageX, currentFirstTouchEv.pageY, 0, false);
        }else if(nbTouch == 2 && !smartData.touch.touchMove && smartData.settings.pinchEnabled == true){ // if the user use two fingers and touchMove==false => we manage pinch 
            smartData.touch.touchPinch = true;
            
            var currentSecondTouchEv = touchListEv[1]; // get current fingers position and last fingers positions
            var lastP1 = smartData.touch.lastTouchPositionArr[0];
            var lastP2 = smartData.touch.lastTouchPositionArr[1];
            var currentP1 = new Point(currentFirstTouchEv.pageX, currentFirstTouchEv.pageY);
            var currentP2 = new Point(currentSecondTouchEv.pageX, currentSecondTouchEv.pageY);
            
            var currentP1P2Distance = currentP1.distance(currentP2); // distance between current two fingers positions
            var lastP1P2Distance = lastP1.distance(lastP2); // distance between the last two fingers positions registered 
            var currentDistance = currentP1P2Distance - lastP1P2Distance; // distance between last move and current move
            
            if(Math.abs(currentDistance)<3) // finger pixel error (jump between in and out mode sometimes if i don't do this check)  
                return;
            
            var middle =  new Point((currentP1.x + currentP2.x) /2, (currentP1.y + currentP2.y) /2); // get the point between the two fingers
            var targetRect = getTargetRect(); // the current plugin target size
            var originSize = smartData.originalSize; // original plugin target size
            var currentScale = (targetRect.width / originSize.width); // current scale base on original size
            var newZoomValueToAdd = currentP1P2Distance/lastP1P2Distance; // scale between current distance and last fingers distance
            var newZoomScale = ((targetRect.width * newZoomValueToAdd) / originSize.width); // the new zoom scale
            
            publicMethods.zoom(newZoomScale - currentScale, middle, 0); // call zoom fonction with the scale to add (newZoomScale - currentScale)
            
            smartData.touch.lastTouchPositionArr[0] = currentP1; //update last touch position points for next function iteration 
            smartData.touch.lastTouchPositionArr[1] = currentP2;
        }
    }
    
    /**
     * manage touch move end or double tap at touch end
     * @param {Object} e : touch event
     */
    function touchEndHandler(e){
        e.preventDefault(); // prevent default browser behaviour
        
        var nbTouchAtEnd = e.originalEvent.touches.length;
        if(nbTouchAtEnd == 0){ // unbind listeners if the user take off all his fingers
            $(document).unbind('touchmove.smartZoom');
            $(document).unbind('touchend.smartZoom');
        }
        var smartData = targetElement.data('smartZoomData');
        
        if(smartData.touch.touchPinch) // nothing to do for pinch behaviour in this function
            return;
            
        if(smartData.touch.touchMove){ // smooth motion at end if we are in drag mode
            if(smartData.moveLastPosition.distance(smartData.moveCurrentPosition) > 2){ // smooth only if the user drag fast
                var interpolateP = smartData.moveLastPosition.interpolate(smartData.moveCurrentPosition, -4); // the end smooth motion is calculate according to last finger motion 
                moveOnMotion(interpolateP.x, interpolateP.y, 500, true);
            }
        }else{
            if(smartData.settings.dblTapEnabled == true && smartData.touch.lastTouchEndTime != 0 && new Date().getTime() - smartData.touch.lastTouchEndTime < 400){ // if the user double tap (double tap if there is less than 300 ms between first and second tap)
                var lastStartPos = smartData.touch.lastTouchPositionArr[0];
                zoomOnDblClick(lastStartPos.x, lastStartPos.y);  
            }
            smartData.touch.lastTouchEndTime = new Date().getTime();
        }
    }
    
    /**
     *  manage plugin target move after mouse or finger motion
     * @param {Number} xPos : new x position to set
     * @param {Number} yPos : new y position to set 
     * @param {Number} duration : move effect duration
     */
    function moveOnMotion(xPos, yPos, duration, motionEnd){
        stopAnim(ESmartZoomEvent.PAN);// stop previous effect before make calculation
        
        var smartData = targetElement.data('smartZoomData');
        smartData.moveLastPosition.x = smartData.moveCurrentPosition.x; // save the current position in "moveLastPosition" before moving the plugin target
        smartData.moveLastPosition.y = smartData.moveCurrentPosition.y; // (moveLastPosition will be use to smooth last motion in "touchEndHandler" and "mouseUpHandler")
        
        var currentPosition = targetElement.offset(); // the target current position
        var targetRect = getTargetRect(); // current target size
        
        var newMarginLeft = currentPosition.left + (xPos - smartData.moveCurrentPosition.x); // add current mouseX (orTouchX) position difference to the target position
        var newMarginTop = currentPosition.top + (yPos - smartData.moveCurrentPosition.y);
        
        var validPosition = getValidTargetElementPosition(newMarginLeft, newMarginTop, targetRect.width, targetRect.height); // check if the new position is valid
        
        dispatchSmartZoomEvent(ESmartZoomEvent.PAN, ESmartZoomEvent.START, false); 

        animate(targetElement, validPosition.x, validPosition.y, targetRect.width, targetRect.height, duration, motionEnd == true ? function(){
            dispatchSmartZoomEvent(ESmartZoomEvent.PAN, ESmartZoomEvent.END, false); 
        }: null); // move to the right position
        
        smartData.moveCurrentPosition.x = xPos; // save the new position
        smartData.moveCurrentPosition.y = yPos;
    }
    
    /**
     * manage zoom when user double click or double tap 
     * @param {Number} pageX : double click (or tap) x position in page
     * @param {Number} pageY : double click (or tap) y position in page
     */
    function zoomOnDblClick(pageX, pageY){
        var smartData = targetElement.data('smartZoomData');
        var originalSize = smartData.originalSize; // original target size
        var targetRect = getTargetRect(); // current target size
        var currentScale = (targetRect.width / originalSize.width); // the current target scale
        var originalScale = smartData.adjustedPosInfos.scale; // original scale
        var dblClickMaxScale = parseFloat(smartData.settings.dblClickMaxScale); // the doucble click or double tap max scale
        
        var scaleDiff; // if the current scale is close from "dblClickMaxScale" go to "originalScale" else go to "dblClickMaxScale" 
        if(currentScale.toFixed(2)>dblClickMaxScale.toFixed(2) || Math.abs(dblClickMaxScale - currentScale)>Math.abs(currentScale-originalScale)){
            scaleDiff = dblClickMaxScale - currentScale;
        }else{
            scaleDiff = originalScale - currentScale;
        }

        publicMethods.zoom(scaleDiff, {"x":pageX, "y":pageY});   
    }
    
    /**
     * stop the animation
     */
    function stopAnim(userActionType){

        var smartData = targetElement.data('smartZoomData');
        if(smartData.transitionObject){ // if css transformation is surpported
            if(smartData.transitionObject.cssAnimHandler) // stop the transformation end handler if it exists
              targetElement.off($.support.transition, smartData.transitionObject.cssAnimTimer); 
            var originalSize = smartData.originalSize; // get the original target size              
            var targetRect = getTargetRect(); // the target current size
        
            var cssObject = new Object(); // set the current current target size and the target scale to css transformation so it stop previous transformation
            cssObject[smartData.transitionObject.transition] = 'all 0s'; // apply transformation now
            if(smartData.transitionObject.css3dSupported){
                cssObject[smartData.transitionObject.transform] = 'translate3d('+targetRect.x+'px, '+targetRect.y+'px, 0) scale3d('+targetRect.width/originalSize.width+','+targetRect.height/originalSize.height+', 1)';
            }else{
                cssObject[smartData.transitionObject.transform] = 'translateX('+targetRect.x+'px) translateY('+targetRect.y+'px) scale('+targetRect.width/originalSize.width+','+targetRect.height/originalSize.height+')';
            }
            targetElement.css(cssObject);   
                
        }else{
            targetElement.stop(); // if we use a jquery transformation, just call stop function
        }
        updateMouseMoveCursor(); // update mouse move cursor after animation stop (set the cross cursor or not)

        if(userActionType != null)
            dispatchSmartZoomEvent(userActionType, '', true); 
    }
    
    /**
     * manage position validation
     * @param {Number} marginLeft : global x position
     * @param {Number} marginTop : global y position
     * @param {Number} width : element width
     * @param {Number} height : element height
     */
    function getValidTargetElementPosition(xPosition, yPosition, width, height){
        var smartData = targetElement.data('smartZoomData');
         // adjusting if the content is out of the initial content box from "adjustedPosInfos"
        var newMarginTop = Math.min(smartData.adjustedPosInfos.top, yPosition); // adjust in top 
        newMarginTop += Math.max(0, (smartData.adjustedPosInfos.top + smartData.adjustedPosInfos.height) - (newMarginTop + height)) // adjust in bottom
        var newMarginLeft = Math.min(smartData.adjustedPosInfos.left, xPosition); // adjust in left
        newMarginLeft += Math.max(0, (smartData.adjustedPosInfos.left + smartData.adjustedPosInfos.width) - (newMarginLeft + width)); // adjust in right
        return new Point(newMarginLeft.toFixed(2), newMarginTop.toFixed(2));
    }
    
    /**
     * when the plugin target is an image we wait for image loading before initilization 
     * @param {Object} e : load event
     */
    function imgLoadedHandler(e){
        targetElement.unbind('load.smartZoom');
        publicMethods.init.apply( targetElement, [e.data.arguments]); 
    }
    
    /**
     * this function fit the plugin target to the zoom container at initialization and when the window is resized
     */    
    function adjustToContainer(){
        
        var smartData = targetElement.data('smartZoomData');
        var containerDiv = smartData.containerDiv; // the zoom container 
        var originalSize = smartData.originalSize; // target original size
        
        // get the zoomable container position from settings
        var parentOffset = containerDiv.parent().offset(); 
        var containerDivNewLeft = getContainerDivPositionFromSettings(smartData.settings.left, parentOffset.left, containerDiv.parent().width());
        var containerDivNewTop = getContainerDivPositionFromSettings(smartData.settings.top, parentOffset.top, containerDiv.parent().height());
        
        containerDiv.offset({left: containerDivNewLeft, top: containerDivNewTop}); // apply position find
        containerDiv.width(getContainerDivSizeFromSettings(smartData.settings.width, containerDiv.parent().width(), containerDivNewLeft - parentOffset.left)); // apply size found to zoomablecontainer 
        containerDiv.height(getContainerDivSizeFromSettings(smartData.settings.height, containerDiv.parent().height(), containerDivNewTop - parentOffset.top));
        
        var containerRect = getRect(containerDiv); // get the rectangle from the new containerDiv position and size
        var scaleToFit = Math.min(Math.min(containerRect.width/originalSize.width, containerRect.height/originalSize.height), 1).toFixed(2); // scale to use to include the target into containerRect
        var newWidth = originalSize.width * scaleToFit; // we could now find the new size
        var newHeight = originalSize.height * scaleToFit;
      
        // store the position and size information in adjustedPosInfos object
        smartData.adjustedPosInfos = {"left":(containerRect.width - newWidth)/2 + parentOffset.left, "top": (containerRect.height - newHeight)/2 + parentOffset.top, "width": newWidth, "height" : newHeight, "scale":scaleToFit};
        stopAnim();
        // call animate method with 10 ms duration to apply new target position and size
        animate(targetElement,  smartData.adjustedPosInfos.left , smartData.adjustedPosInfos.top, newWidth, newHeight, 0, function() {
            targetElement.css('visibility','visible'); // set target visibility to visible if developper whant to hide it before the plugin resize
        });
        updateMouseMoveCursor(); 
    }
    
    /**
     * animate the plugin target  
     * @param {Object} target : the element to animate
     * @param {Number} globalLeft : the global x target position 
     * @param {Number} globalTop : the global y target position 
     * @param {Number} width : targeted width
     * @param {Number} width : targeted height
     * @param {Number} duration : effect duration
     * @param {Function} callback : function to call when effect end
     * 
     */
    function animate(target, globalLeft, globalTop, width, height, duration, callback){
        
        var smartData = targetElement.data('smartZoomData');
        var parentOffset = smartData.containerDiv.offset();
        var left = globalLeft - parentOffset.left; // get the relative position from parent 
        var top = globalTop - parentOffset.top;
        
        if (smartData.transitionObject != null) { // use css transition if supported
            var originalSize = smartData.originalSize;
            var cssObject = new Object();
            cssObject[smartData.transitionObject.transform+'-origin'] = '0 0';
            cssObject[smartData.transitionObject.transition] = 'all '+duration / 1000+'s ease-out'; // set effect duration
            
            if(smartData.transitionObject.css3dSupported) // use css 3d translate if supported
                cssObject[smartData.transitionObject.transform] = 'translate3d('+left+'px, '+top+'px, 0) scale3d('+width/originalSize.width+','+height/originalSize.height+', 1)';
            else
                cssObject[smartData.transitionObject.transform] = 'translateX('+left+'px) translateY('+top+'px) scale('+width/originalSize.width+','+height/originalSize.height+')';
            if(callback != null){
                smartData.transitionObject.cssAnimHandler = callback;
          target.one($.support.transition.end, smartData.transitionObject.cssAnimHandler);
        }
            target.css(cssObject); // apply css transformation
        }else{ // use JQuery animate if css transition is not supported
            
            target.animate({"margin-left": left, "margin-top": top, "width": width, "height" : height}, {duration:duration, easing:smartData.settings.easing, complete:function() {
                if(callback != null)
                    callback();
            }});
        }
    }
    
    /**
     * get the plugin target rectangle on screen 
     * @param {Boolean} globalPosition : if true return global position else return relative position
     * @return {Object} {'x':'x Position', 'y':'y Position', 'width':' element width', 'height': 'element height'}
     */     
    function getTargetRect(globalPosition){
        var smartData = targetElement.data('smartZoomData');
        var width = targetElement.width(); // get the current object size
        var height = targetElement.height();
        var position = targetElement.offset(); // global position
        var x = parseInt(position.left); // save global position in vars
        var y = parseInt(position.top);
        
        var parentOffset = smartData.containerDiv.offset(); // get zoomable container global position
        
        if(globalPosition != true){ // set local position
            x = parseInt(x) - parentOffset.left;            
            y = parseInt(y) - parentOffset.top;  
        }
        
        if (smartData.transitionObject != null) { // if CSS3 transition is enabled
            var transformMatrix = targetElement.css(smartData.transitionObject.transform);
            if(transformMatrix && transformMatrix != "" && transformMatrix.search('matrix') != -1){ // get the target css matrix tranform 
                var scale;
                var arrValues;
                if(transformMatrix.search('matrix3d') != -1){ // check the matrix type
                    arrValues = transformMatrix.replace('matrix3d(','').replace(')','').split(',');
                    scale = arrValues[0]; // get target current scale
                }else{
                    arrValues = transformMatrix.replace('matrix(','').replace(')','').split(',');
                    scale = arrValues[3];// get target current scale
                    x = parseFloat(arrValues[4]);// get target current position
                    y = parseFloat(arrValues[5]);
                    if(globalPosition){ // adjust for global
                        x = parseFloat(x) + parentOffset.left;          
                        y = parseFloat(y) + parentOffset.top;
                    }
                }
                width = scale * width; // find the actual object size thanks to current scale
                height = scale * height;
            }
        }
        return {'x' : x,'y' : y, 'width' : width, 'height' : height};
    }

    /**
     * dispatch zoom or pan event 
     * @param {Boolean} fromZoom : set to true if the function is call from zoom action
     * 
     **/
    function dispatchSmartZoomEvent(actionType, actionStep, stop){
        var smartData = targetElement.data('smartZoomData');
        var eventTypeToDispatch = '';

        if(stop == true && smartData.currentActionType != actionType){ // if the action type has changed and that the function is called from "stopAnim" dispatch END event
            eventTypeToDispatch = smartData.currentActionType+'_'+ESmartZoomEvent.END;
            smartData.currentActionType = '';
            smartData.currentActionStep = '';
        }else{ 
            if(smartData.currentActionType != actionType || smartData.currentActionStep == ESmartZoomEvent.END){ // if the current action had changed (MOVE to ZOOM for exemple) and the last action step was END we whant to dispatch START
                smartData.currentActionType = actionType;
                smartData.currentActionStep = ESmartZoomEvent.START;
                eventTypeToDispatch = smartData.currentActionType+'_'+smartData.currentActionStep;
            }else if(smartData.currentActionType == actionType && actionStep == ESmartZoomEvent.END){ // dispatch END if actionstep ask is END and action type don't change
                smartData.currentActionStep = ESmartZoomEvent.END;
                eventTypeToDispatch = smartData.currentActionType+'_'+smartData.currentActionStep;
                smartData.currentActionType = '';
                smartData.currentActionStep = '';
            }
        }

        if(eventTypeToDispatch != ''){ // dispatch event if we have to
            var ev = jQuery.Event(eventTypeToDispatch);
            ev.targetRect = getTargetRect(true);
            ev.scale = ev.targetRect.width / smartData.originalSize.width;
      //console.log(targetElement, eventTypeToDispatch);
            targetElement.trigger(ev);
        }
    }

    /**
     * return an object that contains the kind of CSS3 supported transition
     *  @return {Object} {'transition':'-webkit-transition', 'transform':'-webkit-transform', 'css3dSupported':'true'}
     */  
    function getBrowserTransitionObject(){
        
       var pageBody = document.body || document.documentElement;
       var bodyStyle = pageBody.style;
       
       var transitionTestArr = ['transition', 'WebkitTransition', 'MozTransition', 'MsTransition', 'OTransition']; // all type all transitions to test
       var transitionArr = ['transition', '-webkit-transition', '-moz-transition', '-ms-transition', '-o-transition'];
       var transformArr = ['transform', '-webkit-transform', '-moz-transform', '-ms-transform', '-o-transform'];
        
       var length = transitionTestArr.length;
       var transformObject;
       for(var i=0; i<length; i++){ // for all kind of css transition we make a test
            if(bodyStyle[transitionTestArr[i]] != null){
                transformStr = transformArr[i];
                var div = $('<div style="position:absolute;">Translate3d Test</div>');
                $('body').append(div); // try a transformation on a new div each time
                transformObject = new Object();
                transformObject[transformArr[i]] = "translate3d(20px,0,0)";
                div.css(transformObject);
                css3dSupported = ((div.offset().left - $('body').offset().left) == 20); // if translate3d(20px,0,0) via transformArr[i] == 20px the transformation is valid for this browser
                div.empty().remove();
                if(css3dSupported){ // return the kind of transformation supported
                    return {transition:transitionArr[i], transform:transformArr[i], css3dSupported:css3dSupported};
                }               
            }
       }
       return null; 
    }
    
    /**
     * get the plugin target rectangle on screen 
     * @param {Object} settingsValue : a number or a string value given in plugin params
     * @param {Number} zoomableContainerParentValue : zoomable container parent width or height
     * @param {Number} divPosDiff : zoomable container parent and zoomable container position difference
     * @return {Number} return the zoomable container size (in pixel) from setting value (pixel or percent)
     */  
    function getContainerDivSizeFromSettings(settingsValue, zoomableContainerParentValue, divPosDiff){
        if(settingsValue.search && settingsValue.search("%") != -1)
            return (zoomableContainerParentValue - divPosDiff)* (parseInt(settingsValue)/100);
        else
            return parseInt(settingsValue);
    }
    
     /**
     * get the plugin target rectangle on screen 
     * @param {Object} settingsValue : a number or a string value given in plugin params
     * @param {Number} zoomableContainerParentPosValue : zoomable container parent global x  or y
     * @param {Number} zoomableContainerParentSizeValue : zoomable container parent width or height
     * @return {Number} return the zoomable container position (in pixel) from setting value (pixel or percent) 
     */  
    function getContainerDivPositionFromSettings(settingsValue, zoomableContainerParentPosValue, zoomableContainerParentSizeValue){
        if(settingsValue.search && settingsValue.search("%") != -1)
            return zoomableContainerParentPosValue + zoomableContainerParentSizeValue * (parseInt(settingsValue)/100);
        else
            return zoomableContainerParentPosValue + parseInt(settingsValue);
    }
    
    /**
     * reinit the component when the user resize the window 
     */
    function windowResizeEventHandler(){
        adjustToContainer();
    }

    /**
     * return a retangle from a JQuery object 
     * @param {Object} jqObject : a JQuery object like $('#myObject')
     * @return {Object} return {'x':objectX, 'y':objectY, 'width':objectWidth, 'height':objectHeight} 
     */  
    function getRect(jqObject) {
        var offset = jqObject.offset();
        if(!offset)
            return null;
        var formX = offset.left;
        var formY = offset.top; 
        return {'x':formX, 'y':formY, 'width':jqObject.outerWidth(), 'height':jqObject.outerHeight()};
    }
     
    /**
     * Point Class
     * @param {Number} x : point position on X axis
     * @param {Number} y : point position on Y axis
     */
    function Point(x, y) {
        this.x = x;
        this.y = y;
         /**
         * return point informations into a string
         * @return {String} return (x=5, y=5) 
         */
        this.toString = function() {
            return '(x=' + this.x + ', y=' + this.y + ')';
        };
        /**
         * return a new point who is the interpolation of this and the given point 
         * the new point position is calculate thanks to percentInterpolate (the distance between this and pointToInterpolate in percent)
         * @return {Point} return {'x':interpolateX, 'y':interpolateY}  
         */
        this.interpolate = function(pointToInterpolate, percentInterpolate) {
            var x = percentInterpolate * this.x + (1 - percentInterpolate) * pointToInterpolate.x;
            var y = percentInterpolate * this.y + (1 - percentInterpolate) * pointToInterpolate.y;
            return new Point(x, y);
        };
        /**
         * return the distance between "this" point and the given point  
         * @return {Number} distance between this and "point"    
         */
        this.distance = function(point) {
            return Math.sqrt(Math.pow((point.y - this.y) ,2) + Math.pow((point.x - this.x),2));
        } 
    }


  };
})( jQuery );

/*
 * add smartZoomEasing and smartZoomOutQuad to jQuery easing function 
 */
(function($){
    $.extend($.easing,
    {
        smartZoomEasing: function (x, t, b, c, d) {
            return $.easing['smartZoomOutQuad'](x, t, b, c, d);
        },
        smartZoomOutQuad: function (x, t, b, c, d) {
            return -c *(t/=d)*(t-2) + b;
        }
    });
})(jQuery);

/*! Copyright (c) 2011 Brandon Aaron (http://brandonaaron.net)
 * Licensed under the MIT License (LICENSE.txt).
 *
 * Thanks to: http://adomas.org/javascript-mouse-wheel/ for some pointers.
 * Thanks to: Mathias Bank(http://www.mathias-bank.de) for a scope bug fix.
 * Thanks to: Seamus Leahy for adding deltaX and deltaY
 *
 * Version: 3.0.6
 * 
 * Requires: 1.2.2+
 */
(function(e){function r(t){var n=t||window.event,r=[].slice.call(arguments,1),i=0,s=true,o=0,u=0;t=e.event.fix(n);t.type="mousewheel";if(n.wheelDelta){i=n.wheelDelta/120}if(n.detail){i=-n.detail/3}u=i;if(n.axis!==undefined&&n.axis===n.HORIZONTAL_AXIS){u=0;o=-1*i}if(n.wheelDeltaY!==undefined){u=n.wheelDeltaY/120}if(n.wheelDeltaX!==undefined){o=-1*n.wheelDeltaX/120}r.unshift(t,i,o,u);return(e.event.dispatch||e.event.handle).apply(this,r)}var t=["DOMMouseScroll","mousewheel"];if(e.event.fixHooks){for(var n=t.length;n;){e.event.fixHooks[t[--n]]=e.event.mouseHooks}}e.event.special.mousewheel={setup:function(){if(this.addEventListener){for(var e=t.length;e;){this.addEventListener(t[--e],r,false)}}else{this.onmousewheel=r}},teardown:function(){if(this.removeEventListener){for(var e=t.length;e;){this.removeEventListener(t[--e],r,false)}}else{this.onmousewheel=null}}};e.fn.extend({mousewheel:function(e){return e?this.bind("mousewheel",e):this.trigger("mousewheel")},unmousewheel:function(e){return this.unbind("mousewheel",e)}})})(jQuery)

// CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
// ============================================================

function transitionEnd() {
  var el = document.createElement('bootstrap');

  var transEndEventNames = {
    'WebkitTransition' : 'webkitTransitionEnd',
    'MozTransition'    : 'transitionend',
    'OTransition'      : 'oTransitionEnd otransitionend',
    'transition'       : 'transitionend'
  };

  for (var name in transEndEventNames) {
    if (el.style[name] !== undefined) {
      return { end: transEndEventNames[name] };
    }
  }

  return false; // explicit for ie8 (  ._.)
}

// http://blog.alexmaccaw.com/css-transitions
$.fn.emulateTransitionEnd = function (duration) {
  var called = false, $el = this;
  $(this).one($.support.transition.end, function () { called = true; })
  var callback = function () { if (!called) $($el).trigger($.support.transition.end); }
  setTimeout(callback, duration);
  return this;
};

$(function () {
  $.support.transition = transitionEnd();
});


/*!
 * Lightweight URL manipulation with JavaScript
 * This library is independent of any other libraries and has pretty simple
 * interface and lightweight code-base.
 * Some ideas of query string parsing had been taken from Jan Wolter
 * @see http://unixpapa.com/js/querystring.html
 *
 * @license MIT
 * @author Mykhailo Stadnyk <mikhus@gmail.com>
 */
(function (ns) {
    'use strict';

    // mapping between what we want and <a> element properties
    var map = {
        protocol: 'protocol',
        host: 'hostname',
        port: 'port',
        path: 'pathname',
        query: 'search',
        hash: 'hash'
    };

    // jscs: disable
    /**
     * default ports as defined by http://url.spec.whatwg.org/#default-port
     * We need them to fix IE behavior, @see https://github.com/Mikhus/jsurl/issues/2
     */
    // jscs: enable
    var defaultPorts = {
        ftp: 21,
        gopher: 70,
        http: 80,
        https: 443,
        ws: 80,
        wss: 443
    };

    function parse (self, url) {
        var currUrl, link, i, auth;

        if (typeof document === 'undefined' && typeof require === 'function') {
            currUrl = 'file://' +
                (process.platform.match(/^win/i) ? '/' : '') +
                require('fs').realpathSync('.');

            if (url && url.charAt(0) !== '/' && !url.match(/^\w+:\/\//)) {
                url = currUrl + require('path').sep + url;
            }

            link = require('url').parse(url || currUrl);
        }

        else {
            currUrl = document.location.href;
            link = document.createElement('a');
            link.href = url || currUrl;
        }

        auth = (url || currUrl).match(/\/\/(.*?)(?::(.*?))?@/) || [];

        for (i in map) {
            self[i] = link[map[i]] || '';
        }

        // fix-up some parts
        self.protocol = self.protocol.replace(/:$/, '');
        self.query = self.query.replace(/^\?/, '');
        self.hash = decode(self.hash.replace(/^#/, ''));
        self.user = decode(auth[1] || '');
        self.pass = decode(auth[2] || '');
        self.port = (
            defaultPorts[self.protocol] === self.port || self.port === 0
        ) ? '' : self.port; // IE fix, Android browser fix

        if (!self.protocol && !/^([a-z]+:)?\/\/\/?/.test(url)) {
            // is IE and path is relative
            var base = new Url(currUrl.match(/(.*\/)/)[0]);
            var basePath = base.path.split('/');
            var selfPath = self.path.split('/');
            var props = ['protocol', 'user', 'pass', 'host', 'port'];
            var s = props.length;

            basePath.pop();

            for (i = 0; i < s; i++) {
                self[props[i]] = base[props[i]];
            }

            while (selfPath[0] == '..') { // skip all "../
                basePath.pop();
                selfPath.shift();
            }

            self.path =
                (url.charAt(0) != '/' ? basePath.join('/') : '') +
                '/' + selfPath.join('/')
            ;
        }

        else {
            // fix absolute URL's path in IE
            self.path = self.path.replace(/^\/?/, '/');
        }

        self.paths((self.path.charAt(0) == '/' ?
            self.path.slice(1) : self.path).split('/')
        );

        self.query = new QueryString(self.query);
    }

    function encode (s) {
        return encodeURIComponent(s).replace(/'/g, '%27');
    }

    function decode (s) {
        s = s.replace(/\+/g, ' ');

        s = s.replace(/%([ef][0-9a-f])%([89ab][0-9a-f])%([89ab][0-9a-f])/gi,
            function (code, hex1, hex2, hex3) {
                var n1 = parseInt(hex1, 16) - 0xE0;
                var n2 = parseInt(hex2, 16) - 0x80;

                if (n1 === 0 && n2 < 32) {
                    return code;
                }

                var n3 = parseInt(hex3, 16) - 0x80;
                var n = (n1 << 12) + (n2 << 6) + n3;

                if (n > 0xFFFF) {
                    return code;
                }

                return String.fromCharCode(n);
            }
        );

        s = s.replace(/%([cd][0-9a-f])%([89ab][0-9a-f])/gi,
            function (code, hex1, hex2) {
                var n1 = parseInt(hex1, 16) - 0xC0;

                if (n1 < 2) {
                    return code;
                }

                var n2 = parseInt(hex2, 16) - 0x80;

                return String.fromCharCode((n1 << 6) + n2);
            }
        );

        return s.replace(/%([0-7][0-9a-f])/gi,
            function (code, hex) {
                return String.fromCharCode(parseInt(hex, 16));
            }
        );
    }

    /**
     * Class QueryString
     *
     * @param {string} qs - string representation of QueryString
     * @constructor
     */
    function QueryString (qs) {
        var re = /([^=&]+)(=([^&]*))?/g;
        var match;

        while ((match = re.exec(qs))) {
            var key = decodeURIComponent(match[1].replace(/\+/g, ' '));
            var value = match[3] ? decode(match[3]) : '';

            if (!(this[key] === undefined || this[key] === null)) {
                if (!(this[key] instanceof Array)) {
                    this[key] = [this[key]];
                }

                this[key].push(value);
            }

            else {
                this[key] = value;
            }
        }
    }

    /**
     * Converts QueryString object back to string representation
     *
     * @returns {string}
     */
    QueryString.prototype.toString = function () {
        var s = '';
        var e = encode;
        var i, ii;

        for (i in this) {
            if (this[i] instanceof Function || this[i] === null) {
                continue;
            }

            if (this[i] instanceof Array) {
                var len = this[i].length;

                if (len) {
                    for (ii = 0; ii < len; ii++) {
                        s += s ? '&' : '';
                        s += e(i) + '=' + e(this[i][ii]);
                    }
                }

                else {
                    // parameter is an empty array, so treat as
                    // an empty argument
                    s += (s ? '&' : '') + e(i) + '=';
                }
            }

            else {
                s += s ? '&' : '';
                s += e(i) + '=' + e(this[i]);
            }
        }

        return s;
    };

    /**
     * Class Url
     *
     * @param {string} [url] - string URL representation
     * @constructor
     */
    function Url (url) {
        parse(this, url);
    }

    /**
     * Clears QueryString, making it contain no params at all
     *
     * @returns {Url}
     */
    Url.prototype.clearQuery = function () {
        for (var key in this.query) {
            if (!(this.query[key] instanceof Function)) {
                delete this.query[key];
            }
        }

        return this;
    };

    /**
     * Returns total number of parameters in QueryString
     *
     * @returns {number}
     */
    Url.prototype.queryLength = function () {
        var count = 0;
        var key;

        for (key in this) {
            if (!(this[key] instanceof Function)) {
                count++;
            }
        }

        return count;
    };

    /**
     * Returns true if QueryString contains no parameters, false otherwise
     *
     * @returns {boolean}
     */
    Url.prototype.isEmptyQuery = function () {
        return this.queryLength() === 0;
    };

    /**
     *
     * @param {Array} [paths] - an array pf path parts (if given will modify
     *                          Url.path property
     * @returns {Array} - an array representation of the Url.path property
     */
    Url.prototype.paths = function (paths) {
        var prefix = '';
        var i = 0;
        var s;

        if (paths && paths.length && paths + '' !== paths) {
            if (this.isAbsolute()) {
                prefix = '/';
            }

            for (s = paths.length; i < s; i++) {
                paths[i] = !i && paths[i].match(/^\w:$/) ? paths[i] :
                    encode(paths[i]);
            }

            this.path = prefix + paths.join('/');
        }

        paths = (this.path.charAt(0) === '/' ?
            this.path.slice(1) : this.path).split('/');

        for (i = 0, s = paths.length; i < s; i++) {
            paths[i] = decode(paths[i]);
        }

        return paths;
    };

    /**
     * Performs URL-specific encoding of the given string
     *
     * @method Url#encode
     * @param {string} s - string to encode
     * @returns {string}
     */
    Url.prototype.encode = encode;

    /**
     * Performs URL-specific decoding of the given encoded string
     *
     * @method Url#decode
     * @param {string} s - string to decode
     * @returns {string}
     */
    Url.prototype.decode = decode;

    /**
     * Checks if current URL is an absolute resource locator (globally absolute
     * or absolute path to current server)
     *
     * @returns {boolean}
     */
    Url.prototype.isAbsolute = function () {
        return this.protocol || this.path.charAt(0) === '/';
    };

    /**
     * Returns string representation of current Url object
     *
     * @returns {string}
     */
    Url.prototype.toString = function () {
        return (
            (this.protocol && (this.protocol + '://')) +
            (this.user && (
            encode(this.user) + (this.pass && (':' + encode(this.pass))
            ) + '@')) +
            (this.host && this.host) +
            (this.port && (':' + this.port)) +
            (this.path && this.path) +
            (this.query.toString() && ('?' + this.query)) +
            (this.hash && ('#' + encode(this.hash)))
        );
    };

    ns[ns.exports ? 'exports' : 'Url'] = Url;
}(typeof module !== 'undefined' && module.exports ? module : window));

!function(root, factory) {
    "function" == typeof define && define.amd ? // AMD. Register as an anonymous module unless amdModuleId is set
        define([], function() {
            return root.svg4everybody = factory();
        }) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
                var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""),
                    cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                    xhr._embeds.splice(0).map(function(item) {
                        // get the cached target
                        var target = xhr._cachedTarget[item.id];
                        // ensure the cached target
                        target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)),
                            // embed the target into the svg
                            embed(item.parent, item.svg, target);
                    });
            }
        }, // test the ready state change immediately
            xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
                var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)),
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(),
                                    xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                    xhr._embeds.push({
                                        parent: parent,
                                        svg: svg,
                                        id: id
                                    }), // prepare the xhr ready state change event
                                    loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});
var ZPG = {}; // global Object cointainer



// Test browser support for various features
ZPG.support = {

    // Test browser support for localStorage
    localStorage: function() {
        try {
            if ( 'localStorage' in window && window['localStorage'] !== null ) {

                // Safari Private browsing shows support for localStorage
                // but throws and exception when try to use it because
                // it doesn't support it. Have added addional check to
                // try to use localStorage if it is available 
                var testKey = '_testLocalStorage_', 
                    storage = window.localStorage;

                try {
                    storage.setItem(testKey, '1');
                    storage.removeItem(testKey);
                    return true;
                } catch (error) {
                    return false;
                }
            }
        } catch(e) {
            return false;
        }
    },

    // Test browser support for localStorage
    sessionStorage: function() {
        try {
            if ( 'localStorage' in window && window['localStorage'] !== null ) {

                // Safari Private browsing shows support for sessionStorage
                // but throws and exception when try to use it because
                // it doesn't support it. Have added addional check to
                // try to use sessionStorage if it is available 
                var testKey = '_testSessionStorage_', 
                    session = window.sessionStorage;

                try {
                    session.setItem(testKey, '1');
                    session.removeItem(testKey);
                    return true;
                } catch (error) {
                    return false;
                }
            }
        } catch(e) {
            return false;
        }
    }

}

ZPG.user_signin_register = {

    init: function() {

        ZUS = ZPG.user_signin_register;

        $(document).on('change', '#register_heard_about_us', function(){

            ZUS.heard( $(this) );

        });

        $(document).on('keyup', '#register_username', function() {

            ZUS.username($(this));

        });

    },

    tabs: function($this) {

        var selectedClass = 'ui-tabs-active',
            tabsHideClass = 'ui-tabs-hide',
            tabType = $this.attr('data-tab'),
            otherTabType;

        if ( tabType === 'signin' ) {
            otherTabType = 'register';
        } else {
            otherTabType = 'signin';
        }

        // Deselect previous tab
        $this.closest('.ui-tabs').find('.' + selectedClass).removeClass(selectedClass);

        // Select new tab
        $this.parent().addClass('ui-tabs-active');

        $('#signin_register_section_' + otherTabType).addClass(tabsHideClass);
        $('#signin_register_section_' + tabType).removeClass(tabsHideClass);

        // Shift focus to email field
        $('#' + tabType + '_email').focus();

    },

    heard: function( $this ) {

        // If 'other' selected, show a new text field
        var $howOther = $('#register_how_other');

        if ( $this.attr('value') == 'other' ) {
            $howOther.fadeIn('slow');
        } else {
            $howOther.fadeOut('slow');
        }

    },

    username: function($this) {

        // Variables
        var currentUserNameRequest,
            username = $this.val(),
            $usernameAvailability = $('#username_availability'),
            $usernameAvailabilityMessage = $('#username_availability_message'),
            url = '/ajax/register/check_username',
            pData = 'username=' + username;

        // Prevent spaces in username
        $this.val(function(i, v) { 
            return v.replace(/ /g,""); 
        });

        // Abort if currentUserNameRequest is true
        if ( currentUserNameRequest ) {
            currentUserNameRequest.abort();
        }

        // Username length restrictions
        if ( username.length < 5 || username.length > 20 ) {
            
            if (username.length < 5 )  {

                $usernameAvailabilityMessage.html('Username must be unique, e.g. peter123.');
                $usernameAvailability.removeClass();  

            } else {                    

                $usernameAvailability.removeClass('available').addClass('unavailable');    

            }

            return;

        }

        currentUserNameRequest = $.ajax({

            type: 'GET',
            url: url,
            data: pData,
            dataType: 'json',
            success: function(rData) {

                if ( rData.belongs_to_user != null ) {

                    $usernameAvailability.removeClass('available').removeClass('unavailable');
                    $usernameAvailabilityMessage.html(rData.message);

                } else if ( rData.success != null ) {

                    $usernameAvailability.addClass('available').removeClass('unavailable');
                    $usernameAvailabilityMessage.html(rData.message);

                } else {

                    $usernameAvailability.addClass('unavailable').removeClass('available');
                    $usernameAvailabilityMessage.html(rData.message);

                }  

            },

            error: function() {

                $usernameAvailability.removeClass('available').removeClass('unavailable');

            }

        });

    }

}

ZPG.user_alerts = function ( options ) {

    var me = {

        options: $.extend({

            'action': '',
            'href': '',
            'isAlert': false,
            'isAlertModified': false,
            'pageSize': '',
            'view': 'list'

        }, options),

        init: function( action, href ) {

            data = getSearchOptions();

            // Set view type
            data['view_type'] = me.options.view;

            // Map view requires different setup
            me._mapPolygon();

            // Create or modify
            if ( action === 'create' ) {
                me._create( href );
            } else {
                me._modify( href );
            }

        }, 

        _create: function( href ) {

            // Section is already specified 
            delete data['section'];

            // Default for list is 25, grid is 24
            data['page_size'] = me.options.pageSize;

            // Append modified args to href 
            href = ZPG.util.appendParams( href, data );

            // Open popup to create alert/search
            $.fancybox({
                href: href,
                titleShow: false,
                type: 'ajax'
            });

        },

        _modify: function( href ) {

            // Post data
            $.ajax({
                url: href,
                type: 'POST',
                data: data,
                success: function( data ) {

                    me.options.isAlertModified = false;
                    me._updateUI();

                    // If the alert/search was deleted under the scenes, 
                    // a new one is created and we need to redirect
                    if ( data['javascript'] ) {
                        $.globalEval( data['javascript'] );
                    }

                }

            });

        },

        _mapPolygon: function() {

            if ( me.options.view === 'map' && isUserPolygon ) {
                var polys = map.getPolygons();

                if ( !polys.length ) {
                    if ( fancybox ) {
                        $.fancybox({
                            content: 'You need a defined search area to perform this action.'
                        });
                    }
                    return false;
                }

                data['q'] = $('input[name="orig_q"]').attr('value');

            }

        },

        searchAlertUpdated: function() {

            if ( me.options.isAlert ) {
                me.options.isAlertModified = true;
            }

            me._updateUI();

        },

        _updateUI: function() {

            // Update the interface with success/modifed messaging
            // TODO - this bit specfic to desktop, make it a success callback
            if ( me.options.isAlert ) {

                var $alertsSaved = $('#alerts-saved'),
                    $alertsModified = $('#alerts-modified'),
                    mapUrl = $('#listings-tabs li:eq(2) a').attr('href'),
                    $alertsMap = $('#alerts-map');

                if ( me.options.isAlertModified ) {

                    $alertsModified.css('display', 'block');
                    $alertsSaved.css('display', 'none');

                } else {

                    $alertsModified.css('display', 'none');
                    $alertsSaved.css('display', 'block').delay(2000).fadeOut(200);
                    $alertsMap.attr('href', mapUrl);

                }

            }

        }

    };

    return {
        init: me.init,
        searchAlertUpdated: me.searchAlertUpdated
    };

}

ZPG.user_favourites = {

    init: function() {

        ZUF = ZPG.user_favourites;

        $(document).on('click', 'a[data-favourite-action]', function() {

            ZUF.$this = $(this);
            ZUF.data = ZUF.$this.attr('data-favourite-id');
            ZUF.type = ZUF.$this.attr('data-favourite-type');
            ZUF.action = ZUF.$this.attr('data-favourite-action');
            ZUF.url = '/myaccount/favourites/' + ((ZUF.type == "listings") ? "listings" : "home-values") + '/' + ZUF.action + '/' + ZUF.data;

            // ACTION 1: Add favourite
            if (ZUF.action == 'add') {

                ZUF.add();

            // ACTION 2: Remove favourite
            } else {

                ZUF.remove();

            }

            return false;

        });

    }, 

    add: function() {

        $.ajax({
            url: ZUF.url,
            data: ZUF.data
        });

        // Change action to 'remove' so that the next click will remove the favourite
        var current_copy = ZUF.$this.find('span').html(),
            change_copy  = ZUF.$this.attr('data-fav-copy');

        ZUF.$this
            .attr('data-favourite-action', 'remove')
            .attr('data-fav-copy', current_copy)
            .addClass('favourite-saved')
            .find('span').html(change_copy);

        var $favourites_menu_counter = $('.js-favourite-menu-counter');
        if ($favourites_menu_counter.text() != "") {
            $favourites_menu_counter.text(parseInt($favourites_menu_counter.text()) + 1);
        } else {
            $favourites_menu_counter.text('1');
        }

        // PL listing result page - Change star icon 
        if (ZUF.$this.next('i').find('icon-star-empty')) {
            ZUF.$this.find('i').removeClass('icon-star-empty').addClass('icon-star');
        }

        // GA tracking
        dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'Save to Favourites',
            'eventAction': 'Click',
            'eventLabel': 'Saved'
        });

    }, 

    remove: function() {

        $.ajax({
            url: ZUF.url,
            data: ZUF.data
        });

        // Change action to 'add' so that the next click will save the favourite
        var current_copy = ZUF.$this.find('span').html(),
            change_copy  = ZUF.$this.attr('data-fav-copy');

        ZUF.$this
            .attr('data-favourite-action', 'add')
            .attr('data-fav-copy', current_copy)
            .removeClass('favourite-saved')
            .find('span').html(change_copy);

        var $favourites_menu_counter = $('.js-favourite-menu-counter');
        if (parseInt($favourites_menu_counter.text()) > 1) {
            $favourites_menu_counter.text(parseInt($favourites_menu_counter.text()) - 1);
        } else {
            $favourites_menu_counter.text('');
        }

        // PL listing result page - Change star icon 
        if (ZUF.$this.next('i').find('icon-star')) {
            ZUF.$this.find('i').removeClass('icon-star').addClass('icon-star-empty');
        }

        // GA tracking
        dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': 'Remove from Favourites',
            'eventAction': 'Click',
            'eventLabel': ZUF.$this.attr('data-ga-label')
        });

    }

}

ZPG.user_notes = (function() {

    var self = {

        init: function( config ) {

            self.config = $.extend({
                'char_limit': 1000,
                'truncate'  : 150,
                'dataLabel' : window.location.pathname.replace(/[0-9]/g, '')
            }, config );

            self.controls = $.extend({
                'button'    : $( '<button></button>' ).addClass('btn btn-sm'),
                'btnSave'   : $( '<button data-ga-category="MyZoopla" data-ga-action="My Notes - Save" data-ga-label="/tracking'+self.config.dataLabel+'" class="save btn btn-sm btn-default">Save</button>' ),
                'btnCancel' : $( '<button class="cancel btn btn-sm btn-link">Cancel</button>' ),
                'btnEdit'   : $( '<button data-ga-category="MyZoopla" data-ga-action="My Notes - Edit" data-ga-label="/tracking'+self.config.dataLabel+'" class="edit btn btn-sm btn-link">Edit</button>' ),
                'btnDelete' : $( '<button data-ga-category="MyZoopla" data-ga-action="My Notes - Delete" data-ga-label="/tracking'+self.config.dataLabel+'" class="delete btn btn-sm btn-link">Delete</button>' ),
                'btnSend'   : $( '<button data-ga-category="MyZoopla" data-ga-action="My Notes - Send" data-ga-label="/tracking'+self.config.dataLabel+'" class="send btn btn-sm btn-link">Send</button>' ),
                'btnMore'   : $( '<button class="showmore btn btn-sm btn-link fleft none">Show more</button>' )
            });

            $('.listing-note textarea').css('overflow', 'hidden');

            $(document).on('keyup', '.listing-note textarea', function() {

                var $el = $(this),
                    btn_save   = $el.parent().find('button.save'),
                    btn_cancel = $el.parent().find('button.cancel'),
                    limit      = self.config.char_limit;

                if ($el.val().length > 0) {
                    btn_save.prop('disabled', false);
                    btn_cancel.prop('disabled', false);
                } else {
                    btn_save.prop('disabled', true);
                    btn_cancel.prop('disabled', true);
                }

                if ( $el.val().length > limit ) $el.val( $el.val().substr(0, limit) );

            });

            $(document).on('click', '.listing-note > a', function(e) {

                e.preventDefault();

                ZPG.user_notes.togglePane( $(this) );

            });

            $(document).on('click', '.listing-note button.delete', function(e) {

                e.preventDefault();

                ZPG.user_notes.noteDelete( $(this) );

                dataLayer.push({ 
                    "event": "GAEvent",
                    "eventCategory": $( this ).attr( "data-ga-category" ), 
                    "eventAction": "My Notes - Delete", 
                    "eventLabel": $( this ).attr( "data-ga-label" ),
                    "eventValue": undefined 
                });

            });

            $(document).on('click', '.listing-note button.save', function(e) {

                e.preventDefault();

                ZPG.user_notes.noteSave( $(this) );

                dataLayer.push({
                    "event": "taxonomy",
                    "eventTaxonomy": {
                        "activity": "user_account",
                        "action": "add_note"
                    }
                });

                dataLayer.push({ 
                    "event": "GAEvent",
                    "eventCategory": $( this ).attr( "data-ga-category" ), 
                    "eventAction": "My Notes - Save", 
                    "eventLabel": $( this ).attr( "data-ga-label" ),
                    "eventValue": undefined 
                });

            });

            $(document).on('click', '.listing-note button.send', function(e) {

                e.preventDefault();

                ZPG.user_notes.noteSend( $(this) );

            });

            $(document).on('click', '.listing-note button.cancel', function(e) {

                e.preventDefault();

                ZPG.user_notes.noteCancel( $(this) );

            });

            $(document).on('click', '.listing-note button.edit', function(e) {

                e.preventDefault();

                ZPG.user_notes.noteEdit( $(this) );

                dataLayer.push({ 
                    "event": "GAEvent",
                    "eventCategory": $( this ).attr( "data-ga-category" ), 
                    "eventAction": "My Notes - Edit", 
                    "eventLabel": $( this ).attr( "data-ga-label" ),
                    "eventValue": undefined 
                });

            });

            $(document).on('click', '.listing-note button.showmore', function(e) {

                e.preventDefault();

                ZPG.user_notes.toggleText( $(this) );

            });

        },


        togglePane: function( $el ) {

            var $iconArrowClass = $el.find( '.icon-arrow .icon' ),
                $noteContainer  = $el.siblings( '.note-container' );

            if ( $noteContainer.is(':hidden') ) {

                $iconArrowClass.addClass( 'icon-up-open' );
                $iconArrowClass.removeClass( 'icon-down-open' );
                $noteContainer.show();

            } else {

                $iconArrowClass.removeClass( 'icon-up-open' );
                $iconArrowClass.addClass( 'icon-down-open' );
                $noteContainer.hide();

            }

        },

        toggleText: function($el) {

            var container = $el.parents('.listing-note'),
                hiddenCopy = container.find('p span'),
                button     = container.find('.note-control .showmore'),
                ellipsis   = container.find('.ellipsis');

                if (hiddenCopy.is(':hidden')) {

                    button.text('Show less');
                    hiddenCopy.show();
                    ellipsis.hide();

                } else {

                    button.text('Show more');
                    hiddenCopy.hide();
                    ellipsis.show();

                }

        },

        noteEdit: function( $el ) {

            var $container   = $el.parents('.listing-note'),
                $currentNote = $container.find('p');

                self._makeEditable( $currentNote );

        },

        noteCancel: function( $el ) {

            var container   = $el.parents('.listing-note'),
                currentNote = container.find('p'),
                textarea    = container.find('textarea');

                if ( container.data('note-id') > 0 ) {

                    self._makeControlEdit( currentNote );
                    currentNote.show();
                    textarea.remove();

                } else {

                    textarea.val('').trigger('keyup');
                    self._makeControlSave( currentNote );

                }

        },

        noteSave: function( $el ) {

            var url = '/ajax/user/update_listing_note';

            var container   = $el.parents( '.listing-note' ),
                noteId      = container.data( 'note-id' ),
                listingId   = container.data( 'listing-id' ),
                section     = container.data( 'section' ),
                heading     = container.find( 'a' ),
                currentNote = container.find( 'p' ),
                textarea    = container.find( 'textarea' ),
                controls    = container.find('.note-control'),
                seeAll      = container.find('.see-all');

            var data = {
                note       : textarea.val(),
                listing_id : listingId,
                section    : section
            };

            $el.prop('disabled', true);

            if (typeof(noteId) != 'undefined') {

                data['note_id'] = noteId;

            }

            $.getJSON( url , data, function( res ) {

                // success contains the note ID
                if ( res && res ['success']) {

                    if ( container.data('note-id') > 0 ) {

                        self._makeControlEdit( currentNote );

                        currentNote.text( self._truncateNote( textarea ) ).show();

                    } else {

                        container.data('note-id',  res['success']);

                        self._toggleTitle( heading );
                        textarea.after( '<p>' + self._truncateNote( textarea ) + '</p>');
                        self._makeControlEdit( textarea );
                        currentNote = container.find( 'p' );

                    }

                    if (currentNote.text().length < self.config.truncate )
                        controls.find('.showmore').hide();
                    else
                        controls.find('.showmore').show();

                    textarea.remove();

                    // add see all bar (if there's not one present)
                    seeAll.show();

                }

            });

        },

        noteSend: function( $el ) {

            var container = $el.parents('.listing-note'),
                listingId = container.data( 'listing-id' ),
                section   = container.data( 'section' );
                window.location.href = '/friend/'+listingId+'?section='+section;

        },

        noteDelete: function( $el ) {

            var url = '/ajax/user/delete_listing_note';

            var container = $el.parents('.listing-note'),
                heading     = container.find('a'),
                currentNote = container.find( 'p' ),
                date        = container.find('.date'),
                textarea    = container.find( 'textarea' ),
                controls    = container.find( '.note-control' ),
                listingRow  = container.parents('li:eq(0)'),
                noteId      = container.data('note-id')
                seeAll      = container.find('.see-all');

            if (typeof(noteId) != 'undefined') {

                var data = {
                    note_id: noteId
                };

                $.getJSON(url, data, function( res ) {

                    if (res && res['success']) {

                        container.data('note-id', '');

                        self._toggleTitle( heading );
                        date.remove();

                        textarea.val('testing');
                        currentNote.html('');

                        self._makeEditable( currentNote );
                        self._makeControlSave( currentNote );
                        currentNote.remove();

                        heading.trigger('click');

                        // add see all bar (if there's not one present)
                        seeAll.hide();

                    }

                }).fail(function() {

                    date.remove();
                    controls.remove();
                    currentNote.html('An unexpected error has occured while trying to delete your note. Please try again soon.').addClass('error');

                    setTimeout(function(){

                        // remove troublesome note from list
                        listingRow.slideUp(function() {
                            $(this).remove();
                        });

                    }, 3000);

                });

            }

        },

        _makeEditable: function( $el ) {

            var $textarea  = $('<textarea></textarea>');
                $textarea.text( $el.text() );

            $el.after( $textarea );
            $el.hide();

            $textarea.css('overflow', 'hidden');
            $textarea.focus();

            self._makeControlSave( $el );

        },

        _makeControlEdit: function( $el ) {

            var $controls = $el.siblings('.note-control');

            return $controls.html( self.controls.btnDelete.clone() )
                           .append( self.controls.btnEdit.clone() )
                           .append( self.controls.btnSend.clone() )
                           .append( self.controls.btnMore.clone() );

        },

        _makeControlSave: function( $el ) {

            var $controls = $el.siblings('.note-control');

            return $controls.html( self.controls.btnCancel.clone() )
                           .append( self.controls.btnSave.clone() );

        },

        _toggleTitle: function( $el ) {

            var $iconText  = $el.find( '.icon-text' ),
                $iconClass = $el.find( '.icon' ).eq(0);

            if ( $iconText.text() === 'Note added' ) {

                $iconText.text('Add a note');
                $iconClass.removeClass('icon-doc-text');
                $iconClass.addClass('icon-doc');

            } else {

                $iconText.text('Note added');
                $iconClass.removeClass('icon-doc');
                $iconClass.addClass('icon-doc-text');

            }

        },

        _truncateNote: function( $el ) {

            var $note  = $el.val(),
                $limit = self.config.truncate;

            $note = $note.replace(/(?:\r\n|\r)/g, '\n');

            if ( $note.length >= 150 )
                return $note.substring(0, 150) + '<span class="none">' + $note.substring( 150 ) + '</span><i class="ellipsis"></i>';
            else
                return $note;

        }

    };

    return {
        init       : self.init,
        togglePane : self.togglePane,
        toggleText : self.toggleText,
        noteDelete : self.noteDelete,
        noteSave   : self.noteSave,
        noteSend   : self.noteSend,
        noteCancel : self.noteCancel,
        noteEdit   : self.noteEdit
    }

})();

// Hide listings from search results
ZPG.user_hide_listing = (function() {

    var self = {

        init: function( options ) {

            self.options = $.extend({
                hiddenInPage:       []
            }, options);

            // Check sessionStorageSupport
            self.sessionStorageIsSupported = ZPG.support.sessionStorage();

            if ( self.sessionStorageIsSupported ) {

                // Store session object 
                self.session = window.sessionStorage;

                if ( typeof self.options.searchIdentifier !== "undefined" ) {

                    // If we have done a new search tidy up stored listings_ids
                    // Compare current search_identifier to stored search_identifier
                    if ( self.options.searchIdentifier !== self.session.getItem( "search_identifier" ) ) {

                        // Remove hidden/unhidden listing_ids
                        self.session.removeItem( "listings_hide" );
                        self.session.removeItem( "listings_unhide" );

                        // Reset search identifier to current
                        self.session.setItem( "search_identifier", self.options.searchIdentifier );
                    }

                }

            }

            // Data object to submit via Ajax
            self.data = {};

            // Define arrays to store hidden and unhidden listing_ids
            self.listings_unhide = [];
            self.listings_hide = [];

            // Grab all listings we have hidden and stored in sessionStorage
            self._getListings( "hide", self.listings_hide );

            // Get all unhidden listing_ids
            self._getListings( "unhide", self.listings_unhide );

            // On every view of results/details page we need to restore the page state
            if ( self.options.placement === "results" ) {
                self._updateResultsUI();
            } else if ( self.options.placement === "details" ) {
                self._updateDetailsUI();
            }

        },

        _compareOriginal: function() {

            // Don't do if no listings previously hidden in page
            if ( !self.options.hiddenInPage.length ) {
                return false;
            }

            var lookup = {};

            // Create a lookup to allow us to compare original hidden listing_ids
            // with any newly unhidden listing_ids so that we can restore the
            // state of the page for those particular listings

            for ( var j in self.options.hiddenInPage ) {
                lookup[ self.options.hiddenInPage[ j ] ] = self.options.hiddenInPage[ j ];
            }

            for ( var i in self.listings_unhide ) {

                if ( typeof lookup[ self.listings_unhide[ i ] ] != "undefined" ) {

                    var $item = $( "#listing_" + self.listings_unhide[ i ] ),
                        $hideButtonCopy = $item.find( ".js-hide-listing-copy" ),
                        hideCopy = $hideButtonCopy.data( "hide-copy" ),
                        action = "unhide",
                        duration = 0;

                    // If there is a match it means the original listing_id
                    // has since been hidden, so we should hide it
                    ZPG.user_hide_listing.updateResultsListUI( $item, action, duration );

                    // Set data-hidden to true
                    $item.find( "[data-hidden]" ).attr( "data-hidden", "false" );

                    // Change copy
                    $hideButtonCopy.html( hideCopy );

                } 

            }

            // Remove listing_ids from hidden listings tally
            // if it exists in the original listings_ids tally
            for ( var i in self.listings_hide ) {

                if ( typeof lookup[ self.listings_hide[ i ] ] != "undefined" ) {

                    var index = $.inArray( lookup[ self.listings_hide[ i ] ], self.listings_hide );

                    // If the index exists we should remove it
                    if ( index > -1 ) {
                        self.listings_hide.splice( index, 1 );
                        self.session.setItem( "listings_hide" , JSON.stringify( self.listings_hide ) );
                    }
                
                } 

            }
            
        },

        toggle: function( $el ) {

            // The clicked jQuery object
            self.$el = $el;

            // Is the listing hidden, true/false
            self.isHidden = self.$el.attr( "data-hidden" );

            // Get the listing_id
            self.listingId = self.$el.attr( "data-listing-id" );

            // Hide or unhide the listing
            if ( self.isHidden === "false" ) {
                self._hide();
            } else {
                self._unhide();
            }

        },

        _hide: function() {

            var url = "/ajax/user/hide_listing";

            // Get listing_id we want to hide from $el
            self.data[ "listing_id" ] = self.$el.attr( "data-listing-id" );

            // Listing section
            self.data[ "section" ] = self.$el.attr( "data-section" );

            // Display some user feedback on clicked link
            self.$el
                .find( ".js-hide-listing-copy")
                .text( "..." );

            $.ajax({
                url: url,
                data: self.data,
                success: function() {

                    // Store the result in sessionStorage
                    self._storeHidden();

                    // Update all hide buttons making sure we find duplicated links
                    $( ".js-hide-listing[data-listing-id=" + self.listingId + "]" ).attr( "data-hidden", "true" );

                    // If a hideCallback is defined run it
                    if ( typeof self.options.hideCallback == "function" ) {
                        self.options.hideCallback( self.$el, self.options );
                    }

                    // Use a timeout to overcome some niggles
                    setTimeout(function(){

                        // Update user message allows hidden tally to update
                        self._updateResultsMessageUI();

                        // Lets UI change before changing button copy

                        var $el = $( ".js-hide-listing[data-listing-id=" + self.listingId + "] .js-hide-listing-copy" );

                        $el.each(function() {
                            var $this = $( this ),
                                unhideCopy = $this.data( "unhide-copy" );

                            $this.html( $this.data( unhideCopy ) );
                        });

                    }, 500);

                }

            });

        },

        _unhide: function() {

            var url = "/ajax/user/unhide_listing";

            // Get listing_id we want to unhide from $el
            self.data[ "listing_id" ] = self.$el.attr( "data-listing-id" );

            // Display some user feedback on clicked link
            self.$el
                .find( ".js-hide-listing-copy")
                .text( "..." );

            $.ajax({
                url: url,
                data: self.data,
                success: function() {

                    self.restoreHidden( "[" + self.listingId + "]" );

                    // Update all hide buttons making sure we find duplicated links
                    $( ".js-hide-listing[data-listing-id=" + self.listingId + "]" ).attr( "data-hidden", "false" );
                    var $el = $( ".js-hide-listing[data-listing-id=" + self.listingId + "] .js-hide-listing-copy" );

                    $el.each(function() {
                        var $this = $( this ),
                            hideCopy = $this.data( "hide-copy" );

                        $this.html( $this.data( hideCopy ) );
                    });

                    // If an unhideCallback is defined run it
                    if ( typeof self.options.unhideCallback == "function" ) {
                        self.options.unhideCallback( self.$el, self.options );
                    }

                    // Update user message
                    setTimeout(function(){
                        self._updateResultsMessageUI();
                    }, 500);

                }

            });

        },

        _getListings: function( type, arr ) {

            if ( self.sessionStorageIsSupported ) {

                var listings = self.session.getItem( "listings_" + type );

                // Create array from hidden_listings string
                if ( typeof listings != "undefined" && listings != null ) {
                    $.each( JSON.parse( listings ), function( i, val ) {
                        arr[i] = val;
                    });
                }

            }

        },

        _storeHidden: function() {

            // Stores hidden listing_id in Javascript array && sessionStorage
            if ( self.sessionStorageIsSupported ) {

                // Push hidden listing to array of previous hidden listings
                self.listings_hide.push( self.listingId );

                // Store updated list of hidden listings in sessionStorage
                self.session.setItem( "listings_hide" , JSON.stringify( self.listings_hide ) );

                // Store listing_id to keep track all unhidden listings
                // Define an index variable so that we can see if the 
                // listing_id is in the array or unhidden listings
                var index = $.inArray( self.listingId, self.listings_unhide );

                // If the index exists we should remove it
                if ( index > -1 ) {
                    self.listings_unhide.splice( index, 1 );
                    self.session.setItem( "listings_unhide" , JSON.stringify( self.listings_unhide ) );
                }

            }

        },

        restoreHidden: function( listing_ids ) {

            if ( self.sessionStorageIsSupported ) {

                // We restore listing_ids in bulk in myaccount so this needs to 
                // accept an array and we need to restore all listing_ids within it
                var listings = [];

                $.each( JSON.parse( listing_ids ), function( i, val ) {
                    listings[i] = "" + val + "";
                });

                for ( var i = 0; i < listings.length; i++ ) {

                    if ( self.sessionStorageIsSupported ) {

                        // Push unhidden listing to array of previous unhidden listings
                        self.listings_unhide.push( listings[i] );

                        // Store updated list of unhidden listings in sessionStorage
                        self.session.setItem( "listings_unhide" , JSON.stringify( self.listings_unhide ) );

                        // Store listing_id to keep track all hidden listings
                        // Define an index variable so that we can see if the 
                        // listing_id is in the array or hidden listings
                        var index = $.inArray( listings[ i ], self.listings_hide );

                        // If the index exists we should remove it
                        if ( index > -1 ) {
                            self.listings_hide.splice( index, 1 );
                            self.session.setItem( "listings_hide" , JSON.stringify( self.listings_hide ) );
                        }

                    }

                }

            }

        },

        _updateDetailsUI: function() {

            var index = $.inArray( self.options.listingId, self.listings_hide ),
                $hideButton = $( ".js-hide-listing" ),
                $hideButtonCopy = $( ".js-hide-listing-copy" ),
                $hideMsg = $( ".js-hide-listing-msg" );

            if ( self.listings_hide.length ) {
                if ( index > -1 ) {

                    $hideMsg.show();
                    $hideButton.attr( "data-hidden", true );

                    $hideButtonCopy.each( function() {
                        var $this = $( this),
                            hideCopy = $this.data( "unhide-copy" );

                        $this.html( hideCopy );
                    });

                } else {

                    $hideMsg.hide();
                    $hideButton.attr( "data-hidden", false );

                    $hideButtonCopy.each( function() {
                        var $this = $( this),
                            unhideCopy = $this.data( "hide-copy" );

                        $this.html( unhideCopy );

                    });

                }
            }
                
        },

        _updateResultsUI: function() {

            if ( self.options.placement !== "results" ) {
                return false;
            }

            self._restoreUI();
            self._updateResultsMessageUI();

        },

        _restoreUI: function() {

            if ( self.sessionStorageIsSupported ) {

                // Faster DOM manipulation to cut down on page jittering
                // Grab all IDs we have hidden and update UI in one swoop
                self.updateResultsListUI( 
                    $.map( self.listings_hide, function( id ) { 
                        return "#listing_" + id 
                    }).join(", "), "hide", 0 );

                // Compare original hidden listing_ids with newly unhidden listing_ids
                // to restore the state of the UI for those listings
                self._compareOriginal();

            }

        },

        resultsToggle: function( $el ) {

            var $iconText = $el.find( ".icon-text" ),
                $iconClass = $el.find( ".icon" ),
                $item = $el.closest( "li" ),
                $listingWrapper = $item.find( ".listing-results-wrapper" );

            if ( $el.data( "clicked" ) === true ) {

                $iconText.html( "Show" );
                $iconClass.addClass( "icon-right-dir" );
                $iconClass.removeClass( "icon-down-dir" );
                $el.data( "clicked", false );
                $listingWrapper.hide();

            } else {

                $iconText.html( "Close" );
                $iconClass.removeClass( "icon-right-dir" );
                $iconClass.addClass( "icon-down-dir" );
                $el.data( "clicked", true );
                $listingWrapper.show();

            }

        },

        updateResultsListUI: function( item, action, duration ) {

            // Allow slideUp animation duration to be overwritten as 
            // we do not want any animation when restoring the UI on init
            if ( duration == null ) {
                duration = 300;
            }

            // TODO -- select like we do new fast hide
            var $item = $( item );
                $listingWrapper = $item.find( ".listing-results-wrapper" ),
                $hideButton = $item.find( ".js-hide-listing" ),
                $hideButtonCopy = $item.find( ".js-hide-listing-copy" ),
                hideCopy = $hideButtonCopy.data( "hide-copy" ),
                unhideCopy = $hideButtonCopy.data( "unhide-copy" ),
                $msg = $( ".js-hidden-listings-msg" ),
                $hiddenWrapper = $item.find( ".hidden-listing-wrapper" );

            // Unhide
            if ( action === "unhide" ) {

                $hideButton.attr( "data-hidden", false );
                $hideButton.attr( "data-ga-action", "Hide" );
                $hideButtonCopy.html( hideCopy );

                var $toggle = $item.find( ".js-hidden-listing-result-toggle" ),
                    $iconText = $toggle.find( ".icon-text" ),
                    $iconClass = $toggle.find( ".icon" );

                $toggle.data( "clicked", false );
                $iconText.html( "Show" );
                $iconClass.addClass( "icon-right-dir" );
                $iconClass.removeClass( "icon-down-dir" );

                // Generic
                $listingWrapper.show();
                $hiddenWrapper.hide();
                $item.removeClass( "js-is-hidden-listing-result is-hidden-listing-result" );
                $msg.before( $item );

                if ( self.options.viewType === "grid" ) {

                    $( ".listing-results li.grid-cell:eq(-1)" ).after( $item );
                    $item.addClass( "grid-cell" );
                    self.updateResultsGridUI();

                }

            // Hide
            } else {

                // On each return to the results page, we need to update the state of the page visited via the
                // browser back button. We need to re-hide listings because the browser
                // will always return the page to it's initial state

                $hideButton.attr( "data-hidden", true );
                $hideButton.attr( "data-ga-action", "Unhide" ),
                $hideButtonCopy.html( unhideCopy );

                if ( duration === 0 ) {

                    $listingWrapper.hide();
                    $hiddenWrapper.show();
                    $item.addClass( "js-is-hidden-listing-result is-hidden-listing-result" );
                    $msg.after( $item );

                    // Grid only extras
                    if ( self.options.viewType === "grid" ) {
                        $item.removeClass( "grid-cell grid-cell-first grid-cell-third" );
                        self.updateResultsGridUI();
                    }

                } else {

                    $listingWrapper.slideUp( duration, function() {

                        $item.addClass( "js-is-hidden-listing-result is-hidden-listing-result" );
                        $hiddenWrapper.show();
                        $msg.after( $item );
                        
                    });

                }

            }

        },

        updateResultsGridUI: function() {

            // Grid view has to have some css magic applied
            var $parentList = $( ".listing-results" );

            // Modify grid classes to maintain layout
            $parentList
                .find( "li" ).not( ".js-is-hidden-listing-result" )
                .removeClass( "grid-cell-first grid-cell-third" );

            $parentList
                .find( "li:nth-child(3n+1)" ).not( ".js-is-hidden-listing-result" )
                .addClass( "grid-cell-first" );

            $parentList
                .find( "li:nth-child(3n+3)" ).not( ".js-is-hidden-listing-result" )
                .addClass( "grid-cell-third" );

        },

        _updateResultsMessageUI: function() {

            // Update DOM element to display the running tally of hidden listings.
            // Tally maintained by adding initial hiddenCount from server
            // with length of array of hidden listings for current search which we
            // have stored in sessionStorage and referenced by search_identifier

            if ( self.options.placement !== "results" ) {
                return false;
            }

            var $hiddenCount = $( ".js-hidden-listings-count" ),
                $msg = $( ".js-hidden-listings-msg" ),
                $property = $( ".js-hidden-listings-property" ),
                hiddenTally = $( ".js-is-hidden-listing-result" ).size();

            if ( hiddenTally === 0 ) {
                // Hide user message if no hidden properties
                $msg.hide();

            } else {
                
                // Show user message if we have hidden properites
                $msg.show();

                // Tweak copy based on plurality
                if ( hiddenTally === 1 ) {
                    $property.text( "property" );
                } else {
                    $property.text( "properties" );
                }

                // Change copy to show number of hidden properties on page
                $hiddenCount.text( hiddenTally );

            }

        }

    };

    return {
        init:                   self.init,
        updateResultsListUI:    self.updateResultsListUI,
        updateResultsGridUI:    self.updateResultsGridUI,
        restoreHidden:          self.restoreHidden,
        resultsToggle:          self.resultsToggle,
        toggle:                 self.toggle
    }

})();

ZPG.user_hide_listing_details = (function() {

    // HMMM
    var self = {

        hideCallback: function( $el ) {

            var listingId = $el.attr( "data-listing-id" ),
                $alert = $( ".js-hide-listing-msg" ),
                $copy = $( ".js-hide-listing-copy" );

            // Change copy
            $copy.each( function() {
                var $this = $( this ),
                    unhideCopy = $this.data( "unhide-copy" );

                $this.html( unhideCopy );

            });

            // Show user message
            $alert.show();

        },

        unhideCallback: function( $el ) {

            var $copy = $( ".js-hide-listing-copy" ),
                $alert = $( ".js-hide-listing-msg" );

            // Change copy
            $copy.each( function() {

                var $this = $( this ),
                    hideCopy = $this.data( "hide-copy" );

                $this.html( hideCopy );

            });

            // Hide user message
            $alert.hide();

        }

    };

    return {
        hideCallback: self.hideCallback,
        unhideCallback: self.unhideCallback
    };

})();

ZPG.user_hide_listing_results = (function() {

    var self = {

        hideCallback: function( $el, options ) {

            // Grid view has different callback from list view
            if ( options.viewType === "grid" ) {

                // Grid view has to have some css magic applied
                var $item = $el.closest( "li" );
                var action = "hide";
                var duration = 0;

                ZPG.user_hide_listing.updateResultsListUI( $item, action, duration );

            } else {

                var $item = $el.closest( "li[data-listing-id]" );
                ZPG.user_hide_listing.updateResultsListUI( $item );

            }

        },

        unhideCallback: function( $el, options ) {

            // Grid view has different callback from list view
            if ( options.viewType === "grid" ) {

                // Grid view has to have some css magic applied
                var $item = $el.closest( "li" ),
                    action = "unhide";

                ZPG.user_hide_listing.updateResultsListUI( $item, action );

            } else {

                var $item = $el.closest( "li[data-listing-id]" ),
                    action = "unhide";

                ZPG.user_hide_listing.updateResultsListUI( $item, action );

            }

        }

    };

    return {
        hideCallback    : self.hideCallback,
        unhideCallback  : self.unhideCallback
    };

})();

ZPG.user_hide_listing_map = (function() {

    var self = {

        hideCallback: function( $el ) {

            var listingId = $el.attr( "data-listing-id" ),
                infoWindowPos = map.getInfoWindow().getPosition(),
                pinLat = infoWindowPos.lat(),
                pinLong = infoWindowPos.lng(),
                $ol = $el.closest( "ol" ),
                $popupObj,
                moreDetail = $el.parents( "#map-popup" ).find( ".map-popup-full-details:visible" );

            // Check if more details popup open
            if ( moreDetail.length ) {
                $popupObj = moreDetail;
            } else {
                $popupObj = $el.closest( "li" );
            }

            // Fade out popup object
            $popupObj.fadeOut({

                complete: function() {

                    // Remove popup
                    $popupObj.remove();

                    // Update user msg
                    var t = parseInt( $( ".hidden-listings-count" ).text().replace(",", "") );
                    $( ".hidden-listings-count" ).text( ZPG.util.formatNumber( t + 1 ) );
                    if ( parseInt( $( ".hidden-listings-count" ).text().replace(",", "")) === 1 ) {
                        $( ".hidden-listings-property" ).text( "property" );
                    } else {
                        $( ".hidden-listings-property" ).text( "properties" );
                    }

                    if ( $( ".hidden-listings-count" ).parent( "span" ).hasClass( "none") ) $( ".hidden-listings-count" ).parent( "span" ).removeClass( "none" );

                    var section = $el.attr( "data-section" );

                    if ( section === "to-rent" ) {
                        map.removeToRentPin( listingId, pinLat, pinLong );
                        map.removeFavouriteResultsToRentPin( listingId, pinLat, pinLong );
                    } else {
                        map.removeForSalePin( listingId, pinLat, pinLong );
                        map.removeFavouriteResultsForSalePin( listingId, pinLat, pinLong );
                    }
                   
                    // Get all list items within $ol
                    var lis = $ol.find( "li" );

                    $( ".map-popup-tally" ).html( lis.size() );
                    if ( lis.size() === 1 ) {
                        $( ".map-popup-tally-property" ).html( "property" );
                    }

                    // If no more list items
                    if ( !lis.length ) {

                        // Hide the info window if there are no listings left
                        map.closeInfoWindow();

                    }

                }

            });

        }

    };

    return {
        hideCallback: self.hideCallback
    };

})();

ZPG.movies = (function() {

    var self = {

        valid_url: false,
        player_width: 645,
        player_height: 365,

        _validate_url: function(config) {

            self.config = $.extend({
                URL: ''
            }, config);

            var url = self._parse_player_url({url: $.trim(self.config.URL)});

            if (url) {

                self.valid_url = true;
                $('#movie-play')
                    .attr('href', url)
                    .data('player-height', self.player_height)
                    .data('player-width', self.player_width)
                    .data('valid-url', true)
                    .show();
                $('#agent-movie-play').show();
                $('#images-slideshow').hide();

            } else {

                $('#movie-play').attr('href', '').hide();
                // $('ul.listing-content.clearfix.noprint').append('<li><a href="'+ self.config.URL +'" target="_blank">Virtual Tour</li>')
                // var popup = window.open(this.href,'name','left=200,top=150,height=550,width=700,toolbar=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,titlebar=no');
                // displayPopup(popup);
                $('#agent-movie-play').hide();
                $('#images-slideshow').show();

            }

        },

        _parse_player_url: function(config) {

            var args = {URL: config.url};

            if (config.url.indexOf('vistabee') > -1) {

                return self._source_vistabee(args);

            } else if (config.url.indexOf('vieweet') > -1) {

                return self._source_vieweet(args);

            } else if (config.url.indexOf('youtube') > -1 || config.url.indexOf('youtu.be') > -1) {

                return self._source_youtube(args);

            } else if (config.url.indexOf('audioagent') > -1) {

                return self._source_audioagent(args);

            } else if (config.url.indexOf('vimeo') > -1) {

                return self._source_vimeo(args);

            } else if (config.url.indexOf('propertytours') > -1) {

                return self._source_propertytours(args);

            } else if (config.url.indexOf('matterport') > -1) {

                return self._source_matterport(args);

            }

        },

        _init_player: function(config) {

            self.config = $.extend({
                enabled: 1,
                movieContainer: $('#movie'),
                movieObject: $('#movie-main'),
                imageContainer: $('#images'),
                imageNav: $('#images'),
                playerType: '',
                URL: '',
                source: '',
                target: '',
                width: '',
                height: '',
                listing_id: '',
                branch_id: '',
                autoplay: false // autoplay doesnt work for all sources
            }, config);

            if (self.config.width && self.config.width !== self.player_width)  self.player_width = self.config.width;
            if (self.config.height && self.config.height !== self.player_height)  self.player_height = self.config.height;

            var url = $('#movie-play').data('valid-url')
                ? $('#movie-play').attr('href')
                : self._parse_player_url({url: $.trim(self.config.URL)});

            // only show this if url is valid

            if (self.valid_url) {

                if (url.indexOf('.mp4') > -1) {

                    self._create_video_frame({URL: url});

                } else {

                    self._create_iframe({URL: url});

                }
                self._toggle_state();

                if (self.config.listing_id && self.config.branch_id) {

                    $.get('/ajax/movies/log_view/?listing_id=' + self.config.listing_id + '&branch_id=' + self.config.branch_id);

                } else if (!self.config.listing_id && self.config.branch_id) {

                    $.get('/ajax/movies/log_view/?branch_id=' + self.config.branch_id);

                } else if (self.config.listing_id && !self.config.branch_id) {

                    $.get('/ajax/movies/log_view/?listing_id=' + self.config.listing_id);

                }

            } else {

                $('#movie-play').hide();
                $('#images-slideshow').show();

            }
            return;

        },

        _create_video_frame: function(config) {

            var frameName  = ('movie-' + (new Date()).getTime()),
                videoFrame = $('<video id=\'zpg-' + frameName + '\' name=\'' + frameName + '\'>');

            videoFrame.css('width', self.player_width + 'px')
                .css('height', self.player_height + 'px')
                .attr('controls', 'controls')
                .attr('autoplay', 'autoplay')
                .attr('preload', 'preload')
                .html('<source type="video/mp4">')
                .appendTo(self.config.movieObject);

            videoFrame.find('source').attr('src', config.URL);

        },

        _create_iframe: function(config) {

            var iFrameName = ('movie-' + (new Date()).getTime()),
                iFrame     = $('<iframe id=\'zpg-' + iFrameName + '\' name=\'' + iFrameName + '\'>');

            iFrame.css('width', self.player_width + 'px')
                .css('height', self.player_height + 'px')
                .attr('scrolling', 'no')
                .attr('seamless', 'seamless')
                .appendTo(self.config.movieObject);

            $('#zpg-' + iFrameName).attr('src', config.URL);

        },

        _remove_frame: function(config) {

            var img      = self.config.imageContainer,
                imgMain  = img.find('#images-main'),
                imgThumb = img.find('.images-thumb'),
                mov      = self.config.movieContainer,
                movMain  = mov.find('#movie-main'),
                movNav   = mov.find('#movie-nav'),
                movFrame = movMain.find('iframe');

            // Remove Thumbnail additional click event
            imgThumb.unbind('click.ZPG.movies.remove');

            $.each(['iframe', 'video'],

                function(i, v) {

                    var frame = mov.find(v);
                    // Prevent Security Issue if the source of the iframe is not on Zoopla servers
                    var is = frame.attr('src');

                    if (is && is[0] == '/') {

                        // Existing source code
                        frame.contents().find('body').html('&nbsp;');

                    }
                    frame.remove();

                }

            );

        },

        _toggle_state: function() {

            var mov     = self.config.movieContainer,
                movNav  = mov.find('#movie-nav'),
                movMain = mov.find('#movie-main'),
                img     = self.config.imageContainer,
                imgMain = img.find('#images-main'),
                imgNav  = img.find('#images-nav');

            if (mov.is(':hidden') && (imgMain.is(':visible') && imgNav.is(':visible'))) {

                // movie is hidden, we want to show it
                self._show_movie();

                // we want to enable all the buttons that will allow us to stop, and hide the movie
                movNav.on('click', 'a.back',

                    function(event) {

                        event.preventDefault();
                        self._show_images();

                    }

                );
                $('.images-thumb').click(

                    function(event) {

                        event.preventDefault();
                        self._show_images();

                    }

                );

            } else if (mov.is(':visible') && (imgMain.is(':hidden') && imgNav.is(':hidden'))) {

                // movie is showing, we want to stop it, then remove it
                self._show_images();

                // we want to make sure the image carousel is activated and toggle doesnt trigger
                img.find('.images-thumb').unbind('click');

            }

        },

        _show_movie: function() {

            var mov = self.config.movieContainer;
            img = self.config.imageContainer;

            mov.show();
            img.find('#images-main').hide();
            img.find('#images-nav').hide();

            self._push_event({
                category: 'Video Embedded',
                action: 'Play',
                label: self.config.playerType
            });

            dataLayer.push({
                "event": "taxonomy",
                "eventTaxonomy": {
                    "activity": "listing_tools",
                    "action": "play_video"
                }
            });

        },

        _show_images: function() {

            var mov = self.config.movieContainer;
            img = self.config.imageContainer;

            self._remove_frame();
            mov.hide();
            img.find('#images-main').show();
            img.find('#images-nav').show();

            self._push_event({
                category: 'Video Embedded',
                action: 'Back to photos',
                label: self.config.playerType
            });

        },

        _source_vistabee: function(cfg) {

            self.config.playerType = 'Vistabee';

            if( cfg.URL.indexOf('.js') > -1) {
                return '/ajax/movies/embedd/?url=' + cfg.URL;
            } else {
                return cfg.URL;
            }

        },

        _source_vieweet: function(cfg) {

            self.config.playerType = 'Vieweet';
            return cfg.URL + (cfg.URL.indexOf('?') > -1 ? '&' : '?') + 'source=zoopla';

        },

        _source_audioagent: function(cfg) {

            // * 1. The form at the end of the tour : F=0
            // * 2. The ‘similar properties’ thumbnails at the end of the tour : S=0
            // * 3. The ‘enquire now button’ that appears during the tour : E=0
            // * 4. A ‘responsive player’ : R=0
            //      For the audiotour to automatically play without having to click the ‘play’ button, enter [1] in place of A=[0]

            if (cfg.URL.match(/(?:http|https)?:\/\/(?:vid\.)?audioagent.com\//)) {

                self.config.playerType = 'Audioagent';
                self.player_width      = 560;
                self.player_height     = 420;

                $('#movie-main').height(self.player_height)
                    .css({
                        'text-align': 'center',
                        'margin': 'auto',
                        'background-color': '#000',
                        'min-width': '620px'
                    });
                return cfg.URL + (cfg.URL.indexOf('?') > -1 ? '&' : '?') + 'embed=1&F=0&S=0&E=0&A=' + (self.config.autoplay ? '1' : '0') + '&R=1';

            }

        },

        _source_youtube: function(cfg) {

            var match = cfg.URL.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/);

            if (match && match[2].length == 11) {

                self.config.playerType = 'Youtube';
                var url = 'https://www.youtube.com/embed/' + match[2];
                return url + (url.indexOf('?') > -1 ? '&' : '?') + 'rel=0&amp;showinfo=0&modestbranding=1&fs=0&iv_load_policy=3' + (self.config.autoplay ? '&amp;autoplay=1' : '');

            }

        },

        _source_vimeo: function(cfg) {

            self.config.autoplay = true;
            var url = cfg.URL;

            var userRegEx    = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(?:user\d+)\/?(?:review)\/?(\d+)(?:$|\/|\?)/;
            var userVideoKey = url.match(userRegEx);

            if (userVideoKey) {

                url = 'https://player.vimeo.com/video/' + userVideoKey[1];

            }

            if (url.match(/https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/)) {

                self.config.playerType = 'Vimeo';

                if (url.indexOf('player') < 1) { // is vimeo url, but not 'player' code

                    var keyPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;

                    if (keyPattern.test(url)) {

                        var playerUrl = 'https://player.vimeo.com/video/$1';

                        url = url.replace(keyPattern, playerUrl);

                    }

                }

                return url + (self.config.autoplay ? (url.indexOf('?') > -1 ? '&' : '?') + 'autoplay=true' : '') + '&byline=0&badge=0&portrait=0&title=0&color=333';

            } else {

                return false;

            }

        },

        _source_propertytours: function(cfg) {

            var match = cfg.URL.match(/(?:http|https)?:\/\/(?:www\.|media\.)?propertytours.tv\/(?:movies\/[\d_-]+.mp4|(\d+))/);

            if (match) {

                self.config.playerType = 'Propertytours';
                self.player_height     = 421;

                $('#movie-main').height(self.player_height)
                    .css({
                        'text-align': 'center',
                        'margin': 'auto',
                        'background-color': '#000',
                        'min-width': '620px'
                    });

                if (cfg.URL.indexOf('.mp4') > -1) {

                    return cfg.URL;

                } else {

                    return 'https://www.propertytours.tv/player/movieZ.php?pid=' + match[1];

                }

            }

        },

        _source_matterport: function(cfg) {

            var match = cfg.URL.match(/^http?s?:\/\/my\.matterport\.com\/show.+\?m=.+$/);

            if (match) {

                self.config.playerType = 'Matterport';

                return cfg.URL;

            }

        },

        _push_event: function(e) {

            dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': e.category,
                'eventAction': e.action,
                'eventLabel': e.label,
                'eventValue': undefined
            });

        }

    };

    return {
        init: self._init_player,
        validate_url: self._validate_url,
        remove: self._remove_frame,
        toggle_state: self._toggle_state
    };

})();

ZPG.util = {

    // Format numbers
    formatNumber: function(num) {

        var ret = '';

        while (num > 999) {

            var next = (num%1000);

            if (next % 1 !== 0) {
                next = parseFloat(next).toFixed(2);
            }

            if ( next < 10 ) {
                next = '00' + next;
            } else if ( next < 100 ) {
                next = '0' + next;
            }

            ret = ',' + next + ret;
            num = Math.floor(num / 1000);

        }

        ret = num + ret;
        return ret;

    },

    // Append parameters to an href
    appendParams: function(href, params) {

        $.each(params, function (key, value) {

            var values;
            if (typeof(value) == 'object' && value instanceof Array) {
                values = value;
            } else {
                values = new Array();
                values.push(value);
            }

            $.each(values, function (k, v) {
                href = href + (href.indexOf('?') == -1 ? '?' : '&') + encodeURIComponent(key) + '=' + encodeURIComponent(v);
            });

        });

        return href;

    }, 

    // Get cookie by name
    getCookie: function(c_name) {

        var i, x, y, ARRcookies = document.cookie.split(";");

        for ( i=0; i < ARRcookies.length; i++ ) {

            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
            x = x.replace(/^\s+|\s+$/g,"");

            if ( x == c_name ) {
                return decodeURIComponent(y);
            }
        }

    },

    getParameterByName: function(name, url) {
        if (!url) url = window.location.href;
        name        = name.replace(/[\[\]]/g, '\\$&');
        var regex   = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

}

ZPG.util_textarea = {

    init: function(config) {

        ZUT = ZPG.util_textarea;

        ZUT.$input = $('.textarea-limit');
        ZUT.$charsPlaceholder = $('.chars');
        ZUT.charsLimit = Number(ZUT.$charsPlaceholder.html());

        // Initial timeout function to cope with delay loading input copy with Javascript
        setTimeout(function(){

            ZUT.limitInputCopy();

        }, 500);

        // Initiate input limit text limit function on each keyup
        ZUT.$input.keyup(function(){

            ZUT.limitInputCopy();

        });

    },

    limitInputCopy: function(inputContent){

        // Current copy entered in the input
        var inputContent = ZUT.$input.val();

        // How many chars remain after each keyup event
        var numCharsRemaining = ZUT.remainingForTextArea(inputContent);

        // Update HTML tally
        ZUT.$charsPlaceholder.html(numCharsRemaining);

        // Prevent user entering more than limit amount
        if ( numCharsRemaining <= 0 ) {

            // Set HTML to display 0
            ZUT.$charsPlaceholder.html('0');

            // Trim string each time user tries to enter more than limit

            inputContentBeforeKeyup = inputContent.substring(0, ZUT.charsLimit);
            ZUT.$input.val( inputContentBeforeKeyup );

        }

    },

    remainingForTextArea: function(inputContent) {
        
        // Variables
        var inputTitle = ZUT.$input.attr('title'),
            inputContentLength;
        
        if ( inputContent ){
            inputContentLength = inputContent.length;
        } else {
            inputContentLength = 0;
        }
        
        return ZUT.charsLimit - inputContentLength;

    }

}

var highChartColors = [];

if ( $('.wl-primelocation').length > 0 ) {
    highChartColors = [ '#63cb95', '#003896', '#63cb95', '#594fbe', '#5a5a5a' ]

} else if ( $('.wl-smartnewhomes').length > 0 ) {
    highChartColors = [ '#007CBB', '#229264', '#58585b', '#116031', '#5a5a5a' ]

} else {
    highChartColors = [ '#d64521', '#b2d235', '#7ecdcd', '#ffca05', '#5a5a5a' ]

}

Highcharts.setOptions({

    chart: {
        spacingTop: 20,
        spacingBottom: 20,
        spacingLeft: 30,
        spacingRight: 30,
        style: {
            fontFamily: 'sans-serif',
            fontSize: '12px'
        },
        backgroundColor: 'rgba(255, 255, 255, 0)'
    },
    colors: highChartColors

});

ZPG.highchart = {

    config: {

        categories: '',
        colors : highChartColors,
        titleStyle: {
            color: '#999999',
            fontSize: '11px'
        },
        series: [],
        data: '',
        domId: '',
        width: 583,
        height: 300,
        lineColour: null,
        showDataPoints: true,
        xAxisType: 'category',
        xAxis: {},
        yAxis: {},
        tooltip: {
            borderColor: '#dedede',
            backgroundColor: '#eee',
            color: '#000'
        },
        tooltip_formatter: function() {
            return this.y;
        }
    },

    init: function(config) {

        ZHC = ZPG.highchart;

        var $report = $('#report');

        // Provide for custom configuration via init()
        if (config && typeof(config) == 'object') {
            $.extend(ZHC.config, config);
        }
        var plotLines = [];

        if (ZHC.config.showUkAverageLine) {
            plotLines = [{
                color: '#FF0000',
                width: 2,
                value: 100,
                label: {
                    y: -5,
                    align: 'center',
                    text: 'UK Average',
                    style: {
                        color: '#999999',
                        fontSize: '11px'

                    },
                    rotation:0
                },
                zIndex: 2
            }];
        }

        ZHC.chart = new Highcharts.Chart({

            exporting: {
                enabled: false
            },
            chart: {
                renderTo: ZHC.config.domId,
                type: ZHC.config.chartType,
                width: ZHC.config.width,
                height: ZHC.config.height
            },
            colors: ZHC.config.colors,
            title: {
                text: ZHC.config.title || null,
                style: {
                    color: ZHC.config.titleStyle.color,
                    fontSize: ZHC.config.titleStyle.fontSize
                }
            },
            tooltip: {
                borderWidth: 1,
                borderColor: ZHC.config.tooltip.borderColor,
                backgroundColor: ZHC.config.tooltip.backgroundColor,
                shadow: false,
                style: {
                    color: ZHC.config.tooltip.color
                },
                formatter: ZHC.config.tooltip_formatter
            },
            plotOptions: {
                line: {
                    marker: {
                        lineColor: ZHC.config.lineColour,
                        enabled: ZHC.config.showDataPoints
                    }
                },
                series: {
                    shadow: false
                },
                bar: {
                    dataLabels: {
                        enabled: false
                    }
                }
            },
            credits: {
                style: {
                    color: '#cccccc',
                    fontSize: '9px'
                },
                text: ZHC.config.creditsText,
                href: ''

            },
            xAxis: {
                lineColor: ZHC.config.xAxis.lineColor || '#dedede',
                lineWidth: ZHC.config.xAxis.lineWidth || 1,
                gridLineWidth: ZHC.config.xAxis.gridLineWidth || 0,
                gridLineColor: ZHC.config.yAxis.gridLineColor || "#dedede",
                type: ZHC.config.xAxisType,
                categories: ZHC.config.categories
            },
            yAxis: {
                lineColor: ZHC.config.yAxis.lineColor || "#dedede",
                lineWidth: ZHC.config.yAxis.lineWidth || 0,
                gridLineDashStyle: ZHC.config.yAxis.gridLineDashStyle || "Solid",
                gridLineColor: ZHC.config.yAxis.gridLineColor || "#dedede",
                plotLines: plotLines,
                title: {
                    style: {
                        color: '#999999'
                    },
                    text: ZHC.config.yAxisTitle
                },
                labels: {
                    overflow: 'justify'
                }
            },

            series: ZHC.config.series

        });

    }

}

var autocomplete_cache_prev_search_listings = {},
    autocomplete_cache_prev_search_properties = {},
    autocomplete_cache_prev_search_askme = {},
    autocomplete_cache_prev_search_pvi = {},
    autocomplete_cache_geo_listings = {},
    autocomplete_cache_geo_properties = {},
    autocomplete_cache_geo_askme = {},
    autocomplete_cache_geo_pvi = {},
    last_autocomplete_xhr;
var autocomplete_is_hover_select = false;

$(document).on('keydown', '.geo_autocomplete', function (e) {

    // Clear the identifier if the search text is changed - using
    // keydown here so the clear is handled before autocomplete can
    // potentially fill the identifier with a nice new value.  Don't
    // clear if the keypress was a ctrl key etc.  The numeric
    // keycodes are enter, tab, and the arrow keys.
    // If there's a cleaner way to do this (i.e. check for an actual
    // change to the input's value as it happens as opposed to on
    // blur etc. as you get with the "change" event) then I'd love
    // to know! Guy
    if (!e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey &&
        e.keyCode != 13 && e.keyCode != 9 &&
        e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40) {
        $('.geo_autocomplete_identifier').val('');
    }

    var $this = $(this);

    $this.autocomplete({

        source: function(request, response) {

            var prev_search_term = geoAutocompleteNormaliseSearchTerm(request.term);

            if (prev_search_term.length < 1) {
                return;
            }

            var geo_search_term = prev_search_term;

            var section = $('input[name="section"]:checked').val() ||
                          $('input[name="section"]').val() ||
                          $('.geo_autocomplete_identifier').attr('data-section');

            // the site section dictates which set of geo types we query for -
            // keep this section -> search type mapping in sync with the one
            // in Internal::Website::GeoAutocomplete->save_search_query_string
            var search_type;
            var autocomplete_cache_prev_search;
            var autocomplete_cache_geo;

            if (section == 'home-values' || section == 'house-prices') {

                search_type = 'properties';
                autocomplete_cache_prev_search = autocomplete_cache_prev_search_properties;
                autocomplete_cache_geo = autocomplete_cache_geo_properties;

            } else if (section == 'askme') {

                search_type = 'askme';
                autocomplete_cache_prev_search = autocomplete_cache_prev_search_askme;
                autocomplete_cache_geo = autocomplete_cache_geo_askme;

            } else if (section == 'property-value-index') {

                search_type = 'pvi';
                autocomplete_cache_prev_search = autocomplete_cache_prev_search_pvi;
                autocomplete_cache_geo = autocomplete_cache_geo_pvi;

            } else {

                search_type = 'listings';
                autocomplete_cache_prev_search = autocomplete_cache_prev_search_listings;
                autocomplete_cache_geo = autocomplete_cache_geo_listings;
            }

            // split any property number ("18a", "7", "Flat 3, 44") from the
            // search term.
            var property_num = '';
            if (search_type === 'properties') {
                var property_num_regex = /^(flat ?(\d+|\d+[a-z]|[a-z]) )?\d+[a-z]? /;
                var property_num_match = property_num_regex.exec(geo_search_term);
                if (property_num_match) {
                    geo_search_term = geo_search_term.replace(property_num_regex, '');
                    property_num = property_num_match[0];
                    if (!geo_search_term) {
                        return;
                    }
                }
            }

            var prev_search_suggestions = [];
            var geo_suggestions = [];

            // If we've already cached results then return them.  Just check
            // the geo cache - if it's in there then it'll be in the previous
            // search cache too, but not necessarily vice-versa.

            if (prev_search_term in autocomplete_cache_prev_search) {
                prev_search_suggestions = autocomplete_cache_prev_search[prev_search_term];
                geo_suggestions = autocomplete_cache_geo[geo_search_term];
                geoAutocompleteSetSearchResponse(
                    response,
                    prev_search_suggestions,
                    geo_suggestions,
                    search_type,
                    property_num
                );
                return;
            }


            // If we've cached results for a shorter form of the search term
            // (whether empty results or not) then examine them to see if we
            // can use them instead of performing an AJAX call to get
            // results.

            prev_search_suggestions =
                geoAutocompleteGetDerivedSuggestions(
                    autocomplete_cache_prev_search,
                    prev_search_term,
                    10
            );
            // don't bother populating geo_suggestions if
            // prev_search_suggestions didn't get populated
            geo_suggestions = prev_search_suggestions ?
                geoAutocompleteGetDerivedSuggestions(
                autocomplete_cache_geo,
                geo_search_term,
                10
            ) : undefined;

            if (prev_search_suggestions && geo_suggestions) {

                prev_search_suggestions =
                    geoAutocompleteHighlightValues(prev_search_suggestions, prev_search_term);
                geo_suggestions =
                    geoAutocompleteHighlightValues(geo_suggestions, geo_search_term);

                autocomplete_cache_prev_search[prev_search_term] = prev_search_suggestions;
                autocomplete_cache_geo[geo_search_term] = geo_suggestions;

                geoAutocompleteSetSearchResponse(
                    response,
                    prev_search_suggestions,
                    geo_suggestions,
                    search_type,
                    property_num
                );
                return;
            }


            // we've failed to get suggestions from our local cache, so perform
            // an AJAX call to get them
            last_autocomplete_xhr = $.getJSON('/ajax/search/geo_autocomplete/',
                                                {
                                                    prev_search_term: prev_search_term,
                                                    geo_search_term: geo_search_term,
                                                    search_type: search_type
                                                },
                                                function(data, status, xhr) {

                // highlight previous search suggestions
                prev_search_suggestions = geoAutocompleteHighlightValues(data.p || [], prev_search_term);

                // process and highlight geo suggestions
                geo_suggestions = $.map(data.g || [], function(geo_suggestion) {
                    // for values like "Edinburgh [(County)]", make the value
                    // "Edinburgh" and store the suffix for later appending to
                    // the suggestion, a la "Edinburgh <s>(County)</s>"
                    var suffix_regex = new RegExp(' \\[(.*)\\]$');
                    var suffix_match = suffix_regex.exec(geo_suggestion.v);
                    if (suffix_match) {
                        geo_suggestion.v = geo_suggestion.v.replace(suffix_regex, '');
                        geo_suggestion.s = suffix_match[1];
                    }
                    return geo_suggestion;
                });
                geo_suggestions = geoAutocompleteHighlightValues(geo_suggestions, geo_search_term);

                autocomplete_cache_prev_search[prev_search_term] = prev_search_suggestions;
                autocomplete_cache_geo[geo_search_term] = geo_suggestions;

                if (xhr == last_autocomplete_xhr) {
                    geoAutocompleteSetSearchResponse(
                        response,
                        prev_search_suggestions,
                        geo_suggestions,
                        search_type,
                        property_num
                    );
                }
            });

        },
        select: function( event, ui ) {
            // prevent situation where user's mouse just happens to be hovering
            // a suggestion, they hit enter, and that suggestion is selected -
            // instead they need to have actually clicked the suggestion or focussed
            // it previously (see the focus() function below) using the keyboard.
            var truly_click = (!event.keyCode && !event.button);

            if (truly_click == false &&
                ( (autocomplete_is_hover_select == true && typeof event.keyCode != 'undefined' && event.keyCode != 0))) {
                //just tabbed or hovered and hit enter
                event.preventDefault();
            } else {
                if ( $('body').is('[class*="ie-"]') ) {
                } else {
                    if ($(event.srcElement || event.target).hasClass('delete_autocomplete_suggestion')) {
                        return false;
                    }
                }
                $('.geo_autocomplete_identifier').val(ui.item.i);
                $('.geo_autocomplete').val(ui.item.v).change();
            }

            return false;
        },
        focus: function( event, ui ) {
            if (typeof event.keyCode === 'undefined' || event.keyCode == 0) {
                autocomplete_is_hover_select = true;
            } else {
                autocomplete_is_hover_select = false;
            }
            return false;
        },
        appendTo: $this.hasClass('search-refine-location') ? $('.search-refine-location-autocomplete-results') : ($('#fancybox-content').is(':visible') ? $('#fancybox-content') : $('body')),
        position: {
                    my: "right top",
                    at: "right bottom"
                },
        minLength: 1,
        delay: 5
    }).each(function() {
        $(this).data("ui-autocomplete")._renderMenu = function( ul, data ) {

            var prev_search_suggestions = data[0].prev_search_suggestions || [];
            var geo_suggestions = data[0].geo_suggestions || [];
            var search_type = data[0].search_type;

            $.each(prev_search_suggestions, function(index, item) {
                geoAutocompleteRenderPrevSearchItem(ul, item, search_type);
            });

            if (prev_search_suggestions.length && geo_suggestions.length) {
                ul.append('<li id="autocomplete_suggestions_divider"></li>');
            }

            $.each(geo_suggestions, function(index, item) {
                geoAutocompleteRenderGeoItem(ul, item);
            });

            // On the mobile site we need to add extra list items to allow us to scroll the overflow without scrolling the page
            if ($('.geo_autocomplete').attr('data-mobile') === 'true') {
                for (x=0;x<20;x++) {
                    ul.append('<li class="ui-autocomplete-placeholder"><span>&nbsp;</span></li>');
                }
            }
        }
    });
});


function geoAutocompleteRenderPrevSearchItem( ul, item, search_type ) {
    return $( '<li data-value="' + escape(item.v) + '"></li>' )
        .data( "ui-autocomplete-item", item )
        .append( "<a>" + item.l + "</a>" )
        .append('<span title="Delete suggestion" class="delete_autocomplete_suggestion" ' +
                'data-value="' + escape(item.v) + '" ' +
                'data-search-type="' + search_type + '"' +
                '>&times;</span>')
        .addClass('previous_query_string')
        .appendTo( ul );
}

function geoAutocompleteRenderGeoItem( ul, item ) {
    var li = $( '<li></li>' )
        .data( "ui-autocomplete-item", item )
        .append( "<a>" + item.l + "</a>" );

    if (item.c) {
        $(li).addClass('geo-category-'+item.c);
    }

    $(li).appendTo( ul );

    return li;
}

function geoAutocompleteSetSearchResponse (response, prev_search_suggestions, geo_suggestions, search_type, property_num) {
    // Instead of returning a simple array of suggestions for
    // _renderMenu to iterate over, we're instead returning a 1-element
    // array of [{prev_search_suggestions, geo_suggestions, search_type}].
    // We return an empty array if we have no results - if you don't do
    // that then JQuery UI autocomplete will call _renderMenu, causing an
    // an empty menu <ul> to be rendered.
    // We also check if there's still a value in the search input - if not
    // then we return no suggestions.  This is to fix an issue whereby a
    // user could type a search term, delete it, and the autocomplete
    // would struggle to keep up, causing it to show a set of suggestions
    // for an empty search term
    if ($('.geo_autocomplete').val() &&
        (prev_search_suggestions && prev_search_suggestions.length ||
         geo_suggestions && geo_suggestions.length)) {

        if (property_num) {

            // tidy "flat 33a 44 " to "Flat 33A, 44 "
            property_num = property_num.toUpperCase()
                                        .replace(/FLAT/, 'Flat')
                                        .replace(/^Flat (\S+) (\S+) $/, "Flat $1, $2 ");

            // clone the suggestions so our prefixing of the property_num
            // doesn't affect the cached suggestions
            geo_suggestions = $.extend(true, [], geo_suggestions);

            $.map(geo_suggestions, function(geo_suggestion) {
                geo_suggestion.l = '<em>' + property_num + '</em>' + geo_suggestion.l;
                geo_suggestion.v = property_num + geo_suggestion.v;
            });
        }
        response([{
            prev_search_suggestions: prev_search_suggestions,
            geo_suggestions: geo_suggestions,
            search_type: search_type
        }]);
    } else {
        response([]);
    }
    return;
}

// given one of the autocomplete cache maps (search term -> [suggestions])
// and a search term, check if suggestions for a shorter version of the
// search term are in the cache.  If they are then see if we can derive
// our new set of suggestions from them, saving us an AJAX call.
function geoAutocompleteGetDerivedSuggestions( cache, term, maxSuggestions ) {
    var shorter_term_length = term.length - 1;
    while (shorter_term_length >= 1) {
        var shorter_term = term.substr(0, shorter_term_length--);
        if (shorter_term in cache) {

            var prior_suggestions = cache[shorter_term];

            // if we got zero suggestions for a shorter version of our
            // search term, we can return zero suggestions for our new
            // longer term.
            if (prior_suggestions.length == 0) {
                return [];

            // else if we got less than the max number of suggestions
            // for a shorter version of our search term then we can just
            // filter those suggestions by our new longer term
            } else if (prior_suggestions.length < maxSuggestions) {
                // clone the prior suggestions so we don't stop on their
                // highlighting etc.
                prior_suggestions = $.extend(true, [], prior_suggestions);

                return $.grep(prior_suggestions, function(suggestion) {
                    var normalised_value = geoAutocompleteNormaliseSearchTerm(suggestion.v);
                    var term_pattern = '^' + geoAutocompleteApplyStreetTypeExpansions(term);
                    var term_regex = new RegExp(term_pattern);
                    return term_regex.test(normalised_value);
                });

            // else if every suggestion matches our search term then
            // we can use them as-is.
            } else {
                var all_matched = 1;
                $.each(prior_suggestions, function(index, suggestion) {
                    var normalised_value = geoAutocompleteNormaliseSearchTerm(suggestion.v);
                    var term_pattern = '^' + geoAutocompleteApplyStreetTypeExpansions(term);
                    var term_regex = new RegExp(term_pattern);

                    // if any of the prior suggestions doesn't match our
                    // search term then we can't use them to derive our new
                    // suggestions
                    if (! term_regex.test(normalised_value)) {
                        all_matched = 0;
                        return false;
                    }
                });

                if (all_matched) {
                    // clone the prior suggestions so we don't stomp on their
                    // highlighting etc.
                    prior_suggestions = $.extend(true, [], prior_suggestions);
                    return prior_suggestions;
                } else {
                    return;
                }

            }
        }
    }
    return;
}

function geoAutocompleteApplyStreetTypeExpansions( term ) {

    // the following list of expansions needs to be kept in sync with
    // the one in Internal::Search::GeoAutocomplete::Query

    return term.replace(/ st /g, ' st(reet)? ')
                .replace(/ av /g, ' av(enue)? ')
                .replace(/ ave /g, ' ave(nue)? ')
                .replace(/ cl /g, ' cl(ose)? ')
                .replace(/ cres /g, ' cres(cent)? ')
                .replace(/ dr /g, ' dr(ive)? ')
                .replace(/ pl /g, ' pl(ace)? ')
                .replace(/ sq /g, ' sq(uare)? ')
                .replace(/ st /g, ' st(reet)? ')

                // note that the following street type expansions
                // are different to the above in that they don't
                // require a following space char
                .replace(/ ct/g, ' (ct|court)')
                .replace(/ ln/g, ' (ln|lane)')
                .replace(/ rd/g, ' (rd|road)');
}

function geoAutocompleteHighlightValues( items, term ) {

    items = $.map(items, function(item) {
        item.l = geoAutocompleteHighlightValue(item.v, term);
        if (item.s) {
            // wrap outcodes in a span so we can give them a consistent
            // width and so have their suffixed names line up
            if (item.v.length <= 4) {
                item.l = '<span class="autocomplete_outcode">' + item.l + '</span>';
            }
            item.l += ' <s>' + item.s + '</s>';
        }
        return item;
    });
    return items;
}

function geoAutocompleteHighlightValue( value, term ) {
    term = geoAutocompleteApplyStreetTypeExpansions(term);

    // normalise ' and ' to ' & '
    term = term.replace(/ and /g, ' & ');

    // ignore apostrophes
    term = term.replace(/(\w)/g, "'?$1");

    // if the value is a postcode, allow for the search term to be missing
    // spaces (e.g. user searches for rg53bn, but we still want to
    // successfully highlight RG5 3BN
    if (value.match(/^[A-Z]{1,2}[0-9][0-9A-Z]? [0-9][A-Z]{2}$/)) {
        term = term.replace(/([a-z0-9])/g, '$1\\s?');
    }

    // treat all non-alphanumeric-or-ampersand chars as space
    term = term.replace(/ /g, '[^A-Za-z0-9&]+');

    // allow 'and' or '&' for '&'
    term = term.replace(/[^9]&/g, '(&|and)');

    var pattern = '^(' + term + ')';
    var regex = new RegExp(pattern, 'i');
    return value.replace(regex, "<em>$1</em>");
}

function geoAutocompleteNormaliseSearchTerm ( term ) {
    return term.toLowerCase()
                .replace(/^\s\s*/, '')
                .replace(/'/g, '')
                .replace(/&/g, ' and ')
                .replace(/[^a-z0-9]+/g, ' ')
                .replace(/\s\s+/g, ' ');
}

// allow users to delete a previous search string autocomplete suggestion
// so they don't get offered it again.
$(document).on('click', '.delete_autocomplete_suggestion', function(event) {
    var previous_search_string = unescape($(this).attr('data-value')),
        search_type = unescape($(this).attr('data-search-type')),
        li_element = $(this).parent();
    $.get(
        '/ajax/search/geo_autocomplete/delete_suggestion/',
        {
            'previous_search_string' : previous_search_string,
            'search_type' : search_type
        },
        function() {
            var autocomplete_cache_prev_search = search_type === 'listings' ?
                autocomplete_cache_prev_search_listings :
                autocomplete_cache_prev_search_properties;

            // delete previous search from autocomplete_cache_prev_search
            $.each(autocomplete_cache_prev_search, function(index, suggestions) {
                suggestions = $.grep(suggestions, function(suggestion) {
                    return suggestion.v != previous_search_string;
                });
                autocomplete_cache_prev_search[index] = suggestions;
            });

            // if we're removing the last prev search suggestion then also
            // remove the divider between the prev search suggestions and the
            // geo suggestions
            if ($('li.previous_query_string:visible').length == 1) {
                $('li#autocomplete_suggestions_divider').hide();
            }

            li_element.slideUp(200);

            if ($('ul.ui-autocomplete li[role=menuitem]:visible').length <= 1) {
                $('ul.ui-autocomplete').slideUp(200);
            }

        }
    );
    return false;
});

$(document).on('autocompleteselect', '.geo_autocomplete.search-refine-location', function(event, ui){
    $(this).trigger('change');
    $(this).autocomplete('destroy');
});

var autocomplete_cache_prev_search_listings = {},
    autocomplete_cache_geo_listings = {},
    last_autocomplete_xhr;
var autocomplete_is_hover_select = false;


$('.overseas_geo_autocomplete').on('click', function () {
    var keyDownEvent = jQuery.Event('keydown', { dontClearIdentifier: 1 });
    $('.overseas_geo_autocomplete').trigger(keyDownEvent);
    $('.overseas_geo_autocomplete').trigger(keyDownEvent);
    return false;
});

$('.overseas_geo_autocomplete').on('keydown', function (e) {

    // store these so we can use em later rather than traversing the DOM every time
    var oga_element = this;

    // Clear the identifier if the search text is changed - using
    // keydown here so the clear is handled before autocomplete can
    // potentially fill the identifier with a nice new value.  Don't
    // clear if the keypress was a ctrl key etc.  The numeric
    // keycodes are enter, tab, and the arrow keys.
    // If there's a cleaner way to do this (i.e. check for an actual
    // change to the input's value as it happens as opposed to on
    // blur etc. as you get with the "change" event) then I'd love
    // to know! Guy
    if (!e.dontClearIdentifier && !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey &&
        e.keyCode != 13 && e.keyCode != 9 &&
        e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40) {
        $('.overseas_geo_autocomplete_identifier').val('').change();
    }

    $(this).autocomplete({

        source: function(request, response) {

            var prev_search_term = overseasGeoAutocompleteNormaliseSearchTerm(request.term);

            if (prev_search_term.length < 1) {
                // hacking for popular locations to appear without anything typed in
                //return;
                prev_search_term = '';
            }

            var geo_search_term = prev_search_term;

            // TJ ugly patch for some issues with refine search - TODO find a better way
            var country_code = $(oga_element).closest('form').find('select[name="country_code"]').val();
            if (!country_code) country_code = $(oga_element).closest('form').find('input[name="country_code"]').val();

            if (!country_code) {
                return;
            }

            var autocomplete_cache_prev_search, autocomplete_cache_geo;
                autocomplete_cache_prev_search = autocomplete_cache_prev_search_listings;
                autocomplete_cache_geo = autocomplete_cache_geo_listings;

            var prev_search_suggestions = [];
            var geo_suggestions = [];

            // If we've already cached results then return them.  Just check
            // the geo cache - if it's in there then it'll be in the previous
            // search cache too, but not necessarily vice-versa.

            if (country_code+prev_search_term in autocomplete_cache_prev_search) {
                prev_search_suggestions = autocomplete_cache_prev_search[country_code+prev_search_term];
                geo_suggestions = autocomplete_cache_geo[country_code+geo_search_term];
                overseasGeoAutocompleteSetSearchResponse(
                    response,
                    prev_search_suggestions,
                    geo_suggestions,
                    country_code
                );
                return;
            }


            // If we've cached results for a shorter form of the search term
            // (whether empty results or not) then examine them to see if we
            // can use them instead of performing an AJAX call to get
            // results.

            //prev_search_suggestions = 1 ? undefined :
            prev_search_suggestions =
                overseasGeoAutocompleteGetDerivedSuggestions(
                    autocomplete_cache_prev_search,
                    prev_search_term,
                    country_code,
                    10
            );
            // don't bother populating geo_suggestions if
            // prev_search_suggestions didn't get populated
            geo_suggestions = prev_search_suggestions ?
                overseasGeoAutocompleteGetDerivedSuggestions(
                autocomplete_cache_geo,
                geo_search_term,
                country_code,
                10
            ) : undefined;

            if (prev_search_suggestions && geo_suggestions) {
                prev_search_suggestions =
                    overseasGeoAutocompleteHighlightValues(prev_search_suggestions, prev_search_term);
                geo_suggestions =
                    overseasGeoAutocompleteHighlightValues(geo_suggestions, geo_search_term);

                autocomplete_cache_prev_search[country_code+prev_search_term] = prev_search_suggestions;
                autocomplete_cache_geo[country_code+geo_search_term] = geo_suggestions;

                overseasGeoAutocompleteSetSearchResponse(
                    response,
                    prev_search_suggestions,
                    geo_suggestions,
                    country_code
                );
                return;
            }


            // we've failed to get suggestions from our local cache, so perform
            // an AJAX call to get them
            last_autocomplete_xhr = $.getJSON('/ajax/search/overseas_geo_autocomplete/',
                                                {
                                                    prev_search_term: prev_search_term,
                                                    geo_search_term: geo_search_term,
                                                    country_code: country_code
                                                },
                                                function(data, status, xhr) {

                // highlight previous search suggestions
                prev_search_suggestions = overseasGeoAutocompleteHighlightValues(data.p || [], prev_search_term);

                // process and highlight geo suggestions
                geo_suggestions = $.map(data.g || [], function(geo_suggestion) {
                    // for values like "Edinburgh [(County)]", make the value
                    // "Edinburgh" and store the suffix for later appending to
                    // the suggestion, a la "Edinburgh <s>(County)</s>"
                    var suffix_regex = new RegExp(' \\[(.*)\\]$');
                    var suffix_match = suffix_regex.exec(geo_suggestion.v);
                    if (suffix_match) {
                        geo_suggestion.v = geo_suggestion.v.replace(suffix_regex, '');
                        geo_suggestion.s = suffix_match[1];
                    }
                    return geo_suggestion;
                });
                geo_suggestions = overseasGeoAutocompleteHighlightValues(geo_suggestions, geo_search_term);

                autocomplete_cache_prev_search[country_code+prev_search_term] = prev_search_suggestions;
                autocomplete_cache_geo[country_code+geo_search_term] = geo_suggestions;

                if (xhr == last_autocomplete_xhr) {
                    overseasGeoAutocompleteSetSearchResponse(
                        response,
                        prev_search_suggestions,
                        geo_suggestions,
                        country_code
                    );
                }
            });

        },
        select: function( event, ui ) {
            // prevent situation where user's mouse just happens to be hovering
            // a suggestion, they hit enter, and that suggestion is selected -
            // instead they need to have actually clicked the suggestion or focussed
            // it previously (see the focus() function below) using the keyboard.
            var truly_click = false;
            if (event.originalEvent.originalEvent.type == "click") {
                truly_click = true;
            }

            if (truly_click == false &&
                ( (autocomplete_is_hover_select == true && typeof event.keyCode != 'undefined' && event.keyCode != 0))) {
                //just tabbed or hovered and hit enter
                event.preventDefault();
            } else {
                $('.overseas_geo_autocomplete_identifier').val(ui.item.i).change();
                $('.overseas_geo_autocomplete').val(ui.item.v);
            }

            return false;
        },
        focus: function( event, ui ) {
            if (typeof event.keyCode === 'undefined' || event.keyCode == 0) {
                autocomplete_is_hover_select = true;
            } else {
                autocomplete_is_hover_select = false;
            }
            return false;
        },
        appendTo: $('#fancybox-content').is(':visible') ? $('#fancybox-content') : $('body'),
        position: {
                    my: "left top",
                    at: "left bottom"
                },
        minLength: 0,
        delay: 5
    }).each(function() {
        $(this).data("ui-autocomplete")._renderMenu = function( ul, data ) {

            var prev_search_suggestions = data[0].prev_search_suggestions || [];
            var geo_suggestions = data[0].geo_suggestions || [];
            var country_code = data[0].country_code;

            $.each(prev_search_suggestions, function(index, item) {
                overseasGeoAutocompleteRenderPrevSearchItem(ul, item, country_code);
            });

            if (prev_search_suggestions.length && geo_suggestions.length) {
                ul.append('<li id="autocomplete_suggestions_divider"></li>');
            }

            $.each(geo_suggestions, function(index, item) {
                overseasGeoAutocompleteRenderGeoItem(ul, item);
            });

            // On the mobile site we need to add extra list items to allow us to scroll the overflow without scrolling the page
            if ($('.overseas_geo_autocomplete').attr('data-mobile') === 'true') {
                for (x=0;x<20;x++) {
                    ul.append('<li class="ui-autocomplete-placeholder"><span>&nbsp;</span></li>');
                }
            }
        }
    });
});

function overseasGeoAutocompleteRenderPrevSearchItem( ul, item, country_code ) {
    return $( '<li data-value="' + escape(item.v) + '"></li>' )
        .data( "ui-autocomplete-item", item )
        .append( "<a>" + item.l + "</a>" )
        .append('<span title="Delete suggestion" class="delete_overseas_autocomplete_suggestion" ' +
                'data-value="' + escape(item.v) + '" ' +
                'data-country-code="' + country_code + '"' +
                '>&times;</span>')
        .addClass('previous_query_string')
        .appendTo( ul );
}

function overseasGeoAutocompleteRenderGeoItem( ul, item ) {
    return $( '<li></li>' )
        .data( "ui-autocomplete-item", item )
        .append( "<a>" + item.l + "</a>" )
        .appendTo( ul );
}

function overseasGeoAutocompleteSetSearchResponse (response, prev_search_suggestions, geo_suggestions, country_code) {
    // Instead of returning a simple array of suggestions for
    // _renderMenu to iterate over, we're instead returning a 1-element
    // array of [{prev_search_suggestions, geo_suggestions, country_code}].
    // We return an empty array if we have no results - if you don't do
    // that then JQuery UI autocomplete will call _renderMenu, causing an
    // an empty menu <ul> to be rendered.
    // We also check if there's still a value in the search input - if not
    // then we return no suggestions.  This is to fix an issue whereby a
    // user could type a search term, delete it, and the autocomplete
    // would struggle to keep up, causing it to show a set of suggestions
    // for an empty search term
    if (
        //$('.overseas_geo_autocomplete').val() && -> showing top locations if there is no value typed
        (prev_search_suggestions && prev_search_suggestions.length ||
         geo_suggestions && geo_suggestions.length)) {

        response([{
            prev_search_suggestions: prev_search_suggestions,
            geo_suggestions: geo_suggestions,
            country_code: country_code
        }]);
    } else {
        response([]);
    }
    return;
}

// given one of the autocomplete cache maps (search term -> [suggestions])
// and a search term, check if suggestions for a shorter version of the
// search term are in the cache.  If they are then see if we can derive
// our new set of suggestions from them, saving us an AJAX call.
function overseasGeoAutocompleteGetDerivedSuggestions( cache, term, country_code, maxSuggestions ) {
    var shorter_term_length = term.length - 1;
    while (shorter_term_length >= 1) {
        var shorter_term = term.substr(0, shorter_term_length--);
        if (country_code+shorter_term in cache) {

            var prior_suggestions = cache[country_code+shorter_term];

            // if we got zero suggestions for a shorter version of our
            // search term, we can return zero suggestions for our new
            // longer term.
            if (prior_suggestions.length == 0) {
                return [];

            // else if we got less than the max number of suggestions
            // for a shorter version of our search term then we can just
            // filter those suggestions by our new longer term
            } else if (prior_suggestions.length < maxSuggestions) {
                // clone the prior suggestions so we don't stop on their
                // highlighting etc.
                prior_suggestions = $.extend(true, [], prior_suggestions);

                return $.grep(prior_suggestions, function(suggestion) {
                    var normalised_value = overseasGeoAutocompleteNormaliseSearchTerm(suggestion.a?suggestion.a:suggestion.v);
                    var term_pattern = '^' + term;
                    var term_regex = new RegExp(term_pattern);
                    return term_regex.test(normalised_value);
                });

            // else if every suggestion matches our search term then
            // we can use them as-is.
            } else {
                var all_matched = 1;
                $.each(prior_suggestions, function(index, suggestion) {
                    var normalised_value = overseasGeoAutocompleteNormaliseSearchTerm(suggestion.a?suggestion.a:suggestion.v);
                    var term_pattern = '^' + term;
                    var term_regex = new RegExp(term_pattern);

                    // if any of the prior suggestions doesn't match our
                    // search term then we can't use them to derive our new
                    // suggestions
                    if (! term_regex.test(normalised_value)) {
                        all_matched = 0;
                        return false;
                    }
                });

                if (all_matched) {
                    // clone the prior suggestions so we don't stomp on their
                    // highlighting etc.
                    prior_suggestions = $.extend(true, [], prior_suggestions);
                    return prior_suggestions;
                } else {
                    return;
                }

            }
        }
    }
    return;
}

function overseasGeoAutocompleteHighlightValues( items, term ) {

    items = $.map(items, function(item) {
        item.l = overseasGeoAutocompleteHighlightValue(item.v, term);
        if (item.s) {
            // wrap outcodes in a span so we can give them a consistent
            // width and so have their suffixed names line up
            if (item.v.length <= 4) {
                item.l = '<span class="autocomplete_outcode">' + item.l + '</span>';
            }
            item.l += ' <s>' + item.s + '</s>';
        }
        return item;
    });
    return items;
}

function overseasGeoAutocompleteHighlightValue( value, term ) {
    var len = term.length;
    if (len < value.length) {
        var pre = value.substring(0,len);
        var post = value.substring(len);
        return( '<em>' + pre + '</em>' + post );
    } else {
        return( '<em>' + value + '</em>' );
    }
}

function overseasGeoAutocompleteHighlightValue_old( value, term ) {

    // normalise ' and ' to ' & '
    term = term.replace(/ and /g, ' & ');

    // ignore apostrophes
    term = term.replace(/(\w)/g, "'?$1");

    // if the value is a postcode, allow for the search term to be missing
    // spaces (e.g. user searches for rg53bn, but we still want to
    // successfully highlight RG5 3BN
    if (value.match(/^[A-Z]{1,2}[0-9][0-9A-Z]? [0-9][A-Z]{2}$/)) {
        term = term.replace(/([a-z0-9])/g, '$1\\s?');
    }

    // treat all non-alphanumeric-or-ampersand chars as space
    term = term.replace(/ /g, '[^A-Za-z0-9&]+');

    // allow 'and' or '&' for '&'
    term = term.replace(/[^9]&/g, '(&|and)');

    var pattern = '^(' + term + ')';
    var regex = new RegExp(pattern, 'i');
    return value.replace(regex, "<em>$1</em>");
}

function overseasGeoAutocompleteNormaliseSearchTerm ( term ) {
    return term.toLowerCase()
                .replace(/^\s\s*/, '')
                .replace(/'/g, '')
                .replace(/&/g, ' and ')
                .replace(/[^a-z0-9]+/g, ' ')
                .replace(/\s\s+/g, ' ');
}

// allow users to delete a previous search string autocomplete suggestion
// so they don't get offered it again.
$(document).on('click', '.delete_overseas_autocomplete_suggestion', function(event) {
    var previous_search_string = unescape($(this).attr('data-value'));
    var country_code = unescape($(this).attr('data-country-code'));
    var li_element = $(this).parent();
    $.get(
        '/ajax/search/overseas_geo_autocomplete/delete_suggestion/',
        {
            'previous_search_string' : previous_search_string,
            'country_code' : country_code
        },
        function() {
            var autocomplete_cache_prev_search = autocomplete_cache_prev_search_listings;

            // delete previous search from autocomplete_cache_prev_search
            $.each(autocomplete_cache_prev_search, function(index, suggestions) {
                suggestions = $.grep(suggestions, function(suggestion) {
                    return suggestion.v != previous_search_string;
                });
                autocomplete_cache_prev_search[index] = suggestions;
            });

            // if we're removing the last prev search suggestion then also
            // remove the divider between the prev search suggestions and the
            // geo suggestions
            if ($('li.previous_query_string:visible').length == 1) {
                $('li#autocomplete_suggestions_divider').hide();
            }

            li_element.slideUp(200);

            if ($('ul.ui-autocomplete li[role=menuitem]:visible').length <= 1) {
                $('ul.ui-autocomplete').slideUp(200);
            }

        }
    );
    return false;
});



var price_frequency = function() {

    if ( $('#price_frequency').val() == 'per_month' ) {

        var existing_min = $('#rent_price_min_per_week').val();
        var min_index = 0;
        if (existing_min) {
            var delta = undefined;
            var t_monthly_min = (existing_min * 52 / 12);
            $('#rent_price_min_per_month option').each(function(i, option) {
                    var diff = Math.abs(t_monthly_min - $(option).val());
                    if (diff < delta || delta == undefined) {
                        min_index = i;
                        delta = diff;
                    }
                });
        }

        var existing_max = $('#rent_price_max_per_week').val();
        var max_index = 0;
        if (existing_max) {
            var delta = undefined;
            var t_monthly_max = (existing_max * 52 / 12);
            $('#rent_price_max_per_month option').each(function(i, option) {
                    var diff = Math.abs(t_monthly_max - $(option).val());
                    if (diff < delta || delta == undefined) {
                        max_index = i;
                        delta = diff;
                    }
                });
        }

        $('#rent_price_min_per_week,#rent_price_max_per_week').prop('disabled','disabled').addClass('none');
        $('#rent_price_min_per_month,#rent_price_max_per_month').prop('disabled','').removeClass('none');

        $('#rent_price_min_per_month').prop('selectedIndex', min_index);
        $('#rent_price_max_per_month').prop('selectedIndex', max_index);

    } else {

        var existing_min = $('#rent_price_min_per_month').val();
        var min_index = 0;
        if (existing_min) {
            var delta = undefined;
            var t_weekly_min = (existing_min / 52 * 12);
            $('#rent_price_min_per_week option').each(function(i, option) {
                    var diff = Math.abs(t_weekly_min - $(option).val());
                    if (diff < delta || delta == undefined) {
                        min_index = i;
                        delta = diff;
                    }
                });
        }

        var existing_max = $('#rent_price_max_per_month').val();
        var max_index = 0;
        if (existing_max) {
            var delta = undefined;
            var t_weekly_max = (existing_max / 52 * 12);
            $('#rent_price_max_per_week option').each(function(i, option) {
                    var diff = Math.abs(t_weekly_max - $(option).val());
                    if (diff < delta || delta == undefined) {
                        max_index = i;
                        delta = diff;
                    }
                });
        }

        $('#rent_price_min_per_week,#rent_price_max_per_week').prop('disabled','').removeClass('none');
        $('#rent_price_min_per_month,#rent_price_max_per_month').prop('disabled','disabled').addClass('none');

        $('#rent_price_min_per_week').prop('selectedIndex', min_index);
        $('#rent_price_max_per_week').prop('selectedIndex', max_index);
    }

}

$('#price_frequency').change(function() {

    price_frequency();

});


var old_floor_area_units = $('#floor_area_units').val();

var floor_area_units = function() {

    var units = $('#floor_area_units').val();

    // set the dropdowns for the new types according to the values of the old
    $('select.floor_area_max, select.floor_area_min').prop('disabled', 'disabled').parent().addClass('none');
    $('select#floor_area_min_'+units+', select#floor_area_max_'+units).prop('disabled', '').parent().removeClass('none');

    var min_index = 0;
    var max_index = 0;

    $('#floor_area_min_'+units).prop('selectedIndex', min_index);
    $('#floor_area_max_'+units).prop('selectedIndex', max_index);

    var sq_m_to_acres = 0.000247105381;
    var sq_m_to_sq_feet = 10.7639104;

    var min_val_sq_m;
    var max_val_sq_m;

    // if we know the past units then we can set the drop down value to the
    // equivalent of whatever the past one was
    if (typeof(old_floor_area_units) != 'undefined') {
        var min_val = $('#floor_area_min_'+old_floor_area_units).val();
        var max_val = $('#floor_area_max_'+old_floor_area_units).val();

        if (old_floor_area_units == 'sq_metres') {
            // values are as we need them
            min_val_sq_m = min_val;
            max_val_sq_m = max_val;
        } else if (old_floor_area_units == 'sq_feet') {
            min_val_sq_m = min_val / sq_m_to_sq_feet;
            max_val_sq_m = max_val / sq_m_to_sq_feet;
        } else if (old_floor_area_units == 'acres') {
            min_val_sq_m = min_val / sq_m_to_acres;
            max_val_sq_m = max_val / sq_m_to_acres;
        }

        // convert the old values to the new values
        var new_min_val;
        var new_max_val;

        if (units == 'sq_metres') {
            // nothing to do
            new_min_val = min_val_sq_m;
            new_max_val = max_val_sq_m;
        } else if (units == 'sq_feet') {
            new_min_val = min_val_sq_m * sq_m_to_sq_feet;
            new_max_val = max_val_sq_m * sq_m_to_sq_feet;
        } else if (units == 'acres') {
            new_min_val = min_val_sq_m * sq_m_to_acres;
            new_max_val = max_val_sq_m * sq_m_to_acres;
        }

        var nearestMin;
        var nearestMax;
        var thatDelta;

        $('#floor_area_min_'+units+' option').each(function () {
            var this_delta = Math.abs(new_min_val - $(this).val());

            if (typeof(nearestMin) == 'undefined' || this_delta < thatDelta) {
                nearestMin = $(this).val();
                thatDelta = this_delta;
            }
        });

        $('#floor_area_max_'+units+' option').each(function () {
            var this_delta = Math.abs(new_max_val - $(this).val());

            if (typeof(nearestMax) == 'undefined' || this_delta < thatDelta) {
                nearestMax = $(this).val();
                thatDelta = this_delta;
            }
        });

        $('#floor_area_min_'+units).val(nearestMin);
        $('#floor_area_max_'+units).val(nearestMax);
    }

    old_floor_area_units = units;
}

$('#floor_area_units').change(function() {

    floor_area_units();

});



ZPG.calculator = function ( options ) {

    var me = {

        options: $.extend({
        }, options),

        init: function( action, href ) {

            me._calculate( false );

            // Initialise slider
            $( "#calc-term-slider" ).slider({
                range: "max",
                min: 3,
                max: 35,
                value: 35,
                step: 1,
                change: function() {
                    if ( me.options.type === "affordability" ) {
                        me._calculateAffordability();
                    }
                    me._trackEvent( "Slider" );
                    me.googlePush();
                },
                slide: function( event, ui ) {
                    $( "#calc-term" ).val( ui.value );
                }
            });

            // Update term slider when user changes in input field
            $( document ).on( "change" , "#calc-term", function() {

                var $el = $( this ),
                    $mySlider = $( "#calc-term-slider" ),
                    newValue = $el.val();

                $mySlider.slider( "value", newValue );

            });

            // Select inputs onFocus to make editing easier
            $( document ).on( "change", ".calc-form input", function() {
                me._trackEvent( "Input change" );
                me.googlePush();
            });

            $( document ).on( "change", ".calc-form input, .calc-form select", function() {
                me._calculate();
            });


            // Select inputs onFocus to make editing easier
            $( document ).on( "focus", ".calc-form input", function() {
                $( this ).select();
                me._trackEvent( "Input focus" );
            });

            // Re-calculate monthly payment when "Calculate" clicked
            $( document ).on( "click", "#calc-calculate", function() {

                me._calculate();
                me._trackEvent( "Calculate" );

            });

        },

        _calculate: function( track ) {

            if ( me.options.type === "affordability" ) {
                me._calculateAffordability();
            } else if ( me.options.type === "mortgage" || me.options.type === "remortgage" ) {
                me._calculateMortgage();
            }

            if ( track !== false ) {
                me.googlePush();
            }

        },

        googlePush: function() {

            if ( typeof me.options.google_loan_type !== "undefined" && typeof window.google_tag_params !== "undefined" ) {

                window.google_tag_params.LOAN_type = me.options.google_loan_type;

                window.google_trackConversion({
                    google_conversion_id: me.options.google_conversion_id,
                    google_custom_params: window.google_tag_params,
                    google_remarketing_only: true
                });

            }

        },

        _trackEvent: function( action ) {

            var category = $( ".calc-help" ).attr( "data-ga-category" );

            dataLayer.push({
                event: "GAEvent",
                eventCategory: category,
                eventAction: action,
                eventLabel: undefined,
                eventValue: undefined
            });

        },

        pv: function( rate, per, nper, pmt, fv ) {
            nper = parseFloat(nper);
            pmt = parseFloat(pmt);
            fv = parseFloat(fv);
            rate = eval((rate)/(per * 100));

            if (( pmt == 0 ) || ( nper == 0 ))
                return(0);

            if ( rate == 0 ) {
                pv_value = -(fv + (pmt * nper));
            } else {
                x = Math.pow(1 + rate, -nper);
                y = Math.pow(1 + rate, nper);
                pv_value = - ( x * ( fv * rate - pmt + y * pmt )) / rate;
            }

            pv_value = me._conv_number(pv_value,2);

            return (pv_value);
        },

        _conv_number: function( expr, decplaces ) {
            var str = "" + Math.round(eval(expr) * Math.pow(10,decplaces));

            while (str.length <= decplaces)
                str = "0" + str;

            var decpoint = str.length - decplaces;

            return (str.substring(0,decpoint) + "." + str.substring(decpoint,str.length));
        },

        _calculateAffordability: function () {

            var $inputPayment = $( "#calc-monthly" ),
                inputPaymentVal = $inputPayment.val() || 0,
                $inputInterest = $( "#calc-interest" ),
                inputInterestVal = $inputInterest.val(),
                $inputDeposit = $( "#calc-deposit" ),
                inputDepositVal = $inputDeposit.val() || 0,
                $inputTerm = $( "#calc-term" ),
                inputTermVal = $inputTerm.val(),
                $inputType = $( "#calc-mortgagetype" ),
                inputTypeVal = $inputType.val(),
                total,
                $quote = $( ".calc-quote-value" );

            if ( parseInt( inputPaymentVal ) != "NaN" && parseInt( inputPaymentVal ) > 0 ) {

                if ( inputTypeVal === "interest" ) {
                    total = ( ( ( inputPaymentVal * 12 ) / inputInterestVal ) * 100 ) + parseFloat( inputDepositVal );
                } else {
                    total = parseFloat( inputDepositVal ) + parseFloat( me.pv( inputInterestVal, 12, 12 * inputTermVal, -(inputPaymentVal), 0) );
                }

                $quote.html( ZPG.util.formatNumber( Math.round( total / 100 ) * 100 ) );

            } else {
                $quote.html( "--" );

            }

        },

        _calculateMortgage: function() {

            var $inputInterest = $( "#calc-interest" ),
                $inputTerm = $( "#calc-term" ),
                $inputPrice = $( "#calc-price" ),
                $inputDeposit = $( "#calc-deposit" );

            var interestRate,
                term,
                monthRate,
                payments,
                principal,
                repayments;

            interestRate = $inputInterest.val() / 100;
            monthRate = interestRate / 12;
            term = $inputTerm.val();
            payments = term * 12;
            price = $inputPrice.val();
            deposit = $inputDeposit.val();
            principal = price - deposit;
            repayments = Math.floor( ( principal * monthRate ) / ( 1 - Math.pow( ( 1 + monthRate ), ( -1 * payments ) ) ) * 100 ) / 100;
            repaymentsRounded = ZPG.util.formatNumber( Math.floor( repayments ) );

            // Display something better than isNaN
            if ( isNaN( repayments ) === true ) {
                repaymentsRounded = '--';
            }

            // Display monthly rounded montly repayment value
            $( ".calc-quote-value" ).html( repaymentsRounded );

        }

    };

    return {
        init: me.init,
        pv: me.pv
    };

}

ZPG.calculatorOld = function ( options ) {

    var me = {

        options: $.extend({
        }, options),

        _stripFormatNumber: function( el ) {
            return el.replace(/\,|\£|\%/g, '');
        },

        _calculateRepayments: function() {

            var interest_rate = me._stripFormatNumber($('.js-calc-form input[name="calc-interest"]').val()) / 100,
                term       = 25,
                monthRate = interest_rate / 12,
                payments   = term * 12,
                deposit    = me._stripFormatNumber($('.js-calc-form input[name="calc-deposit"]').val()),
                price      = me._stripFormatNumber($('.js-calc-form input[name="calc-price"]').val()),
                principal  = price - deposit,
                repayments = Math.floor( ( principal * monthRate ) / ( 1 - Math.pow( ( 1 + monthRate ), ( -1 * payments ) ) ) * 100 ) / 100;

            $( ".calc-quote span" ).html( ZPG.util.formatNumber( Math.floor(repayments) ) );

        },

        init: function( action, href ) {

            google.setOnLoadCallback( me._drawChart );

            if ( $( "#calc-price" ).length > 0 ) {

                var startPrice = me._stripFormatNumber( $( "input[name=calc-price]" ).val()),
                    startDeposit = startPrice * 0.05,
                    maxPrice = startPrice * 2;

                var $priceSlide = $( "#calc-price" ).slider({
                    range: "max",
                    min: 1000,
                    max: maxPrice,
                    value: startPrice,
                    step: 100,
                    slide: function( event, ui ) {

                        if ( ui.value <= me._stripFormatNumber( $( ".js-calc-form input[name=calc-deposit]" ).val() ) ) {
                            $( "input[name=calc-price]" ).val( ZPG.util.formatNumber( $( ".js-calc-form input[name=calc-deposit]" ).val() ) );

                        } else {
                            $( "input[name=calc-price]" ).val( "£" + ZPG.util.formatNumber( ui.value ) );
                        }

                        me._calculateRepayments();
                        me._drawChart();
                        $depositSlide.slider( "option", "max", ui.value );

                    },
                    change: function() {
                        me._trackEvent( "Slider price" );
                    }

                });

                var $depositSlide = $("#calc-deposit").slider({
                    range: "max",
                    min: 0,
                    max: startPrice,
                    step: 50,
                    value: startDeposit,
                    slide: function(event, ui) {

                        if (ui.value >= me._stripFormatNumber($('.js-calc-form input[name="calc-price"]').val())) {
                            $("input[name=calc-deposit]").val(ZPG.util.formatNumber($('.js-calc-form input[name="calc-price"]').val()));
                        } else {
                            $("input[name=calc-deposit]").val('£' + ZPG.util.formatNumber(ui.value));
                        }

                        me._calculateRepayments();
                        me._drawChart();

                        if (ui.value <= 0) {
                            $('#calc-deposit .ui-slider-handle').addClass('zero');

                        } else {

                            if ($('#calc-deposit .ui-slider-handle').hasClass('zero')) {
                                $('#calc-deposit .ui-slider-handle').removeClass('zero');
                            }

                        }

                    },
                    change: function(event) {
                        me._trackEvent( "Slider deposit" );
                    }
                });

                $("#calc-interest").slider({
                    range: "max",
                    min: 0.5,
                    max: 10.01,
                    value: 2, // Interest rate default
                    step: 0.5,
                    slide: function(event, ui) {
                        $("input[name=calc-interest]").val(ZPG.util.formatNumber(ui.value) + '%');
                        me._calculateRepayments();
                    },
                    change: function() {
                        me._trackEvent( "Slider interest" );
                    }
                });

                me._calculateRepayments();
                me._drawChart();

                $("input[name=calc-price]").val('£' + ZPG.util.formatNumber($("#calc-price").slider("value")));
                $("input[name=calc-deposit]").val('£' + ZPG.util.formatNumber($("#calc-deposit").slider("value")));
                $("input[name=calc-interest]").val(ZPG.util.formatNumber($("#calc-interest").slider("value") + '%'));

            }


        },

        googlePush: function() {

            if ( typeof me.options.google_loan_type !== "undefined" && typeof window.google_tag_params !== "undefined" ) {

                window.google_tag_params.LOAN_type = me.options.google_loan_type;

                window.google_trackConversion({
                    google_conversion_id: me.options.google_conversion_id,
                    google_custom_params: window.google_tag_params,
                    google_remarketing_only: true
                });

            }

        },

        _trackEvent: function( action ) {
        
            var category = $( ".calc-help" ).attr( "data-ga-category" );

            dataLayer.push({ 
                "event": "GAEvent",
                "eventCategory": category, 
                "eventAction": action, 
                "eventLabel": undefined, 
                "eventValue": undefined 
            });

            me.googlePush();

        },

        _drawChart: function() {

            var total = me._stripFormatNumber($('.js-calc-form input[name="calc-price"]').val()),
                dep = me._stripFormatNumber($('.js-calc-form input[name="calc-deposit"]').val()),
                d = Math.ceil((dep / total) * 100),
                m = (100 - d),
                dataTable = new window.google.visualization.DataTable();

            dataTable.addColumn('string', 'year');
            dataTable.addColumn('number', 'sales');

            dataTable.addRows([
                ['Your mortgage', parseInt(m)],
                ['Your deposit', parseInt(d)]
            ]);

            var options = {
                'pieHole': 0.45,
                'pieSliceBorderColor': 'transparent',
                'backgroundColor': '#f9f9f9',
                'width': 150,
                'height': 150,
                'enableInteractivity': false,
                'colors': [ me.options.color_mortgage, me.options.color_deposit],
                'legend': {
                    'position': 'none'
                },
                'pieSliceTextStyle': {
                    'fontName': 'Droid sans',
                    'fontName': 'Arial',
                    'fontSize': 10,
                    'bold': true
                },
                'chartArea': {
                    'top': 10,
                    'left': 15,
                    'width': 120,
                    'height': 120
                }
            };

            var chart = new window.google.visualization.PieChart( document.getElementById('donutchart') );

            chart.draw( dataTable, options );

        }

    };

    return {
        init: me.init
    };

}

$('.search-refine-facets-dropdown').each(function(){
    var $this = $(this);

    if ($this.find('li').length < 1) {
        $this.remove();
    }

    if ($this.find('.facet-link-active').length > 0) {
        $this.find('.search-refine-facets-header-text').text($this.find('.facet-link-active .search-refine-facets-text').text());
    }
});

(function() {
    if ($('.is-new-refine #facets-features .search-refine-filters-item').length < 1) {
        $('.is-new-refine #facets-features').remove();
    }
})();

$('.search-refine-filters-select').each(function(){
    var $this = $(this);

    if ($this.find('option').length < 1) {
        $this.closest('.search-refine-filters-dropdown').remove();
    }
});

$('.form-search-and-refine').on('click touchend', '.js-btn-search-refine-top:not(.is-disabled)', function(e){
    var $this = $(this),
        $parent = $this.parent(),
        $panel = $parent.find('.search-refine-element-panel'),
        $panels = $('.search-refine-element-panel'),
        $btns = $('.js-btn-search-refine-top'),
        page_height = $('.main-content-area').height() + $('footer').height(),
        overlay_width = $('.main-content-area').width() + (window.location.hostname.indexOf('primelocation') >= 0 ? 0 : 20); // Extra width to cover picture flag which hangs past the page

    if ($panel.hasClass('is-hidden')) {
        $panels.addClass('is-hidden');
        $btns.removeClass('is-active');
        $panel.removeClass('is-hidden');
        $this.addClass('is-active');
        if ($parent.attr('data-refine') === 'location') {
            var locationInput = $this.siblings('#location'),
                locationInputVal = locationInput.val();

            locationInput.focus().val('').val(locationInputVal);
        }

        if($parent.is('[data-refine="filters"]')) {
            dataLayer.push({
                "event": "GAEvent",
                "eventCategory": "Search",
                "eventAction": "More filters",
                "eventLabel": "open",
                "eventValue": undefined,
                "eventNonInteraction": false
            });
        }

    } else {
        $panels.addClass('is-hidden');
        $btns.removeClass('is-active');
        $('body').off('click touchend', overlay_listener);
    }

    e.preventDefault();
    e.stopPropagation();

    var all_hidden = true;
    $panels.each(function(){
        if (!$(this).hasClass('is-hidden')) {
            all_hidden = false;
        }
    });
    if (all_hidden) {
        $('.search-refine-overlay').hide();
        $('body').off('click touchend', overlay_listener);
    } else {
        $('.search-refine-overlay').css({ height: page_height + 'px', width: overlay_width + 'px', 'margin-left': -(overlay_width / 2) + 'px' }).show();
        $(".listing-results-utils-view select").selectBoxIt('disable').hide();
        $('body').on('click touchend', overlay_listener);
    }

    function overlay_listener(event) {
        if ($(event.target).parents('.search-refine-element-panel').length < 1 && !$(event.target).hasClass('search-refine-element-panel') &&
            !$(event.target).hasClass('search-refine-location') && $(event.target).parents('.ui-autocomplete').length < 1) {
            $panels.addClass('is-hidden');
            $btns.removeClass('is-active');
            $('.search-refine-overlay').hide();
            $(".listing-results-utils-view select").selectBoxIt('enable').show();
            $('body').off('click touchend', overlay_listener);
        }
    }
});

$('.search-refine-element-wrapper').on('change', 'select, input', function(e){
    var $delegate = $(e.delegateTarget),
        $button = $delegate.find('.js-btn-search-refine-top');

    if ($delegate.attr('data-refine') === "bedrooms") {

        var new_string = '',
            $beds_min = $delegate.find('#beds_min option:selected'),
            $beds_max = $delegate.find('#beds_max option:selected');

        if ($beds_min.val() !== "" && $beds_max.val() !== "") {
            new_string = $beds_min.text() + ' - ' + $beds_max.text() + ($beds_max.text() === "Studio" ? '' : ($beds_max.text() === '1' ? ' bed' : ' beds'));
        } else if ($beds_min.val() !== "" && $beds_max.val() === "") {
            new_string = $beds_min.text() + ($beds_min.text() === "Studio" ? '' : ($beds_min.text() === '1' ? ' bed' : ' beds')) + ' min';
        } else if ($beds_min.val() === "" && $beds_max.val() !== "") {
            new_string = $beds_max.text() + ($beds_max.text() === "Studio" ? '' : ($beds_max.text() === '1' ? ' bed' : ' beds')) + ' max';
        } else {
            new_string = $button.attr('data-all');
        }

        $button.find('.search-refine-price-wrapper').text(new_string);

     } else if ($delegate.attr('data-refine') === "for-sale_price" || $delegate.attr('data-refine') === "new-homes_price") {

        var new_string = '',
            $price_min = $delegate.find('#forsale_price_min option:selected'),
            $price_max = $delegate.find('#forsale_price_max option:selected'),
            price_min_string = $price_min.attr('data-condensed'),
            price_max_string = $price_max.attr('data-condensed'),
            price_currency = $('form#form-search-and-refine.is-new-refine').length > 0 ? '£' : '';

        if ($price_min.val() !== "" && $price_max.val() !== "") {
            new_string = price_currency + price_min_string + ' to ' + price_currency + price_max_string;
        } else if ($price_min.val() !== "" && $price_max.val() === "") {
            new_string = price_currency + price_min_string + ' min';
        } else if ($price_min.val() === "" && $price_max.val() !== "") {
            new_string = price_currency + price_max_string + ' max';
        } else {
            new_string = $button.attr('data-all');
        }

        $button.find('.search-refine-price-wrapper').text(new_string);

    } else if ($delegate.attr('data-refine') === "to-rent_price") {

        var new_string = '',
            frequency = $delegate.find('#rent_price_min_per_year').length > 0 ? 'per_year' : $delegate.find('#price_frequency option:selected').val(),
            frequency_string = frequency === 'per_year' ? 'pa' : (frequency === 'per_month' ? 'pcm' : 'pw'),
            $price_min = $delegate.find('#rent_price_min_' + frequency + ' option:selected'),
            $price_max = $delegate.find('#rent_price_max_' + frequency + ' option:selected'),
            price_min_string = $price_min.attr('data-condensed'),
            price_max_string = $price_max.attr('data-condensed'),
            price_currency = $('form#form-search-and-refine.is-new-refine').length > 0 ? '£' : '';

        if ($(e.currentTarget).is('#price_frequency')) {
            if (frequency === 'per_month') {
                $('#rent_price_min_per_monthSelectBoxIt, #rent_price_max_per_monthSelectBoxIt')
                    .removeClass('selectboxit-disabled none').addClass('selectboxit-enabled').siblings('select').trigger('change');
                $('#rent_price_min_per_weekSelectBoxIt, #rent_price_max_per_weekSelectBoxIt')
                    .addClass('selectboxit-disabled none').removeClass('selectboxit-enabled');
            } else {
                $('#rent_price_min_per_monthSelectBoxIt, #rent_price_max_per_monthSelectBoxIt')
                    .addClass('selectboxit-disabled none').removeClass('selectboxit-enabled');
                $('#rent_price_min_per_weekSelectBoxIt, #rent_price_max_per_weekSelectBoxIt')
                    .removeClass('selectboxit-disabled none').addClass('selectboxit-enabled').siblings('select').trigger('change');
            }
        }

        if ($price_min.val() !== "" && $price_max.val() !== "") {
            new_string = price_currency + price_min_string + ' to ' + price_currency + price_max_string + ' (' + frequency_string + ')';
        } else if ($price_min.val() !== "" && $price_max.val() === "") {
            new_string = price_currency + price_min_string + ' min' + ' (' + frequency_string + ')';
        } else if ($price_min.val() === "" && $price_max.val() !== "") {
            new_string = price_currency + price_max_string + ' max' + ' (' + frequency_string + ')';
        } else {
            new_string = $button.attr('data-all');
        }

        $button.find('.search-refine-price-wrapper').text(new_string);

    } else if ($delegate.attr('data-refine') === "officespace") {

        var new_string = '',
            floor_area_units = $delegate.find('#floor_area_units option:selected').val(),
            floor_area_units_string = floor_area_units === 'sq_feet' ? 'ft<sup>2</sup>' : floor_area_units === 'acres' ? 'ac' : 'm<sup>2</sup>',
            $floor_area_min = $delegate.find('#floor_area_min_' + floor_area_units + ' option:selected'),
            $floor_area_max = $delegate.find('#floor_area_max_' + floor_area_units + ' option:selected'),
            floor_area_min_string = $floor_area_min.attr('data-condensed'),
            floor_area_max_string = $floor_area_max.attr('data-condensed');

        if ($(e.currentTarget).is('#floor_area_units')) {
            if (floor_area_units === 'sq_feet') {
                $('#floor_area_min_sq_feetSelectBoxIt, #floor_area_max_sq_feetSelectBoxIt').removeClass('selectboxit-disabled none').addClass('selectboxit-enabled');
                $('#floor_area_min_sq_metresSelectBoxIt, #floor_area_max_sq_metresSelectBoxIt, #floor_area_min_acresSelectBoxIt, #floor_area_max_acresSelectBoxIt')
                    .addClass('selectboxit-disabled none').removeClass('selectboxit-enabled');
            } else if (floor_area_units === 'sq_metres') {
                $('#floor_area_min_sq_metresSelectBoxIt, #floor_area_max_sq_metresSelectBoxIt').removeClass('selectboxit-disabled none').addClass('selectboxit-enabled');
                $('#floor_area_min_sq_feetSelectBoxIt, #floor_area_max_sq_feetSelectBoxIt, #floor_area_min_acresSelectBoxIt, #floor_area_max_acresSelectBoxIt')
                    .addClass('selectboxit-disabled none').removeClass('selectboxit-enabled');
            } else {
                $('#floor_area_min_acresSelectBoxIt, #floor_area_max_acresSelectBoxIt').removeClass('selectboxit-disabled none').addClass('selectboxit-enabled');
                $('#floor_area_min_sq_feetSelectBoxIt, #floor_area_max_sq_feetSelectBoxIt, #floor_area_min_sq_metresSelectBoxIt, #floor_area_max_sq_metresSelectBoxIt')
                    .addClass('selectboxit-disabled none').removeClass('selectboxit-enabled');
            }

            $('#floor_area_min_' + floor_area_units + ', #floor_area_max_' + floor_area_units).trigger('change');
        }

        if ($floor_area_min.val() !== "" && $floor_area_max.val() !== "") {
            new_string = floor_area_min_string + ' to ' + floor_area_max_string + ' ' + floor_area_units_string;
        } else if ($floor_area_min.val() !== "" && $floor_area_max.val() === "") {
            new_string = floor_area_min_string + ' min' + ' ' + floor_area_units_string;
        } else if ($floor_area_min.val() === "" && $floor_area_max.val() !== "") {
            new_string = floor_area_max_string + ' max' + ' ' + floor_area_units_string;
        } else {
            new_string = $button.attr('data-all');
        }

        $button.find('.search-refine-price-wrapper').html(new_string);

    } else if ($delegate.attr('data-refine') === "location") {

        var new_string = $delegate.find('.selectboxit_overseas').length > 0 ? $delegate.find('#location option:selected').text() + ', ' + $delegate.find('#location_area').val() : $delegate.find('#location').val(),
            radius = $delegate.find('#radius option:selected').text();
            var radius_value = $delegate.find('#radius option:selected').val();

        new_string = new_string.split('<script>').join('').split('</script>').join('');

        new_string = '<span class="search-refine-location-text">' + new_string + '</span>';
        if ($(e.currentTarget).is('select#location')) {
            if ($('#location').find(':selected').attr('data-hierarchy') === 'true') {
                $delegate.find('.selectboxit_overseas + .selectboxit_overseas').css("display", "block");
            } else {
                $delegate.find('.selectboxit_overseas + .selectboxit_overseas').hide();
            }
            if ( !$('#location').find(':selected').attr('selected') ) {
                $delegate.find('#location_area').val('');
            }
            new_string = $delegate.find('#location option:selected').text();
        } else if (radius_value == '') {
            new_string = $delegate.find('.selectboxit_radius').hasClass('is-hidden') ? new_string : new_string;
        } else {
            new_string = $delegate.find('.selectboxit_radius').hasClass('is-hidden') ? new_string : new_string + ' <b>(' + radius.toLowerCase() + ')</b>';
        }

        $button.find('.search-refine-location-wrapper').html(new_string);

    } else if ($delegate.attr('data-refine') === "property-type") {

        $('.form-search-and-refine input[name=property_sub_type]').remove();

        var new_string = $delegate.find('[name=property_type]:checked').parent().text();

        if (new_string === "Show all") {
            new_string = $button.attr('data-all');
        }

        var $btns = $('.search-refine-element-wrapper .btn-search-refine-rooms');
        if ($delegate.find('[name=property_type]:checked').val() === 'land') {
            $btns.addClass('is-disabled');
        } else {
            $btns.removeClass('is-disabled');
            var $disabled = $btns.parent().find( '.search-disabled');
            $disabled.find('.selectboxit-disabled').removeClass('selectboxit-disabled');
            $disabled.find('select').prop('disabled', false);
            $disabled.removeClass('search-disabled');
        }
        $button.find('.search-refine-propertytype-wrapper').text(new_string);

    } else if ($delegate.attr('data-refine') === "property-sub-type") {

        var new_string, $delegates = $delegate.find('[name=property_sub_type]:checked');

        if ($delegates.length > 0) {
            var property_types_data = "?";
            $delegates.each(function(ind, ele) {
                property_types_data += "property_sub_type=" + ele.value + "&";
            });
            property_types_data += "url=" + encodeURIComponent(window.location.href);
            $.get('/ajax/listings/property-selection' + property_types_data, function(data) {
                new_string = data.property_selection_text ? data.property_selection_text : 'Multiple types';
                $button.find('.search-refine-propertytype-wrapper').text(new_string);
            });
        } else {
            new_string = $button.attr('data-all');
            $button.find('.search-refine-propertytype-wrapper').text(new_string);
        }

    } else if ($delegate.attr('data-refine') === "overseas_price") {

        var new_string = '',
            $price_min = $delegate.find('#forsale_price_min option:selected'),
            $price_max = $delegate.find('#forsale_price_max option:selected'),
            price_min_string = $price_min.attr('data-condensed'),
            price_max_string = $price_max.attr('data-condensed'),
            price_currency = $('form#form-search-and-refine.is-new-refine').length > 0 ? $('#currency option:selected').val() : '';


        price_currency = price_currency === 'usd' ? '$' : (price_currency === 'eur' ? '€' : '£');

        if ($price_min.val() !== "" && $price_max.val() !== "") {
            new_string = price_min_string + ' to ' + price_max_string;
        } else if ($price_min.val() !== "" && $price_max.val() === "") {
            new_string =  price_min_string + ' min';
        } else if ($price_min.val() === "" && $price_max.val() !== "") {
            new_string = price_max_string + ' max';
        } else {
            new_string = $button.attr('data-all');
        }

        if ($(e.currentTarget).is('#currency')) {
            var currency = $('#currency option:selected').val();
            $button.removeClass('is-currency-gbp is-currency-eur is-currency-usd').addClass('is-currency-' + currency);

            if ($('form#form-search-and-refine.is-new-refine').length > 0) {
                price_currency = currency === 'usd' ? '$' : (currency === 'eur' ? '€' : '£');

                if ($price_min.val() !== "" && $price_max.val() !== "") {
                    new_string = price_currency + price_min_string + ' to ' + price_currency + price_max_string;
                } else if ($price_min.val() !== "" && $price_max.val() === "") {
                    new_string = price_currency + price_min_string + ' min';
                } else if ($price_min.val() === "" && $price_max.val() !== "") {
                    new_string = price_currency + price_max_string + ' max';
                } else {
                    new_string = $button.attr('data-all');
                }
            }

            $('#forsale_price_min option, #forsale_price_max option').each(function(){
                var $this = $(this);

                $this.html(function(i, html){
                    var current_html = html,
                        new_html,
                        currency_symbol;

                    if (currency === 'eur') {
                        currency_symbol = "&euro;";
                    } else if (currency === 'usd') {
                        currency_symbol = "$";
                    } else {
                        currency_symbol = "&pound;";
                    }

                    new_html = $(this).html().indexOf('00') > 0 ? currency_symbol + ZPG.util.formatNumber($this.val()) : current_html;

                    return new_html;
                });
            });

            $('#forsale_price_min, #forsale_price_max').trigger('change');
        }

        $button.find('.search-refine-price-wrapper').text(new_string);

    } else if ($delegate.attr('data-refine') === "agent-type") {

        var new_string = $delegate.find('[name=section]:checked').parent().text();

        if (new_string === "All") {
            new_string = $button.attr('data-all');
        }

        $button.find('.search-refine-agenttype-wrapper').text(new_string);

    } else if ($delegate.attr('data-refine') === "other") {
        var added_option = $delegate.find('#added option:selected');
        var sold_option = $delegate.find('#include_sold:checked');
        var rented_option = $delegate.find('#include_rented:checked');
        var other_filter_count = 0;
        if (added_option.index() > 0) {
            other_filter_count++;
        }
        if (sold_option.length || rented_option.length) {
            other_filter_count++;
        }
        $button.text($button.attr('data-all') + (other_filter_count > 0 ? " (" + other_filter_count + ")" : ""));
    }

    $('.btn-refine-search').removeClass('is-disabled').prop('disabled', false);
});

$('.overseas_geo_autocomplete').on('autocompleteselect', function(e, ui){
    //$('.search-refine-element-wrapper .search-refine-location-text').text($('#location option:selected').text() + ', ' + ui.item.v);
    setTimeout(function() { $('.search-refine-element-wrapper #radius').trigger('change') }, 200);
});

$('.search-refine-element-wrapper #search_company_name').on('autocompleteopen', function(e, ui){
    $('.btn-refine-search').removeClass('is-disabled').prop('disabled', false);
});

$('.search-refine-location').on('change', function() {
    $('[name=polyenc]').remove();
    $('.search-refine-location-autocomplete-replicate').text($(this).val());
});

$('.is-new-refine .search-filters-propertytype-wrapper').on('change', '.search-filters-propertytype-checkbox', function() {
    var $this = $(this);

    $this.closest('.search-filters-propertytype').toggleClass('is-checked', $this.is(':checked'));
});

$('#include_shared_accommodation').on('click', function() {

    var $el = $(this),
        $hiddenField = $('#include_shared_accommodation_hidden');

    if ($el.prop('checked')) {
        $el.val('true');
        $hiddenField.val('');
    } else {
        $el.val('');
        $hiddenField.val('false');
    }

});

$('.search-refine-facets-group').each(function(i, el){
    var $this = $(this),
        items = $(this).find('.search-refine-facets-item.filter-checkbox').length,
        items_selected = $(this).find('.search-refine-facets-item.filter-selected').length,
        elements_per_line = $('.maps-fullscreen').length > 0 ? 3 : 2;

    /* add toggle for groups with more than two elements */
    if (items > elements_per_line && !$this.hasClass('not-collapsible')) {
        var $btn = $('<button class="btn search-refine-facets-toggle">\
                    <span class="search-refine-facets-toggle-plus">+</span>\
                    <span class="search-refine-facets-toggle-minus">–</span>\
                    </button>');

        $(this).append($btn).addClass('is-collapsed');
        $(this).find('.search-refine-facets-header').addClass('is-toggle').css({ 'cursor': 'pointer' });
        $(this).find('.search-refine-facets-items').attr('data-collapsed-height', function() { return $(this).outerHeight(); });
    }

}).
on('click', '.search-refine-facets-toggle, .search-refine-facets-header.is-toggle', function(e){
    var $this = $(this),
        $container = $this.parents('.search-refine-facets-group'),
        items = $container.find('.search-refine-facets-item').length,
        $wrap = $container.find('.search-refine-facets-items'),
        elements_per_line = $('.maps-fullscreen').length > 0 ? 3 : 2;

    if ($container.hasClass('is-collapsed')) {
        $container.removeClass('is-collapsed').addClass('is-expanded');
        $wrap.css({ height: ($container.find('.search-refine-facets-subitems').length > 0 ? ((Math.ceil(items/elements_per_line) * 50) + 50) : (Math.ceil(items/elements_per_line) * 50)) + 'px' });
    } else {
        $container.removeClass('is-expanded').addClass('is-collapsed');
        $wrap.css({ height: $wrap.attr('data-collapsed-height') + 'px' });
    }

    var tracking_label = $container.find('.search-refine-facets-header').text().toLowerCase().replace(' ', '_');

    dataLayer.push({
        "event": "GAEvent",
        "eventCategory": "Search_Refine",
        "eventAction": "Filter_results_interaction",
        "eventLabel": tracking_label + "_menu_" + ( $container.hasClass( "is-collapsed" ) ? "open" : "close" ),
        "eventValue": undefined
    });

    e.preventDefault();
});

$('.search-refine-facets-group').each(function(){
    var $this = $(this);
    if ($this.find('.search-refine-facets-item').length < 1 && $this.find('.search-refine-facets-keywords-wrapper').length < 1) {
        $this.remove();
    } else if ($this.find('.search-refine-facets-item.filter-selected').length > 0 && !$this.hasClass('not-collapsible')) {
        var items = $this.find('.search-refine-facets-item').length,
            $wrap = $this.find('.search-refine-facets-items'),
            elements_per_line = $('.maps-fullscreen').length > 0 ? 3 : 2;

        $this.removeClass('is-collapsed').addClass('is-expanded');
        $wrap.css({ height: (elements_per_line % 2 ? ((Math.ceil(items/elements_per_line) * 50)) : (Math.ceil(items/elements_per_line) * 50) + 50) + 'px' });
    }
});

$('.js-search-and-refine-filters-toggle').on('click', function(e){
    var $filters_block = $('#search-listings-filters'),
        $filters_toggle = $('.js-search-and-refine-filters-toggle');

    if ($.cookie('filter_results_tooltip_dismissed') !== '1' ) {
        $('.listing-results-utils-tooltip').remove();
        $.cookie('filter_results_tooltip_dismissed', '1', { expires: 365, path: '/' });
    }

    if ($filters_block.hasClass('is-hidden')) {
        $filters_block.slideDown(400, function() { $filters_block.removeClass('is-hidden'); });
        $filters_toggle.addClass('is-expanded');
    } else {
        $filters_block.slideUp(400, function() { $filters_block.addClass('is-hidden'); });
        $filters_toggle.removeClass('is-expanded');
    }

    e.preventDefault();

    dataLayer.push({
        "event": "GAEvent",
        "eventCategory": "Search_Refine",
        "eventAction": "Filter_results_interaction",
        "eventLabel": "filters_" + ( $filters_block.hasClass( "is-hidden" ) ? "open" : "close" ),
        "eventValue": undefined
    });

}).
find('.search-and-refine-filters-toggle-count').html(function(i, html_string){
    var new_string = html_string;
    if ($('.facet-link-active').length > 0) new_string += ' (' + $('.facet-link-active').length + ')';
    return new_string;
});

$('.listing-results-utils-tooltip').on('click', '.btn', function(e){
    e.preventDefault();

    if ($.cookie('filter_results_tooltip_dismissed') !== '1' ) {
        $('.listing-results-utils-tooltip').remove();
        $.cookie('filter_results_tooltip_dismissed', '1', { expires: 365, path: '/' });
    }
});
$('.listing-results-keyword-tooltip').on('click', '.btn', function(e){
    e.preventDefault();

    if ($.cookie('filter_keywords_tooltip_dismissed') !== '1' ) {
        $('.listing-results-keyword-tooltip').remove();
        $.cookie('filter_keywords_tooltip_dismissed', '1', { expires: 1, path: '/' });
    }
});

$('.js-search-and-refine-view-toggle').on('click', function(e){
    var $view_options_toggle = $(this),
        $view_options_panel = $('.listing-results-utils-view');

    if ($view_options_panel.hasClass('is-hidden')) {
        $view_options_panel.slideDown(400, function() { $view_options_panel.removeClass('is-hidden'); });
        $view_options_toggle.addClass('is-expanded');
    } else {
        $view_options_panel.slideUp(400, function() { $view_options_panel.addClass('is-hidden'); });
        $view_options_toggle.removeClass('is-expanded');
    }

    e.preventDefault();

    dataLayer.push({
        "event": "GAEvent",
        "eventCategory": "Search_Refine",
        "eventAction": "Filter_results_interaction",
        "eventLabel": "view_by_" + ( $view_options_panel.hasClass( "is-hidden" ) ? "open" : "close" ),
        "eventValue": undefined
    });
});

$('.js-search-refine-facets-header').on('click touchend', function(e){
    var $this = $(this),
        $parent = $this.parents('.search-refine-facets-dropdown'),
        $menu = $parent.find('.search-refine-facets-items');

    if ($parent.hasClass('is-collapsed')) {
        $('#facets-more-options .search-refine-facets-dropdown').removeClass('is-expanded').addClass('is-collapsed');
        $parent.removeClass('is-collapsed').addClass('is-expanded');
    } else {
        $('#facets-more-options .search-refine-facets-dropdown').removeClass('is-expanded').addClass('is-collapsed');
    }

    e.stopPropagation();

    $('body').one('click touchend', function(event) {
        if ($(event.target).parents('.search-refine-facets-items-button-group').length < 1 && !$(event.target).hasClass('search-refine-facets-items-button-group')) {
            $('#facets-more-options .search-refine-facets-dropdown').removeClass('is-expanded').addClass('is-collapsed');
        }
    });

});

$('.search-refine-filters').on('click', '.search-refine-facets-link, .search-refine-filters-clear', function(e){

    if (!e.button && !e.ctrlKey && !e.shiftKey && !e.metaKey && !e.altKey) {

        var $message_wrapper = $('.search-refine-filters'),
            html = '<div class="search-refine-filters-updating-layer-overlay"><span class="search-refine-filters-updating-layer-text">Updating results...</span></div>';

        $('.search-refine-filters .search-refine-facets-dropdown.is-expanded').removeClass('is-expanded').addClass('is-collapsed');

        if ($message_wrapper.find('.search-refine-filters-updating-layer-overlay').length === 0) {
            $message_wrapper.append(html);
        }

        if ($(e.currentTarget).hasClass('search-refine-filters-clear')) {

            dataLayer.push({
                "event": "GAEvent",
                "eventCategory": "Search_Refine",
                "eventAction": "Filter_results_interaction",
                "eventLabel": "clear_filter_results",
                "eventValue": undefined
            });

        }

        $message_wrapper.addClass('is-updating');

    }
});

$('.js-search-refine-facets-keywords').on('keyup', function(){
    var $this = $(this);

    if ($this.val() !== "") {
        $this.parent().find('.btn-search-refine-facets-keywords').removeClass('is-disabled');
    } else {
        $this.parent().find('.btn-search-refine-facets-keywords').addClass('is-disabled');
    }
});

$('.search-refine-input').on('change', function(){
    var $this = $(this),
        radio = $(this).hasClass('search-refine-input-radio'),
        group = $(this).find('input').attr('name');

    if (radio) {
        $this.parent().find('.search-refine-input-radio input[name="' + group + '"]').parent().removeClass('is-checked');
    }

    $this.toggleClass('is-checked', $this.find('input').is(':checked'));
});

$('.form-search-and-refine #include_sold').on('change', function() {
    var $this = $(this);

    if ($this.is(':checked')) {
        $this.attr('name', 'include_sold');
    } else {
        $this.attr('name', '');
    }
});

// (function() {
//     var filters_applied = 0;
//     $('.search-refine-element-panel-filters input[type="checkbox"], .search-refine-element-panel-filters .search-refine-filters-keywords, .search-refine-element-panel-filters select').each(function(index, element) {
//         var $element = $(element);

//         if ($element.is('[type=checkbox]') && $element.is(':checked')) {
//             filters_applied++;
//         } else if ($element.is('select') && $element.find('option:selected').val() !== $element.find('option').eq(0).val()) {
//             filters_applied++;
//         } else if ($element.hasClass('search-refine-element-panel-filters') && $element.val() !== "") {
//             filters_applied++;
//         }
//     });

//     if (filters_applied > 0) {
//         $('.btn-search-refine-filters').text(function(index, current_text) {
//             return current_text + ' (' + filters_applied + ')';
//         });
//     }
// })();

window.ZPG = window.ZPG || {};
window.ZPG.UI = window.ZPG.UI || {};

window.ZPG.UI.galleryContainer = document.getElementById('images');

var photoGallery = {

    constructor: function (options) {

        this.classes = {
            hidden: 'visually-hidden',
            thumbActive: 'images-thumbs-active',
            linkActive: 'images-links-active'
        };

        this.UI = {
            moviePlayer: $('#movie-play'),
            container: $('#images'),
            thumbnails: $('#images-thumbs li'),
            imgMainContainer: document.getElementById('images-main'),
            imgDescription: document.getElementById('images-description'),
            imgNumber: $('#images-num'),
            advertisement: undefined,
            carousel: ''
        };

        this.UI.mainImg = this.UI.imgMainContainer.getElementsByTagName('img')[0];

        this.defaults = {
            maxPhotoIndex: photoGallery.UI.thumbnails.size() - 1,
            photoIndex: 0,
            carouselIndex: 0,
            maxCarouselIndex: 5,
            carouselStartIndex: 1,
            adThreshold: 3,
            clickCount: 0,
            slideshowTimerActive: 0,
            slideshowTimer: '',
            copySlideStart: 'Start slideshow',
            copySlideStop: 'Stop slideshow',
            bannerVisible: 0
        };
        
        this.defaults.abTestVariant = this.UI.imgMainContainer.getAttribute('data-variant'),
        this.defaults.section = this.UI.imgMainContainer.getAttribute('data-section') || 'for-sale'

        this.tracking = {
            'category': 'move',
            'action': 'clickout',
            'for-sale': {
                copy: 'Find a mortgage and get a decision in principle for this home',
                destination: 'https://www.money.co.uk/mortgages/zoopla-mortgages.htm?src=zoopla&track=867072&utm_source=zoopla&utm_medium=text_link&utm_campaign=sale_return_listings&utm_content=find_mortgages',
                label: 'mortgage|money'
            },
            'to-rent': {
                copy: 'Compare loans and check the cost of each deal',
                destination: 'https://www.money.co.uk/loans/unsecured-loans.htm?src=zoopla&track=867075&utm_source=zoopla&utm_medium=text_link&utm_campaign=rent_return_listings&utm_content=loans_check_cost',
                label: 'loans|money'
            }
        };
    },

    init: function (options) {

        this.constructor(options)

        this.UI.carousel = $('#images-thumbs ul').jcarousel({
            animation: '800',
            scroll: 6,
            initCallback: this.attachEvents.bind(this),
            itemFirstInCallback: function (carousel, liElement, intemIndex, action) {
                this.defaults.carouselStartIndex = intemIndex - 1
            }.bind(this)
        })

        if (this.UI.moviePlayer) {

            ZPG.movies.validate_url({
                URL: this.UI.moviePlayer.attr('href')
            })

            this.UI.moviePlayer.unbind('click').bind('click', function (e) {
                e.preventDefault()

                ZPG.movies.init({
                    URL: $(this).attr('href'),
                    autoplay: true
                })
            })

        }

    },

    attachEvents: function () {

        /* clicking next */
        this.UI.container.on('click', '.images-next', function (e) {

            e.preventDefault()
            this.next()

        }.bind(this))

        /* clicking previous */
        this.UI.container.on('click', '.images-prev', function (e) {

            e.preventDefault()
            this.prev()

        }.bind(this))

        /* clicking a thumbnail */
        this.UI.container.on('click', '#images-thumbs img', function (e) {

            e.preventDefault()

            if (this.UI.advertisement != undefined) {
                if (this.is_ad_showing() === true) {
                    this.UI.advertisement.classList.add(this.classes.hidden)
                }
            }

            var $el = $(e.target).closest('li')

            $('.' + this.classes.thumbActive).removeClass(this.classes.thumbActive)

            $el.addClass(this.classes.thumbActive)

            this.defaults.photoIndex    = $el.index()
            this.defaults.carouselIndex = this.defaults.photoIndex - this.defaults.carouselStartIndex
            this.photo_change()

        }.bind(this))

        // slideshow button
        this.UI.container.on('click', '#images-slideshow', function (e) {

            e.preventDefault()

            var $el = $(e.target)

            if ($el.data('clicked')) {

                $el.removeClass(this.classes.linkActive).html(this.defaults.copySlideStart)
                this.stop_slideshow()

                $el.data('clicked', false)

            } else {

                $el.addClass(this.classes.linkActive).html(this.defaults.copySlideStop)
                this.start_slideshow()

                $el.data('clicked', true)

            }

        }.bind(this))

        $(document).keydown(function (e) {

            var keyCode = e.keyCode || e.which

            if (!$('input, textarea').is(':focus')) {

                if (keyCode == 37) {
                    this.prev()
                } else if (keyCode == 39) {
                    this.next()
                }

            }

        }.bind(this))

    },

    photo_change: function () {

        var target_photo = this.UI.thumbnails.eq(this.defaults.photoIndex),
            photo_big    = target_photo.find('a').data('photo'),
            photo_desc   = target_photo.find('img').attr('title');

        this.UI.imgNumber.html(this.defaults.photoIndex + 1)

        this.UI.mainImg.setAttribute('src', photo_big);
        this.UI.mainImg.setAttribute('title', photo_desc);
        this.UI.imgDescription.innerHTML = photo_desc;

        $('.' + this.classes.thumbActive).removeClass(this.classes.thumbActive)
        target_photo.addClass(this.classes.thumbActive)
    },

    slideshow: function () {

        this.next()

        this.defaults.slideshowTimer = setTimeout(function () {
            this.slideshow()
        }.bind(this), 2000);

    },

    start_slideshow: function () {

        if (!this.defaults.slideshowTimerActive) {

            this.defaults.slideshowTimerActive = 1
            this.slideshow()

        }

    },

    stop_slideshow: function () {

        clearTimeout(this.defaults.slideshowTimer)
        this.defaults.slideshowTimerActive = 0

    },

    prev: function () {

        this.defaults.clickCount++

        if (this.defaults.abTestVariant == 'b') {
            if (!this.defaults.slideshowTimerActive &&
                this.defaults.clickCount == this.defaults.adThreshold) {
                this.init_advertising()
                return false
            } else {
                this.hide_advert()
            }
        }

        if (this.defaults.photoIndex == 0) {

            this.defaults.photoIndex = this.defaults.maxPhotoIndex

        } else {

            this.defaults.photoIndex--

        }

        if (this.defaults.photoIndex == this.defaults.maxPhotoIndex) {

            this.UI.carousel.scroll(this.defaults.maxPhotoIndex)
            this.defaults.carouselIndex = this.defaults.maxCarouselIndex

        } else if (this.defaults.carouselIndex == 0) {

            this.UI.carousel.prev()

            if (this.defaults.photoIndex <= this.defaults.maxCarouselIndex) {

                this.defaults.carouselIndex = this.defaults.photoIndex

            } else {

                this.defaults.carouselIndex = this.defaults.maxCarouselIndex

            }

        } else {

            this.defaults.carouselIndex--

        }

        this.photo_change()

    },

    next: function (slideshow) {

        this.defaults.clickCount++

        if (this.defaults.abTestVariant == 'b') {
            if (!this.defaults.slideshowTimerActive && this.defaults.clickCount == this.defaults.adThreshold) {
                this.init_advertising()
                return false
            } else {
                this.hide_advert()
            }
        }

        if (this.defaults.photoIndex == this.defaults.maxPhotoIndex) {

            this.defaults.photoIndex = 0

        } else {

            this.defaults.photoIndex++

        }

        if (this.defaults.carouselIndex == this.defaults.maxCarouselIndex) {

            if (this.defaults.photoIndex != 0) {

                this.UI.carousel.next()
                this.defaults.carouselIndex = 0

            }

        } else {

            this.defaults.carouselIndex++

        }

        if (this.defaults.photoIndex == 0) {

            this.UI.carousel.scroll(0)
            this.defaults.carouselIndex = 0

        }

        this.photo_change()

    },
    /**
     * Generate the banner html
     * And inject tracking data + taxonomy
     * @returns { String } - the banner to be injected within the slider
     */
    build_banner: function () {

        var bannerLinkTaxonomy = {
            "listings_category": this.fetchTaxonomy().listings_category,
            "section": this.defaults.section,
            "move_second_ldp": this.defaults.section === 'to-rent' ? 'rent' : 'sale',
            "activity":"listing_details"
        }

        return  '<div class="advert">'
                +   '<div class="advert__content">'
                +       '<a class="text-link" rel="noopener noreferrer" target="_blank" ' 
                +           'data-ga-category="' + this.tracking.category + '"' 
                +           'data-ga-action="' + this.tracking.action + '"'
                +           'data-ga-label="' + this.tracking[this.defaults.section].label + '"'
                +           'href="' + this.tracking[this.defaults.section].destination +'" '
                +           'data-taxonomy="' + JSON.stringify(bannerLinkTaxonomy) + '" >'
                +           '<p>' + this.tracking[this.defaults.section].copy + '</p>'
                +           '<div class="btn btn-highlight">Find out more</div>'
                +       '</a>'
                +   '</div>'
                + '</div>';
    },

    /**
     * Grab Taxonomy from the first element on the page who has set up the taxonomy
     * to extract data to generate the banner for function "build_banner"
     * @returns { Obj } - the taxonomy object
     */
    fetchTaxonomy: function () {
        var firstTaxonomyFound = document.querySelector('[data-taxonomy*="listings_category"]');

        if (!firstTaxonomyFound) {
            return false;
        }

        return JSON.parse(firstTaxonomyFound.getAttribute('data-taxonomy'));
    },
    /**
     * Check the visilibity of the advertise block
     * @returns { Boolean } true if is visible false if is not
     */
    is_ad_showing: function () {
        if (!this.UI.advertisement) {
            return false;
        }
        
        if (!this.UI.advertisement.classList.contains(this.classes.hidden)) {
            return true;
        }

        return false;
    },

    hide_advert: function () {
        if (this.is_ad_showing() === true) {
            this.UI.advertisement.classList.add(this.classes.hidden)
        }
    },

    init_advertising: function () {
        var action;

        if (this.defaults.abTestVariant !== 'b') {
            return false;
        }

        if (!this.UI.advertisement) {
            this.append_banner();
            return false;
        } 

        action = this.is_ad_showing() === true ? 'add' : 'remove';
        this.UI.advertisement.classList[action](this.classes.hidden);
    },

    /**
     * Inject the banner within the existing carousel
     * then assign this.UI.advertisement
     * and hiden the description of the image
     */
    append_banner: function () {
        var currentSlide = document.getElementById('images-main-nav');        
        currentSlide.insertAdjacentHTML('afterend', this.build_banner());

        this.UI.advertisement = this.UI.imgMainContainer.getElementsByClassName('advert')[0];
        this.UI.imgDescription.innerHTML = ''; // dont show anything for ads

    }

};

$(function () {

    if (window.ZPG.UI.galleryContainer) {
        photoGallery.init();
    }

});
(function(){

    var rated = new Array();

    function submitRating($wrapper,$rating,$msg,$this){

        var params = {

            unique_rating_string: $wrapper.attr('data-rating-id'), 
            outcode: $wrapper.attr('data-rating-outcode'), 
            incode: $wrapper.attr('data-rating-incode'), 
            area_id: $wrapper.attr('data-rating-area_id'), 
            post_town_id: $wrapper.attr('data-rating-post_town_id'), 
            county_area_id: $wrapper.attr('data-rating-county_area_id'), 
            category: $wrapper.attr('data-category'), 
            rating: $rating

        };

        rated.push(params.category);
        rated = jQuery.unique(rated);

        var $num_categories = $('#rate-local-area-rate .inline-rating').length,
            $rating_success = $('#rate-local-area-tip span');

        if (rated.length == $num_categories) {

            $rating_success.html('<strong class="buyers">All done. Thanks for voting!</strong>'); 

            if ( $('.js-rate-area-btn').length > 0 ) {

                $('.js-rate-area-btn').removeClass('btn btn-highlight').each(function(){

                    var buttonText = $(this).text().replace('Rate','You rated');
                    $(this).html(buttonText);

                });

            }

        }

        $.ajax({
            url: '/ajax/local_info/rating',
            data: params,
            beforeSend: function(){
                $this.closest('.star-rating-wrap').find('.star-rating-msg').html('<img src="/static/images/icons/loading.gif" width="16" height="16" alt="Loading...">');
            },
            success: function(){

                dataLayer.push({
                    "event": "taxonomy",
                    "eventTaxonomy": {
                        "activity": "user_account",
                        "action": "rate_area"
                    }
                });

                $this.closest('.star-rating-wrap').data('data-rating-new', $msg);
                $this.closest('.star-rating-wrap').find('.star-rating-msg').html($msg);
            }
        });

    }

    $('.rating')

        .mouseover(function(){

            var $this = $(this),
                $wrapper = $(this).closest('.star-rating-wrap');

            $wrapper.find('.star-rating-msg').html($this.attr('data-rating-msg'));
            $wrapper.find('.current-rating').css('display','none');

        })

        .mouseout(function(){

            var $this = $(this),
                $wrapper = $(this).closest('.star-rating-wrap');

            $wrapper.find('.star-rating-msg').html('');

            if ($wrapper.data('data-rating-new') != undefined) {

                $wrapper.find('.star-rating-msg').html($wrapper.data('data-rating-new'));

            } else {

                $wrapper.find('.star-rating-msg').html($wrapper.attr('data-rating-current'));

            }

            $wrapper.find('.current-rating').css('display','block');

        })

        .on('click', function(){

            var $this = $(this),
                $wrapper = $(this).closest('.star-rating-wrap'),
                $rating = parseInt($this.attr('data-rating-stars'));
                $msg = $this.attr('data-rating-msg');

            $wrapper.find('.star-rating-success').remove();
            $wrapper.find('.current-rating').css('width', $rating * 20 + '%');

            submitRating($wrapper, $rating, $msg, $this);

            return false;

        }

    );

})();

function load_script(url, callback){
    var s = document.createElement("script")
    s.type = "text/javascript";
    s.async = true;

    if (s.readyState){
        s.onreadystatechange = function(){
            if (s.readyState == "loaded" || s.readyState == "complete"){
                s.onreadystatechange = null;
                if (callback) {
                    callback();
                }
            }
        };
    } else {
        s.onload = function(){
            if (callback) {
                callback();
            }
        };
    }

    s.src = url;
    document.getElementsByTagName("head")[0].appendChild(s);
}

function contact_agent_form_messages() {

    $('#form_contact_agent').find('input[name=msg_type_of_enquiry]').click(function() {

        $('#msg_body').attr('placeholder', '');

        var street_address = $('#listing-details-address h2').text();
        var section;
        if ($('#section').val() == 'for-sale') section = 'for sale';
        else section = 'to rent';


        if( $(this).val() == 'organise_viewing' ) {

            $('#msg_body').val('I would like to arrange a viewing of this property '+section+' in '+street_address+'. Please contact me to arrange a suitable time. Thanks.');

        } else if ( $(this).val() == 'request_property_details' ) {

            $('#msg_body').val('I would be grateful if you would send me further details on this property '+section+' in '+street_address+'. Thanks.');
        }

    }).trigger('click');

}

function contact_agent_postcode_lookup( postcode, selected, preventShowAddress ) {

    $.getJSON('/ajax/lookup_address_by_postcode/' + postcode, function(data) {

        var options = '<option value="">Select</option>';

        for (var i = 0; i < data.length; i++) {

            options += '<option value="' + data[i].property_id + '">' + data[i].address + '</option>';

        }

        options += '<option value="Address not listed.">My address is not listed</option>';

        $('#msg_body_address').html(options);

        if ( !preventShowAddress ) {
            if ( data.length > 0 ) {
                $('#msg_body_address').parent().show();
            }
        }

        $('#msg_body_address').val(selected).attr('selected', true);

    });

}

function remove_movie_frame() {

    // alert( 'remove remove_movie_frame' );
    // Remove Thumbnail additional click event
    // $( ".images-thumb" ).unbind( "click.remove_movie_frame" );

    // // Prevent Security Issue if the source of the iframe is not on Zoopla servers
    // var is = $("#movie-main iframe").attr('src');
    // if(is && is[0]=='/'){
    //     // Existing source code
    //     $("#movie-main iframe").contents().find("body").html("&nbsp;");
    // }

    // // Existing source code
    // $("#movie-main iframe").remove();
    // $("#movie").hide();
    // $("#images").show();

    // // New Code to display the slideshow
    // $("#images-main").show();
    // $("#images-nav").show();

    // $("#movie-main iframe").contents().find( "body" ).html('&nbsp;');//remove();
    // $("#movie-main iframe").remove();

    // $('#movie').hide();
    // $('#images').show();
}

function create_virtual_tour_frame(t, e, i, s) {
    var n = e.attr("data-listing-id");
    var a = e.attr("data-branch-id");
    void 0 === i && (i = 645);

    // Add some parameters to the virtual tour link to remove unnecessary services
    var v = t + (t.indexOf('?') > -1 ? '&' : '?') + 'source=zoopla';

    // Get slideshow height
    var h = $("#images-main").height();

    // Adjust height of the virtual tour holder
    $("#movie-main").height(h);

    // Adjust height of the iframe
    void 0 === s && (s = h);
    n && a ? $.get("/ajax/movies/log_view/?listing_id=" + n + "&branch_id=" + a) : !n && a ? $.get("/ajax/movies/log_view/?branch_id=" + a) : n && !a && $.get("/ajax/movies/log_view/?listing_id=" + n);
    r = $('<iframe src="' + v + '" style="border:0px;width:100%;height:100%;" />');
    r.css("width", i + "px").css("height", s + "px").attr("scrolling", "no").attr("seamless", "seamless").appendTo(e);

    // Display the virtual tour container
    $("#movie").show();

    // Hide the slideshow
    $("#images-main").hide();
    $("#images-nav").hide();

    // Click event listener to go back to the slideshow
    $(".images-thumb").click( function() {
        remove_movie_frame();
    });

}

$(function() {

    // SIGNIN/REGISTER
    ZPG.user_signin_register.init();

    // FAVOURITES
    ZPG.user_favourites.init();

    // MAIN MENU - TOUCH SUPPORT //

    if ($('body').hasClass('ie-8') || $('body').hasClass('ie-7')) {
        $('.has-dropdown-menu > a').on('mouseover', function(){
            $(this).addClass('is-active');
        });
        $('.has-dropdown-menu > a').on('mouseout', function(){
            $(this).removeClass('is-active');
        });
    } else {
        var dropdown_show_content = function() {
                $(this).find('> a').addClass('is-active');
            },
            dropdown_hide_content = function() {
                $(this).find('> a').removeClass('is-active');
            };

        $('.has-dropdown-menu').parent().hoverIntent({
            over: dropdown_show_content,
            out: dropdown_hide_content,
            selector: '.has-dropdown-menu',
            sensitivity: 10,
            timeout: 150
        });
    }

    $(document).on('touchstart click', '.has-dropdown-menu > a', function(e) {
        var $this = $(this);

        if ($(e.target).parents('.has-dropdown-menu').length > 0) {

            if (!$this.hasClass('is-active')) {
                e.preventDefault();
                e.stopPropagation();

                $this.parents('ul').find('.has-dropdown-menu > a').removeClass('is-active');
                $this.addClass('is-active').focus();
            }

        }
    });

    $(document).on('touchstart click', function(ev) {
        if ($(ev.target).parents('.dropdown-menu-content').length < 1) {
            $('.has-dropdown-menu > a').removeClass('is-active').blur();
        }
    });

    // MAIN MENU - WORK OUT SUBMENUS //

    $('.main-nav-top-item').each(function(i,el) {
        var menu_offsetLeft = el.offsetLeft,
            menu_width = $(el).width(),
            parent_width = $('.main-nav').parent().width();

        $(el).find('.main-nav-menu-content').each(function() {
            var submenu_width = $(this).width();

            if (menu_offsetLeft + submenu_width >(parent_width - 20)) {
                $(this).css({ right: (parent_width - menu_offsetLeft - menu_width - 1) + 'px', left: 'auto' });
            } else {
                $(this).css({ left: (menu_offsetLeft - 1) + 'px', right: 'auto' });
            }
        });
    });

    // EVENT TRACKING
    $( document ).on( "click", "[data-ga-category]", function() {

        var $this = $( this );

        dataLayer.push({
            "event": "GAEvent",
            "eventCategory": $this.attr( "data-ga-category" ),
            "eventAction": $this.attr( "data-ga-action" ),
            "eventLabel": $this.attr( "data-ga-label" ),
            "eventValue": undefined
        });

    });

    $( "select[data-ga-category]" ).on( "change", function() {

        var $this = $( this );

        dataLayer.push({
            "event": "GAEvent",
            "eventCategory": $this.attr( "data-ga-category" ),
            "eventAction": $this.find( "option:selected" ).attr( "data-ga-action" ),
            "eventLabel": $this.attr( "data-ga-label" ),
            "eventValue": undefined
        });

    });

    $( "a[data-ga-vpv]" ).on( "click", function() {

        var tracking = $( this ).attr( "data-ga-vpv" );

        dataLayer.push({
            "event": "GAVirtualPageview",
            "virtualPageviewUrl": tracking
        });

    });

    $("#breadcrumbs a").on("click", function() {

        var $el = $(this).parent(),
            level = $el.index() + 1;

        dataLayer.push({
            "event": "GAEvent",
            "eventCategory": "Breadcrumbs",
            "eventAction": "Click",
            "eventLabel": level
        });

    });

    /*
    (function(){

        if ( typeof( dataLayer ) !== "undefined" ) {

            $.each( dataLayer, function( i, v ) {
                if ( v.hasOwnProperty( "taxonomy" ) ) {
                    ZPG.taxonomy = dataLayer[ i ][ "taxonomy" ];
                    return false;
                }
            });

        }

    })();
    */

    $( document ).on( "click", "[data-taxonomy]", function() {

        // For this to work use single quotes for the
        // data attribute and double quotes for JSON.
        // data-taxonomy='{ "foo": "bar" }'
        var data = $( this ).data( "taxonomy" ) || {};

     //   data[ "activity" ] = ZPG.taxonomy[ "activity" ];

        dataLayer.push({
            "event": "taxonomy",
            "eventTaxonomy": data
        });

    });

    $( document ).on( "change", "select[data-taxonomy]", function() {

        var data = $( this ).data( "taxonomy" ) || {};

        dataLayer.push({
            "event": "taxonomy",
            "eventTaxonomy": data
        });

    });

    $.support.placeholder = (function(){
        var i = document.createElement('input');
        return 'placeholder' in i;
    })();

    // Creates HTML5 type functionality for 'placeholder' attribute in IE
    if ( !$.support.placeholder ) {

        $('[placeholder]').on('focus', function() {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
                input.removeClass('placeholder');
            }
        }).blur(function() {
            var input = $(this);
            if (input.val() == '' || input.val() == input.attr('placeholder')) {
                input.addClass('placeholder');
                input.val(input.attr('placeholder'));
            }
        }).blur();

        $('[placeholder]').parents('form').submit(function() {

            $(this).find('[placeholder]').each(function() {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            })

        });

        $('.relevant-details [placeholder], .sidebar #form-search [placeholder]').parents('form').find('.btn').click(function() {

            $(this).parents('form').find('[placeholder]').each(function() {
                var input = $(this);
                if (input.val() == input.attr('placeholder')) {
                    input.val('');
                }
            })

        });

    }

    // Tips
    $('a.jqModal').each(function(){

        $(this).fancybox({

            type: 'ajax',
            titleShow: false,
            href: $(this).attr('data-tip')

        });

    });


    $( ".toggle" ).on( "click", function( e ) {

        var $el = $( this ),
            $target = $( "#" + $el.attr( "rel" ) );

        e.preventDefault();

        if ( $el.data( "clicked" ) ) {

            $target.hide();

            $el.data( "clicked", false );

        } else {

            $target.show();
            $el.data( "clicked", true );

        }

    });

    /* New Market Widget */
    $('.market-panel').on('change', '.js-market-stats-months, .js-market-stats-property-type', function(){
        var months_selected = $('.js-market-stats-months option:selected').val(),
            property_type_selected = $('.js-market-stats-property-type option:selected').val().toLowerCase(),
            $average_price = $('.js-market-stats-average-price'),
            $average_value = $('.js-market-stats-average-value'),
            $num_sales = $('.js-market-stats-num-sales'),
            $value_change = $('.js-market-stats-value-change'),
            $value_change_pct = $('.js-market-stats-value-change-pct'),
            months_selected_index;

        switch (parseInt(months_selected)) {
            case 3: months_selected_index = 0; break;
            case 6: months_selected_index = 1; break;
            case 12: months_selected_index = 2; break;
            case 60: months_selected_index = 3; break;
            case 120: months_selected_index = 4; break;
            case 240: months_selected_index = 5; break;
        }

        $average_price.html($average_price.attr('data-value-' + property_type_selected).split(',')[months_selected_index] === '' || $average_price.attr('data-value-' + property_type_selected).split(',')[months_selected_index] === '0' ? '—' : ('&pound;' + formatThousands($average_price.attr('data-value-' + property_type_selected).split(',')[months_selected_index])));
        $num_sales.html($num_sales.attr('data-value-' + property_type_selected).split(',')[months_selected_index] === '' ? '0' : (formatThousands($num_sales.attr('data-value-' + property_type_selected).split(',')[months_selected_index])));
        $average_value.html($average_value.attr('data-value-' + property_type_selected).split(',')[months_selected_index] === '' ? '—' : ('&pound;' + formatThousands($average_value.attr('data-value-' + property_type_selected).split(',')[months_selected_index])));
        $value_change.html($value_change.attr('data-value-' + property_type_selected).split(',')[months_selected_index] === '0' ? '—' : (($value_change.attr('data-value-' + property_type_selected).split(',')[months_selected_index].indexOf('-') < 0 ? '' : '-') + '&pound;' + formatThousands($value_change.attr('data-value-' + property_type_selected).split(',')[months_selected_index])));
        $value_change_pct.html((parseFloat($value_change_pct.attr('data-value-' + property_type_selected).split(',')[months_selected_index]) < 0 ? '▼' : (parseFloat($value_change_pct.attr('data-value-' + property_type_selected).split(',')[months_selected_index]) > 0 ? '▲' : '')) + ' ' + $value_change_pct.attr('data-value-' + property_type_selected).split(',')[months_selected_index] + '%');

        if (parseFloat($value_change_pct.attr('data-value-' + property_type_selected).split(',')[months_selected_index]) < 0) {
            $value_change.addClass('market-panel-stat-value-change-down').removeClass('market-panel-stat-value-change-up');
            $value_change_pct.addClass('market-panel-stat-value-change-down').removeClass('market-panel-stat-value-change-up');
        } else if (parseFloat($value_change_pct.attr('data-value-' + property_type_selected).split(',')[months_selected_index]) > 0) {
            $value_change.addClass('market-panel-stat-value-change-up').removeClass('market-panel-stat-value-change-down');
            $value_change_pct.addClass('market-panel-stat-value-change-up').removeClass('market-panel-stat-value-change-down');
        } else {
            $value_change.removeClass('market-panel-stat-value-change-up market-panel-stat-value-change-down');
            $value_change_pct.removeClass('market-panel-stat-value-change-up market-panel-stat-value-change-down');
        }

        dataLayer.push({
            "event": "GAEvent",
            "eventCategory": 'market_activity',
            "eventAction": ($(this).hasClass('js-market-stats-months') ? 'dropdown_historical_timeframe' : 'dropdown_property_type'),
            "eventLabel": ($(this).hasClass('js-market-stats-months') ? $('.js-market-stats-months option:selected').val() : $('.js-market-stats-property-type option:selected').text().toLowerCase()),
            "eventValue": undefined
        });
    });

    // Stats widget
    $('#stats-change').change(function(){
        $('#stats span').addClass('none');
        $('#stats-'+$(this).val()).removeClass('none');
        return false;
    });

    if ( $('#vc_month').val() != 2 ) {
        $('.vc').addClass('none');
        $('.vc_' + $('#vc_month').val()).removeClass('none');
    }

    $('#vc_month').change(function(){
        $('.vc').addClass('none');
        for ( var x = 0; x <= 6; x++ ) {
            if ( $('#vc_month').val() == x ) {
                $('.vc_' + x ).removeClass('none');
            }
        }
    });

    $('select.js-redirects-to-option').change(function(){

        var $this = $(this),
            $option = $(this).find('option:selected');

        if ($this.attr('name') == 'listings-sort') {

            dataLayer.push({
                "event": "GAEvent",
                "eventCategory": $option.attr( "data-ga-category" ),
                "eventAction": $option.attr( "data-ga-action" ),
                "eventLabel": $option.attr( "data-ga-label" ),
                "eventValue": undefined
            });

        }

        if ($this.attr('data-ga-category') && $this.attr('data-ga-action')) {
            dataLayer.push({
                "event": "GAEvent",
                "eventCategory": $this.attr( "data-ga-category" ),
                "eventAction": $this.attr( "data-ga-action" ),
                "eventLabel": $option.val(),
                "eventValue": undefined
            });
        }

        // If the option value is a URL, redirect to it
        if ( $this.attr( "data-option" ) === "url" ) {
            window.location = $option.val();

        // SEO don't always want URLs in source so by
        // default we look for param name and option to change
        // the current page using external/url.js plugin
        } else {

            var url  = new Url,
                param = $this.attr( "name" );

            // When we change the sort order,
            // we also want to reset pagination
            delete url.query[ 'pn' ];

            if ( $option.val() === "" ) {
                delete url.query[ param ];
            } else {
                url.query[ param ] = $option.val();
            }

            window.location = url;

        }

    });

    $('.js-use-selectboxit select').not('[data-selectboxit=false]').selectBoxIt({
        autoWidth: false,
        native: true,
        downArrowIcon: 'icon icon-down-open-1'
    });

    // Hide success messages
    $('.alert-fade').delay(15000).fadeOut(1200);

    // Attributes edit
    $('a.attr-edit').fancybox({

        onComplete: function() {

            $('#attr-form').validate({

                submitHandler: function(form){

                    var form = $('#attr-form'),
                        propId = $('#property_id').val();

                    $.ajax({
                        url: form.attr('action'),
                        data: form.serialize(),
                        success: function(){
                            form.html('<h1>Thank you!<\/h1><p>This information has been noted and we will update our records where appropriate as soon as possible.<\/p>')
                            $('#edit_'+propId).parent().find('.attributes-update').load('/widgets/property/attributes.html?property_id='+propId);
                        }

                    });

                }

            });
        }
    });

    $('a.printDetails').on('click', function(event) {

        event.preventDefault();
        window.open( $(this).attr('href'), '', 'width=700,height=650,directories=no,resizable=no,scrollbars=yes,toolbar=no,menubar=no,titlebar=no,status=no' );

    });

    $('.clear-txt').on('click', function( e ) {

        e.preventDefault();

        $(this).siblings('textarea').val('');

    });

    $(window).scroll(function() {

        var start_pos = $('header').height() + $('.js-cookie-policy').height(),
            pos = $(this).scrollTop();

        if (pos > start_pos) {
            setAdBGPosition('fixed');
        } else if (pos <= start_pos) {
            setAdBGPosition('scroll');
        }

    }).ready(function() {

        setTimeout(function(){
            setAdBGPosition();
        }, 2500);

        $('.js-cookie-policy-close').click(function() {
            setAdBGPosition();
        });

    });

    function setAdBGPosition(attach) {

        var adPosition;

        if(attach === 'fixed') {
            adPosition = $('#form-search-and-refine').height();
        } else {
            adPosition = $('.main-content-area').offset().top;
        }

        $('body').css("background-attachment", attach, "important")
                 .css("background-repeat", "no-repeat")
                 .css("background-position", "50% " + adPosition + "px", "important");
    }

});

(function() {

    var ele = $('.popup-trigger').hover(function() {
        $(this).next('.popup-bubble').fadeToggle(200);
    }, function() {
        $(this).next('.popup-bubble').fadeToggle(200);
    });

}());


(function() { $('.show-hide-toggle-label').click(
    function($ev){
        $ev.preventDefault();
        var $label = $($ev.currentTarget),
            $toggled = $( '#'+ $label.attr('for') +' ~ .show-hide' );
        if($toggled.height() === 0){
            $toggled.css({'max-height': 'none', 'opacity': '1', 'display': 'none'});
        }
        $toggled.toggle();
        $label.find( $( '.less' ) ).toggle();
        $label.find( $( '.more' ) ).toggle();
    }
)}());

(function() {
    svg4everybody(); // SVG for Everybody adds SVG External Content support to all browsers.
}());

// Create an immediately invoked functional expression to wrap our code
(function () {

  // Define our constructor
  this.UIModal = function () {

    // Create global element references
    this.closeButton = null;
    this.modal = null;
    this.overlay = null;

    // Determine proper prefix
    this.transitionEnd = transitionSelect();

    // Define option defaults
    var defaults = {
      autoOpen: false,
      className: 'fade-and-scale',
      closeButton: true,
      dismissable: true,
      persistentClose: false,
      content: '',
      variant: 'normal',
      maxWidth: '',
      minWidth: '',
      overlay: true,
      destroy: false,
      onOpen: function () {
      },
      onClose: function () {
      }
    }

    this.State = {
      isModalOpen: false
    };

    // Set defaults or supplied arguments
    this.options = (arguments[0] && typeof arguments[0] === 'object') 
                    ? extendDefaults(defaults, arguments[0]) 
                    : defaults;

    if (this.options.autoOpen === true) {
      this.open();
    }

  }

  // Public Methods
  UIModal.prototype.hide = function () {
    this.closeButton.click();
  }

  UIModal.prototype.close = function () {
    var _ = this;

    this.modalContainer.classList.remove('ui-modal-container--open');

    setTimeout(function () {
      if (!_.modalContainer.parentNode) { // make sure to not trigger error if the parentNode doesn't exist
        return false;
      }
      _.modalContainer.parentNode.removeChild(_.modalContainer);
    }, 500);

    if (this.options.persistentClose) {
      this.storeChoice();
    }

    //  Callback on close
    this.options.onClose();
    this.State.isModalOpen = false;

  }

  UIModal.prototype.storeChoice = function () {
    var modalChoice = 'closeModal';
    var modalCookie = Cookie.read(modalChoice);

    if (!modalCookie) {
      Cookie.create(modalChoice, '1', 365);
    }

  }

  UIModal.prototype.open = function () {

    if (this.State.isModalOpen === true) { // if the modal is already open skip the open function
      return false;
    }

    build.call(this);
    initializeEvents.call(this);

    this.modalContainer.className = this.modalContainer.className + ' ui-modal-container--open';

    document.activeElement.blur();
    this.State.isModalOpen = true;

  }

  function build() {

    var contentHolder, docFrag, appWrapper;
    var existing = (this.modal !== null);
    var content = this.options.content;

    // Check the variant and set inline style variant
    if (this.options.variant !== 'normal') {
      this.options.className = 'ui-modal--inline';
      this.options.overlay = false; // force the overlay to be removed
    }

    // Create a DocumentFragment to work with
    docFrag = document.createDocumentFragment();

    // if this.modal exists we don't want to create a new fragment
    if (!existing) {
      // Create modal

      this.modalContainer = document.createElement('div');
      this.modalContainer.className = 'ui-modal-container';

      this.modal = document.createElement('div');
      this.modal.className = 'ui-modal ' + this.options.className;

      // If closeButton option is true, add a close button
      if (this.options.closeButton === true && this.options.dismissable) {
        this.closeButton = document.createElement('button');
        this.closeButton.className = 'ui-modal__close close-button';
        this.closeButton.innerHTML = '&times;';
        this.modal.appendChild(this.closeButton);
      }

      // Build content and append to modal
      contentHolder = document.createElement('div');
      contentHolder.className = 'ui-modal__wrapper';
      this.modal.appendChild(contentHolder);
      this.modal.insertBefore(content, contentHolder);

      if (content.classList.contains('visually-hidden')) {
        content.classList.remove('visually-hidden');
      }

      this.modalContainer.appendChild(this.modal);
    }

    //this.modalContainer.classList.add('ui-modal-container--open')

    // Overlay required?
    if (this.options.overlay === true) {
      this.modalContainer.classList.add('ui-modal-overlay');
    }

    // Append modal to DocFrag
    docFrag.appendChild(this.modalContainer);

    // Append DocFrag conditionally to Body or above the appWrapper (move-planner)
    if (this.options.variant !== 'normal') {
      appWrapper = document.getElementById('move-planner');

      if (appWrapper) { // check if the move-planner exists
        appWrapper.insertBefore(docFrag, appWrapper.querySelector('.mp-accordion'));
      }

    } else {
      document.body.appendChild(docFrag);

    }
    //  Callback on close
    this.options.onOpen();

  }

  function extendDefaults(source, properties) {
    var property;
    for (property in properties) {
      if (properties.hasOwnProperty(property)) {
        source[property] = properties[property];
      }
    }
    return source;
  }

  function initializeEvents() {

    var thisModal = this;
    var closeModalClass = document.getElementsByClassName('js-close-modal');

    thisModal.modalContainer.addEventListener('mousedown', function (event) {
      var autocompleteLists = thisModal.modalContainer.getElementsByClassName('autocomplete__list'),
        autoCompleteHidden = true;

      for (var i = 0, len = autocompleteLists.length; i < len; i++) {
        if (!autoCompleteHidden) {
          return false;
        }
        autoCompleteHidden = autocompleteLists[i].getAttribute('aria-hidden');
      }

      if (window.ZPG.utils.isDescendant(thisModal.modalContainer, document.activeElement)) {
        return false;
      }
      if (event.target === thisModal.modalContainer && this.options.dismissable)
        thisModal.close();
    }.bind(thisModal));
    if(this.options.dismissable) {
      for (var i = 0, len = closeModalClass.length; i < len; i++) {
          closeModalClass[i].addEventListener('click', thisModal.close.bind(thisModal));
      }
      if (thisModal.closeButton) {
          thisModal.closeButton.addEventListener('click', thisModal.close.bind(thisModal));
      }
    }

  }

  function transitionSelect() {
    var t,
      el = document.createElement('div');

    var animations = {
      animation: "animationend",
      OAnimation: "oAnimationEnd",
      MozAnimation: "animationend",
      WebkitAnimation: "webkitAnimationEnd"
    };
    for (t in animations) {
      if (el.style[t] !== undefined) {
        return animations[t];
      }
    }
  }

}());

if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike === null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method 
      // of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}
window.ZPG = window.ZPG || {};

var utils = (function() {

    var requestData = function(url, type, callback) {
        var xhttp = new XMLHttpRequest();

        xhttp.open('GET', url, true);
        xhttp.onload = function() {
            if (xhttp.readyState === 4) {
                if (xhttp.status === 200) {

                    if (type === 'json') {
                        callback(JSON.parse(xhttp.responseText));
                    } else {
                        callback(xhttp.responseText);
                    }
                } else { // Server responded with some error
                    console.error(xhttp.statusText);
                }
            }
        };
        xhttp.onerror = function() {
            console.error(xhttp.statusText);
        };
        xhttp.send();
    };

    var postData = function(url, data, callback, type) {
        var xhttp = new XMLHttpRequest();

        xhttp.open("POST", url, true);
        xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhttp.onload = function () {
            if (xhttp.readyState == 4 && xhttp.status == 200) {
                if (type === 'json') {
                    callback(JSON.parse(xhttp.responseText));
                } else {
                    callback(xhttp.responseText);
                }
            }
        };
        xhttp.onerror = function() {
            console.error(xhttp.statusText);
        };
        xhttp.send(data);
    };

    var loadScript = function(url, callback) {
        
        var s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;

        if (s.readyState) {
            s.onreadystatechange = function() {
                if (s.readyState == 'loaded' || s.readyState == 'complete') {
                    s.onreadystatechange = null;
                    if (callback) {
                        callback();
                    }
                }
            };
        } else {
            s.onload = function() {
                if (callback) {
                    callback();
                }
            };
        }

        s.src = url;
        document.getElementsByTagName('head')[0].appendChild(s);
    };

    /**
     * Is node a decendant of given parent.
     * @param parent
     * @param child
     * @returns {boolean}
     */
    var isDescendant = function(parent, child) {
        var node = child.parentNode;
        while (node != null) {
            if (node === parent) {
                return true;
            }
            node = node.parentNode;
        }
        return false;
    };

    /**
     * throttle allows to throttle function execution
     * @param  {Function} fn    function to be delayed
     * @param  {number}   delay delay in ms
     * @return {Function|undefined} delayed function or nothing
     */
    var throttle = function(fn, delay) {
        if (typeof fn !== 'function') {
            return;
        }

        var lastCall = 0;
        delay = typeof delay === 'number' ? delay : 100;

        return function() {
            var now = +new Date();

            if (now - lastCall < delay) {
                return;
            }

            lastCall = now;
            fn.apply(this, arguments);
        };
    };

    var debounce = function(func, wait, immediate) {
        if (immediate === void 0) { immediate = false; }
        var timeout;
        return function() {
            var context = this, args = arguments;
            timeout !== null && clearTimeout(timeout);
            timeout = window.setTimeout(function() {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            }, wait);
            if (immediate && !timeout)
                func.apply(context, args);
        };
    };

    var getURLstr = function() {
        var pathArray = window.location.pathname.split('/');
        return '/' + pathArray[1] + '/' + pathArray[2];
    };

    var updateMoveDetails = function(data) {
        var details = ['from_postcode', 'to_postcode', 'move_date'];

        for (var i = 0, len = details.length; i < len; i++) {

            var val = (details[i] === 'move_date')
                ? data['move_date_display']
                : data[details[i]];

            if (val) {
                updateMoveDetail(details[i], val);
            }
        }
    };

    var updateMoveDetail = function(type, val) {

        var detail = document.querySelectorAll('input[name=' + type + ']'),
            updateDetail = document.querySelectorAll('[data-update-detail=' +
                type + ']');

        [].forEach.call(detail, function(item) {
            item.innerHTML = val;
        });

        [].forEach.call(updateDetail, function(item) {
            item.innerHTML = val;
        });

        if (type === 'to_postcode') {
            var outcode = val.match(/([^\s]+)(?:\s...)?$/)[1];
            updateMoveDetail('outcode', outcode);
        }

    };

    var reformatDashDate = function(dashDate) {
        var split = dashDate.split('-');
        return [split[2], split[1], split[0]].join('/');
    };

    var isValidDate = function(dateString) {
        if (dateString == null) return false;
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateString.match(regEx)) return false;  // Invalid format
        var d = new Date(dateString);
        if (!d.getTime() && d.getTime() !== 0) return false; // Invalid date
        return d.toISOString().slice(0, 10) === dateString;
    };

    var serializeForm = function(form) {

        var field, s = [];
        if (typeof form == 'object' && form.nodeName == 'FORM') {
            var len = form.elements.length;
            for (i = 0; i < len; i++) {
                field = form.elements[i];
                if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type !=
                    'button') {
                    if (field.type == 'select-multiple') {
                        for (j = form.elements[i].options.length - 1; j >= 0; j--) {
                            if (field.options[j].selected)
                                s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.options[j].value);
                        }
                    } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                        s[s.length] = encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value);
                    }
                }
            }
        }
        return s.join('&').replace(/%20/g, '+');

    };

    return {
        requestData: requestData,
        postData: postData,
        loadScript: loadScript,
        getURLstr: getURLstr,
        updateMoveDetails: updateMoveDetails,
        updateMoveDetail: updateMoveDetail,
        isDescendant: isDescendant,
        throttle: throttle,
        debounce: debounce,
        reformatDashDate: reformatDashDate,
        serializeForm: serializeForm,
        isValidDate: isValidDate
    };

})();

window.ZPG.utils = utils;

window.ZPG = window.ZPG || {};

window.ZPG.tabs = {
    /**
     * Constructor
     */
    constructor: function (options) {
        this.el = options.el;
        
        this.classes = {
            tabLink: 'zpg-tabs__tab-link',
            activeTab: 'zpg-tabs__tab-link--active',
            panel: 'zpg-tabs__panel',
            activePanel: 'zpg-tabs__panel--active'
        };
        
        this.UI = {
            tabList: this.el.getElementsByClassName(this.classes.tabLink),
            panels: this.el.getElementsByClassName(this.classes.panel),
            currentPanel: this.el.getElementsByClassName(this.classes.activePanel)[0],
            activeTab: this.el.getElementsByClassName(this.classes.activeTab)[0]
        };

        this.STATE = {
            currentIndex: -1
        };

        this.tabCount = this.UI.tabList.length;

    },

    /**
     * Initialize the object
     */
    init: function (options) {

        if (!options.el) {
            return false;
        }

        this.constructor(options);

        this.attachEvents();


    },

    /**
     *
     */
    attachEvents: function() {

        this.el.addEventListener('click', function(e) {
            var el = e.target;

            if (el.classList.contains(this.classes.tabLink)) {
                this.STATE.currentIndex = [].indexOf.call(this.UI.tabList, el);
                this.toggleActiveTab();                
            }

        }.bind(this));

        this.el.addEventListener('keyup', function(e) {
            var el = e.target;

            if (e.keyCode === 37 || e.keyCode === 39) { //left or right
                this.getNextTab(el, e.keyCode);
            }

        }.bind(this));

    },

    getNextTab: function(el, keyCode) {
        this.STATE.currentIndex = [].indexOf.call(this.UI.tabList, el);
        (keyCode === 37 ? this.STATE.currentIndex-- : this.STATE.currentIndex++);
        
        if ( this.STATE.currentIndex <= -1 ) {
            this.STATE.currentIndex = this.tabCount - 1;
        } else if (this.STATE.currentIndex >= this.tabCount){
            this.STATE.currentIndex = 0;
        }

        this.toggleActiveTab();

    },

    toggleActiveTab: function() {
        
        this.removeActive();

        this.updateActive();
        
        this.addActive();

    },

    removeActive: function() { 
        this.UI.currentPanel.classList.remove(this.classes.activePanel);
        this.UI.activeTab.classList.remove(this.classes.activeTab);
        this.UI.activeTab.setAttribute('tabindex','-1');
        this.UI.activeTab.setAttribute('aria-selected','false');   
    },

    addActive: function() {
        this.UI.activeTab.focus();
        this.UI.activeTab.classList.add(this.classes.activeTab);  
        this.UI.activeTab.removeAttribute('tabindex');  
        this.UI.activeTab.setAttribute('aria-selected','true');              
        this.UI.currentPanel.classList.add(this.classes.activePanel);
    },

    updateActive: function() {
        this.UI.activeTab = this.UI.tabList[this.STATE.currentIndex];
        this.UI.currentPanel = this.UI.panels[this.STATE.currentIndex];
    }


};
window.ZPG.googleplus = {

    init: function() {
        var buttons = document.getElementsByClassName('social-login__button--googleplus');

        window.ZPG.utils.loadScript('https://apis.google.com/js/client:platform.js', function() {
            if (!buttons) {
                return false;
            }

            [].forEach.call(buttons, function(button) {
                button.classList.remove('inactive');
            });

        });

    },

    login: function(additionalParams) {
        if (!additionalParams) {
            additionalParams = {
                'callback': ZPG.googleplus.signin_callback,
                'theme': 'dark'
            };
        }
        // if multiple google account selection box appears,
        // we want to stop the default account being logged in immediately
        gapi.auth.signOut();

        gapi.auth.signIn(additionalParams);

    },

    signin_callback: function(authResult) {

        if (authResult['status']['signed_in']) {

            var token = 'access_token=' + authResult['access_token'];

            window.ZPG.utils.postData('/ajax/signin/googleplus', token,
                function(data) {

                    if (data['success']) {
                        // goodness happened, redirect to myaccount
                        top.location.href = '/signin/?via=googleplus';
                    } else {
                        // badness happened - do something
                        alert('Unable to login, permission and e-mail address required.');
                    }

                }, 'json');

        } else {
            // Update the app to reflect a signed out user
            // Possible error values:
            //   "user_signed_out" - User is signed-out
            //   "access_denied" - User denied access to your app
            //   "immediate_failed" - Could not automatically log in the user
            // console.log('Sign-in state: ' + authResult['error']);
        }
    }

};

window.ZPG.facebook = {

    permissions: "public_profile,email",
    error_string: "Your Facebook account was not authorized.",

    login: function( auth, scope ) {

        scope = scope || ZPG.facebook.permissions;
        FB.login(auth, {
            scope: scope,
            return_scopes: true
        })

    },

    login_callback: function( response ) {

        if ( response.authResponse && response.authResponse.grantedScopes ) {
            var grantedScopes = response.authResponse.grantedScopes.split(',');

            var hasEmail = grantedScopes.filter(function (e, i) { return e == 'email'; });

            if (hasEmail.length > 0) {
                ZPG.facebook.check_login_state();
            } else {
                // revoke permissions, so we have to re-request
                FB.api('/v2.2/me/permissions', 'DELETE', { access_token: response.authResponse.accessToken }, function() {
                    alert('Logging via Facebook requires that e-mail address permission be granted, please try again.');
                });
            }
        } else {
            alert( ZPG.facebook.error_string );
        }
    },


    check_login_state: function() {
        FB.getLoginStatus(function(response) {
            ZPG.facebook.status_change_callback( response );
        });
    },

    // This is called with the results from from FB.getLoginStatus().
    status_change_callback: function( response ) {

        if (response.status === 'connected') {

            ZPG.facebook.login_to_zpg( response );

        } else if (response.status === 'not_authorized') {
            // The person is logged into Facebook, but not your app.
            // ZPG.facebook.login();
        } else {
            // The person is not logged into Facebook, so we're not sure if
            // they are logged into this app or not.
        }
    },

    login_to_zpg: function(response) {

        var token = "access_token=" + response.authResponse.accessToken;

        window.ZPG.utils.postData('/ajax/signin/facebook', token,
            function(data) {
                if (data['success']) {
                    top.location.href = '/signin/?via=facebook';
                } else {
                    alert('Unable to login, permission and e-mail address required. Please try again');
                }
            }, 'json');
    },

    init: function(id) {

        window.fbAsyncInit = function() {
            FB.init({
                appId      : id,
                oauth      : true,
                cookie     : true,  // enable cookies to allow the server to access the session
                xfbml      : true,  // parse social plugins on this page
                version    : 'v2.12' // use version 2.12
            });
        };

        // Load the SDK asynchronously
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s);
            js.id = id;
            js.src = '//connect.facebook.net/en_GB/sdk.js';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    }

};

window.ZPG          = window.ZPG || {};
window.ZPG.Searches = window.ZPG.Searches || {};

window.ZPG.Searches.Alerts = {

    /**
     * Constructor
     */
    constructor: function(options) {

        this.classes = {
            formSearchAlert: 'form_alert_search'
        };

        this.UI = {
            formSearchAlert: document.getElementById(this.classes.formSearchAlert)
        };

        this.defaults = {
            ajaxSave: '/ajax/alerts/save_alert.json'
        };
    },

    save: function(options, callback) {

        this.constructor(options);

        if (!this.UI.formSearchAlert) {
            return false;
        }

        window.ZPG.utils.postData(this.defaults.ajaxSave, ZPG.utils.serializeForm(this.UI.formSearchAlert),
            function(data) {
                callback(data);
            }.bind(this), 'json');

    }

};

(function() {
    /**
     * Lazyloader for images
     */

    // problems:
    // - IE9+ only (doucment.querySelectorAll, event handling)
    // - it creates array of images only and only on load
    // - other elements not supported
    // - additional images loaded via AJAX won't be taken care of

    var imgs,
        options = {
            lazyClass: 'lazy',
            loadedClass: 'lazy-loaded',
            sourceAttr: 'data-src',
            offsetY: 200,
            offsetX: 200,
            delay: 100
        };

    /**
     * throttle allows to throttle function execution
     * @param  {Function} fn    function to be delayed
     * @param  {number}   delay delay in ms
     * @return {Function|undefined} delayed function or nothing
     */
    function throttle(fn, delay) {
        if (typeof fn !== 'function') {
            return;
        }

        var lastCall = 0;
        delay = typeof delay === 'number' ? delay : 100;

        return function() {
            var now = +new Date();

            if (now - lastCall < delay) {
                return;
            }

            lastCall = now;
            fn.apply(this, arguments);
        }
    }

    /**
     * scrollTop
     * @return {number}
     */
    function scrollTop() {
        var scroll = window.pageYOffset;
        return (scroll === undefined) ?
            document.scrollTop :
            scroll;
    }

    /**
     * loadAsset loads asset from source on demand
     * @param  {DOM node} el IMG element to perform operation on
     */
    function loadAsset(el) {
        var source = el.getAttribute(options.sourceAttr);

        if (!source) {
            return;
        }

        el.src = source;

        el.addEventListener('load', function() {
            el.removeAttribute(options.sourceAttr);
            el.classList.add(options.loadedClass);
        }, false);
    }

    /**
     * isVisible checks if element is in the visible
     * @param  {DOM node}  el element to be checked
     * @return {Boolean}
     */
    function isVisible(el) {
        var docEl = document.documentElement,
            viewportTop = scrollTop(),
            viewportHeight = window.innerHeight || docEl.clientHeight,
            viewportWidth = window.innerWidth || docEl.clientWindth,
            elPos = el.getBoundingClientRect(),
            topEdge,
            isIn;

        topEdge = (elPos.top + viewportTop - options.offsetY) - viewportHeight;

        isIn = (topEdge <= viewportTop 
                && elPos.bottom > -options.offsetY 
                && elPos.left <= viewportWidth + options.offsetX 
                && elPos.right > -options.offsetX);

        return isIn;
    }

    /**
     * handleLazyImages
     * @return {Funcion|undefined} execute for visible images
     */
    function handleLazyImages() {
        if (!imgs.length) {
            return;
        }

        for (var i = 0; i < imgs.length; i++) {
            if (isVisible(imgs[i])) {
                loadAsset(imgs[i]);
                imgs.splice(i, 1);
                // reset index
                i--;
            }
        }
    }

    // execute on load and add listeners
    document.addEventListener('DOMContentLoaded', function() {
        imgs = [].slice.call(document.querySelectorAll('img.' + options.lazyClass));

        if (imgs.length) {
            handleLazyImages();
            addEventListener('scroll', throttle(handleLazyImages, options.delay));
            addEventListener('resize', throttle(handleLazyImages, options.delay));
        }
    }, false);
})();

window.ZPG = window.ZPG || {};

(function(window) {
    'use strict';

    var regisModal;

    document.addEventListener('DOMContentLoaded', function() {

        if (window.ZPG.Registration.STATE.userIsLoggedIn) {
            return false;
        }

        if (window.ZPG.Registration.UI.modal) {

            // Init the customizer
            regisModal = Object.create(window.ZPG.Registration.Popup);
            regisModal.init({
                el: window.ZPG.Registration.UI.modal,
            });

        }

    });

}(window));

window.ZPG              = window.ZPG || {};
window.ZPG.Registration = window.ZPG.Registration || {};

window.ZPG.Registration.UI = window.ZPG.Registration.UI || {
    modal: document.getElementById('modal_register')

};

window.ZPG.Registration.STATE = window.ZPG.Registration.STATE || {
    modalVisible: false,
    userIsLoggedIn: !window.ZPG.Registration.UI.modal ? 1 : 0
};


window.ZPG              = window.ZPG || {};
window.ZPG.Registration = window.ZPG.Registration || {};

window.ZPG.Registration.Popup = {

    /**
     * Constructor
     */
    constructor: function(options) {

        this.el = options.el;

        this.defaults = {
            url: {
                signin: '/ajax/signin/user-signin',
                register: '/ajax/register/user-registration',
                signinFB: '/ajax/signin/facebook',
                signinGoogle: '/ajax/signin/googleplus',
                alertForm: '/ajax/alerts/create/',
                titleUpdate: '/ajax/register/user-registration-title'
            },
            message: {
                successSignIn: 'Thanks for signing in',
                errorLogin: 'Unable to login, permission and e-mail address required. Please try again',
                errorConsent: 'Please set your contact preferences'
            }
        };

        this.classes = {
            formAlertSearch: '#form_alert_search',
            formRegister: '#register_form',
            formSearchAndRefine: 'form-search-and-refine',
            jsRegister: 'js-register-user',
            jsSignin: 'js-signin-user',
            jsSaveAlert: 'js-save-alert',
            jsTrigger: 'js-registration-modal',
            jsValidationCheck: 'js-check',
            jsValidationInvalid: 'js-invalid',
            jsValidationValid: 'js-valid',
            tabs: 'zpg-tabs',
            tabActive: 'zpg-tabs__panel--active',
            social: 'social-login__button',
            googleplus: 'social-login__button--googleplus',
            facebook: 'social-login__button--facebook',
            radio: 'faux-radios__custom-radio',
            modalHeader: '.ui-modal__header strong',
            modalTitle: 'ui-modal__title',
            modalContent: 'ui-modal__content',
            error: 'error',
            alert: 'alert'
        };

        this.UI = {
            activeForm: this.el.querySelector(this.classes.formRegister),
            formRadios: this.el.querySelector('.faux-radios'),
            formSearch: document.getElementById(this.classes.formSearchAndRefine),
            modal: null,
            modalContent: this.el.getElementsByClassName(this.classes.modalContent)[0],
            modalTitle: this.el.getElementsByClassName(this.classes.modalTitle)[0],
            triggers: document.getElementsByClassName(this.classes.jsTrigger),
            tabs: this.el.getElementsByClassName(this.classes.tabs),
            consents: this.el.querySelectorAll('.faux-radios__group input[type=radio]'),
            socialSignin: {
                facebook: null,
                googleplus: null
            },
            fbRoot: document.getElementById('fb-root'),
            tabList: []
        };

        this.DATA = {
            pageAfterLogin: null,
            actionName: null,
            consents: {}
        };

        this.State = {
            isValid: false,
            errorTotal: 0,
            consentErrorShown: null
        };

    },

    /**
     * Initialize the object
     * @param options
     */
    init: function(options) {

        if (!options.el) {
            return false;
        }

        window.ZPG.Registration.STATE.modalVisible = true; // Set the global state for the modal to true

        this.constructor(options);

        this.attach_events();

    },

    /**
     * Attach the events
     */
    attach_events: function() {

        this.attach_document_events();

        this.attach_modal_event_delegates();

    },

    /**
     * Attach onClick event to all occurances of 'trigger' throughout document
     */
    attach_document_events: function() {

        [].forEach.call(this.UI.triggers, function(el) {

            el.addEventListener('click', function(e) {

                e.preventDefault();

                this.DATA.pageAfterLogin = el.getAttribute('href');

                this.DATA.actionName = el.getAttribute('data-title');

                this.open_registration_modal();

            }.bind(this));

        }.bind(this));
    },

    /**
     * Attach event delegates to the modal
     */
    attach_modal_event_delegates: function() {

        this.el.addEventListener('click', function(e) {
            var target = e.target;

            // remove all error messaging and start again
            this.reset_all_forms(target);

            if (target.nodeName != 'BUTTON' &&
                !target.classList.contains(this.classes.social)) {
                return false;
            }

            e.preventDefault();

            // Register new user
            if (target.classList.contains(this.classes.jsRegister)) {

                this.UI.activeForm = target.closest('form');
                this.register_user();

            }

            // Registered user sign in
            if (target.classList.contains(this.classes.jsSignin)) {

                this.UI.activeForm = target.closest('form');
                this.signin_user();

            }

            // sign in via Google
            if (this.UI.socialSignin.googleplus &&
                target.classList.contains(this.classes.googleplus)) {

                window.ZPG.utils.debounce(this.social_signin_via_google(), 100);

            }

            // sign in via Facebook
            if (this.UI.socialSignin.facebook &&
                target.classList.contains(this.classes.facebook)) {

                window.ZPG.utils.debounce(this.social_login_via_facebook(), 100);

            }

        }.bind(this));
    },

    /**
     * Create the modal instance and push the mp-customizer block
     * into the modal box.
     * Add the js-noscroll class to prevent scroll on open
     * Reload the page without query string on close
     */
    open_registration_modal: function() {

        this.UI.modal = new UIModal({
            content: this.el,
            autoOpen: true,
            className: 'fade-and-scale ui-modal--register',
            onOpen: function() {

                this.modal_init();

                this.track_event({
                    'category': 'Registration',
                    'action': 'Form shown',
                    'label': this.DATA.actionName
                });

            }.bind(this),
            onClose: function() {

                window.ZPG.Registration.STATE.modalVisible = false;

                if (window.ZPG.Registration.STATE.userIsLoggedIn) {

                    this.redirect_location_to();

                } else {

                    this.track_event({
                        'category': 'Registration',
                        'action': 'Form closed',
                        'label': this.DATA.actionName
                    });

                }

            }.bind(this)
        });
    },

    /**
     * Initiate the modal contents
     * - Update heading
     * - Init tabs
     * - Init social sign in
     */
    modal_init: function() {

        // init header title & subtitle
        this.modal_init_header();

        // init sign in and registration tabs
        this.modal_init_tabs();

        // init facebook and Google social sign ins
        this.modal_init_social_signin();
    },

    /**
     * Set up the title and heading of the model box
     * which is derived from the mason h1.html widget used in
     * the usual sign in/registration process (e.g. shows a
     * different h1 depending on $::SESSION->{page_after_login}
     */
    modal_init_header: function() {

        this.modal_change_heading();

        this.modal_change_title();

    },

    /**
     * init register and sign in tabs
     */
    modal_init_tabs: function() {
        [].forEach.call(this.UI.tabs, function(tab, index) {

            this.UI.tabList.push(Object.create(window.ZPG.tabs));
            this.UI.tabList[index].init({el: tab});
            this.UI.tabList[index].STATE.currentIndex = 0;
            this.UI.tabList[index].toggleActiveTab();

        }.bind(this));

    },

    modal_init_social_signin: function() {

        this.UI.socialSignin.googleplus = Object.create(window.ZPG.googleplus);
        this.UI.socialSignin.googleplus.init();

        if (this.UI.fbRoot) {
            this.UI.socialSignin.facebook = Object.create(window.ZPG.facebook);
            this.UI.socialSignin.facebook.init(this.UI.fbRoot.getAttribute('data-app-id'));
        }

    },

    modal_change_heading: function(heading) {
        if (!heading) {
            heading = this.DATA.actionName;
        }

        this.el.querySelector(this.classes.modalHeader).innerHTML = heading;

    },

    modal_change_title: function(title) {
        if (!title) {
            var requestURL = this.defaults.url.titleUpdate
                + '?page_after=' + encodeURIComponent(this.DATA.pageAfterLogin);

            window.ZPG.utils.requestData(requestURL, 'json', function(data) {
                if (data.title) {
                    this.modal_change_title('<h2>' + data.title + '</h2>');
                }
            }.bind(this));
        }

        this.UI.modalTitle.innerHTML = title;

    },

    /**
     * search for js-check field and set the State isValid value
     */
    validate_modal_form: function() {

        var allFields = this.UI.activeForm.getElementsByClassName(this.classes.jsValidationCheck);

        this.State.errorTotal = 0;

        this.validate_modal_form_fields(allFields);

    },

    validate_modal_form_fields: function(fields) {
        [].forEach.call(fields, function(field) {

            this.validate_modal_form_field(field);

        }.bind(this));
    },

    validate_modal_form_field: function(field) {
        var setValid, setInvalid;
        this.State.isValid = window.ZPG.forms.validate(field);

        setValid   = this.State.isValid ? 'add' : 'remove';
        setInvalid = !this.State.isValid ? 'add' : 'remove';

        field.classList[setValid](this.classes.jsValidationValid);
        field.classList[setInvalid](this.classes.jsValidationInvalid);

        if (!this.State.isValid) {
            this.State.errorTotal++;
        }

    },

    /**
     * Register a new user via ajax
     * @param el
     */
    register_user: function() {

        var gaAction = '';

        this.track_event({
            'category': 'Registration',
            'action': 'Clickthrough',
            'label': this.DATA.actionName
        });

        this.validate_modal_form();

        if (!this.State.isValid) {
            return false;
        }

        [].forEach.call(this.UI.consents, function(el, i) {

            // Validate consents && show messaging
            if (!window.ZPG.forms.validate(el) && !this.State.consentErrorShown) {
                var message = this.create_message_node({
                    message: this.defaults.message.errorConsent,
                    styles: ['error']
                });
                if (this.UI.formRadios) {
                    this.UI.formRadios.appendChild(message);
                    this.State.consentErrorShown = true;
                }

            }

            if (el.checked) {
                var consentName         = el.getAttribute('name').split('.')[1],
                    key                 = consentName.replace(/(zoopla|primelocation|smartnewhomes)_/i, '');
                this.DATA.consents[key] = el.value;
            }

        }.bind(this));

        // do not proceed if there are errors
        if (this.State.errorTotal > 0) {
            return false;
        }

        gaAction = this.track_consent_event();

        window.ZPG.utils.postData(this.defaults.url.register, ZPG.utils.serializeForm(this.UI.activeForm),
            function(data) {
                this.login_handler(data);

                // track user opt-in selections
                this.track_event({
                    'category': 'permission opt-in',
                    'action': gaAction,
                    'label': '/register/'
                });

            }.bind(this), 'json');

    },

    signin_user: function() {

        this.validate_modal_form();

        if (!this.State.isValid || this.State.errorTotal > 0) {
            return false;
        }

        window.ZPG.utils.postData(this.defaults.url.signin, ZPG.utils.serializeForm(this.UI.activeForm),
            function(data) {
                this.login_handler(data);
            }.bind(this), 'json');

    },

    login_handler: function(data) {
        if (data['success']) {
            this.login_success();
        } else {
            this.login_failure(data);
        }
    },

    login_success: function(data) {

        window.ZPG.Registration.STATE.userIsLoggedIn = 1;

        if (this.DATA.actionName === 'Create alert' || this.DATA.actionName === 'Save search') {
            this.continue_to_create_alert();
        } else {
            this.redirect_location_to(this.DATA.pageAfterLogin);
        }

    },

    login_failure: function(data) {
        if (!data['message']) {
            return false;
        }

        var container = this.UI.activeForm.parentNode,
            alert     = container.getElementsByClassName(this.classes.alert)[0];

        if (!alert) {
            var message = this.create_message_node({
                message: data['message'],
                styles: ['alert', 'alert-danger']
            });
            container.insertBefore(message, container.childNodes[0]);
        } else {
            alert.innerHTML = data['message'];
        }

    },

    /**
     * Clean the URL and reload the page
     */
    redirect_location_to: function(url) {
        if (!url) {
            url = window.location.href.split('?')[0];
        }
        window.location = url;
    },

    track_event: function(obj) {
        if (!obj) {
            return false;
        }
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': obj.category,
            'eventAction': obj.action,
            'eventLabel': obj.label
        });
    },

    track_consent_event: function() {
        var action;

        if (this.DATA.consents.news_and_updates === 'Y' && this.DATA.consents.offers === 'Y') {
            action = 'optin_both';
        } else if (this.DATA.consents.news_and_updates === 'Y' && this.DATA.consents.offers === 'N') {
            action = 'optin_news_only';
        } else if (this.DATA.consents.news_and_updates === 'N' && this.DATA.consents.offers === 'Y') {
            action = 'optin_partners_only';
        } else if (this.DATA.consents.move === 'Y') {
            action = 'optin_move_only';
        } else {
            action = 'optin_neither';
        }

        return action;
    },

    /**
     * Replace the popup registration form with the create alert form
     */
    continue_to_create_alert: function() {

        var alert_frequency = this.DATA.pageAfterLogin.search(/(frequency=)$/g);

        window.ZPG.utils.requestData(
            this.defaults.url.alertForm + '?' + ZPG.utils.serializeForm(this.UI.formSearch) + '&save_search=' + (alert_frequency > 0 ? 1 : 0), '',
            function(data) {

                this.modal_change_title('<h2>' + this.defaults.message.successSignIn + '</h2>');

                this.UI.modalContent.innerHTML = data;
                this.attach_create_alert_events(data);

            }.bind(this));

    },

    /**
     * Initilise the create alert form
     * @param data
     */
    attach_create_alert_events: function(data) {

        this.el.querySelector(this.classes.formAlertSearch).addEventListener('click', function(e) {

            var target = e.target;

            if (target.nodeName != 'BUTTON') {
                return false;
            }

            e.preventDefault();

            if (target.classList.contains(this.classes.jsSaveAlert)) {

                window.ZPG.Searches.Alerts.save('', function(data) {
                    if (data['return_url']) {
                        this.redirect_location_to(data['return_url']);
                    } else {
                        this.UI.modal.close();
                    }
                }.bind(this), 'json');

            }

        }.bind(this));

    },

    /**
     * Remove bespoke messaging and reset form
     * @param el
     */
    reset_all_forms: function(el) {
        var container    = this.UI.modalContent.querySelector(this.classes.tabActive),
            consentError = this.UI.formRadios.querySelector('.' + this.classes.error),
            alert;

        if (container) {
            alert = container.getElementsByClassName(this.classes.alert)[0];
        }

        if (el.classList.contains(this.classes.radio)) {
            if (consentError) {
                this.UI.formRadios.removeChild(consentError);
                this.State.consentErrorShown = null;
            }
        }
        if (alert) {
            container.removeChild(alert);
        }
        this.State.errorTotal = 0;
    },

    /**
     * Inject a bespoke message returned from server into the top of the form
     */
    create_message_node: function(obj) {
        var msg;
        if (!obj.message) {
            return false;
        }

        msg = document.createElement('div');
        msg.classList.add('message');

        if (obj.styles.length) {
            [].forEach.call(obj.styles, function(s) {
                msg.classList.add(s);
            });
        }

        msg.innerText = obj.message;

        return msg;
    },

    /**
     * Sign user in via google plus
     */
    social_signin_via_google: function() {

        this.UI.socialSignin.googleplus.login({
            'callback': function(authResult) {

                if (authResult['status']['signed_in']) {

                    var token = 'access_token=' + authResult['access_token'];

                    window.ZPG.utils.postData(this.defaults.url.signinGoogle, token,
                        function(data) {
                            if (data['success']) {
                                this.login_handler(data);
                            } else {
                                this.login_handler({
                                    error: 1,
                                    message: this.defaults.message.errorLogin
                                });
                            }
                        }.bind(this), 'json');

                } else {
                    this.login_handler({
                        error: 1,
                        message: authResult['error']
                    });

                }

            }.bind(this),
            'theme': 'dark'
        });
    },

    /**
     * Sign user in via Facebook
     */
    social_login_via_facebook: function() {
        this.UI.socialSignin.facebook.login(function(response) {

            if (response.authResponse && response.authResponse.grantedScopes) {
                var grantedScopes = response.authResponse.grantedScopes.split(',');

                var hasEmail = grantedScopes.filter(function(e, i) { return e == 'email'; });

                if (hasEmail.length > 0) {
                    FB.getLoginStatus(function(response) {
                        if (response.status === 'connected') {

                            window.ZPG.utils.postData(this.defaults.url.signinFB, 'access_token=' + response.authResponse.accessToken,
                                function(data) {
                                    if (data['success']) {
                                        this.login_handler(data);
                                    } else {
                                        this.login_handler({
                                            error: 1,
                                            message: this.defaults.message.errorLogin
                                        });
                                    }
                                }.bind(this), 'json');

                        }
                    }.bind(this));
                } else {
                    // revoke permissions, so we have to re-request
                    FB.api('/v2.2/me/permissions', 'DELETE', {access_token: response.authResponse.accessToken}, function() {
                        alert('Logging via Facebook requires that e-mail address permission be granted, please try again.');
                    });
                }
            } else {
                this.login_handler({
                    message: ZPG.facebook.error_string
                });
            }

        }.bind(this));
    }

};

window.ZPG = window.ZPG || {};

(function(window) {
    'use strict';

    var socialMediaConsents;

    document.addEventListener('DOMContentLoaded', function() {

        if (!window.ZPG.MyAccount.UI.consentModal) {
            return false;
        }

        socialMediaConsents = Object.create(window.ZPG.MyAccount.emailPreferences);
        socialMediaConsents.init({
            el: window.ZPG.MyAccount.UI.consentModal
        });

    });

}(window));

window.ZPG = window.ZPG || {};
window.ZPG.MyAccount = window.ZPG.MyAccount || {};

window.ZPG.MyAccount.UI = window.ZPG.MyAccount.UI || {
    consentModal: document.getElementById("modal_save_preferences")
};

window.ZPG.MyAccount.STATE = window.ZPG.MyAccount.STATE || {
    consentModalVisible: false
};

window.ZPG           = window.ZPG || {};
window.ZPG.MyAccount = window.ZPG.MyAccount || {};

window.ZPG.MyAccount.emailPreferences = {

    /**
     * Constructor
     */
    constructor: function(options) {

        this.el = options.el;

        this.defaults = {
            url: {
                submission: '/ajax/myaccount/social_consents'
            },
            message: {
                success: 'Your preferences have been saved',
                errorConsent: 'Please set your contact preferences'
            }
        };

        this.classes = {
            formConsent: '#social_consents',
            jsSave: 'js-save-consents',
            jsTrigger: 'js-registration-modal',
            jsValidationCheck: 'js-check',
            jsValidationInvalid: 'js-invalid',
            jsValidationValid: 'js-valid',
            radio: 'faux-radios__custom-radio',
            modalHeader: '.mdl-register__header strong',
            modalContent: 'mdl-register__content',
            modalTitle: 'mdl-register__title',
            error: 'error'
        };

        this.UI = {
            form: this.el.querySelector(this.classes.formConsent),
            formRadios: this.el.querySelector('.faux-radios'),
            modal: null,
            modalContent: this.el.getElementsByClassName(this.classes.modalContent)[0],
            modalTitle: this.el.getElementsByClassName(this.classes.modalTitle)[0],
            triggers: document.getElementsByClassName(this.classes.jsTrigger),
            consents: this.el.querySelectorAll('.faux-radios__group input[type=radio]'),
            inputConsumerPermission: this.el.querySelector('input[name=consumer_permissions]'),
            channelReferrer: this.el.querySelector('input[name=channel_referrer]')
        };

        this.DATA = {
            consents: {},
            pathName: window.location.pathname
        };

        this.State = {
            isValid: false,
            consentErrorShown: null,
            isConsent: 0
        };

    },

    /**
     * Initialize the object
     * @param options
     */
    init: function(options) {

        if (!options.el) {
            return false;
        }

        window.ZPG.MyAccount.STATE.consentModalVisible = true; // Set the global state for the modal to true

        this.constructor(options);

        if (ZPG.support.sessionStorage()) {
            if (window.sessionStorage.getItem('consentSeen') > 0) {
                return false;
            }
        }

        this.open_email_preferences_modal();

        this.attach_modal_event_delegates();

    },

    /**
     * Attach event delegates to the modal
     */
    attach_modal_event_delegates: function() {

        this.el.addEventListener('click', function(e) {
            var target = e.target;

            // remove all error messaging and start again
            this.reset_all_forms(target);

            if (target.nodeName != 'BUTTON') {
                return false;
            }

            e.preventDefault();

            // Register new user
            if (target.classList.contains(this.classes.jsSave)) {

                this.save_preferences();

            }

        }.bind(this));
    },

    /**
     * Create the modal instance and push the mp-customizer block
     * into the modal box.
     * Add the js-noscroll class to prevent scroll on open
     * Reload the page without query string on close
     */
    open_email_preferences_modal: function() {

        this.UI.modal = new UIModal({
            content: this.el,
            autoOpen: true,
            className: 'fade-and-scale ui-modal--email-preference',
            onOpen: function() {

                if (ZPG.support.sessionStorage()) {
                    window.sessionStorage.setItem('consentSeen', '1');
                }

                this.track_event({
                    'category': 'Permission opt-in',
                    'action': 'Social overlay shown',
                    'label': this.DATA.pathName
                });

            }.bind(this),
            onClose: function() {

                window.ZPG.MyAccount.STATE.consentModalVisible = false;

                this.track_event({
                    'category': 'Permission opt-in',
                    'action': 'Social overlay dismissed',
                    'label': this.DATA.pathName
                });

            }.bind(this)
        });
    },

    /**
     * Save user email preferences
     * @param el
     */
    save_preferences: function() {

        this.State.isConsent = this.UI.consents[0].getAttribute('name').match(/^consent\.\w*\.\d*$/) ? 1 : 0;

        [].forEach.call(this.UI.consents, function(el, i) {

            // Validate consents && show messaging
            if (!window.ZPG.forms.validate(el) && !this.State.consentErrorShown) {
                var message = this.create_message_node({
                    message: this.defaults.message.errorConsent,
                    styles: ['error']
                });
                if (this.UI.formRadios) {
                    this.UI.formRadios.parentNode.insertBefore(message, this.UI.formRadios);
                    this.State.consentErrorShown = true;
                }
            }

            if (el.checked) {
                var consentName         = el.getAttribute('name').split('.')[1],
                    key                 = consentName.replace(/(zoopla|primelocation|smartnewhomes)_/i, '');
                this.DATA.consents[key] = el.value;
            }

        }.bind(this));

        // do not proceed if there are errors
        if (this.State.consentErrorShown != null) {
            return false;
        }

        window.ZPG.utils.postData(this.defaults.url.submission, ZPG.utils.serializeForm(this.UI.form),
            function(data) {
                if (data.success) {

                    this.UI.modal.close();

                    if (this.State.isConsent) {
                        var channelLabel = 'Social';
                        if (this.UI.channelReferrer && this.UI.channelReferrer.value === 'move') {
                            channelLabel = 'Move';
                        }
                        // track user opt-in selections
                        this.track_event({
                            'category': 'permission opt-in',
                            'action': this.track_consent_event(),
                            'label': channelLabel
                        });

                    }

                }

            }.bind(this), 'json');

    },

    track_event: function(obj) {
        if (!obj) {
            return false;
        }
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            'event': 'GAEvent',
            'eventCategory': obj.category,
            'eventAction': obj.action,
            'eventLabel': obj.label
        });
    },

    track_consent_event: function() {
        var action;
        if (this.DATA.consents.news_and_updates === 'Y' && this.DATA.consents.offers === 'Y') {
            action = 'optin_both';
        } else if (this.DATA.consents.news_and_updates === 'Y' && this.DATA.consents.offers === 'N') {
            action = 'optin_news_only';
        } else if (this.DATA.consents.news_and_updates === 'N' && this.DATA.consents.offers === 'Y') {
            action = 'optin_partners_only';
        } else if (this.DATA.consents.move === 'Y') {
            action = 'optin_move_only';
        } else {
            action = 'optin_neither';
        }
        return action;
    },

    /**
     * Remove bespoke messaging and reset form
     * @param el
     */
    reset_all_forms: function(el) {
        var container    = this.UI.form.parentNode,
            consentError = container.querySelector('.' + this.classes.error);
        if (!consentError) {
            return false;
        }
        consentError.parentNode.removeChild(consentError);
        this.State.consentErrorShown = null;
    },

    /**
     * Inject a bespoke message returned from server into the top of the form
     */
    create_message_node: function(obj) {
        var msg;
        if (!obj.message) {
            return false;
        }

        msg = document.createElement('div');
        msg.classList.add('message');

        if (obj.styles.length) {
            [].forEach.call(obj.styles, function(s) {
                msg.classList.add(s);
            });
        }

        msg.innerText = obj.message;

        return msg;
    }

};

var DOMOps = (function () {
	function removeAllChildren(currentElement) {
		while (currentElement.firstChild) { currentElement.removeChild(currentElement.firstChild); }
		return true;
	}

	function findParentWithClass(currentElement, className) {
		while ((currentElement = currentElement.parentElement) && !currentElement.classList.contains(className));
		return currentElement;
	}

	function findSiblingWithClass(currentElement, className) {
		while ((currentElement = currentElement.nextElementSibling) && !currentElement.classList.contains(className));
		return currentElement;
	}

	return {
		removeAllChildren: removeAllChildren,
		findParentWithClass: findParentWithClass,
		findSiblingWithClass: findSiblingWithClass
	}

})();
var Cookie = (function () {

    function create(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    }

    function read(name) {
        var nameEq = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEq) == 0) return c.substring(nameEq.length, c.length);
        }
        return false;
    }

    function remove(name) {
        create(name, "", -1);
    }

    return {
        create: create,
        read: read,
        remove: remove
    }

}());

window.ZPG = window.ZPG || {};

var forms = (function () {
	var queryString = 'textarea, select, input:not([type="button"]):not([type="hidden"]):not([type="reset"]):not([type="submit"]):not(.show-hide-toggle)',

		allFields = Array.prototype.slice.call(document.body.querySelectorAll(queryString)),
        submitsAndFormsSelectorExclusions = ':not(.rwd-signin-reg-form)',
		allSubmits = Array.prototype.slice.call(document.body.querySelectorAll('.rwd-form' + submitsAndFormsSelectorExclusions + ' [type="submit"]')),
        allForms = Array.prototype.slice.call(document.body.querySelectorAll('.rwd-form'));

	function addValidation(field) {
		var event;

		if (field) {
			field.classList.add('js-check');

			if (field.type === 'checkbox' || field.type === 'radio') {
				event = 'change';
			} else if (field.tagName.toLowerCase() === 'textarea') {
				event = 'keyup';
			} else {
				event = 'blur';
			}

			field.addEventListener(event, function (ev) {
				validate(field)
			});

			if (field.checked || (field.type !== 'checkbox' && field.type !== 'radio' && field.value)) {
				validate(field);
			}
		}
	}

	function validate(field, strict) {
		var count,
			minSelected,
			result = true;

		field.classList.add('js-touched');
		field.classList.remove('js-invalid');
		field.classList.remove('js-valid');

		if (field.hasAttribute('minlength') || field.hasAttribute('maxlength')) {
			result = result && validateLength(field, strict);
		}

		if (field.type === 'checkbox' || field.type === 'radio') {
			count = Array.prototype.slice.call(document.body.querySelectorAll('[name="' + field.name + '"]')).length;
			if (field.hasAttribute('required')) {
				minSelected = 1;
			}

			if (field.type === 'checkbox' && field.hasAttribute('data-min-selected')) {
				minSelected = parseInt(field.getAttribute('data-min-selected'), 10);
			}

			if (field.type === 'radio' && field.hasAttribute('data-rule-required')) {
                result = result && validateConsents(DOMOps.findParentWithClass(field, 'faux-radios__group'));
			}

		}

		if (field.hasAttribute('required') || minSelected) {
			result = result && validateReq(field, strict, count, minSelected);
		}

		if (field.hasAttribute('pattern')) {
			result = result && validatePatt(field);
		}

		var step = DOMOps.findParentWithClass(field, 'fieldgroup--step');

		if (step) {
			validateFormSection(step);
		}

		return result;
	}

	/*

	actual field validation

	*/

	function validateReq(field, strict, count, minSelected) {
		var collection,
			collectionChecked,
			valuationMsg = Array.prototype.slice.call(document.body.querySelectorAll('[data-multi-target="' + field.name + '"]'))[0];

		if (count && minSelected && count >= minSelected) {
			collection = Array.prototype.slice.call(document.body.querySelectorAll('[name="' + field.name + '"]'));
			collectionChecked = Array.prototype.slice.call(document.body.querySelectorAll('[name="' + field.name + '"]:checked'));

			if (collectionChecked.length >= minSelected) {
				collection.forEach(function (item) {
					paintValid(item);
					if (valuationMsg) {
						paintValid(valuationMsg);
					}
				});
			} else {
				field = collection[0];
				paintInvalid(field);
				if (valuationMsg) {
					paintInvalid(valuationMsg);
				}
				return false;
			}
		} else if (field.value) {
			paintValid(field)
		} else {
			if (strict) {
				paintInvalid(field)
			}
			return false;
		}

		return true;

	}

	function validateLength(field) {
		var msg = '',
			min = 0,
			max = 0,
			tooShort,
			charsLeft,
			msgElement = field.nextElementSibling;

		if (field.hasAttribute('minlength')) {
			min = parseInt(field.getAttribute('minlength'), 10);
		}

		if (field.hasAttribute('maxlength')) {
			max = parseInt(field.getAttribute('maxlength'), 10);
		}

		if (field.value.length - min < 0) {
			tooShort = 'Your text is ' + (min - field.value.length) + ' characters too short';
			msg = tooShort;
		}

		if (max - field.value.length > 0) {
			charsLeft = (tooShort ? 'y' : 'Y') + 'ou have ' + (max - field.value.length) + ' character' + ((max - field.value.length > 1) ? 's' : '') + ' left';
			msg = charsLeft;
		}

		if (charsLeft && tooShort) {
			msg = tooShort + ' and ' + charsLeft;
		}

		if (msg.length) {
			msg += '.';
		}

		if (msgElement && msgElement.classList.contains('message')) {
			msgElement.setAttribute('title', msg);
		}

		if (tooShort) {
			paintInvalid(field);
			return false;
		} else {
			paintValid(field);
		}

		return true;
	}

	function validatePatt(field) {
		var ifReq = (!field.hasAttribute('required') ? '^$|' : ''),
			pattern = new RegExp(ifReq + field.getAttribute('pattern'), 'i');

		if (pattern.test(field.value)) {
			paintValid(field);

			if (!field.value) {
				field.classList.add('but-empty');
			}

		} else {
			paintInvalid(field);
			return false;
		}

		return true;
	}

	function paintValid(element) {
		element.classList.add('js-valid');
		element.classList.remove('js-invalid');
	}

	function paintInvalid(element) {
		element.classList.add('js-invalid');
		element.classList.remove('js-valid');
	}

	/*

	this adds ticks when all required / patterned children of the section get validated
	or removes them and opens the section, when fields inside it are invalid

	*/

	function validateFormSection(section) {
		var reqValid = (Array.prototype.slice.call(section.querySelectorAll('.js-valid:required'))).length,
			invalid = (Array.prototype.slice.call(section.querySelectorAll('.js-invalid'))).length,
			allReqFields = Array.prototype.slice.call(section.querySelectorAll(':required')).length,
			allFields = Array.prototype.slice.call(section.querySelectorAll(queryString)).length,
			nextSection,
			result;

		if (!invalid && allReqFields === reqValid && allFields > 0) {
			result = true;

			if (section.classList.contains('fieldgroup--step')) {
				nextSection = findNextStep(section);
				if (nextSection) {
					toggleSection(nextSection, true);
					validateFormSection(nextSection);
				}
			}

			if (!section.classList.contains('js-allvalid')) {
				section.classList.add('js-allvalid');
				toggleSection(section, true);
			}

		} else {
			section.classList.remove('js-allvalid');

			if (section.classList.contains('fieldgroup--step')) {
				toggleSection(section, true);
			}

			result = false;
		}

		return result;
	}

	function findNextStep(currentStep) {
		var allGroups = Array.prototype.slice.call(document.getElementsByClassName('fieldgroup--step')),
			nextToggled;

		allGroups.forEach(function (currentSection, index) {
			if (currentStep === currentSection && allGroups[index + 1]) {
				nextToggled = allGroups[index + 1];
			}
		});
		return nextToggled;
	}

	function toggleSection(section, open) {

		if (!section || section === null) {
			return false;
		}

		var toggler = section.getElementsByClassName('show-hide-toggle')[0];

		if (toggler && !toggler.hasAttribute('disabled')) {
			toggler.checked = open;
		}
	}

	function resetValidation(field) {
		field.classList.remove('js-valid');
		field.classList.remove('js-invalid');
		field.classList.remove('js-touched');

		validateFormSection(DOMOps.findParentWithClass(field, 'fieldgroup--step'));
	}

	function handleInvalidForm(form) {
		var invalids = Array.prototype.slice.call(form.querySelectorAll('.js-invalid')),
			firstInvalid = invalids[0],
			parentSection,
			parentSections = Array();

		invalids.forEach(function (invalid) {
			parentSection = DOMOps.findParentWithClass(invalid, 'fieldgroup--step');

			if (parentSections.indexOf(parentSection) === -1) {
				parentSections.push(parentSection);
			}
		});

		parentSections.forEach(function (section) {
			toggleSection(section, true);
		});

		if (firstInvalid) {
			smoothScroll.to(firstInvalid);
		}

		paintInvalid(form);
	}

	function submitForm(el) {
		var form = el,
			event = 'submit';

		if (el.tagName.toLowerCase() !== 'form') {
			form = el.form;
			event = 'click';
		}

		el.addEventListener(event, function (ev) {
			ev.preventDefault();

			if (document.activeElement.className.indexOf('autocomplete') === -1) {
				allFields.forEach(function (field) { validate(field, 1); });
			}

			if (validateFormSection(form)) {
				form.submit();
			} else if (document.activeElement.className.indexOf('autocomplete') === -1) {
				handleInvalidForm(form);
			}
		})
	}

    function validateConsents(group) {
        var parent         = DOMOps.findParentWithClass(group, 'faux-radios'),
            allReqConsents = Array.prototype.slice.call(parent.querySelectorAll('input[data-rule-required=true]')).length,
            checked        = Array.prototype.slice.call(parent.querySelectorAll(':checked')).length,
            result;

        if (allReqConsents != checked) {
            group.classList.remove('js-valid');
            group.classList.add('js-invalid');
            result = false;
        } else {
            group.classList.add('js-valid');
            group.classList.remove('js-invalid');
            result = true;
        }
        return result;
    }

	function ajaxCall(url, fields, nameSpace, callbackFuncName) {
		var req = new XMLHttpRequest(),
			data,
			jsondata,
			urlEncodedDataPairs = [],
			urlEncodedData = '',
			val;

		if (fields) {
			fields.forEach(function (field) {
				if (validate(field, 1)) {
					urlEncodedDataPairs.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
				}
			});
			urlEncodedData = '?' + urlEncodedDataPairs.join('&').replace(/%20/g, '+');
		}

		req.onreadystatechange = function () {
			if (req.readyState === 4) {
				if (req.status === 200) {
					jsondata = JSON.parse(req.responseText)

					if (nameSpace && callbackFuncName) {
						window[nameSpace][callbackFuncName](jsondata);
					} else {
						callbackFuncName(jsondata);
					}
				} else {
					error(req.responseText);
				}
			}
		}

		req.open('GET', url + urlEncodedData);
		req.send();
	}

	function init() {
		allFields.forEach(function (field) { addValidation(field) });
		allSubmits.forEach(function (button) { submitForm(button) });
		allForms.forEach(function (form) { submitForm(form) });
	}

	init();

	return {
		addValidation: addValidation,
		submitForm: submitForm,
		validate: validate,
		ajaxCall: ajaxCall,
		resetValidation: resetValidation
	}
})();


window.ZPG.forms = forms;

var UserFeedback = (function () {
    var trackControls = document.getElementsByClassName('js-user-feedback__answer');

    function init() {

        [].forEach.call(trackControls, function (trackControl) {
        
            var feedbackId = DOMOps.findParentWithClass(trackControl, 'js-user-feedback').getAttribute('id');
            var feedBackBox = document.getElementById(feedbackId);
        
            feedCookie = Cookie.read(feedbackId);

            if (feedBackBox) {

                if (feedCookie) {
                    
                    feedBackBox.parentNode.removeChild(feedBackBox);

                } else {
                
                    trackControl.addEventListener('click', function () {
                        Cookie.create(feedbackId, '1', 365);
                        feedBackBox.innerHTML = 'Thank you for your feedback.';
                    });
                }
            }
            
        });
    }

    init();

})();
(function() {

    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable,
            params.detail);
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();
